// @ts-nocheck
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  EmailAddress: any;
  JSON: any;
  PositiveInteger: any;
  URL: any;
  Upload: any;
};

export type AcceptRequestConnectionInput = {
  brandId: Scalars['ID'];
  priceTypes?: InputMaybe<Array<RequestPriceType>>;
  retailerId: Scalars['ID'];
};

export type AcceptRequestConnectionPayload = {
  brandId: Scalars['ID'];
  connectionStatus: LGConnectionStatus;
  error?: Maybe<Scalars['String']>;
  retailerId: Scalars['ID'];
};

/** Accepts a PENDING membership invite */
export type AcceptUserMembershipInviteInput = {
  membershipInviteId: Scalars['ID'];
  password: Scalars['String'];
  userName: Scalars['String'];
};

/** Accepts a pending request for membership */
export type AcceptUserMembershipRequestInput = {
  userMembershipRequestId: Scalars['ID'];
};

/** Returns either the user created or an error. */
export type AcceptUserMembershipRequestPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type Account = BaseAccount & {
  accountManagerEmail?: Maybe<Scalars['String']>;
  accountUsers: AccountUsersConnection;
  aliasedName?: Maybe<Scalars['String']>;
  assortmentIntegrations?: Maybe<Array<AssortmentIntegration>>;
  hasAssortmentIntegrations?: Maybe<AvailableAssortmentIntegrations>;
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privacy: Scalars['Boolean'];
  status: AccountStatus;
  type?: Maybe<AccountType>;
};

export type AccountCasepack = Node & {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  skus: CasepackSkuConnection;
};


export type AccountCasepackskusArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type AccountCasepackConnection = {
  edges: Array<AccountCasepackEdge>;
};

export type AccountCasepackEdge = {
  node: AccountCasepack;
};

export enum AccountConnectionOrderByDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum AccountConnectionOrderByField {
  ACCOUNT_NAME = 'ACCOUNT_NAME',
  CREATED = 'CREATED',
  ORDER_ACTIVITY = 'ORDER_ACTIVITY'
}

export type AccountConnectionRequest = {
  action: Action;
  otherAccountId: Scalars['ID'];
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AccountConnectionStatus = {
  accountId: Scalars['ID'];
  brandProfile: PublicBrandProfile;
  otherAccountId: Scalars['ID'];
  retailerProfile: PublicRetailerProfile;
  status: Status;
};

export type AccountConnectionStatusFilter = {
  accountId?: InputMaybe<Scalars['ID']>;
  otherAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  useAllUserAccounts?: InputMaybe<Scalars['Boolean']>;
};

export type AccountConnectionStatusOrderBy = {
  direction?: InputMaybe<AccountConnectionOrderByDirection>;
  field: AccountConnectionOrderByField;
};

export type AccountCreationSource = {
  accountId: Scalars['ID'];
  creationService?: Maybe<CreationService>;
  externalSource?: Maybe<ExternalSource>;
  id: Scalars['ID'];
  requestedByAccount: RequestedByAccount;
  requestedByUser?: Maybe<RequestedByUser>;
};

export type AccountCustomerCode = {
  alias?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  otherAccountId: Scalars['ID'];
};

export type AccountCustomerCodeInput = {
  alias?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  otherAccountId: Scalars['ID'];
};

export type AccountIdAndDisplayName = {
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type AccountIntegration = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
};

export type AccountPaymentProvider = {
  accountId: Scalars['ID'];
  brandNotificationEmail?: Maybe<Scalars['String']>;
  connectionDetails?: Maybe<ConnectionDetails>;
  externalIdentifier: Scalars['String'];
  isAchEnabled?: Maybe<Scalars['Boolean']>;
  isSepaEnabled?: Maybe<Scalars['Boolean']>;
  paymentProvider: Scalars['String'];
  retailersCanSeeInvoices?: Maybe<Scalars['Boolean']>;
  sendBrandMailPaymentProcessed?: Maybe<Scalars['Boolean']>;
  sendRetailerMailPaymentProcessed?: Maybe<Scalars['Boolean']>;
};

export type AccountProfile = Node & {
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  APPLIED = 'APPLIED',
  DENIED = 'DENIED',
  DISABLED = 'DISABLED',
  HISTORICAL = 'HISTORICAL',
  INTERNAL = 'INTERNAL',
  INVISIBLE = 'INVISIBLE',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  PENDING = 'PENDING',
  PRE_ACTIVE = 'PRE_ACTIVE',
  UNKNOWN = 'UNKNOWN'
}

export enum AccountType {
  ADMIN = 'ADMIN',
  BRAND = 'BRAND',
  RETAILER = 'RETAILER'
}

export type AccountUser = {
  accountId: Scalars['ID'];
  active?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['Date']>;
  dataPermissionConfiguration?: Maybe<UserPermissionConfiguration>;
  displayCode?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastDateAdded?: Maybe<Scalars['Date']>;
  lastDateRemoved?: Maybe<Scalars['Date']>;
  lastLogin?: Maybe<Scalars['Date']>;
  numberConnections?: Maybe<Scalars['Int']>;
  orderCC?: Maybe<Array<Scalars['String']>>;
  regions: RegionConnection;
  statusChangeDate?: Maybe<Scalars['Date']>;
  updated?: Maybe<Scalars['Date']>;
  user: User;
  userType: AccountUserType;
};

export type AccountUserGeoRestrictions = Node & {
  accountId: Scalars['ID'];
  exceptionAccounts: Array<PermissionsAccount>;
  id: Scalars['ID'];
  possibleExceptionAccounts: Array<PermissionsAccount>;
  regionAssignedOverride: Scalars['Boolean'];
  regions: RegionConnection;
  userId: Scalars['ID'];
};

export type AccountUserStatus = {
  accountId: Scalars['ID'];
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

export type AccountUserStatusInput = {
  accountId: Scalars['ID'];
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

export enum AccountUserType {
  ADMIN = 'ADMIN',
  INTERNAL = 'INTERNAL',
  NO_ACCESS = 'NO_ACCESS',
  UNSPECIFIED = 'UNSPECIFIED',
  USER = 'USER'
}

export type AccountUserUpdate = {
  accountId: Scalars['ID'];
  displayCode?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderCC?: InputMaybe<Array<Scalars['String']>>;
  userId: Scalars['ID'];
  userType?: InputMaybe<AccountUserType>;
};

export type AccountUsersConnection = {
  edges: Array<AccountUsersEdge>;
};

export type AccountUsersEdge = {
  node: AccountUser;
};

export type AcknowledgeRecentlyCreatedAccountIdsPayload = {
  accounts: Array<Account>;
};

export type AcknowledgeRecentlyCreatedAccountsInput = {
  accountIds: Array<Scalars['ID']>;
};

export enum Action {
  ACCEPT = 'ACCEPT',
  DECLINE = 'DECLINE',
  SEND = 'SEND',
  UNKNOWN = 'UNKNOWN'
}

/** Adds doors to an assortment */
export type AddAssortmentDoorsInput = {
  /** Id of the assortment to add doors */
  assortmentId: Scalars['ID'];
  /** Ids of the doors to add */
  doorIds: Array<Scalars['ID']>;
};

export type AddAssortmentDoorsPayload = {
  assortment: Assortment;
};

export type AddColorsToAssortmentInput = {
  assortmentId: Scalars['ID'];
  collectionId?: InputMaybe<Scalars['ID']>;
  colorIds: Array<Scalars['ID']>;
  priceTypeId: Scalars['ID'];
};

export type AddColorsToAssortmentPayload = {
  assortment?: Maybe<Assortment>;
};

export type AddColorsToAssortmentProductRequest = {
  colors: Array<AssortmentProductColorRequest>;
  productId: Scalars['ID'];
};

export type AddFavoriteAccountInput = {
  brandAccountId: Scalars['ID'];
  tradeShowEventId?: InputMaybe<Scalars['ID']>;
};

export type AddInventoryAvailabilityGroupInput = {
  inventoryDate: Scalars['Date'];
  inventoryNumber: Scalars['String'];
  warehouseId: Scalars['String'];
};

export type AddInventoryAvailabilityGroupPayload = {
  availability: Availability;
  id: Scalars['ID'];
  inventoryNumber: Scalars['String'];
  warehouseId: Scalars['String'];
};

export type AddOrdersToVisualAssortmentResponse = {
  /** List of order IDs that were successfully added to the Visual Assortment sync queue */
  addedOrderIds: Array<Scalars['ID']>;
  /** Existing order IDs that were already in the Visual Assortment sync queue */
  existingOrderIds: Array<Scalars['ID']>;
};

export type AddProductAndSkusToCollectionInput = {
  orderNumber?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
  skus?: InputMaybe<Array<SkuDeliveryInput>>;
};

export type AddProductToCollectionInput = {
  comments?: InputMaybe<Scalars['String']>;
  orderNbr?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
  skuIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AddProductsAndSkusToCollectionInput = {
  collectionId: Scalars['ID'];
  collectionProducts?: InputMaybe<Array<AddProductAndSkusToCollectionInput>>;
};

export type AddProductsToOrdersInput = {
  newOrdersInfo?: InputMaybe<NewOrdersInfo>;
  orderId?: InputMaybe<Scalars['ID']>;
  products?: InputMaybe<Array<ProductInfo>>;
};

export type AddProductsToOrdersPayload = {
  createdOrderIds?: Maybe<Array<Scalars['ID']>>;
  createdWebOrderIds?: Maybe<Array<Scalars['ID']>>;
  modifiedOrderIds?: Maybe<Array<Scalars['ID']>>;
};

/** Add existing skus to an assortment. Does not support custom skus (from the retailer side) */
export type AddSkusToAssortmentInput = {
  assortmentId: Scalars['ID'];
  priceTypeId: Scalars['ID'];
  skuIds: Array<Scalars['ID']>;
};

export type AddSkusToAssortmentPayload = {
  assortment?: Maybe<Assortment>;
};

export type AddStyleboardCommentInput = {
  message: Scalars['String'];
  styleboardId: Scalars['String'];
};

export type AddUnitsInProgressInput = {
  /** To pass bulk quantities to be added to the orders in progress */
  bulkQuantities?: InputMaybe<Array<BulkQuantity>>;
  /** To pass casepack quantities to be added to the orders in progress */
  casepackQuantities?: InputMaybe<Array<CasepackQuantity>>;
  /** To assign a hub to the orders */
  hubId?: InputMaybe<Scalars['ID']>;
  /** Context to get or create orders */
  orderInfo: OrderInfo;
  /** To pass SKU quantities to be added to the orders in progress */
  skuQuantities?: InputMaybe<Array<SkuQuantity>>;
};

export type AddUnitsInProgressPayload = {
  createdOrderIds?: Maybe<Array<Scalars['ID']>>;
};

export type AddVariantsInProgressInput = {
  hubId?: InputMaybe<Scalars['ID']>;
  orderInfo: OrderInfo;
  /** This field is deprecated please use variantItems */
  variantIds?: InputMaybe<Array<Scalars['ID']>>;
  variantItems?: InputMaybe<Array<variantItemsInput>>;
};

export type AddVariantsInProgressPayload = {
  orderIds?: Maybe<Array<Scalars['ID']>>;
};

export type AddWarehousePayload = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  orderNbr?: Maybe<Scalars['Int']>;
};

export type AddWarehousesInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum AdjustmentTypeEnum {
  ADDITIVE = 'ADDITIVE',
  MARKUP = 'MARKUP',
  OVERRIDE = 'OVERRIDE',
  SUBTRACTIVE = 'SUBTRACTIVE'
}

export type AdminViewerAccount = {
  accountManagerEmail?: Maybe<Scalars['String']>;
  aliasedName?: Maybe<Scalars['String']>;
  enableChat: Scalars['Boolean'];
  id: Scalars['ID'];
  integrations: Array<Maybe<Scalars['String']>>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privacy: Scalars['Boolean'];
  status: AccountStatus;
  type?: Maybe<AccountType>;
};

export type AggregateSkuInventoryItem = {
  availableQuantity: Scalars['Int'];
  groups?: Maybe<Array<AggregateSkuInventoryItemGroup>>;
  skuId: Scalars['ID'];
};

export type AggregateSkuInventoryItemGroup = {
  availableQuantity: Scalars['Int'];
  group?: Maybe<InventoryAvailabilityGroup>;
  items: Array<InventoryItem>;
};

export type AggregateSkuInventoryItemsFilter = {
  productIds: Array<Scalars['ID']>;
};

export type AliasAddressInput = {
  address: AddressInput;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AliasAddressUpdateInput = {
  address: AddressUpdateInput;
  buyerId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AppSubscriptionCancelInput = {
  appName: ShopifyAppName;
};

export type AppSubscriptionCancelPayload = {
  success: Scalars['Boolean'];
};

export type ApplyAssortmentSkuAttributesInput = {
  assortmentId?: InputMaybe<Scalars['ID']>;
  /** Ids of the attribute options to apply */
  attributeOptionIds: Array<Scalars['ID']>;
  /** Ids of the assortment sku override values being attributed */
  overrideIds: Array<Scalars['ID']>;
};

export type ApplyAssortmentSkuColorAttributesPayload = {
  /** NOTE: There's a known bug with querying images and swatch on these nodes */
  colors?: Maybe<Array<AssortmentSKUColor>>;
  errors?: Maybe<Array<Error>>;
  /** Required to query the assortment in the mutation response */
  query: Query;
};

export type ApplySizeCurveToDoorColorsRequest = {
  assortmentId: Scalars['ID'];
  requests: Array<DoorColorsRequest>;
};

export type ApplySizeCurveToDoorColorsResponse = {
  assortment?: Maybe<Assortment>;
  query?: Maybe<Query>;
};

export type AssignProductColorImageResult = {
  colorId: Scalars['ID'];
};

export type AssignStyleColorSwatchInput = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  colorCode: Scalars['String'];
  colorName: Scalars['String'];
  hexCode?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['ID']>;
  revert?: InputMaybe<Scalars['Boolean']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']>>;
  styleIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type AssignStyleColorSwatchPayload = {
  errorCode?: Maybe<Scalars['String']>;
};

export type Assortment = BaseAssortment & Node & {
  /** Object version for this assortment */
  _version: Scalars['String'];
  /** The selected attributes for this assortment */
  attributeOptions: AttributeOptionConnection;
  /** Assortment/item attribute fields whose values are required before the assortment can be exported */
  attributeValidationRequirements: Array<AttributeValidation>;
  /** Merchandising hierarchy nodes available to apply to this assortment */
  availableMerchandisingHierarchy: MerchandisingHierarchyNodeConnection;
  /** The attribute options available to be applied to assortment sku colors on this assortment */
  availableSkuColorAttributeOptions: AttributeOptionConnection;
  /** The retailer brand linked to this assortment */
  brand?: Maybe<RetailerBrandEdge>;
  /** Brand Name associated with Assortment itself (not trough brand_id field) */
  brandName?: Maybe<Scalars['String']>;
  brandV2?: Maybe<RetailerBrand>;
  /**
   * The bulk line items contained in this assortment
   * @deprecated Use skus field instead
   */
  bulkLineItems: AssortmentBulkLineItemConnection;
  /** Linesheet */
  collection?: Maybe<Collection>;
  /** Visible Linesheet Code for this Assortment */
  collectionCode?: Maybe<Scalars['String']>;
  /** Visible Linesheet Name for this Assortment */
  collectionName?: Maybe<Scalars['String']>;
  /** The user who created this assortment */
  createdByUser: RetailerUserEdge;
  /** The date the assortment was created */
  createdDate: Scalars['Date'];
  /** The currency information for this assortment */
  currencies: AssortmentCurrencies;
  /** Delivery window details */
  deliveryWindow: AssortmentDeliveryWindow;
  /** A list of clusters to for this assortment */
  doorClusters: AssortmentDoorClusterConnection;
  /** A list of doors and clusters for this assortment */
  doorRuns: AssortmentDoorRunConnection;
  /** A list of doors to for this assortment */
  doors: AssortmentDoorConnection;
  /** The users able to edit this assortment */
  editableByUsers: RetailerUserConnection;
  /** The message associated with the most recent export attempt */
  exportMessage?: Maybe<Scalars['String']>;
  /** Financial Overview associated with this assortment */
  financialOverview: AssortmentFinancialOverview;
  financials: AssortmentFinancials;
  id: Scalars['ID'];
  /** The success status of the most recent export attempt */
  latestExport?: Maybe<AssortmentExportStatus>;
  /**
   * The line items contained in this assortment
   * @deprecated Use skus field instead
   */
  lineItems: AssortmentLineItemConnection;
  /** The merchandising hierarchy nodes selected for this assortment */
  merchandisingHierarchy: MerchandisingHierarchyNodeConnection;
  /** The date the assortment was last modified */
  modifiedDate: Scalars['Date'];
  /** The name of the assortment */
  name: Scalars['String'];
  /** The assortment's sync status with a brand order */
  orderAssortmentSyncStatus?: Maybe<OrderAssortmentSyncStatus>;
  /** The PO number for this assortment */
  poNumber: Scalars['String'];
  /** The price modifiers applied to this assortment */
  priceModifiers: PriceModifierConnection;
  /** The retailer that owns this assortment */
  retailer: RetailerEdge;
  /** The season associated with this assortment */
  season?: Maybe<SeasonEdge>;
  /** List of assortment sharing details */
  shares: Array<AssortmentShare>;
  /** The SKUs that are listed on this assortment */
  skus: AssortmentSKUConnection;
  /** The current status of the assortment status */
  status: AssortmentStatus;
  /**
   * Similar to bulk line items but not assigned to a destination
   * @deprecated Use skus field instead
   */
  unassignedBulkLineItems: AssortmentBulkLineItemConnection;
  /**
   * Similar to line items but not assigned to a destination
   * @deprecated Use skus field instead
   */
  unassignedLineItems: AssortmentLineItemConnection;
  /** Total count of the unread notifications on this assortment for the querying user */
  unreadNotificationsCount: Scalars['Int'];
  /** Entries in this array represent a field whose value is required before the assortment can be exported */
  validationRequirements: Array<Validation>;
  /**
   * Assortments may be a part of a Workspace. If this Assortment is a part of a Workspace, this field will contain
   * information about that workspace. However, if this Assortment is not part of a Workspace, this field will be null.
   */
  workspace?: Maybe<RetailWorkspace>;
};


export type AssortmentavailableSkuColorAttributeOptionsArgs = {
  selectedOptionIds: Array<Scalars['ID']>;
};


export type AssortmentsharesArgs = {
  onlyToMe?: InputMaybe<Scalars['Boolean']>;
};

/** Filter assortments on archived fields */
export type AssortmentArchivedFilter = {
  /** If true then return only archived assortments */
  value: Scalars['Boolean'];
};

/** Filter assortments on brand fields */
export type AssortmentBrandFilter = {
  /** Filter on brand ids */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter on brand name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentBulkLineItemConnection = {
  count: Scalars['Int'];
  edges?: Maybe<Array<AssortmentBulkLineItemEdge>>;
};

export type AssortmentBulkLineItemEdge = {
  /** The line item containing the SKU, its quantity, and destination details */
  node?: Maybe<BulkLineItem>;
};

export type AssortmentConnection = {
  edges: Array<AssortmentEdge>;
  /** Fetch the unique, sorted values for particular assortment fields, without considering pagination or filtering */
  fieldValues: FieldValues;
  pageInfo: PageInfo;
  /** Total number of filtered assortments without considering pagination */
  totalCount: Scalars['Int'];
  /** Total number of filtered workspaces and ungrouped assortments without considering pagination */
  totalCountWorkspaces: Scalars['Int'];
  /** This fetches a list that can contain both workspaces and ungrouped PO's. */
  workspaces: Array<WorkspaceOrAssortmentEdge>;
};

/** Filter assortments on retailer fields */
export type AssortmentCreatedByUserFilter = {
  /** Filter on created-by user name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentCurrencies = {
  /** @deprecated Get currency codes from financialDetails instead */
  assortmentCurrencyCodes: Array<Scalars['String']>;
  currencyConversions?: Maybe<Array<CurrencyConversion>>;
  /** @deprecated Get currency codes from financialDetails instead */
  linesheetCurrencyCodes: Array<Scalars['String']>;
};

export type AssortmentCurrencyConversion = {
  /** The assortment whose conversions were updated */
  assortment: Assortment;
  /**
   * The ID of the assortment to update
   * @deprecated Use field `assortment` instead
   */
  assortmentId: Scalars['ID'];
  /** Multiplicative conversion rate applied */
  factor: Scalars['Decimal'];
  /** Initial currency */
  fromCurrencyCode: Scalars['String'];
  /** Final currency */
  toCurrencyCode: Scalars['String'];
};

export type AssortmentDateRangeFilter = {
  end?: InputMaybe<Scalars['Date']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type AssortmentDeliveryWindow = {
  completeShip?: Maybe<Scalars['Date']>;
  due?: Maybe<Scalars['Date']>;
  startShip?: Maybe<Scalars['Date']>;
};

export type AssortmentDoorClusterConnection = {
  count: Scalars['Int'];
  edges?: Maybe<Array<AssortmentDoorClusterEdge>>;
};

export type AssortmentDoorClusterEdge = {
  node?: Maybe<DoorCluster>;
};

export type AssortmentDoorConnection = {
  edges?: Maybe<Array<AssortmentDoorEdge>>;
};

export type AssortmentDoorEdge = {
  node?: Maybe<Door>;
};

export type AssortmentDoorRun = {
  id: Scalars['ID'];
  orderNbr?: Maybe<Scalars['Int']>;
};

export type AssortmentDoorRunConnection = {
  edges?: Maybe<Array<AssortmentDoorRunEdge>>;
};

export type AssortmentDoorRunEdge = {
  node?: Maybe<AssortmentDoorRun>;
};

export type AssortmentEdge = {
  cursor: Scalars['String'];
  node: Assortment;
};

export enum AssortmentExportStatus {
  CONFIRMED = 'CONFIRMED',
  EXPORTED = 'EXPORTED',
  EXPORT_FAILURE = 'EXPORT_FAILURE',
  EXTERNAL_FAILURE = 'EXTERNAL_FAILURE',
  FAILURE = 'FAILURE',
  NONE = 'NONE',
  RE_EXPORT = 'RE_EXPORT',
  SUCCESS = 'SUCCESS'
}

export type AssortmentExportTask = Node & {
  /** The export's download url, if the task's status is SUCCESS */
  downloadUrl?: Maybe<Scalars['URL']>;
  id: Scalars['ID'];
  status: AssortmentExportStatus;
};

/** Filter for assortments query */
export type AssortmentFilter = {
  /**
   * Group of AssortmentFilters that will be joined by an AND condition
   * (All filters contained within a group will be joined by AND.)
   */
  and?: InputMaybe<Array<AssortmentFilter>>;
  /** Filter on archived */
  archived?: InputMaybe<AssortmentArchivedFilter>;
  /** Filter on brand name or brand ids */
  brand?: InputMaybe<AssortmentBrandFilter>;
  /** Filter on complete ship date (date only), use valid format such as m-d-yyyy */
  completeShip?: InputMaybe<AssortmentFilterValue>;
  /** Filter on created-by user name or created-by user ids */
  createdByUser?: InputMaybe<AssortmentCreatedByUserFilter>;
  /** Filter on created date (date only), use valid format such as m-d-yyyy */
  createdDate?: InputMaybe<AssortmentFilterValue>;
  /** Filter on assortment ids */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter on modified date (date only), use valid format such as m-d-yyyy */
  modifiedDate?: InputMaybe<AssortmentFilterValue>;
  /** Filter on assortment name */
  name?: InputMaybe<AssortmentFilterValue>;
  /**
   * Group of AssortmentFilters that will be joined by an OR condition.
   * (All filters contained within a group will be joined by AND.)
   */
  or?: InputMaybe<Array<AssortmentFilter>>;
  /** Filter on assortment po number */
  poNumber?: InputMaybe<AssortmentFilterValue>;
  /** Filter on retailer name or retailer ids */
  retailer?: InputMaybe<AssortmentRetailerFilter>;
  /** Filter on season name or year */
  season?: InputMaybe<AssortmentSeasonFilter>;
  /** Filter on start ship date (date only), use valid format such as m-d-yyyy */
  startShip?: InputMaybe<AssortmentFilterValue>;
  /** Filter on assortment status */
  status?: InputMaybe<AssortmentFilterValue>;
  /** Filter on workspace */
  workspace?: InputMaybe<AssortmentWorkspaceFilter>;
};

/** Operator used to check equivalency of a field to filter assortments on */
export enum AssortmentFilterOperator {
  CONTAINS = 'CONTAINS',
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN'
}

/** Value and operator used to check equivalency of a field to filter assortments on */
export type AssortmentFilterValue = {
  /** Operator to use for field comparison e.g. equals, less than, greater than */
  operator: AssortmentFilterOperator;
  /** Value to match field on */
  value: Scalars['String'];
};

export type AssortmentFinancialDetails = {
  currencyCode: Scalars['String'];
  isBrandCurrency?: Maybe<Scalars['Boolean']>;
  priceLevels: Array<FinancialPriceLevel>;
  units: AssortmentUnits;
};

export type AssortmentFinancialOverview = {
  /** @deprecated Get currency codes from financialDetails instead */
  assortmentCurrencyCode: Scalars['String'];
  assortmentUnits: AssortmentUnits;
  assortmentUnitsOverview: AssortmentUnitsOverview;
  financialDetails: Array<AssortmentFinancialDetails>;
  financialTargets: AssortmentFinancialTargets;
  /** @deprecated Get currency codes from financialDetails instead */
  linesheetCurrencyCode: Scalars['String'];
};

export type AssortmentFinancialPriceTargets = FinancialPrices & {
  averageUnitCost?: Maybe<Money>;
  averageUnitRetail?: Maybe<Money>;
  cost?: Maybe<Money>;
  initialMarkup?: Maybe<Scalars['Decimal']>;
  retail?: Maybe<Money>;
};

export type AssortmentFinancialTargets = {
  priceTargets: AssortmentFinancialPriceTargets;
  priceTargetsVariance: AssortmentFinancialPriceTargets;
  targetUnits: AssortmentUnits;
  targetUnitsVariance: AssortmentUnits;
};

export type AssortmentFinancials = Node & {
  doors: Array<DoorPriceLevels>;
  id: Scalars['ID'];
  products: Array<ProductPriceLevels>;
  total: TotalPriceLevels;
};

export type AssortmentIntegration = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AssortmentLineItemConnection = {
  count: Scalars['Int'];
  edges?: Maybe<Array<AssortmentLineItemEdge>>;
};

export type AssortmentLineItemEdge = {
  /** The line item containing the SKU, its quantity, and destination details */
  node?: Maybe<LineItem>;
};

export type AssortmentLineItemFinancialTotals = {
  finalAdjustedRetail?: Maybe<Scalars['Decimal']>;
  finalCost?: Maybe<Scalars['Decimal']>;
  finalExtendedCost?: Maybe<Scalars['Decimal']>;
  finalExtendedInternalMarkup?: Maybe<Scalars['Decimal']>;
  finalExtendedRetail?: Maybe<Scalars['Decimal']>;
  finalRetail?: Maybe<Scalars['Decimal']>;
  modifiedCost?: Maybe<Scalars['Decimal']>;
  modifiedRetail?: Maybe<Scalars['Decimal']>;
  originalCost?: Maybe<Scalars['Decimal']>;
  originalRetail?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type AssortmentLineItemFinancials = {
  /** The price modifiers applied to this line item */
  priceModifiers: PriceModifierConnection;
  /** This is the financials totaled for the entire line item quantity */
  total: AssortmentLineItemFinancialTotals;
  /** The financials at the unit level */
  unit: AssortmentLineItemUnitFinancials;
};

export type AssortmentLineItemUnitFinancials = {
  finalAdjustedRetail?: Maybe<Scalars['Decimal']>;
  finalCost?: Maybe<Scalars['Decimal']>;
  finalExtendedCost?: Maybe<Scalars['Decimal']>;
  finalExtendedInternalMarkup?: Maybe<Scalars['Decimal']>;
  finalExtendedRetail?: Maybe<Scalars['Decimal']>;
  finalRetail?: Maybe<Scalars['Decimal']>;
  modifiedCost?: Maybe<Scalars['Decimal']>;
  modifiedRetail?: Maybe<Scalars['Decimal']>;
  originalCost?: Maybe<Scalars['Decimal']>;
  originalRetail?: Maybe<Scalars['Decimal']>;
};

export enum AssortmentOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export enum AssortmentOrderByField {
  DATE = 'DATE'
}

export type AssortmentProductColorRequest = {
  code?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AssortmentProductProductRequest = {
  categories?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fabrication?: InputMaybe<Scalars['String']>;
  heelHeight?: InputMaybe<Scalars['String']>;
  materials?: InputMaybe<Scalars['String']>;
  measurements?: InputMaybe<Scalars['String']>;
  modelHeight?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  silhouette?: InputMaybe<Scalars['String']>;
  sourceOfMaterials?: InputMaybe<Scalars['String']>;
  wholesaleCurrencyCode?: InputMaybe<Scalars['String']>;
  wholesalePrice?: InputMaybe<Scalars['Decimal']>;
};

export type AssortmentProductRequest = {
  colors: Array<AssortmentProductColorRequest>;
  product: AssortmentProductProductRequest;
  sizes: Array<AssortmentProductSizeRequest>;
};

export type AssortmentProductSizeRequest = {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** Filter assortments on retailer fields */
export type AssortmentRetailerFilter = {
  /** Filter on retailer ids */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter on retailer name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentSKUColor = {
  attributeOptions: AttributeOptionConnection;
  /** The bulk quantity for this color, aka color bulk */
  bulkQuantity: Scalars['Int'];
  code: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  doorQuantities: Array<AssortmentSKUColorDoorQuantity>;
  id: Scalars['ID'];
  images: ImageConnection;
  missingRequiredAttributes: AttributeConnection;
  name: Scalars['String'];
  /** Financial price level rollup for this color */
  priceLevels: ProductColorPriceLevels;
  /** Size curves that can be applied to this product color */
  sizeCurves: RetailSizeCurves;
  /** All the assortment skus that share this color */
  skus: Array<AssortmentSKUEdge>;
  swatch: ColorSwatch;
  /**
   * The sum of all sized quantities for this color, aka color total
   * If a product has sizes small, medium and large and two doors, and each size
   * has 10 units for each size in each door, the total_sized_quantity will be:
   * Door1: 10 (small) + 10 (medium) + 10 (large) = 30
   * Door2: 10 (small) + 10 (medium) + 10 (large) = 30
   * totalSizedQuantity = 60
   */
  totalSizedQuantity: Scalars['Int'];
};

export type AssortmentSKUColorDoorQuantity = Node & {
  /** The bulk quantity for this door, aka door color bulk */
  bulkQuantity: Scalars['Int'];
  door?: Maybe<Door>;
  id: Scalars['ID'];
  /**
   * The sum of all sized quantities for this door, aka door color total
   * If a product has sizes small, medium and large and each size has 10
   * units for *this door*, the totalSizedQuantity will be:
   * 10 (small) + 10 (medium) + 10 (large) = 30
   */
  totalSizedQuantity: Scalars['Int'];
};

export type AssortmentSKUConnection = {
  edges?: Maybe<Array<AssortmentSKUEdge>>;
};

export type AssortmentSKUDoorQuantity = Node & {
  /** The size curve ratio applied to the sku */
  appliedSizeRatio?: Maybe<Scalars['Decimal']>;
  door?: Maybe<Door>;
  id: Scalars['ID'];
  /** The sized quantity for this door */
  quantity: Scalars['Int'];
};

export type AssortmentSKUEdge = {
  _id: Scalars['ID'];
  /**
   * Sku-level finanical details in the assortment currency.
   *
   * Note that this field does not support multi-currency assortments.
   * @deprecated Use financials field with filter isBrandCurrency:false
   */
  actualCurrencyFinancials?: Maybe<AssortmentSKUFinancials>;
  attributeOptions: AttributeOptionConnection;
  availableRetailSizeOptions: Array<RetailSize>;
  availableSizeRuns: Array<SizeRun>;
  /** The size bulk quantity for this sku, aka size bulk */
  bulkQuantity: Scalars['Int'];
  /** @deprecated use colorV2 instead */
  color: Color;
  colorV2: AssortmentSKUColor;
  comment?: Maybe<Scalars['String']>;
  /** Sized quantities for each door */
  doorQuantities: Array<AssortmentSKUDoorQuantity>;
  financials: Array<AssortmentSKUFinancials>;
  isCustom?: Maybe<Scalars['Boolean']>;
  legacyItemId: Scalars['ID'];
  /**
   * Sku-level financial details in the linesheet currency.
   *
   * Note that this field does not support multi-currency assortments.
   * @deprecated Use financials field with filter isBrandCurrency:true
   */
  linesheetCurrencyFinancials?: Maybe<AssortmentSKUFinancials>;
  mainImage?: Maybe<Image>;
  node: SKU;
  priceLevels: Array<PriceLevel>;
  /** Retail currency code of this sku (actually a product-level value) */
  retailCurrencyCode?: Maybe<Scalars['String']>;
  retailSize?: Maybe<RetailSize>;
  size: Size;
  sizeRun?: Maybe<SizeRunEdge>;
  style: Style;
  /** Assortment SKU-level UPC if available, otherwise use the brand product UPC */
  upc?: Maybe<Scalars['String']>;
  /** Wholesale currency code of this sku (actually a product-level value) */
  wholesaleCurrencyCode?: Maybe<Scalars['String']>;
};


export type AssortmentSKUEdgepriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type AssortmentSKUFinancials = {
  currencyCode: Scalars['String'];
  finalCost?: Maybe<Scalars['Decimal']>;
  /**
   * Calculated initial markup:
   * (finalRetail - finalCost) / finalRetail
   */
  finalIMU?: Maybe<Scalars['Decimal']>;
  finalRetail?: Maybe<Scalars['Decimal']>;
  isBrandCurrency?: Maybe<Scalars['Boolean']>;
  modifiedCost?: Maybe<Scalars['Decimal']>;
  /**
   * Calculated initial markup:
   * (modifiedRetail - modifiedCost) / modifiedRetail
   */
  modifiedIMU?: Maybe<Scalars['Decimal']>;
  modifiedRetail?: Maybe<Scalars['Decimal']>;
  originalCost?: Maybe<Scalars['Decimal']>;
  /**
   * Calculated initial markup:
   * (originalRetail - originalCost) / originalRetail
   */
  originalIMU?: Maybe<Scalars['Decimal']>;
  originalRetail?: Maybe<Scalars['Decimal']>;
};

/** Filter assortments on season fields */
export type AssortmentSeasonFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** If true then return assortments without a season (i.e. brand notes) */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Filter on season name */
  name?: InputMaybe<AssortmentFilterValue>;
  /** Filter on season year */
  year?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentShare = {
  createdDate: Scalars['Date'];
  id: Scalars['ID'];
  user: User;
  visited?: Maybe<Scalars['Date']>;
};

export type AssortmentShareInput = {
  userId: Scalars['ID'];
};

export type AssortmentSkuDoorLineItemBulkQuantity = {
  assortmentId: Scalars['ID'];
  destinationId: Scalars['ID'];
  destinationType: AssortmentSkuDoorLineItemBulkQuantityDestinationType;
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export enum AssortmentSkuDoorLineItemBulkQuantityDestinationType {
  DOOR = 'DOOR',
  DOOR_CLUSTER = 'DOOR_CLUSTER'
}

export type AssortmentSkuDoorLineItemBulkQuantityDoorOrCluster = Door | DoorCluster;

export type AssortmentSkuDoorLineItemQuantityInput = {
  assortmentId: Scalars['ID'];
  /** An ID for a door or cluster is required as this mutation is for an assigned line item */
  doorOrClusterId: Scalars['ID'];
  /** This will be the quantity to set for each assigned line item at a door level */
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export type AssortmentSkuDoorLineItemQuantityPayload = {
  /** Allow mutations to query the Assortment. */
  assortment: Assortment;
  /**
   * This is the assortment ID of the assortment being edited
   * @deprecated query the assortment object instead
   */
  assortmentId: Scalars['ID'];
  /**
   * Allow mutations to query the AssortmentSKUs modified.
   * @deprecated use generic query response instead
   */
  assortmentSkus: AssortmentSKUConnection;
  /**
   * This is the list of assigned line items that were set with the request's quantity
   * @deprecated query the assortment object instead
   */
  lineItems: AssortmentLineItemConnection;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
};


export type AssortmentSkuDoorLineItemQuantityPayloadassortmentSkusArgs = {
  ids: Array<Scalars['ID']>;
};

export type AssortmentSkuUnassignedLineItemQuantityInput = {
  assortmentId: Scalars['ID'];
  /** This will be the quantity to set for each unassigned line item */
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export type AssortmentSkuUnassignedLineItemQuantityPayload = {
  /** This is the assortment ID of the assortment being edited */
  assortmentId: Scalars['ID'];
  /** This is the list of unassigned line items that were set with the request's quantity */
  unassignedLineItems: AssortmentLineItemConnection;
};

export enum AssortmentStatus {
  ARCHIVED = 'ARCHIVED',
  DONE = 'DONE',
  IN_REVIEW = 'IN_REVIEW',
  IN_WORK = 'IN_WORK',
  UNKNOWN = 'UNKNOWN'
}

export type AssortmentSummary = BaseAssortment & Node & {
  /** Object version for this assortment */
  _version: Scalars['String'];
  /** The retailer brand linked to this assortment */
  brand?: Maybe<RetailerBrandEdge>;
  /** Brand Name associated with Assortment itself (not trough brand_id field) */
  brandName?: Maybe<Scalars['String']>;
  brandV2?: Maybe<RetailerBrand>;
  /** Linesheet */
  collection?: Maybe<Collection>;
  /** Visible Linesheet Code for this Assortment */
  collectionCode?: Maybe<Scalars['String']>;
  /** Visible Linesheet Name for this Assortment */
  collectionName?: Maybe<Scalars['String']>;
  /** The user who created this assortment */
  createdByUser: RetailerUserEdge;
  /** The date the assortment was created */
  createdDate: Scalars['Date'];
  /** Delivery window details */
  deliveryWindow: AssortmentDeliveryWindow;
  /** The users able to edit this assortment */
  editableByUsers: RetailerUserConnection;
  /** The message associated with the most recent export attempt */
  exportMessage?: Maybe<Scalars['String']>;
  /** Financial Overview associated with this assortment */
  financialOverview: AssortmentFinancialOverview;
  id: Scalars['ID'];
  /** The success status of the most recent export attempt */
  latestExport?: Maybe<AssortmentExportStatus>;
  /** The date the assortment was last modified */
  modifiedDate: Scalars['Date'];
  /** The name of the assortment */
  name: Scalars['String'];
  /** The assortment's sync status with a brand order */
  orderAssortmentSyncStatus?: Maybe<OrderAssortmentSyncStatus>;
  /** The PO number for this assortment */
  poNumber: Scalars['String'];
  /** The retailer that owns this assortment */
  retailer: RetailerEdge;
  /** The season associated with this assortment */
  season?: Maybe<SeasonEdge>;
  /** List of assortment sharing details */
  shares: Array<AssortmentShare>;
  /** The current status of the assortment status */
  status: AssortmentStatus;
  /** Total count of the unread notifications on this assortment for the querying user */
  unreadNotificationsCount: Scalars['Int'];
};


export type AssortmentSummarysharesArgs = {
  onlyToMe?: InputMaybe<Scalars['Boolean']>;
};

export type AssortmentSummaryConnection = {
  edges?: Maybe<Array<AssortmentSummaryEdge>>;
};

export type AssortmentSummaryEdge = {
  node?: Maybe<AssortmentSummary>;
};

export type AssortmentUI_RowColorBulkQuantities = {
  assortment: Assortment;
  colors: Array<AssortmentUI__ColorUnitQuantity>;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  skus: Array<AssortmentUI__SkuUnitQuantity>;
};

export type AssortmentUI_RowSizeBulkQuantities = {
  assortment: Assortment;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  sizes: Array<AssortmentUI__SizeUnitQuantity>;
  skus: Array<AssortmentUI__SkuUnitQuantity>;
};

export type AssortmentUI__AddColorsToAssortmentProductRequest = {
  colors: Array<AssortmentUI__AssortmentProductColorRequest>;
  productId: Scalars['ID'];
};

export type AssortmentUI__Assortment = {
  doors: Array<AssortmentUI__AssortmentDoor>;
  id: Scalars['ID'];
  /**
   * Generic top level query field to query for assortment
   * from this namespace
   */
  query?: Maybe<Query>;
  skus: Array<AssortmentUI__AssortmentSku>;
};

export type AssortmentUI__AssortmentDoor = {
  code: Scalars['String'];
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AssortmentUI__AssortmentProductColorRequest = {
  code?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AssortmentUI__AssortmentProductProductRequest = {
  categories?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fabrication?: InputMaybe<Scalars['String']>;
  heelHeight?: InputMaybe<Scalars['String']>;
  materials?: InputMaybe<Scalars['String']>;
  measurements?: InputMaybe<Scalars['String']>;
  modelHeight?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  silhouette?: InputMaybe<Scalars['String']>;
  sourceOfMaterials?: InputMaybe<Scalars['String']>;
  wholesaleCurrencyCode?: InputMaybe<Scalars['String']>;
  wholesalePrice?: InputMaybe<Scalars['Decimal']>;
};

export type AssortmentUI__AssortmentProductRequest = {
  colors: Array<AssortmentUI__AssortmentProductColorRequest>;
  product: AssortmentUI__AssortmentProductProductRequest;
  sizes: Array<AssortmentUI__AssortmentProductSizeRequest>;
};

export type AssortmentUI__AssortmentProductSizeRequest = {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AssortmentUI__AssortmentSku = AssortmentUI__WithUnitQuantities & {
  assortmentPrices: AssortmentUI__AssortmentSkuPrices;
  brandCatalogSku?: Maybe<SKU>;
  color: AssortmentUI__AssortmentSkuColor;
  comment?: Maybe<Scalars['String']>;
  doorQuantities: Array<AssortmentUI__AssortmentSkuDoorQuantities>;
  id: Scalars['ID'];
  initialMarkup: Scalars['Decimal'];
  isCustom?: Maybe<Scalars['Boolean']>;
  linesheetPrices: AssortmentUI__AssortmentSkuPrices;
  product: AssortmentUI__AssortmentSkuProduct;
  size: AssortmentUI__AssortmentSkuSize;
  /** Units target is a target quantity for this sku */
  unitsTarget: Scalars['Int'];
  /** Units total is a quantity explicitly allocated for this sku */
  unitsTotal: Scalars['Int'];
  /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
  unitsVariance?: Maybe<Scalars['Int']>;
  upc?: Maybe<Scalars['String']>;
};

export type AssortmentUI__AssortmentSkuColor = AssortmentUI__WithUnitQuantities & {
  code: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<Array<Image>>;
  name: Scalars['String'];
  swatch?: Maybe<AssortmentUI__Swatch>;
  /** Units target is a target quantity for this sku */
  unitsTarget: Scalars['Int'];
  /** Units total is a quantity explicitly allocated for this sku */
  unitsTotal: Scalars['Int'];
  /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
  unitsVariance?: Maybe<Scalars['Int']>;
};

export type AssortmentUI__AssortmentSkuDoorQuantities = AssortmentUI__WithUnitQuantities & {
  door: AssortmentUI__AssortmentDoor;
  id: Scalars['ID'];
  /** Units target is a target quantity for this sku */
  unitsTarget: Scalars['Int'];
  /** Units total is a quantity explicitly allocated for this sku */
  unitsTotal: Scalars['Int'];
  /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
  unitsVariance?: Maybe<Scalars['Int']>;
};

export type AssortmentUI__AssortmentSkuPrices = {
  costCurrencyCode: Scalars['String'];
  costFinal: Scalars['Decimal'];
  costFinalExtended: Scalars['Decimal'];
  costModified: Scalars['Decimal'];
  costOriginal: Scalars['Decimal'];
  retailCurrencyCode: Scalars['String'];
  retailFinal: Scalars['Decimal'];
  retailFinalExtended: Scalars['Decimal'];
  retailModified: Scalars['Decimal'];
  retailOriginal: Scalars['Decimal'];
};

export type AssortmentUI__AssortmentSkuProduct = {
  categories?: Maybe<Array<Scalars['String']>>;
  code: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
  containsFur: Scalars['Boolean'];
  countryOfOrigin?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  fabrication?: Maybe<Scalars['String']>;
  heelHeight?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: Maybe<Array<Image>>;
  materials?: Maybe<Array<Scalars['String']>>;
  measurements?: Maybe<Scalars['String']>;
  modelHeight?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  silhouette?: Maybe<Scalars['String']>;
  sourceOfMaterials?: Maybe<Scalars['String']>;
};

export type AssortmentUI__AssortmentSkuSize = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AssortmentUI__BulkAddColorsToAssortmentProductRequest = {
  assortmentId: Scalars['ID'];
  requests: Array<AssortmentUI__AddColorsToAssortmentProductRequest>;
};

export type AssortmentUI__BulkAddColorsToAssortmentProductResponse = {
  assortment?: Maybe<Assortment>;
};

export type AssortmentUI__BulkColorUnitUpdate = {
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export type AssortmentUI__BulkCreateAssortmentProductRequest = {
  assortmentId: Scalars['ID'];
  products: Array<AssortmentUI__AssortmentProductRequest>;
};

export type AssortmentUI__BulkSizeUnitUpdate = {
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export type AssortmentUI__ColorUnitQuantity = {
  colorId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type AssortmentUI__CreateRetailerExclusiveSkuRequest = {
  assortmentId: Scalars['ID'];
  color: AssortmentUI__RetailerExclusiveSkuColorRequest;
  product: AssortmentUI__RetailerExclusiveSkuProductRequest;
  size: AssortmentUI__RetailerExclusiveSkuSizeRequest;
};

export type AssortmentUI__CreateRetailerExclusiveSkuResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type AssortmentUI__RetailerExclusiveSkuColorRequest = {
  code: Scalars['String'];
  comment: Scalars['String'];
  name: Scalars['String'];
};

export type AssortmentUI__RetailerExclusiveSkuProductRequest = {
  categories?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fabrication?: InputMaybe<Scalars['String']>;
  heelHeight?: InputMaybe<Scalars['String']>;
  materials?: InputMaybe<Scalars['String']>;
  measurements?: InputMaybe<Scalars['String']>;
  modelHeight?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  silhouette?: InputMaybe<Scalars['String']>;
  sourceOfMaterials?: InputMaybe<Scalars['String']>;
  wholesalePrice?: InputMaybe<Scalars['Decimal']>;
};

export type AssortmentUI__RetailerExclusiveSkuSizeRequest = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type AssortmentUI__RowUnits = {
  bulk?: Maybe<Scalars['Int']>;
};

export type AssortmentUI__SizeUnitQuantity = {
  quantity: Scalars['Int'];
  sizeId: Scalars['ID'];
};

export type AssortmentUI__SkuRow = {
  sku: SKU;
  units?: Maybe<AssortmentUI__SkuRowUnits>;
};

export type AssortmentUI__SkuRowUnits = {
  color?: Maybe<AssortmentUI__RowUnits>;
  size?: Maybe<AssortmentUI__RowUnits>;
};

export type AssortmentUI__SkuUnitQuantity = {
  quantity: Scalars['Int'];
  sku: SKU;
};

export type AssortmentUI__Swatch = Hex | Image | RGB;

export type AssortmentUI__UpdateRetailerExclusiveSkuRequest = {
  assortmentId: Scalars['ID'];
  color: AssortmentUI__RetailerExclusiveSkuColorRequest;
  product: AssortmentUI__RetailerExclusiveSkuProductRequest;
  size: AssortmentUI__RetailerExclusiveSkuSizeRequest;
  skuId: Scalars['ID'];
};

export type AssortmentUI__UpdateRetailerExclusiveSkuResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type AssortmentUI__WithUnitQuantities = {
  /** Units target is a target quantity for this sku */
  unitsTarget: Scalars['Int'];
  /** Units total is a quantity explicitly allocated for this sku */
  unitsTotal: Scalars['Int'];
  /** Units variance is the difference between the actual and bulk. If left null it is intended for this to be dynamically calculated */
  unitsVariance?: Maybe<Scalars['Int']>;
};

export type AssortmentUI__bulkCreateAssortmentProductResponse = {
  assortment?: Maybe<Assortment>;
};

export type AssortmentUnits = {
  colorCount?: Maybe<Scalars['Int']>;
  productCount?: Maybe<Scalars['Int']>;
  skuCount?: Maybe<Scalars['Int']>;
  unitCount?: Maybe<Scalars['Int']>;
  unitDepth?: Maybe<Scalars['String']>;
};

export type AssortmentUnitsOverview = {
  colorCount?: Maybe<Scalars['Int']>;
  productCount?: Maybe<Scalars['Int']>;
  skuCount?: Maybe<Scalars['Int']>;
};

/** Enum of all fields that are supported for validation */
export enum AssortmentValidationField {
  ASSORTMENT_NAME = 'ASSORTMENT_NAME',
  BRAND = 'BRAND',
  COLOR_CODE = 'COLOR_CODE',
  COLOR_NAME = 'COLOR_NAME',
  COMMENT = 'COMMENT',
  COUNTRY_OF_ORIGIN = 'COUNTRY_OF_ORIGIN',
  DELIVERY = 'DELIVERY',
  DESCRIPTION = 'DESCRIPTION',
  DUE_DATE = 'DUE_DATE',
  FABRICATION = 'FABRICATION',
  HEEL_HEIGHT = 'HEEL_HEIGHT',
  HIERARCHY = 'HIERARCHY',
  MATERIALS = 'MATERIALS',
  MEASUREMENTS = 'MEASUREMENTS',
  MISSING = 'MISSING',
  MODEL_HEIGHT = 'MODEL_HEIGHT',
  ORIGINAL_COST = 'ORIGINAL_COST',
  ORIGINAL_RETAIL = 'ORIGINAL_RETAIL',
  PO_NUMBER = 'PO_NUMBER',
  SEASON = 'SEASON',
  SILHOUETTE = 'SILHOUETTE',
  SIZES = 'SIZES',
  SIZE_DOOR_QUANTITIES = 'SIZE_DOOR_QUANTITIES',
  SOURCE_OF_MATERIALS = 'SOURCE_OF_MATERIALS',
  STYLE_CODE = 'STYLE_CODE',
  STYLE_NAME = 'STYLE_NAME'
}

/** Filter assortments on workspace fields */
export type AssortmentWorkspaceFilter = {
  /** Filter on workspace id */
  ids?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter on workspace name */
  name?: InputMaybe<AssortmentFilterValue>;
};

export type AssortmentsOrderBy = {
  field?: InputMaybe<AssortmentOrderByField>;
  order?: InputMaybe<AssortmentOrder>;
};

export enum AssortmentsQueryOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type AssortmentsQueryOrderBy = {
  /** The field used to order the results of an assortments query */
  field: AssortmentsQueryOrderField;
  /** The direction of the ordering (or DESCENDING if not specified) */
  order?: InputMaybe<AssortmentsQueryOrder>;
};

export enum AssortmentsQueryOrderField {
  /** Brand account profile name, as alphanumeric */
  BRAND_NAME = 'BRAND_NAME',
  /** Delivery window, as datetime */
  COMPLETE_SHIP = 'COMPLETE_SHIP',
  /** Created by user's name, as alphanumeric */
  CREATED_BY_USER = 'CREATED_BY_USER',
  /** Created date, as datetime */
  CREATED_DATE = 'CREATED_DATE',
  /** Modified date, as datetime */
  MODIFIED_DATE = 'MODIFIED_DATE',
  /** Assortment name, as alphanumeric */
  NAME = 'NAME',
  /** PO Number, as numeric */
  PO_NUMBER = 'PO_NUMBER',
  /** Season name, as alphanumeric */
  SEASON = 'SEASON',
  /** Delivery window start shipment date, as datetime */
  START_SHIP = 'START_SHIP',
  /** Assortment status, as enum */
  STATUS = 'STATUS'
}

export type AsyncAddOrdersToVisualAssortmentResponse = {
  jobId: Scalars['String'];
};

/** A PDF export job tracked through listMonitoringJobs. */
export type AsyncExportVisualAssortmentPdfResponse = {
  /** Job identifier used to retrieve the export status and download URL. */
  jobId: Scalars['String'];
};

export type Attachment = {
  fileName: Scalars['String'];
  url: Scalars['String'];
};

export type AttachmentInput = {
  fileName: Scalars['String'];
  url: Scalars['String'];
};

/**
 * A user defined field which can apply to a Assortment, Item Color, etc.
 * Attributes can have a parent-child relationship with other assortment attributes.
 */
export type Attribute = Node & {
  availableOptions: AttributeOptionConnection;
  code: Scalars['String'];
  id: Scalars['ID'];
  isMultiSelect: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  name: Scalars['String'];
  options: AttributeOptionConnection;
  parent?: Maybe<AttributeEdge>;
  position: Scalars['Int'];
  type: AttributeType;
};


/**
 * A user defined field which can apply to a Assortment, Item Color, etc.
 * Attributes can have a parent-child relationship with other assortment attributes.
 */
export type AttributeavailableOptionsArgs = {
  assortmentId?: InputMaybe<Scalars['ID']>;
};


/**
 * A user defined field which can apply to a Assortment, Item Color, etc.
 * Attributes can have a parent-child relationship with other assortment attributes.
 */
export type AttributeoptionsArgs = {
  filterBy?: InputMaybe<AttributeOptionFilterInput>;
};

export type AttributeConnection = {
  edges?: Maybe<Array<AttributeEdge>>;
};

export type AttributeEdge = {
  node?: Maybe<Attribute>;
};

/**
 * Attribute options are individual selections for an attribute.
 * Options can be filtered by:
 * 1. other assortment attribute options
 * 1. retailer brands
 * 1. merchandising hierarchy nodes
 */
export type AttributeOption = Node & {
  /** The Attribute that this option belongs to */
  attribute: AttributeEdge;
  /** Attribute options that filter this option */
  attributeOptionFilters: AttributeOptionFilterConnection;
  /** A unique identifier */
  code: Scalars['String'];
  id: Scalars['ID'];
  /** Merchandising hierarchies that filter this option */
  merchandisingHierarchyFilters: MerchandisingHierarchyFilterConnection;
  /** Retailer brands that filter this option */
  retailerBrandFilters: RetailerBrandFilterConnection;
  /** The value of this option */
  value: Scalars['String'];
};

export type AttributeOptionConnection = {
  edges?: Maybe<Array<AttributeOptionEdge>>;
};

export type AttributeOptionEdge = {
  node?: Maybe<AttributeOption>;
};

export type AttributeOptionFilter = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AttributeOption>;
};

export type AttributeOptionFilterConnection = {
  edges?: Maybe<Array<AttributeOptionFilter>>;
};

export type AttributeOptionFilterInput = {
  brandAccountIds: Array<Scalars['ID']>;
  merchandisingHierarchyNodeIds: Array<Scalars['ID']>;
  selectedOptionIds: Array<Scalars['ID']>;
};

export enum AttributeType {
  /** This attribute applies to an assortment */
  ASSORTMENT = 'ASSORTMENT',
  /** This attribute applies to an item-color */
  ITEM_COLOR = 'ITEM_COLOR'
}

export type AttributeValidation = {
  attribute: Attribute;
  /** Whether the field(s) is "valid", i.e. for assortment-level fields, whether it has been set to a value, for product-level fields, whether all products have been assigned a value */
  valid: Scalars['Boolean'];
};

export type AutoCompleteFilter = {
  connectionStatus?: InputMaybe<ConnectionStatus>;
  searchQuery: Scalars['String'];
};

export type Availability = {
  availableOn?: Maybe<Scalars['Date']>;
  isImmediate: Scalars['Boolean'];
};

export enum AvailableAssortmentIntegrations {
  BOTH = 'BOTH',
  NONE = 'NONE',
  NON_SCHEDULABLE = 'NON_SCHEDULABLE'
}

export type BackupProduct = {
  backupVariants: BackupVariantConnection;
  casepacks: ProductCasepackConnection;
  orderId: Scalars['ID'];
  orderMinimum?: Maybe<Scalars['Int']>;
  productId: Scalars['ID'];
  productImage: Scalars['String'];
  productName: Scalars['String'];
  productNumber: Scalars['String'];
  skus: SKUConnection;
};


export type BackupProductcasepacksArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type BackupProductskusArgs = {
  withCasepacks?: InputMaybe<Scalars['Boolean']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
  withInactive?: InputMaybe<Scalars['Boolean']>;
};

export type BackupProductConnection = {
  edges?: Maybe<Array<BackupProductEdge>>;
};

export type BackupProductEdge = {
  node?: Maybe<BackupProduct>;
};

export type BackupVariantConnection = {
  edges?: Maybe<Array<BackupVariantEdge>>;
};

export type BackupVariantEdge = {
  node: VariantTrait;
  values: VariantValueConnection;
};

export type Badge = {
  brand?: Maybe<Brand>;
  id: Scalars['ID'];
  image?: Maybe<Media>;
  name: Scalars['String'];
  visible?: Maybe<Scalars['Boolean']>;
};

export type BadgeConnection = {
  edges: Array<BadgeEdge>;
};

export type BadgeEdge = {
  node: Badge;
};

export type BadgeFilter = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BadgeOrderBy = {
  field?: InputMaybe<BadgeOrderByField>;
};

export enum BadgeOrderByField {
  NAME = 'NAME'
}

export type BankAccount = PaymentMethodI & {
  bankName: Scalars['String'];
  billingEmail: Scalars['String'];
  billingName: Scalars['String'];
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
  status: BankAccountStatus;
  type: Scalars['String'];
};

export enum BankAccountStatus {
  ERROR = 'ERROR',
  NEW = 'NEW',
  UNKNOWN = 'UNKNOWN',
  VERIFIED = 'VERIFIED'
}

export enum BannerType {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export type Banners = {
  imageBanners: Array<CollectionImageBanner>;
  textBanners: Array<CollectionTextBanner>;
  videoBanners: Array<CollectionVideoBanner>;
};

export type BaseAccount = {
  accountManagerEmail?: Maybe<Scalars['String']>;
  aliasedName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privacy: Scalars['Boolean'];
  status: AccountStatus;
  type?: Maybe<AccountType>;
};

export type BaseAssortment = {
  /** The retailer brand linked to this assortment */
  brand?: Maybe<RetailerBrandEdge>;
  /** Brand Name associated with Assortment itself (not trough brand_id field) */
  brandName?: Maybe<Scalars['String']>;
  brandV2?: Maybe<RetailerBrand>;
  /** Linesheet */
  collection?: Maybe<Collection>;
  /** Visible Linesheet Code for this Assortment */
  collectionCode?: Maybe<Scalars['String']>;
  /** Visible Linesheet Name for this Assortment */
  collectionName?: Maybe<Scalars['String']>;
  /** The user who created this assortment */
  createdByUser: RetailerUserEdge;
  /** The date the assortment was created */
  createdDate: Scalars['Date'];
  /** Delivery window details */
  deliveryWindow: AssortmentDeliveryWindow;
  /** The users able to edit this assortment */
  editableByUsers: RetailerUserConnection;
  /** The message associated with the most recent export attempt */
  exportMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The success status of the most recent export attempt */
  latestExport?: Maybe<AssortmentExportStatus>;
  /** The date the assortment was last modified */
  modifiedDate: Scalars['Date'];
  /** The name of the assortment */
  name: Scalars['String'];
  /** The assortment's sync status with a brand order */
  orderAssortmentSyncStatus?: Maybe<OrderAssortmentSyncStatus>;
  /** The PO number for this assortment */
  poNumber: Scalars['String'];
  /** The retailer that owns this assortment */
  retailer: RetailerEdge;
  /** The season associated with this assortment */
  season?: Maybe<SeasonEdge>;
  /** List of assortment sharing details */
  shares: Array<AssortmentShare>;
  /** The current status of the assortment status */
  status: AssortmentStatus;
  /** Total count of the unread notifications on this assortment for the querying user */
  unreadNotificationsCount: Scalars['Int'];
};


export type BaseAssortmentsharesArgs = {
  onlyToMe?: InputMaybe<Scalars['Boolean']>;
};

export type BillingAddress = {
  address?: Maybe<HyperionAddress>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type BillingAddressInput = {
  brandId?: InputMaybe<Scalars['String']>;
  buyerName: Scalars['String'];
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  storeName: Scalars['String'];
  streetAddress1: Scalars['String'];
  streetAddress2?: InputMaybe<Scalars['String']>;
};

export type BillingAddressPayload = {
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** A billing contact on an organization. */
export type BillingContact = {
  /** Contact's email address. */
  email: Scalars['String'];
  /** Unique identifier for this billing contact. */
  id: Scalars['ID'];
  /** Contact's full name. */
  name: Scalars['String'];
};

export type BillingContactInput = {
  /** Contact's email address. */
  email: Scalars['String'];
  /** Contact's full name. */
  name: Scalars['String'];
};

export type BillingInfo = {
  address?: InputMaybe<AddressInput>;
  billingAddressId?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
};

export type BillingProfile = {
  billingAddress: BillingProfileAddress;
  birthdate?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type BillingProfileAddress = {
  city: Scalars['String'];
  country: Scalars['String'];
  region?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  zipCode?: InputMaybe<Scalars['String']>;
};

/** A JOOR brand account */
export type Brand = {
  brandUsers?: Maybe<BrandUserConnection>;
  connectedAccounts: BrandRetailerConnection;
  customerGroups: CustomerGroupConnection;
  divisions?: Maybe<Array<Division>>;
  id: Scalars['ID'];
  /** Account name on JOOR */
  name: Scalars['String'];
  orderEvents: Array<LibraryValue>;
  orderSettings?: Maybe<OrderSettings>;
  orderTypes: OrderTypeConnection;
  paymentMethods: PaymentMethodConnection;
  priceTypes: PriceTypeConnection;
  seasons: BrandSeasonConnection;
  shippingMethods: ShippingMethodConnection;
  tagGroups: TagGroupConnection;
  /** Brand users for this account */
  users: Array<User>;
  warehouses: WarehouseConnection;
};


/** A JOOR brand account */
export type BrandbrandUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
};


/** A JOOR brand account */
export type BrandconnectedAccountsArgs = {
  filter?: InputMaybe<ConnectedAccountsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** A JOOR brand account */
export type BrandorderEventsArgs = {
  orderBy?: InputMaybe<LibraryValuesOrderBy>;
};


/** A JOOR brand account */
export type BrandusersArgs = {
  filter?: InputMaybe<UsersFilter>;
};

export type BrandAssortmentDetailsProfile = {
  brandId: Scalars['ID'];
  brandImage?: Maybe<Media>;
  brandName: Scalars['String'];
  id: Scalars['ID'];
  linesheetName: Scalars['String'];
  /** @deprecated Use orderTimestamp instead */
  orderTime: Scalars['Date'];
  orderTimestamp: Scalars['Date'];
  poNumber: Scalars['String'];
};

export type BrandAutoComplete = {
  brands: PrivateBrandProfileConnection;
  categories: Array<Maybe<Scalars['String']>>;
};

export type BrandBudget = Node & {
  collection?: Maybe<Collection>;
  division?: Maybe<Division>;
  door?: Maybe<BrandDoor>;
  id: Scalars['ID'];
  priceType: PriceType;
  retailerId: Scalars['ID'];
  totalUnits: Scalars['Decimal'];
  totalUnitsPriorYear: Scalars['Decimal'];
  totalWholesale: Scalars['Decimal'];
  totalWholesalePriorYear: Scalars['Decimal'];
};

export type BrandBudgetConnection = {
  edges?: Maybe<Array<BrandBudgetEdge>>;
};

export type BrandBudgetEdge = {
  node: BrandBudget;
};

export type BrandBudgetFilter = {
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BrandBuyer = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type BrandCategory = {
  name: Scalars['String'];
};

export type BrandConnection = {
  edges: Array<BrandEdge>;
};

export type BrandCurrency = {
  code: Scalars['String'];
};

export type BrandDoor = Node & {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BrandDoorConnection = {
  edges: Array<BrandDoorEdge>;
};

export type BrandDoorEdge = {
  node: BrandDoor;
};

export type BrandEdge = {
  node?: Maybe<Brand>;
};

export type BrandMedia = {
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mediaType?: Maybe<MediaType>;
  url?: Maybe<Scalars['String']>;
};

export type BrandMediaFilters = {
  mediaType?: InputMaybe<MediaType>;
  searchFilename?: InputMaybe<Scalars['String']>;
};

export type BrandMediaPayload = {
  media: Array<Media>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BrandOrder = {
  brandId: Scalars['ID'];
  brandImage?: Maybe<Media>;
  brandName: Scalars['String'];
  id: Scalars['ID'];
  linesheetName: Scalars['String'];
  orderTime: Scalars['Date'];
  poNumber: Scalars['String'];
};

export type BrandOrderCombination = {
  collection: Collection;
  division?: Maybe<Division>;
  door?: Maybe<BrandDoor>;
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
  totalUnits: Scalars['Float'];
  totalWholesale: Scalars['Float'];
  traitValues: ProductTraitValueConnection;
  variant?: Maybe<SkuTraitValue>;
};

export type BrandPaymentMethodPayload = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type BrandPriceType = {
  currency: ConnectionCurrency;
  id: Scalars['ID'];
  name: Scalars['String'];
  retailCurrency: ConnectionCurrency;
};

export type BrandProductLine = Node & {
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BrandProfile = {
  /** Account media url */
  accountMedia?: Maybe<BrandMedia>;
  brandId: Scalars['ID'];
  /** Cover media url */
  coverMedia?: Maybe<BrandMedia>;
  /** Custom Profile images associated with account. Filtered by the online home page */
  customProfileImageUrls: Array<Scalars['String']>;
  /** Custom JOOR URL Handle */
  customUrlHandle?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** @deprecated Use brandId instead */
  id: Scalars['ID'];
  /** iPad photo id */
  ipadPhotoId?: Maybe<Scalars['ID']>;
  /** iPad photo url */
  ipadPhotoUrl?: Maybe<Scalars['String']>;
  /** If the brand is a lite brand */
  isLiteBrand?: Maybe<Scalars['Boolean']>;
  /** Logo image id */
  logoId?: Maybe<Scalars['ID']>;
  /** Logo image url */
  logoUrl?: Maybe<Scalars['String']>;
  /** Account name on JOOR */
  name?: Maybe<Scalars['String']>;
  /** Product lines/categories */
  productLines: Array<Scalars['String']>;
  /** Profile images associated with account. Usually found in about me section. */
  profileImageUrls: Array<Scalars['String']>;
  /** Retail max */
  retailMax?: Maybe<Scalars['Int']>;
  /** Retail min */
  retailMin?: Maybe<Scalars['Int']>;
  /** Social media accounts */
  socialMediaAccounts: Array<SocialMediaAccount>;
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']>;
  /** Wholesale max */
  wholesaleMax?: Maybe<Scalars['Int']>;
  /** Wholesale min */
  wholesaleMin?: Maybe<Scalars['Int']>;
  /** Year established */
  yearEstablished?: Maybe<Scalars['Int']>;
};


export type BrandProfilecustomProfileImageUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BrandRetailerConnection = {
  edges: Array<BrandRetailerEdge>;
};

export type BrandRetailerEdge = {
  alias?: Maybe<Scalars['String']>;
  billingAddresses: Array<BillingAddress>;
  buyers: Array<BrandBuyer>;
  code?: Maybe<Scalars['String']>;
  customerGroups: Array<CustomerGroupOutput>;
  node?: Maybe<Retailer>;
  paymentMethods: Array<BrandRetailerPaymentMethod>;
  priceTypes?: Maybe<Array<ConnectionPriceTypeResponse>>;
  shippingAddresses: Array<ShippingAddress>;
  shippingMethods: Array<BrandRetailerShippingMethod>;
};

export type BrandRetailerIdentifiers = {
  brandId?: InputMaybe<Scalars['ID']>;
  retailerId: Scalars['ID'];
};

export type BrandRetailerPaymentMethod = {
  default?: Maybe<Scalars['Boolean']>;
  paymentMethod: PaymentMethod;
};

export type BrandRetailerShippingMethod = {
  default?: Maybe<Scalars['Boolean']>;
  shippingMethod?: Maybe<ShippingMethod>;
};

/** A specific selling period used to group assortments */
export type BrandSeason = Node & {
  id: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
};

export type BrandSeasonConnection = {
  edges: Array<BrandSeasonEdge>;
};

export type BrandSeasonEdge = {
  node: BrandSeason;
};

export type BrandShippingMethodPayload = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type BrandShopifyIntegration = ShopifyIntegration & {
  appName: ShopifyAppName;
  id: Scalars['ID'];
  /** @deprecated use linkedAccounts field instead */
  isEnabled: Scalars['Boolean'];
  isInstalled: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  isSubscriptionActive: Scalars['Boolean'];
  lastSyncDate?: Maybe<Scalars['DateTime']>;
  linkedAccounts: Array<AccountIntegration>;
  shopName: Scalars['String'];
  shopUrl: Scalars['String'];
  storeCurrencyCode: Scalars['String'];
  syncSettings?: Maybe<ShopifyBrandSyncSettings>;
};

export enum BrandStatus {
  ACTIVE = 'ACTIVE',
  HISTORICAL = 'HISTORICAL',
  INTERNAL = 'INTERNAL',
  INVISIBLE = 'INVISIBLE',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  PRE_ACTIVE = 'PRE_ACTIVE'
}

export enum BrandSubType {
  ALL = 'ALL',
  LITE = 'LITE',
  PRO = 'PRO',
  UNKNOWN = 'UNKNOWN'
}

export type BrandSuggestion = {
  brandProfile: PrivateBrandProfile;
  completion: Scalars['String'];
};

export type BrandTag = {
  code: Scalars['String'];
  id: Scalars['ID'];
  value: Scalars['String'];
};

export type BrandTagConnection = {
  edges: Array<BrandTagEdge>;
};

export type BrandTagEdge = {
  node: BrandTag;
};

export type BrandTermsAndConditions = {
  brand: Brand;
  termsAndConditions?: Maybe<Array<TermsAndConditions>>;
};

export type BrandTermsAndConditionsConnection = {
  edges?: Maybe<Array<BrandTermsAndConditionsEdge>>;
};

export type BrandTermsAndConditionsEdge = {
  node: BrandTermsAndConditions;
};

export type BrandUserConnection = {
  edges: Array<BrandUserEdge>;
};

export type BrandUserEdge = {
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  /** Data Permission Configuration for this user in relation to a specific brand */
  dataPermissionConfiguration?: Maybe<DataPermissionConfiguration>;
  /** Display for this user in relation to a specific brand */
  displayName?: Maybe<Scalars['String']>;
  node?: Maybe<User>;
};

export type BrandUserIdList = {
  brandId: Scalars['ID'];
  users: Array<User>;
};

export type BrandViewerAccount = BaseAccount & {
  accountCreationSource?: Maybe<AccountCreationSource>;
  accountManagerEmail?: Maybe<Scalars['String']>;
  aliasedName?: Maybe<Scalars['String']>;
  canTransact: Scalars['Boolean'];
  canViewDataPortal: Scalars['Boolean'];
  enableChat: Scalars['Boolean'];
  id: Scalars['ID'];
  integrations: Array<Maybe<Scalars['String']>>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privacy: Scalars['Boolean'];
  status: AccountStatus;
  subType?: Maybe<Scalars['String']>;
  type?: Maybe<AccountType>;
};

export type BrandsFilter = {
  allowUnconnectedBrands?: InputMaybe<Scalars['Boolean']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  ipadEnabled?: InputMaybe<Scalars['Boolean']>;
  searchName?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<BrandStatus>>;
  subtype?: InputMaybe<BrandSubType>;
};

/**
 * Budgets allow retailers to define planned spending
 * by a set of purchase terms:
 * 1. brand
 * 1. currency
 * 1. door
 * 1. merchandising hierarchy
 * 1. season
 */
export type Budget = Node & {
  /** Brand that filters this budget */
  brand?: Maybe<RetailerBrandEdge>;
  /** Currency that filters this budget */
  currencyCode: Scalars['String'];
  /** Retail door that filters this budget */
  door?: Maybe<Door>;
  /** Spending targets defined by this budget */
  goals: Array<BudgetGoal>;
  id: Scalars['ID'];
  /** Merchandising hierarchy leaf nodes that filter this budget */
  merchandisingHierarchyNodes: MerchandisingHierarchyNodeConnection;
  /** Season that filters this budget */
  season?: Maybe<Season>;
};

export type BudgetConnection = {
  edges?: Maybe<Array<BudgetEdge>>;
};

export type BudgetEdge = {
  node?: Maybe<Budget>;
};

/** Goal for a financial metric of a given type */
export type BudgetGoal = {
  /** Goal type */
  type: BudgetGoalType;
  /** Goal target */
  value: Scalars['Decimal'];
};

/** Goal types */
export enum BudgetGoalType {
  /** Number of style colors for a budget. See numberOfStyleColors */
  BREADTH = 'BREADTH',
  /** Calculation of numberOfUnits divided by numberOfStyleColors */
  DEPTH = 'DEPTH',
  /** Purchasing cost */
  NET_COST_AMOUNT = 'NET_COST_AMOUNT',
  /** Initial markup value */
  NET_IMU_VALUE = 'NET_IMU_VALUE',
  /** Selling price */
  NET_RETAIL_AMOUNT = 'NET_RETAIL_AMOUNT',
  /** Number of styles for a budget */
  NUMBER_OF_STYLES = 'NUMBER_OF_STYLES',
  /** Number of style colors for a budget */
  NUMBER_OF_STYLE_COLORS = 'NUMBER_OF_STYLE_COLORS',
  /** Number of units for a budget */
  NUMBER_OF_UNITS = 'NUMBER_OF_UNITS'
}

/** Supported budget types */
export enum BudgetType {
  ASSORTMENT = 'ASSORTMENT',
  WORKSPACE = 'WORKSPACE'
}

/** Aggregated table view of a budget: top-level totals plus a tree of groups. */
export type BudgetView = {
  budgetId: Scalars['ID'];
  groups: BudgetViewGroupConnection;
  totals: BudgetViewTotals;
};

/** Aggregated row in the budget view tree. May contain nested children (Level 2). */
export type BudgetViewGroup = Node & {
  actualCost: Scalars['String'];
  actualRetail: Scalars['String'];
  budgetCost: Scalars['String'];
  budgetRetail: Scalars['String'];
  children: BudgetViewGroupConnection;
  groupBy: VisualAssortmentGroupByOption;
  id: Scalars['ID'];
  margin: Scalars['String'];
  percentCostSpent: Scalars['Float'];
  percentRetailSpent: Scalars['Float'];
  value: Scalars['String'];
};

/** Connection wrapper for BudgetViewGroup. Used recursively for nested levels. */
export type BudgetViewGroupConnection = {
  edges: Array<BudgetViewGroupEdge>;
};

/** Edge containing a BudgetViewGroup node. */
export type BudgetViewGroupEdge = {
  node: BudgetViewGroup;
};

/** Top-level totals for a BudgetView. */
export type BudgetViewTotals = Node & {
  actualCost: Scalars['String'];
  actualRetail: Scalars['String'];
  budgetCost: Scalars['String'];
  budgetRetail: Scalars['String'];
  id: Scalars['ID'];
  margin: Scalars['String'];
  percentCostSpent: Scalars['Float'];
  percentRetailSpent: Scalars['Float'];
};

export type BulkAddColorsToAssortmentProductRequest = {
  assortmentId: Scalars['ID'];
  requests: Array<AddColorsToAssortmentProductRequest>;
};

export type BulkAddColorsToAssortmentProductResponse = {
  assortment?: Maybe<Assortment>;
};

export type BulkAddProductsAndSkusError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkAddProductsAndSkusErrorDetail>;
  message: Scalars['String'];
};

export type BulkAddProductsAndSkusErrorDetail = {
  collectionId: Scalars['ID'];
  productId: Scalars['ID'];
  skuId: Scalars['ID'];
};

export type BulkAddProductsAndSkusToCollectionsInput = {
  collectionsProducts?: InputMaybe<Array<AddProductsAndSkusToCollectionInput>>;
};

export type BulkAddProductsAndSkusToCollectionsPayload = {
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<BulkAddProductsAndSkusError>>;
};

export type BulkAddProductsToCollectionInput = {
  collectionId: Scalars['ID'];
  collectionProducts?: InputMaybe<Array<AddProductToCollectionInput>>;
};

export type BulkAddProductsToCollectionPayload = {
  collections?: Maybe<Array<Collection>>;
};

export type BulkAddProductsToInventoryAvailabilityGroupInput = {
  inventoryAvailabilityGroupId: Scalars['ID'];
  productIds: Array<Scalars['ID']>;
};

export type BulkAddProductsToInventoryAvailabilityGroupPayload = {
  createdInventoryAvailabilityGroupItemIds: Array<Scalars['ID']>;
};

export type BulkAddWarehousesInput = {
  warehouses: Array<AddWarehousesInput>;
};

export type BulkAddWarehousesPayload = {
  warehouses: Array<AddWarehousePayload>;
};

export type BulkCancelOrdersVariantsInput = {
  orderIds: Array<Scalars['ID']>;
  variantIds: Array<Scalars['ID']>;
};

export type BulkCancelOrdersVariantsPayload = {
  cancelledVariantIds: Array<Scalars['ID']>;
};

export type BulkCopyOrdersInput = {
  orderForAccountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};

export type BulkCopyOrdersPayload = {
  copiedOrderIds: Array<Scalars['ID']>;
};

export type BulkCreateAssortmentProductRequest = {
  assortmentId: Scalars['ID'];
  products: Array<AssortmentProductRequest>;
};

export type BulkCreateAssortmentProductResponse = {
  assortment?: Maybe<Assortment>;
};

export type BulkCreateCollaborationInvitesInput = {
  requestInput: Array<createCollaborationInviteInput>;
};

export type BulkCreateCollaborationInvitesPayload = {
  collaborationInvites: CollaborationInviteConnection;
};

export type BulkCreateCollaborationInvitesToAccountsInput = {
  invitedAccountIds: Array<CreateCollaborationInviteToAccountInput>;
};

export type BulkCreateCollectionGroupPayload = {
  collectionGroups?: Maybe<Array<CollectionGroup>>;
  collectionId: Scalars['ID'];
};

export type BulkCreateCollectionGroupsInput = {
  createCollectionGroups: Array<CreateCollectionGroupsInput>;
};

export type BulkCreateCollectionGroupsPayload = {
  createdCollectionGroups: Array<BulkCreateCollectionGroupPayload>;
};

export type BulkCreateCollectionsInput = {
  brandId: Scalars['ID'];
  collections: Array<CreateCollectionInput>;
};

export type BulkCreateCollectionsPayload = {
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<CreateCollectionError>>;
};

export type BulkCreateProductsInput = {
  products: Array<CreateProductInput>;
};

export type BulkCreateProductsPayload = {
  errors: Array<Maybe<CreateProductError>>;
  products: Array<Product>;
};

export type BulkCreateSkuPricesInput = {
  prices: Array<CreateSkuPriceInput>;
};

export type BulkCreateSkuPricesPayload = {
  errors?: Maybe<Array<CreateSkuPriceError>>;
  prices?: Maybe<Array<SkuPrice>>;
};

export type BulkCreateSkuTraitValuesError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkCreateSkuTraitValuesErrorDetail>;
  message: Scalars['String'];
};

export type BulkCreateSkuTraitValuesErrorDetail = {
  externalIdentifier?: Maybe<Scalars['String']>;
  orderMinimum?: Maybe<Scalars['Int']>;
  orderNbr?: Maybe<Scalars['Int']>;
  productId: Scalars['ID'];
  skuTraitId: Scalars['ID'];
  status?: Maybe<SkuTraitValueStatus>;
  value: Scalars['String'];
};

export type BulkCreateSkuTraitValuesInput = {
  skuTraitValues?: InputMaybe<Array<CreateSkuTraitValueInput>>;
};

export type BulkCreateSkuTraitValuesPayload = {
  errors?: Maybe<Array<BulkCreateSkuTraitValuesError>>;
  skuTraitValues?: Maybe<Array<SkuTraitValue>>;
};

export type BulkCreateUserMembershipRequestsInput = {
  requestInput: Array<CreateUserMembershipRequestInputForBulk>;
};

export type BulkCreateUserMembershipRequestsPayload = {
  results?: Maybe<Array<BulkCreateUserMembershipResult>>;
};

/** One of error or userMembershipId will be returned. */
export type BulkCreateUserMembershipResult = {
  accountId: Scalars['ID'];
  error?: Maybe<Error>;
  userId: Scalars['ID'];
  userMembershipId?: Maybe<Scalars['ID']>;
};

export type BulkDeleteCollectionGroupsInput = {
  collectionGroupIds: Array<Scalars['ID']>;
};

export type BulkDeleteCollectionGroupsPayload = {
  collectionGroupIds?: Maybe<Array<Scalars['ID']>>;
};

export type BulkDeleteCollectionsInput = {
  collectionIds: Array<Scalars['ID']>;
};

export type BulkDeleteCollectionsPayload = {
  collectionIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type BulkDeleteDataPermissionConfigurationsInput = {
  ids: Array<Scalars['ID']>;
};

export type BulkDeleteDataPermissionConfigurationsPayload = {
  success: Scalars['Boolean'];
};

export type BulkDeleteExternalProviderAuthsInput = {
  externalProviderAuthsIds: Array<Scalars['ID']>;
};

export type BulkDeleteExternalProviderAuthsPayload = {
  externalProviderAuthsIds: Array<Scalars['ID']>;
};

export type BulkDeleteProductsFromAvailabilityGroupInput = {
  inventoryId: Scalars['ID'];
  productIds: Array<Scalars['ID']>;
};

export type BulkDeleteProductsFromAvailabilityGroupPayload = {
  deletedProductIds: Array<Scalars['ID']>;
};

export type BulkDeleteProductsInput = {
  products: Array<DeleteProductInput>;
};

export type BulkDeleteProductsPayload = {
  errors?: Maybe<Array<Maybe<DeleteProductError>>>;
  products: Array<Product>;
};

export type BulkDeleteRetailerLocations = {
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type BulkDeleteRetailerLocationsInput = {
  retailerLocationIds: Array<Scalars['ID']>;
};

export type BulkDeleteRetailerUploads = {
  error?: Maybe<Scalars['String']>;
  retailerUploadIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type BulkDeleteRetailerUploadsInput = {
  retailerUploadIds: Array<Scalars['ID']>;
};

export type BulkDeleteWarehousesInput = {
  warehouseIds: Array<Scalars['ID']>;
};

export type BulkDeleteWarehousesPayload = {
  deletedWarehouseIds: Array<Scalars['ID']>;
};

export type BulkDuplicateCollectionsInput = {
  collectionIds: Array<Scalars['ID']>;
};

export type BulkDuplicateCollectionsPayload = {
  collections?: Maybe<Array<Collection>>;
};

/**
 * A bulk line item is a unit of transaction that represents an intent to buy some amount of an item with vairious
 * characteristics, distinguishable from a (non-bulk) line item by a lack of size details.
 */
export type BulkLineItem = Node & {
  /** The destination information of the bulk line item */
  destination?: Maybe<Destination>;
  id: Scalars['ID'];
  /** The quantity of this line item */
  quantity?: Maybe<Scalars['Int']>;
  /** The SKU for this line item */
  skus?: Maybe<BulkLineItemSKUConnection>;
};

export type BulkLineItemSKUConnection = {
  edges?: Maybe<Array<SKUEdge>>;
};

export type BulkMarkInventoryAvailabilityGroupsAsReceivedInput = {
  inventoryAvailabilityGroupIds: Array<Scalars['ID']>;
};

export type BulkMarkInventoryAvailabilityGroupsAsReceivedPayload = {
  payload: Scalars['String'];
  updatedInventoryAvailabilityGroupIds: Array<Scalars['ID']>;
};

export type BulkMarkOrdersAsExportedInput = {
  orderExportIntegrationId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};

export type BulkMarkOrdersAsExportedPayload = {
  updatedOrderIds: Array<Scalars['ID']>;
};

export type BulkQuantity = {
  bulkVariantValue: Scalars['String'];
  doorId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type BulkRemoveProductsAndSkusFromCollectionsInput = {
  collectionsProducts?: InputMaybe<Array<RemoveProductsAndSkusFromCollectionInput>>;
};

export type BulkRemoveProductsAndSkusFromCollectionsPayload = {
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<Error>>;
};

export type BulkRemoveUnmatchedUploadsInput = {
  unmatchedImageIds: Array<Scalars['ID']>;
};

export type BulkRemoveUnmatchedUploadsPayload = {
  errorCode?: Maybe<Scalars['String']>;
};

export type BulkReplaceOrdersVariantInput = {
  emailMessage?: InputMaybe<Scalars['String']>;
  newVariantId: Scalars['ID'];
  notifyByEmail?: InputMaybe<Scalars['Boolean']>;
  oldVariantId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};

export type BulkReplaceOrdersVariantPayload = {
  updatedOrderIds: Array<Scalars['ID']>;
};

export type BulkScheduleForExportInput = {
  orderIds: Array<Scalars['ID']>;
};

export type BulkScheduleForExportPayload = {
  scheduledOrderIds: Array<Scalars['ID']>;
};

export type BulkSetCollectionsDeliveryInput = {
  collections: Array<SetCollectionDeliveryInput>;
};

export type BulkSetCollectionsDeliveryPayload = {
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<Error>>;
};

export type BulkSetOrdersToReexportInput = {
  orderIds: Array<Scalars['ID']>;
};

export type BulkSetOrdersToReexportPayload = {
  updatedOrderIds: Array<Scalars['ID']>;
};

export type BulkSetProductsTraitValuesInput = {
  productTraitValues: Array<SetProductTraitValueInput>;
};

export type BulkSetProductsTraitValuesPayload = {
  errors: Array<Maybe<UpdateProductError>>;
  products: Array<Product>;
};

export type BulkSetSkuItemPropertiesPayload = {
  assortment?: Maybe<Assortment>;
  properties?: Maybe<Array<BulkSkuItemProperty>>;
  query?: Maybe<Query>;
};

export type BulkSetSkuUpcsInput = {
  skuUpcs?: InputMaybe<Array<SetSkuUpcInput>>;
};

export type BulkSetSkuUpcsPayload = {
  errors?: Maybe<Array<Error>>;
  skus?: Maybe<Array<SKU>>;
};

export type BulkSkuItemProperty = {
  id: Scalars['ID'];
  propertyName: Scalars['String'];
  propertyValue: Scalars['String'];
};

export type BulkStyleImportInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  categoryOption?: InputMaybe<CategoryOptions>;
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  filePath: Scalars['String'];
  isNewCollection?: InputMaybe<Scalars['Boolean']>;
};

export type BulkStyleImportPayload = {
  error?: Maybe<GenericStyleImportError>;
};

export type BulkUnscheduleForExportInput = {
  orderIds: Array<Scalars['ID']>;
};

export type BulkUnscheduleForExportPayload = {
  updatedOrderIds: Array<Scalars['ID']>;
};

export type BulkUpdateAccountsPrivacyInput = {
  accounts: Array<UpdateAccountPrivacyInput>;
};

export type BulkUpdateAccountsPrivacyPayload = {
  accounts: Array<Maybe<Account>>;
};

export type BulkUpdateAssortmentDetailsPayload = {
  assortmentIds: Array<Scalars['ID']>;
};

export type BulkUpdateCollectionGroupsInput = {
  collectionGroups: Array<UpdateCollectionGroupInput>;
};

export type BulkUpdateCollectionGroupsPayload = {
  collectionGroups?: Maybe<Array<CollectionGroup>>;
};

export type BulkUpdateCollectionProductsInput = {
  collectionProducts: Array<UpdateCollectionProductInput>;
};

export type BulkUpdateCollectionProductsPayload = {
  collectionProducts: Array<CollectionProduct>;
};

export type BulkUpdateCollectionsInput = {
  collections: Array<UpdateCollectionInput>;
};

export type BulkUpdateCollectionsPayload = {
  collections?: Maybe<Array<Collection>>;
  errors?: Maybe<Array<UpdateCollectionError>>;
};

export type BulkUpdateCollectionsPositionInput = {
  collectionsPositions: Array<UpdateCollectionsPositionInput>;
};

export type BulkUpdateCollectionsPositionPayload = {
  collections?: Maybe<Array<Collection>>;
};

export type BulkUpdateCollectionsPublicInput = {
  publicCollections: Array<UpdateCollectionsPublicInput>;
};

export type BulkUpdateCollectionsPublicPayload = {
  collections?: Maybe<Array<Collection>>;
};

export type BulkUpdateInventoryItemsInput = {
  itemsToUpdate: Array<UpdateInventoryItemQuantity>;
};

export type BulkUpdateInventoryItemsPayload = {
  updatedInventoryItemIds: Array<Scalars['String']>;
};

export type BulkUpdateOrderPricingByFiltersInput = {
  appliedFilters?: InputMaybe<OrderFilterInput>;
  searchFilter?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateOrderPricingByFiltersPayload = {
  success: Scalars['Boolean'];
};

export type BulkUpdateOrderPricingByIdsInput = {
  orderIds: Array<Scalars['ID']>;
};

export type BulkUpdateOrderPricingByIdsPayload = {
  notUpdatedOrdersCount: Scalars['Int'];
  updatedOrdersCount: Scalars['Int'];
};

export type BulkUpdateOrderSalesRepByFiltersInput = {
  appliedFilters?: InputMaybe<OrderFilterInput>;
  newSalesRep: Scalars['String'];
  searchFilter?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateOrderSalesRepByFiltersPayload = {
  updatedOrdersCount: Scalars['Int'];
};

export type BulkUpdateOrderStatusAsyncInput = {
  orderIds: Array<Scalars['ID']>;
  sendToBrand?: InputMaybe<Scalars['Boolean']>;
  sendToRetailer?: InputMaybe<Scalars['Boolean']>;
  status: OrderStatus;
};

export type BulkUpdateOrderStatusAsyncPayload = {
  jobId: Scalars['String'];
};

export type BulkUpdateOrderStatusInput = {
  customMessage?: InputMaybe<Scalars['String']>;
  customSubject?: InputMaybe<Scalars['String']>;
  orderIds: Array<Scalars['ID']>;
  sendToBrand?: InputMaybe<Scalars['Boolean']>;
  sendToRetailer?: InputMaybe<Scalars['Boolean']>;
  status: OrderStatus;
};

export type BulkUpdateOrderStatusPayload = {
  errors: Array<Error>;
  updatedOrderIds: Array<Scalars['ID']>;
};

export type BulkUpdateProductsInput = {
  products: Array<UpdateProductInput>;
};

export type BulkUpdateProductsPayload = {
  errors: Array<Maybe<UpdateProductError>>;
  products: Array<Product>;
};

export type BulkUpdateRetailerGoogleAddressesInput = {
  accepted: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type BulkUpdateRetailerGoogleAddressesPayload = {
  retailerGoogleAddressIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type BulkUpdateSkuPricesInput = {
  prices: Array<UpdateSkuPriceInput>;
};

export type BulkUpdateSkuPricesPayload = {
  errors?: Maybe<Array<UpdateSkuPriceError>>;
  prices?: Maybe<Array<SkuPrice>>;
};

export type BulkUpdateSkuTraitValuesError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkUpdateSkuTraitValuesErrorDetail>;
  message: Scalars['String'];
};

export type BulkUpdateSkuTraitValuesErrorDetail = {
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderMinimum?: Maybe<Scalars['Int']>;
  status?: Maybe<SkuTraitValueStatus>;
  value?: Maybe<Scalars['String']>;
};

export type BulkUpdateSkuTraitValuesInput = {
  skuTraitValues?: InputMaybe<Array<UpdateSkuTraitValueInput>>;
};

export type BulkUpdateSkuTraitValuesPayload = {
  errors?: Maybe<Array<BulkUpdateSkuTraitValuesError>>;
  skuTraitValues?: Maybe<Array<SkuTraitValue>>;
};

export type BulkUpdateStorefrontsInput = {
  storefronts: Array<UpdateStorefrontInput>;
};

export type BulkUpdateUserFavoriteCollectionsInput = {
  favoriteCollections: Array<UpdateUserFavoriteCollectionsInput>;
};

export type BulkUpdateUserFavoriteCollectionsPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type BulkUpdateWarehousesInput = {
  warehouses: Array<UpdateWarehousesInput>;
};

export type BulkUpdateWarehousesPayload = {
  updatedWarehouseIds: Array<Scalars['ID']>;
};

export type BulkUpsertOrderEventsInput = {
  eventId: Scalars['String'];
  orderIds: Array<Scalars['ID']>;
};

export type BulkUpsertOrderEventsPayload = {
  updatedOrderIds: Array<Scalars['ID']>;
};

export type BulkUpsertRetailerLocations = {
  locations: Array<Location>;
};

export type BulkUpsertRetailerLocationsInput = {
  locations: Array<LocationInput>;
};

export type BulkUpsertRetailerUploadsInput = {
  uploads: Array<Scalars['ID']>;
};

export type BulkUpsertRetailerUploadsPayload = {
  retailerUploadIds?: Maybe<Array<Scalars['ID']>>;
};

export type BulkUpsertSkuExternalIdentifiersError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<BulkUpsertSkuExternalIdentifiersErrorDetail>;
  message: Scalars['String'];
};

export type BulkUpsertSkuExternalIdentifiersErrorDetail = {
  externalId?: Maybe<Scalars['String']>;
  skuId: Scalars['ID'];
  skuIdentifier?: Maybe<Scalars['String']>;
};

export type BulkUpsertSkuExternalIdentifiersInput = {
  skuExternalIdentifiers?: InputMaybe<Array<SkuExternalIdentifierInput>>;
};

export type BulkUpsertSkuExternalIdentifiersPayload = {
  errors?: Maybe<Array<BulkUpsertSkuExternalIdentifiersError>>;
  skuExternalIdentifiers?: Maybe<Array<SkuExternalIdentifier>>;
};

export enum BusinessStatus {
  CLOSED_PERMANENTLY = 'CLOSED_PERMANENTLY',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  OPERATIONAL = 'OPERATIONAL',
  UNKNOWN = 'UNKNOWN'
}

export type BuyerInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CarriedBrand = {
  accountId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type CasepackFilterInput = {
  casepackIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CasepackLineItem = {
  casepack: AccountCasepack;
  collection: LineItemCollection;
  inventory?: Maybe<InventoryAvailabilityGroup>;
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  suggestedRetailPrice: Scalars['Decimal'];
  variantInfo?: Maybe<VariantByCasepackLineItem>;
  wholesalePrice: Scalars['Decimal'];
};

export type CasepackQuantity = {
  casepackId: Scalars['ID'];
  doorId?: InputMaybe<Scalars['ID']>;
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  variantValue?: InputMaybe<Scalars['String']>;
};

export type CasepackSKUEdge = {
  node: SKU;
  quantity: Scalars['Int'];
};

export type CasepackSkuConnection = {
  edges: Array<CasepackSKUEdge>;
};

export type Category = {
  department?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  parentName?: Maybe<Scalars['String']>;
};

export type CategoryConnection = {
  edges: Array<CategoryEdge>;
};

export type CategoryEdge = {
  node: Category;
};

export enum CategoryOptions {
  ALL_STYLES = 'ALL_STYLES',
  NEW_STYLES_ONLY = 'NEW_STYLES_ONLY',
  SKIP = 'SKIP'
}

export type CeleryJob = Node & {
  account?: Maybe<Account>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  inputFileUrl?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  status: CeleryJobStatus;
  type: CeleryJobType;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
};

export type CeleryJobConnection = {
  edges: Array<CeleryJobEdge>;
};

export type CeleryJobEdge = {
  node: CeleryJob;
};

export type CeleryJobFilter = {
  jobsIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum CeleryJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum CeleryJobType {
  ORDER_IMPORT = 'ORDER_IMPORT'
}

export type CheckOrdersInVisualAssortmentResponse = {
  /** List of order IDs that are currently in the Visual Assortment sync queue */
  existingOrderIds: Array<Scalars['ID']>;
  /** List of order IDs that are not in the Visual Assortment sync queue */
  notExistingOrderIds: Array<Scalars['ID']>;
};

export type CheckUserInOrganizationInput = {
  accountId: Scalars['ID'];
  email: Scalars['String'];
};

export type CheckUserInOrganizationPayload = {
  isActive: Scalars['Boolean'];
  isInOrganization: Scalars['Boolean'];
};

/** Checkout data for one brand–retailer pair. */
export type Checkout = {
  /**
   * True when the All Orders tab (one bulk form for every order) may be shown:
   * more than one order and at most one saved shipping address.
   * Placeholder: always false for now.
   */
  allOrdersEligible: Scalars['Boolean'];
  /**
   * Same as `shippingAddressLocked`, evaluated for billing addresses.
   * Placeholder: always false for now.
   */
  billingAddressLocked: Scalars['Boolean'];
  /** Billing address book to offer. Placeholder: empty for now. */
  billingAddresses: Array<BillingAddress>;
  /**
   * Buyer contacts for the pair, one per email. A buyer record wins on a duplicate email.
   * Placeholder: fixed sample data for now.
   */
  buyers: Array<CheckoutBuyer>;
  /**
   * The retailer's default tax ID per country. The page uses it when `order.tax.number` is empty.
   * Placeholder: fixed sample data for now.
   */
  defaultTaxIds: Array<CheckoutTaxId>;
  /**
   * Doors of the connection, sorted by name A→Z. Empty when the connection has none.
   * `shippingAddressId` prefills the shipping address when a door is picked.
   * Placeholder: fixed sample data for now.
   */
  doors: Array<ConnectionDoor>;
  /**
   * The orders that can be checked out, in the order of `orderIds`. Orders that can't are left out
   * and listed in the query's GraphQL error under `extensions.orderErrors`.
   */
  orders: Array<Order>;
  /**
   * Payment methods ("Terms") available for the pair; `default` marks the preselected one.
   * Placeholder: empty for now.
   */
  paymentMethods: Array<BrandRetailerPaymentMethod>;
  /**
   * Allowed sales-commission names from the brand's order settings.
   * Placeholder: fixed sample data for now.
   */
  salesCommissions: Array<Scalars['String']>;
  /**
   * Active sales reps of the brand, sorted by display name A→Z.
   * Placeholder: fixed sample data for now.
   */
  salesRepresentatives: Array<User>;
  /**
   * True when the retailer may not edit the postal fields of the shipping address, because the brand
   * has an active order integration and at least one saved shipping address.
   * Placeholder: always false for now.
   */
  shippingAddressLocked: Scalars['Boolean'];
  /** Shipping address book to offer. Placeholder: empty for now. */
  shippingAddresses: Array<ShippingAddress>;
  /**
   * Shipping methods available for the pair; `default` marks the preselected one.
   * Placeholder: empty for now.
   */
  shippingMethods: Array<BrandRetailerShippingMethod>;
};

/** A buyer contact offered in the Buyer Email dropdown. */
export type CheckoutBuyer = {
  /** May hold several addresses separated by commas; passed through unchanged. */
  email: Scalars['String'];
  /** Buyer record id. Null for contacts that don't come from a buyer record. */
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

/** A retailer's default tax ID for one country. */
export type CheckoutTaxId = {
  /** Country name, as in the billing address. */
  country: Scalars['String'];
  /** The tax ID number for that country. */
  taxId: Scalars['String'];
};

export type ClienteleDescription = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** CLIENTELE DESCRIPTION */
export type ClienteleDescriptionConnection = {
  edges?: Maybe<Array<ClienteleDescriptionEdge>>;
};

export type ClienteleDescriptionEdge = {
  node?: Maybe<ClienteleDescription>;
};

export type ClienteleInfo = {
  clienteleAge?: Maybe<Scalars['String']>;
  clienteleDescriptions?: Maybe<Array<ClienteleDescription>>;
  clienteleFemale?: Maybe<Scalars['Boolean']>;
  clienteleInterests?: Maybe<Array<ClienteleInterest>>;
  clienteleMale?: Maybe<Scalars['Boolean']>;
};

export type ClienteleInfoInput = {
  clienteleAge?: InputMaybe<Scalars['String']>;
  clienteleDescriptions?: InputMaybe<Array<Scalars['ID']>>;
  clienteleFemale?: InputMaybe<Scalars['Boolean']>;
  clienteleInterests?: InputMaybe<Array<Scalars['ID']>>;
  clienteleMale?: InputMaybe<Scalars['Boolean']>;
};

export type ClienteleInterest = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/** CLIENTELE INTEREST */
export type ClienteleInterestConnection = {
  edges?: Maybe<Array<ClienteleInterestEdge>>;
};

export type ClienteleInterestEdge = {
  node?: Maybe<ClienteleInterest>;
};

export type CollaborationInvite = Node & {
  created?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invitedEmail: Scalars['String'];
  invitedUser?: Maybe<User>;
  invitingAccount: AccountProfile;
  invitingUser: CollaborationUser;
};

export type CollaborationInviteConnection = {
  edges: Array<CollaborationInviteEdge>;
};

export type CollaborationInviteEdge = {
  node?: Maybe<CollaborationInvite>;
};

/**
 * Used to access user information in the context of
 * a received collaboration invite
 */
export type CollaborationUser = Node & {
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  profileImage?: Maybe<Scalars['String']>;
};

export type Collection = {
  archived?: Maybe<Scalars['Boolean']>;
  brand: Brand;
  code?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Date']>;
  delivery?: Maybe<Delivery>;
  description?: Maybe<Scalars['String']>;
  groups: Array<CollectionGroup>;
  id: Scalars['ID'];
  /** @deprecated Get from madeToOrder */
  ignores_inventory?: Maybe<Scalars['Boolean']>;
  image?: Maybe<Media>;
  /**
   * Orders still IN_PROGRESS (in a cart, not yet checked out) that reference this
   * collection, with the people who authored them. Used to warn a brand user archiving
   * a linesheet that in-progress orders exist and who to follow up with.
   */
  inProgressOrders: CollectionInProgressOrders;
  isCustom?: Maybe<Scalars['Boolean']>;
  isVisibleToRetailer?: Maybe<Scalars['Boolean']>;
  /** @deprecated Get from isCustom */
  is_custom?: Maybe<Scalars['Boolean']>;
  items: CollectionItemsConnection;
  madeToOrder?: Maybe<Scalars['Boolean']>;
  modified?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  owner?: Maybe<BrandUserEdge>;
  position?: Maybe<Scalars['Int']>;
  retailers: Array<RetailerAccount>;
  season?: Maybe<Season>;
  skus?: Maybe<SKUConnection>;
  source?: Maybe<CollectionSource>;
  syncToIpad?: Maybe<Scalars['Boolean']>;
  textStyles?: Maybe<Array<CollectionTextStyle>>;
  visibility?: Maybe<CollectionVisibility>;
  visibleToViewer: Scalars['Boolean'];
};


export type CollectionisVisibleToRetailerArgs = {
  retailerId: Scalars['ID'];
};


export type CollectionitemsArgs = {
  withCasepacks?: InputMaybe<Scalars['Boolean']>;
};


export type CollectionskusArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};

export type CollectionBanner = {
  bannerType: BannerType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type CollectionBannerConnection = {
  edges: Array<CollectionBannerEdge>;
};

export type CollectionBannerEdge = {
  node: CollectionBanners;
};

export type CollectionBanners = {
  collectionId: Scalars['ID'];
  imageBanners: Array<CollectionImageBanner>;
  textBanners: Array<CollectionTextBanner>;
  videoBanners: Array<CollectionVideoBanner>;
};

export type CollectionConnection = {
  deliveryWindow?: Maybe<CollectionDeliveryWindow>;
  edges: Array<Maybe<CollectionEdge>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CollectionDeliveryWindow = {
  maxCompleteShipDate?: Maybe<Scalars['Date']>;
  minStartShipDate?: Maybe<Scalars['Date']>;
};

export type CollectionDetails = {
  archived?: Maybe<Scalars['Boolean']>;
  brandId: Scalars['ID'];
  created?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  imageId?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageUrlThumbnail?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  modified?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  ownerEmail?: Maybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  retailerAccountsIds?: Maybe<Array<Scalars['ID']>>;
  seasonId?: Maybe<Scalars['ID']>;
  syncToIpad?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<CollectionVisibility>;
};

export type CollectionEdge = {
  node: Collection;
};

export type CollectionGroup = {
  header: Scalars['String'];
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
};

export type CollectionImageBanner = CollectionBanner & {
  bannerType: BannerType;
  id: Scalars['ID'];
  imageId?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

/**
 * In-progress orders on a collection, and the distinct people who authored them.
 *
 * The authors are deliberately de-duplicated: someone with two in-progress orders on the
 * same collection appears once in salesReps/buyers, so these lists are shorter than
 * totalCount. Internal JOOR users and authors without an email are excluded from both
 * totalCount and the lists, so the count always matches the people we can name.
 */
export type CollectionInProgressOrders = {
  /**
   * Distinct retailer-account users (Buyers) who authored the counted orders, each
   * paired with their retailer account's name.
   */
  buyers: Array<InProgressOrdersBuyer>;
  /** Distinct brand-account users (Sales Reps) who authored the counted orders. */
  salesReps: Array<InProgressOrdersSalesRep>;
  totalCount: Scalars['Int'];
};

export type CollectionInputInfo = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type CollectionItems = {
  externalId?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['Int']>;
  productId: Scalars['ID'];
  skuDeliveries: SkuDeliveryConnection;
  /** @deprecated Use skuDeliveries instead */
  skus?: Maybe<Array<SkuIdWithDelivery>>;
};

export type CollectionItemsConnection = {
  edges: Array<CollectionItemsEdge>;
};

export type CollectionItemsEdge = {
  node: CollectionItems;
};

export type CollectionName = {
  name?: Maybe<Scalars['String']>;
};

export enum CollectionOrderByDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum CollectionOrderByField {
  COLLECTION_OWNER = 'COLLECTION_OWNER',
  CREATED_DATE = 'CREATED_DATE',
  MODIFIED_DATE = 'MODIFIED_DATE',
  NAME = 'NAME',
  POSITION = 'POSITION'
}

export type CollectionPayload = {
  code?: Maybe<Scalars['String']>;
  endShipDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startShipDate?: Maybe<Scalars['Date']>;
};

export type CollectionProduct = Node & {
  casepacks: ProductCasepackConnection;
  collection: Collection;
  comments: Scalars['String'];
  groupedBy?: Maybe<CollectionProductGroupBy>;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  priceRange?: Maybe<PriceRange>;
  priceTypes: PriceTypeConnection;
  product: Product;
  skus: SKUConnection;
  variantTotal: Scalars['Int'];
  variants: ProductSkuVariantConnection;
};


export type CollectionProductcasepacksArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type CollectionProductpriceRangeArgs = {
  priceTypeId: Scalars['ID'];
};


export type CollectionProductskusArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
};


export type CollectionProductvariantTotalArgs = {
  code?: InputMaybe<Scalars['String']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type CollectionProductvariantsArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
};

export type CollectionProductConnection = {
  edges: Array<CollectionProductEdge>;
  pageInfo: PageInfo;
};

export type CollectionProductEdge = {
  cursor: Scalars['String'];
  node: CollectionProduct;
};

export type CollectionProductGroupBy = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum CollectionProductGroupByField {
  BADGE = 'BADGE',
  COLLGROUP = 'COLLGROUP',
  DISPCAT = 'DISPCAT',
  DIVISION = 'DIVISION',
  FABNAME = 'FABNAME',
  SILHOUETTE = 'SILHOUETTE',
  STYLETAG = 'STYLETAG'
}

export type CollectionProductGroupByInput = {
  groupBy: CollectionProductGroupByField;
  subGroupById?: InputMaybe<Scalars['ID']>;
};

export type CollectionProductGroupTotal = {
  collection: Collection;
  groupId?: Maybe<Scalars['ID']>;
  total: Scalars['Int'];
};

export type CollectionProductInput = {
  collectionId: Scalars['ID'];
  productId: Scalars['ID'];
  variantId?: InputMaybe<Scalars['ID']>;
};

export enum CollectionProductOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type CollectionProductOrderByField = {
  order?: InputMaybe<CollectionProductOrder>;
  orderByField?: InputMaybe<CollectionProductSortableField>;
};

export type CollectionProductOrderByInput = {
  field?: InputMaybe<CollectionProductOrderByField>;
  price?: InputMaybe<CollectionProductOrderByPrice>;
};

export type CollectionProductOrderByPrice = {
  order?: InputMaybe<CollectionProductOrder>;
  priceTypeId: Scalars['ID'];
};

export enum CollectionProductSortableField {
  COLOR_CODE = 'COLOR_CODE',
  COLOR_NAME = 'COLOR_NAME',
  FABRICATION_CODE = 'FABRICATION_CODE',
  FABRICATION_NAME = 'FABRICATION_NAME',
  PRODUCT_NAME = 'PRODUCT_NAME',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  SILHOUETTE_CODE = 'SILHOUETTE_CODE',
  SILHOUETTE_NAME = 'SILHOUETTE_NAME'
}

export type CollectionSeasonInput = {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  year: Scalars['Int'];
};

export type CollectionSource = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CollectionTextBanner = CollectionBanner & {
  bannerType: BannerType;
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type CollectionTextStyle = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
  orderNbr: Scalars['Int'];
  size: Scalars['String'];
  typeface: Scalars['String'];
  weight: Scalars['String'];
};

export type CollectionTextStyleInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  orderNbr: Scalars['Int'];
  size: Scalars['String'];
  typeface: Scalars['String'];
  weight: Scalars['String'];
};

export type CollectionVideoBanner = CollectionBanner & {
  bannerType: BannerType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
  videoId?: Maybe<Scalars['ID']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export enum CollectionVisibility {
  ALL_CONNECTIONS = 'ALL_CONNECTIONS',
  OWNER = 'OWNER',
  OWNER_ALL_CONNECTIONS = 'OWNER_ALL_CONNECTIONS',
  OWNER_PUBLIC = 'OWNER_PUBLIC',
  PUBLIC = 'PUBLIC',
  SELECTED_CONNECTIONS = 'SELECTED_CONNECTIONS'
}

export type CollectionVisibilityInput = {
  collections: Array<CollectionVisibilityType>;
};

export type CollectionVisibilityStyle = {
  customerIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
  visibility: CollectionVisibility;
};

export type CollectionVisibilityType = {
  collectionId?: InputMaybe<Scalars['ID']>;
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  customerIds?: InputMaybe<Array<Scalars['ID']>>;
  upsertExternalVisibilityOnly?: InputMaybe<Scalars['Boolean']>;
  visibility: CollectionVisibility;
};

export type CollectionsDetailsPayload = {
  collectionsDetails?: Maybe<Array<CollectionDetails>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CollectionsFilter = {
  archived?: InputMaybe<Scalars['Boolean']>;
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  collectionNames?: InputMaybe<Array<Scalars['String']>>;
  createdEndDate?: InputMaybe<Scalars['Date']>;
  createdStartDate?: InputMaybe<Scalars['Date']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  ipadEnabled?: InputMaybe<Scalars['Boolean']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  lastModificationEndDate?: InputMaybe<Scalars['Date']>;
  lastModificationStartDate?: InputMaybe<Scalars['Date']>;
  limitByProfileSettingsMax?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Scalars['String']>;
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']>>;
  sharedWith?: InputMaybe<Array<Scalars['String']>>;
  visibleForRetailerId?: InputMaybe<Scalars['ID']>;
  visibleToAllMatches?: InputMaybe<Scalars['Boolean']>;
};

export type CollectionsOrderBy = {
  direction?: InputMaybe<CollectionOrderByDirection>;
  field?: InputMaybe<CollectionOrderByField>;
};

export type Color = Node & {
  /** Attribute options applied to this color */
  attributeOptions: AttributeOptionConnection;
  /** A unique identifier */
  code: Scalars['String'];
  /** A user input comment */
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Images of the unit with this color */
  images: ImageConnection;
  /** A display name */
  name: Scalars['String'];
  /** Swatch that represents this color */
  swatch: ColorSwatch;
};

export type ColorSwatch = {
  hex?: Maybe<Scalars['String']>;
  image?: Maybe<ImageEdge>;
  rgb?: Maybe<RGB>;
};

export type ColorSwatchAgg = {
  colorCode: Scalars['String'];
  colorName: Scalars['String'];
  colorSwatchId: Scalars['String'];
  stylesCount: Scalars['Int'];
  stylesMissingSwatch: Scalars['Boolean'];
  swatches?: Maybe<Array<SwatchHexImage>>;
};

export type CommentAccountUserTag = Node & {
  accountName: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  userEmail: Scalars['String'];
  userName: Scalars['String'];
};

export type CommentAccountUserTagConnection = {
  edges: Array<CommentAccountUserTagEdge>;
  pageInfo: PageInfo;
};

export type CommentAccountUserTagEdge = {
  cursor: Scalars['String'];
  node: CommentAccountUserTag;
};

export type CompleteShopifyInstallationForEmbeddedAppsInput = {
  accountsToLink: Array<Scalars['ID']>;
  accountsToUnlink: Array<Scalars['ID']>;
  appName: ShopifyAppName;
  storeLink: Scalars['String'];
};

export type CompleteShopifyInstallationForEmbeddedAppsPayload = {
  success: Scalars['Boolean'];
};

export type CompleteShopifyInstallationInput = {
  accountId: Scalars['ID'];
  appName: ShopifyAppName;
  code: Scalars['String'];
  hmac: Scalars['String'];
  host: Scalars['String'];
  shop: Scalars['String'];
  state: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type CompleteShopifyInstallationPayload = {
  shopifyIntegrations?: Maybe<Array<ShopifyIntegration>>;
  success: Scalars['Boolean'];
};

export type Configuration = {
  accountId: Scalars['ID'];
  created?: Maybe<Scalars['Date']>;
  data: Scalars['String'];
  default?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  sharedUserIds?: Maybe<Array<Scalars['ID']>>;
  userId: Scalars['ID'];
  visibility: ConfigurationVisibility;
};

export type ConfigurationInput = {
  accountId: Scalars['ID'];
  data: Scalars['String'];
  default?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  projectName: Scalars['String'];
  sharedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  userId: Scalars['ID'];
  visibility: ConfigurationVisibility;
};

export enum ConfigurationVisibility {
  ACCOUNT = 'ACCOUNT',
  ALL = 'ALL',
  USER = 'USER'
}

export type ConnectAccountsThroughJiraError = {
  code: ConnectAccountsThroughJiraErrorCode;
};

export enum ConnectAccountsThroughJiraErrorCode {
  FAILED_TO_CREATE_CONNECTION_REQUEST = 'FAILED_TO_CREATE_CONNECTION_REQUEST',
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  UNSUPPORTED_FILE_EXTENSION = 'UNSUPPORTED_FILE_EXTENSION'
}

export type ConnectAccountsThroughJiraInput = {
  file: Scalars['Upload'];
};

export type ConnectAccountsThroughJiraPayload = {
  error?: Maybe<ConnectAccountsThroughJiraError>;
};

export type ConnectPaymentProviderInput = {
  accountId: Scalars['ID'];
  authorizationCode: Scalars['String'];
  hmacSecret?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  paymentProvider: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};

export type ConnectedAccountsFilter = {
  connectedAccountIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ConnectionBuyer = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  retailerId: Scalars['ID'];
};

export type ConnectionBuyersPayload = {
  connection_buyers: Array<ConnectionBuyer>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionCurrency = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ConnectionDetails = {
  hmacSecret: Scalars['String'];
  merchantId: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type ConnectionDiscount = {
  amount?: Maybe<Scalars['String']>;
  divisionId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  level: DiscountLevel;
  retailerId: Scalars['ID'];
};

export type ConnectionDiscountsPayload = {
  connectionDiscounts: Array<ConnectionDiscount>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionDoor = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  retailerId: Scalars['ID'];
  shippingAddressId?: Maybe<Scalars['ID']>;
};

export type ConnectionDoorInput = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  retailerId: Scalars['ID'];
  shippingAddressId?: InputMaybe<Scalars['ID']>;
};

export type ConnectionPaymentMethod = {
  isDefault: Scalars['Boolean'];
  paymentMethodId: Scalars['ID'];
  retailerId: Scalars['ID'];
};

export type ConnectionPaymentMethodInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  paymentMethodId: Scalars['ID'];
  retailerId: Scalars['ID'];
};

export type ConnectionPriceType = {
  id: Scalars['ID'];
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
  termsConditionId?: Maybe<Scalars['ID']>;
};

export type ConnectionPriceTypeResponse = {
  id: Scalars['ID'];
  priceType: BrandPriceType;
  retailerId: Scalars['ID'];
  termsCondition?: Maybe<TermsAndCondition>;
};

export type ConnectionPriceTypesPayload = {
  connectionPriceTypes: Array<ConnectionPriceTypeResponse>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionRequestInfo = {
  recipientAccountId?: Maybe<Scalars['ID']>;
  senderAccountId?: Maybe<Scalars['ID']>;
  status: ConnectionRequestStatus;
};

/**
 * Status of the connection request between the submission's sending brand and its
 * recipient retailer. Every outreach carries an implicit connection request.
 */
export enum ConnectionRequestStatus {
  /** The request was accepted: the two accounts are connected. */
  ACCEPTED = 'ACCEPTED',
  /**
   * A request between the two accounts was removed and none exists now. Note
   * this covers every way a request can disappear — the recipient declining it,
   * the sender cancelling it, or the two accounts disconnecting — because the
   * only record left behind is the deletion itself.
   */
  DECLINED = 'DECLINED',
  /** The two accounts have no connection and no record of a request between them. */
  NON_EXISTENT = 'NON_EXISTENT',
  /** A request has been sent and is awaiting a response from the other side. */
  PENDING = 'PENDING'
}

export type ConnectionSalesRep = {
  divisionId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
  userId?: Maybe<Scalars['ID']>;
};

export type ConnectionSalesRepsPayload = {
  connectionSalesReps: Array<ConnectionSalesRep>;
  errors?: Maybe<Array<CustomerError>>;
};

export type ConnectionShippingMethod = {
  isDefault: Scalars['Boolean'];
  retailerId: Scalars['ID'];
  shippingMethodId: Scalars['ID'];
};

export type ConnectionShippingMethodInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  retailerId: Scalars['ID'];
  shippingMethodId: Scalars['ID'];
};

export enum ConnectionStatus {
  ALL = 'ALL',
  CONNECTED = 'CONNECTED',
  UNCONNECTED = 'UNCONNECTED'
}

export type ConnectionWarehouse = {
  isDefault: Scalars['Boolean'];
  retailerId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

export type ConnectionWarehouseInput = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  retailerId: Scalars['ID'];
  warehouseId: Scalars['ID'];
};

export type CopyAssortmentsInput = {
  /** Ids of the assortments to copy */
  ids: Array<Scalars['ID']>;
};

export type CopyAssortmentsPayload = {
  assortments: Array<AssortmentSummary>;
};

export type CountryCurrency = {
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  currencyCode: Scalars['String'];
};

export type CreateAccountUserInput = {
  accountId: Scalars['ID'];
  displayCode?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  orderCC?: InputMaybe<Array<Scalars['String']>>;
  userType: AccountUserType;
};

export type CreateAccountUserPayload = {
  accountUserId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Creates an assortment for a given collection. */
export type CreateAssortmentInput = {
  /** The name of the assortment that is being created */
  assortmentName?: InputMaybe<Scalars['String']>;
  /** Collection that we're making this assortment for. Also known as 'linesheet' */
  collectionId?: InputMaybe<Scalars['ID']>;
  /** The retail currency of the assortment */
  retailCurrencyId?: InputMaybe<Scalars['ID']>;
  /** Retailer account that we're making this assortment for */
  retailerId: Scalars['ID'];
  /** The retail season that the created assortment will be associated with */
  seasonId?: InputMaybe<Scalars['ID']>;
  /** The wholesale currency of the assortment */
  wholesaleCurrencyId?: InputMaybe<Scalars['ID']>;
  /** The Retail Workspace Id that created assortment will be associated with */
  workspaceId?: InputMaybe<Scalars['ID']>;
};

export type CreateAssortmentPayload = {
  assortment?: Maybe<Assortment>;
};

export type CreateAssortmentWithColorsInput = {
  assortmentName: Scalars['String'];
  collectionId: Scalars['ID'];
  colorIds: Array<Scalars['ID']>;
  priceTypeId: Scalars['ID'];
  retailCurrencyId: Scalars['ID'];
  retailerId: Scalars['ID'];
  seasonId: Scalars['ID'];
  wholesaleCurrencyId: Scalars['ID'];
};

export type CreateAssortmentsExportRecordInput = {
  assortmentId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type CreateAssortmentsExportRecordPayload = {
  assortmentId: Scalars['ID'];
};

/** Creates a new attribute */
export type CreateAttributeInput = {
  /** A unique identifier */
  code: Scalars['String'];
  /** If true allows more than one option to be selected for this attribute */
  isMultiSelect: Scalars['Boolean'];
  /** If true requires an option to be selected for this attribute */
  isRequired: Scalars['Boolean'];
  /** A display name */
  name: Scalars['String'];
  /** Parent attribute */
  parentId?: InputMaybe<Scalars['ID']>;
  /** Defines display order */
  position: Scalars['Int'];
  /** The ID of the retailer for which to create this attribute */
  retailerId: Scalars['ID'];
  /** Determines an attributes applicable objects */
  type: AttributeType;
};

/** Creates a new attribute option */
export type CreateAttributeOptionInput = {
  /** The Attribute that this option belongs to */
  attributeId: Scalars['ID'];
  /** A unique identifier */
  code: Scalars['String'];
  /** The value of the option */
  value: Scalars['String'];
};

export type CreateAttributeOptionPayload = {
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

/** Creates the attribute option rules for a price modifier */
export type CreateAttributeOptionRuleForPriceModifierInput = {
  /** Values for the updated rules */
  attributeOptionIds: Array<Scalars['ID']>;
  /** The factor to apply for this rule */
  factor: Scalars['Decimal'];
  /** Id of the object to update */
  priceModifierGroupId: Scalars['ID'];
  /** The name to display for this rule */
  ruleName: Scalars['String'];
};

export type CreateAttributeOptionRuleForPriceModifierPayload = {
  priceModifierRule: PriceModifierRule;
};

export type CreateAttributePayload = {
  attribute?: Maybe<Attribute>;
  errors?: Maybe<Array<Error>>;
};

export type CreateBrandDoorInput = {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  retailerAccountId: Scalars['ID'];
};

export type CreateBrandDoorPayload = {
  brandDoorId: Scalars['ID'];
};

/** Creates the brand rules of a price modifier */
export type CreateBrandRuleForPriceModifierInput = {
  /** Value for the updated rule */
  brandId: Scalars['ID'];
  /** The factor to apply for this rule */
  factor: Scalars['Decimal'];
  /** Id of the object to update */
  priceModifierGroupId: Scalars['ID'];
  /** The name to display for this rule */
  ruleName: Scalars['String'];
};

export type CreateBrandRuleForPriceModifierPayload = {
  priceModifierRule: PriceModifierRule;
};

/** Updates budget details */
export type CreateBudgetInput = {
  /** Id of the Brand that filters this budget */
  brandId?: InputMaybe<Scalars['ID']>;
  /** Currency that filters this budget */
  currencyCode: Scalars['String'];
  /** Id of the door that filters this budget */
  doorId?: InputMaybe<Scalars['ID']>;
  /** A list of goals for this budget */
  goals?: InputMaybe<Array<SetBudgetGoalInput>>;
  /** Ids of the merchandising hierarchy leaf nodes that filter this budget */
  merchandisingHierarchyNodeIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Id of the Season that filters this budget */
  seasonId?: InputMaybe<Scalars['ID']>;
};

export type CreateBudgetPayload = {
  budget?: Maybe<Budget>;
  errors?: Maybe<Array<Error>>;
};

export type CreateCollaborationInvitePayload = {
  collaborationInvite?: Maybe<CollaborationInvite>;
};

/** Creates a new collaboration invite for a given Account ID. */
export type CreateCollaborationInviteToAccountInput = {
  invitedAccountId: Scalars['ID'];
};

export type CreateCollectionBannerInput = {
  imageBanners?: InputMaybe<Array<CreateCollectionImageBannerInput>>;
  textBanners?: InputMaybe<Array<CreateCollectionTextBannerInput>>;
  videoBanners?: InputMaybe<Array<CreateCollectionVideoBannerInput>>;
};

export type CreateCollectionBannersInput = {
  banners: CreateCollectionBannerInput;
  collectionId: Scalars['ID'];
};

export type CreateCollectionBannersPayload = {
  imageBanners?: Maybe<Array<CollectionImageBanner>>;
  textBanners?: Maybe<Array<CollectionTextBanner>>;
  videoBanners?: Maybe<Array<CollectionVideoBanner>>;
};

export type CreateCollectionError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateCollectionErrorDetail>;
  message: Scalars['String'];
};

export type CreateCollectionErrorDetail = {
  archived?: Maybe<Scalars['Boolean']>;
  brandId: Scalars['ID'];
  code?: Maybe<Scalars['String']>;
  ignores_inventory?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  seasonId: Scalars['ID'];
};

export type CreateCollectionGroupInput = {
  header: Scalars['String'];
  orderNbr: Scalars['Int'];
};

export type CreateCollectionGroupsInput = {
  collectionGroups: Array<CreateCollectionGroupInput>;
  collectionId: Scalars['ID'];
};

export type CreateCollectionImageBannerInput = {
  imageId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type CreateCollectionInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  completeShipDate?: InputMaybe<Scalars['Date']>;
  cutoffDate?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  ignores_inventory?: InputMaybe<Scalars['Boolean']>;
  madeToOrder?: InputMaybe<Scalars['Boolean']>;
  minimumShippingWindow?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  season?: InputMaybe<CollectionSeasonInput>;
  seasonId?: InputMaybe<Scalars['ID']>;
  startShipDate?: InputMaybe<Scalars['Date']>;
  visibleToAllMatches?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCollectionTextBannerInput = {
  content: Scalars['String'];
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type CreateCollectionVideoBannerInput = {
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
  videoId?: InputMaybe<Scalars['ID']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateConfigurationInput = {
  configuration: ConfigurationInput;
};

export type CreateConnectionBuyerInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['ID'];
};

export type CreateConnectionDiscountInput = {
  amount?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  level: DiscountLevel;
  retailerId: Scalars['ID'];
};

export type CreateConnectionPriceTypeInput = {
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
  termsConditionId?: InputMaybe<Scalars['ID']>;
};

export type CreateConnectionSalesRepInput = {
  divisionId?: InputMaybe<Scalars['ID']>;
  retailerId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateCustomAssortmentInput = {
  assortmentName?: InputMaybe<Scalars['String']>;
  retailCurrencyId: Scalars['ID'];
  retailerId: Scalars['ID'];
  wholesaleCurrencyId: Scalars['ID'];
};

export type CreateCustomProductsFromSheetsResponse = {
  jobId: Scalars['String'];
};

export type CreateDataPermissionConfigurationInput = {
  configuration: PermissionConfigurationInput;
  name: Scalars['String'];
};

export type CreateDataPermissionConfigurationPayload = {
  dataPermissionConfiguration: DataPermissionConfiguration;
};

/** Creates a new door */
export type CreateDoorInput = {
  /** A unique identifier */
  code: Scalars['String'];
  /** A display name */
  name: Scalars['String'];
};

export type CreateDoorPayload = {
  door?: Maybe<Door>;
  errors?: Maybe<Array<Error>>;
};

export type CreateEventInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateExportIntegrationConfigInput = {
  autoStatus: Array<Scalars['Int']>;
  columnConfig: Scalars['String'];
  combineExportsIntoSingleFile?: InputMaybe<Scalars['Boolean']>;
  convertImagesUrlsToColumns?: InputMaybe<Scalars['Boolean']>;
  convertSingleDoorToCluster?: InputMaybe<Scalars['Boolean']>;
  csvDelimiter?: InputMaybe<CsvDelimiterType>;
  csvEncodingType?: InputMaybe<ExportCSVEncodingType>;
  defaultClusterDoors?: InputMaybe<Array<Scalars['String']>>;
  doorQuantityColumn?: InputMaybe<Scalars['Boolean']>;
  excludeSkusWithZeroQuantities?: InputMaybe<Scalars['Boolean']>;
  fileExtension: ExportFileExtensionType;
  fileName?: InputMaybe<Scalars['String']>;
  fileNameDelimiter?: InputMaybe<Scalars['String']>;
  fileNameParts: Array<ExportFileNameParts>;
  fileNamePrefix?: InputMaybe<Scalars['String']>;
  ftpPath?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  level: ExportLevel;
  name: Scalars['String'];
  onlySkuQuantities?: InputMaybe<Scalars['Boolean']>;
  overwrittenFileExtension?: InputMaybe<Scalars['String']>;
  removeHeader?: InputMaybe<Scalars['Boolean']>;
  textQualifier?: InputMaybe<Scalars['String']>;
  type: ExportType;
  unzipFilesToFTPPath?: InputMaybe<Scalars['Boolean']>;
};

export type CreateExternalPaymentInput = {
  amount: Scalars['Float'];
  attachments: Array<AttachmentInput>;
  billingAddress: Scalars['String'];
  billingCity: Scalars['String'];
  billingCountry: Scalars['String'];
  billingPostalCode: Scalars['String'];
  billingState: Scalars['String'];
  brandContactEmail: Scalars['EmailAddress'];
  brandContactName: Scalars['String'];
  brandId: Scalars['ID'];
  brandName: Scalars['String'];
  currency: Scalars['String'];
  dueDate?: InputMaybe<Scalars['Date']>;
  notes?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
  retailerEmails: Array<Scalars['EmailAddress']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerName: Scalars['String'];
};

export type CreateExternalProviderAuthInput = {
  apiKey: Scalars['String'];
  provider: Scalars['String'];
};

export type CreateIdentityProviderInput = {
  domain: Scalars['String'];
  sigCert: Scalars['String'];
  ssoLoginUrl: Scalars['String'];
};

export type CreateIdentityProviderPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  idpConfig?: Maybe<IdpConfig>;
  success: Scalars['Boolean'];
};

export type CreateInProgressOrdersWithUnitsInput = {
  /** Billing info for the order */
  billingInfo?: InputMaybe<BillingInfo>;
  /** To pass bulk quantities to be added to the created order */
  bulkQuantities?: InputMaybe<Array<InputMaybe<BulkQuantity>>>;
  buyer?: InputMaybe<BuyerInput>;
  /** To pass casepack quantities to be added to the created order */
  casepackQuantities?: InputMaybe<Array<InputMaybe<CasepackQuantity>>>;
  /** Context to create orders */
  orderInfo: OrderInfo;
  /** Shipping info for the order */
  shippingInfo?: InputMaybe<ShippingInfo>;
  /** To add comments to skus on the created order */
  skuComments?: InputMaybe<Array<InputMaybe<SkuComment>>>;
  /** To pass SKU quantities to be added to the created order */
  skuQuantities?: InputMaybe<Array<InputMaybe<SkuQuantity>>>;
};

export type CreateInProgressOrdersWithUnitsPayload = {
  createdOrderIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type CreateInvoicesInput = {
  amount?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  isPartialPaymentRequest?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderIds: Array<Scalars['ID']>;
  retailerId: Scalars['ID'];
};

export type CreateJobInput = {
  inputData?: InputMaybe<Scalars['JSON']>;
  inputFileUrl: Scalars['String'];
  jobId?: InputMaybe<Scalars['String']>;
  type: JobType;
};

export type CreateJobPayload = {
  id: Scalars['ID'];
};

export type CreateManualPaymentRecordInput = {
  amount: Scalars['Float'];
  brandId: Scalars['ID'];
  currency: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  paymentDate: Scalars['Date'];
  paymentMethod: ManualPaymentMethod;
  recordedBy?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['ID'];
};

/** Creates a new merchandising hierarchy node */
export type CreateMerchandisingHierarchyNodeInput = {
  /** A unique identifier */
  code: Scalars['String'];
  /** The merchandising hierarchy level */
  levelId: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
  /** The ID of the parent merchandising hierarchy node */
  parentId?: InputMaybe<Scalars['ID']>;
};

export type CreateMerchandisingHierarchyNodePayload = {
  errors?: Maybe<Array<Error>>;
  merchandisingHierarchyNode?: Maybe<MerchandisingHierarchyNode>;
};

/** Creates the merchandising hierarchy rules for a price modifier */
export type CreateMerchandisingHierarchyRuleForPriceModifierInput = {
  /** The factor to apply for this rule */
  factor: Scalars['Decimal'];
  /** Values for the updated rules */
  merchandisingHierarchyNodeId: Scalars['ID'];
  /** Id of the object to update */
  priceModifierGroupId: Scalars['ID'];
  /** The name to display for this rule */
  ruleName: Scalars['String'];
};

export type CreateMerchandisingHierarchyRuleForPriceModifierPayload = {
  priceModifierRule: PriceModifierRule;
};

/** Creates a message given sender and recipient account ids, subject, and body. */
export type CreateMessageInput = {
  attachment?: InputMaybe<Scalars['Upload']>;
  body: Scalars['String'];
  messageType: MessageType;
  recipientAccountId: Scalars['ID'];
  senderAccountId: Scalars['ID'];
  subject: Scalars['String'];
};

/** Creates new workspace with blank assortment */
export type CreateNewRetailWorkspaceInput = {
  /** Name of the initial assortment in the new retail workspace */
  assortmentName: Scalars['String'];
  /** The retailer account id */
  retailerId: Scalars['String'];
  /** Season to assign to the initial assortment */
  seasonId: Scalars['ID'];
  /** Name of the new retail workspace */
  workspaceName: Scalars['String'];
};

export type CreateOrderFromAssortmentInput = {
  assortmentId: Scalars['ID'];
  brandSalesRepresentativeEmail: Scalars['String'];
  ccSenderOnEmail?: InputMaybe<Scalars['Boolean']>;
  customMessage?: InputMaybe<Scalars['String']>;
};

export type CreateOrderFromAssortmentPayload = {
  assortment: Assortment;
  query?: Maybe<Query>;
};

export type CreateOrderPriceModifier = {
  modifierFactor: Scalars['Decimal'];
  type: OrderPriceModifierType;
};

export type CreateOrphanInProgressOrdersWithUnitsInput = {
  /** Billing info for the order */
  billingInfo?: InputMaybe<OrphanBillingInfo>;
  /** To pass bulk quantities to be added to the created order */
  bulkQuantities?: InputMaybe<Array<BulkQuantity>>;
  buyer?: InputMaybe<BuyerInput>;
  /** To pass casepack quantities to be added to the created order */
  casepackQuantities?: InputMaybe<Array<CasepackQuantity>>;
  /** Context to create orders */
  orderInfo: OrphanOrderInfo;
  /** Shipping info for the order */
  shippingInfo?: InputMaybe<OrphanShippingInfo>;
  /** To add comments to skus on the created order */
  skuComments?: InputMaybe<Array<SkuComment>>;
  /** To pass SKU quantities to be added to the created order */
  skuQuantities?: InputMaybe<Array<SkuQuantity>>;
};

export type CreateOrphanInProgressOrdersWithUnitsPayload = {
  createdOrderIds?: Maybe<Array<Scalars['ID']>>;
};

export type CreateOrphanRetailerInput = {
  accountId: Scalars['ID'];
  connectionProcessed: Scalars['Boolean'];
  retailerCode?: InputMaybe<Scalars['String']>;
  retailerEmail: Scalars['String'];
  retailerName: Scalars['String'];
};

export type CreatePaymentWithPaymentMethodInput = {
  amount: Scalars['Float'];
  billingProfile?: InputMaybe<BillingProfile>;
  brandId: Scalars['ID'];
  callbackUrl?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  externalPaymentId?: InputMaybe<Scalars['ID']>;
  extraData?: InputMaybe<ExtraData>;
  invoiceCurrency?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['ID']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  paymentProvider: Scalars['String'];
  rateOfferId?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  userId?: InputMaybe<Scalars['String']>;
  viaAgent?: InputMaybe<Scalars['Boolean']>;
};

export type CreateProductError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateProductErrorDetail>;
  message: Scalars['String'];
};

export type CreateProductErrorDetail = {
  categoryIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  externalIdentifier: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  orderMinimum?: Maybe<Scalars['Int']>;
  productIdentifier?: Maybe<Scalars['String']>;
};

export type CreateProductInput = {
  badgeIds?: InputMaybe<Array<Scalars['ID']>>;
  brandId: Scalars['String'];
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  externalIdentifier?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderMinimum: Scalars['Int'];
  productIdentifier?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type CreateRawOrdersExportPayload = {
  taskId: Scalars['ID'];
};

export type CreateReachPaymentPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  sessionId: Scalars['String'];
};

export type CreateRegionInput = {
  geographyIds: Array<Scalars['ID']>;
  name: Scalars['String'];
};

/** Converts the assortment to retail workspace */
export type CreateRetailWorkspaceInput = {
  /** The assortments to convert to a retail workspace */
  assortmentIds?: InputMaybe<Array<Scalars['String']>>;
  /** The name of the new retail workspace */
  name: Scalars['String'];
  /** The retailer account id */
  retailerId: Scalars['String'];
};

export type CreateSeasonError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateSeasonErrorDetail>;
  message: Scalars['String'];
};

export type CreateSeasonErrorDetail = {
  /** A unique identifier */
  code: Scalars['String'];
  /** A display name */
  name: Scalars['String'];
  /** A calendar year */
  year: Scalars['Int'];
};

/** Creates a new season */
export type CreateSeasonInput = {
  /** A unique identifier */
  code: Scalars['String'];
  /** A display name */
  name: Scalars['String'];
  /** A calendar year */
  year: Scalars['Int'];
};

export type CreateSeasonPayload = {
  errors?: Maybe<Array<CreateSeasonError>>;
  season?: Maybe<Season>;
};

export type CreateSkuPriceError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<CreateSkuPriceErrorDetail>;
  message: Scalars['String'];
};

export type CreateSkuPriceErrorDetail = {
  priceTypeId: Scalars['ID'];
  skuId: Scalars['ID'];
  suggestedRetailPrice?: Maybe<Scalars['Decimal']>;
  wholesalePrice: Scalars['Decimal'];
};

export type CreateSkuPriceInput = {
  priceTypeId: Scalars['ID'];
  skuId: Scalars['ID'];
  suggestedRetailPrice?: InputMaybe<Scalars['Decimal']>;
  wholesalePrice: Scalars['Decimal'];
};

export type CreateSkuTraitValueInput = {
  externalIdentifier?: InputMaybe<Scalars['String']>;
  orderMinimum?: InputMaybe<Scalars['Int']>;
  orderNbr?: InputMaybe<Scalars['Int']>;
  productId: Scalars['ID'];
  skuTraitId: Scalars['ID'];
  status?: InputMaybe<SkuTraitValueStatus>;
  value: Scalars['String'];
};

/** Creates a user given an email and password. */
export type CreateUserInput = {
  /** The unique email of the new user */
  email: Scalars['String'];
  /** The password for the new user */
  password: Scalars['String'];
};

/** Creates a PENDING membership invite from the given user and account to given email */
export type CreateUserMembershipInviteInput = {
  invitedEmail: Scalars['String'];
  invitingAccountId: Scalars['ID'];
  invitingUserId: Scalars['ID'];
};

/** Creates a pending request for membership by the given user to the given account */
export type CreateUserMembershipRequestInput = {
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type CreateUserMembershipRequestInputForBulk = {
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Returns either the user created or an error. */
export type CreateUserPayload = {
  error?: Maybe<Error>;
  user?: Maybe<User>;
};

/**
 * Input for creating a custom Visual Assortment Attribute Key (type). The owning
 * access is resolved server-side from the principal; system keys (Seasons, Doors)
 * cannot be created this way.
 */
export type CreateVisualAssortmentAttributeKeyInput = {
  /** Display name of the attribute key. Must not match a system key name. */
  name: Scalars['String'];
  /** Order number for the attribute key. */
  orderNbr: Scalars['Int'];
};

/** Response type for creating a custom Visual Assortment Attribute Key (type). */
export type CreateVisualAssortmentAttributeKeyResponse = {
  /** The custom attribute key that was created. */
  attributeKey: VisualAssortmentAttributeKey;
};

/** Response type for creating Visual Assortment Attribute Values. */
export type CreateVisualAssortmentAttributeValuesResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
  /** List of attribute keys and their values for the account */
  visualAssortmentAttributeKeys: Array<VisualAssortmentAttributeKey>;
};

/** Input for creating a Visual Assortment Budget. */
export type CreateVisualAssortmentBudgetInput = {
  attributeFilterId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  groupings: Array<VisualAssortmentBudgetGroupingInput>;
  visualAssortmentId: Scalars['ID'];
};

export enum CreationService {
  ADMIN_ACCOUNT_CREATION = 'ADMIN_ACCOUNT_CREATION',
  AMR = 'AMR',
  API_CUSTOMER = 'API_CUSTOMER',
  BULK_STAGED_CONNECTIONS = 'BULK_STAGED_CONNECTIONS',
  CREATION_SERVICE_UNKNOWN = 'CREATION_SERVICE_UNKNOWN',
  ISPO = 'ISPO',
  RETAIL_REGISTRATION = 'RETAIL_REGISTRATION',
  STAGED_CONNECTIONS = 'STAGED_CONNECTIONS'
}

export type CreditCard = PaymentMethodI & {
  billingEmail: Scalars['String'];
  billingName: Scalars['String'];
  brand: Scalars['String'];
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
  type: Scalars['String'];
};

export enum CsvDelimiterType {
  ASTERISK = 'ASTERISK',
  BACKTICK = 'BACKTICK',
  COLON = 'COLON',
  COMMA = 'COMMA',
  DASH = 'DASH',
  HASH = 'HASH',
  PIPE = 'PIPE',
  SEMICOLON = 'SEMICOLON',
  SPACE = 'SPACE',
  TAB = 'TAB'
}

export type Currency = Node & {
  code: Scalars['String'];
  decimal_separator?: Maybe<Scalars['String']>;
  decimals: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  thousands_separator?: Maybe<Scalars['String']>;
};

export enum CurrencyCode {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BOV = 'BOV',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHE = 'CHE',
  CHF = 'CHF',
  CHW = 'CHW',
  CLF = 'CLF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  COU = 'COU',
  CRC = 'CRC',
  CUC = 'CUC',
  CUP = 'CUP',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  FJD = 'FJD',
  FKP = 'FKP',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRU = 'MRU',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MXV = 'MXV',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SLL = 'SLL',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STN = 'STN',
  SVC = 'SVC',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  USN = 'USN',
  USS = 'USS',
  UYI = 'UYI',
  UYU = 'UYU',
  UZS = 'UZS',
  VES = 'VES',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW',
  ZWL = 'ZWL'
}

export type CurrencyConnection = {
  edges?: Maybe<Array<CurrencyEdge>>;
};

/** A conversion between two currencies. */
export type CurrencyConversion = {
  /** Multiplicative conversion rate applied */
  factor: Scalars['Decimal'];
  /** Initial currency */
  fromCurrencyCode: Scalars['String'];
  /** Final currency */
  toCurrencyCode: Scalars['String'];
};

export type CurrencyEdge = {
  node?: Maybe<Currency>;
};

export enum CurrencyFilter {
  ASSORTMENT_CURRENCY = 'ASSORTMENT_CURRENCY',
  LINESHEET_CURRENCY = 'LINESHEET_CURRENCY',
  LINESHEET_RETAIL_CURRENCY = 'LINESHEET_RETAIL_CURRENCY',
  LINESHEET_WHOLESALE_CURRENCY = 'LINESHEET_WHOLESALE_CURRENCY'
}

export type CurrencyFilterInput = {
  priceChangeCurrenciesOnly?: InputMaybe<Scalars['Boolean']>;
};

export type CustomFeeInput = {
  factor: Scalars['Decimal'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  type: OrderPriceModifierType;
};

export type CustomSizeRequest = {
  code?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CustomerCode = {
  alias?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CustomerError = {
  code?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type CustomerGroup = Node & {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CustomerGroupConnection = {
  edges: Array<Maybe<CustomerGroupEdge>>;
};

export type CustomerGroupEdge = {
  node?: Maybe<CustomerGroup>;
};

export type CustomerGroupOutput = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CustomerPayload = {
  buyerName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type CustomerRecordPaymentMethodError = {
  message?: Maybe<Scalars['String']>;
};

export type CustomerWarehouse = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
};

/**
 * DataPermissionConfiguration represents a grouping of permissions with unique names between accounts
 * this data permissions could be:
 * 1 - groups of divisions and categories that the users in the group are allowed to see
 * 2 - divisions that the users in the groups are allowed to see
 */
export type DataPermissionConfiguration = Node & {
  configuration?: Maybe<PermissionConfiguration>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DataPermissionConfigurationConnection = {
  edges: Array<DataPermissionConfigurationEdge>;
};

export type DataPermissionConfigurationEdge = {
  node: DataPermissionConfiguration;
};

export type DataPermissionConfigurationFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export enum DateFormat {
  DAY_FIRST = 'DAY_FIRST',
  MONTH_FIRST = 'MONTH_FIRST',
  YEAR_FIRST = 'YEAR_FIRST'
}

export type DateRange = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type DeleteBulkLineItem = {
  orderId: Scalars['ID'];
  variantId: Scalars['ID'];
};

export type DeleteCasepackLineItem = {
  casepackId: Scalars['ID'];
  casepackName?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type DeleteCollectionBannerInput = {
  imageBannerIds?: InputMaybe<Array<Scalars['ID']>>;
  textBannerIds?: InputMaybe<Array<Scalars['ID']>>;
  videoBannerIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type DeleteCollectionBannersInput = {
  banners: DeleteCollectionBannerInput;
  collectionId: Scalars['ID'];
};

export type DeleteCollectionBannersPayload = {
  imageBannerIds?: Maybe<Array<Scalars['ID']>>;
  textBannerIds?: Maybe<Array<Scalars['ID']>>;
  videoBannerIds?: Maybe<Array<Scalars['ID']>>;
};

export type DeleteConfigurationInput = {
  id: Scalars['ID'];
};

export type DeleteConnectionBuyerInput = {
  id: Scalars['ID'];
};

export type DeleteConnectionDiscountInput = {
  id: Scalars['ID'];
};

export type DeleteConnectionDiscountsResponse = {
  errors?: Maybe<Array<CustomerError>>;
  ids: Array<Scalars['ID']>;
};

export type DeleteConnectionPriceTypeInput = {
  id: Scalars['ID'];
};

export type DeleteConnectionPriceTypesResponse = {
  errors?: Maybe<Array<CustomerError>>;
  ids: Array<Scalars['ID']>;
};

export type DeleteConnectionSalesRepInput = {
  id: Scalars['ID'];
};

export type DeleteConnectionSalesRepsResponse = {
  errors?: Maybe<Array<CustomerError>>;
  ids: Array<Scalars['ID']>;
};

export type DeleteExportIntegrationConfigsInput = {
  ids: Array<Scalars['String']>;
};

export type DeleteExternalPaymentInput = {
  /** must be `ExternalPayment:<id>` encoded in base64 */
  id: Scalars['ID'];
};

export type DeleteExternalPaymentPayload = {
  ok: Scalars['Boolean'];
};

export type DeleteFavoriteAccountInput = {
  brandAccountId: Scalars['ID'];
};

export type DeleteIdentityProviderInput = {
  domain: Scalars['String'];
};

export type DeleteIdentityProviderPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type DeleteManualPaymentRecordInput = {
  id: Scalars['ID'];
};

export type DeleteManualPaymentRecordPayload = {
  ok: Scalars['Boolean'];
};

export type DeleteOrderLineItemsInput = {
  /** To pass bulk quantities to be deleted */
  bulkLineItems?: InputMaybe<Array<DeleteBulkLineItem>>;
  /** To pass casepack quantities to be deleted */
  casepackLineItems?: InputMaybe<Array<DeleteCasepackLineItem>>;
  /** To pass the order line item ids to be deleted */
  orderLineItemIds?: InputMaybe<Array<Scalars['ID']>>;
  /** To pass SKU quantities to be deleted */
  skuLineItems?: InputMaybe<Array<DeleteSkuLineItem>>;
};

export type DeleteOrderLineItemsPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteOrderVariantsInput = {
  orderId: Scalars['ID'];
  variantIds: Array<Scalars['ID']>;
};

export type DeleteOrderVariantsPayload = {
  success?: Maybe<Scalars['Boolean']>;
  updatedOrderId: Scalars['ID'];
};

export type DeletePayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePaymentMethodPayload = {
  ok: Scalars['Boolean'];
};

export type DeleteProductError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<DeleteProductErrorDetail>;
  message: Scalars['String'];
};

export type DeleteProductErrorDetail = {
  externalIdentifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  productIdentifier?: Maybe<Scalars['String']>;
};

export type DeleteProductInput = {
  externalIdentifier?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  productIdentifier?: InputMaybe<Scalars['String']>;
};

export type DeleteRegionInput = {
  id: Scalars['ID'];
};

export type DeleteShowroomCollectionPayload = {
  id: Scalars['ID'];
};

export type DeleteShowroomCollectionsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteSkuLineItem = {
  orderId: Scalars['ID'];
  skuId: Scalars['ID'];
};

export type DeleteStorefrontsPayload = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteStyleboardPayload = {
  id: Scalars['ID'];
};

export type DeleteStyleboardsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteUrl3dShowroomInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteUrl3dShowroomPayload = {
  ids: Array<Scalars['ID']>;
};

/** Response type for deleting a custom Visual Assortment Attribute Key (type). */
export type DeleteVisualAssortmentAttributeKeyResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
};

/** Response type for deleting Visual Assortment Attribute Values. */
export type DeleteVisualAssortmentAttributeValuesResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
  /** List of attribute keys and their values for the account */
  visualAssortmentAttributeKeys: Array<VisualAssortmentAttributeKey>;
};

export type DeleteVisualAssortmentCardsResponse = {
  /** List of card IDs that were successfully deleted */
  deletedCardIds: Array<Scalars['ID']>;
  versionDelta: VersionDelta;
};

export type Delivery = {
  /** @deprecated Get from cutoffDate */
  cancelDate?: Maybe<Scalars['Date']>;
  completeShipDate?: Maybe<Scalars['Date']>;
  cutoffDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  minimumShippingWindow?: Maybe<Scalars['Int']>;
  startShipDate?: Maybe<Scalars['Date']>;
};

export type Destination = {
  node?: Maybe<Door>;
};

/** Filter options for diff results */
export enum DiffFilterBy {
  /** Only return cards that exist in VA but not in orders (removed cards) */
  CANCELLED = 'CANCELLED',
  /** No filter applied - return all diffs */
  NONE = 'NONE'
}

/** Response containing all differences between current and unsynced cards */
export type DiffVisualAssortmentCardsResponse = {
  /** Count of cards that would be added */
  addedCount: Scalars['Int'];
  /** List of all card differences */
  diffs: Array<VisualAssortmentCardDiff>;
  /** Count of cards that would be modified */
  modifiedCount: Scalars['Int'];
  /** Count of cards that would be removed */
  removedCount: Scalars['Int'];
  /** Total count of all changes (added + removed + modified) */
  totalChanges: Scalars['Int'];
};

export type Discount = Node & {
  brandId: Scalars['ID'];
  factor?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
};

export type DiscountConnection = {
  edges: Array<Maybe<DiscountEdge>>;
};

export type DiscountEdge = {
  node?: Maybe<Discount>;
};

export enum DiscountLevel {
  LINE_ITEM = 'LINE_ITEM',
  ORDER = 'ORDER'
}

export enum DisplayFormatEnum {
  ALL = 'ALL',
  DECIMAL = 'DECIMAL',
  PERCENT = 'PERCENT',
  PRICE = 'PRICE'
}

export type Division = Node & {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DivisionCategory = {
  category: Category;
  division: Division;
};

export type DivisionCategoryInput = {
  categoryId: Scalars['ID'];
  divisionId: Scalars['ID'];
};

/** Doors represent physical locations or selling channels of your business. */
export type Door = Node & {
  /** A unique identifier */
  code: Scalars['String'];
  id: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
};

/** DoorCluster represent a grouping of doors */
export type DoorCluster = Node & {
  /** A unique identifier */
  code?: Maybe<Scalars['String']>;
  /** The doors in the cluster */
  doors?: Maybe<DoorClusterDoorConnection>;
  id: Scalars['ID'];
  /** A display name */
  name?: Maybe<Scalars['String']>;
};

export type DoorClusterDoorConnection = {
  edges?: Maybe<Array<DoorClusterDoorEdge>>;
};

export type DoorClusterDoorEdge = {
  node?: Maybe<Door>;
};

/**
 * Single door cluster input for creating or updating assortment clusters
 * If the id is provided, we update the cluster, if not we create a cluster.
 * Code and name are optional for both cases.
 */
export type DoorClusterInput = {
  code?: InputMaybe<Scalars['String']>;
  doorIds: Array<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type DoorColorsRequest = {
  colorId: Scalars['ID'];
  doorId: Scalars['ID'];
};

export type DoorConnection = {
  edges?: Maybe<Array<DoorEdge>>;
};

export type DoorEdge = {
  node?: Maybe<Door>;
};

export type DoorInputInfo = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Upserts a quantity for an assigned SKU-door line item */
export enum DoorOrCluster {
  CLUSTER = 'CLUSTER',
  DOOR = 'DOOR'
}

export type DoorPriceLevels = Node & {
  id: Scalars['ID'];
  node: Door;
  priceLevels: Array<PriceLevel>;
  quantity: Scalars['Int'];
  skuCount: Scalars['Int'];
};


export type DoorPriceLevelspriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type DownloadCustomProductsSheetTemplate = {
  customProductsSheetUrl: Scalars['String'];
};

/** Response type for editing Visual Assortment Cards. */
export type EditVisualAssortmentCardsResponse = {
  /** The edited visual assortment cards */
  cards: VisualAssortmentCardConnection;
  versionDelta: VersionDelta;
};


/** Response type for editing Visual Assortment Cards. */
export type EditVisualAssortmentCardsResponsecardsArgs = {
  filter?: InputMaybe<VisualAssortmentCardsFilterInput>;
  onlyEdited?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<VisualAssortmentCardsPaginationInput>;
  search?: InputMaybe<VisualAssortmentCardsSearchInput>;
};

export enum ElementType {
  ABOUT = 'ABOUT',
  COLLECTION = 'COLLECTION',
  IMAGE = 'IMAGE',
  INSTAGRAM = 'INSTAGRAM',
  LOOKBOOK = 'LOOKBOOK',
  ORB360 = 'ORB360',
  PRODUCT = 'PRODUCT',
  SHOWROOM_BRAND = 'SHOWROOM_BRAND',
  SHOWROOM_COLLECTION = 'SHOWROOM_COLLECTION',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

/** Date field used to filter eligible orders. */
export enum EligibleOrdersDateBasis {
  DELIVERY_WINDOW_END = 'DELIVERY_WINDOW_END',
  ORDER_CREATION = 'ORDER_CREATION'
}

export type EligibleOrdersDateFilterInput = {
  /** Date field to filter on */
  dateBasis: EligibleOrdersDateBasis;
  /** Number of months for LAST_N_MONTHS or NEXT_N_MONTHS EligibleOrdersTimeframe */
  nMonths?: InputMaybe<Scalars['Int']>;
  /** Timeframe window for the selected date basis */
  timeframe: EligibleOrdersTimeframe;
};

/** Filter criteria for eligible orders date filtering. */
export type EligibleOrdersFilterInput = {
  /** Date filter for eligible orders */
  dateFilter?: InputMaybe<EligibleOrdersDateFilterInput>;
};

/** Timeframe window applied to the selected date basis. */
export enum EligibleOrdersTimeframe {
  LAST_N_MONTHS = 'LAST_N_MONTHS',
  NEXT_N_MONTHS = 'NEXT_N_MONTHS',
  THIS_MONTH = 'THIS_MONTH'
}

export type Error = {
  code?: Maybe<ErrorCode>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export enum ErrorCode {
  MAX_PAYMENT_AMOUNT_EXCEEDED = 'MAX_PAYMENT_AMOUNT_EXCEEDED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export enum ErrorType {
  ACCOUNT = 'ACCOUNT',
  COLLECTION = 'COLLECTION',
  DOOR = 'DOOR',
  PRICE = 'PRICE',
  PRICE_TYPE = 'PRICE_TYPE',
  PRODUCT = 'PRODUCT',
  PRODUCT_COLOR = 'PRODUCT_COLOR',
  PRODUCT_SIZE = 'PRODUCT_SIZE',
  QUANTITY = 'QUANTITY',
  SKU_IDENTIFIER = 'SKU_IDENTIFIER',
  UPC = 'UPC'
}

export type Event = {
  code?: Maybe<Scalars['String']>;
  event?: Maybe<Scalars['String']>;
};

export enum ExportCSVEncodingType {
  ASCII = 'ASCII',
  UTF8 = 'UTF8',
  UTF8SIG = 'UTF8SIG',
  WIN1252 = 'WIN1252'
}

export enum ExportFileExtensionType {
  CSV = 'CSV',
  XLS = 'XLS',
  XLSX = 'XLSX'
}

export enum ExportFileNameParts {
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  DESIGNER = 'DESIGNER',
  ID = 'ID',
  SEASON_CODE = 'SEASON_CODE',
  TIME = 'TIME',
  UNKNOWN_NAME = 'UNKNOWN_NAME'
}

/** Export format for Visual Assortment export. */
export enum ExportFormat {
  CSV = 'CSV',
  XLSX = 'XLSX'
}

export type ExportIntegrationConfig = {
  accountId?: Maybe<Scalars['ID']>;
  autoStatus: Array<Scalars['Int']>;
  columnConfig: Scalars['String'];
  combineExportsIntoSingleFile?: Maybe<Scalars['Boolean']>;
  convertImagesUrlsToColumns?: Maybe<Scalars['Boolean']>;
  convertSingleDoorToCluster?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['Date'];
  csvDelimiter?: Maybe<CsvDelimiterType>;
  csvEncodingType?: Maybe<ExportCSVEncodingType>;
  defaultClusterDoors?: Maybe<Array<Maybe<Scalars['String']>>>;
  doorQuantityColumn?: Maybe<Scalars['Boolean']>;
  excludeSkusWithZeroQuantities?: Maybe<Scalars['Boolean']>;
  fileExtension?: Maybe<ExportFileExtensionType>;
  fileName: Scalars['String'];
  fileNameDelimiter?: Maybe<Scalars['String']>;
  fileNameParts: Array<ExportFileNameParts>;
  fileNamePrefix?: Maybe<Scalars['String']>;
  ftpPath?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  level?: Maybe<ExportLevel>;
  name: Scalars['String'];
  onlySkuQuantities?: Maybe<Scalars['Boolean']>;
  overwrittenFileExtension?: Maybe<Scalars['String']>;
  removeHeader?: Maybe<Scalars['Boolean']>;
  textQualifier: Scalars['String'];
  type?: Maybe<ExportType>;
  unzipFilesToFTPPath?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['Date'];
};

export enum ExportLevel {
  LINE_ITEM = 'LINE_ITEM',
  SKU = 'SKU',
  STYLE_COLOR = 'STYLE_COLOR',
  TOP_LEVEL = 'TOP_LEVEL'
}

export enum ExportType {
  ASSORTMENT_EXPORT = 'ASSORTMENT_EXPORT',
  ORDER_EXPORT = 'ORDER_EXPORT',
  ORDER_IMPORT = 'ORDER_IMPORT',
  PRODUCT_EXPORT = 'PRODUCT_EXPORT'
}

export type ExportVisualAssortmentBudgetResponse = {
  downloadUrl: Scalars['String'];
};

export type ExportVisualAssortmentResponse = {
  downloadUrl: Scalars['String'];
};

export type ExternalMedia = Node & {
  format: Scalars['String'];
  id: Scalars['ID'];
  payload: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ExternalPayment = {
  amount: Scalars['Float'];
  attachments?: Maybe<Array<Attachment>>;
  billingAddress: Scalars['String'];
  billingCity: Scalars['String'];
  billingCountry: Scalars['String'];
  billingPostalCode: Scalars['String'];
  billingState: Scalars['String'];
  brandContactEmail: Scalars['EmailAddress'];
  brandContactName: Scalars['String'];
  brandId: Scalars['ID'];
  brandName: Scalars['String'];
  created?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  deletedAt?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  link: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  paymentId: Scalars['String'];
  paymentProvider?: Maybe<ReachPaymentProvider>;
  paymentStatus: ExternalPaymentStatus;
  retailerEmails: Array<Scalars['EmailAddress']>;
  retailerId?: Maybe<Scalars['ID']>;
  retailerName: Scalars['String'];
  sent: Scalars['Boolean'];
  sentDate?: Maybe<Scalars['Date']>;
};

export enum ExternalPaymentStatus {
  FULLY_PAID = 'FULLY_PAID',
  NOT_PAID = 'NOT_PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID'
}

export type ExternalProviderAuth = {
  apiKey: Scalars['String'];
  brandId: Scalars['ID'];
  id: Scalars['ID'];
  provider: Scalars['String'];
};

export type ExternalProviderAuthFilters = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type ExternalRecipient = {
  accountId: Scalars['ID'];
  email: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  sendCopy: Scalars['Boolean'];
};

export enum ExternalSource {
  EXTERNAL_SOURCE_UNKNOWN = 'EXTERNAL_SOURCE_UNKNOWN',
  ISPO2024 = 'ISPO2024',
  SHOWROOMX2025 = 'SHOWROOMX2025'
}

export type ExtraData = {
  brandName?: InputMaybe<Scalars['String']>;
  orderTotalAmount?: InputMaybe<Scalars['Float']>;
  poNumber?: InputMaybe<Scalars['String']>;
  retailerEmail?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
};

export type Fabrication = {
  name: Scalars['String'];
};

export type Favorite = {
  brandAccountId: Scalars['ID'];
  id: Scalars['ID'];
  tradeShowEventId?: Maybe<Scalars['ID']>;
};

export type FavoriteBrandAccountPayload = {
  brandAccountId: Scalars['ID'];
  id: Scalars['ID'];
  tradeShowEventId?: Maybe<Scalars['ID']>;
};

export type FavoritedBrand = {
  id: Scalars['ID'];
  mainImage?: Maybe<Scalars['String']>;
  profileName?: Maybe<Scalars['String']>;
  tradeShowEventSlug?: Maybe<Scalars['String']>;
};

export type FavoritedBrandsFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type FavoritedBrandsOrderBy = {
  field: FavoritedBrandsOrderByField;
};

export enum FavoritedBrandsOrderByField {
  NAME = 'NAME'
}

/** A Keycloak Federated Identity */
export type FederatedIdentity = {
  identityProvider?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type FieldValues = {
  brand: Array<RetailerBrandEdge>;
  brandV2: Array<RetailerBrand>;
  createdByUser: Array<RetailerUserEdge>;
  name: Array<Scalars['String']>;
  poNumber: Array<Scalars['String']>;
  season: Array<SeasonEdge>;
};

export enum FileToGenerate {
  ORDERS_DETAILS = 'ORDERS_DETAILS',
  ORDER_ERRORS = 'ORDER_ERRORS'
}

export type FilterItem = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type FinancialPriceLevel = FinancialPrices & {
  averageUnitCost: Money;
  averageUnitRetail: Money;
  cost: Money;
  extendedCost: Money;
  extendedRetail: Money;
  initialMarkup: Scalars['Decimal'];
  name: FinancialPriceLevelName;
  retail: Money;
};

export enum FinancialPriceLevelName {
  FINAL = 'FINAL',
  MODIFIED = 'MODIFIED',
  ORIGINAL = 'ORIGINAL'
}

export type FinancialPrices = {
  averageUnitCost?: Maybe<Money>;
  averageUnitRetail?: Maybe<Money>;
  cost?: Maybe<Money>;
  initialMarkup?: Maybe<Scalars['Decimal']>;
  retail?: Maybe<Money>;
};

export type FindProspectsFilters = {
  brandUsers?: InputMaybe<Array<Scalars['ID']>>;
  /** Keep only prospects whose connection request is in one of these states. */
  connectionRequestStatuses?: InputMaybe<Array<ProspectConnectionRequestStatus>>;
  submissionEngagement?: InputMaybe<SubmissionEngagementFilter>;
};

export type FindProspectsOrderBy = {
  field: FindProspectsOrderByField;
  order: FindProspectsOrderByOrder;
};

export enum FindProspectsOrderByField {
  ACTIVITY = 'ACTIVITY'
}

export enum FindProspectsOrderByOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export enum FurStatus {
  CONTAINS_FUR = 'CONTAINS_FUR',
  DOES_NOT_CONTAIN_FUR = 'DOES_NOT_CONTAIN_FUR',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type GenerateBSUTemplateInput = {
  collectionId?: InputMaybe<Scalars['ID']>;
  exportFormat?: InputMaybe<exportFormats>;
  priceTypeIds: Array<Scalars['ID']>;
};

export type GenerateBSUTemplatePayload = {
  bsuTemplateFileUrl: Scalars['String'];
};

export type GenerateSummaryFileInput = {
  fileToGenerate: FileToGenerate;
  validatedOrdersIdentifier: Scalars['String'];
};

export type GenerateSummaryFilePayload = {
  url?: Maybe<Scalars['String']>;
};

export type GenericError = {
  code?: Maybe<GenericErrorCode>;
  message: Scalars['String'];
};

export enum GenericErrorCode {
  DATA_ERROR = 'DATA_ERROR',
  DUPLICATED = 'DUPLICATED',
  NOT_FOUND = 'NOT_FOUND',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

/** Update details of a price modifier */
export type GenericSetPriceModifierValueInput = {
  /** Id of assortment */
  assortmentId: Scalars['ID'];
  /** Id of price_modifier_field */
  groupId: Scalars['ID'];
  /** Id of the object to update */
  priceModifierId?: InputMaybe<Scalars['ID']>;
  /** The value to apply */
  value?: InputMaybe<PriceModifierValueInput>;
};

export type GenericStyleImportError = {
  code: GenericStyleImportErrorCode;
  details?: Maybe<Scalars['String']>;
};

export enum GenericStyleImportErrorCode {
  ACCESS_FORBIDDEN = 'ACCESS_FORBIDDEN',
  DOWNLOAD_FAILED = 'DOWNLOAD_FAILED',
  FAILED_TO_ADD_IMAGES = 'FAILED_TO_ADD_IMAGES',
  FAILED_TO_PROCESS_FILE = 'FAILED_TO_PROCESS_FILE',
  FAILED_TO_READ_FILE = 'FAILED_TO_READ_FILE',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  INVALID_CATEGORY = 'INVALID_CATEGORY',
  INVALID_COLLECTION = 'INVALID_COLLECTION',
  INVALID_FILE_HEADERS = 'INVALID_FILE_HEADERS',
  INVALID_IMAGES_SOURCE_LINK = 'INVALID_IMAGES_SOURCE_LINK',
  INVALID_PRICE_TYPE = 'INVALID_PRICE_TYPE',
  MISSING_CATEGORIES_COLUMN = 'MISSING_CATEGORIES_COLUMN',
  NO_STYLES = 'NO_STYLES',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNSUPPORTED_FILE_EXTENSION = 'UNSUPPORTED_FILE_EXTENSION',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export type Geography = Node & {
  abbreviation?: Maybe<Scalars['String']>;
  geographyParentId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  taxLabel?: Maybe<Scalars['String']>;
  type: GeographyType;
};

export type GeographyConnection = {
  edges: Array<GeographyEdge>;
};

export type GeographyEdge = {
  node: Geography;
};

export type GeographyFilter = {
  geographyParentId: Scalars['ID'];
};

export enum GeographyType {
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  COUNTY = 'COUNTY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  PLANET = 'PLANET',
  STATE = 'STATE'
}

export type GetAccountCustomerCodesInput = {
  otherAccountIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type GetBrandStyleIdentifierPayload = {
  styleIdentifiers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetManageImagesStyleDataInput = {
  collectionId: Scalars['ID'];
  styleId: Scalars['ID'];
};

export type GetManageImagesStyleDataPayload = {
  fabrication?: Maybe<ManageImagesStyleFabrication>;
  images?: Maybe<Array<Maybe<ManageImagesStyleImage>>>;
  silhouette?: Maybe<ManageImagesStyleSilhouette>;
  styleColors?: Maybe<Array<Maybe<ManageImagesStyleColor>>>;
  styleId: Scalars['ID'];
  styleName: Scalars['String'];
  styleNumber: Scalars['String'];
};

export type GetOrCreatePendingUsersInput = {
  emails: Array<Scalars['String']>;
};

export type GetOrCreatePendingUsersPayload = {
  users?: Maybe<Array<GetOrCreateUserPayload>>;
};

/** Returns either the user who matches this email or an error. */
export type GetOrCreateUserPayload = {
  email: Scalars['String'];
  error?: Maybe<Error>;
  user?: Maybe<User>;
};

export type GetOrderCustomerDataPayload = {
  customerBillingAddressId?: Maybe<Scalars['ID']>;
  customerRecordId?: Maybe<Scalars['ID']>;
  customerShippingAddressId?: Maybe<Scalars['ID']>;
  errors: Array<Error>;
};

export type GetShowroomCollectionTokenizedLinkInput = {
  showroomCollectionId: Scalars['ID'];
  tokenActiveDays?: InputMaybe<Scalars['Int']>;
};

export type GoogleAddress = {
  accepted?: Maybe<Scalars['Boolean']>;
  accountId: Scalars['ID'];
  address1?: Maybe<Scalars['String']>;
  businessStatus?: Maybe<BusinessStatus>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  modified?: Maybe<Scalars['Date']>;
  phone?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type GoogleAddressConnection = {
  edges: Array<GoogleAddressEdge>;
};

export type GoogleAddressEdge = {
  node: GoogleAddress;
};

export type HandleRemoveAccountUserInput = {
  account_id: Scalars['String'];
  user_id: Scalars['String'];
};

export type HandleRemoveAccountUserPayload = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Response type for checking Visual Assortment Feature Access. */
export type HasVisualAssortmentFeatureAccessResponse = {
  /**
   * Always true. Every Lite Retailer is entitled to Visual Assortment, so the account no longer decides access.
   * @deprecated Always true, carries no information. Gate on hasUserAccess
   */
  hasAccess: Scalars['Boolean'];
  /**
   * Always true. Every Lite Retailer is entitled to Visual Assortment, so the account no longer decides access.
   * @deprecated Always true, carries no information. Gate on hasUserAccess
   */
  hasAccountAccess: Scalars['Boolean'];
  /**
   * Indicates whether the user may use Visual Assortment. True for any user of an account
   * that has no assortment yet, since there are no assigned users to compare against and
   * whoever acts first becomes the first one.
   */
  hasUserAccess: Scalars['Boolean'];
  /** Indicates whether the Visual Assortment access record has already been initialized for the account */
  isAccessInitialized: Scalars['Boolean'];
};

export type Hex = {
  value: Scalars['String'];
};

export type Hub = Node & {
  brand: Brand;
  creator: User;
  id: Scalars['ID'];
  lastModified?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  number: Scalars['String'];
  orders: HubOrderConnection;
  retailer: Retailer;
  shared: Scalars['Boolean'];
  status: HubStatus;
};


export type HubordersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type HubConnection = {
  edges: Array<HubEdge>;
};

export type HubEdge = {
  node: Hub;
};

export type HubFilter = {
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  /** Search by hub name, hub number and retailer name */
  searchText?: InputMaybe<Scalars['String']>;
};

export type HubOrderConnection = {
  buyers: Array<OrderBuyer>;
  collections: Array<Collection>;
  divisions: Array<Division>;
  doors: Array<BrandDoor>;
  edges: Array<HubOrderEdge>;
  events: Array<OrderEvent>;
  numberOfColors: Scalars['Int'];
  numberOfProducts: Scalars['Int'];
  numberOfUnits: Scalars['Int'];
  priceTypes: Array<PriceType>;
  salesRepresentatives: Array<User>;
  totalOrders: Scalars['Int'];
  warehouses: Array<Warehouse>;
  wholesaleTotals: Array<WholesaleTotalsByPriceType>;
};

export type HubOrderEdge = {
  node: Order;
};

export enum HubStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export enum HubStatusInput {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type HyperionAddress = {
  city?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

/** A Keycloak Identity Provider */
export type IdentityProvider = {
  alias: Scalars['String'];
};

/**
 * A Keycloak Identity Provider
 * alias - IdP id
 * acesUrl - Assertion consumer service url (url which should be redirected back to after logging into IdP)
 */
export type IdpConfig = {
  acsUrl: Scalars['String'];
  domain: Scalars['String'];
  enabled?: Maybe<Scalars['Boolean']>;
  entityId: Scalars['String'];
  sigCert: Scalars['String'];
  ssoLoginUrl: Scalars['String'];
};

export type IdpConfigConnection = {
  count: Scalars['Int'];
  edges?: Maybe<Array<IdpConfigEdge>>;
};

export type IdpConfigEdge = {
  node: IdpConfig;
};

export type Image = Node & {
  /** A Base64 Encoding of the image. The default size is 114x114 */
  base64Data?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  owner?: Maybe<ImageOwnerAccount>;
  url: Scalars['URL'];
};


export type Imagebase64DataArgs = {
  dimensions?: InputMaybe<ImageSize>;
};

export type ImageConnection = {
  edges: Array<ImageEdge>;
};

export type ImageEdge = {
  node: Image;
};

export type ImageOwnerAccount = Node & {
  id: Scalars['ID'];
};

export type ImageRemoved = {
  id: Scalars['ID'];
};

/**
 * All valid supported dimensions. For more info regarding dimensions see: https://jooraccess.atlassian.net/wiki/spaces/TECH/pages/17465352/Image+Resizing
 * Source: https://github.com/joor/aws-lambda/blob/master/src/imgixRedirect/constants.js
 */
export enum ImageSize {
  D_18x18W = 'D_18x18W',
  D_36x136W = 'D_36x136W',
  D_37x37W = 'D_37x37W',
  D_40x40W = 'D_40x40W',
  D_50x50 = 'D_50x50',
  D_50x50W = 'D_50x50W',
  D_50x50WF = 'D_50x50WF',
  D_56x56W = 'D_56x56W',
  D_56x75W = 'D_56x75W',
  D_65x65W = 'D_65x65W',
  D_82x112W = 'D_82x112W',
  D_84x112 = 'D_84x112',
  D_100x100W = 'D_100x100W',
  D_114x114W = 'D_114x114W',
  D_120x160W = 'D_120x160W',
  D_136x181W = 'D_136x181W',
  D_138x181W = 'D_138x181W',
  D_140x140 = 'D_140x140',
  D_150x150W = 'D_150x150W',
  D_150x150WF = 'D_150x150WF',
  D_152x88W = 'D_152x88W',
  D_165x112W = 'D_165x112W',
  D_165x225G2 = 'D_165x225G2',
  D_165x225W = 'D_165x225W',
  D_188x125W = 'D_188x125W',
  D_213x283W = 'D_213x283W',
  D_216x144W = 'D_216x144W',
  D_216x276 = 'D_216x276',
  D_220x300W = 'D_220x300W',
  D_220x300WC = 'D_220x300WC',
  D_222x222W = 'D_222x222W',
  D_222x222WF = 'D_222x222WF',
  D_250x300WC = 'D_250x300WC',
  D_330x450W = 'D_330x450W',
  D_345x470W = 'D_345x470W',
  D_400x70W = 'D_400x70W',
  D_400x10000C = 'D_400x10000C',
  D_424x238WC = 'D_424x238WC',
  D_450x600W = 'D_450x600W',
  D_472x348WC = 'D_472x348WC',
  D_494x238WC = 'D_494x238WC',
  D_498x664 = 'D_498x664',
  D_540x300W = 'D_540x300W',
  D_660x100W = 'D_660x100W',
  D_660x900WC = 'D_660x900WC',
  D_700x390W = 'D_700x390W',
  D_848x476GC = 'D_848x476GC',
  D_918x1236 = 'D_918x1236',
  D_1200x800W = 'D_1200x800W',
  D_1350x1406W = 'D_1350x1406W',
  D_1350x1406WF = 'D_1350x1406WF',
  D_1536x2048 = 'D_1536x2048',
  D_1650x2250W = 'D_1650x2250W'
}

export type ImagesUploaderProcessInput = {
  collectionId?: InputMaybe<Scalars['ID']>;
  customSorting?: InputMaybe<Array<Scalars['String']>>;
  fileNameParts?: InputMaybe<Array<UploaderFileNameParts>>;
  filePath?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['ID']>;
  onlyProductLevel?: InputMaybe<Scalars['Boolean']>;
  replace?: InputMaybe<Scalars['Boolean']>;
  separator?: InputMaybe<Scalars['String']>;
};

export type ImagesUploaderProcessPayload = {
  errorCode?: Maybe<Scalars['String']>;
};

export type ImportValidatedOrdersInput = {
  validatedOrdersIdentifier: Scalars['String'];
  validatedOrdersUrl: Scalars['String'];
};

export type ImportValidatedOrdersPayload = {
  importJobIdentifier?: Maybe<Scalars['String']>;
};

export type InProgressOrdersBuyer = {
  email: Scalars['String'];
  retailerAccountName: Scalars['String'];
};

export type InProgressOrdersSalesRep = {
  email: Scalars['String'];
};

export type InstagramAccount = {
  brandId: Scalars['ID'];
  expiresAt: Scalars['Date'];
  id: Scalars['ID'];
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type InstagramAccountFilters = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type InstagramAccountImages = {
  imageUrls: Array<Scalars['String']>;
  instagramAccountId: Scalars['ID'];
};

export type InterestedBrand = {
  brandId: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type InvalidSkuLineItem = {
  colorCode?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
  doorCode?: Maybe<Scalars['String']>;
  doorName?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  productIdentifier?: Maybe<Scalars['String']>;
  productNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sizeName?: Maybe<Scalars['String']>;
  skuIdentifier?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
  wholesalePrice?: Maybe<Scalars['String']>;
};

export enum InventoryAvailability {
  ALL = 'ALL',
  FUTURE_DATES = 'FUTURE_DATES',
  IMMEDIATE = 'IMMEDIATE'
}

export type InventoryAvailabilityGroup = Node & {
  availability: Availability;
  id: Scalars['ID'];
  /**
   * This field allows us to know if the Inventory Availability Group has
   * items and if a productId is passed it will tell us if it has items for
   * the product
   */
  isEmpty?: Maybe<Scalars['Boolean']>;
  items: InventoryItemConnection;
};


export type InventoryAvailabilityGroupisEmptyArgs = {
  productId?: InputMaybe<Scalars['ID']>;
};


export type InventoryAvailabilityGroupitemsArgs = {
  filter?: InputMaybe<InventoryItemsFilterInput>;
};

export type InventoryAvailabilityGroupConnection = {
  edges: Array<Maybe<InventoryAvailabilityGroupEdge>>;
};

export type InventoryAvailabilityGroupEdge = {
  node: InventoryAvailabilityGroup;
};

export type InventoryFilter = {
  availability?: InputMaybe<InventoryAvailability>;
  unitsRange?: InputMaybe<UnitRange>;
  warehouseIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type InventoryItem = Node & {
  availableQuantity: Scalars['Int'];
  id: Scalars['ID'];
  skuId: Scalars['ID'];
  submittedQuantity: Scalars['Int'];
};

export type InventoryItemConnection = {
  edges?: Maybe<Array<InventoryItemEdge>>;
};

export type InventoryItemEdge = {
  node: InventoryItem;
};

export type InventoryItemsFilterInput = {
  productIds: Array<Scalars['ID']>;
};

export type InventoryVisibilityGroupSettings = {
  applyToAllRetailers?: Maybe<Scalars['Boolean']>;
  applyToRetailerIds: Array<Scalars['ID']>;
  options?: Maybe<Array<InventoryVisibilityGroupSettingsOption>>;
};

export type InventoryVisibilityGroupSettingsOption = {
  field: Scalars['String'];
  value: Scalars['String'];
};

export type InventoryVisibilitySettings = {
  brandId: Scalars['ID'];
  groupSettings: Array<InventoryVisibilityGroupSettings>;
};

export type InviteEmailTriggerInput = {
  accountUserId: Scalars['ID'];
};

export type InviteEmailTriggerPayload = {
  success: Scalars['Boolean'];
};

export type InvoiceBrandDoorConnection = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type InvoiceData = {
  billingCity?: Maybe<Scalars['String']>;
  billingCompany?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingFirstAddress?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingSecondAddress?: Maybe<Scalars['String']>;
  billingState?: Maybe<Scalars['String']>;
  billingZip?: Maybe<Scalars['String']>;
  brand?: Maybe<AccountIdAndDisplayName>;
  collections?: Maybe<InvoiceOrderCollections>;
  deliveryComplete?: Maybe<Scalars['String']>;
  deliveryStart?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Float']>;
  door?: Maybe<InvoiceBrandDoorConnection>;
  financials?: Maybe<OrderFinancials>;
  id: Scalars['ID'];
  lastModifier?: Maybe<LastModifier>;
  /** @deprecated Get from financials */
  lineItems?: Maybe<LineItems>;
  modified: Scalars['Date'];
  /** @deprecated Get from paymentInfo */
  partialPaymentRequests?: Maybe<Array<PartialPaymentRequest>>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentMethod?: Maybe<InvoicePaymentMethodConnection>;
  priceType?: Maybe<InvoiceOrderPriceType>;
  referenceNumber?: Maybe<Scalars['String']>;
  retailer?: Maybe<AccountIdAndDisplayName>;
  salesRepresentative?: Maybe<SalesRepresentative>;
  seasonYear?: Maybe<OrderSeasonYear>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingCompany?: Maybe<Scalars['String']>;
  shippingCountry?: Maybe<Scalars['String']>;
  shippingEmail?: Maybe<Scalars['String']>;
  shippingFirstAddress?: Maybe<Scalars['String']>;
  shippingPhone?: Maybe<Scalars['String']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  shippingSecondAddress?: Maybe<Scalars['String']>;
  shippingState?: Maybe<Scalars['String']>;
  shippingZip?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  warehouse?: Maybe<InvoiceWarehouseConnection>;
  webOrderLookupId?: Maybe<Scalars['String']>;
};

export type InvoiceDelivery = {
  orderId: Scalars['ID'];
  sentOn: Scalars['Date'];
  sentTo: Scalars['String'];
};

export type InvoiceExportPaymentDetails = {
  dueDate: Scalars['String'];
  issuedDate: Scalars['String'];
  orderId: Scalars['ID'];
  paidAmount: Scalars['Float'];
};

export type InvoiceOrderCollectionEdge = {
  node?: Maybe<CollectionName>;
};

export type InvoiceOrderCollections = {
  edges?: Maybe<Array<InvoiceOrderCollectionEdge>>;
};

export type InvoiceOrderCurrency = {
  code?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  symbol?: Maybe<Scalars['String']>;
};

export type InvoiceOrderPriceType = {
  currency?: Maybe<InvoiceOrderCurrency>;
};

export type InvoiceParameter = {
  amount?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  billingAddress?: InputMaybe<Scalars['String']>;
  brandContactName?: InputMaybe<Scalars['String']>;
  brandName: Scalars['String'];
  brandUsername: Scalars['String'];
  currency?: InputMaybe<Scalars['String']>;
  customMessage?: InputMaybe<Scalars['String']>;
  customSubject?: InputMaybe<Scalars['String']>;
  destinationAccountId: Scalars['ID'];
  dueDate?: InputMaybe<Scalars['Date']>;
  isPartialPaymentRequest?: InputMaybe<Scalars['Boolean']>;
  language: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  orderBrandId: Scalars['ID'];
  orderId: Scalars['ID'];
  paymentName?: InputMaybe<Scalars['String']>;
  poNumber: Scalars['String'];
  retailerEmail?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  sentBcc?: InputMaybe<Array<Scalars['EmailAddress']>>;
  sentFrom: Scalars['String'];
  sentTo: Scalars['EmailAddress'];
  webOrderId: Scalars['ID'];
};

export type InvoicePaymentMethodConnection = {
  id?: Maybe<Scalars['String']>;
  paymentName?: Maybe<Scalars['String']>;
};

export type InvoiceWarehouseConnection = {
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ItemVisibility = {
  collectionProduct?: Maybe<CollectionProduct>;
  variantId?: Maybe<Scalars['ID']>;
  visible: Scalars['Boolean'];
};

export type JobMonitor = {
  createdAt?: Maybe<Scalars['Date']>;
  errorDetails?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  inputData?: Maybe<Scalars['JSON']>;
  inputFileUrl: Scalars['String'];
  jobId: Scalars['String'];
  outputData?: Maybe<Scalars['JSON']>;
  status: JobStatus;
  type: JobType;
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
};

export enum JobStatus {
  COMPLETED = 'COMPLETED',
  COMPLETED_WITH_ERRORS = 'COMPLETED_WITH_ERRORS',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum JobType {
  COLLECTIONS_UPSERT = 'COLLECTIONS_UPSERT',
  COLLECTION_PRODUCTS_DELETE = 'COLLECTION_PRODUCTS_DELETE',
  COLLECTION_PRODUCTS_UPSERT = 'COLLECTION_PRODUCTS_UPSERT',
  COLLECTION_SKU_DELIVERIES_UPSERT = 'COLLECTION_SKU_DELIVERIES_UPSERT',
  IMAGE_UPLOADER = 'IMAGE_UPLOADER',
  ORDER_IMPORT = 'ORDER_IMPORT',
  ORDER_STATUS_CHANGE = 'ORDER_STATUS_CHANGE',
  PRODUCTS_UPSERT = 'PRODUCTS_UPSERT',
  PRODUCT_PRICES_DELETE = 'PRODUCT_PRICES_DELETE',
  PRODUCT_PRICES_UPSERT = 'PRODUCT_PRICES_UPSERT',
  SKUS_UPSERT = 'SKUS_UPSERT',
  SKU_PRICES_DELETE = 'SKU_PRICES_DELETE',
  SKU_PRICES_UPSERT = 'SKU_PRICES_UPSERT',
  STYLE_UPLOADER = 'STYLE_UPLOADER',
  VA_CUSTOM_PRODUCT_UPLOADER = 'VA_CUSTOM_PRODUCT_UPLOADER',
  VA_IMAGE_UPLOADER = 'VA_IMAGE_UPLOADER',
  VA_ORDERS_ADD_AND_SYNC = 'VA_ORDERS_ADD_AND_SYNC',
  VA_PDF_EXPORT = 'VA_PDF_EXPORT'
}

export type JobsFilter = {
  jobIds?: InputMaybe<Array<Scalars['String']>>;
  jobTypes?: InputMaybe<Array<JobType>>;
};

/** A Keycloak User */
export type KeycloakUser = {
  email: Scalars['String'];
  federatedIdentities?: Maybe<Array<FederatedIdentity>>;
  /** User id on Keycloak */
  id: Scalars['ID'];
};

export type LGBrandCarried = Node & {
  accountId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LGBrandCarriedEdge = {
  node: LGBrandCarried;
};

export type LGBrandsCarriedConnection = {
  edges: Array<LGBrandCarriedEdge>;
  totalCount: Scalars['Int'];
};

export type LGBuyer = {
  isBuyer?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type LGBuyerInput = {
  isBuyer: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  name: Scalars['String'];
};

export type LGClienteleInfo = {
  age?: Maybe<Scalars['String']>;
  descriptions?: Maybe<Array<LGClienteleInfoBit>>;
  female?: Maybe<Scalars['Boolean']>;
  interests?: Maybe<Array<LGClienteleInfoBit>>;
  male?: Maybe<Scalars['Boolean']>;
};

export type LGClienteleInfoBit = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type LGClienteleInfoInput = {
  clienteleAge?: InputMaybe<Scalars['String']>;
  clienteleDescriptionIds?: InputMaybe<Array<Scalars['ID']>>;
  clienteleFemale?: InputMaybe<Scalars['Boolean']>;
  clienteleInterestIds?: InputMaybe<Array<Scalars['ID']>>;
  clienteleMale?: InputMaybe<Scalars['Boolean']>;
};

export enum LGConnectionStatus {
  CONNECTED = 'CONNECTED',
  PENDING_BRAND = 'PENDING_BRAND',
  PENDING_RETAILER = 'PENDING_RETAILER',
  UNCONNECTED = 'UNCONNECTED'
}

export type LGFindRetailersFilters = {
  brandsCarried?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['ID']>>;
  hideProspects?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LGRetailersLocationFilter>;
  retailerId?: InputMaybe<Scalars['ID']>;
  wholesalePriceRange?: InputMaybe<LGRetailersWholesalePriceRange>;
  yearsOrdered?: InputMaybe<Array<Scalars['Int']>>;
};

export type LGFindRetailersOrderBy = {
  field: LGFindRetailersOrderByField;
  order: LGFindRetailersOrderByOrder;
};

export enum LGFindRetailersOrderByField {
  PROFILE_NAME = 'PROFILE_NAME',
  PROFILE_SCORE = 'PROFILE_SCORE'
}

export enum LGFindRetailersOrderByOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type LGLocationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  carriedBrandIds?: InputMaybe<Array<Scalars['ID']>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  city: Scalars['String'];
  clienteleInfo?: InputMaybe<LGClienteleInfoInput>;
  country: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  isPrimaryLocation: Scalars['Boolean'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type: LocationType;
  wholesaleMax?: InputMaybe<Scalars['Int']>;
  wholesaleMin?: InputMaybe<Scalars['Int']>;
  yearEstablished?: InputMaybe<Scalars['Int']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type LGLogo = {
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type LGOtherUserBrands = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
  priceTypes: Array<Maybe<LGPriceType>>;
};

export type LGPriceType = Node & {
  currencyCode: Scalars['String'];
  currencyId: Scalars['String'];
  currencyName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum LGProfileCompleteness {
  EMPTY = 'EMPTY',
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  POOR = 'POOR'
}

export type LGProfileImage = {
  id: Scalars['ID'];
  upload?: Maybe<RetailerUpload>;
};

export type LGRequestConnectionData = {
  inviteMessage?: Maybe<Scalars['String']>;
  otherUserBrands: Array<Maybe<LGOtherUserBrands>>;
  parentCompany?: Maybe<Scalars['String']>;
  priceTypes: Array<Maybe<LGPriceType>>;
  termsConditions: Array<Maybe<LGTermsConditions>>;
};

export type LGRetailer = Node & {
  allRecipientsContacted: Scalars['Boolean'];
  autoConnect: Scalars['Boolean'];
  brandsOrdered?: Maybe<Array<Scalars['String']>>;
  connectionStatus: LGConnectionStatus;
  description?: Maybe<Scalars['String']>;
  hasBeenAwarded: Scalars['Boolean'];
  id: Scalars['ID'];
  location?: Maybe<LGRetailerLocation>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  submission?: Maybe<Submission>;
  submissionRecipients?: Maybe<Array<Scalars['ID']>>;
  submissions?: Maybe<SubmissionConnection>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type LGRetailersubmissionsArgs = {
  submissionsOrderBy?: InputMaybe<SubmissionsOrderBy>;
};

export type LGRetailerConnection = {
  edges: Array<LGRetailerEdge>;
  totalCount: Scalars['Int'];
};

export type LGRetailerEdge = {
  node: LGRetailer;
};

export type LGRetailerLocation = Node & {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  brandsCarried?: Maybe<Array<Scalars['String']>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LGRetailerProfile = {
  accountSubmission?: Maybe<Submission>;
  autoConnect?: Maybe<Scalars['Boolean']>;
  awards?: Maybe<Array<TradeShowAward>>;
  brandsOrdered?: Maybe<Array<Scalars['String']>>;
  buyer?: Maybe<LGBuyer>;
  categoriesOrdered?: Maybe<Array<Scalars['String']>>;
  connectionStatus?: Maybe<LGConnectionStatus>;
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<LGRetailerProfileLocation>>;
  logo?: Maybe<LGLogo>;
  name?: Maybe<Scalars['String']>;
  people?: Maybe<Array<PersonInformation>>;
  primaryLocation?: Maybe<LGRetailerProfileLocation>;
  privacy?: Maybe<Scalars['Boolean']>;
  profileCompleteness: LGProfileCompleteness;
  profileImages?: Maybe<Array<LGProfileImage>>;
  profileSnoozeCounter?: Maybe<Scalars['Int']>;
  public?: Maybe<Scalars['Boolean']>;
  socialMediaAccounts?: Maybe<Array<LGSocialMediaAccounts>>;
  taxId?: Maybe<Scalars['String']>;
  taxIdCountry?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  yearsOrdered?: Maybe<Array<Scalars['Int']>>;
};

export type LGRetailerProfileLocation = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  brandsCarried?: Maybe<Array<LGBrandCarried>>;
  categories?: Maybe<Array<ProductLine>>;
  city?: Maybe<Scalars['String']>;
  clienteleInfo?: Maybe<LGClienteleInfo>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** @deprecated Use categories instead */
  productLines: Array<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** @deprecated Use carriedBrands instead */
  topBrands: Array<Scalars['String']>;
  type?: Maybe<LocationType>;
  wholesaleRange?: Maybe<LGRetailerProfileWholesaleRange>;
  yearEstablished?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LGRetailerProfileWholesaleRange = {
  max?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['String']>;
};

export type LGRetailersLocationFilter = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type LGRetailersWholesalePriceRange = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type LGSocialMediaAccounts = {
  type: SocialMediaType;
  url: Scalars['String'];
};

export type LGTermsConditions = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LastModifier = {
  byAdmin: Scalars['Boolean'];
  email: Scalars['String'];
};

export type LatestBrandProfile = {
  accountMedia?: Maybe<Media>;
  categories: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LatestFavoriteBrandProfile = {
  accountMedia?: Maybe<Media>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LibraryValue = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LibraryValuesOrderBy = {
  field: LibraryValuesOrderByField;
  order?: InputMaybe<LibraryValuesOrdering>;
};

export enum LibraryValuesOrderByField {
  CREATION_DATE = 'CREATION_DATE',
  NAME = 'NAME'
}

export enum LibraryValuesOrdering {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

/**
 * A line item is a unit of transaction that represents a SKU, destination information, and a quantity.
 *
 * Represents an amount of an single SKU being delivered to a destination.
 */
export type LineItem = Node & {
  /** Information pertaining to the shipping location of this line item */
  destination?: Maybe<Destination>;
  id: Scalars['ID'];
  /** An amount of the SKU to send to the destination */
  quantity?: Maybe<Scalars['Int']>;
  /** The SKU for this line item */
  sku?: Maybe<SKUEdge>;
};

export type LineItemCollection = Node & {
  id: Scalars['ID'];
  ignoresInventory?: Maybe<Scalars['Boolean']>;
};

export type LineItemIdsPayload = {
  assortmentId: Scalars['ID'];
  lineItemIds: Array<Scalars['ID']>;
};

export type LineItems = {
  discountedPrice?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['String']>;
  totalRetailPrice?: Maybe<Scalars['String']>;
  totalUnits?: Maybe<Scalars['String']>;
};

export type Linesheet = {
  items: LinesheetItemConnection;
};

export type LinesheetItemConnection = {
  edges?: Maybe<LinesheetItemEdge>;
};

export type LinesheetItemEdge = {
  node?: Maybe<SKU>;
};

export type ListAccountColorSwatchesFilterBy = {
  colorName?: InputMaybe<Scalars['String']>;
  onlyStylesMissingSwatch?: InputMaybe<Scalars['Boolean']>;
};

export type ListAccountColorSwatchesInput = {
  collectionIds: Array<Scalars['ID']>;
  endRow?: InputMaybe<Scalars['Int']>;
  filterBy?: InputMaybe<ListAccountColorSwatchesFilterBy>;
  orderBy?: InputMaybe<ListAccountColorSwatchesOrderBy>;
  seasonIds: Array<Scalars['ID']>;
  startRow?: InputMaybe<Scalars['Int']>;
};

export enum ListAccountColorSwatchesOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ListAccountColorSwatchesOrderBy = {
  field?: InputMaybe<ListAccountColorSwatchesOrderField>;
  order?: InputMaybe<ListAccountColorSwatchesOrder>;
};

export enum ListAccountColorSwatchesOrderField {
  NAME = 'NAME',
  STYLE_COUNT = 'STYLE_COUNT',
  SWATCH_COUNT = 'SWATCH_COUNT'
}

export type ListAccountColorSwatchesPayload = {
  colorSwatches: Array<ColorSwatchAgg>;
};

export type ListAccountConnectionPriceTypeInput = {
  brandId: Scalars['String'];
  retailerId: Scalars['String'];
};

export type ListConnectedBrandsFilter = {
  accountStatuses?: InputMaybe<Array<AccountStatus>>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type ListConnectionBuyersInput = {
  retailerId: Scalars['ID'];
};

export type ListConnectionDiscountInput = {
  retailerId: Scalars['ID'];
};

export type ListConnectionDoorsInput = {
  retailerId: Scalars['ID'];
};

export type ListConnectionPaymentMethodsInput = {
  retailerId: Scalars['ID'];
};

export type ListConnectionPriceTypeInput = {
  orderId?: InputMaybe<Scalars['ID']>;
  retailerId: Scalars['ID'];
};

export type ListConnectionSalesRepInput = {
  retailerId: Scalars['ID'];
};

export type ListConnectionShippingMethodsInput = {
  retailerId: Scalars['ID'];
};

export type ListConnectionWarehousesInput = {
  retailerId: Scalars['ID'];
};

export type ListLatestBrandsFilter = {
  /**
   * This is a BrandProductLine.id list associated
   * to a Brand. 'eg: Category: 3'.
   * This is an 'AND' filter.
   */
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListMonitoringJobsPayload = {
  jobs?: Maybe<Array<JobMonitor>>;
};

export type ListMonitoringJobsRequest = {
  filter?: InputMaybe<JobsFilter>;
};

export type ListOrderExportTasksInput = {
  ids: Array<Scalars['String']>;
};

export type ListOrderExportTasksPayload = {
  exportTasks: Array<OrderExportTasks>;
};

export type ListPriceRangeGroupsFilter = {
  /**
   * Style colors excluded from these collections are ignored when calculating
   * the price ranges
   */
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  orderIds?: InputMaybe<Array<Scalars['ID']>>;
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  withCasepacks?: InputMaybe<Scalars['Boolean']>;
  withInactive?: InputMaybe<Scalars['Boolean']>;
};

export type ListStylesColorSwatchInput = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  colorCode: Scalars['String'];
  colorName: Scalars['String'];
  endRow?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ListStylesColorSwatchOrderBy>;
  seasonIds?: InputMaybe<Array<Scalars['ID']>>;
  startRow?: InputMaybe<Scalars['Int']>;
};

export enum ListStylesColorSwatchOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ListStylesColorSwatchOrderBy = {
  field?: InputMaybe<ListStylesColorSwatchOrderField>;
  order?: InputMaybe<ListStylesColorSwatchOrder>;
};

export enum ListStylesColorSwatchOrderField {
  COLOR_VISIBILITY = 'COLOR_VISIBILITY',
  STYLE_NUMBER = 'STYLE_NUMBER'
}

export type ListStylesColorSwatchPayload = {
  stylesColorSwatch: Array<StyleColorSwatch>;
};

export type ListUnmatchedUploadsFilters = {
  mediaType?: InputMaybe<MediaType>;
  searchFileName?: InputMaybe<Scalars['String']>;
};

export type ListUnmatchedUploadsInput = {
  collectionId: Scalars['ID'];
  filters?: InputMaybe<ListUnmatchedUploadsFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ListUnmatchedUploadsPayload = {
  totalCount?: Maybe<Scalars['Int']>;
  uploads: Array<UnmatchedUpload>;
};

export type LiteBrandInput = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  primaryContactEmailAddress: Scalars['String'];
  primaryContactFullName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storeName: Scalars['String'];
  taxId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type LiteBrandPayload = {
  address?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  postalCode?: Maybe<Scalars['String']>;
  primaryContactFullName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storeName: Scalars['String'];
};

export type Location = {
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  carriedBrands?: Maybe<Array<CarriedBrand>>;
  categories?: Maybe<Array<ProductLine>>;
  city?: Maybe<Scalars['String']>;
  clienteleInfo?: Maybe<ClienteleInfo>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPrimaryLocation: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** @deprecated Use categories instead */
  productLines: Array<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** @deprecated Use carriedBrands instead */
  topBrands: Array<Scalars['String']>;
  type?: Maybe<LocationType>;
  wholesaleMax?: Maybe<Scalars['String']>;
  wholesaleMin?: Maybe<Scalars['String']>;
  yearEstablished?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LocationInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  carriedBrands?: InputMaybe<Array<Scalars['ID']>>;
  categories?: InputMaybe<Array<Scalars['ID']>>;
  city: Scalars['String'];
  clienteleInfo?: InputMaybe<ClienteleInfoInput>;
  country: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  isPrimaryLocation: Scalars['Boolean'];
  name: Scalars['String'];
  nonJoorCarriedBrands?: InputMaybe<Array<Scalars['String']>>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  type: LocationType;
  wholesaleMax?: InputMaybe<Scalars['String']>;
  wholesaleMin?: InputMaybe<Scalars['String']>;
  yearEstablished?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum LocationType {
  OFFICE = 'OFFICE',
  STORE = 'STORE'
}

export type Look = Node & {
  id: Scalars['ID'];
  items: Array<ItemVisibility>;
  layout: Scalars['String'];
  media: Array<LookMedia>;
  textContents: Array<LookTextContent>;
};

export type LookConnection = {
  edges?: Maybe<Array<LookEdge>>;
  pageInfo: PageInfo;
};

export type LookEdge = {
  cursor: Scalars['String'];
  node: Look;
};

export type LookItemConnection = {
  collectionId: Scalars['ID'];
  productId: Scalars['ID'];
  variantId?: InputMaybe<Scalars['ID']>;
};

export type LookMedia = {
  id: Scalars['ID'];
  streamingUrl: Scalars['String'];
  type: LookMediaType;
  url: Scalars['String'];
};

export enum LookMediaType {
  IMAGE = 'IMAGE',
  STREAMING = 'STREAMING',
  VIDEO = 'VIDEO'
}

export type LookTextContent = {
  content: Scalars['String'];
  layoutKey: Scalars['String'];
  presentation: Scalars['String'];
};

export type LookTextContentInput = {
  content: Scalars['String'];
  layoutKey: Scalars['String'];
  presentation: Scalars['String'];
};

export type Lookbook = Node & {
  brandId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  notifiedConnections?: Maybe<Scalars['Boolean']>;
  pdfName?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type LookbookConnection = {
  edges?: Maybe<Array<LookbookEdge>>;
};

export type LookbookEdge = {
  node: Lookbook;
};

export type ManageImagesStyleColor = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageId?: Maybe<Scalars['ID']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  swatch?: Maybe<SwatchImage>;
};

export type ManageImagesStyleFabrication = {
  code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ManageImagesStyleImage = {
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  url: Scalars['String'];
};

export type ManageImagesStyleSilhouette = {
  code?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export enum ManualPaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CASH = 'CASH',
  CHECK = 'CHECK',
  CREDIT_CARD = 'CREDIT_CARD',
  CREDIT_MEMO = 'CREDIT_MEMO',
  INVOICE_FACTORING = 'INVOICE_FACTORING',
  OTHER = 'OTHER',
  WIRE = 'WIRE'
}

export type ManualPaymentRecord = {
  amount: Scalars['Float'];
  brandId: Scalars['ID'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  paymentDate?: Maybe<Scalars['Date']>;
  paymentMethod: ManualPaymentMethod;
  recordedBy?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['ID']>;
};

export type MarkAssortmentVisitedInput = {
  assortmentId: Scalars['ID'];
};

export type MarkAssortmentVisitedPayload = {
  assortment: Assortment;
};

export type Material = {
  name: Scalars['String'];
};

/** Used to reperesent Media such as images and videos */
export type Media = {
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  urlThumbnail?: Maybe<Scalars['String']>;
};

export enum MediaType {
  IMAGE = 'IMAGE',
  UNKNOWN = 'UNKNOWN',
  VIDEO = 'VIDEO'
}

export type MembershipInvite = Node & {
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  invitedEmail: Scalars['String'];
  invitedUser?: Maybe<User>;
  invitingAccount: AccountProfile;
  invitingUser: User;
  status?: Maybe<UserMembershipInviteStatus>;
};

export type MembershipInvitePayload = {
  membershipInvite?: Maybe<MembershipInvite>;
};

export type MerchandisingHierarchyFilter = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MerchandisingHierarchyNode>;
};

export type MerchandisingHierarchyFilterConnection = {
  edges?: Maybe<Array<MerchandisingHierarchyFilter>>;
};

export type MerchandisingHierarchyLevel = Node & {
  /** A unique identifier */
  code: Scalars['String'];
  /** The numeric depth of this level */
  depth: Scalars['String'];
  id: Scalars['ID'];
  /** Display name */
  name: Scalars['String'];
};

export type MerchandisingHierarchyLevelEdge = {
  node?: Maybe<MerchandisingHierarchyLevel>;
};

/** Representation of a node withing a retailer's merchandising organization. */
export type MerchandisingHierarchyNode = Node & {
  /** A unique identifier */
  code: Scalars['String'];
  id: Scalars['ID'];
  /** The merchandising hierarchy level */
  level?: Maybe<MerchandisingHierarchyLevelEdge>;
  /** A display name */
  name: Scalars['String'];
  parent?: Maybe<MerchandisingHierarchyNodeEdge>;
};

export type MerchandisingHierarchyNodeConnection = {
  edges: Array<MerchandisingHierarchyNodeEdge>;
};

export type MerchandisingHierarchyNodeEdge = {
  node?: Maybe<MerchandisingHierarchyNode>;
};

export type MergeAccountsInput = {
  accountIds: Array<Scalars['ID']>;
  targetAccountId: Scalars['ID'];
};

export type MergeAccountsPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type MergeOrderBulkLineItemInfo = {
  variantId: Scalars['ID'];
};

export type MergeOrderCasepackLineItemInfo = {
  casepackId: Scalars['ID'];
};

export type MergeOrderInput = {
  orders: Array<MergedOrderInfo>;
  targetOrderId: Scalars['ID'];
};

export type MergeOrderSkuLineItemInfo = {
  skuId: Scalars['ID'];
};

export type MergeOrdersPayload = {
  success: Scalars['Boolean'];
};

export type MergedOrderInfo = {
  bulkLineItems: Array<MergeOrderBulkLineItemInfo>;
  casepackLineItems: Array<MergeOrderCasepackLineItemInfo>;
  id: Scalars['ID'];
  skuLineItems: Array<MergeOrderSkuLineItemInfo>;
};

export type MergingAccountCriteriaPayload = {
  ids: Array<Scalars['String']>;
};

export type MergingOrderCriteriaPayload = {
  message: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Message = {
  /** ID of sender account */
  accountId: Scalars['ID'];
  attachment?: Maybe<Media>;
  body: Scalars['String'];
  id: Scalars['ID'];
  messageType?: Maybe<MessageType>;
  /** ID of message sent immediately previous to this message */
  parentId?: Maybe<Scalars['ID']>;
  subject: Scalars['String'];
  /** ID of first message in thread sent between accounts */
  threadId: Scalars['ID'];
};

export type MessageCount = {
  count: Scalars['Int'];
};

export type MessageSubmissionThreadInput = {
  messageId: Scalars['ID'];
};

export type MessageSubmissionThreadPayload = {
  activityCreated: Scalars['Boolean'];
};

export enum MessageType {
  INVITATION = 'INVITATION',
  MESSAGE = 'MESSAGE'
}

export type Money = {
  currencyCode: Scalars['String'];
  value: Scalars['Decimal'];
};

export type MoveToRetailWorkspaceInput = {
  /** The assortment to move to a retail workspace */
  assortmentId: Scalars['ID'];
  /** The id of the retail workspace to move the assortment to */
  retailWorkspaceId?: InputMaybe<Scalars['ID']>;
  /** Season to assign to the moved assortment, overriding the existing season */
  seasonId?: InputMaybe<Scalars['ID']>;
};

export type Mutation = {
  AssortmentUI__assignProductColorImage?: Maybe<UploadColorImage>;
  AssortmentUI__bulkAddColorsToAssortmentProduct: AssortmentUI__BulkAddColorsToAssortmentProductResponse;
  AssortmentUI__bulkCreateAssortmentProduct: AssortmentUI__bulkCreateAssortmentProductResponse;
  AssortmentUI__createConfiguration?: Maybe<Configuration>;
  AssortmentUI__createRetailerExclusiveSku?: Maybe<AssortmentUI__CreateRetailerExclusiveSkuResponse>;
  AssortmentUI__deleteConfiguration?: Maybe<DeletePayload>;
  AssortmentUI__deleteSkuColorsForAssortment?: Maybe<AssortmentUI__Assortment>;
  AssortmentUI__removeProductImage?: Maybe<ImageRemoved>;
  AssortmentUI__updateConfiguration?: Maybe<Configuration>;
  AssortmentUI__updateRetailerExclusiveSku?: Maybe<AssortmentUI__UpdateRetailerExclusiveSkuResponse>;
  AssortmentUI__updateRowColorBulk: AssortmentUI_RowColorBulkQuantities;
  AssortmentUI__updateRowSizeBulk: AssortmentUI_RowSizeBulkQuantities;
  AssortmentUI__uploadProductColorImage?: Maybe<UploadColorImage>;
  AssortmentUI__uploadProductImage?: Maybe<UploadItemImage>;
  AssortmentUI__uploadSwatchImage?: Maybe<UploadSwatchImage>;
  UpdateRetailerPrimaryAccount: UpdateRetailerPrimaryAccount;
  _empty?: Maybe<Scalars['String']>;
  acceptRequestConnection: AcceptRequestConnectionPayload;
  acceptUserMembershipRequest: AcceptUserMembershipRequestPayload;
  acknowledgeRecentlyCreatedAccounts: AcknowledgeRecentlyCreatedAccountIdsPayload;
  addAssortmentDoors: AddAssortmentDoorsPayload;
  addColorsToAssortment: AddColorsToAssortmentPayload;
  addInventoryAvailabilityGroup: AddInventoryAvailabilityGroupPayload;
  /** Adds orders to the Visual Assortment sync queue. */
  addOrdersToVisualAssortment: AddOrdersToVisualAssortmentResponse;
  addProductsToOrders: AddProductsToOrdersPayload;
  addSkusToAssortment: AddSkusToAssortmentPayload;
  addStyleboardComment: StyleboardComment;
  addUnitsInProgress: AddUnitsInProgressPayload;
  addVariantsInProgress: AddVariantsInProgressPayload;
  anonymousCreateReachPayment: CreateReachPaymentPayload;
  anonymousUpdatePayment: UpdatePaymentPayload;
  appSubscriptionCancel: AppSubscriptionCancelPayload;
  applyAssortmentSkuColorAttributes: ApplyAssortmentSkuColorAttributesPayload;
  applySizeCurveToDoorColors: ApplySizeCurveToDoorColorsResponse;
  assignProductColorImage?: Maybe<AssignProductColorImageResult>;
  assignStyleColorSwatch: AssignStyleColorSwatchPayload;
  /** Move an assortment to a new retail workspace */
  assortmentMoveToRetailWorkspace?: Maybe<RetailWorkspacePayload>;
  /**
   * Asynchronously adds orders to a Visual Assortment and syncs them.
   * Returns a job ID that can be used to track the progress of the operation.
   */
  asyncAddOrdersToVisualAssortment: AsyncAddOrdersToVisualAssortmentResponse;
  /** Starts a PDF export. Poll listMonitoringJobs with the returned jobId for the status and download URL. */
  asyncExportVisualAssortmentPdf: AsyncExportVisualAssortmentPdfResponse;
  bulkAddColorsToAssortmentProduct: BulkAddColorsToAssortmentProductResponse;
  bulkAddProductsAndSkusToCollections: BulkAddProductsAndSkusToCollectionsPayload;
  bulkAddProductsToCollection: BulkAddProductsToCollectionPayload;
  bulkAddProductsToInventoryAvailabilityGroup: BulkAddProductsToInventoryAvailabilityGroupPayload;
  bulkAddWarehouses: BulkAddWarehousesPayload;
  bulkCancelOrdersVariants: BulkCancelOrdersVariantsPayload;
  bulkCopyOrders: BulkCopyOrdersPayload;
  bulkCreateAssortmentProduct: BulkCreateAssortmentProductResponse;
  bulkCreateCollaborationInvites: BulkCreateCollaborationInvitesPayload;
  bulkCreateCollaborationInvitesToAccounts: BulkCreateCollaborationInvitesPayload;
  bulkCreateCollectionGroups: BulkCreateCollectionGroupsPayload;
  bulkCreateCollections: BulkCreateCollectionsPayload;
  bulkCreateProducts: BulkCreateProductsPayload;
  bulkCreateSkuTraitValues: BulkCreateSkuTraitValuesPayload;
  bulkCreateUserMembershipRequests: BulkCreateUserMembershipRequestsPayload;
  bulkDeleteCollectionGroups: BulkDeleteCollectionGroupsPayload;
  bulkDeleteCollections: BulkDeleteCollectionsPayload;
  bulkDeleteDataPermissionConfigurations: BulkDeleteDataPermissionConfigurationsPayload;
  bulkDeleteExternalProviderAuths: BulkDeleteExternalProviderAuthsPayload;
  bulkDeleteProducts: BulkDeleteProductsPayload;
  bulkDeleteProductsFromAvailabilityGroup: BulkDeleteProductsFromAvailabilityGroupPayload;
  bulkDeleteRetailerLocations: BulkDeleteRetailerLocations;
  /** DELETE OPERATIONS */
  bulkDeleteRetailerUploads: BulkDeleteRetailerUploads;
  bulkDeleteWarehouses: BulkDeleteWarehousesPayload;
  bulkDuplicateCollections: BulkDuplicateCollectionsPayload;
  bulkMarkInventoryAvailabilityGroupsAsReceived: BulkMarkInventoryAvailabilityGroupsAsReceivedPayload;
  bulkMarkOrdersAsExported: BulkMarkOrdersAsExportedPayload;
  bulkRemoveProductsAndSkusFromCollections: BulkRemoveProductsAndSkusFromCollectionsPayload;
  bulkRemoveUnmatchedUploads: BulkRemoveUnmatchedUploadsPayload;
  bulkReplaceOrdersVariant: BulkReplaceOrdersVariantPayload;
  bulkScheduleForExport: BulkScheduleForExportPayload;
  bulkSetCollectionsDelivery: BulkSetCollectionsDeliveryPayload;
  bulkSetOrdersToReexport: BulkSetOrdersToReexportPayload;
  bulkSetProductsTraitValues: BulkSetProductsTraitValuesPayload;
  bulkSetSkuItemProperties: BulkSetSkuItemPropertiesPayload;
  bulkSetSkuUpcs: BulkSetSkuUpcsPayload;
  /** Trigger style import in bulk */
  bulkStyleImport: BulkStyleImportPayload;
  bulkUnscheduleForExport: BulkUnscheduleForExportPayload;
  bulkUpdateAccountsPrivacy: BulkUpdateAccountsPrivacyPayload;
  bulkUpdateAssortmentDetails: BulkUpdateAssortmentDetailsPayload;
  bulkUpdateCollectionGroups: BulkUpdateCollectionGroupsPayload;
  bulkUpdateCollectionProducts?: Maybe<BulkUpdateCollectionProductsPayload>;
  bulkUpdateCollections: BulkUpdateCollectionsPayload;
  bulkUpdateCollectionsPosition: BulkUpdateCollectionsPositionPayload;
  bulkUpdateCollectionsPublic: BulkUpdateCollectionsPublicPayload;
  bulkUpdateInventoryItems: BulkUpdateInventoryItemsPayload;
  bulkUpdateOrderPricingByFilters: BulkUpdateOrderPricingByFiltersPayload;
  bulkUpdateOrderPricingByIds: BulkUpdateOrderPricingByIdsPayload;
  bulkUpdateOrderSalesRepByFilters: BulkUpdateOrderSalesRepByFiltersPayload;
  bulkUpdateOrderStatus: BulkUpdateOrderStatusPayload;
  bulkUpdateOrderStatusAsync: BulkUpdateOrderStatusAsyncPayload;
  bulkUpdateProducts: BulkUpdateProductsPayload;
  bulkUpdateRetailerGoogleAddresses: BulkUpdateRetailerGoogleAddressesPayload;
  bulkUpdateSkuTraitValues: BulkUpdateSkuTraitValuesPayload;
  bulkUpdateStorefronts: Array<Storefront>;
  bulkUpdateUserFavoriteCollections: BulkUpdateUserFavoriteCollectionsPayload;
  bulkUpdateWarehouses: BulkUpdateWarehousesPayload;
  bulkUpsertOrderEvents: BulkUpsertOrderEventsPayload;
  /** UPDATE OPERATIONS */
  bulkUpsertRetailerLocations: BulkUpsertRetailerLocations;
  bulkUpsertRetailerUploads: BulkUpsertRetailerUploadsPayload;
  bulkUpsertSkuExternalIdentifiers: BulkUpsertSkuExternalIdentifiersPayload;
  completeShopifyInstallation: CompleteShopifyInstallationPayload;
  completeShopifyInstallationForEmbeddedApps: CompleteShopifyInstallationForEmbeddedAppsPayload;
  /** Connect accounts creating a ticket in Jira for JDT to handle. */
  connectAccountsThroughJira: ConnectAccountsThroughJiraPayload;
  connectPaymentProvider: AccountPaymentProvider;
  copyAssortments: CopyAssortmentsPayload;
  createAccountUser: CreateAccountUserPayload;
  createAchPayment: PaymentPayload;
  createAssortment: CreateAssortmentPayload;
  createAssortmentWithColors: CreateAssortmentPayload;
  createAssortmentsExportRecord: CreateAssortmentsExportRecordPayload;
  createAttribute: CreateAttributePayload;
  createAttributeOption: CreateAttributeOptionPayload;
  createAttributeOptionRuleForPriceModifier: CreateAttributeOptionRuleForPriceModifierPayload;
  createBrandDoor: CreateBrandDoorPayload;
  createBrandRuleForPriceModifier: CreateBrandRuleForPriceModifierPayload;
  createCollaborationInvite: CreateCollaborationInvitePayload;
  createCollectionBanners: CreateCollectionBannersPayload;
  createConfiguration?: Maybe<Configuration>;
  createConnectionBuyers?: Maybe<ConnectionBuyersPayload>;
  createConnectionDiscounts?: Maybe<ConnectionDiscountsPayload>;
  createConnectionDoors: Array<ConnectionDoor>;
  createConnectionPaymentMethods: Array<ConnectionPaymentMethod>;
  createConnectionPriceTypes?: Maybe<ConnectionPriceTypesPayload>;
  createConnectionSalesReps?: Maybe<ConnectionSalesRepsPayload>;
  createConnectionShippingMethods: Array<ConnectionShippingMethod>;
  createConnectionWarehouses: Array<ConnectionWarehouse>;
  createCustomAssortment: CreateAssortmentPayload;
  createCustomProductsFromSheet?: Maybe<CreateCustomProductsFromSheetsResponse>;
  createCustomerPortalLink: Scalars['String'];
  createDataPermissionConfiguration: CreateDataPermissionConfigurationPayload;
  createEvent?: Maybe<LibraryValue>;
  createExportIntegrationConfig: ExportIntegrationConfig;
  createExternalPayment: ExternalPayment;
  createExternalProviderAuth: ExternalProviderAuth;
  createFavoriteAccount: Favorite;
  createIdentityProvider?: Maybe<CreateIdentityProviderPayload>;
  createInProgressOrdersWithUnits: CreateInProgressOrdersWithUnitsPayload;
  createInvoices: Array<OrderInvoice>;
  createJob: CreateJobPayload;
  createManualPaymentRecord: ManualPaymentRecord;
  createMerchandisingHierarchyNode: CreateMerchandisingHierarchyNodePayload;
  createMerchandisingHierarchyRuleForPriceModifier: CreateMerchandisingHierarchyRuleForPriceModifierPayload;
  createMessage: Message;
  /** Create a new retail workspace with a single empty assortment */
  createNewRetailWorkspace: RetailWorkspacePayload;
  createOrderFromAssortment: CreateOrderFromAssortmentPayload;
  createOrphanInProgressOrdersWithUnits: CreateOrphanInProgressOrdersWithUnitsPayload;
  createOrphanRetailer?: Maybe<OrphanRetailer>;
  createPayment: PaymentPayload;
  createPaymentWithPaymentMethod: PaymentPayload;
  createRawOrdersExport: CreateRawOrdersExportPayload;
  createReachPayment: CreateReachPaymentPayload;
  createRegion: Region;
  /** Convert a bare assortment to a new retail workspace */
  createRetailWorkspace: RetailWorkspacePayload;
  createSeason: CreateSeasonPayload;
  createSepaPayment: PaymentPayload;
  createSkuPrices: BulkCreateSkuPricesPayload;
  createStripeProductLink: Scalars['String'];
  createSubmissionTemplate: SubmissionTemplate;
  createUser: CreateUserPayload;
  createUserMembershipInvite: MembershipInvitePayload;
  /** Creates a custom Visual Assortment Attribute Key (type) for the current access. */
  createVisualAssortmentAttributeKey: CreateVisualAssortmentAttributeKeyResponse;
  /** Creates Visual Assortment Attribute Values for the current Visual Assortment Account Access. */
  createVisualAssortmentAttributeValues: CreateVisualAssortmentAttributeValuesResponse;
  /** Creates a Visual Assortment Budget. */
  createVisualAssortmentBudget: VisualAssortmentBudget;
  deleteAchBankAccount: DeletePaymentMethodPayload;
  deleteCollectionBanners: DeleteCollectionBannersPayload;
  deleteConfiguration?: Maybe<DeletePayload>;
  deleteConnectionBuyers?: Maybe<ConnectionBuyersPayload>;
  deleteConnectionDiscounts?: Maybe<DeleteConnectionDiscountsResponse>;
  deleteConnectionDoors: Array<Scalars['ID']>;
  deleteConnectionPaymentMethods: Array<Scalars['ID']>;
  deleteConnectionPriceTypes?: Maybe<DeleteConnectionPriceTypesResponse>;
  deleteConnectionSalesReps?: Maybe<DeleteConnectionSalesRepsResponse>;
  deleteConnectionShippingMethods: Array<Scalars['ID']>;
  deleteConnectionWarehouses: Array<Scalars['ID']>;
  deleteExportIntegrationConfigs?: Maybe<DeletePayload>;
  /** This mutation is used to soft delete external payments. */
  deleteExternalPayment: DeleteExternalPaymentPayload;
  deleteFavoriteAccount?: Maybe<DeletePayload>;
  deleteIdentityProvider?: Maybe<DeleteIdentityProviderPayload>;
  deleteManualPaymentRecord?: Maybe<DeleteManualPaymentRecordPayload>;
  deleteOrderLineItems?: Maybe<DeleteOrderLineItemsPayload>;
  deleteOrderVariants?: Maybe<DeleteOrderVariantsPayload>;
  deletePaymentMethod: DeletePaymentMethodPayload;
  deleteRegion?: Maybe<DeletePayload>;
  deleteShowroomCollections: Array<DeleteShowroomCollectionPayload>;
  deleteStorefronts: DeleteStorefrontsPayload;
  deleteStyleboards: Array<DeleteStyleboardPayload>;
  deleteSubmissionTemplate: SubmissionTemplateId;
  deleteUnavailableProducts: deleteUnavailableProductsPayload;
  deleteUrl3dShowroom: DeleteUrl3dShowroomPayload;
  /**
   * Deletes a custom Visual Assortment Attribute Key and cascades to its values
   * and card assignments. System keys cannot be deleted.
   */
  deleteVisualAssortmentAttributeKey: DeleteVisualAssortmentAttributeKeyResponse;
  /** Deletes Visual Assortment Attribute Values for the current Visual Assortment Account Access. */
  deleteVisualAssortmentAttributeValues: DeleteVisualAssortmentAttributeValuesResponse;
  /** Deletes Visual Assortment Cards. */
  deleteVisualAssortmentCards: DeleteVisualAssortmentCardsResponse;
  downloadCustomProductsSheetTemplate: DownloadCustomProductsSheetTemplate;
  /** Edits Visual Assortment Cards information and moves them between groups. */
  editVisualAssortmentCards: EditVisualAssortmentCardsResponse;
  /** Exports the Visual Assortment to CSV. Returns a download URL for the generated file. */
  exportVisualAssortment: ExportVisualAssortmentResponse;
  /** Exports a Visual Assortment Budget. Returns a download URL for the generated file. */
  exportVisualAssortmentBudget: ExportVisualAssortmentBudgetResponse;
  /** Generates the Basic Style Uploader file */
  generateBSUTemplate: GenerateBSUTemplatePayload;
  generateSummaryFile?: Maybe<GenerateSummaryFilePayload>;
  genericSetPriceModifierValue: Array<SetPriceModifierValuePayload>;
  getOrCreatePendingUsers: GetOrCreatePendingUsersPayload;
  getShowroomCollectionTokenizedLink: ShowroomCollectionTokenizedLink;
  handleRemoveAccountUser?: Maybe<HandleRemoveAccountUserPayload>;
  /** Trigger the async task to process self serve images */
  imagesUploaderProcess: ImagesUploaderProcessPayload;
  importValidatedOrders?: Maybe<ImportValidatedOrdersPayload>;
  inviteEmailTrigger: InviteEmailTriggerPayload;
  /**
   * Marks a shared assortment as having been visited
   * @deprecated Sharing no longer supported
   */
  markAssortmentVisited: MarkAssortmentVisitedPayload;
  mergeAccounts: MergeAccountsPayload;
  mergeOrders: MergeOrdersPayload;
  messageSubmissionThread: MessageSubmissionThreadPayload;
  public: PublicMutation;
  reassignConnections: ReassignConnectionsPayload;
  /** Removes door clusters from an assortment */
  removeAssortmentDoorClusters: RemoveAssortmentDoorClustersPayload;
  /** Removes doors from an assortment */
  removeAssortmentDoors: RemoveAssortmentDoorsPayload;
  removeAssortmentSkuColorAttributes: RemoveAssortmentSkuColorAttributesPayload;
  /** Removes orders from the Visual Assortment sync queue. */
  removeOrdersFromVisualAssortment: RemoveOrdersFromVisualAssortmentResponse;
  removeSelectedAssortmentAttributeOptions: RemoveSelectedAssortmentAttributeOptionsPayload;
  /** Removes users from the current Visual Assortment Account access. */
  removeVisualAssortmentAccessUsers: RemoveVisualAssortmentAccessUsersResponse;
  replySubmission: ReplySubmissionPayload;
  requestAssortmentOrderUpdate: RequestAssortmentOrderUpdatePayload;
  requestConnectionToRetailer: Array<RequestConnectionToRetailerPayload>;
  resetPaymentRecords?: Maybe<ResetPaymentRecordsPayload>;
  saveAchBankAccount: BankAccount;
  saveCreditCard: CreditCard;
  saveMethodAndCreatePayment: PaymentPayload;
  saveProductImages: SaveProductImagesPayload;
  saveUnmatchedUpload: SaveUnmatchedUploadPayload;
  /** Find the styles most similar to a text, existing styles and/or uploaded photos. A mutation because it accepts uploads; it changes nothing. */
  searchSimilarStyles: SearchSimilarStylesPayload;
  sendCollectionsToConnections: SendCollectionsToConnectionsPayload;
  sendEmailConfirmation: SendEmailConfirmationPayload;
  sendInvoicesForOrders?: Maybe<Array<Maybe<InvoiceDelivery>>>;
  sendJoorPayImInterestedEmail: SendJoorPayImInterestedEmailPayload;
  sendMessageToConnection: SendMessageToConnectionPayload;
  sendPayment: PaymentDelivery;
  sendStyleboardsToEmails: SendStyleboardsToEmailsPayload;
  sendSubmission: Submission;
  setAssortmentColorBulkDoorQuantity?: Maybe<SetAssortmentColorBulkDoorQuantityPayload>;
  /** Creates or updates the fields of a Assortment Currency object */
  setAssortmentCurrencyConversion: Array<SetAssortmentCurrencyConversionPayload>;
  setAssortmentDefaultDoorClusters: SetAssortmentDefaultDoorClustersPayload;
  /** Creates or updates door clusters in an assortment */
  setAssortmentDoorClusters: SetAssortmentDoorClustersPayload;
  setAssortmentDoors: SetAssortmentDoorsPayload;
  setAssortmentMerchandisingHierarchy: SetAssortmentMerchandisingHierarchyPayload;
  setAssortmentProductRetailPrice: SetAssortmentProductPricePayload;
  setAssortmentProductWholesalePrice: SetAssortmentProductWholesalePricePayload;
  /**
   * Set the users that the assortment should be shared to
   * @deprecated Sharing no longer supported
   */
  setAssortmentShares: SetAssortmentSharesPayload;
  setAssortmentSizedDoorQuantity?: Maybe<SetAssortmentSizedDoorQuantityPayload>;
  setAssortmentSkuDoorLineItemBulkQuantity: Array<SetAssortmentSkuDoorLineItemBulkQuantityPayload>;
  setAssortmentSkuDoorLineItemQuantities: Array<AssortmentSkuDoorLineItemQuantityPayload>;
  setAssortmentSkuFinalRetailPrice: SetAssortmentSkuFinalRetailPricePayload;
  setAssortmentSkuRetailPrice: SetAssortmentSkuRetailPricePayload;
  /** Upserts a quantity for an unassigned SKU line item (no door or cluster) */
  setAssortmentSkuUnassignedLineItemQuantities: Array<AssortmentSkuUnassignedLineItemQuantityPayload>;
  /** Set or override the UPC for a SKU within a particular assortment */
  setAssortmentSkuUpc: SetAssortmentSkuUpcPayload;
  setAssortmentSkuWholesalePrice: SetAssortmentSkuWholesalePricePayload;
  setAttributeOptionFilterForAttributeOption: SetAttributeOptionFilterForAttributeOptionPayload;
  /** Creates or updates the fields of a currency conversion object */
  setCurrencyConversion: SetCurrencyConversionPayload;
  setDisplayLanguageForUser: SetDisplayLanguageForUserPayload;
  setImpersonatedUser?: Maybe<SetImpersonatedUserPayload>;
  setMerchandisingHierarchyFilterForAttributeOption: SetMerchandisingHierarchyFilterForAttributeOptionPayload;
  /** @deprecated Use genericSetPriceModifierValue instead */
  setPriceModifierValue: Array<SetPriceModifierValuePayload>;
  setProductSizeRun?: Maybe<SetProductSizeRunResponse>;
  setRetailerBrandFilterForAttributeOption: SetRetailerBrandFilterForAttributeOptionPayload;
  /**
   * Set custom retailer product sizes on an Assortment
   *
   * This will remove existing sizes associated with a product
   */
  setRetailerProductSizesOnAssortment: SetRetailerProductSizesOnAssortmentPayload;
  setSelectedAccount?: Maybe<SetSelectedAccountPayload>;
  /**
   * This mutation allows for setting multiple assortment attributes at a time. However,
   * this should not be used to set attributes that have a parent/child relationship in
   * the same request. Doing so will result in the option selected for the child attribute
   * to be overwritten.
   */
  setSelectedAssortmentAttributeOptions: SetSelectedAssortmentAttributeOptionsPayload;
  setSkuItemProperty: SetSkuItemPropertyPayload;
  /** sets the retail size on a sku note: assortmentId is required for this mutation to work properly */
  setSkuRetailSize?: Maybe<SetSkuRetailSizeResponse>;
  setUserPassword?: Maybe<SetUserPasswordPayload>;
  /** Sets the default grouping for a Visual Assortment. */
  setVisualAssortmentDefaultGrouping: SetVisualAssortmentDefaultGroupingResponse;
  shareAndSendLinesheetsWithCollaborationInvitesEmails: ShareAndSendLinesheetsWithCollaborationInvitesEmailsPayload;
  shareAndSendStyleboardsWithCollaborationInvitesEmails: ShareAndSendStyleboardsWithCollaborationInvitesEmailsPayload;
  shareCollectionsWithRetailers: ShareCollectionsWithRetailersPayload;
  shareShowroomCollection: Array<ShowroomCollectionShare>;
  shareShowroomCollectionWithTeamMembers: TeamMemberShowroomCollectionShare;
  shareStyleboard: Array<StyleboardShare>;
  /** Loads images from an url and uploads them */
  styleImportAddImages: StyleImportAddImagesPayload;
  subscribeUserToFeature: SubscribeUserToFeaturePayload;
  syncShopifyOrderStyles: SyncShopifyOrderStylesPayload;
  /** Syncs orders in the Visual Assortment sync queue. */
  syncVisualAssortmentOrders: SyncVisualAssortmentOrdersResponse;
  /** Trigger a task to generate a generic assortment excel export */
  triggerAssortmentExcelExportTasks: TriggerAssortmentExcelExportTasksPayload;
  /** Trigger a custom self-serve assortment export */
  triggerAssortmentExport: TriggerAssortmentExportPayload;
  /** Trigger a task to generate a generic assortment PDF export */
  triggerAssortmentPdfExportTasks: TriggerAssortmentPDFExportTasksPayload;
  /** Trigger multiple custom self-serve assortment exports in bulk */
  triggerBulkAssortmentExport: TriggerAssortmentExportPayload;
  /** Trigger Celery Job for a custom self-serve assortment export */
  triggerBulkAssortmentExportAsync: TriggerBulkAssortmentExportAsyncPayload;
  /** Trigger multiple custom self-serve product exports in bulk */
  triggerBulkProductExport: TriggerProductExportPayload;
  triggerOrdersPdfExportTasks: TriggerOrdersPdfExportTasksPayload;
  triggerOrphanRetailerRequest: TriggerOrphanRetailerRequestPayload;
  triggerResetPassword?: Maybe<TriggerResetPasswordPayload>;
  unSubscribeUserToFeature: UnSubscribeUserToFeaturePayload;
  /**
   * Reinstate a connection that was declined, as an active connection.
   *
   * Only succeeds if a connection request between the two accounts was previously
   * declined and they are not connected or pending right now.
   */
  undoDeclinedConnection: UndoDeclinedConnectionPayload;
  unshareCollectionsWithRetailers: UnshareCollectionsWithRetailersPayload;
  unshareShowroomCollection: Array<ShowroomCollectionShare>;
  updateAccountPermissionAccess: UpdateAccountPermissionAccessPayload;
  updateAccountPrivacy: UpdateAccountPrivacyPayload;
  updateAccountProvider: AccountPaymentProvider;
  updateAccountUserDataPermissionConfiguration: UpdateAccountUserDataPermissionConfigurationPayload;
  updateAccountUserGeoRestrictions: UpdateAccountUserGeoRestrictionsPayload;
  updateAccountUserPossibleExceptions: Array<PermissionsAccount>;
  updateAccountUserStatus: UpdateAccountUserStatusPayload;
  updateAccountUsersPermissionAccess: UpdateAccountUsersPermissionAccessPayload;
  /** Updates the accounts that have access to a Visual Assortment. */
  updateAccountsForVisualAssortment: UpdateAccountsForVisualAssortmentResponse;
  updateAccountsLinkedToStore: ShopifyIntegration;
  updateAccountsUsers: UpdateAccountsUsersPayload;
  updateAssortmentDetails: UpdateAssortmentDetailsPayload;
  updateAssortmentImportStatus: UpdateAssortmentImportStatusPayload;
  updateAttribute: UpdateAttributePayload;
  updateAttributeOption: UpdateAttributeOptionPayload;
  updateAttributeOptionRuleForPriceModifier: UpdateAttributeOptionRuleForPriceModifierPayload;
  updateAvailablePaymentMethods: AccountPaymentProvider;
  updateBrandRuleForPriceModifier: UpdateBrandRuleForPriceModifierPayload;
  updateCollaborationInvitesToAccount: UpdateUserCollaborationInvitePayload;
  updateCollectionBanners: UpdateCollectionBannersPayload;
  updateConfiguration?: Maybe<Configuration>;
  updateConnectionBuyers?: Maybe<ConnectionBuyersPayload>;
  updateConnectionDiscounts?: Maybe<ConnectionDiscountsPayload>;
  updateConnectionDoors: Array<ConnectionDoor>;
  updateConnectionPaymentMethods: Array<ConnectionPaymentMethod>;
  updateConnectionPriceTypes?: Maybe<ConnectionPriceTypesPayload>;
  updateConnectionSalesReps?: Maybe<ConnectionSalesRepsPayload>;
  updateConnectionShippingMethods: Array<ConnectionShippingMethod>;
  updateConnectionWarehouses: Array<ConnectionWarehouse>;
  updateDataPermissionConfiguration: CreateDataPermissionConfigurationPayload;
  updateExportIntegrationConfig: ExportIntegrationConfig;
  updateIdentityProvider?: Maybe<UpdateIdentityProviderPayload>;
  updateJob: UpdateJobPayload;
  updateManualPaymentRecord: ManualPaymentRecord;
  updateMerchandisingHierarchyNode: UpdateMerchandisingHierarchyNodePayload;
  updateMerchandisingHierarchyRuleForPriceModifier: UpdateMerchandisingHierarchyRuleForPriceModifierPayload;
  updateOrderBilling: UpdateOrderPayload;
  updateOrderComments: UpdateOrderCommentsPayload;
  updateOrderCustomerRecordId: UpdateOrderCustomerRecordIdPayload;
  updateOrderCustomerShippingBilling: UpdateOrderPayload;
  updateOrderDeliveryInfo: UpdateOrderDeliveryInfoPayload;
  updateOrderDiscount?: Maybe<UpdateOrderDiscountPayload>;
  updateOrderInfo: UpdateOrderPayload;
  updateOrderProductDiscounts?: Maybe<UpdateOrderProductDiscountsPayload>;
  updateOrderShipping: UpdateOrderPayload;
  updateOrderShippingBilling: UpdateOrderPayload;
  updateOrders: OrdersPayload;
  updateOrphanRetailer?: Maybe<OrphanRetailer>;
  updatePayment: UpdatePaymentPayload;
  updatePaymentSettings: AccountPaymentProvider;
  updateRegion: Region;
  /** Update retail workspace name */
  updateRetailWorkspaceName: RetailWorkspacePayload;
  updateRetailerImpersonationFeedback: UpdateRetailerImpersonationFeedbackPayload;
  updateRetailerProfile: LGRetailerProfile;
  updateRetailerShopifyProductSyncSettings?: Maybe<Array<RetailerShopifyProductSync>>;
  updateSeason: UpdateSeasonPayload;
  updateShopifyBrandSyncSettings: ShopifyBrandSyncSettings;
  updateShowroomCollections: Array<ShowroomCollection>;
  updateSkuPrices: BulkUpdateSkuPricesPayload;
  updateStyleboards: Array<Styleboard>;
  updateSubmissionSenderProfile: ViewingUser;
  updateSubmissionTemplate: SubmissionTemplate;
  updateUserCollaborationInvite: UpdateUserCollaborationInvitePayload;
  /**
   * Updates (renames/reorders) a custom Visual Assortment Attribute Key. System
   * keys (Seasons, Doors) cannot be modified.
   */
  updateVisualAssortmentAttributeKey: UpdateVisualAssortmentAttributeKeyResponse;
  /** Updates Visual Assortment Attribute Values for the current Visual Assortment Account Access. */
  updateVisualAssortmentAttributeValues: UpdateVisualAssortmentAttributeValuesResponse;
  /**
   * Updates a Visual Assortment Budget. Replaces groupings atomically when provided.
   * Any change to attributeFilterId or groupings will delete all associated budget data.
   * Only currency changes preserve existing budget data.
   */
  updateVisualAssortmentBudget: VisualAssortmentBudget;
  uploadAttachmentToS3?: Maybe<UploadAttachmentToS3Payload>;
  /** Performs upload of images for async processing */
  uploadBulkStyleImage: UploadBulkStyleImagePayload;
  uploadFileToS3?: Maybe<Media>;
  /** Uploads an image to the Gallery and sets it as the product image for a Visual Assortment Card. */
  uploadImageToVisualAssortmentCard: UploadImageToVisualAssortmentCardResponse;
  uploadProductColorImage?: Maybe<UploadProductColorImageResult>;
  uploadProductImage?: Maybe<UploadProductImageResult>;
  /** Performs the upload of the csv or xlsx file with the styles data to S3 */
  uploadStyleImportFile: UploadStyleImportFilePayload;
  /**
   * Create or update the status of an account connection.
   * Currently only implemented for a retailer accepting or declining a pending brand
   * connection request, and a retailer sending a connection request to a brand.
   */
  upsertAccountConnectionStatuses: UpsertAccountConnectionStatusesPayload;
  /** Create or update the customer codes associated with other accounts. */
  upsertAccountCustomerCodes: Array<AccountCustomerCode>;
  upsertBillingAddresses: UpsertBillingAddressesPayload;
  /** Atomically replace all billing contacts for an organization. */
  upsertBillingContacts: Array<BillingContact>;
  upsertBrandProfile: PrivateBrandProfile;
  upsertCollectionTextStyles: UpsertCollectionTextStylesPayload;
  upsertCollectionsVisibility: UpsertCollectionsVisibilityPayload;
  upsertOrderQuantities: UpsertOrderQuantitiesPayload;
  upsertRetailBudget?: Maybe<RetailBudget>;
  upsertShowroomCollection: ShowroomCollection;
  upsertStorefront: Storefront;
  upsertStorefrontTextStyles: Array<TextStyle>;
  upsertStyleboard: Styleboard;
  upsertUrl3dShowroom: Array<Url3dShowroom>;
  /**
   * Upserts the list of users with access to the current Visual Assortment Account.
   * Replaces existing users with the provided list; order_nbr determines display order.
   */
  upsertVisualAssortmentAccessUsers: UpsertVisualAssortmentAccessUsersResponse;
  /** Upserts budget row values. Returns the updated BudgetView. */
  upsertVisualAssortmentBudgetRows: BudgetView;
  validateOrders?: Maybe<ValidateOrdersPayload>;
  /** Validate style import file */
  validateStyleImportFile: ValidateStyleImportFilePayload;
  verifyAchBankAccount: BankAccount;
  verifyUserEmail: VerifyUserEmailPayload;
  viewSubmission: ViewSubmissionPayload;
  visitRetailerProfile: VisitRetailerProfilePayload;
};


export type MutationAssortmentUI__assignProductColorImageArgs = {
  imageId: Scalars['String'];
  productColorId: Scalars['String'];
};


export type MutationAssortmentUI__bulkAddColorsToAssortmentProductArgs = {
  input: AssortmentUI__BulkAddColorsToAssortmentProductRequest;
};


export type MutationAssortmentUI__bulkCreateAssortmentProductArgs = {
  input: AssortmentUI__BulkCreateAssortmentProductRequest;
};


export type MutationAssortmentUI__createConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationAssortmentUI__createRetailerExclusiveSkuArgs = {
  input: AssortmentUI__CreateRetailerExclusiveSkuRequest;
};


export type MutationAssortmentUI__deleteConfigurationArgs = {
  input: DeleteConfigurationInput;
};


export type MutationAssortmentUI__deleteSkuColorsForAssortmentArgs = {
  assortmentId: Scalars['ID'];
  colorIds: Array<Scalars['ID']>;
};


export type MutationAssortmentUI__removeProductImageArgs = {
  imageId: Scalars['String'];
};


export type MutationAssortmentUI__updateConfigurationArgs = {
  input: UpdateConfigurationInput;
};


export type MutationAssortmentUI__updateRetailerExclusiveSkuArgs = {
  input: AssortmentUI__UpdateRetailerExclusiveSkuRequest;
};


export type MutationAssortmentUI__updateRowColorBulkArgs = {
  assortmentId: Scalars['ID'];
  updates: Array<AssortmentUI__BulkColorUnitUpdate>;
};


export type MutationAssortmentUI__updateRowSizeBulkArgs = {
  assortmentId: Scalars['ID'];
  updates: Array<AssortmentUI__BulkSizeUnitUpdate>;
};


export type MutationAssortmentUI__uploadProductColorImageArgs = {
  file: Scalars['Upload'];
  productColorId: Scalars['String'];
};


export type MutationAssortmentUI__uploadProductImageArgs = {
  assortmentId: Scalars['String'];
  file: Scalars['Upload'];
  productId: Scalars['String'];
};


export type MutationAssortmentUI__uploadSwatchImageArgs = {
  assortmentId: Scalars['String'];
  colorId: Scalars['String'];
  file: Scalars['Upload'];
};


export type MutationUpdateRetailerPrimaryAccountArgs = {
  input: UpdateRetailerPrimaryAccountInput;
};


export type MutationacceptRequestConnectionArgs = {
  input: AcceptRequestConnectionInput;
};


export type MutationacceptUserMembershipRequestArgs = {
  input: AcceptUserMembershipRequestInput;
};


export type MutationacknowledgeRecentlyCreatedAccountsArgs = {
  input: AcknowledgeRecentlyCreatedAccountsInput;
};


export type MutationaddAssortmentDoorsArgs = {
  input: AddAssortmentDoorsInput;
};


export type MutationaddColorsToAssortmentArgs = {
  input: AddColorsToAssortmentInput;
};


export type MutationaddInventoryAvailabilityGroupArgs = {
  input: AddInventoryAvailabilityGroupInput;
};


export type MutationaddOrdersToVisualAssortmentArgs = {
  orderIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationaddProductsToOrdersArgs = {
  input: AddProductsToOrdersInput;
};


export type MutationaddSkusToAssortmentArgs = {
  input: AddSkusToAssortmentInput;
};


export type MutationaddStyleboardCommentArgs = {
  input: AddStyleboardCommentInput;
};


export type MutationaddUnitsInProgressArgs = {
  input: AddUnitsInProgressInput;
};


export type MutationaddVariantsInProgressArgs = {
  input: AddVariantsInProgressInput;
};


export type MutationanonymousCreateReachPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationanonymousUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationappSubscriptionCancelArgs = {
  input: AppSubscriptionCancelInput;
};


export type MutationapplyAssortmentSkuColorAttributesArgs = {
  input: ApplyAssortmentSkuAttributesInput;
};


export type MutationapplySizeCurveToDoorColorsArgs = {
  input: ApplySizeCurveToDoorColorsRequest;
};


export type MutationassignProductColorImageArgs = {
  imageId: Scalars['ID'];
  productColorId: Scalars['ID'];
};


export type MutationassignStyleColorSwatchArgs = {
  input: AssignStyleColorSwatchInput;
};


export type MutationassortmentMoveToRetailWorkspaceArgs = {
  input: MoveToRetailWorkspaceInput;
};


export type MutationasyncAddOrdersToVisualAssortmentArgs = {
  orderIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationasyncExportVisualAssortmentPdfArgs = {
  visualAssortmentId: Scalars['ID'];
};


export type MutationbulkAddColorsToAssortmentProductArgs = {
  input: BulkAddColorsToAssortmentProductRequest;
};


export type MutationbulkAddProductsAndSkusToCollectionsArgs = {
  input: BulkAddProductsAndSkusToCollectionsInput;
};


export type MutationbulkAddProductsToCollectionArgs = {
  input: BulkAddProductsToCollectionInput;
};


export type MutationbulkAddProductsToInventoryAvailabilityGroupArgs = {
  input: BulkAddProductsToInventoryAvailabilityGroupInput;
};


export type MutationbulkAddWarehousesArgs = {
  input: BulkAddWarehousesInput;
};


export type MutationbulkCancelOrdersVariantsArgs = {
  input: BulkCancelOrdersVariantsInput;
};


export type MutationbulkCopyOrdersArgs = {
  input: BulkCopyOrdersInput;
};


export type MutationbulkCreateAssortmentProductArgs = {
  input: BulkCreateAssortmentProductRequest;
};


export type MutationbulkCreateCollaborationInvitesArgs = {
  input: BulkCreateCollaborationInvitesInput;
};


export type MutationbulkCreateCollaborationInvitesToAccountsArgs = {
  input: BulkCreateCollaborationInvitesToAccountsInput;
};


export type MutationbulkCreateCollectionGroupsArgs = {
  input: BulkCreateCollectionGroupsInput;
};


export type MutationbulkCreateCollectionsArgs = {
  input: BulkCreateCollectionsInput;
};


export type MutationbulkCreateProductsArgs = {
  input: BulkCreateProductsInput;
};


export type MutationbulkCreateSkuTraitValuesArgs = {
  input: BulkCreateSkuTraitValuesInput;
};


export type MutationbulkCreateUserMembershipRequestsArgs = {
  input: BulkCreateUserMembershipRequestsInput;
};


export type MutationbulkDeleteCollectionGroupsArgs = {
  input: BulkDeleteCollectionGroupsInput;
};


export type MutationbulkDeleteCollectionsArgs = {
  input: BulkDeleteCollectionsInput;
};


export type MutationbulkDeleteDataPermissionConfigurationsArgs = {
  input: BulkDeleteDataPermissionConfigurationsInput;
};


export type MutationbulkDeleteExternalProviderAuthsArgs = {
  input: BulkDeleteExternalProviderAuthsInput;
};


export type MutationbulkDeleteProductsArgs = {
  input: BulkDeleteProductsInput;
};


export type MutationbulkDeleteProductsFromAvailabilityGroupArgs = {
  input: BulkDeleteProductsFromAvailabilityGroupInput;
};


export type MutationbulkDeleteRetailerLocationsArgs = {
  input: BulkDeleteRetailerLocationsInput;
};


export type MutationbulkDeleteRetailerUploadsArgs = {
  input: BulkDeleteRetailerUploadsInput;
};


export type MutationbulkDeleteWarehousesArgs = {
  input: BulkDeleteWarehousesInput;
};


export type MutationbulkDuplicateCollectionsArgs = {
  input: BulkDuplicateCollectionsInput;
};


export type MutationbulkMarkInventoryAvailabilityGroupsAsReceivedArgs = {
  input: BulkMarkInventoryAvailabilityGroupsAsReceivedInput;
};


export type MutationbulkMarkOrdersAsExportedArgs = {
  input: BulkMarkOrdersAsExportedInput;
};


export type MutationbulkRemoveProductsAndSkusFromCollectionsArgs = {
  input: BulkRemoveProductsAndSkusFromCollectionsInput;
};


export type MutationbulkRemoveUnmatchedUploadsArgs = {
  input: BulkRemoveUnmatchedUploadsInput;
};


export type MutationbulkReplaceOrdersVariantArgs = {
  input: BulkReplaceOrdersVariantInput;
};


export type MutationbulkScheduleForExportArgs = {
  input: BulkScheduleForExportInput;
};


export type MutationbulkSetCollectionsDeliveryArgs = {
  input: BulkSetCollectionsDeliveryInput;
};


export type MutationbulkSetOrdersToReexportArgs = {
  input: BulkSetOrdersToReexportInput;
};


export type MutationbulkSetProductsTraitValuesArgs = {
  input: BulkSetProductsTraitValuesInput;
};


export type MutationbulkSetSkuItemPropertiesArgs = {
  input?: InputMaybe<Array<SetSkuItemPropertyInput>>;
};


export type MutationbulkSetSkuUpcsArgs = {
  input: BulkSetSkuUpcsInput;
};


export type MutationbulkStyleImportArgs = {
  input: BulkStyleImportInput;
};


export type MutationbulkUnscheduleForExportArgs = {
  input: BulkUnscheduleForExportInput;
};


export type MutationbulkUpdateAccountsPrivacyArgs = {
  input: BulkUpdateAccountsPrivacyInput;
};


export type MutationbulkUpdateAssortmentDetailsArgs = {
  input: Array<UpdateAssortmentDetailsInput>;
};


export type MutationbulkUpdateCollectionGroupsArgs = {
  input: BulkUpdateCollectionGroupsInput;
};


export type MutationbulkUpdateCollectionProductsArgs = {
  input: BulkUpdateCollectionProductsInput;
};


export type MutationbulkUpdateCollectionsArgs = {
  input: BulkUpdateCollectionsInput;
};


export type MutationbulkUpdateCollectionsPositionArgs = {
  input: BulkUpdateCollectionsPositionInput;
};


export type MutationbulkUpdateCollectionsPublicArgs = {
  input: BulkUpdateCollectionsPublicInput;
};


export type MutationbulkUpdateInventoryItemsArgs = {
  input: BulkUpdateInventoryItemsInput;
};


export type MutationbulkUpdateOrderPricingByFiltersArgs = {
  input: BulkUpdateOrderPricingByFiltersInput;
};


export type MutationbulkUpdateOrderPricingByIdsArgs = {
  input: BulkUpdateOrderPricingByIdsInput;
};


export type MutationbulkUpdateOrderSalesRepByFiltersArgs = {
  input: BulkUpdateOrderSalesRepByFiltersInput;
};


export type MutationbulkUpdateOrderStatusArgs = {
  input: BulkUpdateOrderStatusInput;
};


export type MutationbulkUpdateOrderStatusAsyncArgs = {
  input: BulkUpdateOrderStatusAsyncInput;
};


export type MutationbulkUpdateProductsArgs = {
  input: BulkUpdateProductsInput;
};


export type MutationbulkUpdateRetailerGoogleAddressesArgs = {
  input: Array<BulkUpdateRetailerGoogleAddressesInput>;
};


export type MutationbulkUpdateSkuTraitValuesArgs = {
  input: BulkUpdateSkuTraitValuesInput;
};


export type MutationbulkUpdateStorefrontsArgs = {
  input: BulkUpdateStorefrontsInput;
};


export type MutationbulkUpdateUserFavoriteCollectionsArgs = {
  input: BulkUpdateUserFavoriteCollectionsInput;
};


export type MutationbulkUpdateWarehousesArgs = {
  input: BulkUpdateWarehousesInput;
};


export type MutationbulkUpsertOrderEventsArgs = {
  input: BulkUpsertOrderEventsInput;
};


export type MutationbulkUpsertRetailerLocationsArgs = {
  input: BulkUpsertRetailerLocationsInput;
};


export type MutationbulkUpsertRetailerUploadsArgs = {
  input: BulkUpsertRetailerUploadsInput;
};


export type MutationbulkUpsertSkuExternalIdentifiersArgs = {
  input: BulkUpsertSkuExternalIdentifiersInput;
};


export type MutationcompleteShopifyInstallationArgs = {
  input: CompleteShopifyInstallationInput;
};


export type MutationcompleteShopifyInstallationForEmbeddedAppsArgs = {
  input: CompleteShopifyInstallationForEmbeddedAppsInput;
};


export type MutationconnectAccountsThroughJiraArgs = {
  input: ConnectAccountsThroughJiraInput;
};


export type MutationconnectPaymentProviderArgs = {
  input: ConnectPaymentProviderInput;
};


export type MutationcopyAssortmentsArgs = {
  input: CopyAssortmentsInput;
};


export type MutationcreateAccountUserArgs = {
  input: CreateAccountUserInput;
};


export type MutationcreateAchPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationcreateAssortmentArgs = {
  input: CreateAssortmentInput;
};


export type MutationcreateAssortmentWithColorsArgs = {
  input: CreateAssortmentWithColorsInput;
};


export type MutationcreateAssortmentsExportRecordArgs = {
  input: CreateAssortmentsExportRecordInput;
};


export type MutationcreateAttributeArgs = {
  input: CreateAttributeInput;
};


export type MutationcreateAttributeOptionArgs = {
  input: CreateAttributeOptionInput;
};


export type MutationcreateAttributeOptionRuleForPriceModifierArgs = {
  input: CreateAttributeOptionRuleForPriceModifierInput;
};


export type MutationcreateBrandDoorArgs = {
  input: CreateBrandDoorInput;
};


export type MutationcreateBrandRuleForPriceModifierArgs = {
  input: CreateBrandRuleForPriceModifierInput;
};


export type MutationcreateCollaborationInviteArgs = {
  input: createCollaborationInviteInput;
};


export type MutationcreateCollectionBannersArgs = {
  input: CreateCollectionBannersInput;
};


export type MutationcreateConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationcreateConnectionBuyersArgs = {
  input: Array<CreateConnectionBuyerInput>;
};


export type MutationcreateConnectionDiscountsArgs = {
  input: Array<CreateConnectionDiscountInput>;
};


export type MutationcreateConnectionDoorsArgs = {
  input: Array<ConnectionDoorInput>;
};


export type MutationcreateConnectionPaymentMethodsArgs = {
  input: Array<ConnectionPaymentMethodInput>;
};


export type MutationcreateConnectionPriceTypesArgs = {
  input: Array<CreateConnectionPriceTypeInput>;
};


export type MutationcreateConnectionSalesRepsArgs = {
  input: Array<CreateConnectionSalesRepInput>;
};


export type MutationcreateConnectionShippingMethodsArgs = {
  input: Array<ConnectionShippingMethodInput>;
};


export type MutationcreateConnectionWarehousesArgs = {
  input: Array<ConnectionWarehouseInput>;
};


export type MutationcreateCustomAssortmentArgs = {
  input: CreateCustomAssortmentInput;
};


export type MutationcreateCustomProductsFromSheetArgs = {
  sheet: Scalars['Upload'];
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationcreateDataPermissionConfigurationArgs = {
  input: CreateDataPermissionConfigurationInput;
};


export type MutationcreateEventArgs = {
  input: CreateEventInput;
};


export type MutationcreateExportIntegrationConfigArgs = {
  input: CreateExportIntegrationConfigInput;
};


export type MutationcreateExternalPaymentArgs = {
  input: CreateExternalPaymentInput;
};


export type MutationcreateExternalProviderAuthArgs = {
  input: CreateExternalProviderAuthInput;
};


export type MutationcreateFavoriteAccountArgs = {
  input: AddFavoriteAccountInput;
};


export type MutationcreateIdentityProviderArgs = {
  input: CreateIdentityProviderInput;
};


export type MutationcreateInProgressOrdersWithUnitsArgs = {
  input: CreateInProgressOrdersWithUnitsInput;
};


export type MutationcreateInvoicesArgs = {
  input: CreateInvoicesInput;
};


export type MutationcreateJobArgs = {
  input: CreateJobInput;
};


export type MutationcreateManualPaymentRecordArgs = {
  input: CreateManualPaymentRecordInput;
};


export type MutationcreateMerchandisingHierarchyNodeArgs = {
  input: CreateMerchandisingHierarchyNodeInput;
};


export type MutationcreateMerchandisingHierarchyRuleForPriceModifierArgs = {
  input: CreateMerchandisingHierarchyRuleForPriceModifierInput;
};


export type MutationcreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationcreateNewRetailWorkspaceArgs = {
  input: CreateNewRetailWorkspaceInput;
};


export type MutationcreateOrderFromAssortmentArgs = {
  input: CreateOrderFromAssortmentInput;
};


export type MutationcreateOrphanInProgressOrdersWithUnitsArgs = {
  input: CreateOrphanInProgressOrdersWithUnitsInput;
};


export type MutationcreateOrphanRetailerArgs = {
  input: CreateOrphanRetailerInput;
};


export type MutationcreatePaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationcreatePaymentWithPaymentMethodArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationcreateReachPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationcreateRegionArgs = {
  input: CreateRegionInput;
};


export type MutationcreateRetailWorkspaceArgs = {
  input: CreateRetailWorkspaceInput;
};


export type MutationcreateSeasonArgs = {
  input: CreateSeasonInput;
};


export type MutationcreateSepaPaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationcreateSkuPricesArgs = {
  input: BulkCreateSkuPricesInput;
};


export type MutationcreateStripeProductLinkArgs = {
  priceId: Scalars['String'];
  returnUrl?: InputMaybe<Scalars['String']>;
};


export type MutationcreateSubmissionTemplateArgs = {
  input: createSubmissionTemplateInput;
};


export type MutationcreateUserArgs = {
  input: CreateUserInput;
};


export type MutationcreateUserMembershipInviteArgs = {
  input: CreateUserMembershipInviteInput;
};


export type MutationcreateVisualAssortmentAttributeKeyArgs = {
  input: CreateVisualAssortmentAttributeKeyInput;
};


export type MutationcreateVisualAssortmentAttributeValuesArgs = {
  attributeValues: Array<VisualAssortmentAttributeValueInput>;
};


export type MutationcreateVisualAssortmentBudgetArgs = {
  input: CreateVisualAssortmentBudgetInput;
};


export type MutationdeleteAchBankAccountArgs = {
  input: PaymentMethodInput;
};


export type MutationdeleteCollectionBannersArgs = {
  input: DeleteCollectionBannersInput;
};


export type MutationdeleteConfigurationArgs = {
  input: DeleteConfigurationInput;
};


export type MutationdeleteConnectionBuyersArgs = {
  input: Array<DeleteConnectionBuyerInput>;
};


export type MutationdeleteConnectionDiscountsArgs = {
  input: Array<DeleteConnectionDiscountInput>;
};


export type MutationdeleteConnectionDoorsArgs = {
  input: Array<ConnectionDoorInput>;
};


export type MutationdeleteConnectionPaymentMethodsArgs = {
  input: Array<ConnectionPaymentMethodInput>;
};


export type MutationdeleteConnectionPriceTypesArgs = {
  input: Array<DeleteConnectionPriceTypeInput>;
};


export type MutationdeleteConnectionSalesRepsArgs = {
  input: Array<DeleteConnectionSalesRepInput>;
};


export type MutationdeleteConnectionShippingMethodsArgs = {
  input: Array<ConnectionShippingMethodInput>;
};


export type MutationdeleteConnectionWarehousesArgs = {
  input: Array<ConnectionWarehouseInput>;
};


export type MutationdeleteExportIntegrationConfigsArgs = {
  input: DeleteExportIntegrationConfigsInput;
};


export type MutationdeleteExternalPaymentArgs = {
  input: DeleteExternalPaymentInput;
};


export type MutationdeleteFavoriteAccountArgs = {
  input: DeleteFavoriteAccountInput;
};


export type MutationdeleteIdentityProviderArgs = {
  input: DeleteIdentityProviderInput;
};


export type MutationdeleteManualPaymentRecordArgs = {
  input: DeleteManualPaymentRecordInput;
};


export type MutationdeleteOrderLineItemsArgs = {
  input: DeleteOrderLineItemsInput;
};


export type MutationdeleteOrderVariantsArgs = {
  input: DeleteOrderVariantsInput;
};


export type MutationdeletePaymentMethodArgs = {
  input: PaymentMethodInput;
};


export type MutationdeleteRegionArgs = {
  input: DeleteRegionInput;
};


export type MutationdeleteShowroomCollectionsArgs = {
  input: DeleteShowroomCollectionsInput;
};


export type MutationdeleteStorefrontsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationdeleteStyleboardsArgs = {
  input: DeleteStyleboardsInput;
};


export type MutationdeleteSubmissionTemplateArgs = {
  input: deleteSubmissionTemplateInput;
};


export type MutationdeleteUnavailableProductsArgs = {
  input: deleteUnavailableProductsInput;
};


export type MutationdeleteUrl3dShowroomArgs = {
  input: DeleteUrl3dShowroomInput;
};


export type MutationdeleteVisualAssortmentAttributeKeyArgs = {
  id: Scalars['ID'];
};


export type MutationdeleteVisualAssortmentAttributeValuesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationdeleteVisualAssortmentCardsArgs = {
  cardIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationdownloadCustomProductsSheetTemplateArgs = {
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationeditVisualAssortmentCardsArgs = {
  cardsToEdit: Array<VisualAssortmentCardsToEdit>;
  visualAssortmentId: Scalars['ID'];
};


export type MutationexportVisualAssortmentArgs = {
  format?: InputMaybe<ExportFormat>;
  visualAssortmentId: Scalars['ID'];
};


export type MutationexportVisualAssortmentBudgetArgs = {
  budgetId: Scalars['ID'];
  format?: InputMaybe<ExportFormat>;
};


export type MutationgenerateBSUTemplateArgs = {
  input: GenerateBSUTemplateInput;
};


export type MutationgenerateSummaryFileArgs = {
  input: GenerateSummaryFileInput;
};


export type MutationgenericSetPriceModifierValueArgs = {
  input: Array<GenericSetPriceModifierValueInput>;
};


export type MutationgetOrCreatePendingUsersArgs = {
  input: GetOrCreatePendingUsersInput;
};


export type MutationgetShowroomCollectionTokenizedLinkArgs = {
  input: GetShowroomCollectionTokenizedLinkInput;
};


export type MutationhandleRemoveAccountUserArgs = {
  input: HandleRemoveAccountUserInput;
};


export type MutationimagesUploaderProcessArgs = {
  input: ImagesUploaderProcessInput;
};


export type MutationimportValidatedOrdersArgs = {
  input: ImportValidatedOrdersInput;
};


export type MutationinviteEmailTriggerArgs = {
  input: InviteEmailTriggerInput;
};


export type MutationmarkAssortmentVisitedArgs = {
  input: MarkAssortmentVisitedInput;
};


export type MutationmergeAccountsArgs = {
  input: MergeAccountsInput;
};


export type MutationmergeOrdersArgs = {
  input: MergeOrderInput;
};


export type MutationmessageSubmissionThreadArgs = {
  input: MessageSubmissionThreadInput;
};


export type MutationreassignConnectionsArgs = {
  input: ReassignConnectionsInput;
};


export type MutationremoveAssortmentDoorClustersArgs = {
  input: RemoveAssortmentDoorClustersInput;
};


export type MutationremoveAssortmentDoorsArgs = {
  input: RemoveAssortmentDoorsInput;
};


export type MutationremoveAssortmentSkuColorAttributesArgs = {
  input: RemoveAssortmentSkuAttributesInput;
};


export type MutationremoveOrdersFromVisualAssortmentArgs = {
  orderIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationremoveSelectedAssortmentAttributeOptionsArgs = {
  input: RemoveSelectedAssortmentAttributeOptionsInput;
};


export type MutationremoveVisualAssortmentAccessUsersArgs = {
  userIds: Array<Scalars['ID']>;
};


export type MutationreplySubmissionArgs = {
  input: ReplySubmissionInput;
};


export type MutationrequestAssortmentOrderUpdateArgs = {
  input: RequestAssortmentOrderUpdateInput;
};


export type MutationrequestConnectionToRetailerArgs = {
  input: RequestConnectionToRetailerInput;
};


export type MutationresetPaymentRecordsArgs = {
  input: ResetPaymentRecordsInput;
};


export type MutationsaveAchBankAccountArgs = {
  input: PaymentMethodInput;
};


export type MutationsaveCreditCardArgs = {
  input: PaymentMethodInput;
};


export type MutationsaveMethodAndCreatePaymentArgs = {
  input: CreatePaymentWithPaymentMethodInput;
};


export type MutationsaveProductImagesArgs = {
  input: SaveProductImagesInput;
};


export type MutationsaveUnmatchedUploadArgs = {
  input: SaveUnmatchedUploadInput;
};


export type MutationsearchSimilarStylesArgs = {
  input: SearchSimilarStylesInput;
};


export type MutationsendCollectionsToConnectionsArgs = {
  input: SendCollectionsToConnectionsInput;
};


export type MutationsendEmailConfirmationArgs = {
  input: SendEmailConfirmationInput;
};


export type MutationsendInvoicesForOrdersArgs = {
  input: SendInvoicesForOrdersInput;
};


export type MutationsendJoorPayImInterestedEmailArgs = {
  input: SendJoorPayImInterestedEmailInput;
};


export type MutationsendMessageToConnectionArgs = {
  input: SendMessageToConnectionInput;
};


export type MutationsendPaymentArgs = {
  input: SendPaymentInput;
};


export type MutationsendStyleboardsToEmailsArgs = {
  input: SendStyleboardsToEmailsInput;
};


export type MutationsendSubmissionArgs = {
  input: sendSubmissionInput;
};


export type MutationsetAssortmentColorBulkDoorQuantityArgs = {
  input: SetAssortmentColorBulkDoorQuantityInput;
};


export type MutationsetAssortmentCurrencyConversionArgs = {
  input: Array<SetAssortmentCurrencyConversionInput>;
};


export type MutationsetAssortmentDefaultDoorClustersArgs = {
  input: SetAssormentDefaultDoorClustersInput;
};


export type MutationsetAssortmentDoorClustersArgs = {
  input: SetAssortmentDoorClustersInput;
};


export type MutationsetAssortmentDoorsArgs = {
  input: SetAssortmentDoorsInput;
};


export type MutationsetAssortmentMerchandisingHierarchyArgs = {
  input: SetAssortmentMerchandisingHierarchyInput;
};


export type MutationsetAssortmentProductRetailPriceArgs = {
  input: SetAssortmentProductRetailPriceInput;
};


export type MutationsetAssortmentProductWholesalePriceArgs = {
  input: SetAssortmentProductWholesalePriceInput;
};


export type MutationsetAssortmentSharesArgs = {
  input: SetAssortmentSharesInput;
};


export type MutationsetAssortmentSizedDoorQuantityArgs = {
  input: SetAssortmentSizedDoorQuantityInput;
};


export type MutationsetAssortmentSkuDoorLineItemBulkQuantityArgs = {
  input: Array<AssortmentSkuDoorLineItemBulkQuantity>;
};


export type MutationsetAssortmentSkuDoorLineItemQuantitiesArgs = {
  input: Array<AssortmentSkuDoorLineItemQuantityInput>;
};


export type MutationsetAssortmentSkuFinalRetailPriceArgs = {
  input: SetAssortmentSkuFinalRetailPriceInput;
};


export type MutationsetAssortmentSkuRetailPriceArgs = {
  input: SetAssortmentSkuRetailPriceInput;
};


export type MutationsetAssortmentSkuUnassignedLineItemQuantitiesArgs = {
  input: Array<AssortmentSkuUnassignedLineItemQuantityInput>;
};


export type MutationsetAssortmentSkuUpcArgs = {
  input: SetAssortmentSkuUpcInput;
};


export type MutationsetAssortmentSkuWholesalePriceArgs = {
  input: SetAssortmentSkuWholesalePriceInput;
};


export type MutationsetAttributeOptionFilterForAttributeOptionArgs = {
  input: SetAttributeOptionFilterForAttributeOptionInput;
};


export type MutationsetCurrencyConversionArgs = {
  input: SetCurrencyConversionInput;
};


export type MutationsetDisplayLanguageForUserArgs = {
  input: SetDisplayLanguageForUserInput;
};


export type MutationsetImpersonatedUserArgs = {
  input: SetImpersonatedUserInput;
};


export type MutationsetMerchandisingHierarchyFilterForAttributeOptionArgs = {
  input: SetMerchandisingHierarchyFilterForAttributeOptionInput;
};


export type MutationsetPriceModifierValueArgs = {
  input: Array<SetPriceModifierValueInput>;
};


export type MutationsetProductSizeRunArgs = {
  productId: Scalars['ID'];
  sizeRunId: Scalars['ID'];
};


export type MutationsetRetailerBrandFilterForAttributeOptionArgs = {
  input: SetRetailerBrandFilterForAttributeOptionInput;
};


export type MutationsetRetailerProductSizesOnAssortmentArgs = {
  input: SetRetailerProductSizesOnAssortmentInput;
};


export type MutationsetSelectedAccountArgs = {
  input: SetSelectedAccountInput;
};


export type MutationsetSelectedAssortmentAttributeOptionsArgs = {
  input: SetSelectedAssortmentAttributeOptionsInput;
};


export type MutationsetSkuItemPropertyArgs = {
  input: SetSkuItemPropertyInput;
};


export type MutationsetSkuRetailSizeArgs = {
  assortmentId?: InputMaybe<Scalars['ID']>;
  retailSizeId: Scalars['ID'];
  skuId: Scalars['ID'];
};


export type MutationsetUserPasswordArgs = {
  input: SetUserPasswordInput;
};


export type MutationsetVisualAssortmentDefaultGroupingArgs = {
  groups: Array<VisualAssortmentGroupingByInput>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationshareAndSendLinesheetsWithCollaborationInvitesEmailsArgs = {
  input: ShareAndSendLinesheetsWithCollaborationInvitesEmailsInput;
};


export type MutationshareAndSendStyleboardsWithCollaborationInvitesEmailsArgs = {
  input: ShareAndSendStyleboardsWithCollaborationInvitesEmailsInput;
};


export type MutationshareCollectionsWithRetailersArgs = {
  input: ShareCollectionsWithRetailersInput;
};


export type MutationshareShowroomCollectionArgs = {
  input: ShareShowroomCollectionInput;
};


export type MutationshareShowroomCollectionWithTeamMembersArgs = {
  input: ShareShowroomCollectionWithTeamMembersInput;
};


export type MutationshareStyleboardArgs = {
  input: ShareStyleboardInput;
};


export type MutationstyleImportAddImagesArgs = {
  input: StyleImportAddImagesInput;
};


export type MutationsubscribeUserToFeatureArgs = {
  input: SubscribeUserToFeatureInput;
};


export type MutationsyncShopifyOrderStylesArgs = {
  input: SyncShopifyOrderStylesInput;
};


export type MutationsyncVisualAssortmentOrdersArgs = {
  orderIds?: InputMaybe<Array<Scalars['ID']>>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationtriggerAssortmentExcelExportTasksArgs = {
  input: TriggerAssortmentExcelExportTasksInput;
};


export type MutationtriggerAssortmentExportArgs = {
  input: TriggerAssortmentExportInput;
};


export type MutationtriggerAssortmentPdfExportTasksArgs = {
  input: TriggerAssortmentPDFExportTasksInput;
};


export type MutationtriggerBulkAssortmentExportArgs = {
  input: TriggerBulkAssortmentExportInput;
};


export type MutationtriggerBulkAssortmentExportAsyncArgs = {
  input: TriggerBulkAssortmentExportAsyncInput;
};


export type MutationtriggerBulkProductExportArgs = {
  input: TriggerBulkProductExportInput;
};


export type MutationtriggerOrdersPdfExportTasksArgs = {
  input: TriggerOrdersPdfExportTasksInput;
};


export type MutationtriggerOrphanRetailerRequestArgs = {
  input: TriggerOrphanRetailerRequestInput;
};


export type MutationtriggerResetPasswordArgs = {
  input: TriggerResetPasswordInput;
};


export type MutationunSubscribeUserToFeatureArgs = {
  input: UnSubscribeUserToFeatureInput;
};


export type MutationundoDeclinedConnectionArgs = {
  input: UndoDeclinedConnectionInput;
};


export type MutationunshareCollectionsWithRetailersArgs = {
  input: Array<UnshareCollectionsWithRetailersInput>;
};


export type MutationunshareShowroomCollectionArgs = {
  input: UnshareShowroomCollectionInput;
};


export type MutationupdateAccountPermissionAccessArgs = {
  input: UpdateAccountPermissionAccessInput;
};


export type MutationupdateAccountPrivacyArgs = {
  input: UpdateAccountPrivacyInput;
};


export type MutationupdateAccountProviderArgs = {
  input: ConnectPaymentProviderInput;
};


export type MutationupdateAccountUserDataPermissionConfigurationArgs = {
  input: UpdateAccountUserDataPermissionConfigurationInput;
};


export type MutationupdateAccountUserGeoRestrictionsArgs = {
  input: UpdateAccountUserGeoRestrictionsInput;
};


export type MutationupdateAccountUserPossibleExceptionsArgs = {
  input: UpdateAccountUserPossibleExceptionsInput;
};


export type MutationupdateAccountUserStatusArgs = {
  input: UpdateAccountUserStatusInput;
};


export type MutationupdateAccountUsersPermissionAccessArgs = {
  input: UpdateAccountUsersPermissionAccessInput;
};


export type MutationupdateAccountsForVisualAssortmentArgs = {
  accountIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type MutationupdateAccountsLinkedToStoreArgs = {
  input: updateAccountsLinkedToStoreInput;
};


export type MutationupdateAccountsUsersArgs = {
  input: UpdateAccountsUsersInput;
};


export type MutationupdateAssortmentDetailsArgs = {
  input: UpdateAssortmentDetailsInput;
};


export type MutationupdateAssortmentImportStatusArgs = {
  input: UpdateAssortmentImportStatusInput;
};


export type MutationupdateAttributeArgs = {
  input: UpdateAttributeInput;
};


export type MutationupdateAttributeOptionArgs = {
  input: UpdateAttributeOptionInput;
};


export type MutationupdateAttributeOptionRuleForPriceModifierArgs = {
  input: UpdateAttributeOptionRuleForPriceModifierInput;
};


export type MutationupdateAvailablePaymentMethodsArgs = {
  input: UpdateAvailablePaymentMethodsInput;
};


export type MutationupdateBrandRuleForPriceModifierArgs = {
  input: UpdateBrandRuleForPriceModifierInput;
};


export type MutationupdateCollaborationInvitesToAccountArgs = {
  input: UpdateCollaborationInvitesToAccountInput;
};


export type MutationupdateCollectionBannersArgs = {
  input: UpdateCollectionBannersInput;
};


export type MutationupdateConfigurationArgs = {
  input: UpdateConfigurationInput;
};


export type MutationupdateConnectionBuyersArgs = {
  input: Array<UpdateConnectionBuyerInput>;
};


export type MutationupdateConnectionDiscountsArgs = {
  input: Array<UpdateConnectionDiscountInput>;
};


export type MutationupdateConnectionDoorsArgs = {
  input: Array<ConnectionDoorInput>;
};


export type MutationupdateConnectionPaymentMethodsArgs = {
  input: Array<ConnectionPaymentMethodInput>;
};


export type MutationupdateConnectionPriceTypesArgs = {
  input: Array<UpdateConnectionPriceTypeInput>;
};


export type MutationupdateConnectionSalesRepsArgs = {
  input: Array<UpdateConnectionSalesRepInput>;
};


export type MutationupdateConnectionShippingMethodsArgs = {
  input: Array<ConnectionShippingMethodInput>;
};


export type MutationupdateConnectionWarehousesArgs = {
  input: Array<ConnectionWarehouseInput>;
};


export type MutationupdateDataPermissionConfigurationArgs = {
  input: UpdateDataPermissionConfigurationInput;
};


export type MutationupdateExportIntegrationConfigArgs = {
  input: UpdateExportIntegrationConfigInput;
};


export type MutationupdateIdentityProviderArgs = {
  input: UpdateIdentityProviderInput;
};


export type MutationupdateJobArgs = {
  input: UpdateJobInput;
};


export type MutationupdateManualPaymentRecordArgs = {
  input: UpdateManualPaymentRecordInput;
};


export type MutationupdateMerchandisingHierarchyNodeArgs = {
  input: UpdateMerchandisingHierarchyNodeInput;
};


export type MutationupdateMerchandisingHierarchyRuleForPriceModifierArgs = {
  input: UpdateMerchandisingHierarchyRuleForPriceModifierInput;
};


export type MutationupdateOrderBillingArgs = {
  input: UpdateOrderBillingInput;
};


export type MutationupdateOrderCommentsArgs = {
  input: UpdateOrderCommentsInput;
};


export type MutationupdateOrderCustomerRecordIdArgs = {
  input: UpdateOrderCustomerRecordIdInput;
};


export type MutationupdateOrderCustomerShippingBillingArgs = {
  input: UpdateOrderCustomerShippingBillingInput;
};


export type MutationupdateOrderDeliveryInfoArgs = {
  input: UpdateOrderDeliveryInfoInput;
};


export type MutationupdateOrderDiscountArgs = {
  input: UpdateOrderDiscountInput;
};


export type MutationupdateOrderInfoArgs = {
  input?: InputMaybe<UpdateOrderInfoInput>;
};


export type MutationupdateOrderProductDiscountsArgs = {
  input: UpdateOrderProductDiscountsInput;
};


export type MutationupdateOrderShippingArgs = {
  input: UpdateOrderShippingInput;
};


export type MutationupdateOrderShippingBillingArgs = {
  input: UpdateOrderShippingBillingInput;
};


export type MutationupdateOrdersArgs = {
  input: UpdateOrdersConnection;
};


export type MutationupdateOrphanRetailerArgs = {
  input: UpdateOrphanRetailerInput;
};


export type MutationupdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationupdatePaymentSettingsArgs = {
  input: UpdatePaymentSettingsInput;
};


export type MutationupdateRegionArgs = {
  input: UpdateRegionInput;
};


export type MutationupdateRetailWorkspaceNameArgs = {
  input: UpdateRetailWorkspaceNameInput;
};


export type MutationupdateRetailerImpersonationFeedbackArgs = {
  input: RetailerImpersonationFeedbackInput;
};


export type MutationupdateRetailerProfileArgs = {
  input: UpdateRetailerProfileInput;
};


export type MutationupdateRetailerShopifyProductSyncSettingsArgs = {
  input: ShopifyRetailerProductSyncSettingsInput;
};


export type MutationupdateSeasonArgs = {
  input: UpdateSeasonInput;
};


export type MutationupdateShopifyBrandSyncSettingsArgs = {
  input: UpdateShopifyBrandSyncSettingsInput;
};


export type MutationupdateShowroomCollectionsArgs = {
  input: UpdateShowroomCollectionsInput;
};


export type MutationupdateSkuPricesArgs = {
  input: BulkUpdateSkuPricesInput;
};


export type MutationupdateStyleboardsArgs = {
  input: UpdateStyleboardsInput;
};


export type MutationupdateSubmissionSenderProfileArgs = {
  input: UpdateSubmissionSenderProfileInput;
};


export type MutationupdateSubmissionTemplateArgs = {
  input: updateSubmissionTemplateInput;
};


export type MutationupdateUserCollaborationInviteArgs = {
  input: UpdateUserCollaborationInviteInput;
};


export type MutationupdateVisualAssortmentAttributeKeyArgs = {
  input: UpdateVisualAssortmentAttributeKeyInput;
};


export type MutationupdateVisualAssortmentAttributeValuesArgs = {
  attributeValues: Array<VisualAssortmentAttributeValueUpdateInput>;
};


export type MutationupdateVisualAssortmentBudgetArgs = {
  input: UpdateVisualAssortmentBudgetInput;
};


export type MutationuploadAttachmentToS3Args = {
  input: UploadAttachmentToS3Input;
};


export type MutationuploadBulkStyleImageArgs = {
  input: UploadBulkStyleImageInput;
};


export type MutationuploadFileToS3Args = {
  input: UploadFileToS3Input;
};


export type MutationuploadImageToVisualAssortmentCardArgs = {
  cardUuid: Scalars['ID'];
  image: Scalars['Upload'];
  visualAssortmentId: Scalars['ID'];
};


export type MutationuploadProductColorImageArgs = {
  file: Scalars['Upload'];
  productColorId: Scalars['ID'];
};


export type MutationuploadProductImageArgs = {
  assortmentId: Scalars['ID'];
  file: Scalars['Upload'];
  productId: Scalars['ID'];
};


export type MutationuploadStyleImportFileArgs = {
  input: UploadStyleImportFileInput;
};


export type MutationupsertAccountConnectionStatusesArgs = {
  input: UpsertAccountConnectionStatusesInput;
};


export type MutationupsertAccountCustomerCodesArgs = {
  input: UpsertAccountCustomerCodesInput;
};


export type MutationupsertBillingAddressesArgs = {
  input: Array<BillingAddressInput>;
};


export type MutationupsertBillingContactsArgs = {
  contacts: Array<BillingContactInput>;
  organizationId: Scalars['ID'];
};


export type MutationupsertBrandProfileArgs = {
  input: UpsertBrandProfileInput;
};


export type MutationupsertCollectionTextStylesArgs = {
  input: UpsertCollectionTextStylesInput;
};


export type MutationupsertCollectionsVisibilityArgs = {
  input: CollectionVisibilityInput;
};


export type MutationupsertOrderQuantitiesArgs = {
  input: UpsertOrderQuantitiesInput;
};


export type MutationupsertRetailBudgetArgs = {
  input: RetailBudgetInput;
};


export type MutationupsertShowroomCollectionArgs = {
  input: UpsertShowroomCollectionInput;
};


export type MutationupsertStorefrontArgs = {
  input: UpsertStorefrontInput;
};


export type MutationupsertStorefrontTextStylesArgs = {
  input: UpsertStorefrontTextStylesInput;
};


export type MutationupsertStyleboardArgs = {
  input: UpsertStyleboardInput;
};


export type MutationupsertUrl3dShowroomArgs = {
  input: UpsertUrl3dShowroomInput;
};


export type MutationupsertVisualAssortmentAccessUsersArgs = {
  users: Array<VisualAssortmentAccessUserInput>;
};


export type MutationupsertVisualAssortmentBudgetRowsArgs = {
  input: UpsertVisualAssortmentBudgetRowsInput;
};


export type MutationvalidateOrdersArgs = {
  orderSettings: OrderInputSettings;
  settings?: InputMaybe<ValidateOrdersSettings>;
  templateId: Scalars['ID'];
  url: Scalars['String'];
};


export type MutationvalidateStyleImportFileArgs = {
  input: ValidateStyleImportFileInput;
};


export type MutationverifyAchBankAccountArgs = {
  input: VerifyAchBankAccountInput;
};


export type MutationverifyUserEmailArgs = {
  input: VerifyUserEmailInput;
};


export type MutationviewSubmissionArgs = {
  input: ViewSubmissionInput;
};


export type MutationvisitRetailerProfileArgs = {
  input: VisitRetailerProfileInput;
};

export type NewOrdersInfo = {
  brandId: Scalars['ID'];
  buyerEmail?: InputMaybe<Scalars['String']>;
  buyerName?: InputMaybe<Scalars['String']>;
  doorIds?: InputMaybe<Array<Scalars['ID']>>;
  eventId?: InputMaybe<Scalars['ID']>;
  inventoryId?: InputMaybe<Scalars['ID']>;
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
  status?: InputMaybe<NewOrdersStatus>;
  typeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export enum NewOrdersStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  NOTES = 'NOTES',
  PENDING = 'PENDING'
}

export type Node = {
  /** Identifier used to fetch a specific node */
  id: Scalars['ID'];
};

export type Orb360Product = Node & {
  externalMedia: Array<ExternalMedia>;
  id: Scalars['ID'];
  images: Array<Media>;
  name: Scalars['String'];
};

export type Orb360ProductPayload = {
  products: Array<Orb360Product>;
  totalCount: Scalars['Int'];
};

export type Order = {
  agreesWithTerms: Scalars['Boolean'];
  author: User;
  billing: OrderBilling;
  brand: Brand;
  buyer?: Maybe<OrderBuyer>;
  /** @deprecated Use collections instead */
  collection: Collection;
  collections: CollectionConnection;
  created: Scalars['Date'];
  createdByRetailer: Scalars['Boolean'];
  /** @deprecated Use orderFinancials.orderDiscount */
  discount?: Maybe<OrderProductDiscount>;
  discountedProductRange: OrderPriceRange;
  discountedTotalRange: OrderPriceRange;
  divisions: Array<Division>;
  doors: BrandDoorConnection;
  event?: Maybe<OrderEvent>;
  financials?: Maybe<OrderFinancials>;
  /** @deprecated Use orderFinancials.grandTotal */
  grandTotal: OrderPriceRange;
  hasCancelledProducts: Scalars['Boolean'];
  hasEmptyLineItems: Scalars['Boolean'];
  id: Scalars['ID'];
  internalComments?: Maybe<Scalars['String']>;
  isOrphan: Scalars['Boolean'];
  lastModifier?: Maybe<LastModifier>;
  latestExports: Array<OrderExportRecord>;
  modified: Scalars['Date'];
  name: Scalars['String'];
  orderComments?: Maybe<Scalars['String']>;
  orphanRetailer?: Maybe<OrphanRetailer>;
  paymentInfo?: Maybe<PaymentInfo>;
  paymentMethod?: Maybe<PaymentMethodDesc>;
  priceType?: Maybe<PriceType>;
  /** @deprecated Moved this attr to ProductEdge as each product has his own comment not one comment per order. */
  productComment: Scalars['String'];
  products: OrderProductConnection;
  quantity: Scalars['Int'];
  referenceNumber?: Maybe<Scalars['String']>;
  /** @deprecated Use retailTotalRange instead. */
  retailTotal: Scalars['Decimal'];
  /** @deprecated Use orderFinancials.suggestedRetailTotal */
  retailTotalRange: OrderPriceRange;
  /** @deprecated Returns only matching brand retailers. Use retailerProfile instead */
  retailer: Retailer;
  retailerProfile?: Maybe<PublicRetailerProfile>;
  salesComissions?: Maybe<Array<SalesComission>>;
  salesRepresentative?: Maybe<User>;
  season?: Maybe<Season>;
  shared: Scalars['Boolean'];
  shipping: OrderShipping;
  /** @deprecated Use shipping instead */
  shippingInfo: OrderShippingInfo;
  status?: Maybe<OrderStatus>;
  statusModified?: Maybe<Scalars['Date']>;
  /** @deprecated Use orderFinancials.subTotal */
  subtotalWholesale: OrderPriceRange;
  tax?: Maybe<Tax>;
  /** @deprecated Use OrderTermsAndConditions */
  terms?: Maybe<Scalars['String']>;
  termsAndConditions?: Maybe<OrderTermsAndConditions>;
  /** @deprecated Use orderFinancials.orderDiscount */
  totalDiscount: OrderPriceRange;
  trackingNumber?: Maybe<Scalars['String']>;
  types: Array<OrderType>;
  unavailableProducts?: Maybe<OrderUnavailableProductConnection>;
  warehouses: WarehouseConnection;
  /** @deprecated It will be deleted in the future */
  webOrderLookupId: Scalars['ID'];
  /** @deprecated Use wholesaleTotalRange instead. */
  wholesaleTotal: Scalars['Decimal'];
  /** @deprecated Use orderFinancials.wholesaleTotal */
  wholesaleTotalRange: OrderPriceRange;
};


export type OrderproductsArgs = {
  filters?: InputMaybe<OrderProductFilterInput>;
};

export type OrderAddress = {
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  secondAddress?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum OrderAssortmentSyncStatus {
  DRAFT = 'DRAFT',
  LOCKED = 'LOCKED',
  MISSING = 'MISSING',
  SUBMITTED_IN_SYNC = 'SUBMITTED_IN_SYNC',
  SUBMITTED_OUT_OF_SYNC = 'SUBMITTED_OUT_OF_SYNC'
}

export type OrderBilling = {
  address: OrderBillingAddress;
};

export type OrderBillingAddress = OrderAddress & {
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  secondAddress?: Maybe<Scalars['String']>;
  /** Address used to initially populate the order address fields */
  sourceBillingAddress?: Maybe<BillingAddress>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OrderBulkLineItem = {
  collection: LineItemCollection;
  inventory?: Maybe<InventoryAvailabilityGroup>;
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  suggestedRetailPrice: Scalars['Decimal'];
  variant?: Maybe<SkuTraitValue>;
  /** @deprecated Get variantId from variant instead */
  variantId: Scalars['ID'];
  /** @deprecated Use wholesalePriceRange */
  wholesalePrice: Scalars['Decimal'];
  wholesalePriceRange: OrderPriceRange;
};

export type OrderBuyer = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type OrderCheckMinimums = {
  colorMinimums: Scalars['Boolean'];
  orderAmount: Scalars['Boolean'];
  orderQuantity: Scalars['Boolean'];
  productMinimums: Scalars['Boolean'];
};

export type OrderConnection = {
  edges: Array<OrderEdge>;
  totalCount: Scalars['Int'];
};

export type OrderDeliveryInfo = {
  delivery?: InputMaybe<OrderDeliveryInput>;
  doorId?: InputMaybe<Scalars['ID']>;
  purchaseOrderCode?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<SeasonInput>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type OrderDeliveryInput = {
  completeShipDate: Scalars['Date'];
  startShipDate: Scalars['Date'];
};

export type OrderDetails = {
  agreesWithTerms?: InputMaybe<Scalars['Boolean']>;
  buyerEmail?: InputMaybe<Scalars['String']>;
  buyerName?: InputMaybe<Scalars['String']>;
  deliveryWindowEnd?: InputMaybe<Scalars['Date']>;
  deliveryWindowStart?: InputMaybe<Scalars['Date']>;
  eventId?: InputMaybe<Scalars['ID']>;
  internalComments?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderComments?: InputMaybe<Scalars['String']>;
  orderCommissions?: InputMaybe<Array<Scalars['String']>>;
  priceTypeId?: InputMaybe<Scalars['ID']>;
  salesRepId?: InputMaybe<Scalars['ID']>;
  termsAndConditions?: InputMaybe<OrderTermsAndConditionsInput>;
  typeId?: InputMaybe<Scalars['ID']>;
};

export type OrderDiscount = {
  factor: Scalars['Decimal'];
  type: OrderDiscountType;
};

export enum OrderDiscountLevel {
  ENTIRE_ORDER = 'ENTIRE_ORDER',
  SKU = 'SKU'
}

export enum OrderDiscountType {
  NUMERIC = 'NUMERIC',
  PERCENT = 'PERCENT'
}

export type OrderEdge = {
  checkMinimums: OrderCheckMinimums;
  node: Order;
};

export type OrderEvent = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type OrderExportPaymentDetails = {
  dueDate: Scalars['Date'];
  orderId: Scalars['ID'];
};

export type OrderExportRecord = {
  created: Scalars['Date'];
  exportDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  status: OrderExportRecordStatus;
};

export enum OrderExportRecordStatus {
  FAILURE = 'FAILURE',
  NONE = 'NONE',
  SCHEDULED = 'SCHEDULED',
  SUCCESS = 'SUCCESS'
}

export enum OrderExportStatus {
  ANY = 'ANY',
  FALSE = 'FALSE',
  TRUE = 'TRUE',
  UNDEFINED = 'UNDEFINED'
}

export type OrderExportStatusFilterInput = {
  failed?: InputMaybe<Array<Scalars['ID']>>;
  modified?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<Array<Scalars['ID']>>;
  scheduled?: InputMaybe<Array<Scalars['ID']>>;
  success?: InputMaybe<Array<Scalars['ID']>>;
};

export enum OrderExportTaskStatus {
  FAILURE = 'FAILURE',
  NONE = 'NONE',
  SUCCESS = 'SUCCESS'
}

export type OrderExportTasks = {
  downloadUrl: Scalars['String'];
  id: Scalars['ID'];
  status: OrderExportTaskStatus;
};

export type OrderFilterInput = {
  collections?: InputMaybe<Array<Scalars['ID']>>;
  createdByRetailer?: InputMaybe<Scalars['Boolean']>;
  createdDateRange?: InputMaybe<DateRange>;
  deliveryCompleteDateRange?: InputMaybe<DateRange>;
  deliveryStartDateRange?: InputMaybe<DateRange>;
  divisions?: InputMaybe<Array<Scalars['ID']>>;
  events?: InputMaybe<Array<Scalars['ID']>>;
  exportStatus?: InputMaybe<OrderExportStatusFilterInput>;
  hasPayments?: InputMaybe<Scalars['Boolean']>;
  hubIds?: InputMaybe<Array<Scalars['ID']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  isHubUnassigned?: InputMaybe<Scalars['Boolean']>;
  isUnassigned?: InputMaybe<Scalars['Boolean']>;
  modifiedDateRange?: InputMaybe<DateRange>;
  orderGroupId?: InputMaybe<Scalars['ID']>;
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  salesRepresentative?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<OrderSource>;
  status?: InputMaybe<Array<InputMaybe<OrderStatus>>>;
  styleColorIds?: InputMaybe<Array<Scalars['ID']>>;
  types?: InputMaybe<Array<Scalars['ID']>>;
  webIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type OrderFinancials = {
  customFees?: Maybe<Array<OrderPriceModifier>>;
  dueTotal: OrderPriceRange;
  grandTotal: OrderPriceRange;
  id: Scalars['ID'];
  orderDiscount?: Maybe<OrderPriceModifier>;
  orderId: Scalars['ID'];
  shippingFees?: Maybe<OrderPriceModifier>;
  subTotal: OrderPriceRange;
  suggestedRetailTotal: OrderPriceRange;
  tax?: Maybe<OrderPriceModifier>;
  totalUnits: Scalars['Int'];
  wholesaleTotal: OrderPriceRange;
};

export type OrderIdentifiers = {
  orderIds: Array<Scalars['ID']>;
};

export type OrderInfo = {
  agreesWithTerms?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['ID']>;
  collectionId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  inventoryAvailabilityId?: InputMaybe<Scalars['ID']>;
  orderDelivery?: InputMaybe<OrderDeliveryInput>;
  orderGroupExternalId?: InputMaybe<Scalars['String']>;
  orphanRetailerId?: InputMaybe<Scalars['ID']>;
  priceTypeId: Scalars['ID'];
  purchaseOrderCode?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['ID'];
  typeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type OrderInputSettings = {
  billingAddressId?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
  collection: CollectionInputInfo;
  customerBillingAddressId?: InputMaybe<Scalars['ID']>;
  customerDoor?: InputMaybe<DoorInputInfo>;
  customerId?: InputMaybe<Scalars['ID']>;
  customerShippingAddressId?: InputMaybe<Scalars['ID']>;
  door?: InputMaybe<DoorInputInfo>;
  orderStatus: OrderStatus;
  orderTypeId?: InputMaybe<Scalars['ID']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  priceTypeId: Scalars['ID'];
  retailerLocationId?: InputMaybe<Scalars['ID']>;
  shippingAddressId?: InputMaybe<Scalars['ID']>;
  shippingMethodId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type OrderInvoice = {
  invoiceId: Scalars['String'];
  orderId: Scalars['ID'];
};

export type OrderLineItems = {
  bulkLineItems: Array<Maybe<OrderBulkLineItem>>;
  casepackLineItems: Array<Maybe<CasepackLineItem>>;
  skuLineItems: Array<Maybe<SkuLineItem>>;
};

export type OrderLineItemsFilter = {
  variantIds: Array<Scalars['ID']>;
};

export enum OrderOrdering {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type OrderPayload = {
  billingAddress?: Maybe<BillingAddressPayload>;
  brandPaymentMethod?: Maybe<BrandPaymentMethodPayload>;
  buyer?: Maybe<OrderBuyer>;
  collection?: Maybe<CollectionPayload>;
  collectionId: Scalars['ID'];
  comments?: Maybe<Scalars['String']>;
  customer?: Maybe<CustomerPayload>;
  deliveryWindowEnd?: Maybe<Scalars['Date']>;
  deliveryWindowStart?: Maybe<Scalars['Date']>;
  exportDescription?: Maybe<Scalars['String']>;
  exportStatus: OrderExportStatus;
  exportSuccess: Scalars['Boolean'];
  exportedOn?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  internalComments?: Maybe<Scalars['String']>;
  poNumber: Scalars['String'];
  priceType?: Maybe<PriceTypePayload>;
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
  salesRepresentative?: Maybe<SalesRepresentativePayload>;
  shippingAddress?: Maybe<ShippingAddressPayload>;
  shippingMethod?: Maybe<BrandShippingMethodPayload>;
  status?: Maybe<OrderStatus>;
  tax?: Maybe<Tax>;
  taxAmount?: Maybe<Scalars['Float']>;
  trackingNumber?: Maybe<Scalars['String']>;
};

export type OrderPaymentMethod = {
  id: Scalars['ID'];
  paymentMethod?: Maybe<PaymentMethodDesc>;
};

export type OrderPriceModifier = {
  factor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  percentageAmount?: Maybe<Scalars['String']>;
  type?: Maybe<OrderPriceModifierType>;
};

export enum OrderPriceModifierType {
  NUMERIC = 'NUMERIC',
  PERCENT = 'PERCENT'
}

export type OrderPriceRange = {
  maxPrice: Scalars['String'];
  minPrice: Scalars['String'];
};

export type OrderProductComment = {
  comment: Scalars['String'];
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type OrderProductConnection = {
  discountedTotal?: Maybe<Scalars['Decimal']>;
  edges: Array<OrderProductEdge>;
  retailTotal?: Maybe<Scalars['Decimal']>;
  totalDiscount: OrderPriceRange;
  totalProducts?: Maybe<Scalars['Int']>;
  totalUnits?: Maybe<Scalars['Int']>;
  totalVariant?: Maybe<Scalars['Int']>;
  wholesaleTotal?: Maybe<Scalars['Decimal']>;
};


export type OrderProductConnectiontotalVariantArgs = {
  filter?: InputMaybe<OrderTotalVariantFilter>;
};

export type OrderProductDiscount = {
  factor: Scalars['Decimal'];
  level: OrderDiscountLevel;
  orderId: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  type: OrderDiscountType;
};

export type OrderProductDiscountConnection = {
  edges?: Maybe<Array<OrderProductDiscountEdge>>;
};

export type OrderProductDiscountEdge = {
  node?: Maybe<OrderProductDiscount>;
};

export type OrderProductDiscountInput = {
  factor: Scalars['Decimal'];
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  type: OrderDiscountType;
};

export type OrderProductEdge = {
  attributes?: Maybe<Array<ProductAttribute>>;
  backupProduct?: Maybe<BackupProduct>;
  collectionProduct?: Maybe<CollectionProduct>;
  discounts: Array<Maybe<OrderProductDiscount>>;
  financials?: Maybe<OrderProductFinancials>;
  node: Product;
  orderLineItems: OrderLineItems;
  orderProductComment?: Maybe<Scalars['String']>;
  priceRange?: Maybe<PriceRange>;
  quantity?: Maybe<Scalars['Int']>;
  variantTotals: OrderVariantTotalsConnection;
  /** @deprecated Use financials.subTotal */
  wholesaleFinalPrice: OrderPriceRange;
  wholesaleRangeOverwritten?: Maybe<OrderPriceRange>;
  /** @deprecated Use financials.wholesaleTotal */
  wholesaleTotalPrice: OrderPriceRange;
};


export type OrderProductEdgediscountsArgs = {
  level?: InputMaybe<OrderDiscountLevel>;
};


export type OrderProductEdgeorderLineItemsArgs = {
  filter?: InputMaybe<OrderLineItemsFilter>;
};

export type OrderProductFilterInput = {
  pagination?: InputMaybe<PaginationInfo>;
  quantifyByBulk?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<OrderProductStatus>;
  variantValueIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type OrderProductFinancials = {
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  subTotal: OrderPriceRange;
  suggestedRetailTotal: OrderPriceRange;
  wholesaleTotal: OrderPriceRange;
};

export enum OrderProductStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED'
}

export type OrderRequirementChecks = {
  checksInventory?: Maybe<Scalars['Boolean']>;
  checksMinimums?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  sizeRunChanged?: Maybe<Scalars['Boolean']>;
};

export type OrderSeasonYear = {
  season?: Maybe<SeasonName>;
  year?: Maybe<Scalars['String']>;
};

export type OrderSettings = {
  allowOrderDiscounts?: Maybe<Scalars['Boolean']>;
  allowSkuDiscounts?: Maybe<Scalars['Boolean']>;
  brandId: Scalars['ID'];
  displayCountryOfOrigin?: Maybe<Scalars['Boolean']>;
  displayInternalOrderId?: Maybe<Scalars['Boolean']>;
  displayShippingCode?: Maybe<Scalars['Boolean']>;
  minAmount?: Maybe<Scalars['Float']>;
  minDetail?: Maybe<Scalars['String']>;
  minUnits?: Maybe<Scalars['Int']>;
  multipleDivisionsAllowed?: Maybe<Scalars['Boolean']>;
  restrictEditNotesAndReturnedOrders?: Maybe<Scalars['Boolean']>;
  restrictPendingToNotes?: Maybe<Scalars['Boolean']>;
  retailerRestrictedFromEditing?: Maybe<Scalars['Boolean']>;
  salesComissions?: Maybe<Array<Scalars['String']>>;
  shippingRates?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
};

export type OrderShipping = {
  address: OrderShippingAddress;
  /**
   * True when the retailer is billed for shipping (legacy "Bill me / Bill retailer for shipping").
   * Placeholder: always false for now.
   */
  billForShipping: Scalars['Boolean'];
  deliveryWindow?: Maybe<OrderShippingDeliveryWindow>;
  method?: Maybe<ShippingMethod>;
  /** @deprecated Use priceString instead */
  price?: Maybe<Scalars['Decimal']>;
  priceString?: Maybe<Scalars['String']>;
  /**
   * Carrier account details as one free-text value (carrier, account number, service type).
   * Placeholder: always null for now.
   */
  shippingAccount?: Maybe<Scalars['String']>;
};

export type OrderShippingAddress = OrderAddress & {
  account?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  secondAddress?: Maybe<Scalars['String']>;
  /** Address used to initially populate the order address fields */
  sourceShippingAddress?: Maybe<ShippingAddress>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type OrderShippingDeliveryWindow = {
  completeDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type OrderShippingInfo = {
  id: Scalars['ID'];
  /** @deprecated Use OrderShippingDeliveryWindow.shippingComplete instead */
  shippingComplete?: Maybe<Scalars['Date']>;
  /** @deprecated Use OrderShipping.price instead */
  shippingPrice?: Maybe<Scalars['Decimal']>;
  /** @deprecated Use OrderShippingDeliveryWindow.shippingStart instead */
  shippingStart?: Maybe<Scalars['Date']>;
};

export enum OrderSource {
  BRAND_APP = 'BRAND_APP',
  CREATED_BY_RETAILER = 'CREATED_BY_RETAILER',
  EXCEL_IMPORT = 'EXCEL_IMPORT',
  HISTORICAL_ORDER_IMPORT = 'HISTORICAL_ORDER_IMPORT',
  INTEGRATION = 'INTEGRATION',
  RETAILER_APP = 'RETAILER_APP',
  WEB = 'WEB'
}

export enum OrderStatus {
  ALL_NOTES = 'ALL_NOTES',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOTES = 'NOTES',
  NOTES_WITHOUT_QUANTITIES = 'NOTES_WITHOUT_QUANTITIES',
  NOTES_WITH_QUANTITIES = 'NOTES_WITH_QUANTITIES',
  PENDING = 'PENDING',
  RETURNED = 'RETURNED',
  SHIPPED = 'SHIPPED'
}

export type OrderStatusChangeEligibility = {
  brandId: Scalars['ID'];
  brandName: Scalars['String'];
  eligible: Scalars['Boolean'];
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
  reason?: Maybe<OrderStatusChangeIneligibilityReason>;
};

export enum OrderStatusChangeIneligibilityReason {
  ALREADY_IN_STATUS = 'ALREADY_IN_STATUS',
  INVALID_TARGET_STATUS = 'INVALID_TARGET_STATUS',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  PENDING_TO_NOTES_RESTRICTED = 'PENDING_TO_NOTES_RESTRICTED',
  TRANSITION_NOT_ALLOWED = 'TRANSITION_NOT_ALLOWED',
  UNKNOWN = 'UNKNOWN'
}

export type OrderTermsAndConditions = {
  agreesWithTerms: Scalars['Boolean'];
  dateCreated?: Maybe<Scalars['Date']>;
  dateModified?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: OrderTermsAndConditionsPlatform;
  terms: Scalars['String'];
  title: Scalars['String'];
};

export type OrderTermsAndConditionsInput = {
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<OrderTermsAndConditionsPlatform>;
  title?: InputMaybe<Scalars['String']>;
};

export enum OrderTermsAndConditionsPlatform {
  APP = 'APP',
  UNKNOWN = 'UNKNOWN',
  WEB = 'WEB'
}

export type OrderToImport = {
  doorId?: Maybe<Scalars['ID']>;
  orderIdentifier?: Maybe<Scalars['String']>;
  poNumber?: Maybe<Scalars['String']>;
  skuLineItems?: Maybe<Array<SkuLineItemToImport>>;
};

export type OrderTotalVariantFilter = {
  productFilters?: InputMaybe<OrderProductFilterInput>;
  traitCodes: VariantFilterValuesInput;
};

export type OrderType = Node & {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OrderTypeConnection = {
  edges: Array<OrderTypeEdge>;
};

export type OrderTypeEdge = {
  node?: Maybe<OrderType>;
};

export type OrderUnavailableProduct = {
  casepackLineItems: Array<CasepackLineItem>;
  product: Product;
  quantity?: Maybe<Scalars['Int']>;
  skuLineItems: Array<SkuLineItem>;
};

export type OrderUnavailableProductConnection = {
  edges?: Maybe<Array<OrderUnavailableProductEdge>>;
};

export type OrderUnavailableProductEdge = {
  node: OrderUnavailableProduct;
};

export type OrderVariantComment = {
  comment: Scalars['String'];
  orderId: Scalars['ID'];
  variantId: Scalars['ID'];
};

export type OrderVariantTotals = {
  orderId: Scalars['ID'];
  productComment: Scalars['String'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  retailTotal: Scalars['Decimal'];
  variant: SkuTraitValue;
  variantComment: Scalars['String'];
  /** @deprecated Get variantId from variant instead */
  variantId: Scalars['ID'];
  /** @deprecated Use wholesaleTotalRange.maxPrice instead */
  wholesaleTotal: Scalars['Decimal'];
  wholesaleTotalRange: OrderPriceRange;
};

export type OrderVariantTotalsConnection = {
  edges?: Maybe<Array<OrderVariantTotalsEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrderVariantTotalsEdge = {
  cursor: Scalars['String'];
  node?: Maybe<OrderVariantTotals>;
};

export type OrderVariantTotalsFilter = {
  onlyCancelled?: InputMaybe<Scalars['Boolean']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type OrderVariantTotalsOrderBy = {
  field: OrderVariantTotalsOrderByField;
  order: OrderOrdering;
};

export enum OrderVariantTotalsOrderByField {
  PRODUCT_NAME = 'PRODUCT_NAME',
  QUANTITY = 'QUANTITY',
  RETAIL_TOTAL = 'RETAIL_TOTAL',
  WHOLESALE_TOTAL = 'WHOLESALE_TOTAL'
}

export type OrdersPayload = {
  errors: Array<Error>;
  /** @deprecated Use updatedOrders */
  orders: Array<OrderPayload>;
  updatedOrders?: Maybe<OrderConnection>;
};

export type Organization = {
  accountOrganizations: OrganizationAccountsConnection;
  activeSeats?: Maybe<Scalars['Int']>;
  billingContacts: Array<BillingContact>;
  contractedSeats?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OrganizationAccount = {
  accountId: Scalars['ID'];
  accountName?: Maybe<Scalars['String']>;
  accountUsers: AccountUsersConnection;
  activeSeats?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type OrganizationAccountsConnection = {
  edges: Array<OrganizationAccountsEdge>;
};

export type OrganizationAccountsEdge = {
  node: OrganizationAccount;
};

export type OrganizationInput = {
  accountID: Scalars['ID'];
};

export type OrphanBillingInfo = {
  address: AddressInput;
  code: Scalars['String'];
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  phoneNumber: Scalars['String'];
};

export type OrphanOrderInfo = {
  agreesWithTerms?: InputMaybe<Scalars['Boolean']>;
  brandId?: InputMaybe<Scalars['ID']>;
  collectionId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
  inventoryAvailabilityId?: InputMaybe<Scalars['ID']>;
  orderDelivery?: InputMaybe<OrderDeliveryInput>;
  orderGroupExternalId?: InputMaybe<Scalars['String']>;
  priceTypeId: Scalars['ID'];
  purchaseOrderCode?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
};

export type OrphanRetailer = {
  accountId: Scalars['ID'];
  connectionProcessed: Scalars['Boolean'];
  created: Scalars['Date'];
  deleted?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  retailerCode?: Maybe<Scalars['String']>;
  retailerEmail: Scalars['String'];
  retailerName: Scalars['String'];
  update: Scalars['Date'];
};

export type OrphanRetailersRequest = {
  accountId: Scalars['ID'];
  retailerName?: InputMaybe<Scalars['String']>;
};

export type OrphanShippingInfo = {
  address: AddressInput;
  code: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  shippingMethodId?: InputMaybe<Scalars['ID']>;
};

export type PageInfo = {
  /** The cursor to continue when paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** Whether there is a next page when paginating. */
  hasNextPage: Scalars['Boolean'];
  /** Whether there is a previous page when paginating. */
  hasPreviousPage: Scalars['Boolean'];
  /** The cursor to continue when paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginationInfo = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PaidAmount = {
  orderId: Scalars['ID'];
  paidAmount: Scalars['Float'];
};

export type PartialPaymentRequest = {
  active?: Maybe<Scalars['Boolean']>;
  amount: Scalars['String'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PaymentDelivery = {
  id: Scalars['ID'];
  sentOn: Scalars['Date'];
};

export type PaymentId = {
  secret: Scalars['String'];
};

export type PaymentInfo = {
  dueDate?: Maybe<Scalars['Date']>;
  firstRequest?: Maybe<Scalars['Date']>;
  lastNotifiedDate?: Maybe<Scalars['Date']>;
  lastTransaction?: Maybe<Scalars['Date']>;
  paidAmount: Scalars['String'];
  partialPaymentRequests?: Maybe<Array<PartialPaymentRequest>>;
  paymentStatus: PaymentStatus;
  remainingBalance: Scalars['String'];
  requestStatus: RequestStatus;
};

export type PaymentMethod = Node & {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PaymentMethodConnection = {
  edges: Array<PaymentMethodEdge>;
};

export type PaymentMethodDesc = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PaymentMethodEdge = {
  node: PaymentMethod;
};

export type PaymentMethodI = {
  billingEmail: Scalars['String'];
  billingName: Scalars['String'];
  last4: Scalars['String'];
  paymentMethodId: Scalars['String'];
  type: Scalars['String'];
};

export type PaymentMethodIdentifier = {
  paymentMethodExternalId?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
};

export type PaymentMethodInput = {
  brandId: Scalars['ID'];
  paymentMethodId: Scalars['String'];
  paymentProvider: Scalars['String'];
  retailerId?: InputMaybe<Scalars['ID']>;
};

export enum PaymentMethodType {
  ACH = 'ACH',
  CREDIT_CARD = 'CREDIT_CARD',
  SEPA = 'SEPA'
}

export type PaymentPayload = {
  error?: Maybe<Error>;
  paymentId?: Maybe<PaymentId>;
};

export type PaymentProvider = {
  connectUrl: Scalars['String'];
  loginUrl: Scalars['String'];
  name: Scalars['String'];
};

export type PaymentRecord = {
  amount?: Maybe<Scalars['Float']>;
  brandId: Scalars['ID'];
  created?: Maybe<Scalars['Date']>;
  currency: Scalars['String'];
  errorMessage?: Maybe<Scalars['String']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  localAmount?: Maybe<Scalars['Float']>;
  localCurrency?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  paymentMethod?: Maybe<PaymentMethodI>;
  paymentProvider: Scalars['String'];
  retailerId?: Maybe<Scalars['ID']>;
  sourceUserId?: Maybe<Scalars['ID']>;
  status?: Maybe<PaymentRecordStatus>;
};

export enum PaymentRecordStatus {
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  REFUND = 'REFUND',
  REFUND_PROCESSING = 'REFUND_PROCESSING',
  SUCCESS = 'SUCCESS'
}

export enum PaymentStatus {
  FULLY_PAID = 'FULLY_PAID',
  NOT_PAID = 'NOT_PAID',
  PARTIALLY_PAID = 'PARTIALLY_PAID',
  PROCESSING = 'PROCESSING'
}

export type Permission = Node & {
  id: Scalars['ID'];
};

export type PermissionConfiguration = {
  collectionPermissions: Array<Collection>;
  divisionCategoryPermissions: Array<DivisionCategory>;
  divisionPermissions: Array<Division>;
  priceTypePermissions: Array<PriceType>;
};

export type PermissionConfigurationInput = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  divisionCategories: Array<DivisionCategoryInput>;
  divisionIds: Array<Scalars['ID']>;
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PermissionConnection = {
  edges: Array<PermissionEdge>;
};

export type PermissionEdge = {
  node: Permission;
};

export type PermissionState = {
  active: Scalars['Boolean'];
  permissionId: Scalars['ID'];
};

export type PermissionsAccount = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PersonInformation = Node & {
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  submissions?: Maybe<Array<Submission>>;
};

export type PremiumFeature = {
  description?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  groupLevel?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  internalUrl: Scalars['String'];
  marketingUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  openTrialDaysRemaining?: Maybe<Scalars['Int']>;
  prices?: Maybe<Array<PremiumFeaturePrice>>;
  subscriptions: Array<PremiumFeatureSubscription>;
};

export type PremiumFeaturePrice = {
  amount: Scalars['String'];
  frequency: Scalars['String'];
  id: Scalars['ID'];
  trialDays?: Maybe<Scalars['Int']>;
};

export type PremiumFeatureSubscription = {
  accountAccessCount: Scalars['Int'];
  expiryDate: Scalars['Date'];
  frequency: Scalars['String'];
  id: Scalars['ID'];
  isOwner: Scalars['Boolean'];
  isTrial: Scalars['Boolean'];
  priceId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
  status: SubscriptionStatus;
};

export type Press = Node & {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<PressImage>;
  name: Scalars['String'];
};

export type PressConnection = {
  edges?: Maybe<Array<PressEdge>>;
};

export type PressEdge = {
  node?: Maybe<Press>;
};

export type PressImage = {
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type PriceLevel = Node & {
  currencyCode: Scalars['String'];
  currencySource?: Maybe<CurrencyFilter>;
  extendedRetail: Scalars['Decimal'];
  extendedWholesale: Scalars['Decimal'];
  id: Scalars['ID'];
  maxRetail: Scalars['Decimal'];
  maxWholesale: Scalars['Decimal'];
  name: FinancialPriceLevelName;
};

export enum PriceLevelTypeEnum {
  RETAIL = 'RETAIL',
  WHOLESALE = 'WHOLESALE'
}

export type PriceLevelsFilter = {
  currency?: InputMaybe<CurrencyFilter>;
  currencyCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<FinancialPriceLevelName>;
};

/** User defined modifier that contains a factor to apply and a nested set of rules that determine when it should be applied */
export type PriceModifier = Node & {
  /** Factor to apply */
  factor?: Maybe<Scalars['Decimal']>;
  /** The price modifier group that this object belongs to */
  group: PriceModifierGroupEdge;
  id: Scalars['ID'];
  /** The factor for this price modifier displayed as a percentage */
  percent?: Maybe<Scalars['Decimal']>;
};

export type PriceModifierConnection = {
  edges?: Maybe<Array<PriceModifierEdge>>;
};

export type PriceModifierEdge = {
  node?: Maybe<PriceModifier>;
};

/** Price Modifier Groups contain all of the high lieve details common accross price modifiers */
export type PriceModifierGroup = Node & {
  /** Adjustment type for the price modifier class */
  adjustmentType?: Maybe<AdjustmentTypeEnum>;
  /** Unique identifier for this proce modifier class */
  code: Scalars['String'];
  /** Display format for the price modifier class */
  displayFormat?: Maybe<DisplayFormatEnum>;
  id: Scalars['ID'];
  /** Level index for price modifier class */
  levelIndex?: Maybe<Scalars['Int']>;
  /** Display name for the price modifier class */
  name: Scalars['String'];
  /** Price level type for price modifier class */
  priceLevelType?: Maybe<PriceLevelTypeEnum>;
  /** Set of rules which determine when the factor will be applied */
  rules: PriceModifierRuleConnection;
  /** The type of object that this proce modifier applies to */
  type: PriceModifierGroupType;
};

export type PriceModifierGroupConnection = {
  edges?: Maybe<Array<PriceModifierGroupEdge>>;
};

export type PriceModifierGroupEdge = {
  node: PriceModifierGroup;
};

export enum PriceModifierGroupType {
  /** This price modifier group applies to an assortment */
  ASSORTMENT = 'ASSORTMENT',
  /** This price modifier group applies to an item-color */
  ITEM_COLOR = 'ITEM_COLOR'
}

export type PriceModifierRule = Node & {
  id: Scalars['ID'];
  /** The set of rules that determine this rule should apply */
  ruleSet?: Maybe<RuleSet>;
};

export type PriceModifierRuleConnection = {
  edges: Array<PriceModifierRuleEdge>;
};

export type PriceModifierRuleEdge = {
  node: PriceModifierRule;
};

export type PriceModifierValueInput = {
  /** The type of value that is being supplied */
  type: PriceModifierValueType;
  /** The Factor or Percentage to apply */
  value: Scalars['Decimal'];
};

export enum PriceModifierValueType {
  FACTOR = 'FACTOR',
  PERCENT = 'PERCENT'
}

export type PriceRange = {
  maxRetailValue: Scalars['Float'];
  maxWholesaleValue: Scalars['Float'];
  minRetailValue: Scalars['Float'];
  minWholesaleValue: Scalars['Float'];
};

export type PriceRangeFilterInput = {
  max?: InputMaybe<Scalars['PositiveInteger']>;
  min?: InputMaybe<Scalars['PositiveInteger']>;
};

export type PriceRangeGroup = {
  colorId?: Maybe<Scalars['ID']>;
  priceRange: PriceRange;
  priceType: PriceType;
  product: Product;
  sizeId?: Maybe<Scalars['ID']>;
};

export enum PriceRangeGroupBy {
  COLOR = 'COLOR',
  PRICE_TYPE = 'PRICE_TYPE',
  PRODUCT = 'PRODUCT',
  SIZE = 'SIZE'
}

export type PriceRangeGroupConnection = {
  edges: Array<PriceRangeGroupEdge>;
  pageInfo: PageInfo;
};

export type PriceRangeGroupEdge = {
  cursor: Scalars['String'];
  node: PriceRangeGroup;
};

export type PriceRangeInput = {
  maxValue?: InputMaybe<Scalars['Decimal']>;
  minValue?: InputMaybe<Scalars['Decimal']>;
  priceTypeId: Scalars['ID'];
};

export type PriceType = Node & {
  currency: Currency;
  /** @deprecated Get from currency.code */
  currencyCode: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  retailCurrency: Currency;
  /** @deprecated Get from retailCurrency.code */
  retailCurrencyCode: Scalars['String'];
};

export type PriceTypeConnection = {
  edges: Array<PriceTypeEdge>;
};

export type PriceTypeEdge = {
  node: PriceType;
};

export type PriceTypePayload = {
  currency?: Maybe<Scalars['String']>;
  currencyRetail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PriceTypesFilter = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  currencyCodes?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  names?: InputMaybe<Array<Scalars['String']>>;
  retailCurrencyCodes?: InputMaybe<Array<Scalars['String']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PrivateBrandProfile = BrandProfile & {
  /** Account media url */
  accountMedia?: Maybe<BrandMedia>;
  brandId: Scalars['ID'];
  /** Optional Connected status of current account and brand account */
  connected?: Maybe<Status>;
  /** Cover media url */
  coverMedia?: Maybe<BrandMedia>;
  /** Custom Profile images associated with account. Filtered by the online home page */
  customProfileImageUrls: Array<Scalars['String']>;
  /** Custom JOOR URL Handle */
  customUrlHandle?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** iPad photo id */
  ipadPhotoId?: Maybe<Scalars['ID']>;
  /** iPad photo url */
  ipadPhotoUrl?: Maybe<Scalars['String']>;
  /** If the brand is a lite brand */
  isLiteBrand?: Maybe<Scalars['Boolean']>;
  /** The number of line sheets shown in the profile */
  lineSheetLimit?: Maybe<Scalars['Int']>;
  /** Logo image id */
  logoId?: Maybe<Scalars['ID']>;
  /** Logo image url */
  logoUrl?: Maybe<Scalars['String']>;
  /** Lookbooks associated with the account */
  lookbooks: LookbookConnection;
  /** Account name on JOOR */
  name?: Maybe<Scalars['String']>;
  /** Press associated with account */
  press?: Maybe<PressConnection>;
  /** Product lines/categories */
  productLines: Array<Scalars['String']>;
  /** Profile images associated with account. Usually found in about me section. */
  profileImageUrls: Array<Scalars['String']>;
  /** Retail max */
  retailMax?: Maybe<Scalars['Int']>;
  /** Retail min */
  retailMin?: Maybe<Scalars['Int']>;
  /** Social media accounts */
  socialMediaAccounts: Array<SocialMediaAccount>;
  /** Team users associated with account */
  teamUsers: TeamUserConnection;
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']>;
  /** Wholesale max */
  wholesaleMax?: Maybe<Scalars['Int']>;
  /** Wholesale min */
  wholesaleMin?: Maybe<Scalars['Int']>;
  /** Year established */
  yearEstablished?: Maybe<Scalars['Int']>;
};


export type PrivateBrandProfilecustomProfileImageUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PrivateBrandProfileConnection = {
  edges: Array<Maybe<PrivateBrandProfileEdge>>;
  pageInfo: PageInfo;
};

export type PrivateBrandProfileEdge = {
  isFavorite: Scalars['Boolean'];
  node?: Maybe<PrivateBrandProfile>;
};

export type PrivateRetailerProfile = {
  id: Scalars['ID'];
};

export type PrivateRetailerProfileConnection = {
  edges: Array<PrivateRetailerProfileEdge>;
  pageInfo: PageInfo;
};

export type PrivateRetailerProfileEdge = {
  node: PrivateRetailerProfile;
};

export type Product = Node & {
  badges: BadgeConnection;
  brandProfile: PrivateBrandProfile;
  casepacks: ProductCasepackConnection;
  categories: CategoryConnection;
  /** Warning! This node is only available for retailers and not for brands. */
  collections: Array<Collection>;
  description: Scalars['String'];
  externalIdentifier: Scalars['String'];
  externalMedia: Array<ExternalMedia>;
  id: Scalars['ID'];
  images: Array<Media>;
  mainImage?: Maybe<Media>;
  modified?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  orderMinimum: Scalars['Int'];
  priceRange?: Maybe<PriceRange>;
  priceTypes: Array<PriceType>;
  productIdentifier: Scalars['String'];
  skus: SKUConnection;
  stylePrices: Array<StylePrice>;
  tagValues: TagValueConnection;
  /** @deprecated Use tagValues instead */
  tags: TagConnection;
  traitValues: ProductTraitValueConnection;
  variants: ProductSkuVariantConnection;
  videos: Array<Media>;
};


export type ProductcasepacksArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type ProductpriceRangeArgs = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  priceTypeId: Scalars['ID'];
};


export type ProductskusArgs = {
  withCasepacks?: InputMaybe<Scalars['Boolean']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
  withInactive?: InputMaybe<Scalars['Boolean']>;
};


export type ProductstylePricesArgs = {
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type ProductvariantsArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
  withDeletedTraits?: InputMaybe<Array<TraitCode>>;
};

export type ProductAttribute = {
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type: ProductAttributeType;
  value: Scalars['String'];
};

export enum ProductAttributeType {
  TAG = 'TAG',
  TRAIT = 'TRAIT'
}

export type ProductCasepack = Node & {
  description?: Maybe<Scalars['String']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  skus: CasepackSkuConnection;
};


export type ProductCasepackskusArgs = {
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCasepackConnection = {
  edges: Array<ProductCasepackEdge>;
};

export type ProductCasepackEdge = {
  node: ProductCasepack;
};

export type ProductColorPriceLevels = Node & {
  colorId: Scalars['ID'];
  doors: Array<DoorPriceLevels>;
  id: Scalars['ID'];
  priceLevels: Array<PriceLevel>;
  quantity: Scalars['Int'];
  skuCount: Scalars['Int'];
};


export type ProductColorPriceLevelspriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type ProductConnection = {
  edges: Array<ProductEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProductDiscount = Node & {
  factor?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  productId: Scalars['ID'];
};

export type ProductDiscountConnection = {
  edges: Array<Maybe<ProductDiscountEdge>>;
};

export type ProductDiscountEdge = {
  node?: Maybe<ProductDiscount>;
};

export type ProductEdge = {
  cursor: Scalars['String'];
  node: Product;
};

export type ProductImages = {
  orderNbr: Scalars['Int'];
  unmatchedImageId?: InputMaybe<Scalars['ID']>;
  uploadId: Scalars['ID'];
};

export type ProductInfo = {
  collectionId: Scalars['ID'];
  productId: Scalars['ID'];
  variantId?: InputMaybe<Scalars['ID']>;
};

export type ProductLine = {
  id: Scalars['ID'];
  image?: Maybe<Image>;
  name?: Maybe<Scalars['String']>;
};

export enum ProductOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type ProductOrderByField = {
  order?: InputMaybe<ProductOrder>;
  orderByField?: InputMaybe<ProductSortableField>;
};

export type ProductOrderByInput = {
  field?: InputMaybe<ProductOrderByField>;
};

export type ProductPriceLevels = Node & {
  colorPriceLevels: Array<ProductColorPriceLevels>;
  id: Scalars['ID'];
  productId: Scalars['ID'];
  skuPriceLevels: Array<ProductSkuPriceLevels>;
};

export type ProductSkuPriceLevels = Node & {
  id: Scalars['ID'];
  node: SKU;
  priceLevels: Array<PriceLevel>;
  quantity: Scalars['Int'];
  skuCount: Scalars['Int'];
};


export type ProductSkuPriceLevelspriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type ProductSkuVariantConnection = {
  edges: Array<ProductSkuVariantEdge>;
};

export type ProductSkuVariantEdge = {
  node: SkuTrait;
  values: SkuTraitValueConnection;
};

export enum ProductSortableField {
  MODIFIED = 'MODIFIED',
  NAME = 'NAME',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type ProductTrait = Trait & {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum ProductTraitCode {
  CATGENDER = 'CATGENDER',
  DISPCAT = 'DISPCAT',
  DISPSUBCAT = 'DISPSUBCAT',
  DIVISION = 'DIVISION',
  FABNAME = 'FABNAME',
  SILNAME = 'SILNAME'
}

export type ProductTraitConnection = {
  edges: Array<ProductTraitEdge>;
};

export type ProductTraitEdge = {
  node: ProductTrait;
};

export type ProductTraitValue = TraitValue & {
  externalIdentifier: Scalars['String'];
  id: Scalars['ID'];
  trait: ProductTrait;
  value: Scalars['String'];
};

export type ProductTraitValueConnection = {
  edges: Array<ProductTraitValueEdge>;
};

export type ProductTraitValueEdge = {
  node: ProductTraitValue;
};

export type ProductTraitValueInput = {
  traitCode: ProductTraitCode;
  traitValueIds: Array<Scalars['ID']>;
};

export type ProductTraitValuesFilter = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  otherAccountId?: InputMaybe<Scalars['ID']>;
};

export type ProductsCollectionFilter = {
  badgeIds?: InputMaybe<Array<Scalars['ID']>>;
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  deliveryDates?: InputMaybe<Array<DateRange>>;
  inventoryFilter?: InputMaybe<InventoryFilter>;
  ipadEnabled?: InputMaybe<Scalars['Boolean']>;
  priceRange?: InputMaybe<PriceRangeInput>;
  priceTypeId?: InputMaybe<Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  tagValueIds?: InputMaybe<Array<Scalars['String']>>;
  traitValueInputs?: InputMaybe<Array<TraitValueInput>>;
  upc?: InputMaybe<Scalars['String']>;
  withArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ProductsFilter = {
  badgeIds?: InputMaybe<Array<Scalars['ID']>>;
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  colorNames?: InputMaybe<Array<Scalars['String']>>;
  countryOfOriginNames?: InputMaybe<Array<Scalars['String']>>;
  deliveryDates?: InputMaybe<Array<DateRange>>;
  divisionExternalIds?: InputMaybe<Array<Scalars['String']>>;
  divisionNames?: InputMaybe<Array<Scalars['String']>>;
  fabricationExternalIds?: InputMaybe<Array<Scalars['String']>>;
  fabricationNames?: InputMaybe<Array<Scalars['String']>>;
  inventoryFilter?: InputMaybe<InventoryFilter>;
  materialsNames?: InputMaybe<Array<Scalars['String']>>;
  orderIds?: InputMaybe<Array<Scalars['ID']>>;
  priceTypesFilter?: InputMaybe<PriceTypesFilter>;
  productExternalIds?: InputMaybe<Array<Scalars['String']>>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  searchText?: InputMaybe<Scalars['String']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']>>;
  seasonNames?: InputMaybe<Array<Scalars['String']>>;
  seasonYears?: InputMaybe<Array<Scalars['String']>>;
  silhouetteExternalIds?: InputMaybe<Array<Scalars['String']>>;
  silhouetteNames?: InputMaybe<Array<Scalars['String']>>;
  sizeNames?: InputMaybe<Array<Scalars['String']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']>>;
  tagValues?: InputMaybe<Array<Scalars['String']>>;
  traitValueInputs?: InputMaybe<Array<ProductTraitValueInput>>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The status of the connection request between the two accounts. Named
 * distinctly from submissions' own ConnectionRequestStatus (which has two
 * more values, PENDING and NON_EXISTENT, that don't apply to a prospect
 * filter) rather than reusing that type.
 */
export enum ProspectConnectionRequestStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED'
}

export enum Provider3dShowroom {
  ISTAGING = 'ISTAGING',
  MATTERPORT = 'MATTERPORT'
}

/** A JOOR brand publicly-viewable account profile */
export type PublicBrandProfile = BrandProfile & {
  /** Account media url */
  accountMedia?: Maybe<BrandMedia>;
  brandId: Scalars['ID'];
  /** Cover media url */
  coverMedia?: Maybe<BrandMedia>;
  /** Custom Profile images associated with account. Filtered by the online home page */
  customProfileImageUrls: Array<Scalars['String']>;
  /** Custom JOOR URL Handle */
  customUrlHandle?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** @deprecated Use brandId instead */
  id: Scalars['ID'];
  /** iPad photo id */
  ipadPhotoId?: Maybe<Scalars['ID']>;
  /** iPad photo url */
  ipadPhotoUrl?: Maybe<Scalars['String']>;
  /** If the brand is a lite brand */
  isLiteBrand?: Maybe<Scalars['Boolean']>;
  /** Logo image id */
  logoId?: Maybe<Scalars['ID']>;
  /** Logo image url */
  logoUrl?: Maybe<Scalars['String']>;
  /** Account name on JOOR */
  name?: Maybe<Scalars['String']>;
  /** Product lines/categories */
  productLines: Array<Scalars['String']>;
  /** Profile images associated with account. Usually found in about me section. */
  profileImageUrls: Array<Scalars['String']>;
  /** Retail max */
  retailMax?: Maybe<Scalars['Int']>;
  /** Retail min */
  retailMin?: Maybe<Scalars['Int']>;
  /** Social media accounts */
  socialMediaAccounts: Array<SocialMediaAccount>;
  /** Website URL */
  websiteUrl?: Maybe<Scalars['String']>;
  /** Wholesale max */
  wholesaleMax?: Maybe<Scalars['Int']>;
  /** Wholesale min */
  wholesaleMin?: Maybe<Scalars['Int']>;
  /** Year established */
  yearEstablished?: Maybe<Scalars['Int']>;
};


/** A JOOR brand publicly-viewable account profile */
export type PublicBrandProfilecustomProfileImageUrlsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PublicBrandProfileConnection = {
  edges: Array<PublicBrandProfileEdge>;
};

export type PublicBrandProfileEdge = {
  node?: Maybe<PublicBrandProfile>;
};

export type PublicCollection = {
  delivery?: Maybe<PublicDelivery>;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  products: Array<PublicProduct>;
};


export type PublicCollectionproductsArgs = {
  filters?: InputMaybe<PublicProductFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PublicCollectionProductPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PublicCollectionsFilter = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  hasProducts?: InputMaybe<Scalars['Boolean']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
  productPagination?: InputMaybe<PublicCollectionProductPagination>;
  skipLimitByProfileSettings?: InputMaybe<Scalars['Boolean']>;
};

export type PublicDelivery = {
  completeShipDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  startShipDate?: Maybe<Scalars['Date']>;
};

export type PublicItemVisibility = {
  collectionId: Scalars['ID'];
  collectionProductId: Scalars['ID'];
  colorVariantTotal: Scalars['Int'];
  id: Scalars['ID'];
  productId: Scalars['ID'];
  productImageUrl?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  productNumber: Scalars['String'];
  variantId?: Maybe<Scalars['ID']>;
  visible: Scalars['Boolean'];
};

export type PublicLook = Node & {
  id: Scalars['ID'];
  items: Array<PublicItemVisibility>;
  layout: Scalars['String'];
  media: Array<LookMedia>;
  textContents: Array<LookTextContent>;
};

export type PublicLookConnection = {
  edges: Array<PublicLookEdge>;
  pageInfo: PageInfo;
};

export type PublicLookEdge = {
  cursor: Scalars['String'];
  node: PublicLook;
};

/** Publicly accessible mutation */
export type PublicMutation = {
  _empty?: Maybe<Scalars['String']>;
  acceptUserMembershipInvite: MembershipInvitePayload;
  createLiteBrand: LiteBrandPayload;
  createPaymentAnonymously: PaymentPayload;
  createUserMembershipRequest: PublicUserMembershipRequestPayload;
  startShopifyInstallation: StartShopifyInstallationPayload;
  vetRetailer: VettingResult;
};


/** Publicly accessible mutation */
export type PublicMutationacceptUserMembershipInviteArgs = {
  input: AcceptUserMembershipInviteInput;
};


/** Publicly accessible mutation */
export type PublicMutationcreateLiteBrandArgs = {
  input: LiteBrandInput;
};


/** Publicly accessible mutation */
export type PublicMutationcreatePaymentAnonymouslyArgs = {
  input: CreatePaymentWithPaymentMethodInput;
  invoiceId: Scalars['String'];
};


/** Publicly accessible mutation */
export type PublicMutationcreateUserMembershipRequestArgs = {
  input: CreateUserMembershipRequestInput;
};


/** Publicly accessible mutation */
export type PublicMutationstartShopifyInstallationArgs = {
  input: StartShopifyInstallationInput;
};


/** Publicly accessible mutation */
export type PublicMutationvetRetailerArgs = {
  input: RetailerApplicationInput;
};

export type PublicPriceType = {
  currency: Currency;
  id: Scalars['ID'];
  name: Scalars['String'];
  retailCurrency: Currency;
};

export type PublicProduct = Node & {
  description?: Maybe<Scalars['String']>;
  externalMedia: Array<ExternalMedia>;
  id: Scalars['ID'];
  images: Array<Media>;
  keyImage?: Maybe<Media>;
  name: Scalars['String'];
  variants: PublicProductVariant;
};

export type PublicProductFilter = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type PublicProductVariant = {
  colors: Array<PublicProductVariantColor>;
};

export type PublicProductVariantColor = {
  id: Scalars['ID'];
  image?: Maybe<Media>;
  name: Scalars['String'];
  swatch: PublicProductVariantColorSwatch;
};

export type PublicProductVariantColorSwatch = {
  hexColor: Scalars['String'];
  image?: Maybe<Media>;
};

/** Publicly accessible query */
export type PublicQuery = {
  _empty?: Maybe<Scalars['String']>;
  brandProfiles: PublicBrandProfileConnection;
  collectionParamsByShareToken: SharedCollectionParams;
  collectionProductsByShareToken: SharedCollectionProductConnection;
  collections: Array<PublicCollection>;
  geographies: GeographyConnection;
  getOrderByInvoice: InvoiceData;
  identityProvider?: Maybe<IdentityProvider>;
  publicShowroomCollection: PublicShowroomCollection;
  retailer: Array<PublicRetailer>;
  retailerProfile: Array<PublicRetailerProfile>;
  storefronts: Array<Storefront>;
  tradeShowBrands: TradeShowEventBrandConnection;
  tradeShowBrandsCategories: TradeShowEventBrandCategoriesConnection;
  tradeShowRetailers: TradeShowEventRetailerConnection;
  tradeShowRetailersCategories: TradeShowEventRetailerCategoriesConnection;
  tradeShows: TradeShowEventConnection;
  useJoorPay: Scalars['Boolean'];
  useJoorPayLocalPayments: Scalars['Boolean'];
  /** Validate a tax ID for a country. Publicly accessible without authentication. */
  validateTaxId: TaxIdValidationResult;
};


/** Publicly accessible query */
export type PublicQuerybrandProfilesArgs = {
  brandIds: Array<Scalars['ID']>;
};


/** Publicly accessible query */
export type PublicQuerycollectionParamsByShareTokenArgs = {
  token: Scalars['String'];
};


/** Publicly accessible query */
export type PublicQuerycollectionProductsByShareTokenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  token: Scalars['String'];
};


/** Publicly accessible query */
export type PublicQuerycollectionsArgs = {
  brandId: Scalars['ID'];
  filters?: InputMaybe<PublicCollectionsFilter>;
};


/** Publicly accessible query */
export type PublicQuerygeographiesArgs = {
  filter?: InputMaybe<GeographyFilter>;
  types: Array<Scalars['String']>;
};


/** Publicly accessible query */
export type PublicQuerygetOrderByInvoiceArgs = {
  invoiceId: Scalars['String'];
};


/** Publicly accessible query */
export type PublicQueryidentityProviderArgs = {
  email: Scalars['String'];
};


/** Publicly accessible query */
export type PublicQuerypublicShowroomCollectionArgs = {
  showroomCollectionShareToken: Scalars['String'];
};


/** Publicly accessible query */
export type PublicQueryretailerArgs = {
  retailerIds: Array<Scalars['ID']>;
};


/** Publicly accessible query */
export type PublicQueryretailerProfileArgs = {
  retailerIds: Array<Scalars['ID']>;
};


/** Publicly accessible query */
export type PublicQuerystorefrontsArgs = {
  brandIds: Array<Scalars['ID']>;
  filters?: InputMaybe<StorefrontFilters>;
};


/** Publicly accessible query */
export type PublicQuerytradeShowBrandsArgs = {
  filter?: InputMaybe<TradeShowEventBrandFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
};


/** Publicly accessible query */
export type PublicQuerytradeShowBrandsCategoriesArgs = {
  filter?: InputMaybe<TradeShowEventBrandFilter>;
};


/** Publicly accessible query */
export type PublicQuerytradeShowRetailersArgs = {
  filter?: InputMaybe<TradeShowEventRetailerFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
};


/** Publicly accessible query */
export type PublicQuerytradeShowRetailersCategoriesArgs = {
  filter?: InputMaybe<TradeShowEventRetailerFilter>;
};


/** Publicly accessible query */
export type PublicQuerytradeShowsArgs = {
  filter?: InputMaybe<TradeShowEventFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
};


/** Publicly accessible query */
export type PublicQueryuseJoorPayArgs = {
  brandAccountId: Scalars['ID'];
};


/** Publicly accessible query */
export type PublicQueryuseJoorPayLocalPaymentsArgs = {
  brandAccountId: Scalars['ID'];
};


/** Publicly accessible query */
export type PublicQueryvalidateTaxIdArgs = {
  country: Scalars['String'];
  taxId: Scalars['String'];
};

export type PublicRetailer = {
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profileImages?: Maybe<Array<RetailerProfileImage>>;
};

export type PublicRetailerProfile = {
  buyerName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBuyer?: Maybe<Scalars['Boolean']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  logoId?: Maybe<Scalars['ID']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  primaryLocation?: Maybe<Location>;
  profileImages?: Maybe<Array<RetailerProfileImage>>;
  profileSnoozeCounter?: Maybe<Scalars['Int']>;
  socialMediaAccounts?: Maybe<Array<SocialMediaAccount>>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type PublicShowroomCollection = Node & {
  id: Scalars['ID'];
  looks: PublicLookConnection;
  name: Scalars['String'];
  url3dShowroom?: Maybe<Url3dShowroom>;
};

export type PublicUserMembershipRequestPayload = Node & {
  id: Scalars['ID'];
};

export type Query = {
  AssortmentUI__assortment?: Maybe<AssortmentUI__Assortment>;
  AssortmentUI__assortmentSku?: Maybe<AssortmentUI__AssortmentSku>;
  AssortmentUI__configurations?: Maybe<Array<Maybe<Configuration>>>;
  AssortmentUI__getRowColorBulk: AssortmentUI_RowColorBulkQuantities;
  AssortmentUI__getRowSizeBulk: AssortmentUI_RowSizeBulkQuantities;
  /** @deprecated Use 'brandProfiles' instead */
  _brandProfiles: Array<PrivateBrandProfile>;
  _empty?: Maybe<Scalars['String']>;
  _products: Array<Maybe<Product>>;
  /** Query account connections between an account and other specified accounts */
  accountConnectionStatuses: Array<AccountConnectionStatus>;
  /** Query customer codes between the first active account and other specified accounts */
  accountCustomerCodes: Array<AccountCustomerCode>;
  accountExportIntegrationConfigs: Array<ExportIntegrationConfig>;
  accountPaymentProviders: Array<AccountPaymentProvider>;
  accountPermissionAccess: PermissionConnection;
  accountUserDataPermissionConfiguration?: Maybe<DataPermissionConfiguration>;
  accountUserGeoRestrictions: AccountUserGeoRestrictions;
  accountUserPermissionAccess: PermissionConnection;
  activeViewingAccount: Account;
  aggregateSkuInventoryItems: Array<WarehouseAggregateSkuInventoryItemList>;
  /** Query an assortment by its id */
  assortment?: Maybe<Assortment>;
  assortmentSkus: AssortmentSKUConnection;
  assortments: Array<AssortmentSummary>;
  assortmentsForBrand: Array<Assortment>;
  assortmentsForCollection: Array<Assortment>;
  assortmentsQuery: AssortmentConnection;
  backupProducts: BackupProductConnection;
  badges: BadgeConnection;
  /** Get billing contacts for an organization. */
  billingContacts: Array<BillingContact>;
  brandBudgets: BrandBudgetConnection;
  brandDoors: BrandDoorConnection;
  brandMedia: BrandMediaPayload;
  brandProductLines: Array<BrandProductLine>;
  brandProfiles: PrivateBrandProfileConnection;
  brands: BrandConnection;
  casepacks: AccountCasepackConnection;
  categories: CategoryConnection;
  checkMergingAccountCriteria?: Maybe<MergingAccountCriteriaPayload>;
  checkMergingOrderCriteria?: Maybe<MergingOrderCriteriaPayload>;
  /** Check which orders are in sync with the Visual Assortment */
  checkOrdersInVisualAssortment: CheckOrdersInVisualAssortmentResponse;
  checkUserInOrganization: CheckUserInOrganizationPayload;
  /**
   * Everything the Checkout page needs for a set of orders of one brand–retailer pair:
   * each order's saved values plus the pair's option lists and server-side restrictions.
   * Orders that can't be checked out are left out of `orders` and listed in one GraphQL error,
   * under `extensions.orderErrors`.
   */
  checkout: Checkout;
  collectionBanners: CollectionBannerConnection;
  collectionProducts: CollectionProductConnection;
  collectionProductsGroupTotal: Array<CollectionProductGroupTotal>;
  collectionProductsTotal: Scalars['Int'];
  collections: CollectionConnection;
  collectionsDetails: CollectionsDetailsPayload;
  configurations?: Maybe<Array<Maybe<Configuration>>>;
  countriesCurrencies: Array<CountryCurrency>;
  currencies?: Maybe<CurrencyConnection>;
  dataPermissionConfigurations: DataPermissionConfigurationConnection;
  deliveryReportFeature?: Maybe<Scalars['Boolean']>;
  /**
   * Compare current Visual Assortment cards with what would be created on sync.
   * Returns differences: added (new cards), removed (cards that no longer exist),
   * and modified (cards with changes).
   */
  diffVisualAssortmentCards: DiffVisualAssortmentCardsResponse;
  eligibleAccountsForVisualAssortments: Array<VAAccessAccount>;
  eligibleAccountsToLinkToShopifyStore: Array<ShopifyEligibleAccount>;
  /** Get orders that can be used in the visual assortment. */
  eligibleOrdersForVisualAssortments: Array<VAEligibleOrder>;
  externalPaymentByLink: ExternalPayment;
  externalPaymentRecords: Array<PaymentRecord>;
  externalPayments: Array<ExternalPayment>;
  externalProviderAuths: Array<ExternalProviderAuth>;
  /** Query brands favorited by retail account user */
  favoritedBrandsByRetailAccountUser: Array<FavoritedBrand>;
  /** Query brands carried by name */
  findBrandsCarried: LGBrandsCarriedConnection;
  /** Query account connections between an account and other specified accounts */
  findInterestedBrands: Array<Maybe<InterestedBrand>>;
  findProspects: LGRetailerConnection;
  /** Query retailers available for brands */
  findRetailers: LGRetailerConnection;
  generateSubmissionMessage: Scalars['String'];
  geographies: GeographyConnection;
  getBrandStyleIdentifier: GetBrandStyleIdentifierPayload;
  getManageImagesStyleData: GetManageImagesStyleDataPayload;
  getOrderCustomerData?: Maybe<GetOrderCustomerDataPayload>;
  /** Check if the viewing account has access to the Visual Assortment feature */
  hasVisualAssortmentAccess: HasVisualAssortmentFeatureAccessResponse;
  hubs: HubConnection;
  idpConfigs: IdpConfigConnection;
  instagramAccountImages: Array<InstagramAccountImages>;
  instagramAccounts: Array<InstagramAccount>;
  inventoryAvailabilityGroups: InventoryAvailabilityGroupConnection;
  inventoryVisibilitySettings: InventoryVisibilitySettings;
  invoiceExportPaymentDetailsByOrderIds: Array<InvoiceExportPaymentDetails>;
  invoices: Array<InvoiceDelivery>;
  keycloakUser?: Maybe<KeycloakUser>;
  lgGetRequestConnectionData: LGRequestConnectionData;
  listAccountColorSwatches: ListAccountColorSwatchesPayload;
  listAccountConnectionPriceTypes: Array<ConnectionPriceTypeResponse>;
  /** Details about triggered assortment export tasks */
  listAssortmentExportTasks: Array<AssortmentExportTask>;
  listClienteleDescriptions: ClienteleDescriptionConnection;
  listClienteleInterests: ClienteleInterestConnection;
  /** Query Buyers for a given customer record */
  listConnectionBuyers: Array<ConnectionBuyer>;
  listConnectionDiscounts: Array<ConnectionDiscount>;
  listConnectionDoors: Array<ConnectionDoor>;
  listConnectionPaymentMethods: Array<ConnectionPaymentMethod>;
  listConnectionPriceTypes: Array<ConnectionPriceTypeResponse>;
  listConnectionSalesReps: Array<ConnectionSalesRep>;
  listConnectionShippingMethods: Array<ConnectionShippingMethod>;
  listConnectionWarehouses: Array<ConnectionWarehouse>;
  listJobs: CeleryJobConnection;
  listLatestBrands: Array<LatestBrandProfile>;
  listLatestFavoriteBrands: Array<LatestFavoriteBrandProfile>;
  listMonitoringJobs: ListMonitoringJobsPayload;
  listOrderExportTasks: ListOrderExportTasksPayload;
  listRecentBrandAssortments: Array<BrandAssortmentDetailsProfile>;
  listRecentBrandOrders: Array<BrandOrder>;
  /** Query last 5 shared linesheets/showroom collections */
  listRecentSharedCollections: Array<SharedCollection>;
  listRetailerGoogleAddresses: GoogleAddressConnection;
  listRetailerImpersonationFeedback: RetailerImpersonationFeedbackConnection;
  listShopifyStyleSyncErrors: Array<ShopifyStyleSync>;
  listStylesColorSwatch: ListStylesColorSwatchPayload;
  listUnmatchedUploads: ListUnmatchedUploadsPayload;
  look: Look;
  manualPaymentRecords: Array<ManualPaymentRecord>;
  newInvitationCount: MessageCount;
  orb360Products: Orb360ProductPayload;
  orderDiscounts: DiscountConnection;
  orderLineItems: OrderLineItems;
  orderProductDiscounts: OrderProductDiscountConnection;
  orderRequirementChecks: Array<OrderRequirementChecks>;
  orderSettings: Array<OrderSettings>;
  orderStatusChangeEligibility: Array<OrderStatusChangeEligibility>;
  /** @deprecated Use order.products instead */
  orderVariantTotals: OrderVariantTotalsConnection;
  orders: OrderConnection;
  organization?: Maybe<Organization>;
  orphanRetailers: Array<OrphanRetailer>;
  paidAmountsByOrderId: Array<PaidAmount>;
  paymentErrors: Array<PaymentRecord>;
  paymentMethods: Array<PaymentMethodI>;
  paymentProviders: Array<PaymentProvider>;
  paymentRecords: Array<PaymentRecord>;
  premiumFeatures?: Maybe<Array<PremiumFeature>>;
  priceRangeGroups: PriceRangeGroupConnection;
  priceTypes: PriceTypeConnection;
  productDiscounts: ProductDiscountConnection;
  productTraitValues: ProductTraitValueConnection;
  productTraits: ProductTraitConnection;
  products: ProductConnection;
  public: PublicQuery;
  regions: RegionConnection;
  /** Get a specific retailBudget given the RetailWorkspace or Assortment that it is linked to */
  retailBudget?: Maybe<RetailBudget>;
  /** Get a retail workspace by ID */
  retailWorkspace?: Maybe<RetailWorkspace>;
  /** Get retail workspaces from a list of ids */
  retailWorkspaces: Array<RetailWorkspace>;
  /** List all the workspaces and bare assortments in a single query */
  retailWorkspacesAndAssortments: Array<WorkspaceOrAssortment>;
  /** Query a retailer by its id */
  retailer?: Maybe<Retailer>;
  /** Query for private retailer profile */
  retailerProfile: LGRetailerProfile;
  /** Query percentage completed for retailer profile */
  retailerProfileCompletion: RetailerProfileCompletion;
  retailerUsers: RetailerUserConnection;
  /** Query a list of retailers */
  retailers: RetailerConnection;
  /** Query retailers that have liked a brand */
  retailersThatFavoritedBrand: Array<RetailerThatFavoritedBrand>;
  searchBrandAutoComplete: BrandAutoComplete;
  searchBrandCategories: Array<BrandCategory>;
  searchBrandCurrencies: Array<BrandCurrency>;
  searchBrands: PrivateBrandProfileConnection;
  searchRetailersInfo: PrivateRetailerProfileConnection;
  seasons: SeasonConnection;
  shipments: ShipmentConnection;
  shippingReportFeature?: Maybe<Scalars['Boolean']>;
  shopifyIntegrations?: Maybe<Array<ShopifyIntegration>>;
  showroomCollection: ShowroomCollection;
  showroomCollectionListFilters: ShowroomCollectionFilterList;
  showroomCollections: ShowroomCollectionConnection;
  /** List all available size runs, optionally filtered by some criteria */
  sizeRuns: Array<SizeRun>;
  skuDeliveries: SkuDeliveryConnection;
  skuTraits: Array<SkuTrait>;
  skus: SKUConnection;
  storefronts: Array<Storefront>;
  styleboard: Styleboard;
  styleboardComments: StyleboardCommentConnection;
  styleboardLastModified: StyleboardLastModified;
  styleboardListFilters: StyleboardFilterList;
  styleboardVisibleToAccountUsers: CommentAccountUserTagConnection;
  styleboards: StyleboardConnection;
  submission: Submission;
  submissionAuthors?: Maybe<Array<SubmissionAuthor>>;
  submissionTemplates?: Maybe<Array<SubmissionTemplate>>;
  submissions: SubmissionConnection;
  swatchListImageSelector: SwatchListImageSelectorPayload;
  termsAndConditions: BrandTermsAndConditionsConnection;
  totalInOrders: Array<BrandOrderCombination>;
  /** Query retailers that have liked a brand */
  tradeShowEvents: Array<TradeShowEvent>;
  uniqueTagValues: TagValueConnection;
  unreadMessageCount: MessageCount;
  url3dShowroom: Array<Maybe<Url3dShowroom>>;
  user?: Maybe<User>;
  /** Query a list of User Collaboration Invites */
  userCollaborationInvites: CollaborationInviteConnection;
  userMembershipRequests: UserMembershipRequestConnection;
  users: UserConnection;
  usesNewEditAndCreate: Scalars['Boolean'];
  /**
   * Validate a tax ID for a country.
   * @deprecated Use public { validateTaxId } instead.
   */
  validateTaxId: TaxIdValidationResult;
  variantsInCart: Array<VariantInCart>;
  viewingAccountUser: ViewingAccountUser;
  viewingAccounts: Array<Account>;
  viewingUser: ViewingUser;
  /** Get all users with access to the current Visual Assortment Account. */
  visualAssortmentAccessUsers: Array<VisualAssortmentAccessUser>;
  /** Get all attribute keys and their associated values for the VA Account Access */
  visualAssortmentAttributeKeys: Array<VisualAssortmentAttributeKey>;
  /** Get detailed product information for orders in a visual assortment card */
  visualAssortmentCardOrdersDetails: Array<VAOrderProductDetail>;
  /** Get gallery of images for a Visual Assortment */
  visualAssortmentGallery: VisualAssortmentGallery;
  /** Effective Visual Assortment limits for the viewing account */
  visualAssortmentLimits: VisualAssortmentLimitsSummary;
  /** Available global options for visual assortments */
  visualAssortmentOptions: VisualAssortmentOptions;
  /** It's the visualAssortment for the viewing account */
  visualAssortments: Array<VisualAssortment>;
  warehouses: WarehouseConnection;
  zendeskUser: ZendeskUser;
};


export type QueryAssortmentUI__assortmentArgs = {
  assortmentId: Scalars['ID'];
};


export type QueryAssortmentUI__assortmentSkuArgs = {
  skuId: Scalars['ID'];
};


export type QueryAssortmentUI__getRowColorBulkArgs = {
  assortmentId: Scalars['ID'];
};


export type QueryAssortmentUI__getRowSizeBulkArgs = {
  assortmentId: Scalars['ID'];
};


export type Query_brandProfilesArgs = {
  brandIds: Array<Scalars['ID']>;
};


export type Query_productsArgs = {
  productIds: Array<Scalars['ID']>;
};


export type QueryaccountConnectionStatusesArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<AccountConnectionStatusFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AccountConnectionStatusOrderBy>;
  otherAccountIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryaccountCustomerCodesArgs = {
  otherAccountIds: Array<Scalars['ID']>;
};


export type QueryaccountExportIntegrationConfigsArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  integrationTypes: Array<ExportType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
};


export type QueryaccountPaymentProvidersArgs = {
  destinationAccountId: Scalars['ID'];
};


export type QueryaccountPermissionAccessArgs = {
  accountId: Scalars['ID'];
};


export type QueryaccountUserDataPermissionConfigurationArgs = {
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryaccountUserGeoRestrictionsArgs = {
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryaccountUserPermissionAccessArgs = {
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryaggregateSkuInventoryItemsArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AggregateSkuInventoryItemsFilter>;
  includeImmediate?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['String']>;
  warehouseIds: Array<Scalars['ID']>;
};


export type QueryassortmentArgs = {
  id: Scalars['ID'];
};


export type QueryassortmentSkusArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryassortmentsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryassortmentsForBrandArgs = {
  brandId: Scalars['ID'];
};


export type QueryassortmentsForCollectionArgs = {
  collectionId: Scalars['ID'];
  includeCustom?: InputMaybe<Scalars['Boolean']>;
};


export type QueryassortmentsQueryArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AssortmentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AssortmentsQueryOrderBy>;
};


export type QuerybackupProductsArgs = {
  orderIds: Array<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
};


export type QuerybadgesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<BadgeFilter>;
  orderBy?: InputMaybe<BadgeOrderBy>;
};


export type QuerybillingContactsArgs = {
  organizationId: Scalars['ID'];
};


export type QuerybrandBudgetsArgs = {
  filters?: InputMaybe<BrandBudgetFilter>;
};


export type QuerybrandDoorsArgs = {
  brandId: Scalars['ID'];
};


export type QuerybrandMediaArgs = {
  filters?: InputMaybe<BrandMediaFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerybrandProfilesArgs = {
  brandIds: Array<Scalars['ID']>;
};


export type QuerybrandsArgs = {
  filter?: InputMaybe<BrandsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerycasepacksArgs = {
  filters: CasepackFilterInput;
};


export type QuerycheckMergingAccountCriteriaArgs = {
  accountIdsToMerge?: InputMaybe<Array<Scalars['ID']>>;
  targetAccountId?: InputMaybe<Scalars['ID']>;
};


export type QuerycheckMergingOrderCriteriaArgs = {
  orderIds: Array<Scalars['ID']>;
  targetOrderId?: InputMaybe<Scalars['ID']>;
};


export type QuerycheckOrdersInVisualAssortmentArgs = {
  orderIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type QuerycheckUserInOrganizationArgs = {
  input: CheckUserInOrganizationInput;
};


export type QuerycheckoutArgs = {
  brandId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
};


export type QuerycollectionBannersArgs = {
  collectionIds: Array<Scalars['ID']>;
};


export type QuerycollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CollectionProductOrderByInput>;
};


export type QuerycollectionProductsGroupTotalArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
};


export type QuerycollectionProductsTotalArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ProductsCollectionFilter>;
};


export type QuerycollectionsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  excludeCollectionsFromOrders?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<CollectionsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CollectionsOrderBy>;
};


export type QuerycollectionsDetailsArgs = {
  filters?: InputMaybe<CollectionsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CollectionsOrderBy>;
};


export type QuerycountriesCurrenciesArgs = {
  countriesNames: Array<Scalars['String']>;
};


export type QuerycurrenciesArgs = {
  filters?: InputMaybe<CurrencyFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerydataPermissionConfigurationsArgs = {
  filter?: InputMaybe<DataPermissionConfigurationFilter>;
};


export type QuerydeliveryReportFeatureArgs = {
  accountId: Scalars['ID'];
};


export type QuerydiffVisualAssortmentCardsArgs = {
  filterBy?: InputMaybe<DiffFilterBy>;
  visualAssortmentId: Scalars['ID'];
};


export type QueryeligibleOrdersForVisualAssortmentsArgs = {
  filter?: InputMaybe<EligibleOrdersFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type QueryexternalPaymentByLinkArgs = {
  uuid: Scalars['String'];
};


export type QueryexternalPaymentRecordsArgs = {
  externalPaymentId: Scalars['ID'];
};


export type QueryexternalPaymentsArgs = {
  accountId: Scalars['ID'];
};


export type QueryexternalProviderAuthsArgs = {
  filters?: InputMaybe<ExternalProviderAuthFilters>;
};


export type QueryfavoritedBrandsByRetailAccountUserArgs = {
  filter?: InputMaybe<FavoritedBrandsFilter>;
  orderBy?: InputMaybe<FavoritedBrandsOrderBy>;
};


export type QueryfindBrandsCarriedArgs = {
  first?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryfindProspectsArgs = {
  filters?: InputMaybe<FindProspectsFilters>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<FindProspectsOrderBy>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryfindRetailersArgs = {
  filters?: InputMaybe<LGFindRetailersFilters>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LGFindRetailersOrderBy>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QuerygenerateSubmissionMessageArgs = {
  recipientAccountId?: InputMaybe<Scalars['ID']>;
  recipientAccountUserId?: InputMaybe<Scalars['ID']>;
};


export type QuerygeographiesArgs = {
  filter?: InputMaybe<GeographyFilter>;
  types: Array<Scalars['String']>;
};


export type QuerygetManageImagesStyleDataArgs = {
  input: GetManageImagesStyleDataInput;
};


export type QuerygetOrderCustomerDataArgs = {
  orderId: Scalars['ID'];
};


export type QueryhubsArgs = {
  filter?: InputMaybe<HubFilter>;
  pagination?: InputMaybe<PaginationInfo>;
};


export type QueryinstagramAccountImagesArgs = {
  instagramAccountIds: Array<Scalars['ID']>;
};


export type QueryinstagramAccountsArgs = {
  filters?: InputMaybe<InstagramAccountFilters>;
};


export type QueryinventoryAvailabilityGroupsArgs = {
  warehouseId: Scalars['ID'];
};


export type QueryinventoryVisibilitySettingsArgs = {
  brandId: Scalars['ID'];
};


export type QueryinvoiceExportPaymentDetailsByOrderIdsArgs = {
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QueryinvoicesArgs = {
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QuerykeycloakUserArgs = {
  email: Scalars['String'];
};


export type QuerylgGetRequestConnectionDataArgs = {
  brandId: Scalars['ID'];
  retailerId: Scalars['ID'];
};


export type QuerylistAccountColorSwatchesArgs = {
  input: ListAccountColorSwatchesInput;
};


export type QuerylistAccountConnectionPriceTypesArgs = {
  input: ListAccountConnectionPriceTypeInput;
};


export type QuerylistAssortmentExportTasksArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerylistConnectionBuyersArgs = {
  input: ListConnectionBuyersInput;
};


export type QuerylistConnectionDiscountsArgs = {
  input: ListConnectionDiscountInput;
};


export type QuerylistConnectionDoorsArgs = {
  input: ListConnectionDoorsInput;
};


export type QuerylistConnectionPaymentMethodsArgs = {
  input: ListConnectionPaymentMethodsInput;
};


export type QuerylistConnectionPriceTypesArgs = {
  input: ListConnectionPriceTypeInput;
};


export type QuerylistConnectionSalesRepsArgs = {
  input: ListConnectionSalesRepInput;
};


export type QuerylistConnectionShippingMethodsArgs = {
  input: ListConnectionShippingMethodsInput;
};


export type QuerylistConnectionWarehousesArgs = {
  input: ListConnectionWarehousesInput;
};


export type QuerylistJobsArgs = {
  filters: CeleryJobFilter;
};


export type QuerylistLatestBrandsArgs = {
  filters?: InputMaybe<ListLatestBrandsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuerylistMonitoringJobsArgs = {
  input: ListMonitoringJobsRequest;
};


export type QuerylistOrderExportTasksArgs = {
  input: ListOrderExportTasksInput;
};


export type QuerylistRetailerGoogleAddressesArgs = {
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerylistRetailerImpersonationFeedbackArgs = {
  accountIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerylistShopifyStyleSyncErrorsArgs = {
  accountId: Scalars['ID'];
};


export type QuerylistStylesColorSwatchArgs = {
  input: ListStylesColorSwatchInput;
};


export type QuerylistUnmatchedUploadsArgs = {
  input: ListUnmatchedUploadsInput;
};


export type QuerylookArgs = {
  id: Scalars['ID'];
};


export type QuerymanualPaymentRecordsArgs = {
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type Queryorb360ProductsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
};


export type QueryorderDiscountsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  brandRetailerIds?: InputMaybe<Array<BrandRetailerIdentifiers>>;
  retailerId?: InputMaybe<Scalars['ID']>;
};


export type QueryorderLineItemsArgs = {
  filter?: InputMaybe<OrderLineItemsFilter>;
  orderIds: Array<Scalars['ID']>;
};


export type QueryorderProductDiscountsArgs = {
  level?: InputMaybe<OrderDiscountLevel>;
  orderIds: Array<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
};


export type QueryorderRequirementChecksArgs = {
  orderIds: Array<Scalars['ID']>;
};


export type QueryorderSettingsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryorderStatusChangeEligibilityArgs = {
  orderIds: Array<Scalars['ID']>;
  status: OrderStatus;
};


export type QueryorderVariantTotalsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<OrderVariantTotalsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderVariantTotalsOrderBy>;
  orderIds: Array<Scalars['ID']>;
};


export type QueryordersArgs = {
  filters: OrderFilterInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryorganizationArgs = {
  input: OrganizationInput;
};


export type QueryorphanRetailersArgs = {
  request: OrphanRetailersRequest;
};


export type QuerypaidAmountsByOrderIdArgs = {
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QuerypaymentErrorsArgs = {
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QuerypaymentMethodsArgs = {
  brandId: Scalars['ID'];
  paymentProvider?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['ID'];
};


export type QuerypaymentRecordsArgs = {
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']>;
};


export type QuerypriceRangeGroupsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ListPriceRangeGroupsFilter>;
  groupBy?: InputMaybe<PriceRangeGroupBy>;
};


export type QuerypriceTypesArgs = {
  brandIds: Array<Scalars['ID']>;
  filter?: InputMaybe<PriceTypesFilter>;
};


export type QueryproductDiscountsArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
  productIds: Array<Scalars['ID']>;
  retailerId: Scalars['ID'];
};


export type QueryproductTraitValuesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ProductTraitValuesFilter>;
};


export type QueryproductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  brandId?: InputMaybe<Scalars['ID']>;
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<ProductsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ProductOrderByInput>;
};


export type QueryregionsArgs = {
  accountId: Scalars['ID'];
};


export type QueryretailBudgetArgs = {
  assortmentOrWorkspaceId: Scalars['ID'];
};


export type QueryretailWorkspaceArgs = {
  id: Scalars['ID'];
};


export type QueryretailWorkspacesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryretailerArgs = {
  id: Scalars['ID'];
};


export type QueryretailerProfileArgs = {
  id: Scalars['ID'];
};


export type QueryretailerProfileCompletionArgs = {
  id: Scalars['ID'];
};


export type QueryretailerUsersArgs = {
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryretailersArgs = {
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryretailersThatFavoritedBrandArgs = {
  brandAccountId: Scalars['ID'];
  days?: InputMaybe<Scalars['Int']>;
};


export type QuerysearchBrandAutoCompleteArgs = {
  input: AutoCompleteFilter;
};


export type QuerysearchBrandsArgs = {
  input: SearchBrandsFilter;
};


export type QuerysearchRetailersInfoArgs = {
  input: SearchRetailerFilter;
};


export type QueryshippingReportFeatureArgs = {
  accountId: Scalars['ID'];
};


export type QueryshopifyIntegrationsArgs = {
  accountId: Scalars['ID'];
  appName: ShopifyAppName;
};


export type QueryshowroomCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryshowroomCollectionListFiltersArgs = {
  status?: InputMaybe<ShowroomCollectionStatus>;
};


export type QueryshowroomCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShowroomCollectionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ShowroomCollectionOrderBy>;
};


export type QuerysizeRunsArgs = {
  filters?: InputMaybe<SizeRunFilters>;
};


export type QueryskuDeliveriesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  collectionIds: Array<Scalars['ID']>;
  filter?: InputMaybe<SkuDeliveryFilter>;
};


export type QueryskusArgs = {
  ids: Array<Scalars['ID']>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type QuerystorefrontsArgs = {
  brandIds: Array<Scalars['ID']>;
  filters?: InputMaybe<StorefrontFilters>;
};


export type QuerystyleboardArgs = {
  id: Scalars['ID'];
};


export type QuerystyleboardCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<StyleboardCommentsQueryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QuerystyleboardLastModifiedArgs = {
  id: Scalars['ID'];
};


export type QuerystyleboardListFiltersArgs = {
  status?: InputMaybe<StyleboardStatus>;
};


export type QuerystyleboardVisibleToAccountUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  styleboardId: Scalars['ID'];
};


export type QuerystyleboardsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<StyleboardsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StyleboardOrderBy>;
};


export type QuerysubmissionArgs = {
  id: Scalars['ID'];
};


export type QuerysubmissionTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerysubmissionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<SubmissionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryswatchListImageSelectorArgs = {
  input: SwatchListImageSelectorInput;
};


export type QuerytermsAndConditionsArgs = {
  brandIds: Array<Scalars['ID']>;
};


export type QuerytotalInOrdersArgs = {
  filters?: InputMaybe<OrderFilterInput>;
};


export type QuerytradeShowEventsArgs = {
  tradeShowEventIds: Array<Scalars['ID']>;
};


export type QueryuniqueTagValuesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<uniqueTagValuesFilter>;
};


export type Queryurl3dShowroomArgs = {
  filter?: InputMaybe<Url3dShowroomFilter>;
};


export type QueryuserArgs = {
  id: Scalars['ID'];
};


export type QueryuserCollaborationInvitesArgs = {
  filter?: InputMaybe<UserCollaborationInviteFilter>;
};


export type QueryuserMembershipRequestsArgs = {
  accountId: Scalars['ID'];
  filter?: InputMaybe<UserMembershipRequestFilter>;
};


export type QueryusersArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  filter?: InputMaybe<UsersFilter>;
};


export type QueryusesNewEditAndCreateArgs = {
  accountId: Scalars['ID'];
};


export type QueryvalidateTaxIdArgs = {
  country: Scalars['String'];
  taxId: Scalars['String'];
};


export type QueryvariantsInCartArgs = {
  filterBy?: InputMaybe<VariantsInCartFilter>;
};


export type QueryvisualAssortmentCardOrdersDetailsArgs = {
  cardIds: Array<Scalars['ID']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type QueryvisualAssortmentGalleryArgs = {
  visualAssortmentId: Scalars['ID'];
};


export type QueryvisualAssortmentsArgs = {
  defaultOnly?: InputMaybe<Scalars['Boolean']>;
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
};


export type QuerywarehousesArgs = {
  brandId?: InputMaybe<Scalars['ID']>;
};

export type RGB = {
  blue: Scalars['Int'];
  green: Scalars['Int'];
  red: Scalars['Int'];
};

export type ReachPaymentProvider = {
  merchantId?: Maybe<Scalars['String']>;
};

export type ReassignConnectionsInput = {
  accountId: Scalars['ID'];
  sourceAccountUserId: Scalars['ID'];
  targetAccountUserId?: InputMaybe<Scalars['ID']>;
};

export type ReassignConnectionsPayload = {
  success: Scalars['Boolean'];
};

export type RecipientAccountUser = {
  accountUserId: Scalars['ID'];
  displayName: Scalars['String'];
};

export type Region = Node & {
  custom: Scalars['Boolean'];
  geographies: GeographyConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RegionConnection = {
  edges: Array<RegionEdge>;
};

export type RegionEdge = {
  node: Region;
};

export type RemoveAssortmentDoorClustersInput = {
  /** Id of the assortment to remove door clusters */
  assortmentId: Scalars['ID'];
  /** Ids of the door clusters to remove */
  doorClusterIds: Array<Scalars['ID']>;
};

export type RemoveAssortmentDoorClustersPayload = {
  assortment: Assortment;
};

export type RemoveAssortmentDoorsInput = {
  /** Id of the assortment to remove doors */
  assortmentId: Scalars['ID'];
  /** Ids of the doors to remove */
  doorIds: Array<Scalars['ID']>;
};

export type RemoveAssortmentDoorsPayload = {
  assortment: Assortment;
};

export type RemoveAssortmentSkuAttributesInput = {
  assortmentId?: InputMaybe<Scalars['ID']>;
  /** Ids of the attribute options to remove */
  attributeOptionIds: Array<Scalars['ID']>;
  /** Ids of the assortment sku override values being attributed */
  overrideIds: Array<Scalars['ID']>;
};

export type RemoveAssortmentSkuColorAttributesPayload = {
  assortment?: Maybe<Assortment>;
  /** NOTE: There's a known bug with querying images and swatch on these nodes */
  colors?: Maybe<Array<AssortmentSKUColor>>;
  errors?: Maybe<Array<Error>>;
  /** Required to query the assortment in the mutation response */
  query?: Maybe<Query>;
};

export type RemoveOrdersFromVisualAssortmentResponse = {
  /** List of order IDs that were successfully removed from the Visual Assortment sync queue */
  deletedOrderIds: Array<Scalars['ID']>;
  versionDelta: VersionDelta;
};

export type RemoveProductsAndSkusFromCollectionInput = {
  collectionId: Scalars['ID'];
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RemoveSelectedAssortmentAttributeOptionsInput = {
  assortmentId: Scalars['ID'];
  attributeOptionIds: Array<Scalars['ID']>;
};

export type RemoveSelectedAssortmentAttributeOptionsPayload = {
  assortment?: Maybe<Assortment>;
  errors?: Maybe<Array<Error>>;
  query?: Maybe<Query>;
};

/** Response type for removing Visual Assortment Access Users. */
export type RemoveVisualAssortmentAccessUsersResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
};

export type ReplySubmissionInput = {
  message: Scalars['String'];
  subject: Scalars['String'];
  submissionId: Scalars['ID'];
};

export type ReplySubmissionPayload = {
  messageId: Scalars['ID'];
};

export type RequestAssortmentOrderUpdateInput = {
  assortmentId: Scalars['ID'];
  brandSalesRepresentativeEmail: Scalars['String'];
  ccSenderOnEmail?: InputMaybe<Scalars['Boolean']>;
  customMessage?: InputMaybe<Scalars['String']>;
};

export type RequestAssortmentOrderUpdatePayload = {
  assortment: Assortment;
  query?: Maybe<Query>;
};

export type RequestConnectionToRetailerInput = {
  brandId: Scalars['ID'];
  invitationMessage?: InputMaybe<Scalars['String']>;
  otherUserBrands?: InputMaybe<Array<RequestOtherUserBrand>>;
  priceTypes: Array<RequestPriceType>;
  retailerId: Scalars['ID'];
};

export type RequestConnectionToRetailerPayload = {
  brandId: Scalars['ID'];
  connectionStatus: LGConnectionStatus;
  error?: Maybe<Scalars['String']>;
};

export type RequestOtherUserBrand = {
  brandId: Scalars['ID'];
  priceTypes: Array<RequestPriceType>;
};

export type RequestPriceType = {
  priceTypeId: Scalars['ID'];
  termsAndConditionsId?: InputMaybe<Scalars['ID']>;
};

export enum RequestStatus {
  NOT_SENT = 'NOT_SENT',
  SENT = 'SENT'
}

export type RequestedByAccount = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type RequestedByUser = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type ResetPaymentRecordsInput = {
  accountId: Scalars['ID'];
  paymentProvider: Scalars['String'];
};

export type ResetPaymentRecordsPayload = {
  ok: Scalars['Boolean'];
};

export type RetailAssortmentsFilters = {
  /** This will default to false, ignored if status filter is ARCHIVED */
  archived?: InputMaybe<Scalars['Boolean']>;
  createdDateRange?: InputMaybe<AssortmentDateRangeFilter>;
  fullTextSearch?: InputMaybe<Scalars['String']>;
  modifiedDateRange?: InputMaybe<AssortmentDateRangeFilter>;
  status?: InputMaybe<AssortmentStatus>;
};

/** A retail budget is either an Assortment budget or a Workspace budget */
export type RetailBudget = {
  budgetType: BudgetType;
  categoryAmounts: Array<RetailBudgetCategoryAmount>;
  /** The Sum of all top level budget categories in the budget */
  categoryTotals: RetailBudgetCategoryTotals;
  finalExtCost?: Maybe<Scalars['Decimal']>;
  finalExtCostCurrency?: Maybe<Scalars['String']>;
  finalExtRetail?: Maybe<Scalars['Decimal']>;
  finalExtRetailCurrency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The sum of the total metric amounts for all products in the budget */
  productTotals: RetailBudgetCategoryTotals;
  topLevelBudgetCategory?: Maybe<RetailBudgetCategory>;
  totalUnits?: Maybe<Scalars['Decimal']>;
  workspaceOrAssortmentId: Scalars['ID'];
};

/**
 * A RetailBudgetCategory can have Brand, Hierarchy, or Order attribute as type. It is a self-referencing type to allow multiple levels of budgeting. One can budget by _Brand_ as the top-level budget category and then break it down further by _Order attribute_ on the second level. This allows you to specify a budget for each order attribute per brand. For example:
 *
 * Budget Level 1: Brand
 * Selections: Balenciaga, Falke, Missoni
 *
 * Budget Level 2: Order attribute
 * Selections: Phase -> Pre-collection, Phase -> Main Collection, Phase -> Chase.
 *
 * With the budget levels above, we can budget each brand's pre-collection amount:
 * Balenciaga -> Pre-collection has a budget of $10,000.00
 * Falke -> Pre-collection has a budget of $20,000.00
 * Missoni -> Pre-collection has a budget of $30,000.00
 *
 * Similarly, we can budget for all the other second-level categories per brand.
 */
export type RetailBudgetCategory = {
  categoryType: RetailBudgetCategoryType;
  child?: Maybe<RetailBudgetCategory>;
  id: Scalars['ID'];
};

/** Holds data related to the amount for a BudgetCategory. */
export type RetailBudgetCategoryAmount = {
  categoryAmounts?: Maybe<Array<RetailBudgetCategoryAmount>>;
  /** The sum of all category amounts associated with this RetailBudgetCategoryAmount */
  categoryTotals: RetailBudgetCategoryTotals;
  finalExtCost?: Maybe<Scalars['Decimal']>;
  finalExtRetail?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  /** Sum of all metric amounts (including parent amounts) for products that apply to the selection */
  productTotals: RetailBudgetCategoryTotals;
  selection: RetailCategorySelection;
  totalUnits?: Maybe<Scalars['Decimal']>;
};

export type RetailBudgetCategoryAmountInput = {
  /**
   * one of brandId, orderAttributeId or hierarchyElementId must be specified
   * the resolver will throw an error if none of them are specified
   */
  brandId?: InputMaybe<Scalars['ID']>;
  categoryAmounts?: InputMaybe<Array<RetailBudgetCategoryAmountInput>>;
  finalExtCost?: InputMaybe<Scalars['Decimal']>;
  finalExtRetail?: InputMaybe<Scalars['Decimal']>;
  hierarchyElementId?: InputMaybe<Scalars['ID']>;
  /** A new budget category amount will be created if id is omitted */
  id?: InputMaybe<Scalars['ID']>;
  orderAttributeId?: InputMaybe<Scalars['ID']>;
  totalUnits?: InputMaybe<Scalars['Decimal']>;
};

export type RetailBudgetCategoryInput = {
  categoryType: RetailBudgetCategoryType;
  /**
   * "
   * NOTE: Omitting a child category will delete the child categorry.
   */
  child?: InputMaybe<RetailBudgetCategoryInput>;
  /** A new budget category will be created if id is omitted */
  id?: InputMaybe<Scalars['ID']>;
};

export type RetailBudgetCategoryTotals = {
  finalExtCost: Scalars['Decimal'];
  finalExtRetail: Scalars['Decimal'];
  totalUnits: Scalars['Decimal'];
};

/** The supported types that a RetailBudget can be. */
export enum RetailBudgetCategoryType {
  BRAND = 'BRAND',
  HIERARCHY = 'HIERARCHY',
  ORDER_ATTRIBUTE = 'ORDER_ATTRIBUTE'
}

export type RetailBudgetInput = {
  /**
   * "
   * NOTE: If id is included in the input, budgetType, workspaceOrAssortmentId
   * and metric will be ignored. One cannot update the budgetType,
   * workspaceOrAssortmentId or metric of an existing budget
   */
  budgetType: BudgetType;
  /**
   * "
   * NOTE: Omitting amounts when updating an existing budget will delete amounts.
   * categoryAmounts need to contain the completed desired state of the budget.
   */
  categoryAmounts?: InputMaybe<Array<RetailBudgetCategoryAmountInput>>;
  finalExtCost?: InputMaybe<Scalars['Decimal']>;
  finalExtCostCurrency?: InputMaybe<Scalars['String']>;
  finalExtRetail?: InputMaybe<Scalars['Decimal']>;
  finalExtRetailCurrency?: InputMaybe<Scalars['String']>;
  /**
   * A new budget will be created if id is omitted. The RetailBudgetInput needs
   * to included the entire desired state of the budget. Any categories or
   * amounts that are omitted on subsequent edits will be deleted. Any categories
   * and amounts that specifies `id` will be updated. Categories and amounts
   * without `id` will be created.
   */
  id?: InputMaybe<Scalars['ID']>;
  topLevelBudgetCategory?: InputMaybe<RetailBudgetCategoryInput>;
  totalUnits?: InputMaybe<Scalars['Decimal']>;
  workspaceOrAssortmentId: Scalars['ID'];
};

/** A RetailCategorySelection is associated with either a Brand, Hierarchy, or Assortment Attribute */
export type RetailCategorySelection = AttributeOption | MerchandisingHierarchyNode | RetailerBrand;

export type RetailDoorSizeCurves = {
  /** Applicable size curve ratios for this door and product color */
  curveRatios: Array<SizeCurveRatio>;
  door: Door;
};

export type RetailSize = Node & {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type RetailSizeCurves = {
  /** Size curves available for this color by door */
  doorSizeCurves: Array<RetailDoorSizeCurves>;
  /** Indicates a missing required field for a size curve to be applicable */
  missingFields: Array<RetailSizeCurvesMissingFields>;
};

export enum RetailSizeCurvesMissingFields {
  ATTRIBUTE_OPTIONS = 'ATTRIBUTE_OPTIONS',
  BRAND = 'BRAND',
  HIERARCHY = 'HIERARCHY',
  SEASON = 'SEASON',
  SIZE_RUN = 'SIZE_RUN'
}

export type RetailWorkspace = Node & {
  /** A list of currencies common to the assortment POs in the workspace. */
  assortmentCurrencies: Array<RetailWorkspaceAssortmentCurrency>;
  /** Price level roll-ups for the assortment POs in the workspace. */
  assortmentPriceLevels: Array<RetailWorkspaceAssortmentPriceLevel>;
  /** The assortment POs that make up the workspace */
  assortments: Array<Assortment>;
  id: Scalars['ID'];
  /** The name of the workspace */
  name: Scalars['String'];
};


export type RetailWorkspaceassortmentCurrenciesArgs = {
  filters?: InputMaybe<RetailWorkspaceAssortmentCurrencyFilters>;
};


export type RetailWorkspaceassortmentPriceLevelsArgs = {
  filters?: InputMaybe<RetailWorkspaceAssortmentPriceLevelFilters>;
};

export type RetailWorkspaceAssortmentCurrency = Node & {
  assortments: Array<Assortment>;
  currencyCode: CurrencyCode;
  id: Scalars['ID'];
  isCommonCurrency: Scalars['Boolean'];
  workspace: RetailWorkspace;
};

export type RetailWorkspaceAssortmentCurrencyFilters = {
  commonCurrenciesOnly?: InputMaybe<Scalars['Boolean']>;
};

export type RetailWorkspaceAssortmentPriceLevel = Node & {
  currency: RetailWorkspaceAssortmentCurrency;
  extendedCost: RetailWorkspaceAssortmentPriceRange;
  extendedRetail: RetailWorkspaceAssortmentPriceRange;
  id: Scalars['ID'];
  name: FinancialPriceLevelName;
  totalUnitCount: Scalars['Int'];
  workspace: RetailWorkspace;
};

export type RetailWorkspaceAssortmentPriceLevelFilters = {
  commonCurrenciesOnly?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<FinancialPriceLevelName>;
};

export type RetailWorkspaceAssortmentPriceRange = {
  max: Scalars['Decimal'];
  min: Scalars['Decimal'];
};

export type RetailWorkspacePayload = {
  retailWorkspace?: Maybe<RetailWorkspace>;
};

/** A JOOR retailer account */
export type Retailer = Node & {
  accountCreationSource?: Maybe<AccountCreationSource>;
  accountProfile?: Maybe<AccountProfile>;
  /** Query an assortment by its id */
  assortment: Assortment;
  /** Assortment attributes */
  assortmentAttributes: AttributeConnection;
  /** Assortment price modifiers */
  assortmentPriceModifierGroups: PriceModifierGroupConnection;
  /** A list of assortments */
  assortments: AssortmentSummaryConnection;
  attributes: AttributeConnection;
  /** The attribute options available to be applied to assortment sku colors for this retailer */
  availableItemColorAttributeOptions: AttributeOptionConnection;
  /** Brand connections on JOOR */
  brands: RetailerBrandConnection;
  categories?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['Date']>;
  /** Currency conversion defaults */
  currencyConversions: Array<CurrencyConversion>;
  displayName: Scalars['String'];
  /** Retailer doors */
  doors: DoorConnection;
  id: Scalars['ID'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  /** Item color attributes */
  itemColorAttributes: AttributeConnection;
  /** Item color price modifiers */
  itemColorPriceModifierGroups: PriceModifierGroupConnection;
  locations?: Maybe<Array<Location>>;
  /** Flattened merchandising hierarchy */
  merchandisingHierarchy: MerchandisingHierarchyNodeConnection;
  /** A display name */
  name: Scalars['String'];
  privacy?: Maybe<Scalars['Boolean']>;
  /** Set of public information about the retailer */
  publicRetailerProfile?: Maybe<PublicRetailerProfile>;
  /** Specific selling periods used to group assortments */
  seasons: SeasonConnection;
};


/** A JOOR retailer account */
export type RetailerassortmentArgs = {
  id: Scalars['ID'];
};


/** A JOOR retailer account */
export type RetailerassortmentsArgs = {
  filters?: InputMaybe<RetailAssortmentsFilters>;
  hasBeenImported?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<AssortmentsOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


/** A JOOR retailer account */
export type RetailerattributesArgs = {
  ids: Array<Scalars['ID']>;
};


/** A JOOR retailer account */
export type RetaileravailableItemColorAttributeOptionsArgs = {
  brandAccountId: Scalars['ID'];
  buyerHierarchyNodeId?: InputMaybe<Scalars['ID']>;
  selectedOptionIds: Array<Scalars['ID']>;
};


/** A JOOR retailer account */
export type RetailerbrandsArgs = {
  allConnections?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<ListConnectedBrandsFilter>;
};

export type RetailerAccount = {
  /** @deprecated Get account id from the retailerAccount node instead */
  account: Scalars['ID'];
  customer_codes?: Maybe<Array<Maybe<CustomerCode>>>;
  retailerAccount: AccountProfile;
};

/** Visibility options for retailer account access */
export enum RetailerAccountVisibility {
  CURRENT = 'CURRENT',
  HAS_ACCESS = 'HAS_ACCESS',
  NO_ACCESS = 'NO_ACCESS'
}

export type RetailerApplicationInput = {
  accountId?: InputMaybe<Scalars['ID']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  buyerEmail: Scalars['String'];
  buyerName: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type RetailerBrand = Node & {
  alias?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RetailerBrandConnection = {
  edges: Array<RetailerBrandEdge>;
};

/**
 * A connection between a retailer account and brand account on JOOR
 * represents the ability to do business
 */
export type RetailerBrandEdge = {
  /** A display name */
  alias?: Maybe<Scalars['String']>;
  /** A user defined identifier used to distinguish connections to brands. */
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** A brand account */
  node?: Maybe<Brand>;
  profileName?: Maybe<Scalars['String']>;
};

export type RetailerBrandFilter = {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<RetailerBrandEdge>;
};

export type RetailerBrandFilterConnection = {
  edges?: Maybe<Array<RetailerBrandFilter>>;
};

export type RetailerConnection = {
  edges?: Maybe<Array<RetailerEdge>>;
};

export type RetailerEdge = {
  node?: Maybe<Retailer>;
};

export type RetailerImpersonationFeedback = {
  accountId: Scalars['ID'];
  comment?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  modified?: Maybe<Scalars['Date']>;
  option: RetailerImpersonationFeedbackOption;
};

export type RetailerImpersonationFeedbackConnection = {
  edges: Array<RetailerImpersonationFeedbackEdge>;
};

export type RetailerImpersonationFeedbackEdge = {
  node: RetailerImpersonationFeedback;
};

export type RetailerImpersonationFeedbackInput = {
  accountId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  option: RetailerImpersonationFeedbackOption;
};

export enum RetailerImpersonationFeedbackOption {
  OTHER = 'OTHER',
  PERSONAL_SHOPPER = 'PERSONAL_SHOPPER',
  RETAILER_REPRESENTATIVE = 'RETAILER_REPRESENTATIVE',
  UNCONNECTED_ORDERS = 'UNCONNECTED_ORDERS',
  UNKNOWN = 'UNKNOWN'
}

export type RetailerProfileCompletion = {
  id: Scalars['ID'];
  percentage: Scalars['Int'];
};

export type RetailerProfileImage = {
  id: Scalars['ID'];
  upload?: Maybe<RetailerUpload>;
};

export type RetailerRecipient = {
  accountId: Scalars['ID'];
  email: Scalars['String'];
};

export type RetailerShopifyProductSync = ShopifyIntegration & {
  /**
   * Sync settings for every account the requesting user may see: the active
   * account plus any linked account that shares the same Shopify store.
   */
  accountStoreSettings: Array<ShopifyRetailerProductSyncStore>;
  activeAccountStore?: Maybe<ShopifyRetailerProductSyncStore>;
  appName: ShopifyAppName;
  id: Scalars['ID'];
  /** @deprecated use linkedAccounts field instead */
  isEnabled: Scalars['Boolean'];
  isInstalled: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  isSubscriptionActive: Scalars['Boolean'];
  lastSyncDate?: Maybe<Scalars['DateTime']>;
  linkedAccounts: Array<AccountIntegration>;
  shopName: Scalars['String'];
  shopUrl: Scalars['String'];
  storeCurrencyCode: Scalars['String'];
};

export type RetailerSize = Node & {
  /** A unique identifier */
  code: Scalars['String'];
  id: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
};

export type RetailerThatFavoritedBrand = {
  retailerAccountId: Scalars['ID'];
  retailerUser?: Maybe<RetailerUserThatFavoritedBrand>;
  timeFavorited: Scalars['Date'];
  tradeShowEvent?: Maybe<TradeShowEvent>;
};

export type RetailerUpload = {
  id: Scalars['ID'];
  mediaType: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type RetailerUser = Node & {
  code: Scalars['String'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type RetailerUserConnection = {
  edges?: Maybe<Array<RetailerUserEdge>>;
};

export type RetailerUserEdge = {
  node?: Maybe<RetailerUser>;
};

export type RetailerUserThatFavoritedBrand = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type RetailerViewerAccount = BaseAccount & {
  accountCreationSource?: Maybe<AccountCreationSource>;
  accountManagerEmail?: Maybe<Scalars['String']>;
  aliasedName?: Maybe<Scalars['String']>;
  assortmentIntegrations?: Maybe<Array<AssortmentIntegration>>;
  assortmentPlanning: Scalars['Boolean'];
  canFindBrands: Scalars['Boolean'];
  canShop: Scalars['Boolean'];
  enableChat: Scalars['Boolean'];
  hasAssortmentIntegrations?: Maybe<AvailableAssortmentIntegrations>;
  id: Scalars['ID'];
  integrations: Array<Maybe<Scalars['String']>>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  privacy: Scalars['Boolean'];
  status: AccountStatus;
  type?: Maybe<AccountType>;
};

/** Conditional relationships between rules that evaluate if a price modifier is applicable */
export enum RuleConectivity {
  /** Rules will be required to ALL be true */
  AND = 'AND',
  /** Rules will require AT LEAST ONE to be true */
  OR = 'OR'
}

export type RuleItem = RuleSet | SimpleRule;

/** Relationships which evaluate a field-value pair */
export enum RuleRelation {
  /** Evaluate the equality of two values */
  IS = 'IS',
  IS_NOT = 'IS_NOT'
}

/**
 * Nested collection of individually evaluated rule-sets which itself evaluates to true or false. The connectivity field
 * determines how the entire collection evaluates in relation to those rule-sets
 */
export type RuleSet = {
  /** Setting which determines how this collection will evaluate its nested set of rules */
  connectivity: RuleConectivity;
  /** Collection of rules which are individually evaluated */
  rules?: Maybe<Array<RuleItem>>;
};

export type SKU = Node & {
  collections: CollectionConnection;
  /** The color properties of this unit */
  color: Color;
  description?: Maybe<Scalars['String']>;
  doorPrices: SkuDoorPriceConnection;
  /** External SKU identifiers */
  external_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * List of prices with their price types for this unit
   * TODO(smarsh): replace array with a Connection before exposing to external users
   */
  prices: Array<SkuPrice>;
  /** The size properties of this unit */
  size: Size;
  sku_identifier?: Maybe<Scalars['String']>;
  /** List of prices that by default only reads from the sku_prices table */
  sku_prices: Array<SkuPrice>;
  /** Designates whether this unit was created by a brand of a retailer */
  source: Source;
  /** The style properties of this unit */
  style: Style;
  traitValues: SkuTraitValueConnection;
  upc?: Maybe<Scalars['String']>;
  variantValues: SkuTraitValueConnection;
};


export type SKUdoorPricesArgs = {
  doorIds?: InputMaybe<Array<Scalars['ID']>>;
  orderTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
};


export type SKUpricesArgs = {
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SKUConnection = {
  edges?: Maybe<Array<SKUEdge>>;
};

export type SKUEdge = {
  node?: Maybe<SKU>;
};

export type SalesComission = {
  amount?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orderId: Scalars['ID'];
};

export type SalesRepresentative = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SalesRepresentativePayload = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type SaveProductImagesInput = {
  collectionId: Scalars['ID'];
  hasProductImagesChanges: Scalars['Boolean'];
  productId: Scalars['ID'];
  productImages?: InputMaybe<Array<ProductImages>>;
  styleColorsImage?: InputMaybe<Array<StyleColorsImage>>;
};

export type SaveProductImagesPayload = {
  errorCode?: Maybe<Scalars['String']>;
};

export type SaveUnmatchedUploadInput = {
  collectionId: Scalars['ID'];
  file: Scalars['Upload'];
  fileName: Scalars['String'];
};

export type SaveUnmatchedUploadPayload = {
  errorCode?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  unmatchedUploadId?: Maybe<Scalars['ID']>;
  uploadId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type SearchBrandsFilter = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  connectionStatus?: InputMaybe<ConnectionStatus>;
  currencies?: InputMaybe<Array<Scalars['String']>>;
  first: Scalars['Int'];
  hasJoorPay?: InputMaybe<Scalars['Boolean']>;
  maximumPrice?: InputMaybe<Scalars['Int']>;
  minimumPrice?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SearchBrandsSort>;
};

export enum SearchBrandsSort {
  ALPHABETICAL = 'ALPHABETICAL',
  MOST_POPULAR = 'MOST_POPULAR',
  MOST_RELEVANT = 'MOST_RELEVANT',
  NEWEST_LINESHEET = 'NEWEST_LINESHEET',
  RECENTLY_CREATED = 'RECENTLY_CREATED'
}

export type SearchRetailerFilter = {
  connectionStatus?: InputMaybe<ConnectionStatus>;
  first: Scalars['Int'];
  offset: Scalars['Int'];
  searchQuery?: InputMaybe<Scalars['String']>;
};

export type SearchSimilarStylesInput = {
  /** Evaluation override: search this embedding set instead of the served one */
  embeddingSetId?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<SimilarStylesFiltersInput>;
  /** Photos to find similar styles to: JPEG or PNG, at most 5, each at most 10 MB. Never stored. */
  images?: InputMaybe<Array<Scalars['Upload']>>;
  pagination?: InputMaybe<SimilarStylesPaginationInput>;
  /** Existing styles to find more like */
  referenceStyleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** A free-text description of what to find */
  searchText?: InputMaybe<Scalars['String']>;
};

export type SearchSimilarStylesPayload = {
  /** The embedding set that answered */
  embeddingSetId: Scalars['Int'];
  /** Matches in this page only; keep paging while a page comes back full */
  matches: Array<SimilarStyleMatch>;
  /** Positions in input.images that do not look like photographs; results for them may be poor */
  nonPhotographicImageIndexes: Array<Scalars['Int']>;
};

/** A specific selling period used to group assortments */
export type Season = Node & {
  /** A unique identifier */
  code: Scalars['String'];
  id: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
  /** A calendar year */
  year?: Maybe<Scalars['Int']>;
};

export type SeasonConnection = {
  edges: Array<SeasonEdge>;
};

export type SeasonEdge = {
  node: Season;
};

export type SeasonInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  year: Scalars['Int'];
};

export type SeasonName = {
  name?: Maybe<Scalars['String']>;
};

export type SendCollectionsToConnectionsInput = {
  collectionIds: Array<Scalars['ID']>;
  externalEmails?: InputMaybe<Array<Scalars['String']>>;
  messageAttachmentId?: InputMaybe<Scalars['ID']>;
  messageBody: Scalars['String'];
  messageSubject: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  priceTypeId: Scalars['ID'];
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  sendToAllConnections?: InputMaybe<Scalars['Boolean']>;
  tokenActiveDays?: InputMaybe<Scalars['Int']>;
};

export type SendCollectionsToConnectionsPayload = {
  collections?: Maybe<CollectionConnection>;
};

export type SendEmailConfirmationInput = {
  orderId: Scalars['ID'];
};

export type SendEmailConfirmationPayload = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SendInvoicesForOrdersInput = {
  accountId: Scalars['ID'];
  invoicesParameters: Array<InvoiceParameter>;
};

export type SendJoorPayImInterestedEmailInput = {
  language?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type SendJoorPayImInterestedEmailPayload = {
  success: Scalars['Boolean'];
};

export type SendMessageToConnectionInput = {
  body?: InputMaybe<Scalars['String']>;
  recipientId: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  uploadId?: InputMaybe<Scalars['ID']>;
};

export type SendMessageToConnectionPayload = {
  error?: Maybe<Scalars['String']>;
  messageId: Scalars['ID'];
};

export type SendPaymentInput = {
  bccEmails?: InputMaybe<Array<Scalars['String']>>;
  customMessage?: InputMaybe<Scalars['String']>;
  customSubject?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
};

export type SendStyleboardsToEmailsInput = {
  emails: Array<Scalars['String']>;
  message: Scalars['String'];
  sendCopyToSender: Scalars['Boolean'];
  styleboardIds: Array<Scalars['ID']>;
};

export type SendStyleboardsToEmailsPayload = {
  errors?: Maybe<Array<Error>>;
};

export type SetAssormentDefaultDoorClustersInput = {
  /** List of default cluster ids */
  clusterIds?: InputMaybe<Array<Scalars['ID']>>;
  /** List of default door ids */
  doorIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SetAssortmentColorBulkDoorQuantityInput = {
  assortmentId: Scalars['ID'];
  bulkQuantity: Scalars['Int'];
  clusterId?: InputMaybe<Scalars['ID']>;
  colorId: Scalars['ID'];
  doorId?: InputMaybe<Scalars['ID']>;
  skuId: Scalars['ID'];
};

export type SetAssortmentColorBulkDoorQuantityPayload = {
  assortment: Assortment;
  color: AssortmentSKUColor;
  query?: Maybe<Query>;
};

export type SetAssortmentCurrencyConversionInput = {
  /** The ID of the assortment to update */
  assortmentId: Scalars['ID'];
  /** Multiplicative conversion rate applied */
  factor: Scalars['Decimal'];
  /** Initial currency */
  fromCurrencyCode: Scalars['String'];
  /** Final currency */
  toCurrencyCode: Scalars['String'];
};

export type SetAssortmentCurrencyConversionPayload = {
  assortmentCurrencyConversion?: Maybe<AssortmentCurrencyConversion>;
  errors?: Maybe<Array<Error>>;
};

export type SetAssortmentDefaultDoorClustersPayload = {
  /** List of default cluster ids */
  clusterIds?: Maybe<Array<Scalars['ID']>>;
  /** List of default door ids */
  doorIds?: Maybe<Array<Scalars['ID']>>;
};

export type SetAssortmentDoorClustersInput = {
  /** Id of the assortment to create or update door clusters */
  assortmentId: Scalars['ID'];
  /** Door clusters to create or update */
  doorClusters: Array<DoorClusterInput>;
};

export type SetAssortmentDoorClustersPayload = {
  assortment: Assortment;
};

export type SetAssortmentDoorsInput = {
  /** Id of the assortment to create or update door clusters */
  assortmentId: Scalars['ID'];
  /** Door clusters to create or update */
  doorClusters: Array<DoorClusterInput>;
  /** Ids of the doors to include */
  doorIds: Array<Scalars['ID']>;
};

export type SetAssortmentDoorsPayload = {
  assortment: Assortment;
};

export type SetAssortmentMerchandisingHierarchyInput = {
  assortmentId: Scalars['ID'];
  merchandisingHierarchyNodeId: Scalars['ID'];
};

export type SetAssortmentMerchandisingHierarchyPayload = {
  assortment?: Maybe<Assortment>;
};

export type SetAssortmentProductPricePayload = {
  assortment?: Maybe<Assortment>;
  query?: Maybe<Query>;
};

export type SetAssortmentProductRetailPriceInput = {
  assortmentId: Scalars['ID'];
  itemId: Scalars['ID'];
  retailCurrencyCode?: InputMaybe<CurrencyCode>;
  retailPrice?: InputMaybe<Scalars['Decimal']>;
};

export type SetAssortmentProductWholesalePriceInput = {
  assortmentId: Scalars['ID'];
  itemId: Scalars['ID'];
  wholesaleCurrencyCode?: InputMaybe<CurrencyCode>;
  wholesalePrice?: InputMaybe<Scalars['Decimal']>;
};

export type SetAssortmentProductWholesalePricePayload = {
  assortment?: Maybe<Assortment>;
  query?: Maybe<Query>;
};

export type SetAssortmentSharesInput = {
  assortmentId: Scalars['ID'];
  shares: Array<AssortmentShareInput>;
};

export type SetAssortmentSharesPayload = {
  assortment: Assortment;
};

export type SetAssortmentSizedDoorQuantityInput = {
  assortmentId: Scalars['ID'];
  doorId: Scalars['ID'];
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export type SetAssortmentSizedDoorQuantityPayload = {
  assortment: Assortment;
  sku: AssortmentSKUEdge;
};

export type SetAssortmentSkuDoorLineItemBulkQuantityPayload = {
  assortment: Assortment;
  destination?: Maybe<AssortmentSkuDoorLineItemBulkQuantityDoorOrCluster>;
  lineItems: Array<LineItem>;
  quantity: Scalars['Int'];
  query?: Maybe<Query>;
};

export type SetAssortmentSkuFinalRetailPriceInput = {
  assortmentId: Scalars['ID'];
  finalRetailPrice: Scalars['Decimal'];
  finalRetailPriceCurrencyCode: CurrencyCode;
  skuIds: Array<Scalars['ID']>;
};

export type SetAssortmentSkuFinalRetailPricePayload = {
  assortment: Assortment;
  doors: Array<DoorPriceLevels>;
  products: Array<ProductPriceLevels>;
  query?: Maybe<Query>;
  total: TotalPriceLevels;
};

export type SetAssortmentSkuRetailPriceInput = {
  assortmentId: Scalars['ID'];
  currencyCode?: InputMaybe<Scalars['String']>;
  retailPrice?: InputMaybe<Scalars['Decimal']>;
  skuIds: Array<Scalars['ID']>;
};

export type SetAssortmentSkuRetailPricePayload = {
  assortment: Assortment;
  doors?: Maybe<Array<DoorPriceLevels>>;
  products: Array<ProductPriceLevels>;
  query?: Maybe<Query>;
  total: TotalPriceLevels;
};

export type SetAssortmentSkuUpcInput = {
  itemColorId: Scalars['String'];
  itemSizeId: Scalars['String'];
  upc: Scalars['String'];
};

export type SetAssortmentSkuUpcPayload = {
  assortment?: Maybe<Assortment>;
  error?: Maybe<Error>;
  query?: Maybe<Query>;
};

export type SetAssortmentSkuWholesalePriceInput = {
  assortmentId: Scalars['ID'];
  currencyCode?: InputMaybe<Scalars['String']>;
  skuIds: Array<Scalars['ID']>;
  wholesalePrice?: InputMaybe<Scalars['Decimal']>;
};

export type SetAssortmentSkuWholesalePricePayload = {
  assortment: Assortment;
  doors: Array<DoorPriceLevels>;
  products: Array<ProductPriceLevels>;
  query?: Maybe<Query>;
  total: TotalPriceLevels;
};

/** Overwrite the attribute options filters for an attribute option */
export type SetAttributeOptionFilterForAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars['ID'];
  /** The other attribute option IDs that will filter this attribute option */
  filterAttributeOptionIds: Array<Scalars['ID']>;
};

export type SetAttributeOptionFilterForAttributeOptionPayload = {
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

export type SetBudgetGoalInput = {
  /** The goal to update */
  goal: BudgetGoalType;
  /** The value to set for this goal */
  value: Scalars['String'];
};

/** Overwirtes goals for a budget */
export type SetBudgetGoalsInput = {
  /** Id of the object to update */
  budgetId: Scalars['ID'];
  /** The goals to set for this budget */
  goals: Array<SetBudgetGoalInput>;
};

export type SetBudgetGoalsPayload = {
  budget?: Maybe<Budget>;
  errors?: Maybe<Array<Error>>;
};

export type SetCollectionDeliveryInput = {
  cancelDate?: InputMaybe<Scalars['Date']>;
  collectionId: Scalars['ID'];
  completeShipDate?: InputMaybe<Scalars['Date']>;
  minimumShippingWindow?: InputMaybe<Scalars['Int']>;
  startShipDate?: InputMaybe<Scalars['Date']>;
};

export type SetCurrencyConversionInput = {
  /** Multiplicative conversion rate applied */
  factor: Scalars['Decimal'];
  /** Initial currency */
  fromCurrencyCode: Scalars['String'];
  /** The ID of the retailer for which to create this currency conversion */
  retailerId: Scalars['ID'];
  /** Final currency */
  toCurrencyCode: Scalars['String'];
};

export type SetCurrencyConversionPayload = {
  currencyConversion?: Maybe<CurrencyConversion>;
  errors?: Maybe<Array<Error>>;
};

export type SetCustomerRecordPaymentMethodRequest = {
  customerRecordId: Scalars['ID'];
  paymentMethodsIds: Array<PaymentMethodIdentifier>;
};

/**
 * Sets the default display language for a user.
 * Valid language codes are listed in app/View/Accounts/settings.ctp and correspond to Localize.js codes.
 * If the language code inputted is invalid, there will be no error thrown and the display language will not be changed.
 */
export type SetDisplayLanguageForUserInput = {
  /** The ID of the user */
  id: Scalars['ID'];
  /** The language code to set the user's display language to */
  languageCode: Scalars['String'];
};

/** Return the user id and language code for the user's updated display language. */
export type SetDisplayLanguageForUserPayload = {
  displayLanguage: Scalars['String'];
  id: Scalars['ID'];
};

export type SetImpersonatedUserInput = {
  impersonated_account_id?: InputMaybe<Scalars['String']>;
  impersonated_user_id: Scalars['String'];
};

export type SetImpersonatedUserPayload = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Overwrite the merchandising hierarchy filters for an attribute option */
export type SetMerchandisingHierarchyFilterForAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars['ID'];
  /** The merchandising hierarchy node IDs that will filter this attribute option */
  filterMerchandisingHierarchyNodeIds: Array<Scalars['ID']>;
};

export type SetMerchandisingHierarchyFilterForAttributeOptionPayload = {
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

/** Update details of a price modifier */
export type SetPriceModifierValueInput = {
  /** Id of assortment */
  assortmentId: Scalars['ID'];
  /** Factor to apply */
  factor?: InputMaybe<Scalars['Decimal']>;
  /** Id of price_modifier_field */
  groupId: Scalars['ID'];
  /** Id of the object to update */
  priceModifierId?: InputMaybe<Scalars['ID']>;
};

export type SetPriceModifierValuePayload = {
  /** The assortment whose price modifiers were updated */
  assortment: Assortment;
  deletePriceModifierId?: Maybe<Scalars['ID']>;
  priceModifier?: Maybe<PriceModifier>;
};

export type SetProductSizeRunResponse = {
  assortment?: Maybe<Assortment>;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  sizeRun?: Maybe<SizeRun>;
};

export type SetProductTraitValueInput = {
  externalIdentifier?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
  traitId: Scalars['String'];
  value: Scalars['String'];
};

/** Overwrite the brand filters for an attribute option */
export type SetRetailerBrandFilterForAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars['ID'];
  /** The brand IDs that will filter this attribute option */
  filterRetailerBrandIds: Array<Scalars['ID']>;
};

export type SetRetailerBrandFilterForAttributeOptionPayload = {
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

export type SetRetailerProductSizesOnAssortmentInput = {
  productId: Scalars['ID'];
  sizes: Array<CustomSizeRequest>;
};

export type SetRetailerProductSizesOnAssortmentPayload = {
  assortment?: Maybe<Assortment>;
};

export type SetSelectedAccountInput = {
  account_id: Scalars['String'];
  switch_from?: InputMaybe<SwitchFromType>;
};

export type SetSelectedAccountPayload = {
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SetSelectedAssortmentAttributeOptionsInput = {
  assortmentId: Scalars['ID'];
  attributeOptionIds: Array<Scalars['ID']>;
};

export type SetSelectedAssortmentAttributeOptionsPayload = {
  assortment?: Maybe<Assortment>;
  errors?: Maybe<Array<Error>>;
  query?: Maybe<Query>;
};

export type SetSkuItemPropertyInput = {
  id: Scalars['ID'];
  propertyName: Scalars['String'];
  propertyValue: Scalars['String'];
};

export type SetSkuItemPropertyPayload = {
  assortment?: Maybe<Assortment>;
  id: Scalars['ID'];
  propertyName: Scalars['String'];
  propertyValue: Scalars['String'];
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
};

export type SetSkuRetailSizeResponse = {
  assortment?: Maybe<Assortment>;
  /** Generic top level query field to query updated skus */
  query?: Maybe<Query>;
  retailSize?: Maybe<RetailSize>;
};

export type SetSkuUpcInput = {
  skuId: Scalars['ID'];
  upc: Scalars['String'];
};

export type SetUserPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type SetUserPasswordPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

/** Response type for setting Visual Assortment default grouping. */
export type SetVisualAssortmentDefaultGroupingResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
  versionDelta: VersionDelta;
};

export type ShareAndSendLinesheetsWithCollaborationInvitesEmailsInput = {
  collaborationInviteRequests: Array<createCollaborationInviteInput>;
  collectionIds: Array<Scalars['ID']>;
  messageAttachmentId?: InputMaybe<Scalars['ID']>;
  messageBody: Scalars['String'];
  messageSubject: Scalars['String'];
  notify?: InputMaybe<Scalars['Boolean']>;
  priceTypeId: Scalars['ID'];
  tokenActiveDays?: InputMaybe<Scalars['Int']>;
};

export type ShareAndSendLinesheetsWithCollaborationInvitesEmailsPayload = {
  errors?: Maybe<Array<Error>>;
};

export type ShareAndSendStyleboardsWithCollaborationInvitesEmailsInput = {
  collaborationInviteRequests: Array<createCollaborationInviteInput>;
  message: Scalars['String'];
  sendCopyToSender: Scalars['Boolean'];
  styleboardIds: Array<Scalars['ID']>;
};

export type ShareAndSendStyleboardsWithCollaborationInvitesEmailsPayload = {
  errors?: Maybe<Array<Error>>;
};

export type ShareBrand = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShareCollection = {
  delivery: PublicDelivery;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShareCollectionsWithRetailersInput = {
  collectionIds: Array<Scalars['ID']>;
  retailerIds: Array<Scalars['ID']>;
};

export type ShareCollectionsWithRetailersPayload = {
  collections: CollectionConnection;
};

export type ShareParamsCollection = {
  banners?: Maybe<Banners>;
  code?: Maybe<Scalars['String']>;
  delivery?: Maybe<Delivery>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  madeToOrder: Scalars['Boolean'];
  name: Scalars['String'];
  season?: Maybe<Season>;
  textStyles?: Maybe<Array<CollectionTextStyle>>;
};

export type ShareShowroomCollectionInput = {
  extraEmailRecipients?: InputMaybe<Array<Scalars['String']>>;
  message?: InputMaybe<Scalars['String']>;
  retailerRecipients: Array<RetailerRecipient>;
  sendCopy: Scalars['Boolean'];
  sendTokenizedLink?: InputMaybe<Scalars['Boolean']>;
  showroomCollectionId: Scalars['ID'];
  teamRecipientIds: Array<Scalars['ID']>;
  tokenActiveDays?: InputMaybe<Scalars['Int']>;
};

export type ShareShowroomCollectionWithTeamMembersInput = {
  message?: InputMaybe<Scalars['String']>;
  sendCopyToSender: Scalars['Boolean'];
  showroomCollectionId: Scalars['ID'];
  teamRecipientIds: Array<Scalars['ID']>;
};

export type ShareStyleboardInput = {
  externalRecipients: Array<ExternalRecipient>;
  styleboardId: Scalars['ID'];
  teamRecipientIds: Array<Scalars['ID']>;
};

export type SharedCollection = {
  brandId: Scalars['ID'];
  brandImage?: Maybe<Media>;
  brandName: Scalars['String'];
  collectionType: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated Use sharedOnDate instead */
  sharedOn: Scalars['Date'];
  sharedOnDate: Scalars['Date'];
};

export type SharedCollectionParams = {
  brand: ShareBrand;
  collection: ShareParamsCollection;
  hasAccess: Scalars['Boolean'];
  id: Scalars['ID'];
  priceType: PublicPriceType;
};

export type SharedCollectionProduct = Node & {
  collection: ShareCollection;
  comments: Scalars['String'];
  id: Scalars['ID'];
  product: SharedProduct;
  variants: Array<SharedVariants>;
};

export type SharedCollectionProductConnection = {
  edges: Array<SharedCollectionProductEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type SharedCollectionProductEdge = {
  cursor: Scalars['String'];
  node: SharedCollectionProduct;
};

export type SharedProduct = {
  badges: Array<Badge>;
  externalMedia: Array<ExternalMedia>;
  id: Scalars['ID'];
  imageUrls: Array<Scalars['String']>;
  name: Scalars['String'];
  priceRange?: Maybe<PriceRange>;
  traitValues: Array<SharedProductTraitValue>;
};

export type SharedProductTraitValue = {
  /** @deprecated use externalIdentifier instead */
  customerCode?: Maybe<Scalars['String']>;
  externalIdentifier: Scalars['String'];
  id: Scalars['ID'];
  trait: SharedTrait;
  value: Scalars['String'];
};

export type SharedTrait = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SharedValues = {
  /** @deprecated use externalIdentifier instead */
  customerCode: Scalars['String'];
  displayDetails: TraitValueDisplayDetails;
  externalIdentifier: Scalars['String'];
  id: Scalars['ID'];
  trait: SharedTrait;
  value: Scalars['String'];
};

export type SharedVariants = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  values: Array<SharedValues>;
};

export type Shipment = {
  brand: Brand;
  carrier: Scalars['String'];
  confirmedUnits: Scalars['Int'];
  expectedDeliveryDate: Scalars['Date'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  openUnits: Scalars['Int'];
  requestedDeliveryDate: Scalars['Date'];
  requestedUnits: Scalars['Int'];
  retailer: Retailer;
  shippedUnits: Scalars['Int'];
  shippingDeliveryDate?: Maybe<Scalars['Date']>;
  status: ShipmentStatus;
  trackingNumber: Scalars['String'];
  trackingUrl: Scalars['String'];
};

export type ShipmentConnection = {
  edges: Array<ShipmentEdge>;
};

export type ShipmentEdge = {
  node: Shipment;
};

export enum ShipmentStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  INVOICED = 'INVOICED',
  IN_PREPARATION = 'IN_PREPARATION',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  PARTIALLY_INVOICED = 'PARTIALLY_INVOICED',
  SHIPPED = 'SHIPPED',
  UNKNOWN = 'UNKNOWN'
}

export type ShippingAddress = {
  address?: Maybe<HyperionAddress>;
  code?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ShippingAddressPayload = {
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ShippingInfo = {
  address?: InputMaybe<AddressInput>;
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  shippingAccount?: InputMaybe<Scalars['String']>;
  shippingAddressId?: InputMaybe<Scalars['ID']>;
  shippingMethodId?: InputMaybe<Scalars['ID']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type ShippingMethod = Node & {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShippingMethodConnection = {
  edges: Array<ShippingMethodEdge>;
};

export type ShippingMethodEdge = {
  node: ShippingMethod;
};

export enum ShopifyAppName {
  BRAND_SYNC = 'BRAND_SYNC',
  RETAILER_PRODUCT_SYNC = 'RETAILER_PRODUCT_SYNC'
}

export type ShopifyBrandSyncSettings = {
  accountId: Scalars['ID'];
  canPerformFullSync?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastFullSyncAt?: Maybe<Scalars['DateTime']>;
  retailPriceMultiplier?: Maybe<Scalars['String']>;
  storeId: Scalars['ID'];
  wholesalePriceMultiplier?: Maybe<Scalars['String']>;
};

export type ShopifyColor = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShopifyEligibleAccount = {
  account: Retailer;
  id: Scalars['ID'];
  isSelected: Scalars['Boolean'];
};

export type ShopifyIntegration = {
  appName: ShopifyAppName;
  id: Scalars['ID'];
  /** @deprecated use linkedAccounts field instead */
  isEnabled: Scalars['Boolean'];
  isInstalled: Scalars['Boolean'];
  isIntegrated: Scalars['Boolean'];
  isSubscriptionActive: Scalars['Boolean'];
  lastSyncDate?: Maybe<Scalars['DateTime']>;
  linkedAccounts: Array<AccountIntegration>;
  shopName: Scalars['String'];
  shopUrl: Scalars['String'];
  storeCurrencyCode: Scalars['String'];
};

export type ShopifyJoorAccount = {
  accountId: Scalars['String'];
  accountName: Scalars['String'];
};

export type ShopifyRetailerProductSyncSettings = {
  autoSyncProducts: Scalars['Boolean'];
  id: Scalars['ID'];
  syncBrandName: Scalars['Boolean'];
  syncBrandNameStyleName: Scalars['Boolean'];
  syncCategory: Scalars['Boolean'];
  syncLinesheet: Scalars['Boolean'];
  syncMedia: Scalars['Boolean'];
  syncRetailPrice: Scalars['Boolean'];
  syncSilhouette: Scalars['Boolean'];
  syncSkuCode: Scalars['Boolean'];
  syncSkuPrices: Scalars['Boolean'];
  syncStyleDescription: Scalars['Boolean'];
  /** @deprecated Style name is always synced; this is always true */
  syncStyleName: Scalars['Boolean'];
  syncUpcCode: Scalars['Boolean'];
};

export type ShopifyRetailerProductSyncSettingsInput = {
  /** Deprecated: Use accountIds instead. */
  accountId?: InputMaybe<Scalars['ID']>;
  accountIds?: InputMaybe<Array<Scalars['ID']>>;
  autoSyncProducts?: InputMaybe<Scalars['Boolean']>;
  syncBrandName?: InputMaybe<Scalars['Boolean']>;
  syncBrandNameStyleName?: InputMaybe<Scalars['Boolean']>;
  syncCategory?: InputMaybe<Scalars['Boolean']>;
  syncLinesheet?: InputMaybe<Scalars['Boolean']>;
  syncMedia?: InputMaybe<Scalars['Boolean']>;
  syncRetailPrice?: InputMaybe<Scalars['Boolean']>;
  syncSilhouette?: InputMaybe<Scalars['Boolean']>;
  syncSkuCode?: InputMaybe<Scalars['Boolean']>;
  syncSkuPrices?: InputMaybe<Scalars['Boolean']>;
  syncStyleDescription?: InputMaybe<Scalars['Boolean']>;
  syncStyleName?: InputMaybe<Scalars['Boolean']>;
  syncUpcCode?: InputMaybe<Scalars['Boolean']>;
};

export type ShopifyRetailerProductSyncStore = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  styleSyncErrors: Array<ShopifyStyleSync>;
  syncSettings?: Maybe<ShopifyRetailerProductSyncSettings>;
};

export type ShopifySKU = {
  color: ShopifyColor;
  id: Scalars['ID'];
  size: ShopifySize;
};

export type ShopifySize = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShopifyStyle = {
  externalIdentifier: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ShopifyStyleSync = Node & {
  createdDate?: Maybe<Scalars['Date']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  product: ShopifyStyle;
  sku?: Maybe<ShopifySKU>;
};

export type ShopifySyncDetails = {
  lastOrderSyncAt?: Maybe<Scalars['String']>;
  lastProductSyncAt?: Maybe<Scalars['String']>;
  totalOrdersSync?: Maybe<Scalars['Int']>;
  totalProductSync?: Maybe<Scalars['Int']>;
};

export type ShowroomCollection = Node & {
  brand: Brand;
  created: Scalars['Date'];
  id: Scalars['ID'];
  lastModified: Scalars['Date'];
  looks: LookConnection;
  name: Scalars['String'];
  owner: ShowroomCollectionOwner;
  showroomCollectionShares: ShowroomCollectionShare;
  status: ShowroomCollectionStatus;
  url3dShowroom?: Maybe<Url3dShowroom>;
  visibleToAllConnected: Scalars['Boolean'];
};

export type ShowroomCollectionConnection = {
  edges: Array<ShowroomCollectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ShowroomCollectionEdge = {
  cursor: Scalars['String'];
  node: ShowroomCollection;
};

export type ShowroomCollectionFilterList = {
  brands: Array<FilterItem>;
  ownerUsers: Array<FilterItem>;
  sharedAccounts: Array<FilterItem>;
  sharedUsers: Array<FilterItem>;
  showroomCollections: Array<FilterItem>;
};

export enum ShowroomCollectionOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type ShowroomCollectionOrderBy = {
  field?: InputMaybe<ShowroomCollectionOrderByField>;
  order?: InputMaybe<ShowroomCollectionOrder>;
};

export enum ShowroomCollectionOrderByField {
  BRAND = 'BRAND',
  CREATED_DATE = 'CREATED_DATE',
  CREATOR_NAME = 'CREATOR_NAME',
  MODIFIED_DATE = 'MODIFIED_DATE',
  SHARED_DATE = 'SHARED_DATE',
  SHOWROOM_COLLECTION_NAME = 'SHOWROOM_COLLECTION_NAME'
}

export type ShowroomCollectionOwner = {
  displayName: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type ShowroomCollectionShare = {
  retailerRecipients: Array<ShowroomCollectionShareRetailerRecipient>;
  showroomCollectionId: Scalars['ID'];
  teamRecipients: Array<ShowroomCollectionShareTeamRecipient>;
};

export type ShowroomCollectionShareRetailerRecipient = {
  email: Scalars['String'];
  retailer: Retailer;
  shareDate?: Maybe<Scalars['Date']>;
};

export type ShowroomCollectionShareTeamRecipient = {
  brand: Brand;
  shareDate?: Maybe<Scalars['Date']>;
  user: User;
};

export enum ShowroomCollectionStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type ShowroomCollectionTokenizedLink = {
  showroomCollectionId: Scalars['ID'];
  tokenizedLink: Scalars['String'];
};

export type ShowroomCollectionsFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  createdDate?: InputMaybe<DateRange>;
  modifiedDate?: InputMaybe<DateRange>;
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  sharedAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  sharedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  showroomCollectionIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<ShowroomCollectionStatus>;
};

export type Silhouette = {
  name: Scalars['String'];
};

export type SimilarStyleMatch = {
  /** Cosine similarity, higher is closer */
  score: Scalars['Float'];
  styleId: Scalars['ID'];
};

export type SimilarStylesFiltersInput = {
  /** Restrict matches to these brand accounts */
  accountIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Restrict matches to these categories */
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Drop the requesting account's own styles from the results */
  excludeOwnStyles?: InputMaybe<Scalars['Boolean']>;
};

export type SimilarStylesPaginationInput = {
  /** Page size, 20 by default and at most 100 */
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Rule which is evaluated based on a conditional relationship between a fetched and a given value */
export type SimpleRule = {
  /** Field on which the rule will act */
  field: Scalars['String'];
  /** Relation between the field and value which will be evaluated */
  relation: RuleRelation;
  /** Value of to compare the field to */
  value: Scalars['ID'];
};

export type Size = Node & {
  /** A unique identifier */
  code: Scalars['String'];
  id: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
};

export type SizeCurveRatio = {
  ratio: Scalars['Decimal'];
  retailSize: RetailSize;
};

export type SizeRun = Node & {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type SizeRunEdge = {
  node?: Maybe<SizeRun>;
};

export type SizeRunFilters = {
  /** Filter by a list of selected attribute options */
  attributeOptionIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by brand account */
  brandId?: InputMaybe<Scalars['ID']>;
  /** Filter by applied merchandising hierarchy */
  merchandisingHierarchyId?: InputMaybe<Scalars['ID']>;
};

export type SkuComment = {
  comment: Scalars['String'];
  skuId: Scalars['ID'];
};

export type SkuDelivery = {
  collection: Collection;
  completeShipDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  product: Product;
  sku: SKU;
  startShipDate?: Maybe<Scalars['Date']>;
};

export type SkuDeliveryConnection = {
  edges: Array<SkuDeliveryEdge>;
};

export type SkuDeliveryEdge = {
  node: SkuDelivery;
};

export type SkuDeliveryFilter = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  productIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SkuDeliveryInput = {
  completeShipDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  startShipDate?: InputMaybe<Scalars['Date']>;
};

export type SkuDoorPrice = {
  door: BrandDoor;
  orderType?: Maybe<OrderType>;
  priceType: PriceType;
  retailValue: Scalars['Float'];
  skuId: Scalars['ID'];
  totalDiscount: Scalars['Float'];
  wholesaleAdjustedValue: Scalars['Float'];
  wholesaleFinalValue: Scalars['Float'];
  wholesaleValue: Scalars['Float'];
};

export type SkuDoorPriceConnection = {
  edges?: Maybe<Array<SkuDoorPriceEdge>>;
};

export type SkuDoorPriceEdge = {
  node?: Maybe<SkuDoorPrice>;
};

export type SkuExternalIdentifier = {
  externalId?: Maybe<Scalars['String']>;
  skuId: Scalars['ID'];
  skuIdentifier?: Maybe<Scalars['String']>;
};

export type SkuExternalIdentifierInput = {
  externalId?: InputMaybe<Scalars['String']>;
  skuId: Scalars['ID'];
  skuIdentifier?: InputMaybe<Scalars['String']>;
};

export type SkuIdWithDelivery = {
  completeShipDate?: Maybe<Scalars['Date']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
  startShipDate?: Maybe<Scalars['Date']>;
};

export type SkuLineItem = {
  collection: LineItemCollection;
  inventory?: Maybe<InventoryAvailabilityGroup>;
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  sku: SKU;
  suggestedRetailPrice: Scalars['Decimal'];
  wholesalePrice: Scalars['Decimal'];
};

export type SkuLineItemToImport = {
  colorCode?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['ID']>;
  colorName?: Maybe<Scalars['String']>;
  doorCode?: Maybe<Scalars['String']>;
  doorId?: Maybe<Scalars['ID']>;
  doorName?: Maybe<Scalars['String']>;
  multiplier?: Maybe<Scalars['Int']>;
  orderIdentifier?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  productId?: Maybe<Scalars['ID']>;
  productIdentifier?: Maybe<Scalars['String']>;
  productNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sizeId?: Maybe<Scalars['ID']>;
  sizeName?: Maybe<Scalars['String']>;
  wholesalePrice?: Maybe<Scalars['String']>;
};

export type SkuPrice = Node & {
  id: Scalars['ID'];
  priceType: PriceType;
  skuId: Scalars['ID'];
  suggestedRetailPrice?: Maybe<Scalars['Decimal']>;
  wholesalePrice: Scalars['Decimal'];
};

export type SkuQuantity = {
  /** NOTE: This is field is not yet implemented */
  discountFactor?: InputMaybe<Scalars['Float']>;
  doorId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  skuId: Scalars['ID'];
};

export type SkuTrait = Trait & {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SkuTraitConnection = {
  edges?: Maybe<Array<SkuTraitEdge>>;
};

export type SkuTraitEdge = {
  node?: Maybe<SkuTrait>;
};

export type SkuTraitValue = TraitValue & {
  description?: Maybe<Scalars['String']>;
  displayDetails?: Maybe<TraitValueDisplayDetails>;
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderMinimum?: Maybe<Scalars['Int']>;
  orderNbr?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['ID']>;
  status?: Maybe<SkuTraitValueStatus>;
  trait: SkuTrait;
  value: Scalars['String'];
};

export type SkuTraitValueConnection = {
  edges?: Maybe<Array<SkuTraitValueEdge>>;
};

export type SkuTraitValueEdge = {
  node?: Maybe<SkuTraitValue>;
};

export enum SkuTraitValueStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN'
}

export type SocialMediaAccount = {
  socialMediaType?: Maybe<SocialMediaType>;
  url?: Maybe<Scalars['String']>;
};

export type SocialMediaAccountInput = {
  type: SocialMediaType;
  url: Scalars['String'];
};

export enum SocialMediaType {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  UNKNOWN = 'UNKNOWN'
}

export enum Source {
  /** Designates that the source of this object is from a brand */
  BRAND = 'BRAND',
  /** Designates that the source of this object is from a retailer */
  RETAILER = 'RETAILER',
  /** Designates that the sku has not a proper style_size_id match in the db */
  UNMATCHED_SIZE = 'UNMATCHED_SIZE'
}

export type StartShopifyInstallationInput = {
  appName: ShopifyAppName;
  hmac: Scalars['String'];
  host: Scalars['String'];
  shop: Scalars['String'];
  timestamp: Scalars['Int'];
};

export type StartShopifyInstallationPayload = {
  redirectUrl?: Maybe<Scalars['String']>;
};

export enum Status {
  CONNECTED = 'CONNECTED',
  NONE = 'NONE',
  PENDING = 'PENDING',
  SENT = 'SENT'
}

export type Storefront = Node & {
  brandId: Scalars['ID'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isHome: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  modified: Scalars['Date'];
  orderNbr: Scalars['Int'];
  projectId: Scalars['ID'];
  rows: StorefrontRowConnection;
  statusSince: Scalars['Date'];
  textStyles?: Maybe<Array<TextStyle>>;
  uniqueName: Scalars['String'];
};

export type StorefrontAboutElement = StorefrontElement & {
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
  settings: Scalars['String'];
};

export type StorefrontAboutElementInput = {
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
  settings: Scalars['String'];
};

export type StorefrontCollectionElement = StorefrontElement & {
  collectionId: Scalars['ID'];
  collectionTitle: Scalars['String'];
  coverId?: Maybe<Scalars['ID']>;
  coverUrl?: Maybe<Scalars['String']>;
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontCollectionElementInput = {
  collectionId: Scalars['ID'];
  collectionTitle: Scalars['String'];
  coverId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type StorefrontElement = {
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontFilters = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
  inMenu?: InputMaybe<Scalars['Boolean']>;
  isHome?: InputMaybe<Scalars['Boolean']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  uniqueName?: InputMaybe<Scalars['String']>;
};

export type StorefrontImageElement = StorefrontElement & {
  elementType: ElementType;
  id: Scalars['ID'];
  imageExternalLink?: Maybe<Scalars['String']>;
  imageId: Scalars['ID'];
  imageUrl: Scalars['String'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontImageElementInput = {
  id?: InputMaybe<Scalars['ID']>;
  imageExternalLink?: InputMaybe<Scalars['String']>;
  imageId: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type StorefrontInstagramElement = StorefrontElement & {
  elementType: ElementType;
  id: Scalars['ID'];
  imageUrls: Array<Maybe<Scalars['String']>>;
  instagramAuthId: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontInstagramElementInput = {
  id?: InputMaybe<Scalars['ID']>;
  instagramAuthId: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type StorefrontLookbookElement = StorefrontElement & {
  coverId?: Maybe<Scalars['ID']>;
  coverUrl?: Maybe<Scalars['String']>;
  elementType: ElementType;
  id: Scalars['ID'];
  lookbookId: Scalars['ID'];
  lookbookTitle: Scalars['String'];
  lookbookUrl: Scalars['String'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontLookbookElementInput = {
  coverId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  lookbookId: Scalars['ID'];
  lookbookTitle: Scalars['String'];
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type StorefrontOrb360Element = StorefrontElement & {
  elementType: ElementType;
  externalVideoId?: Maybe<Scalars['String']>;
  externalVideoLink?: Maybe<Scalars['String']>;
  externalVideoPayload?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontOrb360ElementInput = {
  externalVideoId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type StorefrontProductElement = StorefrontElement & {
  collectionId: Scalars['ID'];
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
  productId: Scalars['ID'];
};

export type StorefrontProductElementInput = {
  collectionId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
  productId: Scalars['ID'];
};

export type StorefrontRow = Node & {
  elements: Array<StorefrontElement>;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  template: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type StorefrontRowConnection = {
  edges?: Maybe<Array<StorefrontRowEdge>>;
};

export type StorefrontRowEdge = {
  cursor: Scalars['String'];
  node?: Maybe<StorefrontRow>;
};

export type StorefrontRowInput = {
  aboutElements?: InputMaybe<Array<StorefrontAboutElementInput>>;
  collectionElements?: InputMaybe<Array<StorefrontCollectionElementInput>>;
  id?: InputMaybe<Scalars['ID']>;
  imageElements?: InputMaybe<Array<StorefrontImageElementInput>>;
  instagramElements?: InputMaybe<Array<StorefrontInstagramElementInput>>;
  lookbookElements?: InputMaybe<Array<StorefrontLookbookElementInput>>;
  orb360Elements?: InputMaybe<Array<StorefrontOrb360ElementInput>>;
  orderNbr: Scalars['Int'];
  productElements?: InputMaybe<Array<StorefrontProductElementInput>>;
  showroomBrandElements?: InputMaybe<Array<StorefrontShowroomBrandElementInput>>;
  showroomCollectionElements?: InputMaybe<Array<StorefrontShowroomCollectionElementInput>>;
  template: Scalars['String'];
  textElements?: InputMaybe<Array<StorefrontTextElementInput>>;
  title?: InputMaybe<Scalars['String']>;
  videoElements?: InputMaybe<Array<StorefrontVideoElementInput>>;
};

export type StorefrontShowroomBrandElement = StorefrontElement & {
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
  showroomBrandId: Scalars['ID'];
};

export type StorefrontShowroomBrandElementInput = {
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
  showroomBrandId: Scalars['ID'];
};

export type StorefrontShowroomCollectionElement = StorefrontElement & {
  coverId?: Maybe<Scalars['ID']>;
  coverUrl?: Maybe<Scalars['String']>;
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
  showroomCollectionId: Scalars['ID'];
  showroomCollectionTitle: Scalars['String'];
};

export type StorefrontShowroomCollectionElementInput = {
  coverId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
  showroomCollectionId: Scalars['ID'];
  showroomCollectionTitle: Scalars['String'];
};

export type StorefrontTextElement = StorefrontElement & {
  content: Scalars['String'];
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
};

export type StorefrontTextElementInput = {
  content: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
};

export type StorefrontVideoElement = StorefrontElement & {
  elementType: ElementType;
  id: Scalars['ID'];
  orderNbr: Scalars['Int'];
  presentation?: Maybe<Scalars['String']>;
  videoId?: Maybe<Scalars['ID']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type StorefrontVideoElementInput = {
  id?: InputMaybe<Scalars['ID']>;
  orderNbr: Scalars['Int'];
  presentation?: InputMaybe<Scalars['String']>;
  videoId?: InputMaybe<Scalars['ID']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type Style = Node & {
  /** A unique identifier */
  code?: Maybe<Scalars['String']>;
  /** A description of the style */
  description?: Maybe<Scalars['String']>;
  /** Details of this style */
  details: StyleDetails;
  id: Scalars['ID'];
  /** Images related to this style */
  images: ImageConnection;
  /** A display name */
  name?: Maybe<Scalars['String']>;
  /** Sizes available */
  sizes_available?: Maybe<Scalars['String']>;
};

export type StyleColorSwatch = {
  active?: Maybe<Scalars['Boolean']>;
  styleColorImage?: Maybe<SwatchImage>;
  styleColorSwatch?: Maybe<SwatchHexImage>;
  styleId: Scalars['ID'];
  styleName: Scalars['String'];
  styleNumber: Scalars['String'];
};

export type StyleColorsImage = {
  styleColorId: Scalars['ID'];
  unmatchedImageId?: InputMaybe<Scalars['ID']>;
  uploadId?: InputMaybe<Scalars['ID']>;
};

export type StyleDetails = {
  categories: Array<Category>;
  countryOfOrigin?: Maybe<Scalars['String']>;
  fabrication?: Maybe<Fabrication>;
  furStatus?: Maybe<FurStatus>;
  heelHeight?: Maybe<Scalars['String']>;
  materials?: Maybe<Array<Maybe<Material>>>;
  measurements?: Maybe<Scalars['String']>;
  modelHeightInches?: Maybe<Scalars['Int']>;
  silhouette?: Maybe<Silhouette>;
  sourceOfMaterials?: Maybe<Scalars['String']>;
};

export type StyleImportAddImagesInput = {
  collectionIds: Array<Scalars['ID']>;
  imagesSource: Scalars['String'];
  replaceExistingImages: Scalars['Boolean'];
};

export type StyleImportAddImagesPayload = {
  error?: Maybe<GenericStyleImportError>;
};

export type StylePrice = Node & {
  id: Scalars['ID'];
  priceType: PriceType;
  styleId: Scalars['ID'];
  suggestedRetailPrice?: Maybe<Scalars['Decimal']>;
  wholesalePrice: Scalars['Decimal'];
};

export type Styleboard = Node & {
  brand: Brand;
  comments: StyleboardCommentConnection;
  created: Scalars['Date'];
  id: Scalars['ID'];
  items: Array<StyleboardItem>;
  lastModified: Scalars['String'];
  layout: Scalars['String'];
  name: Scalars['String'];
  owner: StyleboardOwner;
  status: StyleboardStatus;
  styleboardShares?: Maybe<StyleboardShare>;
  textContents: Array<StyleboardTextContent>;
};


export type StyleboardcommentsArgs = {
  filter?: InputMaybe<StyleboardCommentsFilter>;
};

export type StyleboardComment = Node & {
  created: Scalars['DateTime'];
  id: Scalars['ID'];
  message: Scalars['String'];
  owner: StyleboardCommentOwner;
  taggedAccountUsers: CommentAccountUserTagConnection;
};

export type StyleboardCommentConnection = {
  edges: Array<StyleboardCommentEdge>;
  pageInfo: PageInfo;
};

export type StyleboardCommentEdge = {
  cursor: Scalars['String'];
  node: StyleboardComment;
};

export type StyleboardCommentOwner = {
  accountProfileName: Scalars['String'];
  accountType?: Maybe<AccountType>;
  userDisplayName: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type StyleboardCommentsFilter = {
  createdStartDateTime?: InputMaybe<Scalars['DateTime']>;
};

export type StyleboardCommentsQueryFilter = {
  createdStartDateTime?: InputMaybe<Scalars['DateTime']>;
  styleboardIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type StyleboardConnection = {
  edges?: Maybe<Array<StyleboardEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StyleboardEdge = {
  cursor: Scalars['String'];
  node: Styleboard;
};

export type StyleboardFilterList = {
  brands: Array<FilterItem>;
  ownerUsers: Array<FilterItem>;
  sharedAccounts: Array<FilterItem>;
  sharedUsers: Array<FilterItem>;
  styleboards: Array<FilterItem>;
};

export type StyleboardItem = {
  collectionProduct: CollectionProduct;
  look?: Maybe<Look>;
  variantId?: Maybe<Scalars['ID']>;
};

export type StyleboardLastModified = {
  lastModified: Scalars['String'];
};

export enum StyleboardOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type StyleboardOrderBy = {
  field?: InputMaybe<StyleboardOrderByField>;
  order?: InputMaybe<StyleboardOrder>;
};

export enum StyleboardOrderByField {
  BRAND = 'BRAND',
  CREATED_DATE = 'CREATED_DATE',
  CREATOR_NAME = 'CREATOR_NAME',
  MODIFIED_DATE = 'MODIFIED_DATE',
  SHARED_DATE = 'SHARED_DATE',
  STYLEBOARD_NAME = 'STYLEBOARD_NAME'
}

export type StyleboardOwner = {
  displayName: Scalars['String'];
  logo: Scalars['String'];
  userEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export type StyleboardShare = {
  externalRecipients: Array<StyleboardShareExternalRecipient>;
  styleboardId: Scalars['ID'];
  teamRecipients: Array<StyleboardShareTeamRecipient>;
};

export type StyleboardShareExternalRecipient = {
  account: AccountProfile;
  email?: Maybe<Scalars['String']>;
  shareDate: Scalars['Date'];
};

export type StyleboardShareTeamRecipient = {
  shareDate: Scalars['Date'];
  user?: Maybe<User>;
};

export enum StyleboardStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type StyleboardTextContent = {
  content: Scalars['String'];
  layoutKey: Scalars['String'];
  presentation: Scalars['String'];
};

export type StyleboardsFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  createdDate?: InputMaybe<DateRange>;
  modifiedDate?: InputMaybe<DateRange>;
  ownerUserIds?: InputMaybe<Array<Scalars['ID']>>;
  sharedAccountIds?: InputMaybe<Array<Scalars['ID']>>;
  sharedUserIds?: InputMaybe<Array<Scalars['ID']>>;
  status?: InputMaybe<StyleboardStatus>;
  styleboardIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type Submission = {
  activities?: Maybe<Array<SubmissionActivity>>;
  attachments?: Maybe<Array<Media>>;
  categories?: Maybe<Array<SubmissionCategory>>;
  collections?: Maybe<Array<SubmissionCollection>>;
  /**
   * Status of the connection request between this submission's two accounts,
   * and who actually sent it. Unlike senderAccount/recipientAccount above
   * (always this outreach's brand/retailer), senderAccountId/recipientAccountId
   * here reflect the real connection request direction, which either side may
   * have initiated. Both are null when status is NON_EXISTENT.
   */
  connectionRequestInfo: ConnectionRequestInfo;
  /**
   * Where the connection request between the sending brand and the recipient
   * retailer currently stands.
   */
  connectionRequestStatus: ConnectionRequestStatus;
  createdAt?: Maybe<Scalars['Date']>;
  headerImages?: Maybe<Array<Media>>;
  id: Scalars['ID'];
  messageId?: Maybe<Scalars['ID']>;
  personalizedMessage?: Maybe<Scalars['String']>;
  recipientAccount?: Maybe<SubmissionRecipient>;
  recipientAccountUser?: Maybe<RecipientAccountUser>;
  recipientAccountUserId: Scalars['ID'];
  senderAccount?: Maybe<SubmissionSender>;
  subject?: Maybe<Scalars['String']>;
  submissionStatus?: Maybe<Scalars['String']>;
};

export type SubmissionActivity = {
  activityType: SubmissionActivityType;
  author?: Maybe<RecipientAccountUser>;
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
};

export enum SubmissionActivityType {
  ACTIVITY_UNKNOWN = 'ACTIVITY_UNKNOWN',
  ACTIVITY_VIEWED = 'ACTIVITY_VIEWED',
  BRAND_REPLIED = 'BRAND_REPLIED',
  RETAILER_REPLIED = 'RETAILER_REPLIED',
  SENT = 'SENT'
}

export type SubmissionAttachmentInput = {
  order: Scalars['Int'];
  uploadId: Scalars['ID'];
};

export type SubmissionAuthor = {
  accountUserActive: Scalars['Boolean'];
  accountUserId: Scalars['ID'];
  user: User;
};

export type SubmissionCategory = {
  category: ProductLine;
  wholesaleMax: Scalars['String'];
  wholesaleMin: Scalars['String'];
};

export type SubmissionCategoryInput = {
  categoryId: Scalars['ID'];
  order: Scalars['Int'];
  wholeSaleMax: Scalars['Float'];
  wholeSaleMin: Scalars['Float'];
};

export type SubmissionCollection = {
  collection?: Maybe<PublicCollection>;
  upload?: Maybe<Media>;
};

export type SubmissionCollectionInput = {
  collectionId: Scalars['ID'];
  order: Scalars['Int'];
  uploadId?: InputMaybe<Scalars['ID']>;
};

export type SubmissionConnection = {
  edges: Array<SubmissionEdge>;
  pageInfo: PageInfo;
  totalActivitiesCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SubmissionEdge = {
  cursor: Scalars['String'];
  node: Submission;
};

export type SubmissionEngagementFilter = {
  newReplies?: InputMaybe<Scalars['Boolean']>;
  noActivity?: InputMaybe<Scalars['Boolean']>;
  noNewReplies?: InputMaybe<Scalars['Boolean']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type SubmissionHeaderImageInput = {
  order: Scalars['Int'];
  uploadId: Scalars['ID'];
};

export type SubmissionRecipient = {
  accountId: Scalars['ID'];
  accountName: Scalars['String'];
  accountProfilePictureUrl?: Maybe<Scalars['String']>;
  accountUserId: Scalars['ID'];
  accountUserName: Scalars['String'];
  accountUserPictureUrl?: Maybe<Scalars['String']>;
  accountUserTitle: Scalars['String'];
  brandsCarried: Array<Scalars['String']>;
  facebookUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type SubmissionSender = {
  accountId: Scalars['ID'];
  accountName: Scalars['String'];
  accountProfilePictureUrl?: Maybe<Scalars['String']>;
  accountUserId: Scalars['ID'];
  accountUserName: Scalars['String'];
  accountUserPictureUrl?: Maybe<Scalars['String']>;
  accountUserTitle: Scalars['String'];
  facebookUrl?: Maybe<Scalars['String']>;
  instagramUrl?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type SubmissionStatus = {
  status: Scalars['String'];
};

export enum SubmissionStatusOptions {
  ARCHIVED = 'ARCHIVED',
  MESSAGED = 'MESSAGED',
  NEW = 'NEW',
  VIEWED = 'VIEWED'
}

export type SubmissionTemplate = {
  attachments?: Maybe<Array<Media>>;
  authorId: Scalars['ID'];
  categories?: Maybe<Array<SubmissionTemplateCategory>>;
  collections?: Maybe<Array<SubmissionTemplateCollection>>;
  headerImages?: Maybe<Array<Media>>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
};

export type SubmissionTemplateAttachmentInput = {
  order: Scalars['Int'];
  uploadId: Scalars['ID'];
};

export type SubmissionTemplateCategory = {
  category: ProductLine;
  wholesaleMax: Scalars['String'];
  wholesaleMin: Scalars['String'];
};

export type SubmissionTemplateCategoryInput = {
  categoryId: Scalars['ID'];
  order: Scalars['Int'];
  wholeSaleMax: Scalars['Float'];
  wholeSaleMin: Scalars['Float'];
};

export type SubmissionTemplateCollection = {
  collection?: Maybe<PublicCollection>;
  upload?: Maybe<Media>;
};

export type SubmissionTemplateCollectionInput = {
  collectionId: Scalars['ID'];
  order: Scalars['Int'];
  uploadId?: InputMaybe<Scalars['ID']>;
};

export type SubmissionTemplateHeaderImageInput = {
  order: Scalars['Int'];
  uploadId: Scalars['ID'];
};

export type SubmissionTemplateId = {
  id: Scalars['ID'];
};

export type SubmissionsFilter = {
  /** Keep submissions whose connection request is in any of these states. */
  connectionRequestStatuses?: InputMaybe<Array<ConnectionRequestStatus>>;
  statuses?: InputMaybe<Array<SubmissionStatusOptions>>;
  threadIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SubmissionsOrderBy = {
  field: SubmissionsOrderByField;
  order: SubmissionsOrderByOrder;
};

export enum SubmissionsOrderByField {
  ACTIVITY = 'ACTIVITY'
}

export enum SubmissionsOrderByOrder {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING'
}

export type SubscribeUserToFeatureInput = {
  featureName: Scalars['String'];
  userId: Scalars['ID'];
};

export type SubscribeUserToFeaturePayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type Subscription = {
  _empty?: Maybe<Scalars['String']>;
};

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  AVAILABLE_FOR_PURCHASE = 'AVAILABLE_FOR_PURCHASE',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  PROCESSING = 'PROCESSING',
  SCHEDULED = 'SCHEDULED',
  UNKNOWN = 'UNKNOWN'
}

export type SwatchHexImage = {
  hexCode?: Maybe<Scalars['String']>;
  image?: Maybe<SwatchImage>;
};

export type SwatchImage = {
  fileName?: Maybe<Scalars['String']>;
  hex?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SwatchListImageSelectorInput = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  colorCode?: InputMaybe<Scalars['String']>;
  colorName?: InputMaybe<Scalars['String']>;
  endRow?: InputMaybe<Scalars['Int']>;
  fileName?: InputMaybe<Scalars['String']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']>>;
  startRow?: InputMaybe<Scalars['Int']>;
  styleIds?: InputMaybe<Array<Scalars['ID']>>;
  totalCount?: InputMaybe<Scalars['Boolean']>;
};

export type SwatchListImageSelectorPayload = {
  images: Array<SwatchImage>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum SwitchFromType {
  NAVBAR = 'NAVBAR',
  RETAIL_CENTER = 'RETAIL_CENTER',
  START_NEW_ORDER = 'START_NEW_ORDER',
  VISUAL_ASSORTMENT = 'VISUAL_ASSORTMENT'
}

export type SyncShopifyOrderStylesInput = {
  orderIds: Array<Scalars['ID']>;
};

export type SyncShopifyOrderStylesPayload = {
  jobIds?: Maybe<Array<Scalars['String']>>;
};

export type SyncVisualAssortmentOrdersResponse = {
  /** List of order IDs that were successfully synced */
  syncedOrderIds: Array<Scalars['ID']>;
  versionDelta: VersionDelta;
};

export type Tag = Node & {
  /** @deprecated Get from TagValue.externalIdentifier */
  code: Scalars['String'];
  groupName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated This field wont make sense when TagValues is used */
  parentId: Scalars['ID'];
  /** @deprecated Get from TagValue object */
  value: Scalars['String'];
};

export type TagConnection = {
  edges: Array<TagEdge>;
};

export type TagEdge = {
  node: Tag;
};

export type TagGroup = {
  brandId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  tags: BrandTagConnection;
};

export type TagGroupConnection = {
  edges: Array<TagGroupEdge>;
};

export type TagGroupEdge = {
  node: TagGroup;
};

export type TagInput = {
  code: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};

export type TagValue = {
  externalIdentifier: Scalars['String'];
  id: Scalars['ID'];
  tag: Tag;
  value: Scalars['String'];
};

export type TagValueConnection = {
  edges: Array<TagValueEdge>;
};

export type TagValueEdge = {
  node: TagValue;
};

export type Tax = {
  /** @deprecated Use amountString instead amount */
  amount?: Maybe<Scalars['Float']>;
  amountString?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
};

export type TaxIdValidationResult = {
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type TeamMemberShowroomCollectionShare = {
  showroomCollectionId: Scalars['ID'];
  teamRecipients: Array<ShowroomCollectionShareTeamRecipient>;
};

export type TeamUser = Node & {
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type TeamUserConnection = {
  edges: Array<TeamUserEdge>;
};

export type TeamUserEdge = {
  node?: Maybe<TeamUser>;
};

export type TermsAndCondition = {
  brandAccountId: Scalars['ID'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
};

export type TermsAndConditions = Node & {
  brand: Brand;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
};

export type TextContentInput = {
  content: Scalars['String'];
  layoutKey: Scalars['String'];
  presentation: Scalars['String'];
};

export type TextStyle = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
  orderNbr: Scalars['Int'];
  size: Scalars['String'];
  typeface: Scalars['String'];
  weight: Scalars['String'];
};

export type TextStyleInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  orderNbr: Scalars['Int'];
  size: Scalars['String'];
  typeface: Scalars['String'];
  weight: Scalars['String'];
};

export type TotalPriceLevels = Node & {
  id: Scalars['ID'];
  priceLevels: Array<PriceLevel>;
  quantity: Scalars['Int'];
  skuCount: Scalars['Int'];
};


export type TotalPriceLevelspriceLevelsArgs = {
  filters?: InputMaybe<PriceLevelsFilter>;
};

export type TradeShowAward = Node & {
  awardBadgeUrl?: Maybe<Scalars['String']>;
  current?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type TradeShowEvent = Node & {
  endDate: Scalars['Date'];
  eventName: Scalars['String'];
  eventType: TradeShowEventType;
  id: Scalars['ID'];
  slug: Scalars['String'];
  startDate: Scalars['Date'];
};

export type TradeShowEventBrand = Node & {
  id: Scalars['ID'];
  mainPictureUrl: Scalars['String'];
  name: Scalars['String'];
  productLines: Array<Scalars['String']>;
  profileImageUrls: Array<Scalars['String']>;
  retailMax: Scalars['Int'];
  retailMin: Scalars['Int'];
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  wholesaleMax: Scalars['Int'];
  wholesaleMin: Scalars['Int'];
};

export type TradeShowEventBrandCategories = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TradeShowEventBrandCategoriesConnection = {
  edges?: Maybe<Array<TradeShowEventBrandCategoriesEdge>>;
};

export type TradeShowEventBrandCategoriesEdge = {
  node: TradeShowEventBrandCategories;
};

export type TradeShowEventBrandConnection = {
  edges?: Maybe<Array<TradeShowEventBrandEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TradeShowEventBrandEdge = {
  cursor: Scalars['String'];
  node: TradeShowEventBrand;
};

export type TradeShowEventBrandFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  priceRange?: InputMaybe<PriceRangeFilterInput>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']>>;
  tradeShowIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type TradeShowEventConnection = {
  edges?: Maybe<Array<TradeShowEventEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TradeShowEventEdge = {
  cursor: Scalars['String'];
  node: TradeShowEvent;
};

export type TradeShowEventFilter = {
  eventTypes?: InputMaybe<Array<TradeShowEventType>>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  tradeShowIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type TradeShowEventRetailer = Node & {
  id: Scalars['ID'];
  mainPictureUrl: Scalars['String'];
  mainStorePictureUrl: Scalars['String'];
  name: Scalars['String'];
  slug: Scalars['String'];
  tags: Array<Scalars['String']>;
  wholesaleMax: Scalars['Int'];
  wholesaleMin: Scalars['Int'];
};

export type TradeShowEventRetailerCategories = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TradeShowEventRetailerCategoriesConnection = {
  edges?: Maybe<Array<TradeShowEventRetailerCategoriesEdge>>;
};

export type TradeShowEventRetailerCategoriesEdge = {
  node: TradeShowEventRetailerCategories;
};

export type TradeShowEventRetailerConnection = {
  edges?: Maybe<Array<TradeShowEventRetailerEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TradeShowEventRetailerEdge = {
  cursor: Scalars['String'];
  node: TradeShowEventRetailer;
};

export type TradeShowEventRetailerFilter = {
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  priceRange?: InputMaybe<PriceRangeFilterInput>;
  slugs?: InputMaybe<Array<Scalars['String']>>;
  tagSlugs?: InputMaybe<Array<Scalars['String']>>;
  tradeShowIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum TradeShowEventType {
  BRAND = 'BRAND',
  RETAILER = 'RETAILER',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type TradeShowPageInfo = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type Trait = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum TraitCode {
  COLOR = 'COLOR',
  SIZE = 'SIZE'
}

export type TraitValue = {
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  trait: Trait;
  value: Scalars['String'];
};

export type TraitValueDisplayDetails = {
  hexColor?: Maybe<Scalars['String']>;
  merchandiseImages?: Maybe<Array<Image>>;
  swatchImage?: Maybe<Image>;
};

export type TraitValueInput = {
  traitCode: Scalars['String'];
  traitValueIds: Array<Scalars['ID']>;
};

export type TriggerAssortmentExcelExportTasksInput = {
  assortmentIds: Array<Scalars['ID']>;
  emailRequest?: InputMaybe<Scalars['Boolean']>;
};

export type TriggerAssortmentExcelExportTasksPayload = {
  responses: Array<Maybe<Scalars['ID']>>;
};

export type TriggerAssortmentExportInput = {
  assortmentId: Scalars['ID'];
  integrationId: Scalars['ID'];
};

export type TriggerAssortmentExportPayload = {
  downloadUrl: Scalars['String'];
};

export type TriggerAssortmentPDFExportTasksInput = {
  assortmentIds: Array<Scalars['ID']>;
  emailRequest?: InputMaybe<Scalars['Boolean']>;
};

export type TriggerAssortmentPDFExportTasksPayload = {
  responses: Array<Maybe<Scalars['ID']>>;
};

export type TriggerBulkAssortmentExportAsyncInput = {
  assortmentIds: Array<Scalars['ID']>;
  integrationId: Scalars['ID'];
};

export type TriggerBulkAssortmentExportAsyncPayload = {
  jobId: Scalars['ID'];
};

export type TriggerBulkAssortmentExportInput = {
  assortmentIds: Array<Scalars['ID']>;
  integrationId: Scalars['ID'];
};

export type TriggerBulkProductExportInput = {
  collectionIds: Array<Scalars['ID']>;
  integrationId: Scalars['ID'];
};

export type TriggerOrdersPdfExportTasksInput = {
  orderIds: Array<Scalars['ID']>;
  /** Used to override the dueDate while generating the Invoice on the fly */
  paymentDetails?: InputMaybe<Array<OrderExportPaymentDetails>>;
};

export type TriggerOrdersPdfExportTasksPayload = {
  taskIds: Array<Scalars['ID']>;
};

export type TriggerOrphanRetailerRequestInput = {
  id: Scalars['ID'];
};

export type TriggerOrphanRetailerRequestPayload = {
  success: Scalars['Boolean'];
};

export type TriggerProductExportPayload = {
  downloadUrl: Scalars['String'];
};

export type TriggerResetPasswordInput = {
  email: Scalars['String'];
};

export type TriggerResetPasswordPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type UnSubscribeUserToFeatureInput = {
  featureName: Scalars['String'];
  userId: Scalars['ID'];
};

export type UnSubscribeUserToFeaturePayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type UndoDeclinedConnectionInput = {
  /**
   * The counterparty account. The account performing the undo is taken from the
   * authenticated principal, so either side of the connection can call this.
   */
  accountId: Scalars['ID'];
};

export type UndoDeclinedConnectionPayload = {
  /** The counterparty account the undo was attempted against. */
  accountId: Scalars['ID'];
  /** CONNECTED when the connection was reinstated, otherwise UNCONNECTED. */
  connectionStatus: LGConnectionStatus;
  /** Why the undo was refused, or null when it succeeded. */
  error?: Maybe<Scalars['String']>;
};

export type UnitRange = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

export type UnmatchedUpload = {
  fileName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  unmatchedUploadId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type UnshareCollectionsWithRetailersInput = {
  collectionId: Scalars['ID'];
  retailerIds: Array<Scalars['ID']>;
};

export type UnshareCollectionsWithRetailersPayload = {
  collections: CollectionConnection;
};

export type UnshareShowroomCollectionInput = {
  retailerAccountIds: Array<Scalars['ID']>;
  showroomCollectionId: Scalars['ID'];
  teamRecipientIds: Array<Scalars['ID']>;
};

export type UpdateAccountPermissionAccessInput = {
  accountId: Scalars['ID'];
  permissionStates: Array<PermissionState>;
};

export type UpdateAccountPermissionAccessPayload = {
  success: Scalars['Boolean'];
};

export type UpdateAccountPrivacyInput = {
  accountId: Scalars['ID'];
  privacy: Scalars['Boolean'];
};

export type UpdateAccountPrivacyPayload = {
  account?: Maybe<Account>;
};

export type UpdateAccountUserDataPermissionConfigurationInput = {
  accountId: Scalars['ID'];
  dataPermissionConfigurationId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UpdateAccountUserDataPermissionConfigurationPayload = {
  success: Scalars['Boolean'];
};

export type UpdateAccountUserGeoRestrictionsInput = {
  accountId: Scalars['ID'];
  exceptionAccountIds: Array<Scalars['ID']>;
  regionAssignedOverride: Scalars['Boolean'];
  regionIds: Array<Scalars['ID']>;
  userIds: Array<Scalars['ID']>;
};

export type UpdateAccountUserGeoRestrictionsPayload = {
  success: Scalars['Boolean'];
};

export type UpdateAccountUserPossibleExceptionsInput = {
  accountId: Scalars['ID'];
  regionIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type UpdateAccountUserStatusInput = {
  accountsUsers: Array<AccountUserStatusInput>;
};

export type UpdateAccountUserStatusPayload = {
  accountsUsersIds: Array<Scalars['ID']>;
};

export type UpdateAccountUsersPermissionAccessInput = {
  accountId: Scalars['ID'];
  permissionStates: Array<PermissionState>;
  userIds: Array<Scalars['ID']>;
};

export type UpdateAccountUsersPermissionAccessPayload = {
  success: Scalars['Boolean'];
};

/** Response type for updating accounts for Visual Assortment. */
export type UpdateAccountsForVisualAssortmentResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
};

export type UpdateAccountsUsersInput = {
  accountsUsers: Array<AccountUserUpdate>;
};

export type UpdateAccountsUsersPayload = {
  accountsUsersIds: Array<Scalars['ID']>;
};

/** Updates the import status of an assortment */
export type UpdateAssortmentDetailsInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Id of the object to update */
  assortmentId: Scalars['ID'];
  brandId?: InputMaybe<Scalars['ID']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  completeShip?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
  /** note this only supports a list of one user at the moment */
  editableByUserIds?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  poNumber?: InputMaybe<Scalars['String']>;
  seasonId?: InputMaybe<Scalars['ID']>;
  startShip?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AssortmentStatus>;
  version?: InputMaybe<Scalars['String']>;
};

export type UpdateAssortmentDetailsPayload = {
  assortment?: Maybe<Assortment>;
  errors?: Maybe<Array<Error>>;
};

/** Updates the import status of an assortment */
export type UpdateAssortmentImportStatusInput = {
  /** Ids of the object to update */
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateAssortmentImportStatusPayload = {
  assortments?: Maybe<Array<Scalars['ID']>>;
  errors?: Maybe<Array<Error>>;
};

/** Updates attribute details */
export type UpdateAttributeInput = {
  /** Id of the object to update */
  attributeId: Scalars['ID'];
  /** If true allows more than one option to be selected for this attribute */
  isMultiSelect?: InputMaybe<Scalars['Boolean']>;
  /** If true requires an option to be selected for this attribute */
  isRequired?: InputMaybe<Scalars['Boolean']>;
  /** A display name */
  name?: InputMaybe<Scalars['String']>;
  /** Defines display order */
  position?: InputMaybe<Scalars['Int']>;
};

/** Updates attribute option details */
export type UpdateAttributeOptionInput = {
  /** Id of the object to update */
  attributeOptionId: Scalars['ID'];
  /** The value of the option */
  value: Scalars['String'];
};

export type UpdateAttributeOptionPayload = {
  attributeOption?: Maybe<AttributeOption>;
  errors?: Maybe<Array<Error>>;
};

/** Overwrites the attribute option rules for a price modifier */
export type UpdateAttributeOptionRuleForPriceModifierInput = {
  /** Values for the updated rules */
  attributeOptionIds: Array<Scalars['ID']>;
  /** The factor to apply for this rule */
  factor: Scalars['Decimal'];
  /** Id of the object to update */
  priceModifierRuleId: Scalars['ID'];
  /** The name to display for this rule */
  ruleName: Scalars['String'];
};

export type UpdateAttributeOptionRuleForPriceModifierPayload = {
  priceModifierRule: PriceModifierRule;
};

export type UpdateAttributePayload = {
  attribute?: Maybe<Attribute>;
  errors?: Maybe<Array<Error>>;
};

export type UpdateAvailablePaymentMethodsInput = {
  accountId: Scalars['ID'];
  isAchEnabled: Scalars['Boolean'];
  isSepaEnabled: Scalars['Boolean'];
  paymentProvider: Scalars['String'];
};

/** Overwrites the brand rules of a price modifier */
export type UpdateBrandRuleForPriceModifierInput = {
  /** Value for the updated rule */
  brandId: Scalars['ID'];
  /** The factor to apply for this rule */
  factor: Scalars['Decimal'];
  /** Id of the object to update */
  priceModifierRuleId: Scalars['ID'];
  /** The name to display for this rule */
  ruleName: Scalars['String'];
};

export type UpdateBrandRuleForPriceModifierPayload = {
  priceModifierRule: PriceModifierRule;
};

export type UpdateCollaborationInvitesToAccountInput = {
  invitingAccountId: Scalars['ID'];
  status: UserCollaborationInviteStatus;
};

export type UpdateCollectionBannerInput = {
  imageBanners?: InputMaybe<Array<UpdateCollectionImageBannerInput>>;
  textBanners?: InputMaybe<Array<UpdateCollectionTextBannerInput>>;
  videoBanners?: InputMaybe<Array<UpdateCollectionVideoBannerInput>>;
};

export type UpdateCollectionBannersInput = {
  banners: UpdateCollectionBannerInput;
  collectionId: Scalars['ID'];
};

export type UpdateCollectionBannersPayload = {
  imageBanners?: Maybe<Array<CollectionImageBanner>>;
  textBanners?: Maybe<Array<CollectionTextBanner>>;
  videoBanners?: Maybe<Array<CollectionVideoBanner>>;
};

export type UpdateCollectionError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateCollectionErrorDetail>;
  message: Scalars['String'];
};

export type UpdateCollectionErrorDetail = {
  archived?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ignores_inventory?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  seasonId?: Maybe<Scalars['ID']>;
  syncToIpad?: Maybe<Scalars['Boolean']>;
  visibleToAllMatches?: Maybe<Scalars['Boolean']>;
};

export type UpdateCollectionGroupInput = {
  header?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderNbr?: InputMaybe<Scalars['Int']>;
};

export type UpdateCollectionImageBannerInput = {
  id: Scalars['ID'];
  imageId?: InputMaybe<Scalars['ID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  orderNbr?: InputMaybe<Scalars['Int']>;
  presentation?: InputMaybe<Scalars['String']>;
};

export type UpdateCollectionInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  completeShipDate?: InputMaybe<Scalars['Date']>;
  cutoffDate?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  ignores_inventory?: InputMaybe<Scalars['Boolean']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  madeToOrder?: InputMaybe<Scalars['Boolean']>;
  minimumShippingWindow?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<CollectionSeasonInput>;
  seasonId?: InputMaybe<Scalars['ID']>;
  startShipDate?: InputMaybe<Scalars['Date']>;
  syncToIpad?: InputMaybe<Scalars['Boolean']>;
  visibleToAllMatches?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCollectionProductInput = {
  comments?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderNbr?: InputMaybe<Scalars['Int']>;
};

export type UpdateCollectionTextBannerInput = {
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderNbr?: InputMaybe<Scalars['Int']>;
  presentation?: InputMaybe<Scalars['String']>;
};

export type UpdateCollectionVideoBannerInput = {
  id: Scalars['ID'];
  orderNbr?: InputMaybe<Scalars['Int']>;
  presentation?: InputMaybe<Scalars['String']>;
  videoId?: InputMaybe<Scalars['ID']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateCollectionsPositionInput = {
  collectionId: Scalars['ID'];
  position: Scalars['Int'];
};

export type UpdateCollectionsPublicInput = {
  collectionId: Scalars['ID'];
  public: Scalars['Boolean'];
};

export type UpdateConfigurationInput = {
  configuration: ConfigurationInput;
  id: Scalars['ID'];
};

export type UpdateConnectionBuyerInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['ID'];
};

export type UpdateConnectionDiscountInput = {
  amount?: InputMaybe<Scalars['String']>;
  divisionId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  level: DiscountLevel;
  retailerId?: InputMaybe<Scalars['ID']>;
};

export type UpdateConnectionPriceTypeInput = {
  id: Scalars['ID'];
  priceTypeId: Scalars['ID'];
  retailerId: Scalars['ID'];
  termsConditionId?: InputMaybe<Scalars['ID']>;
};

export type UpdateConnectionSalesRepInput = {
  divisionId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UpdateDataPermissionConfigurationInput = {
  configuration?: InputMaybe<UpdatePermissionConfigurationInput>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDataPermissionConfigurationPayload = {
  dataPermissionConfiguration?: Maybe<DataPermissionConfiguration>;
};

/** Updates information for a door */
export type UpdateDoorInput = {
  /** Id of the object to update */
  doorId: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
};

export type UpdateDoorPayload = {
  door?: Maybe<Door>;
  errors?: Maybe<Array<Error>>;
};

export type UpdateExportIntegrationConfigInput = {
  autoStatus: Array<Scalars['Int']>;
  columnConfig: Scalars['String'];
  combineExportsIntoSingleFile?: InputMaybe<Scalars['Boolean']>;
  convertImagesUrlsToColumns?: InputMaybe<Scalars['Boolean']>;
  convertSingleDoorToCluster?: InputMaybe<Scalars['Boolean']>;
  csvDelimiter?: InputMaybe<CsvDelimiterType>;
  csvEncodingType?: InputMaybe<ExportCSVEncodingType>;
  defaultClusterDoors?: InputMaybe<Array<Scalars['String']>>;
  doorQuantityColumn?: InputMaybe<Scalars['Boolean']>;
  excludeSkusWithZeroQuantities?: InputMaybe<Scalars['Boolean']>;
  fileExtension: ExportFileExtensionType;
  fileName?: InputMaybe<Scalars['String']>;
  fileNameDelimiter?: InputMaybe<Scalars['String']>;
  fileNameParts: Array<ExportFileNameParts>;
  fileNamePrefix?: InputMaybe<Scalars['String']>;
  ftpPath?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  level: ExportLevel;
  name: Scalars['String'];
  onlySkuQuantities?: InputMaybe<Scalars['Boolean']>;
  overwrittenFileExtension?: InputMaybe<Scalars['String']>;
  removeHeader?: InputMaybe<Scalars['Boolean']>;
  textQualifier?: InputMaybe<Scalars['String']>;
  type: ExportType;
  unzipFilesToFTPPath?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateIdentityProviderInput = {
  domain: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  sigCert: Scalars['String'];
  ssoLoginUrl: Scalars['String'];
};

export type UpdateIdentityProviderPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  idpConfig?: Maybe<IdpConfig>;
  success: Scalars['Boolean'];
};

export type UpdateInventoryItemQuantity = {
  availableQuantity: Scalars['Int'];
  inventoryItemId: Scalars['ID'];
};

export type UpdateJobInput = {
  errorDetails?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  jobId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<JobStatus>;
};

export type UpdateJobPayload = {
  id: Scalars['ID'];
};

export type UpdateManualPaymentRecordInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  paymentDate: Scalars['Date'];
  paymentMethod: ManualPaymentMethod;
  recordedBy?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
};

/** Update details for a merchandising hierarchy node */
export type UpdateMerchandisingHierarchyNodeInput = {
  /** Id of the merchandising hierarchy node to update */
  id: Scalars['ID'];
  /** A display name */
  name: Scalars['String'];
};

export type UpdateMerchandisingHierarchyNodePayload = {
  errors?: Maybe<Array<Error>>;
  merchandisingHierarchyNode?: Maybe<MerchandisingHierarchyNode>;
};

/** Overwrites the merchandising hierarchy rules for a price modifier */
export type UpdateMerchandisingHierarchyRuleForPriceModifierInput = {
  /** The factor to apply for this rule */
  factor: Scalars['Decimal'];
  /** Values for the updated rules */
  merchandisingHierarchyNodeId: Scalars['ID'];
  /** Id of the object to update */
  priceModifierRuleId: Scalars['ID'];
  /** The name to display for this rule */
  ruleName: Scalars['String'];
};

export type UpdateMerchandisingHierarchyRuleForPriceModifierPayload = {
  priceModifierRule: PriceModifierRule;
};

export type UpdateOrderBillingInput = {
  billingInfo: BillingInfo;
  orderId: Scalars['ID'];
  overrideSourceAddress?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrderCommentsInput = {
  productComments: Array<OrderProductComment>;
  variantComments: Array<OrderVariantComment>;
};

export type UpdateOrderCommentsPayload = {
  updatedOrderIds: Array<Scalars['ID']>;
};

export type UpdateOrderCustomerRecordIdInput = {
  customerRecordId: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type UpdateOrderCustomerRecordIdPayload = {
  errors: Array<Error>;
  updatedOrderId: Scalars['String'];
};

export type UpdateOrderCustomerShippingBillingInput = {
  billingAddress?: InputMaybe<AliasAddressInput>;
  id: Scalars['ID'];
  shippingAddress?: InputMaybe<AliasAddressInput>;
};

export type UpdateOrderDeliveryInfoInput = {
  orderDeliveryInfo: OrderDeliveryInfo;
  orderId: Scalars['ID'];
};

export type UpdateOrderDeliveryInfoPayload = {
  orders?: Maybe<OrderConnection>;
  updatedOrderIds: Array<Scalars['ID']>;
};

export type UpdateOrderDiscountInput = {
  discount: OrderDiscount;
  orderId: Scalars['ID'];
};

export type UpdateOrderDiscountPayload = {
  orderId: Scalars['ID'];
};

export type UpdateOrderInfoInput = {
  orderDetails: OrderDetails;
  orderIdentifiers: OrderIdentifiers;
};

export type UpdateOrderInput = {
  billingAddressCode?: InputMaybe<Scalars['String']>;
  billingAddressId?: InputMaybe<Scalars['ID']>;
  buyerId?: InputMaybe<Scalars['ID']>;
  comments?: InputMaybe<Scalars['String']>;
  customFees?: InputMaybe<Array<CustomFeeInput>>;
  deliveryWindowEnd?: InputMaybe<Scalars['Date']>;
  deliveryWindowStart?: InputMaybe<Scalars['Date']>;
  discount?: InputMaybe<OrderDiscount>;
  exportDescription?: InputMaybe<Scalars['String']>;
  exportStatus?: InputMaybe<OrderExportStatus>;
  id: Scalars['ID'];
  internalComments?: InputMaybe<Scalars['String']>;
  paymentMethodCode?: InputMaybe<Scalars['String']>;
  paymentMethodId?: InputMaybe<Scalars['ID']>;
  poNumber?: InputMaybe<Scalars['String']>;
  priceTypeId?: InputMaybe<Scalars['ID']>;
  priceTypeName?: InputMaybe<Scalars['String']>;
  retailerCode?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  salesRepCode?: InputMaybe<Scalars['String']>;
  salesRepId?: InputMaybe<Scalars['ID']>;
  shippingAddressCode?: InputMaybe<Scalars['String']>;
  shippingAddressId?: InputMaybe<Scalars['ID']>;
  shippingMethodCode?: InputMaybe<Scalars['String']>;
  shippingMethodId?: InputMaybe<Scalars['ID']>;
  shippingPrice?: InputMaybe<Scalars['Decimal']>;
  tax?: InputMaybe<CreateOrderPriceModifier>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  orders?: Maybe<OrderConnection>;
  updatedOrderIds?: Maybe<Array<Scalars['ID']>>;
  updatedOrders?: Maybe<OrderConnection>;
};

export type UpdateOrderProductDiscountsInput = {
  orderProductDiscounts: Array<OrderProductDiscountInput>;
};

export type UpdateOrderProductDiscountsPayload = {
  updatedOrderIds?: Maybe<Array<Scalars['ID']>>;
};

export type UpdateOrderShippingBillingInput = {
  billingInfo?: InputMaybe<BillingInfo>;
  orderId: Scalars['ID'];
  overrideSourceAddress?: InputMaybe<Scalars['Boolean']>;
  shippingInfo?: InputMaybe<ShippingInfo>;
};

export type UpdateOrderShippingInput = {
  orderId: Scalars['ID'];
  overrideSourceAddress?: InputMaybe<Scalars['Boolean']>;
  shippingInfo: ShippingInfo;
};

export type UpdateOrdersConnection = {
  orders: Array<UpdateOrderInput>;
};

export type UpdateOrphanRetailerInput = {
  connectionProcessed: Scalars['Boolean'];
  id: Scalars['ID'];
  retailerCode?: InputMaybe<Scalars['String']>;
  retailerEmail: Scalars['String'];
  retailerName: Scalars['String'];
};

export type UpdatePaymentInput = {
  amount: Scalars['Float'];
  brandId: Scalars['ID'];
  externalIdentifier: Scalars['String'];
  paymentProvider: Scalars['String'];
  retailerId?: InputMaybe<Scalars['ID']>;
};

export type UpdatePaymentPayload = {
  ok: Scalars['Boolean'];
};

export type UpdatePaymentSettingsInput = {
  accountId: Scalars['ID'];
  brandNotificationEmail?: InputMaybe<Scalars['String']>;
  paymentProvider: Scalars['String'];
  retailersCanSeeInvoices: Scalars['Boolean'];
  sendBrandMailPaymentProcessed: Scalars['Boolean'];
  sendRetailerMailPaymentProcessed: Scalars['Boolean'];
};

export type UpdatePermissionConfigurationInput = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
  divisionCategories?: InputMaybe<Array<DivisionCategoryInput>>;
  divisionIds?: InputMaybe<Array<Scalars['ID']>>;
  priceTypeIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateProductError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateProductErrorDetail>;
  message: Scalars['String'];
};

export type UpdateProductErrorDetail = {
  categoryIds?: Maybe<Array<Scalars['ID']>>;
  description?: Maybe<Scalars['String']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  orderMinimum?: Maybe<Scalars['Int']>;
  productIdentifier?: Maybe<Scalars['String']>;
};

export type UpdateProductInput = {
  badgeIds?: InputMaybe<Array<Scalars['ID']>>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  description?: InputMaybe<Scalars['String']>;
  externalIdentifier?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  orderMinimum?: InputMaybe<Scalars['Int']>;
  productIdentifier?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
};

export type UpdateRegionInput = {
  geographyIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateRetailWorkspaceNameInput = {
  /** The new workspace name */
  name: Scalars['String'];
  /** The id of retail workspace to update */
  retailWorkspaceId: Scalars['ID'];
};

export type UpdateRetailerImpersonationFeedbackPayload = {
  node: RetailerImpersonationFeedback;
};

export type UpdateRetailerPrimaryAccount = {
  retailerId: Scalars['ID'];
};

export type UpdateRetailerPrimaryAccountInput = {
  primaryAccount: Scalars['Boolean'];
  retailerId: Scalars['ID'];
};

export type UpdateRetailerProfileInput = {
  buyer?: InputMaybe<LGBuyerInput>;
  description: Scalars['String'];
  locations?: InputMaybe<Array<LGLocationInput>>;
  logoId?: InputMaybe<Scalars['ID']>;
  profileSnoozeCounter?: InputMaybe<Scalars['Int']>;
  retailerId: Scalars['ID'];
  socialMediaAccounts?: InputMaybe<Array<SocialMediaAccountInput>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdCountry?: InputMaybe<Scalars['String']>;
  uploads?: InputMaybe<Array<Scalars['ID']>>;
  websiteUrl: Scalars['String'];
};

export type UpdateSeasonError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateSeasonErrorDetail>;
  message: Scalars['String'];
};

export type UpdateSeasonErrorDetail = {
  /** Id of the object to update */
  id: Scalars['ID'];
  /** A display name */
  name?: Maybe<Scalars['String']>;
  /** A calendar year */
  year?: Maybe<Scalars['Int']>;
};

/** Updates the details of a season */
export type UpdateSeasonInput = {
  /** Id of the object to update */
  id: Scalars['ID'];
  /** A display name */
  name?: InputMaybe<Scalars['String']>;
  /** A calendar year */
  year?: InputMaybe<Scalars['Int']>;
};

export type UpdateSeasonPayload = {
  errors?: Maybe<Array<UpdateSeasonError>>;
  season?: Maybe<Season>;
};

export type UpdateShopifyBrandSyncSettingsInput = {
  performFullSync?: InputMaybe<Scalars['Boolean']>;
  retailPriceMultiplier?: InputMaybe<Scalars['String']>;
  wholesalePriceMultiplier?: InputMaybe<Scalars['String']>;
};

export type UpdateShowroomCollectionInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  status: ShowroomCollectionStatus;
  url3dShowroom?: InputMaybe<Scalars['ID']>;
  visibleToAllConnected: Scalars['Boolean'];
};

export type UpdateShowroomCollectionsInput = {
  showroomCollections: Array<UpdateShowroomCollectionInput>;
};

export type UpdateSkuPriceError = GenericError & {
  code?: Maybe<GenericErrorCode>;
  details?: Maybe<UpdateSkuPriceErrorDetail>;
  message: Scalars['String'];
};

export type UpdateSkuPriceErrorDetail = {
  id: Scalars['ID'];
  suggestedRetailPrice?: Maybe<Scalars['Decimal']>;
  wholesalePrice?: Maybe<Scalars['Decimal']>;
};

export type UpdateSkuPriceInput = {
  id: Scalars['ID'];
  suggestedRetailPrice?: InputMaybe<Scalars['Decimal']>;
  wholesalePrice?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateSkuTraitValueInput = {
  externalIdentifier?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  orderMinimum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<SkuTraitValueStatus>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateStorefrontInput = {
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isHome?: InputMaybe<Scalars['Boolean']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  orderNbr?: InputMaybe<Scalars['Int']>;
  uniqueName?: InputMaybe<Scalars['String']>;
};

export type UpdateStyleboardInput = {
  brandId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: StyleboardStatus;
};

export type UpdateStyleboardsInput = {
  styleboards: Array<UpdateStyleboardInput>;
};

export type UpdateSubmissionSenderProfileInput = {
  accountUserName: Scalars['String'];
  accountUserPhone: Scalars['String'];
  accountUserPictureId?: InputMaybe<Scalars['ID']>;
  accountUserTitle: Scalars['String'];
};

export type UpdateUserCollaborationInviteInput = {
  collaborationInviteId: Scalars['ID'];
  status: UserCollaborationInviteStatus;
};

export type UpdateUserCollaborationInvitePayload = {
  success: Scalars['Boolean'];
};

export type UpdateUserFavoriteCollectionsInput = {
  collectionId: Scalars['ID'];
  favorite: Scalars['Boolean'];
};

/** Input for updating a custom Visual Assortment Attribute Key (type). */
export type UpdateVisualAssortmentAttributeKeyInput = {
  /** Unique identifier of the attribute key to update. */
  id: Scalars['ID'];
  /** New display name of the attribute key. Must not match a system key name. */
  name?: InputMaybe<Scalars['String']>;
  /** New order number for the attribute key. */
  orderNbr?: InputMaybe<Scalars['Int']>;
};

/** Response type for updating a custom Visual Assortment Attribute Key (type). */
export type UpdateVisualAssortmentAttributeKeyResponse = {
  /** The custom attribute key after the update. */
  attributeKey: VisualAssortmentAttributeKey;
};

/** Response type for updating Visual Assortment Attribute Values. */
export type UpdateVisualAssortmentAttributeValuesResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
  /** List of attribute keys and their values for the account */
  visualAssortmentAttributeKeys: Array<VisualAssortmentAttributeKey>;
};

/** Input for updating a Visual Assortment Budget. */
export type UpdateVisualAssortmentBudgetInput = {
  attributeFilterId?: InputMaybe<Scalars['ID']>;
  currency?: InputMaybe<Scalars['String']>;
  groupings?: InputMaybe<Array<VisualAssortmentBudgetGroupingInput>>;
  id: Scalars['ID'];
};

export type UpdateWarehousesInput = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UploadAttachmentToS3Input = {
  file: Scalars['Upload'];
};

export type UploadAttachmentToS3Payload = {
  fileName?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type UploadBulkStyleImageInput = {
  file: Scalars['Upload'];
  fileName: Scalars['String'];
  filePath: Scalars['String'];
};

export type UploadBulkStyleImagePayload = {
  errorCode?: Maybe<Scalars['String']>;
};

export type UploadColorImage = {
  colorId?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
};

export type UploadFileToS3Input = {
  file?: InputMaybe<Scalars['Upload']>;
};

/** Response type for uploading an image to a Visual Assortment Card. */
export type UploadImageToVisualAssortmentCardResponse = {
  /** The updated visual assortment card */
  card: VisualAssortmentCard;
  versionDelta: VersionDelta;
};

export type UploadItemImage = {
  assortmentId: Scalars['ID'];
};

export type UploadProductColorImageResult = {
  colorId: Scalars['ID'];
};

export type UploadProductImageResult = {
  assortmentId: Scalars['ID'];
};

export type UploadStyleImportFileInput = {
  file: Scalars['Upload'];
};

export type UploadStyleImportFilePayload = {
  filePath?: Maybe<Scalars['String']>;
};

export type UploadSwatchImage = {
  image?: Maybe<Image>;
};

export enum UploaderFileNameParts {
  COLOR_CODE = 'COLOR_CODE',
  COLOR_NAME = 'COLOR_NAME',
  FABRICATION_CODE = 'FABRICATION_CODE',
  FABRICATION_NAME = 'FABRICATION_NAME',
  ORDER_NUMBER = 'ORDER_NUMBER',
  SILHOUETTE_CODE = 'SILHOUETTE_CODE',
  SILHOUETTE_NAME = 'SILHOUETTE_NAME',
  SKIP = 'SKIP',
  STYLE_NAME = 'STYLE_NAME',
  STYLE_NUMBER = 'STYLE_NUMBER'
}

export type UpsertAccountConnectionStatusesInput = {
  accountId: Scalars['ID'];
  customMessage?: InputMaybe<Scalars['String']>;
  otherAccountConnectionActions: Array<AccountConnectionRequest>;
};

export type UpsertAccountConnectionStatusesPayload = {
  accountConnectionStatuses: Array<AccountConnectionStatus>;
};

export type UpsertAccountCustomerCodesInput = {
  customerCodes: Array<AccountCustomerCodeInput>;
};

export type UpsertBillingAddressesPayload = {
  billingAddresses?: Maybe<Array<Maybe<BillingAddress>>>;
  message: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpsertBrandProfileInput = {
  customUrlHandle: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  facebookLink: Scalars['String'];
  instagramHandle: Scalars['String'];
  ipadPictureId?: InputMaybe<Scalars['ID']>;
  logoId?: InputMaybe<Scalars['ID']>;
  mainPictureId?: InputMaybe<Scalars['ID']>;
  productLineIds?: InputMaybe<Array<Scalars['ID']>>;
  /**
   * Null means the brand left the field empty, and clears any stored value.
   * Omitting the field does the same: this input replaces the whole profile
   * rather than patching it, so every save must send all five numeric fields.
   */
  retailMax?: InputMaybe<Scalars['Int']>;
  /**
   * Null means the brand left the field empty, and clears any stored value.
   * Omitting the field does the same: this input replaces the whole profile
   * rather than patching it, so every save must send all five numeric fields.
   */
  retailMin?: InputMaybe<Scalars['Int']>;
  twitterHandle: Scalars['String'];
  websiteLink: Scalars['String'];
  /**
   * Null means the brand left the field empty, and clears any stored value.
   * Omitting the field does the same: this input replaces the whole profile
   * rather than patching it, so every save must send all five numeric fields.
   */
  wholesaleMax?: InputMaybe<Scalars['Int']>;
  /**
   * Null means the brand left the field empty, and clears any stored value.
   * Omitting the field does the same: this input replaces the whole profile
   * rather than patching it, so every save must send all five numeric fields.
   */
  wholesaleMin?: InputMaybe<Scalars['Int']>;
  /**
   * Null means the brand left the field empty, and clears any stored value.
   * Omitting the field does the same: this input replaces the whole profile
   * rather than patching it, so every save must send all five numeric fields.
   */
  yearEstablished?: InputMaybe<Scalars['Int']>;
};

export type UpsertBulkQuantity = {
  collectionId?: InputMaybe<Scalars['ID']>;
  inventoryId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  variantId: Scalars['ID'];
};

export type UpsertCasepackQuantity = {
  casepackId: Scalars['ID'];
  collectionId?: InputMaybe<Scalars['ID']>;
  inventoryId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpsertCollectionTextStylesInput = {
  collectionId: Scalars['ID'];
  textStyles: Array<CollectionTextStyleInput>;
};

export type UpsertCollectionTextStylesPayload = {
  textStyles: Array<CollectionTextStyle>;
};

export type UpsertCollectionsVisibilityPayload = {
  collections: UpsertCollectionsVisibilityPayloadConnection;
  errors: Array<Error>;
};

export type UpsertCollectionsVisibilityPayloadConnection = {
  edges: Array<UpsertCollectionsVisibilityPayloadEdge>;
};

export type UpsertCollectionsVisibilityPayloadEdge = {
  node: CollectionVisibilityStyle;
};

export type UpsertOrderQuantitiesInput = {
  /** To pass bulk quantities to be updated/added on the orders in progress */
  bulkQuantities?: InputMaybe<Array<UpsertBulkQuantity>>;
  /** To pass casepack quantities to be updated/added on the orders in progress */
  casepackQuantities?: InputMaybe<Array<UpsertCasepackQuantity>>;
  /** To pass SKU quantities to be updated/added on the orders in progress */
  skuQuantities?: InputMaybe<Array<UpsertSkuQuantity>>;
};

export type UpsertOrderQuantitiesPayload = {
  orders?: Maybe<OrderConnection>;
  updatedOrderIds?: Maybe<Array<Scalars['ID']>>;
};

export type UpsertShowroomCollectionInput = {
  id?: InputMaybe<Scalars['ID']>;
  looks?: InputMaybe<Array<UpsertShowroomCollectionLookInput>>;
  name: Scalars['String'];
  status: ShowroomCollectionStatus;
  url3dShowroom?: InputMaybe<Scalars['ID']>;
  visibleToAllConnected: Scalars['Boolean'];
};

export type UpsertShowroomCollectionLookInput = {
  id?: InputMaybe<Scalars['ID']>;
  items: Array<LookItemConnection>;
  layout: Scalars['String'];
  media: Array<Scalars['ID']>;
  textContents: Array<LookTextContentInput>;
};

export type UpsertSkuQuantity = {
  collectionId?: InputMaybe<Scalars['ID']>;
  inventoryId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  skuId: Scalars['ID'];
};

/** Update or create a storefront */
export type UpsertStorefrontInput = {
  displayName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  isHome: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  orderNbr: Scalars['Int'];
  rows: Array<StorefrontRowInput>;
  uniqueName: Scalars['String'];
};

export type UpsertStorefrontTextStylesInput = {
  textStyles: Array<TextStyleInput>;
};

export type UpsertStyleboardInput = {
  brandId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<UpsertStyleboardItemsInput>>;
  layout?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: StyleboardStatus;
  textContents?: InputMaybe<Array<TextContentInput>>;
};

export type UpsertStyleboardItemsInput = {
  collectionProduct: CollectionProductInput;
  lookId?: InputMaybe<Scalars['String']>;
};

export type UpsertUrl3dShowroomInput = {
  Url3dShowrooms: Array<Url3dShowroomInput>;
};

/** Response type for upserting Visual Assortment Access Users. */
export type UpsertVisualAssortmentAccessUsersResponse = {
  /** Indicates whether the operation was successful */
  success: Scalars['Boolean'];
};

/** Visual Assortment budget row edit. */
export type UpsertVisualAssortmentBudgetRowEntry = {
  budgetCost: Scalars['String'];
  budgetRetail: Scalars['String'];
  id: Scalars['ID'];
};

/** Input for upserting budget row values. */
export type UpsertVisualAssortmentBudgetRowsInput = {
  rows: Array<UpsertVisualAssortmentBudgetRowEntry>;
};

export type Url3dShowroom = {
  displayUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  provider: Provider3dShowroom;
  url: Scalars['String'];
};

export type Url3dShowroomFilter = {
  provider?: InputMaybe<Provider3dShowroom>;
};

export type Url3dShowroomInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Provider3dShowroom>;
  url?: InputMaybe<Scalars['String']>;
};

export type User = UserInterface & {
  active: Scalars['Boolean'];
  assortmentPlanning: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  dateFormat?: Maybe<DateFormat>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  favoriteCollections: Array<Scalars['ID']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  loggedInAsAdmin: Scalars['Boolean'];
  profileImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * Used to filter the collaboration invites list by inviting/invited user id.
 * Typically only one of these filters will be filled out, though it is valid to
 * provide both.
 */
export type UserCollaborationInviteFilter = {
  invitedUserId?: InputMaybe<Scalars['ID']>;
  invitingUserId?: InputMaybe<Scalars['ID']>;
  searchText?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserCollaborationInviteStatus>;
};

export enum UserCollaborationInviteStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  DENIED = 'DENIED',
  PENDING = 'PENDING'
}

export type UserConnection = {
  edges: Array<UserEdge>;
};

export type UserEdge = {
  brands: BrandConnection;
  node: User;
};

export type UserInterface = {
  active: Scalars['Boolean'];
  assortmentPlanning: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  dateFormat?: Maybe<DateFormat>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  favoriteCollections: Array<Scalars['ID']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  loggedInAsAdmin: Scalars['Boolean'];
  profileImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum UserMembershipInviteStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING'
}

export type UserMembershipRequest = Node & {
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: Maybe<UserMembershipRequestStatus>;
  userId: Scalars['ID'];
};

export type UserMembershipRequestConnection = {
  edges: Array<UserMembershipRequestEdge>;
};

export type UserMembershipRequestEdge = {
  node?: Maybe<UserMembershipRequest>;
};

export type UserMembershipRequestFilter = {
  statuses?: InputMaybe<Array<UserMembershipRequestStatus>>;
};

export enum UserMembershipRequestStatus {
  ACCEPTED = 'ACCEPTED',
  DENIED = 'DENIED',
  PENDING = 'PENDING'
}

export type UserPermission = {
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type UserPermissionConfiguration = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum UserRole {
  SALES_REPRESENTATIVE = 'SALES_REPRESENTATIVE'
}

export enum UserType {
  ADMIN = 'ADMIN',
  UNSPECIFIED = 'UNSPECIFIED',
  USER = 'USER'
}

export type UsersFilter = {
  includeInactives?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<UserRole>;
};

/** Represents access to a visual assortment for an account, including ownership and checked status. */
export type VAAccessAccount = {
  /** The associated account that has access to the visual assortment. */
  account: Retailer;
  /** Users eligible for this account in the context of visual assortments. */
  eligibleUsers: VAAccessAccountUserConnection;
  /** Unique identifier for the access account entry. */
  id: Scalars['ID'];
  /** Indicates whether the account is the owner of the visual assortment. */
  isOwner?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the account is currently checked for this feature. */
  isSelected?: Maybe<Scalars['Boolean']>;
};

/** Connection for users eligible for a VAAccessAccount. */
export type VAAccessAccountUserConnection = {
  edges: Array<VAAccessAccountUserEdge>;
};

/** Edge containing an account user eligible for a VAAccessAccount. */
export type VAAccessAccountUserEdge = {
  node: AccountUser;
};

export type VAEligibleOrder = {
  /** Brand name */
  brandName: Scalars['String'];
  /** Collection name */
  collectionName: Scalars['String'];
  /** Order creation date */
  created: Scalars['Date'];
  /** Delivery window information */
  deliveryWindow: VAOrderDeliveryWindow;
  /** Order ID */
  id: Scalars['ID'];
  /** Marks if this order is already in the Visual Assortment */
  inAssortment: Scalars['Boolean'];
  /** Last time this order was synced */
  lastSeen?: Maybe<Scalars['Date']>;
  /** Order reference number */
  referenceNumber: Scalars['String'];
  /** Order status */
  status: OrderStatus;
  /** Total number of products */
  totalProducts: Scalars['Int'];
  /** Total number of units */
  totalUnits: Scalars['Int'];
};

export type VAOrderDeliveryWindow = {
  /** Maximum delivery date */
  endDate?: Maybe<Scalars['Date']>;
  /** Minimum delivery date */
  startDate?: Maybe<Scalars['Date']>;
};

export type VAOrderProductColorInfo = {
  /** Hex color code */
  hexColor?: Maybe<Scalars['String']>;
  /** Color name */
  name: Scalars['String'];
  /** Swatch image url */
  swatchUrl?: Maybe<Scalars['String']>;
};

export type VAOrderProductDetail = {
  /** Tells if the given VACard has been cancelled from the Order */
  cancelled: Scalars['Boolean'];
  /** Brand category names */
  categories: Array<Scalars['String']>;
  /** Color information */
  color: VAOrderProductColorInfo;
  /** Currency code (e.g. "USD") */
  currencyCode: Scalars['String'];
  /** Delivery window information */
  deliveryWindow: VAOrderDeliveryWindow;
  /** Order ID */
  id: Scalars['ID'];
  /** Order number */
  orderNumber: Scalars['String'];
  /** Wholesale/product cost */
  productCost: Scalars['Decimal'];
  /** Retail cost */
  productRetailCost: Scalars['Decimal'];
  /** Product sizes and quantities */
  productSizes: Array<VAOrderProductSizeQuantity>;
  /** Retailer account ID */
  retailerAccountId: Scalars['ID'];
  /** Visibility of the retailer account for the current user */
  retailerAccountVisibility: RetailerAccountVisibility;
  /** Order status */
  status: OrderStatus;
  /** Style color ID associated with the order */
  styleColorId: Scalars['ID'];
};

export type VAOrderProductSizeQuantity = {
  /** Size name */
  name: Scalars['String'];
  /** Quantity for this size */
  quantity: Scalars['Int'];
};

/** Represents the account that owns the visual assortment. */
export type VAOwnerAccount = {
  id: Scalars['ID'];
};

/** Represents the user who owns the visual assortment. */
export type VAOwnerUser = {
  id: Scalars['ID'];
};

export type ValidateOrdersError = {
  code?: Maybe<GenericErrorCode>;
  message: Scalars['String'];
  skuLineItem: InvalidSkuLineItem;
  type?: Maybe<ErrorType>;
};

export type ValidateOrdersPayload = {
  errors?: Maybe<Array<ValidateOrdersError>>;
  orders: Array<OrderToImport>;
  validatedOrdersIdentifier: Scalars['String'];
  validatedOrdersUrl?: Maybe<Scalars['String']>;
};

export type ValidateOrdersSettings = {
  caseSensitiveColorNames?: InputMaybe<Scalars['Boolean']>;
  caseSensitiveProductNumbers?: InputMaybe<Scalars['Boolean']>;
  caseSensitiveSizeNames?: InputMaybe<Scalars['Boolean']>;
};

export type ValidateStyleImportErrorDetail = {
  errorCode: ValidationErrorCode;
  errorDetails?: Maybe<Scalars['JSON']>;
  field: Scalars['String'];
  rowNumber: Scalars['Int'];
  styleNumber: Scalars['String'];
};

export type ValidateStyleImportFileInput = {
  filePath: Scalars['String'];
};

export type ValidateStyleImportFilePayload = {
  error?: Maybe<GenericStyleImportError>;
  validationResult?: Maybe<ValidateStyleImportFileResult>;
};

export type ValidateStyleImportFileRequest = {
  filePath: Scalars['String'];
};

export type ValidateStyleImportFileResult = {
  hasCategoryColumns: Scalars['Boolean'];
  invalidStylesCount: Scalars['Int'];
  newStylesCount: Scalars['Int'];
  updatedStylesCount: Scalars['Int'];
  validationErrors: Array<ValidateStyleImportErrorDetail>;
};

export type Validation = {
  field: AssortmentValidationField;
  /** Whether the field(s) is "valid", i.e. for assortment-level fields, whether it has been set to a value, for product-level fields, whether all products have been assigned a value */
  valid: Scalars['Boolean'];
};

export enum ValidationErrorCode {
  AT_LEAST_ONE_WHOLESALE_PRICE_REQUIRED = 'AT_LEAST_ONE_WHOLESALE_PRICE_REQUIRED',
  COMMA_SEPARATED_SIZES_NOT_ALLOWED = 'COMMA_SEPARATED_SIZES_NOT_ALLOWED',
  DUPLICATED_STYLE_COLOR_SIZE = 'DUPLICATED_STYLE_COLOR_SIZE',
  EMPTY_SIZE_IN_SIZE_RUN = 'EMPTY_SIZE_IN_SIZE_RUN',
  FABRICATION_CODE_WITHOUT_NAME = 'FABRICATION_CODE_WITHOUT_NAME',
  INVALID_CATEGORY_CHOICE = 'INVALID_CATEGORY_CHOICE',
  INVALID_PRICE = 'INVALID_PRICE',
  MAX_LENGTH_EXCEEDED = 'MAX_LENGTH_EXCEEDED',
  MISSING_SIZES_IN_COLOR = 'MISSING_SIZES_IN_COLOR',
  NON_UNIFORM_DATA = 'NON_UNIFORM_DATA',
  REQUIRED = 'REQUIRED',
  SILHOUETTE_CODE_WITHOUT_NAME = 'SILHOUETTE_CODE_WITHOUT_NAME',
  STYLE_COLOR_DIFFERENT_SIZE_RUNS = 'STYLE_COLOR_DIFFERENT_SIZE_RUNS',
  UNSUPPORTED_CATEGORY = 'UNSUPPORTED_CATEGORY',
  UPC_WITH_MULTIPLE_SIZES = 'UPC_WITH_MULTIPLE_SIZES'
}

export type VariantByCasepackLineItem = {
  casepackId: Scalars['ID'];
  colorName: Scalars['String'];
  sizeName: Scalars['String'];
  variantId: Scalars['ID'];
};

export enum VariantFilterValuesInput {
  COLOR = 'COLOR',
  SIZE = 'SIZE'
}

export type VariantInCart = {
  brand: Brand;
  collection: Collection;
  door?: Maybe<BrandDoor>;
  orderId: Scalars['ID'];
  orphanRetailer?: Maybe<OrphanRetailer>;
  priceType: PriceType;
  product: Product;
  retailer: Retailer;
  variantId: Scalars['ID'];
  warehouse?: Maybe<Warehouse>;
};

export type VariantTrait = Trait & {
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type VariantValue = Node & {
  displayDetails?: Maybe<TraitValueDisplayDetails>;
  id: Scalars['ID'];
  orderMinimum?: Maybe<Scalars['Int']>;
  trait: SkuTrait;
  value: Scalars['String'];
};

export type VariantValueConnection = {
  edges?: Maybe<Array<VariantValueEdge>>;
};

export type VariantValueEdge = {
  node: VariantValue;
};

export type VariantsInCartFilter = {
  brandIds?: InputMaybe<Array<Scalars['ID']>>;
  orphanRetailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type VerifyAchBankAccountInput = {
  amounts: Array<Scalars['Int']>;
  brandId: Scalars['String'];
  paymentMethodId: Scalars['String'];
  paymentProvider: Scalars['String'];
  retailerId: Scalars['String'];
};

/** Verify a user email. */
export type VerifyUserEmailInput = {
  /** The email verification token */
  token: Scalars['String'];
  /** The unique identifier for the user */
  uid: Scalars['String'];
};

/** Returns whether user email was verified and any errors */
export type VerifyUserEmailPayload = {
  errorCode?: Maybe<Scalars['String']>;
  verified: Scalars['Boolean'];
};

export type VersionDelta = {
  newVersion: Scalars['Int'];
  /**
   * Version number for tracking changes to the Visual Assortment, based on UpdatedAt as a timestamp.
   * It includes the old and the new version
   */
  oldVersion: Scalars['Int'];
};

export enum VettingDecision {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  EXISTING_ACCOUNT = 'EXISTING_ACCOUNT',
  NEEDS_REVIEW = 'NEEDS_REVIEW'
}

export type VettingResult = {
  decision: VettingDecision;
  notes: Scalars['String'];
};

export type ViewSubmissionInput = {
  origin: Scalars['String'];
  submissionId: Scalars['ID'];
};

export type ViewSubmissionPayload = {
  success: Scalars['Boolean'];
};

export type ViewerAccount = AdminViewerAccount | BrandViewerAccount | RetailerViewerAccount;

export type ViewingAccount = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ViewingAccountUser = {
  accountUserPermissions: Array<Maybe<UserPermission>>;
  accountUserType: AccountUserType;
  accounts: Array<Maybe<ViewerAccount>>;
  id: Scalars['ID'];
  tiedWithBuyerHierarchy: Scalars['Boolean'];
  viewingAccount: ViewerAccount;
  viewingUser: ViewingUser;
};

export type ViewingUser = UserInterface & {
  active: Scalars['Boolean'];
  assortmentPlanning: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  dateFormat?: Maybe<DateFormat>;
  displayLanguage: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailLanguage: Scalars['String'];
  favoriteCollections: Array<Scalars['ID']>;
  id: Scalars['ID'];
  internalUser: Scalars['Boolean'];
  inviteMessage: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  isOwner: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  loggedInAsAdmin: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  recentlyCreatedAccounts?: Maybe<Array<Account>>;
  title?: Maybe<Scalars['String']>;
  userType: UserType;
};

export type VisitRetailerProfileInput = {
  retailerId: Scalars['ID'];
};

export type VisitRetailerProfilePayload = {
  success: Scalars['Boolean'];
};

/** Represents a Visual Assortment, which organizes cards from products in a visual layout. */
export type VisualAssortment = {
  /** Access control information for the visual assortment */
  access: VisualAssortmentAccess;
  /** Budget configurations associated with this Visual Assortment. */
  budgets: VisualAssortmentBudgetConnection;
  /** Cards contained within this visual assortment */
  cards: VisualAssortmentCardConnection;
  /** Timestamp when the visual assortment was created (ISO format) */
  createdAt: Scalars['Date'];
  /** How is this Visual Assortment grouped/subgrouped by */
  groupedBy: Array<VisualAssortmentGroupedBy>;
  /** Groups that organize the cards within this visual assortment */
  groups: VisualAssortmentGroupConnection;
  /** Base64 encoded visual assortment id -> VisualAssortment:123 */
  id: Scalars['ID'];
  /** Indicates if this is the default visual assortment for the account */
  isDefault: Scalars['Boolean'];
  /** Display name of the visual assortment */
  name: Scalars['String'];
  /** The position of the visual assortment in the list */
  orderNbr: Scalars['Int'];
  /** List of PUBLIC order IDs that are currently related with this visual assortment */
  ordersInSync: Array<VisualAssortmentOrderInSync>;
  /** Timestamp when the visual assortment was last updated (ISO format) */
  updatedAt: Scalars['Date'];
  /** Version number for tracking changes to the visual assortment, based on UpdatedAt as a timestamp */
  version: Scalars['Int'];
  /**
   * Counts of cards in a Visual Assortment grouped by missing fields and other
   * field-state checks (e.g. cancelled in order).
   */
  visualAssortmentCardFieldsCount: VisualAssortmentCardFieldsCount;
};


/** Represents a Visual Assortment, which organizes cards from products in a visual layout. */
export type VisualAssortmentcardsArgs = {
  filter?: InputMaybe<VisualAssortmentCardsFilterInput>;
  pagination?: InputMaybe<VisualAssortmentCardsPaginationInput>;
  search?: InputMaybe<VisualAssortmentCardsSearchInput>;
};

/** Represents the access related information for a Visual Assortment. */
export type VisualAssortmentAccess = {
  /** Unique identifier for the visual assortment access entry. */
  id: Scalars['ID'];
  /** The owner account of the visual assortment. */
  ownerAccount: VAOwnerAccount;
  /** The owner user of the visual assortment. */
  ownerUser: VAOwnerUser;
};

/** User with access to the current Visual Assortment Account. */
export type VisualAssortmentAccessUser = {
  /** Unique identifier for this access user record. */
  id: Scalars['ID'];
  /** Whether the user is active (via AccountUser) in at least one of the VA's accounts. */
  isActiveForAnyAccount: Scalars['Boolean'];
  /** Display order for the user in the list. */
  orderNbr: Scalars['Int'];
  /** User details for display (name, email, etc.). */
  user?: Maybe<User>;
};

/** Input for upserting Visual Assortment Access Users (user access order within an account). */
export type VisualAssortmentAccessUserInput = {
  /** Order number for display ordering. */
  orderNbr: Scalars['Int'];
  /** User ID (global ID format). */
  userId: Scalars['ID'];
};

/** Represents a Visual Assortment Attribute Key and its associated values for the account. */
export type VisualAssortmentAttributeKey = {
  /** Indicates if this attribute key is active */
  active: Scalars['Boolean'];
  /** List of values associated with this attribute key for the current account */
  attributeValues: Array<VisualAssortmentAttributeValue>;
  /** Base64 encoded visual assortment attribute key id -> VisualAssortmentAttributeKey:123 */
  id: Scalars['ID'];
  /** The maximum number of values allowed for this key */
  limitCount: Scalars['Int'];
  /** Indicates if the limit count for this attribute key has been reached */
  limitReached: Scalars['Boolean'];
  /** Display name of the attribute key */
  name: Scalars['String'];
  /** The position of the attribute key in the list */
  orderNbr: Scalars['Int'];
  /** The total number of values associated with this key for the current account */
  totalCount: Scalars['Int'];
};

/** Represents a Visual Assortment Attribute Value. */
export type VisualAssortmentAttributeValue = {
  /** Base64 encoded visual assortment attribute value id -> VisualAssortmentAttributeValue:123 */
  id: Scalars['ID'];
  /** Display name of the attribute value */
  name: Scalars['String'];
  /** The position of the attribute value in the list */
  orderNbr: Scalars['Int'];
};

/** Input for creating Visual Assortment Attribute Values. */
export type VisualAssortmentAttributeValueInput = {
  /** Attribute Key ID associated with this value. */
  attributeKeyId: Scalars['ID'];
  /** Display name of the attribute value. */
  name: Scalars['String'];
  /** Order number for the attribute value. */
  orderNbr: Scalars['Int'];
};

/** Input for updating Visual Assortment Attribute Values. */
export type VisualAssortmentAttributeValueUpdateInput = {
  /** Unique identifier of the attribute value to update. */
  id: Scalars['ID'];
  /** New display name of the attribute value. */
  name?: InputMaybe<Scalars['String']>;
  /** New order number for the attribute value. */
  orderNbr?: InputMaybe<Scalars['Int']>;
};

/** Budget configuration associated with a Visual Assortment. */
export type VisualAssortmentBudget = {
  /** Optional attribute value id used to filter cards (e.g. season, door). */
  attributeFilterId?: Maybe<Scalars['ID']>;
  /** Aggregated table view of this budget (groups + totals). */
  budgetView: BudgetView;
  /**
   * Missing field counts for cards scoped to this budget's attribute filter.
   * Use together with groupings to determine which warnings to surface.
   */
  cardFieldsCount: VisualAssortmentCardFieldsCount;
  /** Timestamp when the budget was created (ISO format). */
  createdAt: Scalars['Date'];
  /** ISO 4217 currency code. */
  currency: Scalars['String'];
  /** Ordered grouping levels that define how the budget is broken down. */
  groupings: Array<VisualAssortmentBudgetGrouping>;
  /** Base64 encoded budget id -> VisualAssortmentBudget:123 */
  id: Scalars['ID'];
  /** Timestamp when the budget was last updated (ISO format). */
  updatedAt: Scalars['Date'];
};

/** Connection wrapper for VisualAssortmentBudget. */
export type VisualAssortmentBudgetConnection = {
  edges: Array<VisualAssortmentBudgetEdge>;
};

/** Edge containing a VisualAssortmentBudget node. */
export type VisualAssortmentBudgetEdge = {
  node: VisualAssortmentBudget;
};

/** Ordered grouping concept for a budget. order_nbr=0 is Level 1, etc. */
export type VisualAssortmentBudgetGrouping = {
  /** When groupBy is ATTRIBUTE, references the attribute key. */
  attributeKey?: Maybe<VisualAssortmentAttributeKey>;
  /** Type of grouping (delivery month, color, category, brand, attribute). */
  groupBy: VisualAssortmentGroupByOption;
};

/** Ordered grouping concept for a budget. */
export type VisualAssortmentBudgetGroupingInput = {
  attributeKeyId?: InputMaybe<Scalars['ID']>;
  groupBy: VisualAssortmentGroupByOption;
};

/** Represents a card within a VisualAssortment that displays product information */
export type VisualAssortmentCard = {
  /** List of attributes and their assigned values for this card */
  attributes: Array<VisualAssortmentCardAttribute>;
  /** Name of the brand associated with the product */
  brandName: Scalars['String'];
  /** UUID that identifies publicly grouped card in the visual assortment. */
  cardUuid: Scalars['ID'];
  /** Timestamp when the card was created */
  createdAt: Scalars['Date'];
  /** Optional custom description for the product */
  customDescription?: Maybe<Scalars['String']>;
  /**
   * List of source card IDs that are grouped together in this card
   * @deprecated Use cardUuid instead
   */
  groupedSourceCardIds: Array<Scalars['ID']>;
  /** Base64 encoded visual assortment card id -> VisualAssortmentCard:123 */
  id: Scalars['ID'];
  /** Optional link related to the product */
  link?: Maybe<Scalars['String']>;
  /** Position of this card relative to its group or sub-group */
  orderNbr: Scalars['Int'];
  /** Related order source data for the card, empty for non ORDER sources */
  orderSourceData: Array<VisualAssortmentCardOrderSourceData>;
  /** Image information for the product */
  productImage?: Maybe<VisualAssortmentCardProductImage>;
  /** Name of the product */
  productName: Scalars['String'];
  /** Product number is the custom identifier for the product */
  productNumber: Scalars['String'];
  /** Quantity of the product */
  quantity: Scalars['Int'];
  /**
   * Date the card was marked as received. Null means the card has not been
   * received, so this doubles as the received flag.
   */
  receivedAt?: Maybe<Scalars['Date']>;
  /** Retail price information */
  retailPrice: VisualAssortmentCardCurrency;
  /** List of sizes with quantities for the card */
  sizes: Array<VisualAssortmentCardSize>;
  /** Source of the product data */
  source: VisualAssortmentCardSource;
  /** Timestamp when the card was last updated */
  updatedAt: Scalars['Date'];
  /** Version number for tracking changes to the card, based on UpdatedAt as a timestamp */
  version: Scalars['Int'];
  /** Category information for the product */
  visualAssortmentCategory?: Maybe<VisualAssortmentCardCategory>;
  /** Color information for the product */
  visualAssortmentColor?: Maybe<VisualAssortmentCardColor>;
  /** Group information for organizing cards */
  visualAssortmentGroup?: Maybe<VisualAssortmentCardGroup>;
  /** Month associated with the product */
  visualAssortmentMonth?: Maybe<Scalars['String']>;
  /** Wholesale price information */
  wholesalePrice: VisualAssortmentCardCurrency;
};

/** Represents an attribute and its assigned values for a VisualAssortmentCard. */
export type VisualAssortmentCardAttribute = {
  /** The attribute key */
  key: VisualAssortmentAttributeKey;
  /** List of attribute values assigned to this card for the given key */
  values: Array<VisualAssortmentAttributeValue>;
};

/** Input for specifying attributes for a Visual Assortment Card. */
export type VisualAssortmentCardAttributeInput = {
  /** Attribute Key ID associated with this value. */
  attributeKeyId: Scalars['ID'];
  /** Attribute Value IDs associated with this key. */
  attributeValueIds: Array<Scalars['ID']>;
};

/** Represents a category for a VisualAssortmentCard */
export type VisualAssortmentCardCategory = {
  /** Base64 encoded visual assortment card category id -> VisualAssortmentCategory:123 */
  id: Scalars['ID'];
  /** Name of the category */
  name: Scalars['String'];
};

/** Represents color information for a VisualAssortmentCard */
export type VisualAssortmentCardColor = {
  /** Hex code representing the color (e.g. "#FF0000"), may be null if its considered a multi-color */
  hexCode?: Maybe<Scalars['String']>;
  /** Base64 encoded visual assortment card color id -> VisualAssortmentColor:123 */
  id: Scalars['ID'];
  /** Name of the color */
  name: Scalars['String'];
};

/** Represents the connection between all VisualAssortmentCard within its parent. */
export type VisualAssortmentCardConnection = {
  edges: Array<VisualAssortmentCardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** Represents price information with associated currency for a VisualAssortmentCard */
export type VisualAssortmentCardCurrency = {
  /** Currency code (e.g. "USD") */
  currency?: Maybe<Scalars['String']>;
  /** Price value as a string (e.g. "19.99" or "19,99") */
  price?: Maybe<Scalars['String']>;
};

/** Represents the difference between current and unsynced card states */
export type VisualAssortmentCardDiff = {
  /** The current card in the Visual Assortment (null if this is a new card) */
  currentCard?: Maybe<VisualAssortmentCard>;
  /** The card that would be created on sync (null if card would be removed) */
  unsyncedCard?: Maybe<VisualAssortmentCard>;
};

/** Edge that contains a VisualAssortmentCard node and related information within its parent. */
export type VisualAssortmentCardEdge = {
  node: VisualAssortmentCard;
};

/**
 * Counts of distinct cards (grouped by card_uuid) within a Visual Assortment
 * that are missing required fields or in special states such as cancelled in order.
 */
export type VisualAssortmentCardFieldsCount = {
  /** Number of cards whose underlying order rows are entirely cancelled. */
  cancelledInOrder: Scalars['Int'];
  /** Number of cards missing a brand name. */
  missingBrand: Scalars['Int'];
  /** Number of cards missing a category. */
  missingCategory: Scalars['Int'];
  /** Number of cards missing a color. */
  missingColor: Scalars['Int'];
  /** Number of cards missing a wholesale (cost) price. */
  missingCost: Scalars['Int'];
  /** Number of cards with no custom attribute values assigned across any attribute key. */
  missingCustomAttributes: Scalars['Int'];
  /** Number of cards missing a delivery month. */
  missingDeliveryMonth: Scalars['Int'];
  /** Number of cards missing the door attribute. */
  missingDoor: Scalars['Int'];
  /** Number of cards missing a product image. */
  missingImage: Scalars['Int'];
  /** Number of cards missing a retail price. */
  missingPrice: Scalars['Int'];
  /** Number of cards missing a retail price currency. */
  missingRetailCurrency: Scalars['Int'];
  /** Number of cards missing the season attribute. */
  missingSeason: Scalars['Int'];
  /** Number of cards missing a wholesale (cost) price currency. */
  missingWholesaleCurrency: Scalars['Int'];
  /** Number of cards that have no received date. */
  notReceived: Scalars['Int'];
  /**
   * Number of cards whose stored size quantities differ from the current
   * order line item totals.
   */
  unitMismatch: Scalars['Int'];
};

/** Represents a group within a VisualAssortmentCard hierarchy */
export type VisualAssortmentCardGroup = {
  /** Base64 encoded visual assortment card group id -> VisualCardGroup:123 */
  id: Scalars['ID'];
  /** Name of the group */
  name: Scalars['String'];
  /** Order number for the group inside his parent */
  orderNbr: Scalars['Int'];
  /** Optional sub-group for hierarchical organization */
  subGroup?: Maybe<VisualAssortmentCardGroup>;
};

/** Information about the order source of a VisualAssortmentCard */
export type VisualAssortmentCardOrderSourceData = {
  /** Base64 encoded order id -> Order:123 */
  id: Scalars['ID'];
  /** Order number reference */
  orderNumber: Scalars['String'];
};

/** Represents product image information for a VisualAssortmentCard */
export type VisualAssortmentCardProductImage = {
  /** File name of the image */
  fileName: Scalars['String'];
  /** Base64 encoded product image id -> Upload:123 */
  id: Scalars['ID'];
  /** URL to access the image */
  url: Scalars['String'];
};

/** Available search fields for visual assortment cards */
export enum VisualAssortmentCardSearchField {
  PRODUCT_NAME = 'PRODUCT_NAME'
}

/** Represents size and quantity information for a VisualAssortmentCard */
export type VisualAssortmentCardSize = {
  /** Quantity for this size */
  quantity: Scalars['Int'];
  /** Name of the size */
  sizeName: Scalars['String'];
};

/** Source options for VisualAssortmentCard data */
export enum VisualAssortmentCardSource {
  CSV = 'CSV',
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  ORDER = 'ORDER'
}

/** Input type for filtering visual assortment cards based on specific criteria. */
export type VisualAssortmentCardsFilterInput = {
  /**
   * Filter cards by attribute value (e.g. a specific season or door). Only cards
   * with this attribute value assigned will be included. Pairs with hasMissing*
   * flags to scope missing-field queries to a specific budget's attribute filter.
   */
  attributeFilterId?: InputMaybe<Scalars['ID']>;
  /** Filter cards by their cancellation status in orders. When true, returns only cancelled cards. */
  cancelledInOrder?: InputMaybe<Scalars['Boolean']>;
  /** An array of group IDs to filter the visual assortment cards by. Only cards belonging to these groups will be included. */
  groupIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter cards by missing brand. When true, returns only cards with no brand. */
  hasMissingBrand?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing category. When true, returns only cards with no category or category set to Unassigned. */
  hasMissingCategory?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing color. When true, returns only cards with no color or color set to Unassigned. */
  hasMissingColor?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing cost. When true, returns only cards with no cost. */
  hasMissingCost?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing delivery month. When true, returns only cards with no month or month set to Unassigned. */
  hasMissingDeliveryMonth?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing doors attribute. When true, returns only cards with no Doors attribute value. */
  hasMissingDoors?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing image. When true, returns only cards with no image. */
  hasMissingImage?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing price. When true, returns only cards with no price. */
  hasMissingPrice?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing retail price currency. When true, returns only cards with no retail currency. */
  hasMissingRetailCurrency?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing seasons attribute. When true, returns only cards with no Seasons attribute value. */
  hasMissingSeasons?: InputMaybe<Scalars['Boolean']>;
  /** Filter cards by missing wholesale (cost) price currency. When true, returns only cards with no wholesale currency. */
  hasMissingWholesaleCurrency?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter cards by unit mismatch. When true, returns only cards whose stored
   * size quantities differ from the current order line item totals.
   */
  hasUnitMismatch?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter cards by received status. When true, returns only cards that have a
   * received date; when false, only cards with no received date. Omit to not
   * filter by received status at all.
   */
  received?: InputMaybe<Scalars['Boolean']>;
  /**
   * Filter cards by attribution status. When true, returns only cards that have
   * no custom attribute values assigned across any attribute key.
   */
  unattributed?: InputMaybe<Scalars['Boolean']>;
};

/** Input type for specifying pagination parameters when querying visual assortment cards. */
export type VisualAssortmentCardsPaginationInput = {
  /** The maximum number of visual assortment cards to return in the query result. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The number of visual assortment cards to skip before starting to collect the result set. */
  offset?: InputMaybe<Scalars['Int']>;
};

/** Input type for searching visual assortment cards using text and specific fields. */
export type VisualAssortmentCardsSearchInput = {
  /** An array of fields to search within. Specifies which fields of the visual assortment cards should be considered for the search. */
  fields?: InputMaybe<Array<VisualAssortmentCardSearchField>>;
  /** The search text to match against the visual assortment cards. */
  text?: InputMaybe<Scalars['String']>;
};

/** Input type for editing Visual Assortment Cards. */
export type VisualAssortmentCardsToEdit = {
  /** Optionally updates the attributes for the card. */
  attributes?: InputMaybe<Array<VisualAssortmentCardAttributeInput>>;
  /** Optionally updates the brand name for the card. */
  brandName?: InputMaybe<Scalars['String']>;
  /** Card UUID identifying the group. Edits apply to all cards with this UUID, or to groupedCardIds if provided. */
  cardUuid: Scalars['ID'];
  /** Optionally updates the custom description for the card. */
  customDescription?: InputMaybe<Scalars['String']>;
  /** Optional. If provided, only these card IDs (with this UUID) are edited. If omitted, all cards with this UUID are edited. */
  groupedCardIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Optionally updates the order number for the card. */
  orderNbr?: InputMaybe<Scalars['Int']>;
  /** Optionally updates the product number for the card. */
  productNumber?: InputMaybe<Scalars['String']>;
  /**
   * Marks the card as received (true) or clears the received date (false).
   * Omit to leave the card's received state untouched.
   */
  received?: InputMaybe<Scalars['Boolean']>;
  /** Optionally updates the retail price currency for the card. */
  retailCurrency?: InputMaybe<Scalars['String']>;
  /** Optionally updates the retail price for the card. */
  retailPrice?: InputMaybe<Scalars['String']>;
  /** Optionally updates the category ID for the card. */
  visualAssortmentCategoryId?: InputMaybe<Scalars['ID']>;
  /** Optionally updates the color ID for the card. */
  visualAssortmentColorId?: InputMaybe<Scalars['ID']>;
  /** ID of the Visual Assortment Image to set as the product image for the card. */
  visualAssortmentImageId?: InputMaybe<Scalars['ID']>;
  /** Optionally updates the month for the card. */
  visualAssortmentMonth?: InputMaybe<Scalars['String']>;
  /** Optionally updates the wholesale price currency for the card. */
  wholesaleCurrency?: InputMaybe<Scalars['String']>;
  /** Optionally updates the wholesale price for the card. */
  wholesalePrice?: InputMaybe<Scalars['String']>;
};

/** Represents a gallery of images for a Visual Assortment */
export type VisualAssortmentGallery = {
  /** List of images in the gallery with pagination and search support */
  images: VisualAssortmentImageConnection;
};


/** Represents a gallery of images for a Visual Assortment */
export type VisualAssortmentGalleryimagesArgs = {
  pagination?: InputMaybe<VisualAssortmentImagesPaginationInput>;
  search?: InputMaybe<VisualAssortmentImagesSearchInput>;
};

/** Represents a Visual Assortment Group, which organizes cards into hierarchical groups. */
export type VisualAssortmentGroup = {
  /** Timestamp when the group was created (ISO format) */
  createdAt: Scalars['Date'];
  /** Base64 encoded visual assortment group id -> VisualAssortmentGroup:123 */
  id: Scalars['ID'];
  /** The max order number of the cards within the group */
  maxCardOrderNbr: Scalars['Int'];
  /** Display name of the group */
  name: Scalars['String'];
  /** The position of the group in the list */
  orderNbr: Scalars['Int'];
  /** Subgroups of this group for hierarchical organization */
  subgroups?: Maybe<VisualAssortmentGroupConnection>;
  /** Timestamp when the group was last updated (ISO format) */
  updatedAt: Scalars['Date'];
  /** Version number for tracking changes to the group, based on UpdatedAt as a timestamp */
  version: Scalars['Int'];
};

/** Available grouping and subgrouping options for visual assortment cards */
export enum VisualAssortmentGroupBy {
  ATTRIBUTE = 'ATTRIBUTE',
  BRAND = 'BRAND',
  CATEGORY = 'CATEGORY',
  COLOR = 'COLOR',
  DELIVERY_MONTH = 'DELIVERY_MONTH'
}

/** Available grouping options for a budget. */
export enum VisualAssortmentGroupByOption {
  ATTRIBUTE = 'ATTRIBUTE',
  BRAND = 'BRAND',
  CATEGORY = 'CATEGORY',
  COLOR = 'COLOR',
  DELIVERY_MONTH = 'DELIVERY_MONTH'
}

/** Represents the connection between all VisualAssortmentGroup within its parent. */
export type VisualAssortmentGroupConnection = {
  edges: Array<VisualAssortmentGroupEdge>;
};

/** Edge that contains a VisualAssortmentGroup node and related information within its parent. */
export type VisualAssortmentGroupEdge = {
  node: VisualAssortmentGroup;
};

export type VisualAssortmentGroupedBy = {
  attributeKey?: Maybe<VisualAssortmentAttributeKey>;
  option: VisualAssortmentGroupBy;
};

export type VisualAssortmentGroupingByInput = {
  attributeKeyId?: InputMaybe<Scalars['ID']>;
  option: VisualAssortmentGroupBy;
};

/** Available grouping options for Visual Assortments. */
export enum VisualAssortmentGroupingOption {
  ATTRIBUTE = 'ATTRIBUTE',
  BRAND = 'BRAND',
  CATEGORY = 'CATEGORY',
  COLOR = 'COLOR',
  DELIVERY_MONTH = 'DELIVERY_MONTH'
}

/** Represents an image in a Visual Assortment gallery */
export type VisualAssortmentImage = {
  /** Timestamp when the image was added to the gallery (ISO format) */
  createdAt: Scalars['Date'];
  /** Filename of the image */
  filename: Scalars['String'];
  /** Base64 encoded visual assortment image id -> VisualAssortmentImage:123 */
  id: Scalars['ID'];
  /** Base64 encoded image id -> Image:123 */
  imageId: Scalars['ID'];
  /** Position of this image in the gallery */
  orderNbr: Scalars['Int'];
  /** URL of the image */
  url: Scalars['String'];
};

/** Represents the connection between VisualAssortmentImage nodes */
export type VisualAssortmentImageConnection = {
  /** List of edges containing VisualAssortmentImage nodes */
  edges: Array<VisualAssortmentImageEdge>;
  /** Pagination information for the connection */
  pageInfo: PageInfo;
  /** Total count of images matching the filters */
  totalCount: Scalars['Int'];
};

/** Edge that contains a VisualAssortmentImage node */
export type VisualAssortmentImageEdge = {
  /** The VisualAssortmentImage node */
  node: VisualAssortmentImage;
};

/** Enum for specifying which fields to search in visual assortment images. */
export enum VisualAssortmentImageSearchField {
  FILENAME = 'FILENAME'
}

/** Input type for specifying pagination parameters when querying visual assortment images. */
export type VisualAssortmentImagesPaginationInput = {
  /** The maximum number of visual assortment images to return in the query result. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The number of visual assortment images to skip before starting to collect the result set. */
  offset?: InputMaybe<Scalars['Int']>;
};

/** Input type for searching visual assortment images using text and specific fields. */
export type VisualAssortmentImagesSearchInput = {
  /** An array of fields to search within. Specifies which fields of the visual assortment images should be considered for the search. */
  fields?: InputMaybe<Array<VisualAssortmentImageSearchField>>;
  /** The search text to match against the visual assortment images. */
  text?: InputMaybe<Scalars['String']>;
};

/**
 * Limits and capabilities of a Visual Assortment plan.
 *
 * The same shape carries the plan's own limits, the limits negotiated for the account and the
 * merge of the two. A null numeric limit means the capability is not available, and -1 means
 * unlimited. On customAccountLimits a null field means nothing was negotiated and the plan
 * decides; on effectiveLimits every capability is a real boolean.
 */
export type VisualAssortmentLimits = {
  /** Whether budgets are available. */
  budgetsEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether products can be added from outside JOOR. */
  customProductsEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of years that Visual Assortment data is retained. */
  dataStorageYears?: Maybe<Scalars['Int']>;
  /** Whether the assortment can be exported. */
  exportsEnabled?: Maybe<Scalars['Boolean']>;
  /** Whether the assortment can be filtered. */
  filtersEnabled?: Maybe<Scalars['Boolean']>;
  /** Maximum number of values allowed per custom attribute type. */
  maxCustomAttributeValues?: Maybe<Scalars['Int']>;
  /** Maximum number of custom attribute types (keys) allowed. */
  maxCustomAttributes?: Maybe<Scalars['Int']>;
  /** Maximum number of doors allowed. */
  maxDoors?: Maybe<Scalars['Int']>;
  /** Maximum number of levels an assortment can be grouped by. */
  maxGroupingLevels?: Maybe<Scalars['Int']>;
  /** Maximum number of products allowed. */
  maxProducts?: Maybe<Scalars['Int']>;
  /** Maximum number of seasons allowed. */
  maxSeasons?: Maybe<Scalars['Int']>;
  /** Maximum number of users allowed. */
  maxUsers?: Maybe<Scalars['Int']>;
  /** Whether the details of a product can be edited. */
  productDetailEditingEnabled?: Maybe<Scalars['Boolean']>;
};

/** Summary of Visual Assortment limits and active packages */
export type VisualAssortmentLimitsSummary = {
  /** Active Visual Assortment packages for the viewing account */
  activePackages: Array<Scalars['String']>;
  /** Custom limits for the Visual Assortment account */
  customAccountLimits: VisualAssortmentLimits;
  /** Effective limits after applying overrides on top of package limits */
  effectiveLimits: VisualAssortmentLimits;
  /** Whether there are custom limits configured */
  hasCustomAccountLimits: Scalars['Boolean'];
  /** Limits from the selected Visual Assortment package */
  packageLimits: VisualAssortmentLimits;
  /** The one-time Premium preview: whether it is on offer, running, or gone. */
  preview: VisualAssortmentPreview;
};

export type VisualAssortmentOptions = {
  /** Distinct brand names for cards in a given Visual Assortment */
  brands: Array<Scalars['String']>;
  /** List of global available categories for cards in visual assortments */
  categories: Array<VisualAssortmentCardCategory>;
  /** List of global available colors for cards in visual assortments */
  colors: Array<VisualAssortmentCardColor>;
};


export type VisualAssortmentOptionsbrandsArgs = {
  visualAssortmentId: Scalars['ID'];
};

/** Represents an order that is synced with a visual assortment */
export type VisualAssortmentOrderInSync = {
  /** Base64 encoded AccountId that added this order to the Visual Assortment */
  addedByAccountId: Scalars['ID'];
  /** Timestamp when the order was added to the visual assortment (ISO format) */
  createdAt: Scalars['Date'];
  /** Base64 encoded visual assortment order in sync id -> VisualAssortmentOrderInSync:123 */
  id: Scalars['ID'];
  /** Base64 encoded PublicOrderId that is synced with the Visual Assortment */
  orderId: Scalars['ID'];
  /** Timestamp when the order sync was last updated (ISO format) */
  updatedAt: Scalars['Date'];
  /** Visibility level for the order */
  visibility: RetailerAccountVisibility;
};

/**
 * The one-time Premium preview. There is deliberately no "used" flag: nothing on screen
 * distinguishes an account that already spent its preview from one that was never eligible.
 */
export type VisualAssortmentPreview = {
  /** Whether a preview is running for the account right now. */
  active: Scalars['Boolean'];
  /** Whether the account can start the preview. */
  available: Scalars['Boolean'];
  /**
   * How many days a preview lasts, as configured on the Premium price. The length of the
   * window, not what is left of a running one — for that, use endsAt. Reported whatever
   * state the account is in, and null only when no preview price is configured for the
   * environment.
   */
  durationDays?: Maybe<Scalars['Int']>;
  /** When the running preview ends (ISO format). Null when no preview is running. */
  endsAt?: Maybe<Scalars['Date']>;
  /**
   * The Premium price the preview runs on, to be passed straight to
   * createStripeProductLink. Null when no preview price is configured for the environment.
   */
  priceId?: Maybe<Scalars['ID']>;
};

export type Warehouse = {
  availabilityGroups: InventoryAvailabilityGroupConnection;
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  orderNbr?: Maybe<Scalars['Int']>;
};

export type WarehouseAggregateSkuInventoryItemList = {
  items?: Maybe<Array<AggregateSkuInventoryItem>>;
  warehouse: Warehouse;
};

export type WarehouseConnection = {
  edges: Array<Maybe<WarehouseEdge>>;
};

export type WarehouseEdge = {
  node?: Maybe<Warehouse>;
};

export type WholesaleTotalsByPriceType = {
  priceType: PriceType;
  wholesaleTotal: Scalars['Decimal'];
};

export type WorkspaceOrAssortment = Assortment | RetailWorkspace;

/** Each node of this object is of type Assortment or RetailWorkspace, whereas the cursor is its index */
export type WorkspaceOrAssortmentEdge = {
  cursor: Scalars['String'];
  node: WorkspaceOrAssortment;
};

export type ZendeskUser = {
  SSOToken: Scalars['String'];
  messagingToken: Scalars['String'];
};

/** Creates a new collaboration invite for a non Joor user. */
export type createCollaborationInviteInput = {
  invitedEmail: Scalars['String'];
  invitedFullname: Scalars['String'];
  invitingAccountId: Scalars['ID'];
};

export type createSubmissionTemplateInput = {
  attachments?: InputMaybe<Array<SubmissionTemplateAttachmentInput>>;
  categories?: InputMaybe<Array<SubmissionTemplateCategoryInput>>;
  collections?: InputMaybe<Array<SubmissionTemplateCollectionInput>>;
  headerImages?: InputMaybe<Array<SubmissionTemplateHeaderImageInput>>;
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
};

export type deleteSubmissionTemplateInput = {
  id: Scalars['ID'];
};

export type deleteUnavailableProductsInput = {
  orderId: Scalars['ID'];
};

export type deleteUnavailableProductsPayload = {
  sentMail: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export enum exportFormats {
  SKU = 'SKU',
  STYLE_COLOR = 'STYLE_COLOR',
  UNKNOWN = 'UNKNOWN'
}

export type sendSubmissionInput = {
  aiMessage?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<SubmissionAttachmentInput>>;
  categories?: InputMaybe<Array<SubmissionCategoryInput>>;
  collections?: InputMaybe<Array<SubmissionCollectionInput>>;
  connectionRequestPriceTypes?: InputMaybe<Array<RequestPriceType>>;
  headerImages?: InputMaybe<Array<SubmissionHeaderImageInput>>;
  message?: InputMaybe<Scalars['String']>;
  recipientAccountId?: InputMaybe<Scalars['ID']>;
  recipientAccountUserId?: InputMaybe<Scalars['ID']>;
  sendConnectionRequest?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type uniqueTagValuesFilter = {
  collectionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type updateAccountsLinkedToStoreInput = {
  accountsToLink: Array<Scalars['ID']>;
  accountsToUnlink: Array<Scalars['ID']>;
  appName: ShopifyAppName;
  shopUrl: Scalars['String'];
};

export type updateSubmissionTemplateInput = {
  attachments?: InputMaybe<Array<SubmissionTemplateAttachmentInput>>;
  categories?: InputMaybe<Array<SubmissionTemplateCategoryInput>>;
  collections?: InputMaybe<Array<SubmissionTemplateCollectionInput>>;
  headerImages?: InputMaybe<Array<SubmissionTemplateHeaderImageInput>>;
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type variantItemsInput = {
  doorId?: InputMaybe<Scalars['ID']>;
  variantId: Scalars['ID'];
};

export type RecordExportStatusMutationMutationVariables = Exact<{
  assortmentId: Scalars['ID'];
  success: Scalars['Boolean'];
}>;


export type RecordExportStatusMutationMutation = { createAssortmentsExportRecord: { assortmentId: string } };

export type PdfExportMutationMutationVariables = Exact<{
  input: TriggerAssortmentPDFExportTasksInput;
}>;


export type PdfExportMutationMutation = { task: { responses: Array<string | null> } };

export type XlsxExportMutationMutationVariables = Exact<{
  input: TriggerAssortmentExcelExportTasksInput;
}>;


export type XlsxExportMutationMutation = { task: { responses: Array<string | null> } };

export type BulkAssortmentExportAsyncMutationMutationVariables = Exact<{
  assortmentIds: Array<Scalars['ID']> | Scalars['ID'];
  integrationId: Scalars['ID'];
}>;


export type BulkAssortmentExportAsyncMutationMutation = { result: { jobId: string } };

export type AvailableAssortmentExportsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AvailableAssortmentExportsQuery = { account: { id: string, assortmentIntegrations?: Array<{ id: string, name: string }> | null }, integrations: Array<{ id: string, name: string, type?: ExportType | null, fileExtension?: ExportFileExtensionType | null, columnConfig: string, level?: ExportLevel | null, autoStatus: Array<number> }> };

export type ExportStatusQueryVariables = Exact<{
  exportIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ExportStatusQuery = { results: Array<{ id: string, status: AssortmentExportStatus, downloadUrl?: any | null }> };

export type ListExportJobQueryVariables = Exact<{
  jobsIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ListExportJobQuery = { listJobs: { edges: Array<{ node: { status: CeleryJobStatus, inputFileUrl?: string | null } }> } };

export type setBrandNoteSeasonMutationVariables = Exact<{
  assortmentId: Scalars['ID'];
  seasonId?: InputMaybe<Scalars['ID']>;
}>;


export type setBrandNoteSeasonMutation = { updateAssortmentDetails: { assortment?: { id: string } | null, errors?: Array<{ message: string }> | null } };

export type AssortmentMoveToRetailWorkspaceMutationVariables = Exact<{
  assortmentId: Scalars['ID'];
  retailWorkspaceId?: InputMaybe<Scalars['ID']>;
  seasonId?: InputMaybe<Scalars['ID']>;
}>;


export type AssortmentMoveToRetailWorkspaceMutation = { assortmentMoveToRetailWorkspace?: { retailWorkspace?: { id: string, assortments: Array<{ id: string }> } | null } | null };

export type GroupedWorkspaceCursorsQueryVariables = Exact<{
  filters?: InputMaybe<AssortmentFilter>;
  orderBy?: InputMaybe<AssortmentsQueryOrderBy>;
}>;


export type GroupedWorkspaceCursorsQuery = { assortmentsQuery: { workspaces: Array<{ cursor: string }> } };

export type QueryGroupedWorkspacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AssortmentFilter>;
  orderBy?: InputMaybe<AssortmentsQueryOrderBy>;
}>;


export type QueryGroupedWorkspacesQuery = { assortmentsQuery: { totalCountWorkspaces: number, workspaces: Array<{ cursor: string, node: { id: string, name: string, status: AssortmentStatus, latestExport?: AssortmentExportStatus | null, exportMessage?: string | null, poNumber: string, createdDate: any, modifiedDate: any, brand?: { alias?: string | null, id: string, name: string } | null, season?: { node: { code: string, name: string, year?: number | null } } | null, createdByUser: { node?: { email: string, displayName: string } | null }, deliveryWindow: { startShip?: any | null, completeShip?: any | null } } | { id: string, name: string, assortments: Array<{ id: string, createdDate: any, modifiedDate: any, status: AssortmentStatus, brand?: { alias?: string | null, id: string, name: string } | null, season?: { node: { code: string, name: string, year?: number | null } } | null, createdByUser: { node?: { email: string, displayName: string } | null }, deliveryWindow: { startShip?: any | null, completeShip?: any | null } }> } }> } };

export type WorkspaceExtraDetailsQueryVariables = Exact<{
  workspaceId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type WorkspaceExtraDetailsQuery = { retailWorkspaces: Array<{ id: string, assortments: Array<{ id: string, financialOverview: { assortmentUnitsOverview: { productCount?: number | null }, financialDetails: Array<{ currencyCode: string, isBrandCurrency?: boolean | null, units: { unitCount?: number | null }, priceLevels: Array<{ name: FinancialPriceLevelName, extendedCost: { value: any, currencyCode: string }, extendedRetail: { value: any, currencyCode: string } }> }> } }> }> };

export type WorkspaceCursorsQueryVariables = Exact<{
  filters?: InputMaybe<AssortmentFilter>;
  orderBy?: InputMaybe<AssortmentsQueryOrderBy>;
}>;


export type WorkspaceCursorsQuery = { workspaces: { edges: Array<{ cursor: string }> } };

export type QueryWorkspacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AssortmentFilter>;
  orderBy?: InputMaybe<AssortmentsQueryOrderBy>;
}>;


export type QueryWorkspacesQuery = { workspaces: { totalCount: number, edges: Array<{ node: { id: string, name: string, status: AssortmentStatus, latestExport?: AssortmentExportStatus | null, exportMessage?: string | null, poNumber: string, createdDate: any, modifiedDate: any, brand?: { alias?: string | null, id: string, name: string } | null, season?: { node: { code: string, name: string, year?: number | null } } | null, createdByUser: { node?: { email: string, displayName: string } | null }, deliveryWindow: { startShip?: any | null, completeShip?: any | null }, workspace?: { id: string } | null } }> } };

export type AssortmentExtraDetailsQueryVariables = Exact<{
  assortmentId: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AssortmentExtraDetailsQuery = { assortments: Array<{ id: string, orderAssortmentSyncStatus?: OrderAssortmentSyncStatus | null, financialOverview: { assortmentUnitsOverview: { productCount?: number | null }, financialDetails: Array<{ currencyCode: string, isBrandCurrency?: boolean | null, units: { unitCount?: number | null }, priceLevels: Array<{ name: FinancialPriceLevelName, extendedCost: { value: any, currencyCode: string }, extendedRetail: { value: any, currencyCode: string } }> }> } }> };

export type FilterFieldValuesQueryVariables = Exact<{
  filters?: InputMaybe<AssortmentFilter>;
}>;


export type FilterFieldValuesQuery = { assortmentsQuery: { fieldValues: { name: Array<string>, poNumber: Array<string>, createdByUser: Array<{ node?: { displayName: string } | null }>, brand: Array<{ id: string, alias?: string | null, name: string }>, season: Array<{ node: { name: string, year?: number | null, code: string } }> } } };

export type CreateOrderFromAssortmentMutationVariables = Exact<{
  input: CreateOrderFromAssortmentInput;
}>;


export type CreateOrderFromAssortmentMutation = { createOrderFromAssortment: { assortment: { id: string, orderAssortmentSyncStatus?: OrderAssortmentSyncStatus | null } } };

export type RequestAssortmentOrderUpdateMutationVariables = Exact<{
  input: RequestAssortmentOrderUpdateInput;
}>;


export type RequestAssortmentOrderUpdateMutation = { requestAssortmentOrderUpdate: { assortment: { id: string, orderAssortmentSyncStatus?: OrderAssortmentSyncStatus | null } } };

export type SendToBrandAssortmentQueryQueryVariables = Exact<{
  workspaceId: Scalars['ID'];
}>;


export type SendToBrandAssortmentQueryQuery = { assortment?: { brand?: { node?: { users: Array<{ displayName?: string | null, email?: string | null }> } | null } | null } | null };

export type retailersThatFavoritedBrandDupe1QueryVariables = Exact<{
  brandAccountId: Scalars['ID'];
}>;


export type retailersThatFavoritedBrandDupe1Query = { retailersThatFavoritedBrand: Array<{ retailerAccountId: string, timeFavorited: any }> };

export type accountConnectionStatusesQueryVariables = Exact<{
  accountId: Scalars['ID'];
  otherAccountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type accountConnectionStatusesQuery = { accountConnectionStatuses: Array<{ status: Status }> };

export type OrdersForStyleCancellationAggregatedTotalsQueryVariables = Exact<{
  filters: OrderFilterInput;
  productsFilters?: InputMaybe<OrderProductFilterInput>;
}>;


export type OrdersForStyleCancellationAggregatedTotalsQuery = { orders: { edges: Array<{ node: { id: string, products: { wholesaleTotal?: any | null, totalUnits?: number | null } } }> } };

export type CreateSelfServeConfigMutationMutationVariables = Exact<{
  createExportIntegrationConfigInput: CreateExportIntegrationConfigInput;
}>;


export type CreateSelfServeConfigMutationMutation = { createExportIntegrationConfig: { id: string } };

export type ListSelfServeConfigsForAccountQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ListSelfServeConfigsForAccountQuery = { accountExportIntegrationConfigs: Array<{ id: string, accountId?: string | null, isActive?: boolean | null, columnConfig: string, name: string, type?: ExportType | null, level?: ExportLevel | null, autoStatus: Array<number>, ftpPath?: string | null, fileExtension?: ExportFileExtensionType | null, overwrittenFileExtension?: string | null, fileNameParts: Array<ExportFileNameParts>, textQualifier: string, defaultClusterDoors?: Array<string | null> | null, removeHeader?: boolean | null, excludeSkusWithZeroQuantities?: boolean | null, doorQuantityColumn?: boolean | null, combineExportsIntoSingleFile?: boolean | null, csvDelimiter?: CsvDelimiterType | null, unzipFilesToFTPPath?: boolean | null, convertSingleDoorToCluster?: boolean | null, convertImagesUrlsToColumns?: boolean | null, fileNameDelimiter?: string | null, fileNamePrefix?: string | null, csvEncodingType?: ExportCSVEncodingType | null, onlySkuQuantities?: boolean | null }> };

export type UpdateSelfServeConfigMutationMutationVariables = Exact<{
  updateExportIntegrationConfigInput: UpdateExportIntegrationConfigInput;
}>;


export type UpdateSelfServeConfigMutationMutation = { updateExportIntegrationConfig: { id: string } };

export type updateAccountUserDataPermissionConfigurationMutationVariables = Exact<{
  input: UpdateAccountUserDataPermissionConfigurationInput;
}>;


export type updateAccountUserDataPermissionConfigurationMutation = { updateAccountUserDataPermissionConfiguration: { success: boolean } };

export type bulkDeleteDataPermissionConfigurationsMutationVariables = Exact<{
  input: BulkDeleteDataPermissionConfigurationsInput;
}>;


export type bulkDeleteDataPermissionConfigurationsMutation = { bulkDeleteDataPermissionConfigurations: { success: boolean } };

export type acceptUserMembershipRequestMutationVariables = Exact<{
  input: AcceptUserMembershipRequestInput;
}>;


export type acceptUserMembershipRequestMutation = { acceptUserMembershipRequest: { success?: boolean | null } };

export type updateAccountPermissionsMutationVariables = Exact<{
  input: UpdateAccountPermissionAccessInput;
}>;


export type updateAccountPermissionsMutation = { updateAccountPermissionAccess: { success: boolean } };

export type createUserMembershipInviteMutationVariables = Exact<{
  input: CreateUserMembershipInviteInput;
}>;


export type createUserMembershipInviteMutation = { createUserMembershipInvite: { membershipInvite?: { id: string, status?: UserMembershipInviteStatus | null, expiresAt?: any | null } | null } };

export type brandUsersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type brandUsersQueryQuery = { brands: { edges: Array<{ node?: { id: string, brandUsers?: { edges: Array<{ displayName?: string | null, node?: { id: string, email?: string | null, displayName?: string | null } | null, dataPermissionConfiguration?: { id: string, name: string } | null }> } | null } | null }> } };

export type dataPermissionConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type dataPermissionConfigurationsQuery = { activeViewingAccount: { id: string }, dataPermissionConfigurations: { edges: Array<{ node: { id: string, name: string, configuration?: { divisionPermissions: Array<{ id: string, name: string, code: string }>, divisionCategoryPermissions: Array<{ category: { id?: string | null, name: string }, division: { id: string, name: string, code: string } }>, collectionPermissions: Array<{ id: string, name: string }>, priceTypePermissions: Array<{ id: string, name: string, currencyCode: string }> } | null } }> } };

export type assignedDataPermissionConfigurationQueryVariables = Exact<{
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type assignedDataPermissionConfigurationQuery = { accountUserDataPermissionConfiguration?: { id: string, name: string, configuration?: { divisionPermissions: Array<{ id: string, name: string, code: string }>, divisionCategoryPermissions: Array<{ category: { id?: string | null, name: string }, division: { id: string, name: string, code: string } }>, collectionPermissions: Array<{ id: string, name: string }>, priceTypePermissions: Array<{ id: string, name: string, currencyCode: string }> } | null } | null };

export type accountUserMembershipRequestsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  filter?: InputMaybe<UserMembershipRequestFilter>;
}>;


export type accountUserMembershipRequestsQuery = { userMembershipRequests: { edges: Array<{ node?: { id: string, userId: string, status?: UserMembershipRequestStatus | null, email?: string | null } | null }> } };

export type ActiveViewingAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveViewingAccountQuery = { activeViewingAccount: { id: string, name: string } };

export type AccountPermissionsDupe1QueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountPermissionsDupe1Query = { accountPermissionAccess: { edges: Array<{ node: { id: string } }> } };

export type createDataPermissionConfigurationMutationVariables = Exact<{
  input: CreateDataPermissionConfigurationInput;
}>;


export type createDataPermissionConfigurationMutation = { createDataPermissionConfiguration: { dataPermissionConfiguration: { id: string } } };

export type updateDataPermissionConfigurationMutationVariables = Exact<{
  input: UpdateDataPermissionConfigurationInput;
}>;


export type updateDataPermissionConfigurationMutation = { updateDataPermissionConfiguration: { dataPermissionConfiguration: { id: string } } };

export type categoriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type categoriesQueryQuery = { categories: { edges: Array<{ node: { id?: string | null, name: string, parentName?: string | null, department?: string | null } }> } };

export type CollectionsQueryDupe1QueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CollectionsQueryDupe1Query = { collections: { edges: Array<{ node: { id: string, name: string } } | null> } };

export type dataPermissionConfigurationQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type dataPermissionConfigurationQueryQuery = { dataPermissionConfigurations: { edges: Array<{ node: { name: string, id: string, configuration?: { divisionPermissions: Array<{ id: string }>, divisionCategoryPermissions: Array<{ division: { id: string }, category: { id?: string | null } }>, collectionPermissions: Array<{ id: string }>, priceTypePermissions: Array<{ id: string }> } | null } }> } };

export type PriceTypesQueryDupe1QueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PriceTypesQueryDupe1Query = { priceTypes: { edges: Array<{ node: { id: string, name: string, currencyCode: string } }> } };

export type createRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type createRegionMutation = { createRegion: { id: string, name: string, custom: boolean } };

export type deleteRegionMutationVariables = Exact<{
  input: DeleteRegionInput;
}>;


export type deleteRegionMutation = { deleteRegion?: { success?: boolean | null } | null };

export type updateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type updateRegionMutation = { updateRegion: { id: string } };

export type checkMergingOrderCriteriaDupe1QueryVariables = Exact<{
  selectedOrdersIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type checkMergingOrderCriteriaDupe1Query = { checkMergingOrderCriteria?: { message: Array<string>, success: boolean } | null };

export type OrderSettingsDupe1QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OrderSettingsDupe1Query = { orderSettings: Array<{ multipleDivisionsAllowed?: boolean | null }> };

export type OrderExportTaskStatusQueryVariables = Exact<{
  input: ListOrderExportTasksInput;
}>;


export type OrderExportTaskStatusQuery = { listOrderExportTasks: { exportTasks: Array<{ id: string, status: OrderExportTaskStatus, downloadUrl: string }> } };

export type BulkSetOrdersToReexportMutationVariables = Exact<{
  input: BulkSetOrdersToReexportInput;
}>;


export type BulkSetOrdersToReexportMutation = { bulkSetOrdersToReexport: { updatedOrderIds: Array<string> } };

export type salesRepQueryQueryVariables = Exact<{
  brandId: Scalars['ID'];
  includeInactives?: InputMaybe<Scalars['Boolean']>;
}>;


export type salesRepQueryQuery = { brands: { edges: Array<{ node?: { id: string, brandUsers?: { edges: Array<{ node?: { id: string, displayName?: string | null, code?: string | null, active: boolean } | null }> } | null } | null }> } };

export type UpdatePaymentSettingsMutationMutationVariables = Exact<{
  input: UpdatePaymentSettingsInput;
}>;


export type UpdatePaymentSettingsMutationMutation = { updatePaymentSettings: { externalIdentifier: string, retailersCanSeeInvoices?: boolean | null, sendBrandMailPaymentProcessed?: boolean | null, sendRetailerMailPaymentProcessed?: boolean | null, brandNotificationEmail?: string | null } };

export type UpdatePaymentMethodsMutationVariables = Exact<{
  input: UpdateAvailablePaymentMethodsInput;
}>;


export type UpdatePaymentMethodsMutation = { updateAvailablePaymentMethods: { isSepaEnabled?: boolean | null, isAchEnabled?: boolean | null } };

export type connectPaymentProviderMutationVariables = Exact<{
  input: ConnectPaymentProviderInput;
}>;


export type connectPaymentProviderMutation = { connectPaymentProvider: { accountId: string, paymentProvider: string, externalIdentifier: string } };

export type updateAccountProviderMutationVariables = Exact<{
  input: ConnectPaymentProviderInput;
}>;


export type updateAccountProviderMutation = { updateAccountProvider: { accountId: string, paymentProvider: string, externalIdentifier: string } };

export type paymentProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type paymentProvidersQuery = { paymentProviders: Array<{ name: string, connectUrl: string, loginUrl: string }> };

export type updateAccountUserGeoRestrictionsMutationVariables = Exact<{
  input: UpdateAccountUserGeoRestrictionsInput;
}>;


export type updateAccountUserGeoRestrictionsMutation = { updateAccountUserGeoRestrictions: { success: boolean } };

export type updateAccountUsersPermissionAccessMutationVariables = Exact<{
  input: UpdateAccountUsersPermissionAccessInput;
}>;


export type updateAccountUsersPermissionAccessMutation = { updateAccountUsersPermissionAccess: { success: boolean } };

export type updateAccountUserPossibleExceptionsMutationVariables = Exact<{
  input: UpdateAccountUserPossibleExceptionsInput;
}>;


export type updateAccountUserPossibleExceptionsMutation = { updateAccountUserPossibleExceptions: Array<{ name: string, id: string }> };

export type AccountUserGeoRestrictionsQueryVariables = Exact<{
  userId: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type AccountUserGeoRestrictionsQuery = { accountUserGeoRestrictions: { id: string, regionAssignedOverride: boolean, regions: { edges: Array<{ node: { id: string, name: string } }> }, exceptionAccounts: Array<{ name: string, id: string }>, possibleExceptionAccounts: Array<{ name: string, id: string }> } };

export type RegionsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type RegionsQuery = { regions: { edges: Array<{ node: { id: string, name: string } }> } };

export type accountUserPermissionAccessQueryVariables = Exact<{
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type accountUserPermissionAccessQuery = { accountUserPermissionAccess: { edges: Array<{ node: { id: string } }> } };

export type ProductTraitValuesQueryDupe1QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type ProductTraitValuesQueryDupe1Query = { productTraitValues: { edges: Array<{ node: { id: string, value: string, externalIdentifier: string, trait: { id: string, code: string, name: string } } }> } };

export type StyleTagsDupe1QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type StyleTagsDupe1Query = { uniqueTagValues: { edges: Array<{ node: { value: string, tag: { id: string, name: string, groupName: string } } }> } };

export type BadgesDupe1QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BadgesDupe1Query = { badges: { edges: Array<{ node: { id: string, name: string } }> } };

export type retailerBrandsQueryQueryVariables = Exact<{
  retailerId: Scalars['ID'];
}>;


export type retailerBrandsQueryQuery = { retailer?: { brands: { edges: Array<{ alias?: string | null, code?: string | null, node?: { id: string, name: string } | null }> } } | null };

export type orderSettingsQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type orderSettingsQuery = { orderSettings: Array<{ brandId: string, minUnits?: number | null, minAmount?: number | null, minDetail?: string | null }> };

export type noteVariantsDupe1MutationVariables = Exact<{
  input: AddVariantsInProgressInput;
}>;


export type noteVariantsDupe1Mutation = { addVariantsInProgress: { orderIds?: Array<string> | null } };

export type CreateOrphanRetailerMutationVariables = Exact<{
  accountId: Scalars['ID'];
  retailerName: Scalars['String'];
  retailerEmail: Scalars['String'];
  connectionProcessed: Scalars['Boolean'];
}>;


export type CreateOrphanRetailerMutation = { createOrphanRetailer?: { id: string, retailerName: string, retailerEmail: string, retailerCode?: string | null, connectionProcessed: boolean, update: any, created: any, deleted?: boolean | null } | null };

export type CombinedCollectionsAndProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  collectionProductsFilters?: InputMaybe<ProductsCollectionFilter>;
  collectionsBrandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  collectionProductsBrandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  priceTypeId: Scalars['ID'];
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
  orderBy?: InputMaybe<CollectionProductOrderByInput>;
  productVideosAreEnabled: Scalars['Boolean'];
  externalMediaEnabled: Scalars['Boolean'];
}>;


export type CombinedCollectionsAndProductsQuery = { collections: { edges: Array<{ node: { id: string, name: string, description?: string | null, madeToOrder?: boolean | null, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null } | null, season?: { id: string, year?: number | null, name: string, code: string } | null } } | null> }, collectionProducts: { edges: Array<{ node: { id: string, comments: string, groupedBy?: { id?: string | null, name: string, value: string } | null, skus: { edges?: Array<{ node?: { id: string } | null }> | null }, casepacks: { edges: Array<{ node: { id: string } }> }, product: { id: string, name: string, externalIdentifier: string, badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> }, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> }, images: Array<{ url?: string | null }>, videos?: Array<{ id?: string | null, url?: string | null }>, externalMedia?: Array<{ id: string, url: string, type: string, format: string, thumbnailUrl: string, payload: string }> }, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number, maxRetailValue: number } | null, collection: { id: string }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> } } }> } };

export type collectionProductsGroupTotalQueryQueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type collectionProductsGroupTotalQueryQuery = { collectionProductsGroupTotal: Array<{ total: number, collection: { id: string } }> };

export type collectionProductsTotalQueryDupe1QueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type collectionProductsTotalQueryDupe1Query = { collectionProductsTotal: number };

export type WarehousesQueryDupe1QueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']>;
}>;


export type WarehousesQueryDupe1Query = { warehouses: { edges: Array<{ node?: { id: string, name: string, code: string, availabilityGroups: { edges: Array<{ node: { id: string, isEmpty?: boolean | null, availability: { availableOn?: any | null, isImmediate: boolean } } } | null> } } | null } | null> } };

export type aggregateSkuInventoryItemsDupe1QueryVariables = Exact<{
  warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
  filter?: InputMaybe<AggregateSkuInventoryItemsFilter>;
}>;


export type aggregateSkuInventoryItemsDupe1Query = { aggregateSkuInventoryItems: Array<{ items?: Array<{ availableQuantity: number, skuId: string }> | null }> };

export type variantsInCartQueryVariables = Exact<{
  brandId: Scalars['ID'];
  retailerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orphanRetailerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type variantsInCartQuery = { variantsInCart: Array<{ variantId: string, orderId: string, collection: { id: string, name: string }, product: { id: string }, priceType: { id: string, name: string, currency: { id: string, name: string, code: string } }, warehouse?: { id: string, name: string } | null, door?: { id: string, name: string, code?: string | null } | null }> };

export type CollectionProductsByShareTokenQueryQueryVariables = Exact<{
  token: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionProductsByShareTokenQueryQuery = { public: { collectionProductsByShareToken: { totalCount: number, edges: Array<{ node: { id: string, collection: { id: string, name: string, description: string, delivery: { id: string, startShipDate?: any | null, completeShipDate?: any | null } }, product: { id: string, name: string, imageUrls: Array<string>, badges: Array<{ id: string, name: string, image?: { url?: string | null } | null }>, traitValues: Array<{ id: string, value: string, trait: { id: string, name: string, code: string } }>, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number, maxRetailValue: number } | null, externalMedia: Array<{ id: string, thumbnailUrl: string }> }, variants: Array<{ id: string, name: string, code: string, values: Array<{ id: string, value: string, customerCode: string, trait: { id: string, code: string, name: string }, displayDetails: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } }> }> } }> } } };

export type createConfigurationMutationVariables = Exact<{
  input: CreateConfigurationInput;
}>;


export type createConfigurationMutation = { createConfiguration?: { id: string } | null };

export type updateConfigurationMutationVariables = Exact<{
  input: UpdateConfigurationInput;
}>;


export type updateConfigurationMutation = { updateConfiguration?: { id: string } | null };

export type deleteConfigurationMutationVariables = Exact<{
  input: DeleteConfigurationInput;
}>;


export type deleteConfigurationMutation = { deleteConfiguration?: { success?: boolean | null } | null };

export type deliveryReportFeatureQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type deliveryReportFeatureQuery = { deliveryReportFeature?: boolean | null };

export type brandProfileNameQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type brandProfileNameQuery = { brandProfiles: { edges: Array<{ node?: { id: string, name?: string | null } | null } | null> } };

export type configurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type configurationsQuery = { configurations?: Array<{ userId: string, accountId: string, visibility: ConfigurationVisibility, id: string, data: string, name?: string | null, projectName?: string | null, default?: boolean | null, sharedUserIds?: Array<string> | null, created?: any | null } | null> | null };

export type LookQueryQueryVariables = Exact<{
  lookId: Scalars['ID'];
}>;


export type LookQueryQuery = { look: { id: string, layout: string, items: Array<{ variantId?: string | null, collectionProduct?: { id: string, variantTotal: number, product: { id: string, externalIdentifier: string, name: string, images: Array<{ url?: string | null }>, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } }, collection: { id: string, name: string }, priceTypes: { edges: Array<{ node: { id: string, retailCurrency: { id: string, name: string } } }> } } | null }>, media: Array<{ id: string, url: string, streamingUrl: string, type: LookMediaType }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }> } };

export type PriceRangeGroupsDupe1QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PriceRangeGroupsDupe1Query = { priceRangeGroups: { edges: Array<{ node: { priceType: { id: string, name: string, retailCurrency: { id: string, name: string } } } }> } };

export type UpdateCollectionMutationVariables = Exact<{
  input: UpdateShowroomCollectionsInput;
}>;


export type UpdateCollectionMutation = { updateShowroomCollections: Array<{ id: string, name: string, visibleToAllConnected: boolean, status: ShowroomCollectionStatus }> };

export type PriceRangeGroupsDupe2QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PriceRangeGroupsDupe2Query = { priceRangeGroups: { edges: Array<{ node: { priceType: { id: string, name: string, retailCurrency: { id: string, name: string } } } }> } };

export type CollectionsQueryDupe3QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ShowroomCollectionsFilter>;
  orderBy?: InputMaybe<ShowroomCollectionOrderBy>;
  fetchAllInfo: Scalars['Boolean'];
}>;


export type CollectionsQueryDupe3Query = { showroomCollections: { totalCount: number, pageInfo?: { hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ node: { id: string, name: string, visibleToAllConnected: boolean, status: ShowroomCollectionStatus, lastModified: any, created: any, brand: { id: string, name: string }, url3dShowroom?: { id: string, name: string, provider: Provider3dShowroom, url: string } | null, owner: { displayName: string, userId: string, userEmail: string }, showroomCollectionShares: { teamRecipients: Array<{ user: { displayName?: string | null, email?: string | null } }>, retailerRecipients: Array<{ shareDate?: any | null, retailer: { name: string } }> } } }> } };

export type ShowroomCollectionListFiltersQueryVariables = Exact<{
  status?: InputMaybe<ShowroomCollectionStatus>;
}>;


export type ShowroomCollectionListFiltersQuery = { showroomCollectionListFilters: { showroomCollections: Array<{ id: string, name?: string | null }>, brands: Array<{ id: string, name?: string | null }>, ownerUsers: Array<{ id: string, name?: string | null }>, sharedUsers: Array<{ id: string, name?: string | null }>, sharedAccounts: Array<{ id: string, name?: string | null }> } };

export type Url3dShowroomQueryQueryVariables = Exact<{
  filter?: InputMaybe<Url3dShowroomFilter>;
}>;


export type Url3dShowroomQueryQuery = { url3dShowroom: Array<{ id: string, name: string, url: string, provider: Provider3dShowroom, displayUrl?: string | null } | null> };

export type UpsertUrl3dShowroomMutationVariables = Exact<{
  input: UpsertUrl3dShowroomInput;
}>;


export type UpsertUrl3dShowroomMutation = { upsertUrl3dShowroom: Array<{ id: string }> };

export type DeleteUrl3dShowroomMutationVariables = Exact<{
  input: DeleteUrl3dShowroomInput;
}>;


export type DeleteUrl3dShowroomMutation = { deleteUrl3dShowroom: { ids: Array<string> } };

export type AddStyleboardCommentMutationVariables = Exact<{
  input: AddStyleboardCommentInput;
}>;


export type AddStyleboardCommentMutation = { addStyleboardComment: { id: string, message: string, created: any, owner: { accountProfileName: string, userEmail: string, userDisplayName: string } } };

export type StyleboardCommentsQueryVariables = Exact<{
  styleboardId: Scalars['ID'];
}>;


export type StyleboardCommentsQuery = { styleboard: { comments: { edges: Array<{ node: { id: string, message: string, created: any, owner: { accountProfileName: string, userEmail: string, userDisplayName: string }, taggedAccountUsers: { edges: Array<{ node: { id: string, displayName: string, userEmail: string, userName: string } }> } } }> } } };

export type VisibleUsersQueryQueryVariables = Exact<{
  styleboardId: Scalars['ID'];
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type VisibleUsersQueryQuery = { styleboardVisibleToAccountUsers: { edges: Array<{ node: { id: string, userEmail: string, accountName: string, displayName: string } }> } };

export type UpdateStyleboardsDupe1MutationVariables = Exact<{
  input: UpdateStyleboardsInput;
}>;


export type UpdateStyleboardsDupe1Mutation = { updateStyleboards: Array<{ id: string, name: string, status: StyleboardStatus }> };

export type UpsertStyleboardDupe1MutationVariables = Exact<{
  input: UpsertStyleboardInput;
}>;


export type UpsertStyleboardDupe1Mutation = { upsertStyleboard: { id: string, lastModified: string, brand: { id: string, name: string, priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { name: string, id: string, code: string } } }> } } } };

export type PriceRangeGroupsDupe3QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  productIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PriceRangeGroupsDupe3Query = { priceRangeGroups: { edges: Array<{ node: { priceType: { id: string, name: string } } }> } };

export type UpdateStyleboardsDupe2MutationVariables = Exact<{
  input: UpdateStyleboardsInput;
}>;


export type UpdateStyleboardsDupe2Mutation = { updateStyleboards: Array<{ id: string, name: string, status: StyleboardStatus }> };

export type StyleboardBrandWarehousesQueryVariables = Exact<{
  filter?: InputMaybe<BrandsFilter>;
}>;


export type StyleboardBrandWarehousesQuery = { brands: { edges: Array<{ node?: { warehouses: { edges: Array<{ node?: { id: string, name: string, code: string } | null } | null> } } | null }> } };

export type StyleboardsQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<StyleboardsFilter>;
  orderBy?: InputMaybe<StyleboardOrderBy>;
  fetchAllInfo: Scalars['Boolean'];
}>;


export type StyleboardsQueryQuery = { styleboards: { totalCount?: number | null, pageInfo?: { hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ node: { id: string, name: string, status: StyleboardStatus, created: any, lastModified: string, owner: { displayName: string, userId: string, userEmail: string }, brand: { id: string, name: string }, styleboardShares?: { teamRecipients: Array<{ user?: { id: string, displayName?: string | null, email?: string | null } | null }>, externalRecipients: Array<{ email?: string | null, account: { id: string, name: string } }> } | null } }> | null } };

export type StyleboardListFiltersQueryVariables = Exact<{
  status?: InputMaybe<StyleboardStatus>;
}>;


export type StyleboardListFiltersQuery = { styleboardListFilters: { styleboards: Array<{ id: string, name?: string | null }>, brands: Array<{ id: string, name?: string | null }>, ownerUsers: Array<{ id: string, name?: string | null }>, sharedUsers: Array<{ id: string, name?: string | null }>, sharedAccounts: Array<{ id: string, name?: string | null }> } };

export type StyleboardCommentsQueryQueryVariables = Exact<{
  lastLogin: Scalars['DateTime'];
}>;


export type StyleboardCommentsQueryQuery = { styleboardComments: { edges: Array<{ node: { id: string, message: string } }> } };

export type IdConfigsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IdConfigsQueryQuery = { idpConfigs: { edges?: Array<{ node: { enabled?: boolean | null, domain: string, ssoLoginUrl: string, acsUrl: string, entityId: string, sigCert: string } }> | null } };

export type CreateIdentityProviderMutationMutationVariables = Exact<{
  input: CreateIdentityProviderInput;
}>;


export type CreateIdentityProviderMutationMutation = { createIdentityProvider?: { success: boolean, errors?: Array<string> | null, idpConfig?: { domain: string, ssoLoginUrl: string, acsUrl: string, entityId: string, sigCert: string } | null } | null };

export type UpdateIdentityProviderMutationMutationVariables = Exact<{
  input: UpdateIdentityProviderInput;
}>;


export type UpdateIdentityProviderMutationMutation = { updateIdentityProvider?: { success: boolean, errors?: Array<string> | null, idpConfig?: { domain: string, ssoLoginUrl: string, acsUrl: string, entityId: string, sigCert: string } | null } | null };

export type DeleteIdentityProviderMutationMutationVariables = Exact<{
  input: DeleteIdentityProviderInput;
}>;


export type DeleteIdentityProviderMutationMutation = { deleteIdentityProvider?: { success: boolean, errors?: Array<string> | null } | null };

export type externalProviderAuthsQueryVariables = Exact<{ [key: string]: never; }>;


export type externalProviderAuthsQuery = { externalProviderAuths: Array<{ id: string, brandId: string, provider: string, apiKey: string }> };

export type createExternalProviderAuthMutationVariables = Exact<{
  input: CreateExternalProviderAuthInput;
}>;


export type createExternalProviderAuthMutation = { createExternalProviderAuth: { id: string, brandId: string, provider: string, apiKey: string } };

export type bulkDeleteExternalProviderAuthsMutationVariables = Exact<{
  input: BulkDeleteExternalProviderAuthsInput;
}>;


export type bulkDeleteExternalProviderAuthsMutation = { bulkDeleteExternalProviderAuths: { externalProviderAuthsIds: Array<string> } };

export type userQueryQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type userQueryQuery = { user?: { id: string, email?: string | null, displayName?: string | null } | null };

export type BulkUpdateAssortmentDetailsMutationMutationVariables = Exact<{
  input: Array<UpdateAssortmentDetailsInput> | UpdateAssortmentDetailsInput;
}>;


export type BulkUpdateAssortmentDetailsMutationMutation = { bulkUpdateAssortmentDetails: { assortmentIds: Array<string> } };

export type CreateAssortmentMutationVariables = Exact<{
  retailerId: Scalars['ID'];
  retailCurrencyId?: InputMaybe<Scalars['ID']>;
  wholesaleCurrencyId?: InputMaybe<Scalars['ID']>;
  assortmentName?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  seasonId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateAssortmentMutation = { createAssortment: { assortment?: { id: string, retailer: { node?: { id: string } | null } } | null } };

export type CreateRetailWorkspaceMutationVariables = Exact<{
  retailerId: Scalars['String'];
  name: Scalars['String'];
  assortmentIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateRetailWorkspaceMutation = { createRetailWorkspace: { retailWorkspace?: { id: string } | null } };

export type CopyAssortmentsMutationVariables = Exact<{
  assortmentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CopyAssortmentsMutation = { copyAssortments: { assortments: Array<{ id: string }> } };

export type AccountSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSeasonsQuery = { seasons: { edges: Array<{ node: { id: string, name: string, code: string, year?: number | null } }> } };

export type BrandNotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AssortmentFilter>;
}>;


export type BrandNotesQuery = { assortmentsQuery: { totalCount: number } };

export type upsertAccountConnectionStatusesMutationVariables = Exact<{
  input: UpsertAccountConnectionStatusesInput;
}>;


export type upsertAccountConnectionStatusesMutation = { upsertAccountConnectionStatuses: { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status }> } };

export type getAccountCustomerCodesQueryVariables = Exact<{
  otherAccountId: Scalars['ID'];
}>;


export type getAccountCustomerCodesQuery = { accountCustomerCodes: Array<{ otherAccountId: string, alias?: string | null, code?: string | null }> };

export type retailersThatFavoritedBrandDupe2QueryVariables = Exact<{
  brandAccountId: Scalars['ID'];
}>;


export type retailersThatFavoritedBrandDupe2Query = { retailersThatFavoritedBrand: Array<{ retailerAccountId: string, timeFavorited: any, retailerUser?: { id: string, name?: string | null, email?: string | null } | null, tradeShowEvent?: { id: string, eventName: string } | null }> };

export type retailerProfilesQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type retailerProfilesQuery = { public: { retailerProfile: Array<{ id: string, name?: string | null, primaryLocation?: { id: string, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, topBrands: Array<string>, productLines: Array<string> } | null }> } };

export type ACCOUNT_CONNECTION_STATUSESDupe2QueryVariables = Exact<{
  accountId: Scalars['ID'];
  otherAccountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ACCOUNT_CONNECTION_STATUSESDupe2Query = { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status }> };

export type UploadBulkStyleImageMutationMutationVariables = Exact<{
  input: UploadBulkStyleImageInput;
}>;


export type UploadBulkStyleImageMutationMutation = { uploadBulkStyleImage: { errorCode?: string | null } };

export type ImagesUploaderProcessMutationMutationVariables = Exact<{
  collectionId?: InputMaybe<Scalars['ID']>;
  filePath?: InputMaybe<Scalars['String']>;
  fileNameParts?: InputMaybe<Array<UploaderFileNameParts> | UploaderFileNameParts>;
  separator?: InputMaybe<Scalars['String']>;
  onlyProductLevel?: InputMaybe<Scalars['Boolean']>;
  replace?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['ID']>;
  customSorting?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ImagesUploaderProcessMutationMutation = { imagesUploaderProcess: { errorCode?: string | null } };

export type LinesheetsQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']>;
}>;


export type LinesheetsQuery = { collections: { edges: Array<{ node: { id: string, name: string } } | null> } };

export type ListConnectionBuyersQueryVariables = Exact<{
  input: ListConnectionBuyersInput;
}>;


export type ListConnectionBuyersQuery = { listConnectionBuyers: Array<{ id: string, retailerId: string, name?: string | null, email?: string | null }> };

export type CreateConnectionBuyersMutationVariables = Exact<{
  input: Array<CreateConnectionBuyerInput> | CreateConnectionBuyerInput;
}>;


export type CreateConnectionBuyersMutation = { createConnectionBuyers?: { connection_buyers: Array<{ id: string, retailerId: string, name?: string | null, email?: string | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type UpdateConnectionBuyersMutationVariables = Exact<{
  input: Array<UpdateConnectionBuyerInput> | UpdateConnectionBuyerInput;
}>;


export type UpdateConnectionBuyersMutation = { updateConnectionBuyers?: { connection_buyers: Array<{ id: string, retailerId: string, name?: string | null, email?: string | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type DeleteConnectionBuyersMutationVariables = Exact<{
  input: Array<DeleteConnectionBuyerInput> | DeleteConnectionBuyerInput;
}>;


export type DeleteConnectionBuyersMutation = { deleteConnectionBuyers?: { connection_buyers: Array<{ id: string, retailerId: string, name?: string | null, email?: string | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type ListConnectionDiscountsQueryVariables = Exact<{
  input: ListConnectionDiscountInput;
}>;


export type ListConnectionDiscountsQuery = { listConnectionDiscounts: Array<{ id: string, retailerId: string, amount?: string | null, level: DiscountLevel, divisionId?: string | null }> };

export type BrandsDivisionsQueryVariables = Exact<{
  brandFilter: BrandsFilter;
}>;


export type BrandsDivisionsQuery = { brands: { edges: Array<{ node?: { divisions?: Array<{ name: string, id: string, code: string }> | null } | null }> } };

export type CreateConnectionDiscountsMutationVariables = Exact<{
  input: Array<CreateConnectionDiscountInput> | CreateConnectionDiscountInput;
}>;


export type CreateConnectionDiscountsMutation = { createConnectionDiscounts?: { connectionDiscounts: Array<{ id: string, retailerId: string, amount?: string | null, level: DiscountLevel, divisionId?: string | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type UpdateConnectionDiscountsMutationVariables = Exact<{
  input: Array<UpdateConnectionDiscountInput> | UpdateConnectionDiscountInput;
}>;


export type UpdateConnectionDiscountsMutation = { updateConnectionDiscounts?: { connectionDiscounts: Array<{ id: string, retailerId: string, amount?: string | null, level: DiscountLevel, divisionId?: string | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type DeleteConnectionDiscountsMutationVariables = Exact<{
  input: Array<DeleteConnectionDiscountInput> | DeleteConnectionDiscountInput;
}>;


export type DeleteConnectionDiscountsMutation = { deleteConnectionDiscounts?: { ids: Array<string>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type ConnectionShippingAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConnectionShippingAddressesQuery = { brands: { edges: Array<{ node?: { connectedAccounts: { edges: Array<{ node?: { id: string } | null, shippingAddresses: Array<{ id: string, code?: string | null, email?: string | null, phoneNumber?: string | null, address?: { companyName?: string | null, name?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null }> }> } } | null }> } };

export type ListConnectionDoorsQueryVariables = Exact<{
  input: ListConnectionDoorsInput;
}>;


export type ListConnectionDoorsQuery = { listConnectionDoors: Array<{ id: string, name: string, code?: string | null, shippingAddressId?: string | null, retailerId: string }> };

export type CreateConnectionDoorsMutationVariables = Exact<{
  input: Array<ConnectionDoorInput> | ConnectionDoorInput;
}>;


export type CreateConnectionDoorsMutation = { createConnectionDoors: Array<{ id: string, name: string, code?: string | null, shippingAddressId?: string | null, retailerId: string }> };

export type UpdateConnectionDoorsMutationVariables = Exact<{
  input: Array<ConnectionDoorInput> | ConnectionDoorInput;
}>;


export type UpdateConnectionDoorsMutation = { updateConnectionDoors: Array<{ id: string, name: string, code?: string | null, shippingAddressId?: string | null, retailerId: string }> };

export type DeleteConnectionDoorsMutationVariables = Exact<{
  input: Array<ConnectionDoorInput> | ConnectionDoorInput;
}>;


export type DeleteConnectionDoorsMutation = { deleteConnectionDoors: Array<string> };

export type BrandsPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsPaymentMethodsQuery = { brands: { edges: Array<{ node?: { paymentMethods: { edges: Array<{ node: { id: string, name: string, code: string } }> } } | null }> } };

export type ConnectionPaymentMethodsQueryVariables = Exact<{
  input: ListConnectionPaymentMethodsInput;
}>;


export type ConnectionPaymentMethodsQuery = { listConnectionPaymentMethods: Array<{ paymentMethodId: string, retailerId: string, isDefault: boolean }> };

export type CreateConnectionPaymentMethodsMutationVariables = Exact<{
  input: Array<ConnectionPaymentMethodInput> | ConnectionPaymentMethodInput;
}>;


export type CreateConnectionPaymentMethodsMutation = { createConnectionPaymentMethods: Array<{ paymentMethodId: string, retailerId: string, isDefault: boolean }> };

export type UpdateConnectionPaymentMethodsMutationVariables = Exact<{
  input: Array<ConnectionPaymentMethodInput> | ConnectionPaymentMethodInput;
}>;


export type UpdateConnectionPaymentMethodsMutation = { updateConnectionPaymentMethods: Array<{ paymentMethodId: string, retailerId: string, isDefault: boolean }> };

export type DeleteConnectionPaymentMethodsMutationVariables = Exact<{
  input: Array<ConnectionPaymentMethodInput> | ConnectionPaymentMethodInput;
}>;


export type DeleteConnectionPaymentMethodsMutation = { deleteConnectionPaymentMethods: Array<string> };

export type BrandPriceTypesQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandPriceTypesQuery = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string, name: string }, retailCurrency: { id: string, code: string, name: string } } }> } };

export type BrandTermsAndConditionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandTermsAndConditionsQuery = { termsAndConditions: { edges?: Array<{ node: { brand: { id: string }, termsAndConditions?: Array<{ id: string, name?: string | null, terms?: string | null, brand: { id: string } }> | null } }> | null } };

export type ListConnectionPriceTypesQueryVariables = Exact<{
  input: ListConnectionPriceTypeInput;
}>;


export type ListConnectionPriceTypesQuery = { listConnectionPriceTypes: Array<{ id: string, retailerId: string, priceType: { id: string }, termsCondition?: { id: string } | null }> };

export type CreateConnectionPriceTypesMutationVariables = Exact<{
  input: Array<CreateConnectionPriceTypeInput> | CreateConnectionPriceTypeInput;
}>;


export type CreateConnectionPriceTypesMutation = { createConnectionPriceTypes?: { connectionPriceTypes: Array<{ id: string, retailerId: string, priceType: { id: string, name: string, currency: { id: string, name?: string | null, code?: string | null }, retailCurrency: { id: string, name?: string | null, code?: string | null } }, termsCondition?: { id: string, brandAccountId: string, name?: string | null, terms?: string | null } | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type UpdateConnectionPriceTypesMutationVariables = Exact<{
  input: Array<UpdateConnectionPriceTypeInput> | UpdateConnectionPriceTypeInput;
}>;


export type UpdateConnectionPriceTypesMutation = { updateConnectionPriceTypes?: { connectionPriceTypes: Array<{ id: string, retailerId: string, priceType: { id: string, name: string, currency: { id: string, name?: string | null, code?: string | null }, retailCurrency: { id: string, name?: string | null, code?: string | null } }, termsCondition?: { id: string, brandAccountId: string, name?: string | null, terms?: string | null } | null }>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type DeleteConnectionPriceTypesMutationVariables = Exact<{
  input: Array<DeleteConnectionPriceTypeInput> | DeleteConnectionPriceTypeInput;
}>;


export type DeleteConnectionPriceTypesMutation = { deleteConnectionPriceTypes?: { ids: Array<string>, errors?: Array<{ code?: string | null, message?: string | null, details?: string | null }> | null } | null };

export type BrandsShippingMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsShippingMethodsQuery = { brands: { edges: Array<{ node?: { shippingMethods: { edges: Array<{ node: { id: string, name: string, code: string } }> } } | null }> } };

export type ConnectionShippingMethodsQueryVariables = Exact<{
  input: ListConnectionShippingMethodsInput;
}>;


export type ConnectionShippingMethodsQuery = { listConnectionShippingMethods: Array<{ shippingMethodId: string, retailerId: string, isDefault: boolean }> };

export type CreateConnectionShippingMethodsMutationVariables = Exact<{
  input: Array<ConnectionShippingMethodInput> | ConnectionShippingMethodInput;
}>;


export type CreateConnectionShippingMethodsMutation = { createConnectionShippingMethods: Array<{ shippingMethodId: string, retailerId: string, isDefault: boolean }> };

export type UpdateConnectionShippingMethodsMutationVariables = Exact<{
  input: Array<ConnectionShippingMethodInput> | ConnectionShippingMethodInput;
}>;


export type UpdateConnectionShippingMethodsMutation = { updateConnectionShippingMethods: Array<{ shippingMethodId: string, retailerId: string, isDefault: boolean }> };

export type DeleteConnectionShippingMethodsMutationVariables = Exact<{
  input: Array<ConnectionShippingMethodInput> | ConnectionShippingMethodInput;
}>;


export type DeleteConnectionShippingMethodsMutation = { deleteConnectionShippingMethods: Array<string> };

export type BrandsWarehousesQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsWarehousesQuery = { brands: { edges: Array<{ node?: { warehouses: { edges: Array<{ node?: { id: string, name: string, code: string } | null } | null> } } | null }> } };

export type ConnectionWarehousesQueryVariables = Exact<{
  input: ListConnectionWarehousesInput;
}>;


export type ConnectionWarehousesQuery = { listConnectionWarehouses: Array<{ warehouseId: string, retailerId: string, isDefault: boolean }> };

export type CreateConnectionWarehousesMutationVariables = Exact<{
  input: Array<ConnectionWarehouseInput> | ConnectionWarehouseInput;
}>;


export type CreateConnectionWarehousesMutation = { createConnectionWarehouses: Array<{ warehouseId: string, retailerId: string, isDefault: boolean }> };

export type UpdateConnectionWarehousesMutationVariables = Exact<{
  input: Array<ConnectionWarehouseInput> | ConnectionWarehouseInput;
}>;


export type UpdateConnectionWarehousesMutation = { updateConnectionWarehouses: Array<{ warehouseId: string, retailerId: string, isDefault: boolean }> };

export type DeleteConnectionWarehousesMutationVariables = Exact<{
  input: Array<ConnectionWarehouseInput> | ConnectionWarehouseInput;
}>;


export type DeleteConnectionWarehousesMutation = { deleteConnectionWarehouses: Array<string> };

export type ConnectionQueryVariables = Exact<{
  connectionId: Scalars['ID'];
}>;


export type ConnectionQuery = { brands: { edges: Array<{ node?: { connectedAccounts: { edges: Array<{ alias?: string | null, code?: string | null, node?: { displayName: string, publicRetailerProfile?: { displayName?: string | null } | null, accountProfile?: { logoUrl?: string | null } | null } | null }> } } | null }> } };

export type UpdateConnectionMutationVariables = Exact<{
  input: UpsertAccountCustomerCodesInput;
}>;


export type UpdateConnectionMutation = { upsertAccountCustomerCodes: Array<{ otherAccountId: string, alias?: string | null, code?: string | null }> };

export type ConnectAccountsThroughJiraMutationMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ConnectAccountsThroughJiraMutationMutation = { connectAccountsThroughJira: { error?: { code: ConnectAccountsThroughJiraErrorCode } | null } };

export type SubscribeUserToFeatureMutationVariables = Exact<{
  input: SubscribeUserToFeatureInput;
}>;


export type SubscribeUserToFeatureMutation = { subscribeUserToFeature: { success?: boolean | null } };

export type UnSubscribeUserToFeatureMutationVariables = Exact<{
  input: UnSubscribeUserToFeatureInput;
}>;


export type UnSubscribeUserToFeatureMutation = { unSubscribeUserToFeature: { success?: boolean | null } };

export type FindNewBrandsSendConnectionRequestMutationVariables = Exact<{
  input: UpsertAccountConnectionStatusesInput;
}>;


export type FindNewBrandsSendConnectionRequestMutation = { upsertAccountConnectionStatuses: { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status }> } };

export type FindNewBrandsSendMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type FindNewBrandsSendMessageMutation = { createMessage: { id: string, threadId: string, messageType?: MessageType | null, accountId: string, parentId?: string | null, subject: string, body: string } };

export type FindNewBrandsAddFavoriteMutationVariables = Exact<{
  input: AddFavoriteAccountInput;
}>;


export type FindNewBrandsAddFavoriteMutation = { createFavoriteAccount: { id: string, brandAccountId: string } };

export type FindNewBrandsDeleteFavoriteMutationVariables = Exact<{
  input: DeleteFavoriteAccountInput;
}>;


export type FindNewBrandsDeleteFavoriteMutation = { deleteFavoriteAccount?: { success?: boolean | null } | null };

export type FindNewBrandsPageQueryVariables = Exact<{
  input: SearchBrandsFilter;
}>;


export type FindNewBrandsPageQuery = { searchBrands: { edges: Array<{ node?: { id: string, brandId: string, name?: string | null, description?: string | null, logoUrl?: string | null, productLines: Array<string>, profileImageUrls: Array<string>, customProfileImageUrls: Array<string>, connected?: Status | null, accountMedia?: { url?: string | null } | null, socialMediaAccounts: Array<{ url?: string | null, socialMediaType?: SocialMediaType | null }>, lookbooks: { edges?: Array<{ node: { id: string, brandId: string } }> | null }, teamUsers: { edges: Array<{ node?: { id: string } | null }> } } | null } | null>, pageInfo: { hasNextPage: boolean } } };

export type FindNewBrandsGetBrandProfileQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type FindNewBrandsGetBrandProfileQuery = { brandProfiles: { edges: Array<{ node?: { id: string, brandId: string, name?: string | null, description?: string | null, yearEstablished?: number | null, productLines: Array<string>, wholesaleMin?: number | null, wholesaleMax?: number | null, retailMin?: number | null, retailMax?: number | null, websiteUrl?: string | null, logoUrl?: string | null, customProfileImageUrls: Array<string>, profileImageUrls: Array<string>, connected?: Status | null, socialMediaAccounts: Array<{ url?: string | null, socialMediaType?: SocialMediaType | null }>, accountMedia?: { url?: string | null } | null } | null } | null> } };

export type SearchBrandsCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchBrandsCurrenciesQuery = { currencies?: { edges?: Array<{ node?: { id: string, name: string, code: string } | null }> | null } | null };

export type RetailerCategoriesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RetailerCategoriesQuery = { retailerProfile: { primaryLocation?: { categories?: Array<{ id: string, name?: string | null, image?: { url: any } | null }> | null } | null } };

export type retailerFavoriteBrandQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type retailerFavoriteBrandQuery = { favoritedBrandsByRetailAccountUser: Array<{ id: string }> };

export type InvitationMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationMessageQuery = { viewingUser: { id: string, inviteMessage: string } };

export type SearchBrandsCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchBrandsCategoriesQuery = { searchBrandCategories: Array<{ name: string }> };

export type ListTemplatesQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ListTemplatesQuery = { accountExportIntegrationConfigs: Array<{ id: string, accountId?: string | null, isActive?: boolean | null, name: string, fileExtension?: ExportFileExtensionType | null, type?: ExportType | null, fileName: string, columnConfig: string, level?: ExportLevel | null, createdAt: any, updatedAt: any }> };

export type PriceTypesDupe1QueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type PriceTypesDupe1Query = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string }, retailCurrency: { id: string, code: string } } }> } };

export type BrandsDupe3QueryVariables = Exact<{
  filter?: InputMaybe<BrandsFilter>;
}>;


export type BrandsDupe3Query = { brands: { edges: Array<{ node?: { id: string, tagGroups: { edges: Array<{ node: { id: string, brandId: string, name: string, tags: { edges: Array<{ node: { id: string, value: string, code: string } }> } } }> } } | null }> } };

export type CreateTemplateMutationVariables = Exact<{
  createExportIntegrationConfigInput: CreateExportIntegrationConfigInput;
}>;


export type CreateTemplateMutation = { createExportIntegrationConfig: { id: string } };

export type UpdateTemplateMutationVariables = Exact<{
  updateExportIntegrationConfigInput: UpdateExportIntegrationConfigInput;
}>;


export type UpdateTemplateMutation = { updateExportIntegrationConfig: { id: string, isActive?: boolean | null } };

export type DeleteTemplateMutationVariables = Exact<{
  deleteExportIntegrationConfigInput: DeleteExportIntegrationConfigsInput;
}>;


export type DeleteTemplateMutation = { deleteExportIntegrationConfigs?: { success?: boolean | null } | null };

export type ListMonitoringJobsQueryVariables = Exact<{
  input: ListMonitoringJobsRequest;
}>;


export type ListMonitoringJobsQuery = { listMonitoringJobs: { jobs?: Array<{ id: string, jobId: string, status: JobStatus, type: JobType, inputFileUrl: string, inputData?: any | null, errorDetails?: any | null, outputData?: any | null, createdAt?: any | null, updatedAt?: any | null, user?: { id: string, email?: string | null } | null }> | null } };

export type FindNewRetailersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<LGFindRetailersFilters>;
  searchText?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<LGFindRetailersOrderBy>;
}>;


export type FindNewRetailersQuery = { findRetailers: { totalCount: number, edges: Array<{ node: { id: string, name: string, description?: string | null, logoUrl?: string | null, brandsOrdered?: Array<string> | null, connectionStatus: LGConnectionStatus, autoConnect: boolean, websiteUrl?: string | null, submissionRecipients?: Array<string> | null, allRecipientsContacted: boolean, location?: { id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null, brandsCarried?: Array<string> | null } | null } }> } };

export type FindNewRetailersAsyncDataQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<LGFindRetailersFilters>;
  searchText?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<LGFindRetailersOrderBy>;
}>;


export type FindNewRetailersAsyncDataQuery = { findRetailers: { edges: Array<{ node: { id: string, hasBeenAwarded: boolean, submissionRecipients?: Array<string> | null, allRecipientsContacted: boolean, submission?: { id: string, createdAt?: any | null, senderAccount?: { accountUserName: string } | null } | null } }> } };

export type LGFindRetailersCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type LGFindRetailersCategoriesQuery = { brandProductLines: Array<{ id: string, name: string }> };

export type FindBrandsCarriedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type FindBrandsCarriedQuery = { findBrandsCarried: { totalCount: number, edges: Array<{ node: { id: string, name: string } }> } };

export type SubmissionAuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmissionAuthorsQuery = { submissionAuthors?: Array<{ accountUserId: string, accountUserActive: boolean, user: { id: string, displayName?: string | null, active: boolean } }> | null };

export type ProspectsPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<FindProspectsOrderBy>;
  filters?: InputMaybe<FindProspectsFilters>;
  submissionsOrderBy?: InputMaybe<SubmissionsOrderBy>;
}>;


export type ProspectsPageQuery = { findProspects: { totalCount: number, edges: Array<{ node: { id: string, name: string, description?: string | null, logoUrl?: string | null, connectionStatus: LGConnectionStatus, autoConnect: boolean, brandsOrdered?: Array<string> | null, websiteUrl?: string | null, location?: { id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null, brandsCarried?: Array<string> | null } | null, submissions?: { totalCount?: number | null, totalActivitiesCount?: number | null, edges: Array<{ node: { id: string, messageId?: string | null, recipientAccountUserId: string, createdAt?: any | null, submissionStatus?: string | null, senderAccount?: { accountId: string, accountUserId: string, accountName: string, accountUserName: string, accountUserTitle: string } | null, recipientAccountUser?: { accountUserId: string, displayName: string } | null, activities?: Array<{ id: string, activityType: SubmissionActivityType, createdAt?: any | null, author?: { accountUserId: string, displayName: string } | null }> | null, connectionRequestInfo: { status: ConnectionRequestStatus, senderAccountId?: string | null, recipientAccountId?: string | null } } }> } | null } }> } };

export type UpdateRetailerProfileMutationVariables = Exact<{
  input: UpdateRetailerProfileInput;
}>;


export type UpdateRetailerProfileMutation = { updateRetailerProfile: { id: string } };

export type BulkUpsertRetailerUploadsMutationVariables = Exact<{
  input: BulkUpsertRetailerUploadsInput;
}>;


export type BulkUpsertRetailerUploadsMutation = { bulkUpsertRetailerUploads: { retailerUploadIds?: Array<string> | null } };

export type BulkDeleteRetailerUploadsMutationVariables = Exact<{
  input: BulkDeleteRetailerUploadsInput;
}>;


export type BulkDeleteRetailerUploadsMutation = { bulkDeleteRetailerUploads: { retailerUploadIds?: Array<string | null> | null } };

export type BulkUpsertRetailerLocationsMutationVariables = Exact<{
  input: BulkUpsertRetailerLocationsInput;
}>;


export type BulkUpsertRetailerLocationsMutation = { bulkUpsertRetailerLocations: { locations: Array<{ id: string }> } };

export type BulkDeleteRetailerLocationMutationVariables = Exact<{
  input: BulkDeleteRetailerLocationsInput;
}>;


export type BulkDeleteRetailerLocationMutation = { bulkDeleteRetailerLocations: { retailerLocationIds?: Array<string | null> | null } };

export type RetailerLocationCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RetailerLocationCountriesQuery = { geographies: { edges: Array<{ node: { id: string, name: string } }> } };

export type RetailerProfileStatesQueryVariables = Exact<{
  countryId: Scalars['ID'];
}>;


export type RetailerProfileStatesQuery = { states: { edges: Array<{ node: { name: string, id: string, abbreviation?: string | null } }> } };

export type ClienteleDescriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClienteleDescriptionsQuery = { listClienteleDescriptions: { edges?: Array<{ node?: { id: string, name?: string | null } | null }> | null } };

export type ClienteleInterestsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClienteleInterestsQuery = { listClienteleInterests: { edges?: Array<{ node?: { id: string, name?: string | null } | null }> | null } };

export type ProductLinesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductLinesQuery = { brandProductLines: Array<{ id: string, name: string }> };

export type AllBrandsAccountsQueryVariables = Exact<{
  filter?: InputMaybe<BrandsFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AllBrandsAccountsQuery = { brands: { edges: Array<{ node?: { id: string, name: string } | null }> } };

export type RetailerProfileTitleQueryQueryVariables = Exact<{
  retailerId: Scalars['ID'];
}>;


export type RetailerProfileTitleQueryQuery = { retailerProfile: { id: string, displayName?: string | null, name?: string | null } };

export type RetailerProfilePageQueryQueryVariables = Exact<{
  retailerId: Scalars['ID'];
  isBrandAccount: Scalars['Boolean'];
}>;


export type RetailerProfilePageQueryQuery = { retailerProfile: { id: string, description?: string | null, name?: string | null, displayName?: string | null, profileSnoozeCounter?: number | null, autoConnect?: boolean | null, connectionStatus?: LGConnectionStatus | null, profileCompleteness: LGProfileCompleteness, websiteUrl?: string | null, taxId?: string | null, taxIdCountry?: string | null, yearsOrdered?: Array<number> | null, brandsOrdered?: Array<string> | null, categoriesOrdered?: Array<string> | null, logo?: { id?: string | null, url?: string | null } | null, socialMediaAccounts?: Array<{ type: SocialMediaType, url: string }> | null, profileImages?: Array<{ id: string, upload?: { id: string, name?: string | null, url: string, mediaType: string } | null }> | null, primaryLocation?: { id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null, phone?: string | null, type?: LocationType | null, yearEstablished?: string | null, wholesaleRange?: { min?: string | null, max?: string | null } | null, clienteleInfo?: { age?: string | null, male?: boolean | null, female?: boolean | null, descriptions?: Array<{ id: string, name?: string | null }> | null, interests?: Array<{ id: string, name?: string | null }> | null } | null, brandsCarried?: Array<{ id: string, name: string, accountId?: string | null }> | null, categories?: Array<{ id: string, name?: string | null }> | null } | null, locations?: Array<{ id: string, name?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, country?: string | null, zip?: string | null, phone?: string | null, type?: LocationType | null, yearEstablished?: string | null, wholesaleRange?: { min?: string | null, max?: string | null } | null, clienteleInfo?: { age?: string | null, male?: boolean | null, female?: boolean | null, descriptions?: Array<{ id: string, name?: string | null }> | null, interests?: Array<{ id: string, name?: string | null }> | null } | null, brandsCarried?: Array<{ id: string, name: string, accountId?: string | null }> | null, categories?: Array<{ id: string, name?: string | null }> | null }> | null, people?: Array<{ id: string, name?: string | null, jobTitle?: string | null, profilePictureUrl?: string | null, phone?: string | null, submissions?: Array<{ id: string, createdAt?: any | null, messageId?: string | null, senderAccount?: { accountName: string, accountUserName: string } | null }> | null }> | null, accountSubmission?: { id: string, messageId?: string | null, createdAt?: any | null, senderAccount?: { accountName: string, accountUserName: string } | null } | null, awards?: Array<{ id: string, description?: string | null, awardBadgeUrl?: string | null }> | null } };

export type VisitRetailerProfileMutationVariables = Exact<{
  input: VisitRetailerProfileInput;
}>;


export type VisitRetailerProfileMutation = { visitRetailerProfile: { success: boolean } };

export type AcceptRequestConnectionMutationVariables = Exact<{
  input: AcceptRequestConnectionInput;
}>;


export type AcceptRequestConnectionMutation = { acceptRequestConnection: { brandId: string, retailerId: string, connectionStatus: LGConnectionStatus, error?: string | null } };

export type ValidateTaxIdQueryVariables = Exact<{
  country: Scalars['String'];
  taxId: Scalars['String'];
}>;


export type ValidateTaxIdQuery = { validateTaxId: { isValid: boolean, message?: string | null } };

export type SendSubmissionMutationVariables = Exact<{
  input: sendSubmissionInput;
}>;


export type SendSubmissionMutation = { sendSubmission: { id: string } };

export type AddLinesheetModalQueryQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AddLinesheetModalQueryQuery = { public: { collections: Array<{ id: string, name: string, isArchived?: boolean | null }> } };

export type get8ProductsForSubmissionQueryQueryVariables = Exact<{
  brandId: Scalars['ID'];
  collectionId: Scalars['ID'];
}>;


export type get8ProductsForSubmissionQueryQuery = { public: { collections: Array<{ id: string, name: string, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null } | null, products: Array<{ id: string, name: string, images: Array<{ id?: string | null, url?: string | null }>, variants: { colors: Array<{ id: string, name: string, swatch: { hexColor: string, image?: { url?: string | null } | null }, image?: { url?: string | null } | null }> } }> }> } };

export type SubmissionContactPageQueryQueryVariables = Exact<{
  retailerId: Scalars['ID'];
  brandId: Scalars['ID'];
}>;


export type SubmissionContactPageQueryQuery = { retailerProfile: { id: string, name?: string | null, connectionStatus?: LGConnectionStatus | null, buyer?: { name?: string | null, isBuyer?: boolean | null, isOwner?: boolean | null } | null, people?: Array<{ id: string, name?: string | null, jobTitle?: string | null, profilePictureUrl?: string | null, submissions?: Array<{ id: string, recipientAccountUserId: string, connectionRequestStatus: ConnectionRequestStatus }> | null }> | null }, brandProfiles: { edges: Array<{ node?: { id: string, name?: string | null, logoUrl?: string | null, websiteUrl?: string | null } | null } | null> }, viewingUser: { id: string, displayName?: string | null, profileImage?: string | null, title?: string | null, phoneNumber?: string | null } };

export type GenerateAiMessageQueryVariables = Exact<{
  recipientAccountUserId?: InputMaybe<Scalars['ID']>;
  recipientAccountId?: InputMaybe<Scalars['ID']>;
}>;


export type GenerateAiMessageQuery = { generateSubmissionMessage: string };

export type GeneralCategoriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GeneralCategoriesQueryQuery = { brandProductLines: Array<{ id: string, name: string }> };

export type UpdateSubmissionSenderProfileMutationVariables = Exact<{
  input: UpdateSubmissionSenderProfileInput;
}>;


export type UpdateSubmissionSenderProfileMutation = { updateSubmissionSenderProfile: { displayName?: string | null, title?: string | null, profileImage?: string | null } };

export type SubmissionHeaderQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmissionHeaderQueryQuery = { submissionTemplates?: Array<{ id: string, name: string, subject?: string | null, message?: string | null, headerImages?: Array<{ id?: string | null, url?: string | null }> | null, attachments?: Array<{ id?: string | null, url?: string | null }> | null, categories?: Array<{ wholesaleMin: string, wholesaleMax: string, category: { id: string, name?: string | null } }> | null, collections?: Array<{ collection?: { id: string } | null, upload?: { id?: string | null, url?: string | null } | null }> | null }> | null };

export type CreateSubmissionTemplateMutationVariables = Exact<{
  createSubmissionTemplateInput: createSubmissionTemplateInput;
}>;


export type CreateSubmissionTemplateMutation = { createSubmissionTemplate: { id: string } };

export type UpdateSubmissionTemplateMutationVariables = Exact<{
  updateSubmissionTemplateInput: updateSubmissionTemplateInput;
}>;


export type UpdateSubmissionTemplateMutation = { updateSubmissionTemplate: { id: string, name: string, subject?: string | null, message?: string | null, headerImages?: Array<{ id?: string | null, url?: string | null }> | null, attachments?: Array<{ id?: string | null, url?: string | null }> | null, categories?: Array<{ wholesaleMin: string, wholesaleMax: string, category: { id: string, name?: string | null } }> | null, collections?: Array<{ collection?: { id: string } | null, upload?: { id?: string | null, url?: string | null } | null }> | null } };

export type SendSubmissionConnectionRequestPriceTypesQueryVariables = Exact<{
  brandId: Scalars['ID'];
  retailerId: Scalars['ID'];
}>;


export type SendSubmissionConnectionRequestPriceTypesQuery = { priceTypeAndTermsConditions: { priceTypes: Array<{ id: string, name: string, currencyName: string } | null>, termsConditions: Array<{ id: string, name: string } | null> } };

export type RetailerListViewSubmissionsQueryVariables = Exact<{
  filters?: InputMaybe<SubmissionsFilter>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type RetailerListViewSubmissionsQuery = { submissions: { totalCount?: number | null, edges: Array<{ cursor: string, node: { id: string, createdAt?: any | null, personalizedMessage?: string | null, headerImages?: Array<{ id?: string | null, url?: string | null }> | null, categories?: Array<{ wholesaleMin: string, wholesaleMax: string, category: { id: string, name?: string | null } }> | null, senderAccount?: { accountUserId: string, accountUserName: string, accountUserPictureUrl?: string | null, accountName: string } | null } }> } };

export type SubmissionsListFiltersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmissionsListFiltersCountQuery = { pendingSubmissions: { totalCount?: number | null }, acceptedSubmissions: { totalCount?: number | null }, declinedSubmissions: { totalCount?: number | null }, oldSubmissions: { totalCount?: number | null } };

export type SubmissionPageQueryQueryVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type SubmissionPageQueryQuery = { submission: { id: string, createdAt?: any | null, recipientAccountUserId: string, subject?: string | null, messageId?: string | null, personalizedMessage?: string | null, submissionStatus?: string | null, connectionRequestInfo: { status: ConnectionRequestStatus, senderAccountId?: string | null, recipientAccountId?: string | null }, recipientAccount?: { accountId: string, accountUserId: string, accountName: string, accountUserName: string, accountUserTitle: string, accountProfilePictureUrl?: string | null, accountUserPictureUrl?: string | null, brandsCarried: Array<string>, websiteUrl?: string | null, twitterUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null } | null, activities?: Array<{ id: string, activityType: SubmissionActivityType, createdAt?: any | null, author?: { accountUserId: string, displayName: string } | null }> | null, attachments?: Array<{ id?: string | null, fileName?: string | null, url?: string | null }> | null, headerImages?: Array<{ id?: string | null, url?: string | null }> | null, collections?: Array<{ collection?: { id: string, name: string, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null } | null, products: Array<{ id: string, name: string, images: Array<{ id?: string | null, url?: string | null }>, variants: { colors: Array<{ id: string, name: string, swatch: { hexColor: string, image?: { id?: string | null, url?: string | null, fileName?: string | null } | null } }> } }> } | null, upload?: { id?: string | null, url?: string | null, fileName?: string | null } | null }> | null, categories?: Array<{ wholesaleMax: string, wholesaleMin: string, category: { id: string, name?: string | null } }> | null, senderAccount?: { accountId: string, accountUserId: string, accountName: string, accountUserName: string, accountUserTitle: string, accountProfilePictureUrl?: string | null, accountUserPictureUrl?: string | null, websiteUrl?: string | null, twitterUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null } | null } };

export type NewSubmissionsQueryQueryVariables = Exact<{
  filters?: InputMaybe<SubmissionsFilter>;
}>;


export type NewSubmissionsQueryQuery = { submissions: { edges: Array<{ node: { id: string, createdAt?: any | null, submissionStatus?: string | null, senderAccount?: { accountName: string } | null, headerImages?: Array<{ url?: string | null }> | null, categories?: Array<{ wholesaleMin: string, wholesaleMax: string, category: { id: string, name?: string | null } }> | null } }> } };

export type ReplySubmissionMutationVariables = Exact<{
  input: ReplySubmissionInput;
}>;


export type ReplySubmissionMutation = { replySubmission: { messageId: string } };

export type ViewSubmissionMutationVariables = Exact<{
  input: ViewSubmissionInput;
}>;


export type ViewSubmissionMutation = { viewSubmission: { success: boolean } };

export type getPaginatedProductsQueryVariables = Exact<{
  brandId: Scalars['ID'];
  collectionId: Scalars['ID'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type getPaginatedProductsQuery = { public: { collections: Array<{ id: string, products: Array<{ id: string, name: string, images: Array<{ id?: string | null, url?: string | null }>, variants: { colors: Array<{ id: string, name: string, swatch: { hexColor: string, image?: { url?: string | null } | null }, image?: { url?: string | null } | null }> } }> }> } };

export type SubmissionAccountConnectionStatusQueryVariables = Exact<{
  retailerId: Scalars['ID'];
  brandId: Scalars['ID'];
}>;


export type SubmissionAccountConnectionStatusQuery = { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status, retailerProfile: { displayName?: string | null } }> };

export type SubmissionAcceptRequestConnectionMutationVariables = Exact<{
  retailerId: Scalars['ID'];
  brandId: Scalars['ID'];
}>;


export type SubmissionAcceptRequestConnectionMutation = { acceptRequestConnection: { connectionStatus: LGConnectionStatus, error?: string | null } };

export type SubmissionUndoDeclinedConnectionMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type SubmissionUndoDeclinedConnectionMutation = { undoDeclinedConnection: { accountId: string, connectionStatus: LGConnectionStatus, error?: string | null } };

export type SubmissionSendConnectionRequestMutationVariables = Exact<{
  input: UpsertAccountConnectionStatusesInput;
}>;


export type SubmissionSendConnectionRequestMutation = { upsertAccountConnectionStatuses: { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status }> } };

export type SubmissionDeclineConnectionRequestMutationVariables = Exact<{
  retailerId: Scalars['ID'];
  brandId: Scalars['ID'];
}>;


export type SubmissionDeclineConnectionRequestMutation = { upsertAccountConnectionStatuses: { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status }> } };

export type ConnectionModalDataQueryVariables = Exact<{
  brandId: Scalars['ID'];
  retailerId: Scalars['ID'];
}>;


export type ConnectionModalDataQuery = { lgGetRequestConnectionData: { inviteMessage?: string | null, priceTypes: Array<{ id: string, name: string, currencyName: string } | null>, termsConditions: Array<{ id: string, name: string } | null>, otherUserBrands: Array<{ id: string, name: string, priceTypes: Array<{ id: string, name: string, currencyName: string } | null> } | null> } };

export type RequestConnectionToRetailerMutationVariables = Exact<{
  input: RequestConnectionToRetailerInput;
}>;


export type RequestConnectionToRetailerMutation = { requestConnectionToRetailer: Array<{ brandId: string, connectionStatus: LGConnectionStatus, error?: string | null }> };

export type SendMessageToConnectionMutationVariables = Exact<{
  recipientId: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  uploadId?: InputMaybe<Scalars['ID']>;
}>;


export type SendMessageToConnectionMutation = { sendMessageToConnection: { messageId: string, error?: string | null } };

export type noteVariantsDupe2MutationVariables = Exact<{
  input: AddVariantsInProgressInput;
}>;


export type noteVariantsDupe2Mutation = { addVariantsInProgress: { orderIds?: Array<string> | null } };

export type SkusInAssortmentQueryVariables = Exact<{
  assortmentId: Scalars['ID'];
}>;


export type SkusInAssortmentQuery = { assortment?: { id: string, skus: { edges?: Array<{ _id: string, node: { id: string, style: { id: string }, color: { id: string } } }> | null } } | null };

export type ProductVariantsAndSkusQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<ProductsFilter>;
}>;


export type ProductVariantsAndSkusQuery = { products: { edges: Array<{ node: { id: string, skus: { edges?: Array<{ node?: { id: string, variantValues: { edges?: Array<{ node?: { id: string, trait: { id: string, code: string, name: string } } | null }> | null } } | null }> | null }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> } } }> } };

export type BadgesDupe2QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<BadgeFilter>;
}>;


export type BadgesDupe2Query = { badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> } };

export type CollectionProductsBasicInfoQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionProductsBasicInfoQuery = { collectionProducts: { edges: Array<{ node: { id: string, orderNbr: number, product: { id: string } } }> } };

export type CollectionProductsEditModeQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionProductsEditModeQuery = { collectionProducts: { edges: Array<{ node: { id: string, comments: string, orderNbr: number, groupedBy?: { id?: string | null, name: string, value: string } | null, collection: { id: string, name: string, madeToOrder?: boolean | null }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> }, skus: { edges?: Array<{ node?: { id: string, variantValues: { edges?: Array<{ node?: { id: string, trait: { id: string, code: string, name: string } } | null }> | null } } | null }> | null }, product: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, traitValues: { edges: Array<{ node: { id: string, externalIdentifier: string, value: string, trait: { id: string, code: string, name: string } } }> }, badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> } } } }> } };

export type collectionProductsGroupTotalQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
}>;


export type collectionProductsGroupTotalQuery = { collectionProductsGroupTotal: Array<{ groupId?: string | null, total: number, collection: { id: string } }> };

export type CollectionProductsViewModeQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  priceTypeId: Scalars['ID'];
  filter?: InputMaybe<ProductsCollectionFilter>;
  groupBy?: InputMaybe<CollectionProductGroupByInput>;
  orderBy?: InputMaybe<CollectionProductOrderByInput>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  productVideosAreEnabled: Scalars['Boolean'];
  externalMediaEnabled: Scalars['Boolean'];
}>;


export type CollectionProductsViewModeQuery = { collectionProducts: { edges: Array<{ node: { id: string, comments: string, orderNbr: number, groupedBy?: { id?: string | null, name: string, value: string } | null, collection: { id: string, name: string, madeToOrder?: boolean | null }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> }, skus: { edges?: Array<{ node?: { id: string, variantValues: { edges?: Array<{ node?: { id: string, trait: { id: string, code: string, name: string } } | null }> | null } } | null }> | null }, product: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, videos?: Array<{ id?: string | null, url?: string | null }>, externalMedia?: Array<{ id: string, url: string, type: string, format: string, thumbnailUrl: string, payload: string }>, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number } | null, traitValues: { edges: Array<{ node: { id: string, externalIdentifier: string, value: string, trait: { id: string, code: string, name: string } } }> }, badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> } } } }> } };

export type aggregateSkuInventoryItemsDupe2QueryVariables = Exact<{
  warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
  filter?: InputMaybe<AggregateSkuInventoryItemsFilter>;
}>;


export type aggregateSkuInventoryItemsDupe2Query = { aggregateSkuInventoryItems: Array<{ items?: Array<{ availableQuantity: number, skuId: string }> | null }> };

export type CollectionProductsByShareTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CollectionProductsByShareTokenQuery = { public: { collectionProductsByShareToken: { totalCount: number, edges: Array<{ node: { id: string, variants: Array<{ id: string, code: string, name: string, values: Array<{ id: string, value: string, trait: { id: string, name: string, code: string }, displayDetails: { hexColor?: string | null, swatchImage?: { url: any } | null, merchandiseImages?: Array<{ url: any }> | null } }> }>, product: { id: string, name: string, imageUrls: Array<string>, externalMedia: Array<{ id: string, thumbnailUrl: string }>, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number, maxRetailValue: number } | null, traitValues: Array<{ id: string, value: string, trait: { id: string, code: string, name: string } }>, badges: Array<{ id: string, name: string, image?: { url?: string | null } | null }> } } }> } } };

export type UpdateLinesheetMutationVariables = Exact<{
  updateInput: BulkUpdateCollectionsInput;
  shouldUpdate?: InputMaybe<Scalars['Boolean']>;
  shareWithRetailersInput: ShareCollectionsWithRetailersInput;
  shouldShareWithRetailers?: InputMaybe<Scalars['Boolean']>;
  unshareWithRetailersInput: Array<UnshareCollectionsWithRetailersInput> | UnshareCollectionsWithRetailersInput;
  shouldUnshareWithRetailers?: InputMaybe<Scalars['Boolean']>;
  updatePublicStatusInput: BulkUpdateCollectionsPublicInput;
  shouldUpdatePublicStatus?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateLinesheetMutation = { bulkUpdateCollections?: { collections?: Array<{ id: string, name: string, code?: string | null, description?: string | null, created?: any | null, modified?: any | null, archived?: boolean | null, visibility?: CollectionVisibility | null, syncToIpad?: boolean | null, madeToOrder?: boolean | null, isCustom?: boolean | null, brand: { id: string }, season?: { id: string, code: string, name: string, year?: number | null } | null, delivery?: { completeShipDate?: any | null, cutoffDate?: any | null, minimumShippingWindow?: number | null, startShipDate?: any | null } | null, retailers: Array<{ retailerAccount: { id: string, name: string } }> }> | null, errors?: Array<{ message: string }> | null }, shareCollectionsWithRetailers?: { collections: { edges: Array<{ node: { id: string, retailers: Array<{ retailerAccount: { id: string, name: string } }> } } | null> } }, unshareCollectionsWithRetailers?: { collections: { totalCount?: number | null, edges: Array<{ node: { id: string, retailers: Array<{ retailerAccount: { id: string, name: string } }> } } | null> } }, bulkUpdateCollectionsPublic?: { collections?: Array<{ id: string }> | null } };

export type BulkDuplicateCollectionsMutationVariables = Exact<{
  input: BulkDuplicateCollectionsInput;
}>;


export type BulkDuplicateCollectionsMutation = { bulkDuplicateCollections: { collections?: Array<{ id: string }> | null } };

export type UpdateCollectionBannersMutationVariables = Exact<{
  createInput: CreateCollectionBannersInput;
  shouldCreate?: InputMaybe<Scalars['Boolean']>;
  deleteInput: DeleteCollectionBannersInput;
  shouldDelete?: InputMaybe<Scalars['Boolean']>;
  updateInput: UpdateCollectionBannersInput;
  shouldUpdate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCollectionBannersMutation = { createCollectionBanners?: { textBanners?: Array<{ id: string, presentation?: string | null, content?: string | null, orderNbr: number }> | null, imageBanners?: Array<{ id: string, presentation?: string | null, orderNbr: number, imageUrl?: string | null, imageId?: string | null }> | null, videoBanners?: Array<{ id: string, presentation?: string | null, orderNbr: number, videoUrl?: string | null, videoId?: string | null }> | null }, deleteCollectionBanners?: { textBannerIds?: Array<string> | null, imageBannerIds?: Array<string> | null, videoBannerIds?: Array<string> | null }, updateCollectionBanners?: { textBanners?: Array<{ id: string, presentation?: string | null, content?: string | null, orderNbr: number }> | null, imageBanners?: Array<{ id: string, presentation?: string | null, orderNbr: number, imageUrl?: string | null, imageId?: string | null }> | null, videoBanners?: Array<{ id: string, presentation?: string | null, orderNbr: number, videoUrl?: string | null, videoId?: string | null }> | null } };

export type UpsertLinesheetTextStylesMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  textStyles: Array<CollectionTextStyleInput> | CollectionTextStyleInput;
}>;


export type UpsertLinesheetTextStylesMutation = { upsertCollectionTextStyles: { textStyles: Array<{ id: string, name: string, typeface: string, weight: string, size: string, orderNbr: number }> } };

export type UpdateLinesheetGroupsMutationVariables = Exact<{
  createInput: BulkCreateCollectionGroupsInput;
  shouldCreate?: InputMaybe<Scalars['Boolean']>;
  deleteInput: BulkDeleteCollectionGroupsInput;
  shouldDelete?: InputMaybe<Scalars['Boolean']>;
  updateInput: BulkUpdateCollectionGroupsInput;
  shouldUpdate?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateLinesheetGroupsMutation = { bulkCreateCollectionGroups?: { createdCollectionGroups: Array<{ collectionGroups?: Array<{ id: string, header: string, orderNbr: number }> | null }> }, bulkDeleteCollectionGroups?: { collectionGroupIds?: Array<string> | null }, bulkUpdateCollectionGroups?: { collectionGroups?: Array<{ id: string, orderNbr: number, header: string }> | null } };

export type UpdateLinesheetProductsMutationVariables = Exact<{
  updateInput: BulkUpdateProductsInput;
  shouldUpdate?: InputMaybe<Scalars['Boolean']>;
  updateLinesheetProductsInput: BulkAddProductsToCollectionInput;
  shouldUpdateLinesheetProducts?: InputMaybe<Scalars['Boolean']>;
  deleteInput: BulkRemoveProductsAndSkusFromCollectionsInput;
  shouldDelete?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateLinesheetProductsMutation = { bulkUpdateProducts?: { products: Array<{ id: string }> }, bulkAddProductsToCollection?: { collections?: Array<{ id: string }> | null }, bulkRemoveProductsAndSkusFromCollections?: { collections?: Array<{ id: string }> | null } };

export type SingleCollectionQueryQueryVariables = Exact<{
  linesheetId: Scalars['ID'];
}>;


export type SingleCollectionQueryQuery = { collections: { edges: Array<{ node: { id: string, name: string, code?: string | null, description?: string | null, created?: any | null, modified?: any | null, archived?: boolean | null, visibility?: CollectionVisibility | null, syncToIpad?: boolean | null, madeToOrder?: boolean | null, isCustom?: boolean | null, brand: { id: string, name: string }, season?: { id: string, code: string, name: string, year?: number | null } | null, delivery?: { startShipDate?: any | null, cutoffDate?: any | null, completeShipDate?: any | null, minimumShippingWindow?: number | null } | null, retailers: Array<{ retailerAccount: { id: string, name: string } }>, groups: Array<{ id: string, header: string, orderNbr: number }>, textStyles?: Array<{ id: string, name: string, typeface: string, weight: string, size: string, orderNbr: number }> | null, source?: { id: string, name: string } | null } } | null> } };

export type CollectionParamsByShareTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CollectionParamsByShareTokenQuery = { public: { collectionParamsByShareToken: { id: string, hasAccess: boolean, brand: { id: string, name: string }, priceType: { id: string, name: string, currency: { id: string, name: string, code: string }, retailCurrency: { id: string, name: string, code: string } }, collection: { id: string, name: string, code?: string | null, description?: string | null, madeToOrder: boolean, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null, cutoffDate?: any | null } | null, banners?: { textBanners: Array<{ id: string, orderNbr: number, presentation?: string | null, content?: string | null }>, imageBanners: Array<{ id: string, orderNbr: number, presentation?: string | null, imageId?: string | null, imageUrl?: string | null }>, videoBanners: Array<{ id: string, orderNbr: number, presentation?: string | null, videoId?: string | null, videoUrl?: string | null }> } | null, textStyles?: Array<{ id: string, name: string, typeface: string, weight: string, size: string, orderNbr: number }> | null, season?: { id: string, code: string, name: string, year?: number | null } | null } } } };

export type SeasonsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SeasonsQueryQuery = { seasons: { edges: Array<{ node: { id: string, name: string, code: string, year?: number | null } }> } };

export type BrandSeasonsQueryQueryVariables = Exact<{
  brandAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BrandSeasonsQueryQuery = { brands: { edges: Array<{ node?: { id: string, seasons: { edges: Array<{ node: { id: string, name: string } }> } } | null }> } };

export type CollectionBannersQueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CollectionBannersQuery = { collectionBanners: { edges: Array<{ node: { textBanners: Array<{ id: string, orderNbr: number, presentation?: string | null, content?: string | null }>, imageBanners: Array<{ id: string, orderNbr: number, presentation?: string | null, imageId?: string | null, imageUrl?: string | null }>, videoBanners: Array<{ id: string, orderNbr: number, presentation?: string | null, videoId?: string | null, videoUrl?: string | null }> } }> } };

export type PriceTypesDupe2QueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
  filter?: InputMaybe<PriceTypesFilter>;
}>;


export type PriceTypesDupe2Query = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string }, retailCurrency: { id: string, code: string } } }> } };

export type WarehousesQueryDupe2QueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']>;
}>;


export type WarehousesQueryDupe2Query = { warehouses: { edges: Array<{ node?: { id: string, name: string, code: string, availabilityGroups: { edges: Array<{ node: { id: string, isEmpty?: boolean | null, availability: { availableOn?: any | null, isImmediate: boolean } } } | null> } } | null } | null> } };

export type CollectionProductsTotalQueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CollectionProductsTotalQuery = { collectionProductsTotal: number };

export type usesNewEditAndCreateQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type usesNewEditAndCreateQuery = { usesNewEditAndCreate: boolean };

export type ProductTraitValuesQueryDupe2QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<ProductTraitValuesFilter>;
}>;


export type ProductTraitValuesQueryDupe2Query = { productTraitValues: { edges: Array<{ node: { id: string, value: string, externalIdentifier: string, trait: { id: string, code: string, name: string } } }> } };

export type StyleTagsDupe2QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<uniqueTagValuesFilter>;
}>;


export type StyleTagsDupe2Query = { uniqueTagValues: { edges: Array<{ node: { id: string, value: string, externalIdentifier: string, tag: { id: string, name: string, groupName: string } } }> } };

export type CollectionsDupe1QueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<CollectionsFilter>;
}>;


export type CollectionsDupe1Query = { collections: { edges: Array<{ node: { id: string, name: string, code?: string | null } } | null> } };

export type BulkDeleteCollectionMutationVariables = Exact<{
  input: BulkDeleteCollectionsInput;
}>;


export type BulkDeleteCollectionMutation = { bulkDeleteCollections: { collectionIds?: Array<string | null> | null } };

export type BulkUpdateCollectionMutationVariables = Exact<{
  input: BulkUpdateCollectionsInput;
}>;


export type BulkUpdateCollectionMutation = { bulkUpdateCollections: { collections?: Array<{ id: string, archived?: boolean | null, modified?: any | null, created?: any | null, name: string, visibility?: CollectionVisibility | null, syncToIpad?: boolean | null, owner?: { node?: { id: string, email?: string | null } | null } | null, season?: { id: string } | null }> | null, errors?: Array<{ message: string }> | null } };

export type BulkUpdateCollectionsPublicMutationVariables = Exact<{
  input: BulkUpdateCollectionsPublicInput;
}>;


export type BulkUpdateCollectionsPublicMutation = { bulkUpdateCollectionsPublic: { collections?: Array<{ id: string, archived?: boolean | null, modified?: any | null, created?: any | null, name: string, visibility?: CollectionVisibility | null, syncToIpad?: boolean | null, owner?: { node?: { id: string, email?: string | null } | null } | null, season?: { id: string } | null }> | null } };

export type BulkUpdateUserFavoriteCollectionsMutationVariables = Exact<{
  input: BulkUpdateUserFavoriteCollectionsInput;
}>;


export type BulkUpdateUserFavoriteCollectionsMutation = { bulkUpdateUserFavoriteCollections: { success?: boolean | null } };

export type SendCollectionsToConnectionsMutationVariables = Exact<{
  input: SendCollectionsToConnectionsInput;
}>;


export type SendCollectionsToConnectionsMutation = { sendCollectionsToConnections: { collections?: { totalCount?: number | null } | null } };

export type BulkUpdateOrderMutationVariables = Exact<{
  input: BulkUpdateCollectionsPositionInput;
}>;


export type BulkUpdateOrderMutation = { bulkUpdateCollectionsPosition: { collections?: Array<{ id: string }> | null } };

export type CollectionQueryDupe1QueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  sharedWith?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CollectionQueryDupe1Query = { collections: { totalCount?: number | null, edges: Array<{ node: { id: string, archived?: boolean | null, modified?: any | null, created?: any | null, name: string, visibility?: CollectionVisibility | null, syncToIpad?: boolean | null, isCustom?: boolean | null, brand: { id: string }, owner?: { node?: { id: string, email?: string | null } | null } | null, image?: { id?: string | null, url?: string | null, urlThumbnail?: string | null } | null, season?: { id: string } | null, retailers: Array<{ retailerAccount: { id: string } }> } } | null> } };

export type UserFavoriteCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFavoriteCollectionsQuery = { viewingUser: { id: string, favoriteCollections: Array<string> } };

export type ProductsQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<ProductsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ProductsQuery = { products: { edges: Array<{ node: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> }, skus: { edges?: Array<{ node?: { id: string, variantValues: { edges?: Array<{ node?: { id: string, value: string, trait: { id: string, name: string, code: string } } | null }> | null } } | null }> | null }, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> }, badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> } } }> } };

export type ExportBulkProductMutationVariables = Exact<{
  triggerBulkProductExportInput: TriggerBulkProductExportInput;
}>;


export type ExportBulkProductMutation = { triggerBulkProductExport: { downloadUrl: string } };

export type ListTemplatesDupe2QueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ListTemplatesDupe2Query = { accountExportIntegrationConfigs: Array<{ name: string, id: string, fileExtension?: ExportFileExtensionType | null }> };

export type UniqueTagValuesQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UniqueTagValuesQuery = { uniqueTagValues: { edges: Array<{ node: { id: string, value: string, tag: { id: string, name: string, groupName: string } } }> } };

export type AccountPermissionsDupe2QueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountPermissionsDupe2Query = { accountPermissionAccess: { edges: Array<{ node: { id: string } }> } };

export type CollectionsDupe2QueryVariables = Exact<{
  filters?: InputMaybe<CollectionsFilter>;
}>;


export type CollectionsDupe2Query = { collections: { totalCount?: number | null, edges: Array<{ node: { id: string } } | null> } };

export type BrandDoorsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandDoorsQuery = { brandDoors: { edges: Array<{ node: { id: string, name: string, code?: string | null } }> } };

export type BulkRemoveUnmatchedUploadsMutationVariables = Exact<{
  unmatchedImageIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkRemoveUnmatchedUploadsMutation = { bulkRemoveUnmatchedUploads: { errorCode?: string | null } };

export type SaveUnmatchedUploadMutationVariables = Exact<{
  collectionId: Scalars['ID'];
  file: Scalars['Upload'];
  fileName: Scalars['String'];
}>;


export type SaveUnmatchedUploadMutation = { saveUnmatchedUpload: { uploadId?: string | null, unmatchedUploadId?: string | null, errorCode?: string | null, fileName?: string | null, url?: string | null } };

export type SaveProductImagesMutationVariables = Exact<{
  productId: Scalars['ID'];
  collectionId: Scalars['ID'];
  hasProductImagesChanges: Scalars['Boolean'];
  productImages?: InputMaybe<Array<ProductImages> | ProductImages>;
  styleColorsImage?: InputMaybe<Array<StyleColorsImage> | StyleColorsImage>;
}>;


export type SaveProductImagesMutation = { saveProductImages: { errorCode?: string | null } };

export type GetManageImagesStyleDataQueryVariables = Exact<{
  styleId: Scalars['ID'];
  collectionId: Scalars['ID'];
}>;


export type GetManageImagesStyleDataQuery = { getManageImagesStyleData: { styleId: string, styleNumber: string, styleName: string, fabrication?: { name: string, code?: string | null } | null, silhouette?: { name: string, code?: string | null } | null, images?: Array<{ id: string, url: string, orderNbr: number, fileName?: string | null } | null> | null, styleColors?: Array<{ id: string, name?: string | null, code?: string | null, imageId?: string | null, imageUrl?: string | null, swatch?: { hex?: string | null, url?: string | null, fileName?: string | null } | null } | null> | null } };

export type ListUnmatchedUploadsQueryVariables = Exact<{
  collectionId: Scalars['ID'];
  searchFileName?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ListUnmatchedUploadsQuery = { listUnmatchedUploads: { totalCount?: number | null, uploads: Array<{ id?: string | null, url?: string | null, fileName?: string | null, unmatchedUploadId?: string | null }> } };

export type NavigationProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductsFilter>;
  orderBy?: InputMaybe<ProductOrderByInput>;
}>;


export type NavigationProductsQuery = { products: { totalCount?: number | null, edges: Array<{ node: { id: string } }> } };

export type UpsertCollectionsVisibilityMutationVariables = Exact<{
  input: CollectionVisibilityInput;
}>;


export type UpsertCollectionsVisibilityMutation = { upsertCollectionsVisibility: { collections: { edges: Array<{ node: { id: string, visibility: CollectionVisibility, customerIds: Array<string> } }> }, errors: Array<{ message: string }> } };

export type VisibilityForLinesheetsQueryVariables = Exact<{
  linesheetIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type VisibilityForLinesheetsQuery = { collections: { edges: Array<{ node: { id: string, visibility?: CollectionVisibility | null, isCustom?: boolean | null, retailers: Array<{ retailerAccount: { id: string } }> } } | null> } };

export type BrandConnectionsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type BrandConnectionsQuery = { brands: { edges: Array<{ node?: { id: string, customerGroups: { edges: Array<{ node?: { id: string, code?: string | null, name: string } | null } | null> }, connectedAccounts: { edges: Array<{ alias?: string | null, code?: string | null, priceTypes?: Array<{ id: string, priceType: { id: string } }> | null, customerGroups: Array<{ id: string, name: string, code?: string | null }>, node?: { id: string, name: string } | null }> } } | null }> } };

export type PriceTypesDupe4QueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PriceTypesDupe4Query = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string } } }> } };

export type PriceTypesQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PriceTypesQuery = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, name: string, code: string }, retailCurrency: { id: string, name: string, code: string } } }> } };

export type createLinesheetsMutationVariables = Exact<{
  input: BulkCreateCollectionsInput;
}>;


export type createLinesheetsMutation = { bulkCreateCollections: { collections?: Array<{ id: string }> | null } };

export type createAssortmentMutationVariables = Exact<{
  retailerId: Scalars['ID'];
  retailCurrencyId?: InputMaybe<Scalars['ID']>;
  assortmentName?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
  seasonId?: InputMaybe<Scalars['ID']>;
}>;


export type createAssortmentMutation = { createAssortment: { assortment?: { id: string, name: string } | null } };

export type PriceTypesDupe3QueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PriceTypesDupe3Query = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string } } }> } };

export type InProgressOrdersCountQueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type InProgressOrdersCountQuery = { collections: { totalCount?: number | null, edges: Array<{ node: { id: string, inProgressOrders: { totalCount: number, salesReps: Array<{ email: string }>, buyers: Array<{ email: string, retailerAccountName: string }> } } } | null> } };

export type CollectionRetailersQueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CollectionRetailersQuery = { collections: { edges: Array<{ node: { id: string, retailers: Array<{ retailerAccount: { id: string, name: string } }> } } | null> } };

export type BulkUpdateAccountsPrivacyMutationVariables = Exact<{
  input: BulkUpdateAccountsPrivacyInput;
}>;


export type BulkUpdateAccountsPrivacyMutation = { bulkUpdateAccountsPrivacy: { accounts: Array<{ id: string, name: string, privacy: boolean } | null> } };

export type LiteRetailerAccountsInfoQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiteRetailerAccountsInfoQuery = { retailers: { edges?: Array<{ node?: { id: string, isPrimary?: boolean | null, isPublic?: boolean | null, name: string, privacy?: boolean | null, createdAt?: any | null, accountCreationSource?: { id: string, requestedByAccount: { id: string, name?: string | null } } | null, brands: { edges: Array<{ id: string, profileName?: string | null, node?: { id: string } | null }> } } | null }> | null } };

export type RecentlyCreatedAccountsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentlyCreatedAccountsQueryQuery = { viewingUser: { id: string, recentlyCreatedAccounts?: Array<{ id: string, name: string, privacy: boolean }> | null } };

export type UpdateRetailerPrimaryAccountMutationVariables = Exact<{
  input: UpdateRetailerPrimaryAccountInput;
}>;


export type UpdateRetailerPrimaryAccountMutation = { UpdateRetailerPrimaryAccount: { retailerId: string } };

export type AcknowledgeRecentlyCreatedAccountsMutationVariables = Exact<{
  input: AcknowledgeRecentlyCreatedAccountsInput;
}>;


export type AcknowledgeRecentlyCreatedAccountsMutation = { acknowledgeRecentlyCreatedAccounts: { accounts: Array<{ id: string }> } };

export type CheckMergeCriteriaQueryVariables = Exact<{
  targetAccountId: Scalars['ID'];
}>;


export type CheckMergeCriteriaQuery = { checkMergingAccountCriteria?: { ids: Array<string> } | null };

export type MergeAccountsMutationVariables = Exact<{
  input: MergeAccountsInput;
}>;


export type MergeAccountsMutation = { mergeAccounts: { success?: boolean | null } };

export type SetSelectedAccountMutationMutationVariables = Exact<{
  input: SetSelectedAccountInput;
}>;


export type SetSelectedAccountMutationMutation = { setSelectedAccount?: { success: boolean, error?: string | null } | null };

export type LiteRetailerConnectedAccountsDropdownQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LiteRetailerConnectedAccountsDropdownQuery = { retailers: { edges?: Array<{ node?: { id: string, displayName: string, name: string, isPrimary?: boolean | null, createdAt?: any | null, privacy?: boolean | null, brands: { edges: Array<{ id: string, profileName?: string | null, node?: { id: string } | null }> } } | null }> | null } };

export type ordersInProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type ordersInProgressQuery = { orders: { edges: Array<{ node: { id: string, referenceNumber?: string | null, priceType?: { id: string, currency: { id: string, code: string } } | null, brand: { id: string, name: string }, retailerProfile?: { id: string, name?: string | null, displayName?: string | null } | null, products: { totalProducts?: number | null, totalUnits?: number | null, totalVariant?: number | null }, financials?: { dueTotal: { maxPrice: string } } | null, orphanRetailer?: { id: string, retailerName: string, retailerEmail: string } | null } }> } };

export type NewInvitationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NewInvitationCountQuery = { newInvitationCount: { count: number } };

export type setDisplayLanguageForUserMutationVariables = Exact<{
  input: SetDisplayLanguageForUserInput;
}>;


export type setDisplayLanguageForUserMutation = { setDisplayLanguageForUser: { id: string, displayLanguage: string } };

export type UnreadMessagesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadMessagesCountQuery = { unreadMessageCount: { count: number } };

export type GetBrandStyleIdentifierQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrandStyleIdentifierQuery = { getBrandStyleIdentifier: { styleIdentifiers?: Array<string | null> | null } };

export type NewSubmissionsQueryVariables = Exact<{
  filters?: InputMaybe<SubmissionsFilter>;
}>;


export type NewSubmissionsQuery = { submissions: { totalCount?: number | null } };

export type AssignPriceTypesModalPriceTypesQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type AssignPriceTypesModalPriceTypesQuery = { priceTypes: { edges: Array<{ node: { id: string, currency: { code: string }, retailCurrency: { code: string } } }> } };

export type RetailerInfoQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  connectedAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type RetailerInfoQuery = { brands: { edges: Array<{ node?: { connectedAccounts: { edges: Array<{ node?: { publicRetailerProfile?: { id: string, email?: string | null } | null } | null, billingAddresses: Array<{ address?: { line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null }> }> } } | null }> } };

export type CreateExternalPaymentMutationVariables = Exact<{
  input: CreateExternalPaymentInput;
}>;


export type CreateExternalPaymentMutation = { createExternalPayment: { id: string, link: string } };

export type SendPaymentLinkEmailMutationVariables = Exact<{
  input: SendPaymentInput;
}>;


export type SendPaymentLinkEmailMutation = { sendPayment: { id: string } };

export type ExternalPaymentQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type ExternalPaymentQuery = { externalPaymentByLink: { id: string, paymentId: string, brandId: string, brandName: string, brandContactName: string, brandContactEmail: any, retailerId?: string | null, retailerName: string, retailerEmails: Array<any>, amount: number, currency: string, billingAddress: string, billingCountry: string, billingState: string, billingCity: string, billingPostalCode: string, notes?: string | null, deletedAt?: any | null, attachments?: Array<{ fileName: string, url: string }> | null, paymentProvider?: { merchantId?: string | null } | null } };

export type ExternalPaymentRecordsQueryVariables = Exact<{
  externalPaymentId: Scalars['ID'];
}>;


export type ExternalPaymentRecordsQuery = { externalPaymentRecords: Array<{ id: string, amount?: number | null, currency: string, status?: PaymentRecordStatus | null, created?: any | null, localAmount?: number | null, localCurrency?: string | null, paymentMethod?: { bankName: string, type: string } | { brand: string, type: string } | null }> };

export type DeleteExternalPaymentRecordMutationVariables = Exact<{
  input: DeleteExternalPaymentInput;
}>;


export type DeleteExternalPaymentRecordMutation = { deleteExternalPayment: { ok: boolean } };

export type ExternalPaymentsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ExternalPaymentsQuery = { externalPayments: Array<{ id: string, retailerId?: string | null, retailerName: string, retailerEmails: Array<any>, paymentId: string, link: string, created?: any | null, sentDate?: any | null, amount: number, currency: string, paymentStatus: ExternalPaymentStatus }> };

export type BrandBudgetsQueryVariables = Exact<{
  retailerId: Scalars['ID'];
  priceTypeId: Scalars['ID'];
}>;


export type BrandBudgetsQuery = { brandBudgets: { edges?: Array<{ node: { id: string, totalWholesale: any, totalUnits: any, totalUnitsPriorYear: any, totalWholesalePriorYear: any, door?: { id: string, name: string } | null, collection?: { id: string, name: string } | null, division?: { id: string, name: string } | null, priceType: { id: string, name: string } } }> | null } };

export type totalInOrdersQueryVariables = Exact<{
  retailerId: Scalars['ID'];
  priceTypeId: Scalars['ID'];
}>;


export type totalInOrdersQuery = { totalInOrders: Array<{ totalUnits: number, totalWholesale: number, priceTypeId: string, retailerId: string, door?: { id: string, name: string, code?: string | null } | null, collection: { id: string, name: string, code?: string | null }, traitValues: { edges: Array<{ node: { id: string, value: string, externalIdentifier: string, trait: { id: string, name: string, code: string } } }> }, division?: { id: string, name: string, code: string } | null, variant?: { id: string, productId?: string | null, value: string, externalIdentifier?: string | null, trait: { id: string, name: string, code: string } } | null }> };

export type JoorPayOrdersQueryVariables = Exact<{
  filters: OrderFilterInput;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type JoorPayOrdersQuery = { orders: { totalCount: number, edges: Array<{ node: { id: string, created: any, referenceNumber?: string | null, status?: OrderStatus | null, trackingNumber?: string | null, webOrderLookupId: string, event?: { id?: string | null, name?: string | null, code?: string | null } | null, collections: { edges: Array<{ node: { id: string, name: string } } | null> }, brand: { id: string, name: string }, retailerProfile?: { id: string, displayName?: string | null } | null, priceType?: { id: string, currency: { id: string, code: string } } | null, salesRepresentative?: { id: string, displayName?: string | null } | null, shipping: { deliveryWindow?: { startDate?: any | null, completeDate?: any | null } | null, address: { email?: string | null } }, billing: { address: { firstAddress?: string | null, secondAddress?: string | null, country?: string | null, city?: string | null, zip?: string | null } }, financials?: { totalUnits: number, dueTotal: { maxPrice: string }, wholesaleTotal: { maxPrice: string }, subTotal: { maxPrice: string }, orderDiscount?: { factor?: string | null } | null, shippingFees?: { factor?: string | null } | null, tax?: { factor?: string | null } | null, customFees?: Array<{ id?: string | null, factor?: string | null }> | null } | null, paymentInfo?: { paymentStatus: PaymentStatus, requestStatus: RequestStatus, firstRequest?: any | null, lastNotifiedDate?: any | null, lastTransaction?: any | null, paidAmount: string, remainingBalance: string, dueDate?: any | null } | null, paymentMethod?: { id: string, name?: string | null } | null } }> } };

export type mergeOrderMutationVariables = Exact<{
  input: MergeOrderInput;
}>;


export type mergeOrderMutation = { mergeOrders: { success: boolean } };

export type OrdersToMergeQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type OrdersToMergeQuery = { orders: { edges: Array<{ node: { id: string, status?: OrderStatus | null, referenceNumber?: string | null, quantity: number, wholesaleTotal: any, retailerProfile?: { id: string, name?: string | null } | null, collection: { id: string, name: string, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null } | null }, collections: { edges: Array<{ node: { id: string, name: string, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null } | null } } | null> }, priceType?: { id: string, name: string, currency: { id: string, code: string, symbol: string } } | null, shippingInfo: { shippingStart?: any | null, shippingComplete?: any | null }, warehouses: { edges: Array<{ node?: { id: string, code: string, name: string } | null } | null> }, doors: { edges: Array<{ node: { id: string, code?: string | null, name: string } }> }, products: { edges: Array<{ node: { id: string, name: string, externalIdentifier: string, variants: { edges: Array<{ node: { code: string, id: string, name: string }, values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { id: string, name: string, code: string } } | null }> | null } }> } }, orderLineItems: { bulkLineItems: Array<{ variantId: string, quantity: number, wholesalePrice: any, suggestedRetailPrice: any } | null>, skuLineItems: Array<{ quantity: number, wholesalePrice: any, suggestedRetailPrice: any, sku: { id: string } } | null>, casepackLineItems: Array<{ quantity: number, wholesalePrice: any, suggestedRetailPrice: any, casepack: { id: string, skus: { edges: Array<{ quantity: number, node: { id: string } }> } } } | null> } }> } } }> } };

export type checkMergingOrderCriteriaDupe2QueryVariables = Exact<{
  selectedOrdersIds: Array<Scalars['ID']> | Scalars['ID'];
  targetOrderId?: InputMaybe<Scalars['ID']>;
}>;


export type checkMergingOrderCriteriaDupe2Query = { checkMergingOrderCriteria?: { message: Array<string>, success: boolean } | null };

export type OrderQueryVariables = Exact<{
  filters: OrderFilterInput;
  priceTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OrderQuery = { orders: { edges: Array<{ node: { id: string, products: { edges: Array<{ node: { id: string, name: string, externalIdentifier: string, images: Array<{ id?: string | null, url?: string | null }>, skus: { edges?: Array<{ node?: { id: string, prices: Array<{ wholesalePrice: any, suggestedRetailPrice?: any | null, id: string }> } | null }> | null }, traitValues: { edges: Array<{ node: { id: string, externalIdentifier: string, value: string, trait: { id: string, name: string, code: string } } }> }, variants: { edges: Array<{ node: { code: string, id: string, name: string }, values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { id: string, name: string, code: string }, displayDetails?: { hexColor?: string | null, swatchImage?: { id: string, url: any } | null } | null } | null }> | null } }> } } }> } } }> } };

export type orderContactsDupe1QueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type orderContactsDupe1Query = { orders: { edges: Array<{ node: { id: string, referenceNumber?: string | null, buyer?: { id: string, name?: string | null, email?: string | null } | null } }> } };

export type anonymousOrderQueryRedirectQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type anonymousOrderQueryRedirectQuery = { public: { getOrderByInvoice: { id: string, brand?: { id: string } | null, retailer?: { id: string } | null } } };

export type anonymousOrderQueryQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type anonymousOrderQueryQuery = { public: { getOrderByInvoice: { id: string, deliveryStart?: string | null, deliveryComplete?: string | null, status?: string | null, referenceNumber?: string | null, shippingEmail?: string | null, taxAmount?: number | null, discountAmount?: number | null, shippingPrice?: number | null, shippingPhone?: string | null, shippingCompany?: string | null, shippingFirstAddress?: string | null, shippingSecondAddress?: string | null, shippingState?: string | null, shippingZip?: string | null, shippingCity?: string | null, shippingCountry?: string | null, webOrderLookupId?: string | null, taxIdNumber?: string | null, billingCountry?: string | null, billingCompany?: string | null, billingFirstAddress?: string | null, billingSecondAddress?: string | null, billingState?: string | null, billingZip?: string | null, billingCity?: string | null, billingPhone?: string | null, modified: any, salesRepresentative?: { name?: string | null, email?: string | null } | null, lineItems?: { discountedPrice?: string | null, totalUnits?: string | null, totalPrice?: string | null, totalRetailPrice?: string | null } | null, priceType?: { currency?: { decimals?: number | null, code?: string | null, symbol?: string | null } | null } | null, brand?: { id: string, displayName?: string | null } | null, retailer?: { displayName?: string | null, id: string } | null, seasonYear?: { year?: string | null, season?: { name?: string | null } | null } | null, collections?: { edges?: Array<{ node?: { name?: string | null } | null }> | null } | null, lastModifier?: { email: string } | null, door?: { id?: string | null, name?: string | null } | null, warehouse?: { id?: string | null, name?: string | null } | null, paymentMethod?: { id?: string | null, paymentName?: string | null } | null, financials?: { id: string, wholesaleTotal: { maxPrice: string, minPrice: string }, suggestedRetailTotal: { maxPrice: string, minPrice: string }, subTotal: { maxPrice: string, minPrice: string }, orderDiscount?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, tax?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, shippingFees?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, customFees?: Array<{ id?: string | null, name?: string | null, factor?: string | null, percentageAmount?: string | null, type?: OrderPriceModifierType | null }> | null, grandTotal: { minPrice: string, maxPrice: string }, dueTotal: { minPrice: string, maxPrice: string } } | null } } };

export type OrderPaymentRecordsQueryVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type OrderPaymentRecordsQuery = { paymentRecords: Array<{ id: string, orderId: string, amount?: number | null, currency: string, status?: PaymentRecordStatus | null, created?: any | null, localAmount?: number | null, localCurrency?: string | null, externalIdentifier?: string | null, errorMessage?: string | null, paymentMethod?: { bankName: string, type: string } | { brand: string, type: string } | null }> };

export type LocalCurrenciesFFQueryQueryVariables = Exact<{
  brandAccountId: Scalars['ID'];
}>;


export type LocalCurrenciesFFQueryQuery = { public: { useJoorPayLocalPayments: boolean } };

export type TriggerOrdersPDFExportTasksMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type TriggerOrdersPDFExportTasksMutation = { triggerOrdersPdfExportTasks: { taskIds: Array<string> } };

export type ListOrderExportTasksQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type ListOrderExportTasksQuery = { listOrderExportTasks: { exportTasks: Array<{ id: string, status: OrderExportTaskStatus, downloadUrl: string }> } };

export type CreateManualTransactionMutationVariables = Exact<{
  input: CreateManualPaymentRecordInput;
}>;


export type CreateManualTransactionMutation = { createManualPaymentRecord: { id: string, paymentMethod: ManualPaymentMethod, paymentDate?: any | null, amount: number, currency: string, recordedBy?: string | null, referenceNumber?: string | null, notes?: string | null, orderId: string } };

export type UpdateManualTransactionMutationVariables = Exact<{
  input: UpdateManualPaymentRecordInput;
}>;


export type UpdateManualTransactionMutation = { updateManualPaymentRecord: { id: string, paymentMethod: ManualPaymentMethod, paymentDate?: any | null, amount: number, currency: string, recordedBy?: string | null, referenceNumber?: string | null, notes?: string | null, orderId: string } };

export type DeleteManualTransactionMutationVariables = Exact<{
  input: DeleteManualPaymentRecordInput;
}>;


export type DeleteManualTransactionMutation = { deleteManualPaymentRecord?: { ok: boolean } | null };

export type ManualTransactionFragment = { id: string, paymentMethod: ManualPaymentMethod, paymentDate?: any | null, amount: number, currency: string, recordedBy?: string | null, referenceNumber?: string | null, notes?: string | null, orderId: string };

export type ManualTransactionsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ManualTransactionsQuery = { manualPaymentRecords: Array<{ id: string, paymentMethod: ManualPaymentMethod, paymentDate?: any | null, amount: number, currency: string, recordedBy?: string | null, referenceNumber?: string | null, notes?: string | null, orderId: string }> };

export type CreateReachPaymentMutationVariables = Exact<{
  input: CreatePaymentWithPaymentMethodInput;
}>;


export type CreateReachPaymentMutation = { createReachPayment: { sessionId: string, errors?: Array<string> | null } };

export type UpdateReachPaymentMutationVariables = Exact<{
  input: UpdatePaymentInput;
}>;


export type UpdateReachPaymentMutation = { updatePayment: { ok: boolean } };

export type AnonymousCreateReachPaymentMutationVariables = Exact<{
  input: CreatePaymentWithPaymentMethodInput;
}>;


export type AnonymousCreateReachPaymentMutation = { anonymousCreateReachPayment: { sessionId: string, errors?: Array<string> | null } };

export type AnonymousUpdateReachPaymentMutationVariables = Exact<{
  input: UpdatePaymentInput;
}>;


export type AnonymousUpdateReachPaymentMutation = { anonymousUpdatePayment: { ok: boolean } };

export type PaymentProvidersQueryQueryVariables = Exact<{
  destinationAccountId: Scalars['ID'];
}>;


export type PaymentProvidersQueryQuery = { accountPaymentProviders: Array<{ paymentProvider: string, connectionDetails?: { merchantId: string } | null }> };

export type OrderPartialPaymentRequestsQueryVariables = Exact<{
  orderId: Scalars['ID'];
}>;


export type OrderPartialPaymentRequestsQuery = { orders: { edges: Array<{ node: { id: string, paymentInfo?: { partialPaymentRequests?: Array<{ id: string, amount: string, name?: string | null, active?: boolean | null }> | null } | null } }> } };

export type PublicOrderPartialPaymentRequestsQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PublicOrderPartialPaymentRequestsQuery = { public: { getOrderByInvoice: { partialPaymentRequests?: Array<{ id: string, amount: string, name?: string | null, active?: boolean | null, currency: string }> | null } } };

export type OrderRemainingBalanceQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type OrderRemainingBalanceQuery = { orders: { edges: Array<{ node: { id: string, paymentInfo?: { paidAmount: string, remainingBalance: string } | null } }> } };

export type PublicOrderRemainingBalanceQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type PublicOrderRemainingBalanceQuery = { public: { getOrderByInvoice: { paymentInfo?: { paidAmount: string, remainingBalance: string } | null } } };

export type TriggerOrdersPdfExportTasksMutationVariables = Exact<{
  input: TriggerOrdersPdfExportTasksInput;
}>;


export type TriggerOrdersPdfExportTasksMutation = { triggerOrdersPdfExportTasks: { taskIds: Array<string> } };

export type listOrderExportTasksQueryVariables = Exact<{
  input: ListOrderExportTasksInput;
}>;


export type listOrderExportTasksQuery = { listOrderExportTasks: { exportTasks: Array<{ id: string, status: OrderExportTaskStatus, downloadUrl: string }> } };

export type UpdateOrderInfoDupe3MutationVariables = Exact<{
  input?: InputMaybe<UpdateOrderInfoInput>;
}>;


export type UpdateOrderInfoDupe3Mutation = { updateOrderInfo: { updatedOrderIds?: Array<string> | null } };

export type UpdateHeaderPricetypesAndDatesMutationVariables = Exact<{
  input: UpdateOrdersConnection;
}>;


export type UpdateHeaderPricetypesAndDatesMutation = { updateOrders: { orders: Array<{ id: string }>, errors: Array<{ message: string }> } };

export type UpdateOrderDeliveryInfoDupe1MutationVariables = Exact<{
  input: UpdateOrderDeliveryInfoInput;
}>;


export type UpdateOrderDeliveryInfoDupe1Mutation = { updateOrderDeliveryInfo: { updatedOrderIds: Array<string> } };

export type OrderBillingShippingQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type OrderBillingShippingQuery = { orders: { edges: Array<{ node: { id: string, trackingNumber?: string | null, billing: { address: { name?: string | null, company?: string | null, firstAddress?: string | null, secondAddress?: string | null, country?: string | null, state?: string | null, city?: string | null, zip?: string | null, phone?: string | null, sourceBillingAddress?: { id: string, code?: string | null } | null } }, shipping: { priceString?: string | null, method?: { id: string, name: string, code: string } | null, deliveryWindow?: { startDate?: any | null, completeDate?: any | null } | null, address: { name?: string | null, company?: string | null, email?: string | null, phone?: string | null, state?: string | null, firstAddress?: string | null, secondAddress?: string | null, country?: string | null, city?: string | null, zip?: string | null, sourceShippingAddress?: { id: string, code?: string | null } | null } }, tax?: { number?: string | null, label?: string | null, amountString?: string | null } | null, doors: { edges: Array<{ node: { id: string, name: string, code?: string | null } }> }, paymentMethod?: { id: string, name?: string | null, code?: string | null } | null } }> } };

export type CountriesForAddressModalQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesForAddressModalQuery = { geographies: { edges: Array<{ node: { id: string, name: string, taxLabel?: string | null } }> } };

export type BrandShippingInfoQueryVariables = Exact<{
  filter?: InputMaybe<BrandsFilter>;
  connectedAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BrandShippingInfoQuery = { brands: { edges: Array<{ node?: { id: string, connectedAccounts: { edges: Array<{ billingAddresses: Array<{ id: string, phoneNumber?: string | null, code?: string | null, address?: { line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, name?: string | null, companyName?: string | null } | null }>, shippingAddresses: Array<{ id: string, email?: string | null, phoneNumber?: string | null, code?: string | null, address?: { line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, name?: string | null, companyName?: string | null } | null }>, shippingMethods: Array<{ shippingMethod?: { id: string, name: string, code: string } | null }>, paymentMethods: Array<{ paymentMethod: { id: string, name: string, code: string } }> }> } } | null }> } };

export type RetailerLocationsQueryVariables = Exact<{
  retailerId: Scalars['ID'];
}>;


export type RetailerLocationsQuery = { retailer?: { id: string, publicRetailerProfile?: { id: string, email?: string | null } | null, locations?: Array<{ id: string, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null, name?: string | null, type?: LocationType | null, phone?: string | null, isPrimaryLocation: boolean }> | null } | null };

export type UpdateOrderBillingMutationVariables = Exact<{
  input: UpdateOrderBillingInput;
}>;


export type UpdateOrderBillingMutation = { updateOrderBilling: { updatedOrderIds?: Array<string> | null, errors?: Array<string> | null } };

export type UpdateOrderShippingMutationVariables = Exact<{
  input: UpdateOrderShippingInput;
}>;


export type UpdateOrderShippingMutation = { updateOrderShipping: { updatedOrderIds?: Array<string> | null, errors?: Array<string> | null } };

export type UpdateShippingDetailDoorMutationVariables = Exact<{
  orderId: Scalars['ID'];
  doorId: Scalars['ID'];
}>;


export type UpdateShippingDetailDoorMutation = { updateOrderDeliveryInfo: { updatedOrderIds: Array<string> } };

export type UpdateFinancialSummaryMutationVariables = Exact<{
  updateOrderFinancials: UpdateOrdersConnection;
}>;


export type UpdateFinancialSummaryMutation = { updateOrders: { updatedOrders?: { edges: Array<{ node: { id: string, financials?: { id: string, wholesaleTotal: { maxPrice: string, minPrice: string }, suggestedRetailTotal: { maxPrice: string, minPrice: string }, subTotal: { maxPrice: string, minPrice: string }, orderDiscount?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, tax?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, shippingFees?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, customFees?: Array<{ id?: string | null, name?: string | null, factor?: string | null, percentageAmount?: string | null, type?: OrderPriceModifierType | null }> | null, grandTotal: { minPrice: string, maxPrice: string }, dueTotal: { minPrice: string, maxPrice: string } } | null } }> } | null, errors: Array<{ message: string }> } };

export type UpdateOrderInternalCommentMutationVariables = Exact<{
  input?: InputMaybe<UpdateOrderInfoInput>;
}>;


export type UpdateOrderInternalCommentMutation = { updateOrderInfo: { updatedOrders?: { edges: Array<{ node: { id: string, internalComments?: string | null } }> } | null } };

export type OrderDetailsEditInfoQueryVariables = Exact<{
  brandId: Scalars['ID'];
  retailerId: Scalars['ID'];
  isBrand: Scalars['Boolean'];
  shouldFetchConnection: Scalars['Boolean'];
}>;


export type OrderDetailsEditInfoQuery = { brands: { edges: Array<{ node?: { id: string, seasons: { edges: Array<{ node: { id: string, name: string } }> }, orderEvents?: Array<{ id: string, name: string, code?: string | null }>, orderTypes?: { edges: Array<{ node?: { id: string, name: string, code?: string | null } | null }> }, warehouses?: { edges: Array<{ node?: { id: string, code: string, name: string } | null } | null> } } | null }> }, listConnectionWarehouses?: Array<{ warehouseId: string }> };

export type UpdateOrderDetailsEventAndTypeMutationVariables = Exact<{
  orderInfoInput?: InputMaybe<UpdateOrderInfoInput>;
}>;


export type UpdateOrderDetailsEventAndTypeMutation = { updateOrderInfo: { errors?: Array<string> | null, orders?: { edges: Array<{ node: { id: string, event?: { id?: string | null, name?: string | null, code?: string | null } | null, types: Array<{ id: string, name: string, code?: string | null }> } }> } | null } };

export type UpdateOrderDetailsWarehouseAndSeasonMutationVariables = Exact<{
  input: UpdateOrderDeliveryInfoInput;
}>;


export type UpdateOrderDetailsWarehouseAndSeasonMutation = { updateOrderDeliveryInfo: { orders?: { edges: Array<{ node: { id: string, warehouses: { edges: Array<{ node?: { id: string, name: string, code: string } | null } | null> }, season?: { id: string, name: string, code: string, year?: number | null } | null } }> } | null } };

export type SendJoorPayImInterestedEmailMutationVariables = Exact<{
  input: SendJoorPayImInterestedEmailInput;
}>;


export type SendJoorPayImInterestedEmailMutation = { sendJoorPayImInterestedEmail: { success: boolean } };

export type PaymentOrderInfoQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type PaymentOrderInfoQuery = { orders: { edges: Array<{ node: { id: string, webOrderLookupId: string, referenceNumber?: string | null, status?: OrderStatus | null, statusModified?: any | null, brand: { id: string, name: string }, billing: { address: { name?: string | null, firstAddress?: string | null, secondAddress?: string | null, city?: string | null, country?: string | null, state?: string | null, phone?: string | null, zip?: string | null } }, retailerProfile?: { id: string, name?: string | null, displayName?: string | null, email?: string | null } | null, priceType?: { id: string, name: string, currency: { id: string, name: string, code: string } } | null, shipping: { priceString?: string | null, method?: { id: string, name: string, code: string } | null, deliveryWindow?: { startDate?: any | null, completeDate?: any | null } | null, address: { name?: string | null, company?: string | null, email?: string | null, phone?: string | null, state?: string | null, firstAddress?: string | null, secondAddress?: string | null, country?: string | null, city?: string | null, zip?: string | null, sourceShippingAddress?: { id: string, code?: string | null } | null } }, financials?: { dueTotal: { minPrice: string, maxPrice: string } } | null } }> } };

export type SendInvoicesPaymentRequestMutationVariables = Exact<{
  input: SendInvoicesForOrdersInput;
}>;


export type SendInvoicesPaymentRequestMutation = { sendInvoicesForOrders?: Array<{ orderId: string, sentTo: string, sentOn: any } | null> | null };

export type CreateInvoicePaymentRequestMutationVariables = Exact<{
  input: CreateInvoicesInput;
}>;


export type CreateInvoicePaymentRequestMutation = { createInvoices: Array<{ orderId: string, invoiceId: string }> };

export type ProductsInfoFragment = { totalProducts?: number | null, totalUnits?: number | null, totalVariant?: number | null, edges: Array<{ quantity?: number | null, orderProductComment?: string | null, attributes?: Array<{ id: string, name: string, value: string, type: ProductAttributeType, externalIdentifier?: string | null }> | null, wholesaleRangeOverwritten?: { minPrice: string, maxPrice: string } | null, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number, maxRetailValue: number } | null, collectionProduct?: { id: string, collection: { id: string, name: string } } | null, backupProduct?: { productId: string, productName: string, productNumber: string } | null, variantTotals: { edges?: Array<{ node?: { quantity: number, variantComment: string, wholesaleTotalRange: { minPrice: string, maxPrice: string }, variant: { id: string, value: string, externalIdentifier?: string | null, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { id: string, url: any } | null } | null } } | null }> | null }, discounts: Array<{ type: OrderDiscountType, level: OrderDiscountLevel, factor: any } | null>, financials?: { id: string, wholesaleTotal: { minPrice: string, maxPrice: string }, subTotal: { minPrice: string, maxPrice: string } } | null, orderLineItems: { skuLineItems: Array<{ quantity: number, wholesalePrice: any, sku: { id: string, variantValues: { edges?: Array<{ node?: { id: string, value: string, orderNbr?: number | null, trait: { id: string, code: string, name: string } } | null }> | null } } } | null>, casepackLineItems: Array<{ quantity: number, wholesalePrice: any, variantInfo?: { variantId: string, sizeName: string } | null, casepack: { id: string, skus: { edges: Array<{ quantity: number, node: { id: string, variantValues: { edges?: Array<{ node?: { id: string, value: string, orderNbr?: number | null, trait: { id: string, code: string, name: string } } | null }> | null } } }> } } } | null>, bulkLineItems: Array<{ quantity: number, wholesalePriceRange: { maxPrice: string, minPrice: string }, variant?: { id: string } | null } | null> }, node: { id: string, name: string, externalIdentifier: string, mainImage?: { id?: string | null, url?: string | null } | null, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } } }> };

export type OrderShippingDetailsFragment = { priceString?: string | null, method?: { id: string, name: string, code: string } | null, deliveryWindow?: { startDate?: any | null, completeDate?: any | null } | null, address: { name?: string | null, company?: string | null, email?: string | null, phone?: string | null, state?: string | null, firstAddress?: string | null, secondAddress?: string | null, country?: string | null, city?: string | null, zip?: string | null, sourceShippingAddress?: { id: string, code?: string | null } | null } };

export type OrderTaxFragment = { number?: string | null, label?: string | null, amountString?: string | null };

export type OrderCollectionsFragment = { edges: Array<{ node: { id: string, name: string, code?: string | null, visibility?: CollectionVisibility | null, visibleToViewer: boolean, archived?: boolean | null, delivery?: { id: string, minimumShippingWindow?: number | null } | null, retailers: Array<{ retailerAccount: { id: string } }> } } | null>, deliveryWindow?: { minStartShipDate?: any | null, maxCompleteShipDate?: any | null } | null };

export type BrandOrderSettingsFragment = { displayShippingCode?: boolean | null, displayInternalOrderId?: boolean | null, minUnits?: number | null, minAmount?: number | null, retailerRestrictedFromEditing?: boolean | null, displayCountryOfOrigin?: boolean | null, restrictEditNotesAndReturnedOrders?: boolean | null, restrictPendingToNotes?: boolean | null, salesComissions?: Array<string> | null, shippingRates?: string | null, allowOrderDiscounts?: boolean | null };

export type OrderFinancialsFragment = { id: string, wholesaleTotal: { maxPrice: string, minPrice: string }, suggestedRetailTotal: { maxPrice: string, minPrice: string }, subTotal: { maxPrice: string, minPrice: string }, orderDiscount?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, tax?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, shippingFees?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, customFees?: Array<{ id?: string | null, name?: string | null, factor?: string | null, percentageAmount?: string | null, type?: OrderPriceModifierType | null }> | null, grandTotal: { minPrice: string, maxPrice: string }, dueTotal: { minPrice: string, maxPrice: string } };

export type UpdateOrderInfoMutationVariables = Exact<{
  input?: InputMaybe<UpdateOrderInfoInput>;
}>;


export type UpdateOrderInfoMutation = { updateOrderInfo: { updatedOrders?: { edges: Array<{ node: { id: string, orderComments?: string | null, termsAndConditions?: { id: string, agreesWithTerms: boolean, terms: string, platform: OrderTermsAndConditionsPlatform, dateModified?: any | null, name: string, title: string } | null } }> } | null } };

export type BulkUpdateOrderStatusMutationMutationVariables = Exact<{
  input: BulkUpdateOrderStatusInput;
}>;


export type BulkUpdateOrderStatusMutationMutation = { bulkUpdateOrderStatus: { updatedOrderIds: Array<string>, errors: Array<{ message: string }> } };

export type OrderGeneralInfoQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type OrderGeneralInfoQuery = { orders: { edges: Array<{ node: { id: string, warehouses: { edges: Array<{ node?: { id: string } | null } | null> }, retailerProfile?: { id: string, displayName?: string | null } | null, collections: { edges: Array<{ node: { id: string, name: string } } | null> }, priceType?: { id: string } | null, doors: { edges: Array<{ node: { id: string, name: string, code?: string | null } }> } } }> } };

export type OrderReviewGigaQueryQueryVariables = Exact<{
  filters: OrderFilterInput;
  traitCodes: VariantFilterValuesInput;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type OrderReviewGigaQueryQuery = { orders: { edges: Array<{ node: { id: string, created: any, name: string, internalComments?: string | null, isOrphan: boolean, modified: any, orderComments?: string | null, quantity: number, referenceNumber?: string | null, status?: OrderStatus | null, statusModified?: any | null, webOrderLookupId: string, wholesaleTotal: any, brand: { id: string, name: string, orderSettings?: { displayShippingCode?: boolean | null, displayInternalOrderId?: boolean | null, minUnits?: number | null, minAmount?: number | null, retailerRestrictedFromEditing?: boolean | null, displayCountryOfOrigin?: boolean | null, restrictEditNotesAndReturnedOrders?: boolean | null, restrictPendingToNotes?: boolean | null, salesComissions?: Array<string> | null, shippingRates?: string | null, allowOrderDiscounts?: boolean | null } | null }, buyer?: { id: string, name?: string | null, email?: string | null } | null, orphanRetailer?: { id: string, retailerName: string, retailerEmail: string } | null, collections: { edges: Array<{ node: { id: string, name: string, code?: string | null, visibility?: CollectionVisibility | null, visibleToViewer: boolean, archived?: boolean | null, delivery?: { id: string, minimumShippingWindow?: number | null } | null, retailers: Array<{ retailerAccount: { id: string } }> } } | null>, deliveryWindow?: { minStartShipDate?: any | null, maxCompleteShipDate?: any | null } | null }, divisions: Array<{ id: string, name: string, code: string }>, event?: { id?: string | null, name?: string | null, code?: string | null } | null, financials?: { id: string, wholesaleTotal: { maxPrice: string, minPrice: string }, suggestedRetailTotal: { maxPrice: string, minPrice: string }, subTotal: { maxPrice: string, minPrice: string }, orderDiscount?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, tax?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, shippingFees?: { factor?: string | null, type?: OrderPriceModifierType | null, percentageAmount?: string | null } | null, customFees?: Array<{ id?: string | null, name?: string | null, factor?: string | null, percentageAmount?: string | null, type?: OrderPriceModifierType | null }> | null, grandTotal: { minPrice: string, maxPrice: string }, dueTotal: { minPrice: string, maxPrice: string } } | null, lastModifier?: { byAdmin: boolean, email: string } | null, priceType?: { id: string, name: string, currency: { id: string, name: string, code: string, symbol: string, decimals: number, decimal_separator?: string | null, thousands_separator?: string | null }, retailCurrency: { id: string, code: string } } | null, retailerProfile?: { id: string, name?: string | null, displayName?: string | null, code?: string | null } | null, salesComissions?: Array<{ name: string }> | null, salesRepresentative?: { id: string, displayName?: string | null, email?: string | null } | null, season?: { id: string, name: string, code: string, year?: number | null } | null, shipping: { priceString?: string | null, method?: { id: string, name: string, code: string } | null, deliveryWindow?: { startDate?: any | null, completeDate?: any | null } | null, address: { name?: string | null, company?: string | null, email?: string | null, phone?: string | null, state?: string | null, firstAddress?: string | null, secondAddress?: string | null, country?: string | null, city?: string | null, zip?: string | null, sourceShippingAddress?: { id: string, code?: string | null } | null } }, tax?: { number?: string | null, label?: string | null, amountString?: string | null } | null, termsAndConditions?: { id: string, agreesWithTerms: boolean, terms: string, platform: OrderTermsAndConditionsPlatform, dateModified?: any | null, name: string, title: string } | null, types: Array<{ id: string, name: string, code?: string | null }>, warehouses: { edges: Array<{ node?: { id: string, name: string, code: string } | null } | null> }, products: { totalProducts?: number | null, totalUnits?: number | null, totalVariant?: number | null, edges: Array<{ quantity?: number | null, orderProductComment?: string | null, attributes?: Array<{ id: string, name: string, value: string, type: ProductAttributeType, externalIdentifier?: string | null }> | null, wholesaleRangeOverwritten?: { minPrice: string, maxPrice: string } | null, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number, maxRetailValue: number } | null, collectionProduct?: { id: string, collection: { id: string, name: string } } | null, backupProduct?: { productId: string, productName: string, productNumber: string } | null, variantTotals: { edges?: Array<{ node?: { quantity: number, variantComment: string, wholesaleTotalRange: { minPrice: string, maxPrice: string }, variant: { id: string, value: string, externalIdentifier?: string | null, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { id: string, url: any } | null } | null } } | null }> | null }, discounts: Array<{ type: OrderDiscountType, level: OrderDiscountLevel, factor: any } | null>, financials?: { id: string, wholesaleTotal: { minPrice: string, maxPrice: string }, subTotal: { minPrice: string, maxPrice: string } } | null, orderLineItems: { skuLineItems: Array<{ quantity: number, wholesalePrice: any, sku: { id: string, variantValues: { edges?: Array<{ node?: { id: string, value: string, orderNbr?: number | null, trait: { id: string, code: string, name: string } } | null }> | null } } } | null>, casepackLineItems: Array<{ quantity: number, wholesalePrice: any, variantInfo?: { variantId: string, sizeName: string } | null, casepack: { id: string, skus: { edges: Array<{ quantity: number, node: { id: string, variantValues: { edges?: Array<{ node?: { id: string, value: string, orderNbr?: number | null, trait: { id: string, code: string, name: string } } | null }> | null } } }> } } } | null>, bulkLineItems: Array<{ quantity: number, wholesalePriceRange: { maxPrice: string, minPrice: string }, variant?: { id: string } | null } | null> }, node: { id: string, name: string, externalIdentifier: string, mainImage?: { id?: string | null, url?: string | null } | null, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } } }> } }, checkMinimums: { orderAmount: boolean, orderQuantity: boolean, productMinimums: boolean, colorMinimums: boolean } }> } };

export type OrderRequirementChecksQueryVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OrderRequirementChecksQuery = { orderRequirementChecks: Array<{ id: string, checksMinimums?: boolean | null, sizeRunChanged?: boolean | null }> };

export type AccountHasPaymentProvidersQueryVariables = Exact<{
  destinationAccountId: Scalars['ID'];
}>;


export type AccountHasPaymentProvidersQuery = { accountPaymentProviders: Array<{ accountId: string, paymentProvider: string, retailersCanSeeInvoices?: boolean | null }> };

export type OrderRequestStatusQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type OrderRequestStatusQuery = { orders: { edges: Array<{ node: { id: string, paymentInfo?: { requestStatus: RequestStatus } | null } }> } };

export type UseJoorPayFlagQueryVariables = Exact<{
  brandAccountId: Scalars['ID'];
}>;


export type UseJoorPayFlagQuery = { public: { useJoorPay: boolean } };

export type ListConnectionPriceTypesORQueryVariables = Exact<{
  input: ListConnectionPriceTypeInput;
}>;


export type ListConnectionPriceTypesORQuery = { listConnectionPriceTypes: Array<{ id: string, priceType: { id: string, name: string, currency: { id: string, name?: string | null, code?: string | null }, retailCurrency: { id: string } } }> };

export type OrderHasRemainingBalanceQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type OrderHasRemainingBalanceQuery = { orders: { edges: Array<{ node: { id: string, paymentInfo?: { remainingBalance: string } | null } }> } };

export type GetShopifySubscriptionStatusQueryVariables = Exact<{
  accountId: Scalars['ID'];
  appName: ShopifyAppName;
}>;


export type GetShopifySubscriptionStatusQuery = { shopifyIntegrations?: Array<{ id: string, isSubscriptionActive: boolean, storeCurrencyCode: string } | { id: string, isSubscriptionActive: boolean, storeCurrencyCode: string }> | null };

export type UpdateOrderContactsMutationVariables = Exact<{
  input?: InputMaybe<UpdateOrderInfoInput>;
}>;


export type UpdateOrderContactsMutation = { updateOrderInfo: { updatedOrderIds?: Array<string> | null } };

export type BrandContactsQueryVariables = Exact<{
  filter?: InputMaybe<BrandsFilter>;
  connectedAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BrandContactsQuery = { brands: { edges: Array<{ node?: { brandUsers?: { edges: Array<{ node?: { id: string, displayName?: string | null, email?: string | null } | null }> } | null, connectedAccounts: { edges: Array<{ buyers: Array<{ id: string, name?: string | null, email?: string | null }> }> } } | null }> } };

export type UploadAttachmentToS3MutationVariables = Exact<{
  input: UploadAttachmentToS3Input;
}>;


export type UploadAttachmentToS3Mutation = { uploadAttachmentToS3?: { url?: string | null, fileName?: string | null } | null };

export type TradeShowRetailersV1QueryVariables = Exact<{
  filters?: InputMaybe<TradeShowEventRetailerFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
}>;


export type TradeShowRetailersV1Query = { public: { __typename: 'PublicQuery', tradeShowRetailers: { totalCount?: number | null, edges?: Array<{ node: { id: string, name: string, slug: string, mainPictureUrl: string, mainStorePictureUrl: string } }> | null } } };

export type TradeShowsQueryVariables = Exact<{
  filters?: InputMaybe<TradeShowEventFilter>;
}>;


export type TradeShowsQuery = { public: { tradeShows: { edges?: Array<{ node: { id: string } }> | null } } };

export type TradeShowBrandsV2QueryVariables = Exact<{
  filters?: InputMaybe<TradeShowEventBrandFilter>;
  pagination?: InputMaybe<TradeShowPageInfo>;
}>;


export type TradeShowBrandsV2Query = { public: { tradeShowBrands: { totalCount?: number | null, edges?: Array<{ node: { id: string, name: string, slug: string, mainPictureUrl: string, profileImageUrls: Array<string> } }> | null } } };

export type TradeShowBrandsCategoriesV2QueryVariables = Exact<{
  filters?: InputMaybe<TradeShowEventBrandFilter>;
}>;


export type TradeShowBrandsCategoriesV2Query = { public: { tradeShowBrandsCategories: { edges?: Array<{ node: { id: string, name: string } }> | null } } };

export type TradeShowRetailersCategoriesV1QueryVariables = Exact<{
  filters?: InputMaybe<TradeShowEventRetailerFilter>;
}>;


export type TradeShowRetailersCategoriesV1Query = { public: { tradeShowRetailersCategories: { edges?: Array<{ node: { id: string, name: string } }> | null } } };

export type createFavoriteAccountDupe1MutationVariables = Exact<{
  input: AddFavoriteAccountInput;
}>;


export type createFavoriteAccountDupe1Mutation = { createFavoriteAccount: { id: string, brandAccountId: string, tradeShowEventId?: string | null } };

export type deleteFavoriteAccountDupe1MutationVariables = Exact<{
  input: DeleteFavoriteAccountInput;
}>;


export type deleteFavoriteAccountDupe1Mutation = { deleteFavoriteAccount?: { success?: boolean | null } | null };

export type FavoritedBrandsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritedBrandsQueryQuery = { favoritedBrandsByRetailAccountUser: Array<{ id: string, profileName?: string | null, mainImage?: string | null, tradeShowEventSlug?: string | null }> };

export type PublicRetailerPageQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PublicRetailerPageQuery = { public: { retailer: Array<{ id: string, name?: string | null, logoUrl?: string | null, profileImages?: Array<{ id: string, upload?: { id: string, url: string } | null }> | null }> } };

export type viewingAccountQueryVariables = Exact<{
  id: Scalars['ID'];
  pro: Scalars['Boolean'];
}>;


export type viewingAccountQuery = { unreadMessageCount: { count: number }, newInvitationCount: { count: number }, retailerProfileCompletion: { percentage: number }, listLatestFavoriteBrands: Array<{ id: string, name: string, accountMedia?: { mimeType?: string | null, id?: string | null, fileName?: string | null, url?: string | null } | null }>, listRecentBrandAssortments?: Array<{ id: string, poNumber: string, orderTime: any, orderTimestamp: any, linesheetName: string, brandName: string, brandId: string, brandImage?: { id?: string | null, url?: string | null, fileName?: string | null, mimeType?: string | null } | null }> };

export type listCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type listCollectionsQuery = { listRecentSharedCollections: Array<{ id: string, collectionType: string, name: string, brandId: string, brandName: string, sharedOn: any, brandImage?: { id?: string | null, url?: string | null, fileName?: string | null, mimeType?: string | null } | null }> };

export type listRecentBrandOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type listRecentBrandOrdersQuery = { listRecentBrandOrders: Array<{ id: string, poNumber: string, orderTime: any, linesheetName: string, brandName: string, brandId: string, brandImage?: { id?: string | null, url?: string | null, fileName?: string | null, mimeType?: string | null } | null }> };

export type listLatestBrandsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type listLatestBrandsQuery = { listLatestBrands: Array<{ id: string, name: string, categories: Array<string>, accountMedia?: { id?: string | null, url?: string | null, fileName?: string | null, mimeType?: string | null } | null }> };

export type FindInterestedBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type FindInterestedBrandsQuery = { findInterestedBrands: Array<{ brandId: string, name: string, logoUrl?: string | null } | null> };

export type SubmissionsBrandsInterestedInYouQueryQueryVariables = Exact<{
  filters?: InputMaybe<SubmissionsFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;


export type SubmissionsBrandsInterestedInYouQueryQuery = { submissions: { edges: Array<{ node: { id: string, createdAt?: any | null, senderAccount?: { accountId: string, accountName: string, accountProfilePictureUrl?: string | null } | null, categories?: Array<{ wholesaleMin: string, wholesaleMax: string, category: { id: string, name?: string | null } }> | null } }> } };

export type NewBrandsQueryVariables = Exact<{
  filters?: InputMaybe<ListLatestBrandsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type NewBrandsQuery = { listLatestBrands: Array<{ id: string, name: string, categories: Array<string>, accountMedia?: { id?: string | null, url?: string | null } | null }> };

export type NewBrandsCategoriesQueryVariables = Exact<{
  filters?: InputMaybe<TradeShowEventBrandFilter>;
}>;


export type NewBrandsCategoriesQuery = { public: { tradeShowBrandsCategories: { edges?: Array<{ node: { id: string, name: string } }> | null } } };

export type RetailerCenterAccountConnectionStatusesQueryVariables = Exact<{
  filter?: InputMaybe<AccountConnectionStatusFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AccountConnectionStatusOrderBy>;
}>;


export type RetailerCenterAccountConnectionStatusesQuery = { accountConnectionStatuses: Array<{ accountId: string, status: Status, brandProfile: { brandId: string, name?: string | null, productLines: Array<string>, accountMedia?: { id?: string | null, url?: string | null } | null } }> };

export type DataActivityCenterQueryQueryVariables = Exact<{
  input: ListMonitoringJobsRequest;
}>;


export type DataActivityCenterQueryQuery = { listMonitoringJobs: { jobs?: Array<{ id: string, jobId: string, status: JobStatus, type: JobType, inputFileUrl: string, inputData?: any | null, outputData?: any | null, errorDetails?: any | null, createdAt?: any | null, updatedAt?: any | null, user?: { id: string, email?: string | null } | null }> | null } };

export type ShippingReportFeatureQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ShippingReportFeatureQuery = { shippingReportFeature?: boolean | null };

export type CompleteShopifyInstallationForEmbeddedAppsMutationVariables = Exact<{
  input: CompleteShopifyInstallationForEmbeddedAppsInput;
}>;


export type CompleteShopifyInstallationForEmbeddedAppsMutation = { completeShopifyInstallationForEmbeddedApps: { success: boolean } };

export type UpdateShopifyBrandSyncSettingsMutationVariables = Exact<{
  shopifySyncSettingsInput: UpdateShopifyBrandSyncSettingsInput;
}>;


export type UpdateShopifyBrandSyncSettingsMutation = { updateShopifyBrandSyncSettings: { __typename: 'ShopifyBrandSyncSettings', id: string, storeId: string, retailPriceMultiplier?: string | null, wholesalePriceMultiplier?: string | null, lastFullSyncAt?: any | null, canPerformFullSync?: boolean | null } };

export type GetBrandShopifyIntegrationQueryVariables = Exact<{
  accountId: Scalars['ID'];
  appName: ShopifyAppName;
}>;


export type GetBrandShopifyIntegrationQuery = { shopifyIntegrations?: Array<{ __typename: 'BrandShopifyIntegration', id: string, shopUrl: string, shopName: string, lastSyncDate?: any | null, isSubscriptionActive: boolean, isInstalled: boolean, syncSettings?: { id: string, accountId: string, storeId: string, canPerformFullSync?: boolean | null, lastFullSyncAt?: any | null, retailPriceMultiplier?: string | null, wholesalePriceMultiplier?: string | null } | null, linkedAccounts: Array<{ id: string, isEnabled: boolean, accountId: string }> } | { __typename: 'RetailerShopifyProductSync', id: string, shopUrl: string, shopName: string, lastSyncDate?: any | null, isSubscriptionActive: boolean, isInstalled: boolean, linkedAccounts: Array<{ id: string, isEnabled: boolean, accountId: string }> }> | null };

export type CompleteShopifyInstallationMutationVariables = Exact<{
  input: CompleteShopifyInstallationInput;
}>;


export type CompleteShopifyInstallationMutation = { completeShopifyInstallation: { success: boolean, shopifyIntegrations?: Array<{ shopUrl: string } | { shopUrl: string }> | null } };

export type UpdateShopifyRetailerSyncSettingsMutationVariables = Exact<{
  input: ShopifyRetailerProductSyncSettingsInput;
}>;


export type UpdateShopifyRetailerSyncSettingsMutation = { updateRetailerShopifyProductSyncSettings?: Array<{ id: string, accountStoreSettings: Array<{ id: string, accountId: string, syncSettings?: { id: string, autoSyncProducts: boolean, syncStyleName: boolean, syncStyleDescription: boolean, syncMedia: boolean, syncCategory: boolean, syncLinesheet: boolean, syncSilhouette: boolean, syncBrandName: boolean, syncBrandNameStyleName: boolean, syncRetailPrice: boolean, syncSkuPrices: boolean, syncSkuCode: boolean, syncUpcCode: boolean } | null }>, activeAccountStore?: { id: string, syncSettings?: { id: string, autoSyncProducts: boolean, syncStyleName: boolean, syncStyleDescription: boolean, syncMedia: boolean, syncCategory: boolean, syncLinesheet: boolean, syncSilhouette: boolean, syncBrandName: boolean, syncBrandNameStyleName: boolean, syncRetailPrice: boolean, syncSkuPrices: boolean, syncSkuCode: boolean, syncUpcCode: boolean } | null } | null }> | null };

export type GetRetailerShopifyProductSyncQueryVariables = Exact<{
  accountId: Scalars['ID'];
  appName: ShopifyAppName;
}>;


export type GetRetailerShopifyProductSyncQuery = { shopifyIntegrations?: Array<{ __typename: 'BrandShopifyIntegration', id: string, shopUrl: string, shopName: string, lastSyncDate?: any | null, isSubscriptionActive: boolean, isInstalled: boolean, linkedAccounts: Array<{ id: string, isEnabled: boolean, accountId: string }> } | { __typename: 'RetailerShopifyProductSync', id: string, shopUrl: string, shopName: string, lastSyncDate?: any | null, isSubscriptionActive: boolean, isInstalled: boolean, accountStoreSettings: Array<{ id: string, accountId: string, syncSettings?: { id: string, autoSyncProducts: boolean, syncStyleName: boolean, syncStyleDescription: boolean, syncMedia: boolean, syncCategory: boolean, syncLinesheet: boolean, syncSilhouette: boolean, syncBrandName: boolean, syncBrandNameStyleName: boolean, syncRetailPrice: boolean, syncSkuPrices: boolean, syncSkuCode: boolean, syncUpcCode: boolean } | null }>, activeAccountStore?: { id: string, accountId: string, styleSyncErrors: Array<{ id: string, errorMessage?: string | null, createdDate?: any | null, product: { id: string, externalIdentifier: string, name: string }, sku?: { color: { id: string, name: string, code: string }, size: { id: string, name: string, code: string } } | null }> } | null, linkedAccounts: Array<{ id: string, isEnabled: boolean, accountId: string }> }> | null };

export type EligibleAccountsToLinkToShopifyStoreQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibleAccountsToLinkToShopifyStoreQuery = { eligibleAccountsToLinkToShopifyStore: Array<{ id: string, isSelected: boolean, account: { id: string, isPrimary?: boolean | null, isPublic?: boolean | null, name: string, privacy?: boolean | null, createdAt?: any | null, accountCreationSource?: { id: string, requestedByAccount: { id: string, name?: string | null } } | null, brands: { edges: Array<{ id: string, profileName?: string | null, node?: { id: string } | null }> } } }> };

export type SyncShopifyOrderStylesMutationVariables = Exact<{
  syncShopifyOrderStylesInput: SyncShopifyOrderStylesInput;
}>;


export type SyncShopifyOrderStylesMutation = { syncShopifyOrderStyles: { jobIds?: Array<string> | null } };

export type StartShopifyInstallationMutationVariables = Exact<{
  input: StartShopifyInstallationInput;
}>;


export type StartShopifyInstallationMutation = { public: { startShopifyInstallation: { redirectUrl?: string | null } } };

export type UpdateAccountsLinkToStoreMutationVariables = Exact<{
  input: updateAccountsLinkedToStoreInput;
}>;


export type UpdateAccountsLinkToStoreMutation = { updateAccountsLinkedToStore: { id: string, shopUrl: string, shopName: string, linkedAccounts: Array<{ isEnabled: boolean, accountId: string }> } | { id: string, shopUrl: string, shopName: string, linkedAccounts: Array<{ isEnabled: boolean, accountId: string }> } };

export type CancelShopifySubscriptionMutationVariables = Exact<{
  input: AppSubscriptionCancelInput;
}>;


export type CancelShopifySubscriptionMutation = { appSubscriptionCancel: { success: boolean } };

export type favoritedBrandsByRetailAccountUserQueryVariables = Exact<{ [key: string]: never; }>;


export type favoritedBrandsByRetailAccountUserQuery = { favoritedBrandsByRetailAccountUser: Array<{ id: string }> };

export type deleteFavoriteAccountDupe2MutationVariables = Exact<{
  input: DeleteFavoriteAccountInput;
}>;


export type deleteFavoriteAccountDupe2Mutation = { deleteFavoriteAccount?: { success?: boolean | null } | null };

export type createFavoriteAccountDupe2MutationVariables = Exact<{
  input: AddFavoriteAccountInput;
}>;


export type createFavoriteAccountDupe2Mutation = { createFavoriteAccount: { id: string, brandAccountId: string } };

export type BrandProductLinesQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandProductLinesQuery = { brandProductLines: Array<{ id: string, name: string, active: boolean }> };

export type UpsertBrandProfileMutationDupe1MutationVariables = Exact<{
  input: UpsertBrandProfileInput;
}>;


export type UpsertBrandProfileMutationDupe1Mutation = { upsertBrandProfile: { id: string, name?: string | null, description?: string | null, yearEstablished?: number | null, productLines: Array<string>, wholesaleMin?: number | null, wholesaleMax?: number | null, retailMin?: number | null, retailMax?: number | null, websiteUrl?: string | null, customUrlHandle?: string | null, logoId?: string | null, logoUrl?: string | null, ipadPhotoId?: string | null, ipadPhotoUrl?: string | null, socialMediaAccounts: Array<{ socialMediaType?: SocialMediaType | null, url?: string | null }>, accountMedia?: { id?: string | null, url?: string | null } | null } };

export type bulkUpdateMutationVariables = Exact<{
  input: BulkUpdateStorefrontsInput;
}>;


export type bulkUpdateMutation = { bulkUpdateStorefronts: Array<{ id: string, uniqueName: string, displayName: string, orderNbr: number, isOnline: boolean, isHome: boolean, modified: any, statusSince: any }> };

export type BulkDeleteStorefrontMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type BulkDeleteStorefrontMutation = { deleteStorefronts: { success: boolean, error?: string | null } };

export type storefrontFragmentFragment = { id: string, brandId: string, isOnline: boolean, modified: any, isHome: boolean, orderNbr: number, displayName: string, uniqueName: string, statusSince: any, rows: { edges?: Array<{ node?: { id: string, title?: string | null, template: string, orderNbr: number, elements: Array<{ settings: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, collectionTitle: string, coverUrl?: string | null, coverId?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageId: string, imageUrl: string, imageExternalLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageUrls: Array<string | null>, instagramAuthId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { lookbookId: string, lookbookTitle: string, lookbookUrl: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { externalVideoId?: string | null, externalVideoLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, productId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomBrandId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomCollectionId: string, showroomCollectionTitle: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { content: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { videoId?: string | null, videoUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null }> } | null }> | null }, textStyles?: Array<{ id: string, name: string, typeface: string, weight: string, size: string, orderNbr: number }> | null };

export type storefrontsQueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<StorefrontFilters>;
}>;


export type storefrontsQuery = { storefronts: Array<{ id: string, brandId: string, isOnline: boolean, modified: any, isHome: boolean, orderNbr: number, displayName: string, uniqueName: string, statusSince: any, rows: { edges?: Array<{ node?: { id: string, title?: string | null, template: string, orderNbr: number, elements: Array<{ settings: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, collectionTitle: string, coverUrl?: string | null, coverId?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageId: string, imageUrl: string, imageExternalLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageUrls: Array<string | null>, instagramAuthId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { lookbookId: string, lookbookTitle: string, lookbookUrl: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { externalVideoId?: string | null, externalVideoLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, productId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomBrandId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomCollectionId: string, showroomCollectionTitle: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { content: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { videoId?: string | null, videoUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null }> } | null }> | null }, textStyles?: Array<{ id: string, name: string, typeface: string, weight: string, size: string, orderNbr: number }> | null }> };

export type PublicStorefrontQueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<StorefrontFilters>;
}>;


export type PublicStorefrontQuery = { public: { storefronts: Array<{ id: string, brandId: string, isOnline: boolean, modified: any, isHome: boolean, orderNbr: number, displayName: string, uniqueName: string, statusSince: any, rows: { edges?: Array<{ node?: { id: string, title?: string | null, template: string, orderNbr: number, elements: Array<{ settings: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, collectionTitle: string, coverUrl?: string | null, coverId?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageId: string, imageUrl: string, imageExternalLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageUrls: Array<string | null>, instagramAuthId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { lookbookId: string, lookbookTitle: string, lookbookUrl: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { externalVideoId?: string | null, externalVideoLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, productId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomBrandId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomCollectionId: string, showroomCollectionTitle: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { content: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { videoId?: string | null, videoUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null }> } | null }> | null }, textStyles?: Array<{ id: string, name: string, typeface: string, weight: string, size: string, orderNbr: number }> | null }> } };

export type AccountConnectionStatusesQueryVariables = Exact<{
  accountId: Scalars['ID'];
  otherAccountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AccountConnectionStatusesQuery = { accountConnectionStatuses: Array<{ accountId: string, otherAccountId: string, status: Status }> };

export type PublicBrandProfileQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PublicBrandProfileQuery = { public: { brandProfiles: { edges: Array<{ node?: { id: string, isLiteBrand?: boolean | null, name?: string | null } | null }> } } };

export type storefrontNavigationAsBrandQueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<StorefrontFilters>;
}>;


export type storefrontNavigationAsBrandQuery = { storefronts: Array<{ id: string, uniqueName: string, displayName: string, orderNbr: number, isOnline: boolean, isHome: boolean }> };

export type publicStorefrontNavigationAsBrandQueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<StorefrontFilters>;
}>;


export type publicStorefrontNavigationAsBrandQuery = { public: { storefronts: Array<{ id: string, uniqueName: string, displayName: string, orderNbr: number, isOnline: boolean, isHome: boolean }> } };

export type UpsertStorefrontMutationVariables = Exact<{
  input: UpsertStorefrontInput;
}>;


export type UpsertStorefrontMutation = { upsertStorefront: { id: string, brandId: string, isOnline: boolean, modified: any, isHome: boolean, displayName: string, uniqueName: string, orderNbr: number, statusSince: any, rows: { edges?: Array<{ node?: { id: string, title?: string | null, template: string, orderNbr: number, elements: Array<{ settings: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { id: string, orderNbr: number, elementType: ElementType, collectionId: string, collectionTitle: string, coverUrl?: string | null, coverId?: string | null, presentation?: string | null } | { imageId: string, imageUrl: string, imageExternalLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { imageUrls: Array<string | null>, instagramAuthId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { lookbookId: string, lookbookTitle: string, lookbookUrl: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { externalVideoId?: string | null, externalVideoLink?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { collectionId: string, productId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomBrandId: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { showroomCollectionId: string, showroomCollectionTitle: string, coverId?: string | null, coverUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { content: string, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null } | { videoId?: string | null, videoUrl?: string | null, id: string, orderNbr: number, elementType: ElementType, presentation?: string | null }> } | null }> | null } } };

export type UpsertTextStylesMutationMutationVariables = Exact<{
  input: UpsertStorefrontTextStylesInput;
}>;


export type UpsertTextStylesMutationMutation = { upsertStorefrontTextStyles: Array<{ id: string, name: string, weight: string, size: string, typeface: string, orderNbr: number }> };

export type UpsertBrandProfileMutationDupe2MutationVariables = Exact<{
  input: UpsertBrandProfileInput;
}>;


export type UpsertBrandProfileMutationDupe2Mutation = { upsertBrandProfile: { id: string, name?: string | null, description?: string | null, yearEstablished?: number | null, productLines: Array<string>, wholesaleMin?: number | null, wholesaleMax?: number | null, retailMin?: number | null, retailMax?: number | null, websiteUrl?: string | null, customUrlHandle?: string | null, logoId?: string | null, logoUrl?: string | null, socialMediaAccounts: Array<{ socialMediaType?: SocialMediaType | null, url?: string | null }>, accountMedia?: { id?: string | null, url?: string | null } | null } };

export type collectionProductsQueryDupe2QueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  externalMediaEnabled: Scalars['Boolean'];
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type collectionProductsQueryDupe2Query = { collectionProducts: { edges: Array<{ node: { id: string, priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string }, retailCurrency: { id: string, code: string } } }> }, product: { id: string, name: string, images: Array<{ url?: string | null }>, externalMedia?: Array<{ id: string, thumbnailUrl: string, type: string }> }, collection: { id: string, name: string }, variants: { edges: Array<{ node: { id: string, code: string }, values: { edges?: Array<{ node?: { id: string, value: string, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, swatchImage?: { url: any } | null, merchandiseImages?: Array<{ url: any }> | null } | null } | null }> | null } }> } } }> } };

export type collectionProductsQueryDupe3QueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type collectionProductsQueryDupe3Query = { collectionProducts: { edges: Array<{ node: { id: string, collection: { id: string, visibility?: CollectionVisibility | null } } }> } };

export type PublicCollectionsQueryDupe1QueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<PublicCollectionsFilter>;
}>;


export type PublicCollectionsQueryDupe1Query = { public: { collections: Array<{ id: string, name: string, products: Array<{ id: string, name: string, images: Array<{ id?: string | null, url?: string | null }>, externalMedia: Array<{ id: string, thumbnailUrl: string, type: string }>, variants: { colors: Array<{ id: string, name: string, image?: { id?: string | null, url?: string | null } | null, swatch: { hexColor: string, image?: { id?: string | null, url?: string | null } | null } }> } }> }> } };

export type CollectionsQueryDupe4QueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type CollectionsQueryDupe4Query = { collections: { edges: Array<{ node: { id: string, name: string, visibility?: CollectionVisibility | null } } | null> } };

export type brandProfilesQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type brandProfilesQuery = { brandProfiles: { edges: Array<{ node?: { id: string, isLiteBrand?: boolean | null, name?: string | null, description?: string | null, yearEstablished?: number | null, productLines: Array<string>, wholesaleMin?: number | null, wholesaleMax?: number | null, retailMin?: number | null, retailMax?: number | null, websiteUrl?: string | null, customUrlHandle?: string | null, logoId?: string | null, logoUrl?: string | null, ipadPhotoId?: string | null, ipadPhotoUrl?: string | null, socialMediaAccounts: Array<{ url?: string | null, socialMediaType?: SocialMediaType | null }>, accountMedia?: { id?: string | null, url?: string | null, mediaType?: MediaType | null } | null } | null } | null> } };

export type PublicBrandProfilesQueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PublicBrandProfilesQuery = { public: { brandProfiles: { edges: Array<{ node?: { id: string, isLiteBrand?: boolean | null, name?: string | null, description?: string | null, yearEstablished?: number | null, productLines: Array<string>, wholesaleMin?: number | null, wholesaleMax?: number | null, retailMin?: number | null, retailMax?: number | null, websiteUrl?: string | null, customUrlHandle?: string | null, logoId?: string | null, logoUrl?: string | null, socialMediaAccounts: Array<{ url?: string | null, socialMediaType?: SocialMediaType | null }>, accountMedia?: { id?: string | null, url?: string | null, mediaType?: MediaType | null } | null } | null }> } } };

export type ShowroomCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowroomCollectionsQuery = { showroomCollections: { edges: Array<{ node: { id: string, name: string, visibleToAllConnected: boolean } }> } };

export type PriceTypesQueryDupe2QueryVariables = Exact<{
  brandIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PriceTypesQueryDupe2Query = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string }, retailCurrency: { id: string, code: string } } }> } };

export type instagramAccountsQueryVariables = Exact<{
  filters?: InputMaybe<InstagramAccountFilters>;
}>;


export type instagramAccountsQuery = { instagramAccounts: Array<{ userId: string, userName: string, expiresAt: any, brandId: string, id: string }> };

export type instagramImagesQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type instagramImagesQuery = { instagramAccountImages: Array<{ imageUrls: Array<string> }> };

export type BrandCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandCategoriesQuery = { categories: { __typename: 'CategoryConnection', edges: Array<{ node: { parentName?: string | null, name: string, id?: string | null, department?: string | null } }> } };

export type BrandSeasonsQueryVariables = Exact<{
  brandAccountIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type BrandSeasonsQuery = { brands: { edges: Array<{ node?: { id: string, seasons: { edges: Array<{ node: { id: string, name: string } }> } } | null }> } };

export type ValidateStyleImportFileMutationMutationVariables = Exact<{
  filePath: Scalars['String'];
}>;


export type ValidateStyleImportFileMutationMutation = { validateStyleImportFile: { validationResult?: { newStylesCount: number, updatedStylesCount: number, invalidStylesCount: number, hasCategoryColumns: boolean, validationErrors: Array<{ rowNumber: number, styleNumber: string, field: string, errorCode: ValidationErrorCode, errorDetails?: any | null }> } | null, error?: { code: GenericStyleImportErrorCode } | null } };

export type UploadStyleImportFileMutationMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadStyleImportFileMutationMutation = { uploadStyleImportFile: { filePath?: string | null } };

export type BulkStyleImportMutationMutationVariables = Exact<{
  filePath: Scalars['String'];
  categoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  categoryOption?: InputMaybe<CategoryOptions>;
  isNewCollection?: InputMaybe<Scalars['Boolean']>;
}>;


export type BulkStyleImportMutationMutation = { bulkStyleImport: { error?: { code: GenericStyleImportErrorCode } | null } };

export type BulkCreateLinesheetsMutationVariables = Exact<{
  input: BulkCreateCollectionsInput;
}>;


export type BulkCreateLinesheetsMutation = { bulkCreateCollections: { collections?: Array<{ id: string }> | null } };

export type GenerateBSUTemplateMutationVariables = Exact<{
  input: GenerateBSUTemplateInput;
}>;


export type GenerateBSUTemplateMutation = { generateBSUTemplate: { bsuTemplateFileUrl: string } };

export type StylesDataQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchText?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<ProductOrderByInput>;
}>;


export type StylesDataQuery = { products: { totalCount?: number | null, edges: Array<{ node: { id: string, name: string, externalIdentifier: string, modified?: any | null, collections: Array<{ id: string, name: string }>, mainImage?: { url?: string | null } | null, categories: { edges: Array<{ node: { name: string } }> }, traitValues: { edges: Array<{ node: { id: string, value: string, externalIdentifier: string, trait: { code: string } } }> }, variants: { edges: Array<{ node: { code: string, id: string }, values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { code: string, name: string }, displayDetails?: { hexColor?: string | null, swatchImage?: { url: any } | null } | null } | null }> | null } }> } } }> } };

export type CreateCustomerPortalLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCustomerPortalLinkMutation = { createCustomerPortalLink: string };

export type CreateStripeProductLinkMutationVariables = Exact<{
  priceId: Scalars['String'];
  returnUrl?: InputMaybe<Scalars['String']>;
}>;


export type CreateStripeProductLinkMutation = { createStripeProductLink: string };

export type PremiumFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type PremiumFeaturesQuery = { premiumFeatures?: Array<{ id: string, name: string, description?: string | null, internalUrl: string, marketingUrl?: string | null, image?: string | null, groupId?: string | null, groupLevel?: number | null, openTrialDaysRemaining?: number | null, prices?: Array<{ id: string, amount: string, frequency: string, trialDays?: number | null }> | null, subscriptions: Array<{ id: string, priceId: string, accountAccessCount: number, expiryDate: any, startDate?: any | null, frequency: string, status: SubscriptionStatus, isOwner: boolean, isTrial: boolean }> }> | null };

export type AssignStyleColorSwatchMutationVariables = Exact<{
  colorName: Scalars['String'];
  colorCode: Scalars['String'];
  styleIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  hexCode?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['ID']>;
  revert?: InputMaybe<Scalars['Boolean']>;
}>;


export type AssignStyleColorSwatchMutation = { assignStyleColorSwatch: { errorCode?: string | null } };

export type LinesheetsForSeasonQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type LinesheetsForSeasonQuery = { collections: { edges: Array<{ node: { id: string, name: string, created?: any | null, season?: { id: string, name: string, year?: number | null, code: string } | null } } | null> } };

export type ListAccountColorSwatchesQueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
  seasonIds: Array<Scalars['ID']> | Scalars['ID'];
  startRow?: InputMaybe<Scalars['Int']>;
  endRow?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ListAccountColorSwatchesOrderBy>;
  filterBy?: InputMaybe<ListAccountColorSwatchesFilterBy>;
}>;


export type ListAccountColorSwatchesQuery = { listAccountColorSwatches: { colorSwatches: Array<{ colorSwatchId: string, stylesMissingSwatch: boolean, colorName: string, colorCode: string, stylesCount: number, swatches?: Array<{ hexCode?: string | null, image?: { id?: string | null, fileName?: string | null, url?: string | null } | null }> | null }> } };

export type ListStylesColorSwatchQueryVariables = Exact<{
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  seasonIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  colorName: Scalars['String'];
  colorCode: Scalars['String'];
  startRow?: InputMaybe<Scalars['Int']>;
  endRow?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ListStylesColorSwatchOrderBy>;
}>;


export type ListStylesColorSwatchQuery = { listStylesColorSwatch: { stylesColorSwatch: Array<{ styleId: string, styleName: string, styleNumber: string, active?: boolean | null, styleColorImage?: { id?: string | null, fileName?: string | null, url?: string | null } | null, styleColorSwatch?: { hexCode?: string | null, image?: { id?: string | null, fileName?: string | null, url?: string | null } | null } | null }> } };

export type SwatchListImageSelectorQueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
  seasonIds: Array<Scalars['ID']> | Scalars['ID'];
  styleIds: Array<Scalars['ID']> | Scalars['ID'];
  colorName?: InputMaybe<Scalars['String']>;
  colorCode?: InputMaybe<Scalars['String']>;
  startRow?: InputMaybe<Scalars['Int']>;
  endRow?: InputMaybe<Scalars['Int']>;
  fileName?: InputMaybe<Scalars['String']>;
}>;


export type SwatchListImageSelectorQuery = { swatchListImageSelector: { images: Array<{ id?: string | null, fileName?: string | null, url?: string | null, level?: string | null }> } };

export type SwatchListImageSelectorTotalQueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
  seasonIds: Array<Scalars['ID']> | Scalars['ID'];
  styleIds: Array<Scalars['ID']> | Scalars['ID'];
  colorName?: InputMaybe<Scalars['String']>;
  colorCode?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
}>;


export type SwatchListImageSelectorTotalQuery = { swatchListImageSelector: { totalCount?: number | null } };

export type BrandAllImagesTotalCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BrandAllImagesTotalCountQuery = { brandMedia: { totalCount?: number | null } };

export type BrandAllImagesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type BrandAllImagesQuery = { brandMedia: { media: Array<{ url?: string | null, id?: string | null, fileName?: string | null, urlThumbnail?: string | null }> } };

export type BulkCopyAccountUserGeoRestrictionsMutationVariables = Exact<{
  input: UpdateAccountUserGeoRestrictionsInput;
}>;


export type BulkCopyAccountUserGeoRestrictionsMutation = { updateAccountUserGeoRestrictions: { success: boolean } };

export type BulkCopyAccountUsersPermissionAccessMutationVariables = Exact<{
  input: UpdateAccountUsersPermissionAccessInput;
}>;


export type BulkCopyAccountUsersPermissionAccessMutation = { updateAccountUsersPermissionAccess: { success: boolean } };

export type BulkCopyPermissionsAccountUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type BulkCopyPermissionsAccountUsersQuery = { activeViewingAccount: { id: string, accountUsers: { edges: Array<{ node: { id: string, displayName?: string | null, displayCode?: string | null, active?: boolean | null, userType: AccountUserType, user: { id: string, email?: string | null } } }> } } };

export type AccountUserPermissionAccessBulkCopyQueryVariables = Exact<{
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AccountUserPermissionAccessBulkCopyQuery = { accountUserPermissionAccess: { edges: Array<{ node: { id: string } }> } };

export type AccountUserGeoRestrictionsBulkCopyQueryVariables = Exact<{
  accountId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type AccountUserGeoRestrictionsBulkCopyQuery = { accountUserGeoRestrictions: { id: string, regionAssignedOverride: boolean, regions: { edges: Array<{ node: { id: string, name: string } }> }, exceptionAccounts: Array<{ name: string, id: string }>, possibleExceptionAccounts: Array<{ name: string, id: string }> } };

export type UpdateAccountUserMutationMutationVariables = Exact<{
  input: UpdateAccountsUsersInput;
}>;


export type UpdateAccountUserMutationMutation = { updateAccountsUsers: { accountsUsersIds: Array<string> } };

export type CreateAccountUserMutationMutationVariables = Exact<{
  input: CreateAccountUserInput;
}>;


export type CreateAccountUserMutationMutation = { createAccountUser: { accountUserId: string, userId: string } };

export type UpdateAccountUserStatusMutationMutationVariables = Exact<{
  input: UpdateAccountUserStatusInput;
}>;


export type UpdateAccountUserStatusMutationMutation = { updateAccountUserStatus: { accountsUsersIds: Array<string> } };

export type InviteEmailTriggerMutationMutationVariables = Exact<{
  input: InviteEmailTriggerInput;
}>;


export type InviteEmailTriggerMutationMutation = { inviteEmailTrigger: { success: boolean } };

export type UserManagementAccountUsersQueryVariables = Exact<{
  viewingUserSeesInternal?: InputMaybe<Scalars['Boolean']>;
}>;


export type UserManagementAccountUsersQuery = { activeViewingAccount: { id: string, accountUsers: { edges: Array<{ node: { id: string, displayName?: string | null, displayCode?: string | null, active?: boolean | null, lastLogin?: any | null, orderCC?: Array<string> | null, created?: any | null, updated?: any | null, userType: AccountUserType, lastDateAdded?: any | null, lastDateRemoved?: any | null, numberConnections?: number | null, user: { id: string, email?: string | null }, dataPermissionConfiguration?: { id: string, name: string } | null, regions: { edges: Array<{ node: { id: string, name: string } }> } } }> } } };

export type GetOrganizationQueryVariables = Exact<{
  accountID: Scalars['ID'];
}>;


export type GetOrganizationQuery = { organization?: { id: string, contractedSeats?: number | null, activeSeats?: number | null, name: string, accountOrganizations: { edges: Array<{ node: { id: string, accountId: string, accountName?: string | null, activeSeats?: number | null } }> } } | null };

export type CheckUserInOrganizationQueryVariables = Exact<{
  accountId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type CheckUserInOrganizationQuery = { checkUserInOrganization: { isInOrganization: boolean, isActive: boolean } };

export type VisualAssortmentCardFieldsFragment = { id: string, cardUuid: string, groupedSourceCardIds: Array<string>, orderNbr: number, source: VisualAssortmentCardSource, brandName: string, productName: string, productNumber: string, quantity: number, visualAssortmentMonth?: string | null, customDescription?: string | null, receivedAt?: any | null, productImage?: { id: string, url: string } | null, wholesalePrice: { currency?: string | null, price?: string | null }, retailPrice: { currency?: string | null, price?: string | null }, visualAssortmentGroup?: { id: string, name: string, orderNbr: number, subGroup?: { id: string, name: string, orderNbr: number } | null } | null, visualAssortmentCategory?: { id: string, name: string } | null, visualAssortmentColor?: { id: string, name: string, hexCode?: string | null } | null, orderSourceData: Array<{ id: string, orderNumber: string }>, sizes: Array<{ sizeName: string, quantity: number }>, attributes: Array<{ key: { id: string, name: string }, values: Array<{ id: string, name: string, orderNbr: number }> }> };

export type VisualAssortmentAttributeKeyFieldsFragment = { id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> };

export type VisualAssortmentGroupFieldsFragment = { id: string, name: string, orderNbr: number, maxCardOrderNbr: number, subgroups?: { edges: Array<{ node: { id: string, name: string, orderNbr: number, maxCardOrderNbr: number } }> } | null };

export type VisualAssortmentBudgetFieldsFragment = { id: string, currency: string, attributeFilterId?: string | null, groupings: Array<{ groupBy: VisualAssortmentGroupByOption, attributeKey?: { id: string } | null }> };

export type BudgetViewFieldsFragment = { budgetId: string, totals: { id: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number }, groups: { edges: Array<{ node: { id: string, groupBy: VisualAssortmentGroupByOption, value: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number, children: { edges: Array<{ node: { id: string, groupBy: VisualAssortmentGroupByOption, value: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number } }> } } }> } };

export type VisualAssortmentLimitFieldsFragment = { maxUsers?: number | null, maxDoors?: number | null, maxSeasons?: number | null, maxProducts?: number | null, maxCustomAttributes?: number | null, maxCustomAttributeValues?: number | null, maxGroupingLevels?: number | null, dataStorageYears?: number | null, budgetsEnabled?: boolean | null, customProductsEnabled?: boolean | null, productDetailEditingEnabled?: boolean | null, filtersEnabled?: boolean | null, exportsEnabled?: boolean | null };

export type VABudgetsViewsQueryVariables = Exact<{ [key: string]: never; }>;


export type VABudgetsViewsQuery = { visualAssortments: Array<{ id: string, budgets: { edges: Array<{ node: { id: string, budgetView: { budgetId: string, totals: { id: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number }, groups: { edges: Array<{ node: { id: string, groupBy: VisualAssortmentGroupByOption, value: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number, children: { edges: Array<{ node: { id: string, groupBy: VisualAssortmentGroupByOption, value: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number } }> } } }> } }, cardFieldsCount: { missingBrand: number, missingCategory: number, missingColor: number, missingCost: number, missingDeliveryMonth: number, missingDoor: number, missingPrice: number, missingWholesaleCurrency: number, missingRetailCurrency: number } } }> } }> };

export type AddOrdersToVisualAssortmentMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddOrdersToVisualAssortmentMutation = { addOrdersToVisualAssortment: { addedOrderIds: Array<string>, existingOrderIds: Array<string> } };

export type SyncVisualAssortmentOrdersMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SyncVisualAssortmentOrdersMutation = { syncVisualAssortmentOrders: { syncedOrderIds: Array<string> } };

export type DeleteVisualAssortmentCardsMutationVariables = Exact<{
  cardIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteVisualAssortmentCardsMutation = { deleteVisualAssortmentCards: { deletedCardIds: Array<string>, versionDelta: { oldVersion: number, newVersion: number } } };

export type UpdateVAAccountsMutationVariables = Exact<{
  accountIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateVAAccountsMutation = { updateAccountsForVisualAssortment: { success: boolean } };

export type SetVADefaultGroupingMutationVariables = Exact<{
  groups: Array<VisualAssortmentGroupingByInput> | VisualAssortmentGroupingByInput;
}>;


export type SetVADefaultGroupingMutation = { setVisualAssortmentDefaultGrouping: { success: boolean, versionDelta: { oldVersion: number, newVersion: number } } };

export type EditVisualAssortmentCardsMutationVariables = Exact<{
  visualAssortmentId: Scalars['ID'];
  cardsToEdit: Array<VisualAssortmentCardsToEdit> | VisualAssortmentCardsToEdit;
}>;


export type EditVisualAssortmentCardsMutation = { editVisualAssortmentCards: { cards: { edges: Array<{ node: { id: string, cardUuid: string, groupedSourceCardIds: Array<string>, orderNbr: number, source: VisualAssortmentCardSource, brandName: string, productName: string, productNumber: string, quantity: number, visualAssortmentMonth?: string | null, customDescription?: string | null, receivedAt?: any | null, productImage?: { id: string, url: string } | null, wholesalePrice: { currency?: string | null, price?: string | null }, retailPrice: { currency?: string | null, price?: string | null }, visualAssortmentGroup?: { id: string, name: string, orderNbr: number, subGroup?: { id: string, name: string, orderNbr: number } | null } | null, visualAssortmentCategory?: { id: string, name: string } | null, visualAssortmentColor?: { id: string, name: string, hexCode?: string | null } | null, orderSourceData: Array<{ id: string, orderNumber: string }>, sizes: Array<{ sizeName: string, quantity: number }>, attributes: Array<{ key: { id: string, name: string }, values: Array<{ id: string, name: string, orderNbr: number }> }> } }> }, versionDelta: { newVersion: number, oldVersion: number } } };

export type CreateCustomProductsFromSheetMutationVariables = Exact<{
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
  sheet: Scalars['Upload'];
}>;


export type CreateCustomProductsFromSheetMutation = { createCustomProductsFromSheet?: { jobId: string } | null };

export type DownloadCustomProductsSheetTemplateMutationVariables = Exact<{
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
}>;


export type DownloadCustomProductsSheetTemplateMutation = { downloadCustomProductsSheetTemplate: { customProductsSheetUrl: string } };

export type AsyncAddOrdersToVisualAssortmentMutationVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  visualAssortmentId?: InputMaybe<Scalars['ID']>;
}>;


export type AsyncAddOrdersToVisualAssortmentMutation = { asyncAddOrdersToVisualAssortment: { jobId: string } };

export type UploadImageToVisualAssortmentCardMutationVariables = Exact<{
  cardUuid: Scalars['ID'];
  visualAssortmentId: Scalars['ID'];
  image: Scalars['Upload'];
}>;


export type UploadImageToVisualAssortmentCardMutation = { uploadImageToVisualAssortmentCard: { card: { id: string, productName: string, productImage?: { id: string, url: string } | null }, versionDelta: { newVersion: number, oldVersion: number } } };

export type CreateVAAttributeValuesMutationVariables = Exact<{
  attributeValues: Array<VisualAssortmentAttributeValueInput> | VisualAssortmentAttributeValueInput;
}>;


export type CreateVAAttributeValuesMutation = { createVisualAssortmentAttributeValues: { visualAssortmentAttributeKeys: Array<{ id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> }> } };

export type UpdateVAAttributeValuesMutationVariables = Exact<{
  attributeValues: Array<VisualAssortmentAttributeValueUpdateInput> | VisualAssortmentAttributeValueUpdateInput;
}>;


export type UpdateVAAttributeValuesMutation = { updateVisualAssortmentAttributeValues: { visualAssortmentAttributeKeys: Array<{ id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> }> } };

export type DeleteVAAttributeValuesMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteVAAttributeValuesMutation = { deleteVisualAssortmentAttributeValues: { visualAssortmentAttributeKeys: Array<{ id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> }> } };

export type CreateVAAttributeKeyMutationVariables = Exact<{
  input: CreateVisualAssortmentAttributeKeyInput;
}>;


export type CreateVAAttributeKeyMutation = { createVisualAssortmentAttributeKey: { attributeKey: { id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> } } };

export type UpdateVAAttributeKeyMutationVariables = Exact<{
  input: UpdateVisualAssortmentAttributeKeyInput;
}>;


export type UpdateVAAttributeKeyMutation = { updateVisualAssortmentAttributeKey: { attributeKey: { id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> } } };

export type DeleteVAAttributeKeyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVAAttributeKeyMutation = { deleteVisualAssortmentAttributeKey: { success: boolean } };

export type UpsertVisualAssortmentAccessUsersMutationVariables = Exact<{
  users: Array<VisualAssortmentAccessUserInput> | VisualAssortmentAccessUserInput;
}>;


export type UpsertVisualAssortmentAccessUsersMutation = { upsertVisualAssortmentAccessUsers: { success: boolean } };

export type RemoveVisualAssortmentAccessUsersMutationVariables = Exact<{
  userIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveVisualAssortmentAccessUsersMutation = { removeVisualAssortmentAccessUsers: { success: boolean } };

export type AsyncExportVisualAssortmentPdfMutationVariables = Exact<{
  visualAssortmentId: Scalars['ID'];
}>;


export type AsyncExportVisualAssortmentPdfMutation = { asyncExportVisualAssortmentPdf: { jobId: string } };

export type ExportVisualAssortmentMutationVariables = Exact<{
  visualAssortmentId: Scalars['ID'];
  format?: InputMaybe<ExportFormat>;
}>;


export type ExportVisualAssortmentMutation = { exportVisualAssortment: { downloadUrl: string } };

export type CreateVABudgetMutationVariables = Exact<{
  input: CreateVisualAssortmentBudgetInput;
}>;


export type CreateVABudgetMutation = { createVisualAssortmentBudget: { id: string, currency: string, attributeFilterId?: string | null, groupings: Array<{ groupBy: VisualAssortmentGroupByOption, attributeKey?: { id: string } | null }> } };

export type UpdateVABudgetMutationVariables = Exact<{
  input: UpdateVisualAssortmentBudgetInput;
}>;


export type UpdateVABudgetMutation = { updateVisualAssortmentBudget: { id: string, currency: string, attributeFilterId?: string | null, groupings: Array<{ groupBy: VisualAssortmentGroupByOption, attributeKey?: { id: string } | null }> } };

export type ExportVABudgetMutationVariables = Exact<{
  budgetId: Scalars['ID'];
  format?: InputMaybe<ExportFormat>;
}>;


export type ExportVABudgetMutation = { exportVisualAssortmentBudget: { downloadUrl: string } };

export type UpsertVABudgetRowsMutationVariables = Exact<{
  input: UpsertVisualAssortmentBudgetRowsInput;
}>;


export type UpsertVABudgetRowsMutation = { upsertVisualAssortmentBudgetRows: { budgetId: string, totals: { id: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number }, groups: { edges: Array<{ node: { id: string, groupBy: VisualAssortmentGroupByOption, value: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number, children: { edges: Array<{ node: { id: string, groupBy: VisualAssortmentGroupByOption, value: string, actualCost: string, actualRetail: string, budgetCost: string, budgetRetail: string, margin: string, percentCostSpent: number, percentRetailSpent: number } }> } } }> } } };

export type VisualAssortmentVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type VisualAssortmentVersionQuery = { visualAssortments: Array<{ id: string, version: number }> };

export type VisualAssortmentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type VisualAssortmentGroupsQuery = { visualAssortments: Array<{ id: string, name: string, version: number, groups: { edges: Array<{ node: { id: string, name: string, orderNbr: number, maxCardOrderNbr: number, subgroups?: { edges: Array<{ node: { id: string, name: string, orderNbr: number, maxCardOrderNbr: number } }> } | null } }> } }> };

export type VisualAssortmentQueryVariables = Exact<{
  cardFilters?: InputMaybe<VisualAssortmentCardsFilterInput>;
  cardPagination?: InputMaybe<VisualAssortmentCardsPaginationInput>;
  cardSearch?: InputMaybe<VisualAssortmentCardsSearchInput>;
}>;


export type VisualAssortmentQuery = { visualAssortments: Array<{ id: string, version: number, groupedBy: Array<{ option: VisualAssortmentGroupBy, attributeKey?: { id: string, name: string, active: boolean } | null }>, ordersInSync: Array<{ id: string, orderId: string, addedByAccountId: string, visibility: RetailerAccountVisibility }>, cards: { totalCount: number, pageInfo: { hasNextPage: boolean }, edges: Array<{ node: { id: string, cardUuid: string, groupedSourceCardIds: Array<string>, orderNbr: number, source: VisualAssortmentCardSource, brandName: string, productName: string, productNumber: string, quantity: number, visualAssortmentMonth?: string | null, customDescription?: string | null, receivedAt?: any | null, productImage?: { id: string, url: string } | null, wholesalePrice: { currency?: string | null, price?: string | null }, retailPrice: { currency?: string | null, price?: string | null }, visualAssortmentGroup?: { id: string, name: string, orderNbr: number, subGroup?: { id: string, name: string, orderNbr: number } | null } | null, visualAssortmentCategory?: { id: string, name: string } | null, visualAssortmentColor?: { id: string, name: string, hexCode?: string | null } | null, orderSourceData: Array<{ id: string, orderNumber: string }>, sizes: Array<{ sizeName: string, quantity: number }>, attributes: Array<{ key: { id: string, name: string }, values: Array<{ id: string, name: string, orderNbr: number }> }> } }> } }> };

export type VACardOrdersDetailsQueryVariables = Exact<{
  cardIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type VACardOrdersDetailsQuery = { visualAssortmentCardOrdersDetails: Array<{ id: string, styleColorId: string, orderNumber: string, status: OrderStatus, categories: Array<string>, productCost: any, productRetailCost: any, currencyCode: string, cancelled: boolean, deliveryWindow: { startDate?: any | null, endDate?: any | null }, color: { name: string, hexColor?: string | null, swatchUrl?: string | null }, productSizes: Array<{ name: string, quantity: number }> }> };

export type EligibleOrdersForVAQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<EligibleOrdersFilterInput>;
}>;


export type EligibleOrdersForVAQuery = { eligibleOrdersForVisualAssortments: Array<{ id: string, referenceNumber: string, status: OrderStatus, created: any, brandName: string, collectionName: string, totalProducts: number, totalUnits: number, inAssortment: boolean, lastSeen?: any | null, deliveryWindow: { startDate?: any | null, endDate?: any | null } }> };

export type EligibleAccountsForVisualAssortmentQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibleAccountsForVisualAssortmentQuery = { eligibleAccountsForVisualAssortments: Array<{ id: string, isOwner?: boolean | null, isSelected?: boolean | null, account: { id: string, isPrimary?: boolean | null, isPublic?: boolean | null, name: string, privacy?: boolean | null, createdAt?: any | null, accountCreationSource?: { id: string, requestedByAccount: { id: string, name?: string | null } } | null, brands: { edges: Array<{ id: string, profileName?: string | null, node?: { id: string } | null }> } } }> };

export type EligibleUsersForVisualAssortmentQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibleUsersForVisualAssortmentQuery = { eligibleAccountsForVisualAssortments: Array<{ id: string, isSelected?: boolean | null, account: { id: string, name: string }, eligibleUsers: { edges: Array<{ node: { id: string, user: { id: string, email?: string | null } } }> } }> };

export type VisualAssortmentAccessUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type VisualAssortmentAccessUsersQuery = { visualAssortmentAccessUsers: Array<{ id: string, orderNbr: number, isActiveForAnyAccount: boolean, user?: { id: string, email?: string | null, active: boolean } | null }> };

export type HasVisualAssortmentAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type HasVisualAssortmentAccessQuery = { hasVisualAssortmentAccess: { hasUserAccess: boolean, isAccessInitialized: boolean } };

export type VisualAssortmentOptionsQueryVariables = Exact<{
  visualAssortmentId: Scalars['ID'];
}>;


export type VisualAssortmentOptionsQuery = { visualAssortmentOptions: { brands: Array<string>, categories: Array<{ id: string, name: string }>, colors: Array<{ id: string, name: string, hexCode?: string | null }> } };

export type VisualAssortmentCancelledCardsQueryVariables = Exact<{
  cardFilters?: InputMaybe<VisualAssortmentCardsFilterInput>;
  cardSearch?: InputMaybe<VisualAssortmentCardsSearchInput>;
}>;


export type VisualAssortmentCancelledCardsQuery = { visualAssortments: Array<{ id: string, version: number, cards: { totalCount: number, edges: Array<{ node: { id: string } }> } }> };

export type ListMonitoringVAJobsQueryVariables = Exact<{
  jobIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ListMonitoringVAJobsQuery = { listMonitoringJobs: { jobs?: Array<{ id: string, jobId: string, status: JobStatus, errorDetails?: any | null, outputData?: any | null, type: JobType }> | null } };

export type ListVAAttributeKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ListVAAttributeKeysQuery = { visualAssortmentAttributeKeys: Array<{ id: string, name: string, orderNbr: number, limitCount: number, active: boolean, totalCount: number, limitReached: boolean, attributeValues: Array<{ id: string, name: string, orderNbr: number }> }> };

export type VisualAssortmentLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type VisualAssortmentLimitsQuery = { visualAssortmentLimits: { activePackages: Array<string>, hasCustomAccountLimits: boolean, preview: { available: boolean, active: boolean, endsAt?: any | null, durationDays?: number | null, priceId?: string | null }, packageLimits: { maxUsers?: number | null, maxDoors?: number | null, maxSeasons?: number | null, maxProducts?: number | null, maxCustomAttributes?: number | null, maxCustomAttributeValues?: number | null, maxGroupingLevels?: number | null, dataStorageYears?: number | null, budgetsEnabled?: boolean | null, customProductsEnabled?: boolean | null, productDetailEditingEnabled?: boolean | null, filtersEnabled?: boolean | null, exportsEnabled?: boolean | null }, customAccountLimits: { maxUsers?: number | null, maxDoors?: number | null, maxSeasons?: number | null, maxProducts?: number | null, maxCustomAttributes?: number | null, maxCustomAttributeValues?: number | null, maxGroupingLevels?: number | null, dataStorageYears?: number | null, budgetsEnabled?: boolean | null, customProductsEnabled?: boolean | null, productDetailEditingEnabled?: boolean | null, filtersEnabled?: boolean | null, exportsEnabled?: boolean | null }, effectiveLimits: { maxUsers?: number | null, maxDoors?: number | null, maxSeasons?: number | null, maxProducts?: number | null, maxCustomAttributes?: number | null, maxCustomAttributeValues?: number | null, maxGroupingLevels?: number | null, dataStorageYears?: number | null, budgetsEnabled?: boolean | null, customProductsEnabled?: boolean | null, productDetailEditingEnabled?: boolean | null, filtersEnabled?: boolean | null, exportsEnabled?: boolean | null } } };

export type VABudgetsQueryVariables = Exact<{ [key: string]: never; }>;


export type VABudgetsQuery = { visualAssortments: Array<{ id: string, version: number, budgets: { edges: Array<{ node: { id: string, currency: string, attributeFilterId?: string | null, groupings: Array<{ groupBy: VisualAssortmentGroupByOption, attributeKey?: { id: string } | null }> } }> } }> };

export type VACardFieldsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type VACardFieldsCountQuery = { visualAssortments: Array<{ id: string, version: number, visualAssortmentCardFieldsCount: { missingImage: number, missingBrand: number, missingCategory: number, missingColor: number, missingCost: number, missingDeliveryMonth: number, missingDoor: number, missingPrice: number, missingSeason: number, missingWholesaleCurrency: number, missingRetailCurrency: number, cancelledInOrder: number, unitMismatch: number, missingCustomAttributes: number, notReceived: number } }> };

export type VACurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type VACurrenciesQuery = { currencies?: { edges?: Array<{ node?: { id: string, code: string } | null }> | null } | null };

export type getZendeskSSOTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type getZendeskSSOTokenQuery = { zendeskUser: { SSOToken: string } };

export type UsesNewEditAndCreateQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type UsesNewEditAndCreateQuery = { usesNewEditAndCreate: boolean };

export type UserInfoQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQueryQuery = { viewingAccountUser: { id: string, tiedWithBuyerHierarchy: boolean, accountUserType: AccountUserType, viewingAccount: { __typename: 'AdminViewerAccount', id: string, name: string } | { __typename: 'BrandViewerAccount', id: string, name: string, logoUrl?: string | null, type?: AccountType | null, status: AccountStatus, canTransact: boolean, canViewDataPortal: boolean, integrations: Array<string | null>, subType?: string | null, enableChat: boolean, accountCreationSource?: { externalSource?: ExternalSource | null } | null } | { __typename: 'RetailerViewerAccount', id: string, name: string, logoUrl?: string | null, type?: AccountType | null, status: AccountStatus, enableChat: boolean, assortmentPlanning: boolean, integrations: Array<string | null>, canShop: boolean, canFindBrands: boolean, accountCreationSource?: { externalSource?: ExternalSource | null } | null }, viewingUser: { id: string, email?: string | null, displayName?: string | null, dateFormat?: DateFormat | null, assortmentPlanning: boolean, profileImage?: string | null, code?: string | null, isAdmin: boolean, isOwner: boolean, loggedInAsAdmin: boolean, lastLogin?: any | null, userType: UserType, internalUser: boolean, emailLanguage: string, displayLanguage: string }, accountUserPermissions: Array<{ id: string, key: string, name: string } | null>, accounts: Array<{ __typename: 'AdminViewerAccount', id: string, name: string } | { __typename: 'BrandViewerAccount', id: string, name: string } | { __typename: 'RetailerViewerAccount', id: string, name: string } | null> } };

export type UpsertAccountCustomerCodesMutationVariables = Exact<{
  input: UpsertAccountCustomerCodesInput;
}>;


export type UpsertAccountCustomerCodesMutation = { upsertAccountCustomerCodes: Array<{ otherAccountId: string, alias?: string | null, code?: string | null }> };

export type createMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type createMessageMutation = { createMessage: { id: string, threadId: string, messageType?: MessageType | null, accountId: string, parentId?: string | null, subject: string, body: string } };

export type BulkUpdateOrderSalesRepByFiltersMutationVariables = Exact<{
  input: BulkUpdateOrderSalesRepByFiltersInput;
}>;


export type BulkUpdateOrderSalesRepByFiltersMutation = { bulkUpdateOrderSalesRepByFilters: { updatedOrdersCount: number } };

export type orderStatusChangeJobQueryQueryVariables = Exact<{
  jobIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type orderStatusChangeJobQueryQuery = { listMonitoringJobs: { jobs?: Array<{ id: string, jobId: string, status: JobStatus, outputData?: any | null, errorDetails?: any | null }> | null } };

export type bulkUpdateOrderStatusAsyncMutationMutationVariables = Exact<{
  input: BulkUpdateOrderStatusAsyncInput;
}>;


export type bulkUpdateOrderStatusAsyncMutationMutation = { bulkUpdateOrderStatusAsync: { jobId: string } };

export type orderStatusChangeEligibilityQueryQueryVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  status: OrderStatus;
}>;


export type orderStatusChangeEligibilityQueryQuery = { orderStatusChangeEligibility: Array<{ orderId: string, orderNumber: string, brandName: string, eligible: boolean, reason?: OrderStatusChangeIneligibilityReason | null }> };

export type CreateRawOrdersExportMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateRawOrdersExportMutation = { createRawOrdersExport: { taskId: string } };

export type BulkMarkOrdersAsExportedMutationVariables = Exact<{
  input: BulkMarkOrdersAsExportedInput;
}>;


export type BulkMarkOrdersAsExportedMutation = { bulkMarkOrdersAsExported: { updatedOrderIds: Array<string> } };

export type accountExportIntegrationConfigsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['ID']>;
  integrationTypes: ExportType;
}>;


export type accountExportIntegrationConfigsQuery = { accountExportIntegrationConfigs: Array<{ id: string, name: string, columnConfig: string }> };

export type ImportValidatedOrdersMutationVariables = Exact<{
  input: ImportValidatedOrdersInput;
}>;


export type ImportValidatedOrdersMutation = { importValidatedOrders?: { importJobIdentifier?: string | null } | null };

export type RetailerBrandDoorsQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type RetailerBrandDoorsQuery = { brandDoors: { edges: Array<{ node: { id: string, name: string, code?: string | null } }> } };

export type LinesheetsQueryCAQueryVariables = Exact<{
  brandId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
}>;


export type LinesheetsQueryCAQuery = { collections: { edges: Array<{ node: { id: string, name: string } } | null> } };

export type PriceTypesQueryCAQueryVariables = Exact<{
  brandId: Scalars['ID'];
  collectionId: Scalars['ID'];
  retailerId: Scalars['ID'];
}>;


export type PriceTypesQueryCAQuery = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { code: string } } }> } };

export type ShippingBillingQueryCAQueryVariables = Exact<{
  brandId: Scalars['ID'];
  retailerId: Scalars['ID'];
}>;


export type ShippingBillingQueryCAQuery = { brands: { edges: Array<{ node?: { connectedAccounts: { edges: Array<{ node?: { id: string, publicRetailerProfile?: { id: string, primaryLocation?: { id: string, name?: string | null, address1?: string | null, address2?: string | null, state?: string | null, city?: string | null, country?: string | null } | null } | null } | null, paymentMethods: Array<{ default?: boolean | null, paymentMethod: { id: string, name: string, code: string } }>, billingAddresses: Array<{ id: string, code?: string | null, phoneNumber?: string | null, address?: { state?: string | null, city?: string | null, country?: string | null, companyName?: string | null } | null }>, shippingMethods: Array<{ default?: boolean | null, shippingMethod?: { id: string, name: string, code: string } | null }>, shippingAddresses: Array<{ id: string, code?: string | null, email?: string | null, phoneNumber?: string | null, address?: { companyName?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, country?: string | null } | null }> }> } } | null }> } };

export type GenerateSummaryFileMutationVariables = Exact<{
  input: GenerateSummaryFileInput;
}>;


export type GenerateSummaryFileMutation = { generateSummaryFile?: { url?: string | null } | null };

export type UploadFileToS3MutationVariables = Exact<{
  file: UploadFileToS3Input;
}>;


export type UploadFileToS3Mutation = { uploadFileToS3?: { fileName?: string | null, mimeType?: string | null, id?: string | null, url?: string | null } | null };

export type ValidateOrdersMutationVariables = Exact<{
  url: Scalars['String'];
  templateId: Scalars['ID'];
  settings?: InputMaybe<ValidateOrdersSettings>;
  orderSettings: OrderInputSettings;
}>;


export type ValidateOrdersMutation = { validateOrders?: { validatedOrdersIdentifier: string, orders: Array<{ doorId?: string | null, orderIdentifier?: string | null, poNumber?: string | null, skuLineItems?: Array<{ colorId?: string | null, productId?: string | null, quantity?: number | null, sizeId?: string | null, wholesalePrice?: string | null, multiplier?: number | null }> | null }>, errors?: Array<{ code?: GenericErrorCode | null, message: string, type?: ErrorType | null }> | null } | null };

export type BulkUnscheduleForExportMutationVariables = Exact<{
  input: BulkUnscheduleForExportInput;
}>;


export type BulkUnscheduleForExportMutation = { bulkUnscheduleForExport: { updatedOrderIds: Array<string> } };

export type SendInvoicesForOrdersMutationVariables = Exact<{
  input: SendInvoicesForOrdersInput;
}>;


export type SendInvoicesForOrdersMutation = { sendInvoicesForOrders?: Array<{ orderId: string, sentTo: string, sentOn: any } | null> | null };

export type CreatePaymentInvoiceMutationVariables = Exact<{
  input: CreateInvoicesInput;
}>;


export type CreatePaymentInvoiceMutation = { createInvoices: Array<{ orderId: string, invoiceId: string }> };

export type NewCustomerDataQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type NewCustomerDataQuery = { priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { id: string, code: string, name: string }, retailCurrency: { id: string, code: string, name: string } } }> }, warehouses: { edges: Array<{ node?: { id: string, name: string, code: string } | null } | null> } };

export type OrphanRetailersQueryVariables = Exact<{
  input: OrphanRetailersRequest;
}>;


export type OrphanRetailersQuery = { orphanRetailers: Array<{ id: string, retailerName: string, retailerEmail: string, retailerCode?: string | null, connectionProcessed: boolean, update: any, created: any, deleted?: boolean | null }> };

export type UserConnectedAccountsQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type UserConnectedAccountsQuery = { retailers: { edges?: Array<{ node?: { id: string, displayName: string, name: string, brands: { edges: Array<{ id: string, code?: string | null, profileName?: string | null, node?: { id: string } | null }> } } | null }> | null } };

export type doorIdsQueryQueryVariables = Exact<{
  brandId: Scalars['ID'];
}>;


export type doorIdsQueryQuery = { brandDoors: { edges: Array<{ node: { id: string, name: string, code?: string | null } }> } };

export type CollectionsQueryDupe5QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderBy?: InputMaybe<CollectionOrderByField>;
}>;


export type CollectionsQueryDupe5Query = { collections: { edges: Array<{ node: { id: string, name: string } } | null> } };

export type BulkUpdateOrderPricingByIdsMutationVariables = Exact<{
  input: BulkUpdateOrderPricingByIdsInput;
}>;


export type BulkUpdateOrderPricingByIdsMutation = { bulkUpdateOrderPricingByIds: { updatedOrdersCount: number, notUpdatedOrdersCount: number } };

export type UpsertOrderQuantitiesDupe1MutationVariables = Exact<{
  input: UpsertOrderQuantitiesInput;
}>;


export type UpsertOrderQuantitiesDupe1Mutation = { upsertOrderQuantities: { updatedOrderIds?: Array<string> | null } };

export type CollectionsQueryDupe6QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  retailerId: Scalars['ID'];
}>;


export type CollectionsQueryDupe6Query = { collections: { edges: Array<{ node: { id: string, name: string, isVisibleToRetailer?: boolean | null, delivery?: { id: string, startShipDate?: any | null } | null } } | null> } };

export type CollectionsOprhanOrderQueryQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CollectionsOprhanOrderQueryQuery = { collections: { edges: Array<{ node: { id: string, name: string, delivery?: { id: string, startShipDate?: any | null } | null } } | null> } };

export type collectionProductsQueryDupe4QueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  priceTypeId: Scalars['ID'];
}>;


export type collectionProductsQueryDupe4Query = { collectionProducts: { pageInfo: { hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ node: { id: string, product: { id: string, name: string, externalIdentifier: string, badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> }, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> }, images: Array<{ url?: string | null }>, priceRange?: { minWholesaleValue: number, maxWholesaleValue: number, minRetailValue: number, maxRetailValue: number } | null, skus: { edges?: Array<{ node?: { id: string } | null }> | null } }, collection: { id: string }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> } } }> } };

export type collectionProductsTotalQueryDupe2QueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type collectionProductsTotalQueryDupe2Query = { collectionProductsTotal: number };

export type OrderVariantTotalsQueryDupe3QueryVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  filter?: InputMaybe<OrderVariantTotalsFilter>;
}>;


export type OrderVariantTotalsQueryDupe3Query = { orderVariantTotals: { edges?: Array<{ node?: { variantId: string } | null }> | null } };

export type OrdersCommonInfoQueryVariables = Exact<{
  orderIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type OrdersCommonInfoQuery = { orders: { edges: Array<{ node: { id: string, retailerProfile?: { id: string } | null, brand: { id: string }, priceType?: { id: string, name: string, currency: { id: string, name: string, code: string } } | null, collections: { edges: Array<{ node: { id: string } } | null> }, doors: { edges: Array<{ node: { id: string } }> }, shipping: { deliveryWindow?: { startDate?: any | null } | null } } }> } };

export type ReassignConnectionsMutationVariables = Exact<{
  accountId: Scalars['ID'];
  sourceAccountUserId: Scalars['ID'];
  targetAccountUserId?: InputMaybe<Scalars['ID']>;
}>;


export type ReassignConnectionsMutation = { reassignConnections: { success: boolean } };

export type getRetailerSeasonsQueryVariables = Exact<{
  retailerId: Scalars['ID'];
}>;


export type getRetailerSeasonsQuery = { retailer?: { seasons: { edges: Array<{ node: { id: string, name: string, year?: number | null, code: string } }> } } | null };

export type getAssortmentsForCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID'];
  includeCustom?: InputMaybe<Scalars['Boolean']>;
}>;


export type getAssortmentsForCollectionQuery = { assortmentsForCollection: Array<{ id: string, name: string }> };

export type createAssortmentWithColorsMutationVariables = Exact<{
  assortmentName: Scalars['String'];
  collectionId: Scalars['ID'];
  colorIds: Array<Scalars['ID']> | Scalars['ID'];
  priceTypeId: Scalars['ID'];
  retailCurrencyId: Scalars['ID'];
  retailerId: Scalars['ID'];
  seasonId: Scalars['ID'];
  wholesaleCurrencyId: Scalars['ID'];
}>;


export type createAssortmentWithColorsMutation = { createAssortmentWithColors: { assortment?: { id: string, brand?: { node?: { id: string } | null } | null } | null } };

export type addColorsToAssortmentMutationVariables = Exact<{
  assortmentId: Scalars['ID'];
  colorIds: Array<Scalars['ID']> | Scalars['ID'];
  priceTypeId: Scalars['ID'];
  collectionId?: InputMaybe<Scalars['ID']>;
}>;


export type addColorsToAssortmentMutation = { addColorsToAssortment: { assortment?: { id: string, brand?: { node?: { id: string } | null } | null } | null } };

export type addUnitsInProgressMutationVariables = Exact<{
  input: AddUnitsInProgressInput;
}>;


export type addUnitsInProgressMutation = { addUnitsInProgress: { createdOrderIds?: Array<string> | null } };

export type WarehousesQueryDupe3QueryVariables = Exact<{
  productId?: InputMaybe<Scalars['ID']>;
  brandId?: InputMaybe<Scalars['ID']>;
}>;


export type WarehousesQueryDupe3Query = { warehouses: { edges: Array<{ node?: { id: string, name: string, code: string, availabilityGroups: { edges: Array<{ node: { id: string, isEmpty?: boolean | null, availability: { availableOn?: any | null, isImmediate: boolean } } } | null> } } | null } | null> } };

export type CollectionProductQueryQueryVariables = Exact<{
  filters?: InputMaybe<ProductsCollectionFilter>;
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  externalMediaEnabled: Scalars['Boolean'];
  productVideosAreEnabled: Scalars['Boolean'];
}>;


export type CollectionProductQueryQuery = { collectionProducts: { edges: Array<{ node: { id: string, product: { id: string, name: string, externalIdentifier: string, description: string, orderMinimum: number, categories: { edges: Array<{ node: { id?: string | null, name: string, parentName?: string | null } }> }, tagValues: { edges: Array<{ node: { id: string, externalIdentifier: string, value: string, tag: { id: string, name: string } } }> }, badges: { edges: Array<{ node: { id: string, name: string, image?: { url?: string | null } | null } }> }, images: Array<{ url?: string | null }>, videos?: Array<{ id?: string | null, url?: string | null }>, externalMedia?: Array<{ id: string, url: string, type: string, format: string, thumbnailUrl: string, payload: string }>, traitValues: { edges: Array<{ node: { id: string, value: string, externalIdentifier: string, trait: { id: string, name: string, code: string } } }> } }, collection: { id: string }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, description?: string | null, externalIdentifier?: string | null, orderMinimum?: number | null, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, merchandiseImages?: Array<{ url: any }> | null, swatchImage?: { url: any } | null } | null } | null }> | null }, node: { id: string, code: string, name: string } }> }, skus: { edges?: Array<{ node?: { id: string, prices: Array<{ id: string, wholesalePrice: any, suggestedRetailPrice?: any | null, priceType: { id: string } }>, variantValues: { edges?: Array<{ node?: { id: string, value: string, trait: { id: string, code: string, name: string } } | null }> | null } } | null }> | null }, casepacks: { edges: Array<{ node: { id: string, name?: string | null, externalIdentifier?: string | null, description?: string | null, skus: { edges: Array<{ quantity: number, node: { id: string, variantValues: { edges?: Array<{ node?: { id: string, value: string, trait: { id: string, code: string, name: string } } | null }> | null }, prices: Array<{ id: string, wholesalePrice: any, suggestedRetailPrice?: any | null, priceType: { id: string } }> } }> } } }> } } }> } };

export type CollectionsQueryDupe7QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CollectionsQueryDupe7Query = { collections: { edges: Array<{ node: { id: string, madeToOrder?: boolean | null, delivery?: { id: string, startShipDate?: any | null, completeShipDate?: any | null } | null } } | null> } };

export type aggregateSkuInventoryItemsDupe3QueryVariables = Exact<{
  warehouseIds: Array<Scalars['ID']> | Scalars['ID'];
  endDate?: InputMaybe<Scalars['String']>;
  includeImmediate?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AggregateSkuInventoryItemsFilter>;
}>;


export type aggregateSkuInventoryItemsDupe3Query = { aggregateSkuInventoryItems: Array<{ items?: Array<{ availableQuantity: number, skuId: string }> | null }> };

export type DiscountsQueryQueryVariables = Exact<{
  brandId?: InputMaybe<Scalars['ID']>;
  retailerId: Scalars['ID'];
  productIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DiscountsQueryQuery = { productDiscounts: { edges: Array<{ node?: { factor?: any | null, id: string } | null } | null> } };

export type skuDeliveriesDupe1QueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<SkuDeliveryFilter>;
}>;


export type skuDeliveriesDupe1Query = { skuDeliveries: { edges: Array<{ node: { id: string, startShipDate?: any | null, completeShipDate?: any | null, sku: { id: string } } }> } };

export type skuDeliveriesDupe2QueryVariables = Exact<{
  collectionIds: Array<Scalars['ID']> | Scalars['ID'];
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  filter?: InputMaybe<SkuDeliveryFilter>;
}>;


export type skuDeliveriesDupe2Query = { skuDeliveries: { edges: Array<{ node: { id: string, startShipDate?: any | null, completeShipDate?: any | null, sku: { id: string }, collection: { id: string }, product: { id: string } } }> } };

export type collectionProductsQueryVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type collectionProductsQuery = { collectionProducts: { edges: Array<{ node: { product: { id: string, name: string, images: Array<{ url?: string | null }> }, skus: { edges?: Array<{ node?: { id: string } | null }> | null }, casepacks: { edges: Array<{ node: { id: string, name?: string | null, skus: { edges: Array<{ node: { id: string } }> } } }> }, variants: { edges: Array<{ values: { edges?: Array<{ node?: { id: string, value: string, externalIdentifier?: string | null, displayDetails?: { hexColor?: string | null, swatchImage?: { url: any } | null, merchandiseImages?: Array<{ url: any }> | null } | null } | null }> | null }, node: { id: string, code: string } }> } } }> } };

export type CollectionsQueryDupe9QueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  searchText?: InputMaybe<Scalars['String']>;
}>;


export type CollectionsQueryDupe9Query = { collections: { edges: Array<{ node: { id: string, name: string, brand: { id: string }, delivery?: { id: string, completeShipDate?: any | null, startShipDate?: any | null } | null } } | null> } };

export type CollectionProductsQueryDupe5QueryVariables = Exact<{
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  externalMediaEnabled: Scalars['Boolean'];
}>;


export type CollectionProductsQueryDupe5Query = { collectionProducts: { edges: Array<{ node: { id: string, variantTotal: number, product: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, externalMedia?: Array<{ id: string, type: string, thumbnailUrl: string }>, tagValues: { edges: Array<{ node: { value: string, tag: { name: string, groupName: string } } }> }, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } }, priceTypes: { edges: Array<{ node: { id: string, retailCurrency: { id: string, name: string } } }> } } }> } };

export type AddProductsToOrdersMutationVariables = Exact<{
  input: AddProductsToOrdersInput;
}>;


export type AddProductsToOrdersMutation = { addProductsToOrders: { createdWebOrderIds?: Array<string> | null } };

export type UpsertStyleboardDupe2MutationVariables = Exact<{
  input: UpsertStyleboardInput;
}>;


export type UpsertStyleboardDupe2Mutation = { upsertStyleboard: { id: string } };

export type StyleboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type StyleboardsQuery = { styleboards: { edges?: Array<{ node: { id: string, layout: string, name: string, status: StyleboardStatus, items: Array<{ variantId?: string | null, look?: { id: string } | null, collectionProduct: { product: { id: string }, collection: { id: string } } }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }> } }> | null } };

export type DeleteCollectionsMutationVariables = Exact<{
  input: DeleteShowroomCollectionsInput;
}>;


export type DeleteCollectionsMutation = { deleteShowroomCollections: Array<{ id: string }> };

export type DeleteStyleboardsMutationVariables = Exact<{
  input: DeleteStyleboardsInput;
}>;


export type DeleteStyleboardsMutation = { deleteStyleboards: Array<{ id: string }> };

export type SaveCollectionMutationVariables = Exact<{
  input: UpsertShowroomCollectionInput;
}>;


export type SaveCollectionMutation = { upsertShowroomCollection: { id: string, name: string, status: ShowroomCollectionStatus, visibleToAllConnected: boolean, brand: { id: string, name: string, priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { name: string, id: string, code: string } } }> } }, url3dShowroom?: { id: string, name: string, provider: Provider3dShowroom, url: string } | null, looks: { edges?: Array<{ node: { id: string, layout: string, items: Array<{ variantId?: string | null, collectionProduct?: { id: string, variantTotal: number, product: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, externalMedia: Array<{ id: string, type: string, thumbnailUrl: string }>, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } }, collection: { id: string, name: string, brand: { id: string } }, priceTypes: { edges: Array<{ node: { id: string } }> } } | null }>, media: Array<{ id: string, url: string, type: LookMediaType, streamingUrl: string }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }> } }> | null } } };

export type sharedShowroomCollectionQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type sharedShowroomCollectionQueryQuery = { showroomCollection: { id: string, showroomCollectionShares: { retailerRecipients: Array<{ email: string, shareDate?: any | null, retailer: { id: string, name: string } }> } } };

export type ShareCollectionsWithRetailersDupe2MutationVariables = Exact<{
  input: ShareCollectionsWithRetailersInput;
}>;


export type ShareCollectionsWithRetailersDupe2Mutation = { shareCollectionsWithRetailers: { collections: { edges: Array<{ node: { id: string } } | null> } } };

export type BulkUpdateCollectionsDupe2MutationVariables = Exact<{
  input: BulkUpdateCollectionsInput;
}>;


export type BulkUpdateCollectionsDupe2Mutation = { bulkUpdateCollections: { collections?: Array<{ id: string }> | null } };

export type getShowroomCollectionTokenMutationVariables = Exact<{
  input: GetShowroomCollectionTokenizedLinkInput;
}>;


export type getShowroomCollectionTokenMutation = { token: { tokenizedLink: string } };

export type ShareStyleboardMutationVariables = Exact<{
  input: ShareStyleboardInput;
}>;


export type ShareStyleboardMutation = { shareStyleboard: Array<{ styleboardId: string }> };

export type CollectionsQueryDupe8QueryVariables = Exact<{
  collectionIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
}>;


export type CollectionsQueryDupe8Query = { collections: { edges: Array<{ node: { id: string, name: string } } | null> } };

export type ShareCollectionsWithRetailerMutationVariables = Exact<{
  input: ShareCollectionsWithRetailersInput;
}>;


export type ShareCollectionsWithRetailerMutation = { shareCollectionsWithRetailers: { collections: { edges: Array<{ node: { id: string } } | null> } } };

export type ShareShowroomCollectionMutationVariables = Exact<{
  input: ShareShowroomCollectionInput;
}>;


export type ShareShowroomCollectionMutation = { shareShowroomCollection: Array<{ showroomCollectionId: string }> };

export type UnshareShowroomCollectionMutationVariables = Exact<{
  input: UnshareShowroomCollectionInput;
}>;


export type UnshareShowroomCollectionMutation = { unshareShowroomCollection: Array<{ showroomCollectionId: string }> };

export type TeamMembersQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamMembersQueryQuery = { users: { edges: Array<{ node: { id: string, displayName?: string | null, email?: string | null } }> } };

export type RetailerTeamMembersQueryQueryVariables = Exact<{
  retailerIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RetailerTeamMembersQueryQuery = { retailerUsers: { edges?: Array<{ node?: { id: string, displayName: string, email: string } | null }> | null } };

export type Orb360ProductQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type Orb360ProductQuery = { orb360Products: { totalCount: number, products: Array<{ id: string, name: string, images: Array<{ id?: string | null, url?: string | null }>, externalMedia: Array<{ id: string, url: string }> }> } };

export type collectionProductExtraInfoQueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
}>;


export type collectionProductExtraInfoQuery = { collectionProducts: { edges: Array<{ node: { id: string, collection: { id: string, visibility?: CollectionVisibility | null }, product: { id: string, externalIdentifier: string } } }> } };

export type CollectionProductsDupe2QueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
}>;


export type CollectionProductsDupe2Query = { collectionProducts: { edges: Array<{ node: { id: string, collection: { id: string, name: string }, product: { id: string, name: string, images: Array<{ url?: string | null }>, externalMedia: Array<{ id: string, thumbnailUrl: string }> } } }> } };

export type PublicCollectionsQueryDupe2QueryVariables = Exact<{
  brandId: Scalars['ID'];
  filters?: InputMaybe<PublicCollectionsFilter>;
}>;


export type PublicCollectionsQueryDupe2Query = { public: { collections: Array<{ id: string, name: string, products: Array<{ id: string, name: string, images: Array<{ id?: string | null, url?: string | null }>, externalMedia: Array<{ id: string, thumbnailUrl: string, type: string }>, variants: { colors: Array<{ id: string, name: string, image?: { id?: string | null, url?: string | null } | null, swatch: { hexColor: string, image?: { id?: string | null, url?: string | null } | null } }> } }> }> } };

export type collectionProductsQueryDupe6QueryVariables = Exact<{
  filter?: InputMaybe<ProductsCollectionFilter>;
  externalMediaEnabled: Scalars['Boolean'];
}>;


export type collectionProductsQueryDupe6Query = { collectionProducts: { edges: Array<{ node: { id: string, product: { id: string, name: string, images: Array<{ url?: string | null }>, externalMedia?: Array<{ id: string, thumbnailUrl: string, type: string }> }, variants: { edges: Array<{ node: { id: string, code: string }, values: { edges?: Array<{ node?: { id: string, externalIdentifier?: string | null, value: string, trait: { id: string, code: string, name: string }, displayDetails?: { hexColor?: string | null, swatchImage?: { url: any } | null, merchandiseImages?: Array<{ url: any }> | null } | null } | null }> | null } }> }, collection: { id: string } } }> } };

export type CollectionParamsByShareTokenQueryQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type CollectionParamsByShareTokenQueryQuery = { public: { collectionParamsByShareToken: { collection: { id: string, name: string }, brand: { id: string, name: string }, priceType: { id: string, name: string, currency: { id: string, name: string, code: string }, retailCurrency: { id: string, name: string, code: string } } } } };

export type LookFragmentFragment = { id: string, layout: string, items: Array<{ variantId?: string | null, collectionProduct?: { id: string, variantTotal: number, product: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, externalMedia: Array<{ id: string, type: string, thumbnailUrl: string }>, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } }, collection: { id: string, name: string, brand: { id: string } }, priceTypes: { edges: Array<{ node: { id: string } }> } } | null }>, media: Array<{ id: string, url: string, type: LookMediaType, streamingUrl: string }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }> };

export type CollectionQueryDupe2QueryVariables = Exact<{
  collectionId: Scalars['ID'];
}>;


export type CollectionQueryDupe2Query = { showroomCollection: { id: string, name: string, status: ShowroomCollectionStatus, visibleToAllConnected: boolean, brand: { id: string, name: string, priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { name: string, id: string, code: string } } }> }, warehouses: { edges: Array<{ node?: { id: string, name: string, code: string } | null } | null> } }, url3dShowroom?: { id: string, name: string, provider: Provider3dShowroom, url: string } | null, looks: { edges?: Array<{ node: { id: string, layout: string, items: Array<{ variantId?: string | null, collectionProduct?: { id: string, variantTotal: number, product: { id: string, name: string, externalIdentifier: string, images: Array<{ url?: string | null }>, externalMedia: Array<{ id: string, type: string, thumbnailUrl: string }>, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } }, collection: { id: string, name: string, brand: { id: string } }, priceTypes: { edges: Array<{ node: { id: string } }> } } | null }>, media: Array<{ id: string, url: string, type: LookMediaType, streamingUrl: string }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }> } }> | null } } };

export type PublicShowroomCollectionQueryVariables = Exact<{
  token: Scalars['String'];
  isPublic: Scalars['Boolean'];
}>;


export type PublicShowroomCollectionQuery = { public: { publicShowroomCollection: { id: string, name: string, url3dShowroom?: { id: string, url?: string } | null, looks: { edges: Array<{ node: { id: string, layout: string, items: Array<{ productId: string, collectionId: string, collectionProductId: string, productNumber: string, productName: string, productImageUrl?: string | null, visible: boolean, variantId?: string | null, colorVariantTotal: number }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }>, media: Array<{ id: string, url: string, type: LookMediaType, streamingUrl: string }> } }> } } } };

export type LastModifiedQueryQueryVariables = Exact<{
  styleboardId: Scalars['ID'];
}>;


export type LastModifiedQueryQuery = { styleboardLastModified: { lastModified: string } };

export type StyleboardQueryQueryVariables = Exact<{
  styleboardId: Scalars['ID'];
  externalMediaEnabled: Scalars['Boolean'];
}>;


export type StyleboardQueryQuery = { styleboard: { id: string, lastModified: string, layout: string, name: string, status: StyleboardStatus, brand: { id: string, name: string, priceTypes: { edges: Array<{ node: { id: string, name: string, currency: { name: string, id: string, code: string } } }> } }, comments: { edges: Array<{ node: { id: string, message: string, created: any, owner: { accountProfileName: string, userEmail: string, userDisplayName: string } } }> }, owner: { logo: string, userId: string }, items: Array<{ variantId?: string | null, look?: { id: string } | null, collectionProduct: { id: string, variantTotal: number, product: { id: string, name: string, tagValues: { edges: Array<{ node: { value: string, tag: { name: string, groupName: string } } }> }, images: Array<{ url?: string | null }>, externalMedia?: Array<{ id: string, thumbnailUrl: string, type: string }>, traitValues: { edges: Array<{ node: { id: string, value: string, trait: { id: string, code: string, name: string } } }> } }, collection: { id: string, name: string, brand: { id: string }, delivery?: { id: string, completeShipDate?: any | null, startShipDate?: any | null } | null }, priceTypes: { edges: Array<{ node: { id: string } }> } } }>, textContents: Array<{ content: string, layoutKey: string, presentation: string }>, styleboardShares?: { externalRecipients: Array<{ account: { name: string } }> } | null } };

export type accountPaymentProvidersQueryVariables = Exact<{
  destinationAccountId: Scalars['ID'];
}>;


export type accountPaymentProvidersQuery = { accountPaymentProviders: Array<{ externalIdentifier: string, paymentProvider: string, isSepaEnabled?: boolean | null, isAchEnabled?: boolean | null, retailersCanSeeInvoices?: boolean | null, sendBrandMailPaymentProcessed?: boolean | null, sendRetailerMailPaymentProcessed?: boolean | null, brandNotificationEmail?: string | null }> };

export type PaymentRecordQueryVariables = Exact<{
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type PaymentRecordQuery = { paymentRecords: Array<{ id: string, orderId: string, amount?: number | null, currency: string, status?: PaymentRecordStatus | null, created?: any | null, localAmount?: number | null, localCurrency?: string | null, paymentMethod?: { bankName: string, type: string, last4: string, billingName: string, billingEmail: string } | { brand: string, type: string, last4: string, billingName: string, billingEmail: string } | null }> };

export type invoicesQueryVariables = Exact<{
  accountId: Scalars['ID'];
  orderIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type invoicesQuery = { invoices: Array<{ orderId: string, sentOn: any, sentTo: string }> };

export type PaymentInfoOrdersQueryVariables = Exact<{
  filters: OrderFilterInput;
}>;


export type PaymentInfoOrdersQuery = { orders: { edges: Array<{ node: { id: string, paymentInfo?: { paymentStatus: PaymentStatus, requestStatus: RequestStatus, remainingBalance: string } | null } }> } };

export type getZendeskUserQueryVariables = Exact<{ [key: string]: never; }>;


export type getZendeskUserQuery = { zendeskUser: { messagingToken: string } };

export const ManualTransactionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ManualTransaction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ManualPaymentRecord"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"recordedBy"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]} as unknown as DocumentNode<ManualTransactionFragment, unknown>;
export const ProductsInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductsInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderProductConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalProducts"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"totalVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"traitCodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traitCodes"}}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleRangeOverwritten"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"minRetailValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetailValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"backupProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotalRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantComment"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderProductComment"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"factor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skuLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"sku"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"casepackLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"variantInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"sizeName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"casepack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePriceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsInfoFragment, unknown>;
export const OrderShippingDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderShippingDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderShipping"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"method"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"firstAddress"}},{"kind":"Field","name":{"kind":"Name","value":"secondAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"sourceShippingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceString"}}]}}]} as unknown as DocumentNode<OrderShippingDetailsFragment, unknown>;
export const OrderTaxFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderTax"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tax"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amountString"}}]}}]} as unknown as DocumentNode<OrderTaxFragment, unknown>;
export const OrderCollectionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCollections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minimumShippingWindow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToViewer"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minStartShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"maxCompleteShipDate"}}]}}]}}]} as unknown as DocumentNode<OrderCollectionsFragment, unknown>;
export const BrandOrderSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrandOrderSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayShippingCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayInternalOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"minUnits"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"retailerRestrictedFromEditing"}},{"kind":"Field","name":{"kind":"Name","value":"displayCountryOfOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"restrictEditNotesAndReturnedOrders"}},{"kind":"Field","name":{"kind":"Name","value":"restrictPendingToNotes"}},{"kind":"Field","name":{"kind":"Name","value":"salesComissions"}},{"kind":"Field","name":{"kind":"Name","value":"shippingRates"}},{"kind":"Field","name":{"kind":"Name","value":"allowOrderDiscounts"}}]}}]} as unknown as DocumentNode<BrandOrderSettingsFragment, unknown>;
export const OrderFinancialsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderFinancials"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFinancials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}},{"kind":"Field","name":{"kind":"Name","value":"minPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"percentageAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"percentageAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"percentageAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"factor"}},{"kind":"Field","name":{"kind":"Name","value":"percentageAmount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grandTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dueTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}}]}}]} as unknown as DocumentNode<OrderFinancialsFragment, unknown>;
export const storefrontFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"storefrontFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Storefront"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"isHome"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueName"}},{"kind":"Field","name":{"kind":"Name","value":"statusSince"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"elements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"elementType"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontTextElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontCollectionElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontVideoElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontProductElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontImageElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageExternalLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontAboutElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontShowroomCollectionElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionId"}},{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"coverId"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontLookbookElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookbookId"}},{"kind":"Field","name":{"kind":"Name","value":"lookbookTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lookbookUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverId"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontOrb360Element"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalVideoId"}},{"kind":"Field","name":{"kind":"Name","value":"externalVideoLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontShowroomBrandElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomBrandId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontInstagramElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"instagramAuthId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"textStyles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"typeface"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}}]} as unknown as DocumentNode<storefrontFragmentFragment, unknown>;
export const VisualAssortmentCardFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisualAssortmentCardFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardUuid"}},{"kind":"Field","name":{"kind":"Name","value":"groupedSourceCardIds"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productNumber"}},{"kind":"Field","name":{"kind":"Name","value":"productImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"subGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentColor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentMonth"}},{"kind":"Field","name":{"kind":"Name","value":"orderSourceData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customDescription"}},{"kind":"Field","name":{"kind":"Name","value":"receivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sizeName"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentCardFieldsFragment, unknown>;
export const VisualAssortmentAttributeKeyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentAttributeKey"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"limitCount"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"limitReached"}},{"kind":"Field","name":{"kind":"Name","value":"attributeValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentAttributeKeyFieldsFragment, unknown>;
export const VisualAssortmentGroupFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisualAssortmentGroupFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"maxCardOrderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"subgroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"maxCardOrderNbr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentGroupFieldsFragment, unknown>;
export const VisualAssortmentBudgetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisualAssortmentBudgetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentBudget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"attributeFilterId"}},{"kind":"Field","name":{"kind":"Name","value":"groupings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupBy"}},{"kind":"Field","name":{"kind":"Name","value":"attributeKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentBudgetFieldsFragment, unknown>;
export const BudgetViewFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BudgetViewFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BudgetView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"budgetId"}},{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualRetail"}},{"kind":"Field","name":{"kind":"Name","value":"budgetCost"}},{"kind":"Field","name":{"kind":"Name","value":"budgetRetail"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"percentCostSpent"}},{"kind":"Field","name":{"kind":"Name","value":"percentRetailSpent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupBy"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualRetail"}},{"kind":"Field","name":{"kind":"Name","value":"budgetCost"}},{"kind":"Field","name":{"kind":"Name","value":"budgetRetail"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"percentCostSpent"}},{"kind":"Field","name":{"kind":"Name","value":"percentRetailSpent"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupBy"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"actualCost"}},{"kind":"Field","name":{"kind":"Name","value":"actualRetail"}},{"kind":"Field","name":{"kind":"Name","value":"budgetCost"}},{"kind":"Field","name":{"kind":"Name","value":"budgetRetail"}},{"kind":"Field","name":{"kind":"Name","value":"margin"}},{"kind":"Field","name":{"kind":"Name","value":"percentCostSpent"}},{"kind":"Field","name":{"kind":"Name","value":"percentRetailSpent"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BudgetViewFieldsFragment, unknown>;
export const VisualAssortmentLimitFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisualAssortmentLimitFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentLimits"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxUsers"}},{"kind":"Field","name":{"kind":"Name","value":"maxDoors"}},{"kind":"Field","name":{"kind":"Name","value":"maxSeasons"}},{"kind":"Field","name":{"kind":"Name","value":"maxProducts"}},{"kind":"Field","name":{"kind":"Name","value":"maxCustomAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"maxCustomAttributeValues"}},{"kind":"Field","name":{"kind":"Name","value":"maxGroupingLevels"}},{"kind":"Field","name":{"kind":"Name","value":"dataStorageYears"}},{"kind":"Field","name":{"kind":"Name","value":"budgetsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"customProductsEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"productDetailEditingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"filtersEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"exportsEnabled"}}]}}]} as unknown as DocumentNode<VisualAssortmentLimitFieldsFragment, unknown>;
export const LookFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LookFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Look"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"COLOR","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textContents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"layoutKey"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}}]}}]}}]} as unknown as DocumentNode<LookFragmentFragment, unknown>;
export const RecordExportStatusMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordExportStatusMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssortmentsExportRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentId"}}]}}]}}]} as unknown as DocumentNode<RecordExportStatusMutationMutation, RecordExportStatusMutationMutationVariables>;
export const PdfExportMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PdfExportMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerAssortmentPDFExportTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"task"},"name":{"kind":"Name","value":"triggerAssortmentPdfExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responses"}}]}}]}}]} as unknown as DocumentNode<PdfExportMutationMutation, PdfExportMutationMutationVariables>;
export const XlsxExportMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"XlsxExportMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerAssortmentExcelExportTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"task"},"name":{"kind":"Name","value":"triggerAssortmentExcelExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responses"}}]}}]}}]} as unknown as DocumentNode<XlsxExportMutationMutation, XlsxExportMutationMutationVariables>;
export const BulkAssortmentExportAsyncMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkAssortmentExportAsyncMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"triggerBulkAssortmentExportAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"integrationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"integrationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<BulkAssortmentExportAsyncMutationMutation, BulkAssortmentExportAsyncMutationMutationVariables>;
export const AvailableAssortmentExportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableAssortmentExports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"activeViewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assortmentIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integrations"},"name":{"kind":"Name","value":"accountExportIntegrationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"integrationTypes"},"value":{"kind":"EnumValue","value":"ASSORTMENT_EXPORT"}},{"kind":"Argument","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"columnConfig"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"autoStatus"}}]}}]}}]} as unknown as DocumentNode<AvailableAssortmentExportsQuery, AvailableAssortmentExportsQueryVariables>;
export const ExportStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"listAssortmentExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ExportStatusQuery, ExportStatusQueryVariables>;
export const ListExportJobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListExportJob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobsIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListExportJobQuery, ListExportJobQueryVariables>;
export const setBrandNoteSeasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setBrandNoteSeason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAssortmentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<setBrandNoteSeasonMutation, setBrandNoteSeasonMutationVariables>;
export const AssortmentMoveToRetailWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssortmentMoveToRetailWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailWorkspaceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentMoveToRetailWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailWorkspaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailWorkspaceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailWorkspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssortmentMoveToRetailWorkspaceMutation, AssortmentMoveToRetailWorkspaceMutationVariables>;
export const GroupedWorkspaceCursorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GroupedWorkspaceCursors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentsQueryOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]} as unknown as DocumentNode<GroupedWorkspaceCursorsQuery, GroupedWorkspaceCursorsQueryVariables>;
export const QueryGroupedWorkspacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryGroupedWorkspaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentsQueryOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCountWorkspaces"}},{"kind":"Field","name":{"kind":"Name","value":"workspaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Assortment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"latestExport"}},{"kind":"Field","name":{"kind":"Name","value":"exportMessage"}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"brand"},"name":{"kind":"Name","value":"brandV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startShip"}},{"kind":"Field","name":{"kind":"Name","value":"completeShip"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RetailWorkspace"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"assortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"brand"},"name":{"kind":"Name","value":"brandV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startShip"}},{"kind":"Field","name":{"kind":"Name","value":"completeShip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]} as unknown as DocumentNode<QueryGroupedWorkspacesQuery, QueryGroupedWorkspacesQueryVariables>;
export const WorkspaceExtraDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceExtraDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailWorkspaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"financialOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentUnitsOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"isBrandCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedRetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WorkspaceExtraDetailsQuery, WorkspaceExtraDetailsQueryVariables>;
export const WorkspaceCursorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceCursors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentsQueryOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"workspaces"},"name":{"kind":"Name","value":"assortmentsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]} as unknown as DocumentNode<WorkspaceCursorsQuery, WorkspaceCursorsQueryVariables>;
export const QueryWorkspacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryWorkspaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentsQueryOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"workspaces"},"name":{"kind":"Name","value":"assortmentsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"latestExport"}},{"kind":"Field","name":{"kind":"Name","value":"exportMessage"}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}},{"kind":"Field","alias":{"kind":"Name","value":"brand"},"name":{"kind":"Name","value":"brandV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"modifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startShip"}},{"kind":"Field","name":{"kind":"Name","value":"completeShip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryWorkspacesQuery, QueryWorkspacesQueryVariables>;
export const AssortmentExtraDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssortmentExtraDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderAssortmentSyncStatus"}},{"kind":"Field","name":{"kind":"Name","value":"financialOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentUnitsOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"isBrandCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"units"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceLevels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"extendedCost"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extendedRetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssortmentExtraDetailsQuery, AssortmentExtraDetailsQueryVariables>;
export const FilterFieldValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterFieldValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdByUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"brand"},"name":{"kind":"Name","value":"brandV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FilterFieldValuesQuery, FilterFieldValuesQueryVariables>;
export const CreateOrderFromAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderFromAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrderFromAssortmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderFromAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderAssortmentSyncStatus"}}]}}]}}]}}]} as unknown as DocumentNode<CreateOrderFromAssortmentMutation, CreateOrderFromAssortmentMutationVariables>;
export const RequestAssortmentOrderUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestAssortmentOrderUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestAssortmentOrderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestAssortmentOrderUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderAssortmentSyncStatus"}}]}}]}}]}}]} as unknown as DocumentNode<RequestAssortmentOrderUpdateMutation, RequestAssortmentOrderUpdateMutationVariables>;
export const SendToBrandAssortmentQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SendToBrandAssortmentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendToBrandAssortmentQueryQuery, SendToBrandAssortmentQueryQueryVariables>;
export const retailersThatFavoritedBrandDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"retailersThatFavoritedBrandDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailersThatFavoritedBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"timeFavorited"}}]}}]}}]} as unknown as DocumentNode<retailersThatFavoritedBrandDupe1Query, retailersThatFavoritedBrandDupe1QueryVariables>;
export const accountConnectionStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountConnectionStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<accountConnectionStatusesQuery, accountConnectionStatusesQueryVariables>;
export const OrdersForStyleCancellationAggregatedTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersForStyleCancellationAggregatedTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productsFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderProductFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productsFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotal"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrdersForStyleCancellationAggregatedTotalsQuery, OrdersForStyleCancellationAggregatedTotalsQueryVariables>;
export const CreateSelfServeConfigMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSelfServeConfigMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createExportIntegrationConfigInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateExportIntegrationConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExportIntegrationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createExportIntegrationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSelfServeConfigMutationMutation, CreateSelfServeConfigMutationMutationVariables>;
export const ListSelfServeConfigsForAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListSelfServeConfigsForAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountExportIntegrationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"integrationTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ASSORTMENT_EXPORT"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"columnConfig"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"autoStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ftpPath"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"overwrittenFileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"fileNameParts"}},{"kind":"Field","name":{"kind":"Name","value":"textQualifier"}},{"kind":"Field","name":{"kind":"Name","value":"defaultClusterDoors"}},{"kind":"Field","name":{"kind":"Name","value":"removeHeader"}},{"kind":"Field","name":{"kind":"Name","value":"excludeSkusWithZeroQuantities"}},{"kind":"Field","name":{"kind":"Name","value":"doorQuantityColumn"}},{"kind":"Field","name":{"kind":"Name","value":"combineExportsIntoSingleFile"}},{"kind":"Field","name":{"kind":"Name","value":"csvDelimiter"}},{"kind":"Field","name":{"kind":"Name","value":"unzipFilesToFTPPath"}},{"kind":"Field","name":{"kind":"Name","value":"convertSingleDoorToCluster"}},{"kind":"Field","name":{"kind":"Name","value":"convertImagesUrlsToColumns"}},{"kind":"Field","name":{"kind":"Name","value":"fileNameDelimiter"}},{"kind":"Field","name":{"kind":"Name","value":"fileNamePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"csvEncodingType"}},{"kind":"Field","name":{"kind":"Name","value":"onlySkuQuantities"}}]}}]}}]} as unknown as DocumentNode<ListSelfServeConfigsForAccountQuery, ListSelfServeConfigsForAccountQueryVariables>;
export const UpdateSelfServeConfigMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSelfServeConfigMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateExportIntegrationConfigInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateExportIntegrationConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExportIntegrationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateExportIntegrationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSelfServeConfigMutationMutation, UpdateSelfServeConfigMutationMutationVariables>;
export const updateAccountUserDataPermissionConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountUserDataPermissionConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUserDataPermissionConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUserDataPermissionConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAccountUserDataPermissionConfigurationMutation, updateAccountUserDataPermissionConfigurationMutationVariables>;
export const bulkDeleteDataPermissionConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkDeleteDataPermissionConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteDataPermissionConfigurationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteDataPermissionConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<bulkDeleteDataPermissionConfigurationsMutation, bulkDeleteDataPermissionConfigurationsMutationVariables>;
export const acceptUserMembershipRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"acceptUserMembershipRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptUserMembershipRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptUserMembershipRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<acceptUserMembershipRequestMutation, acceptUserMembershipRequestMutationVariables>;
export const updateAccountPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountPermissionAccessInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAccountPermissionsMutation, updateAccountPermissionsMutationVariables>;
export const createUserMembershipInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUserMembershipInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserMembershipInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserMembershipInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipInvite"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]}}]} as unknown as DocumentNode<createUserMembershipInviteMutation, createUserMembershipInviteMutationVariables>;
export const brandUsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"brandUsersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dataPermissionConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<brandUsersQueryQuery, brandUsersQueryQueryVariables>;
export const dataPermissionConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataPermissionConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeViewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataPermissionConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"divisionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"divisionCategoryPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"division"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceTypePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<dataPermissionConfigurationsQuery, dataPermissionConfigurationsQueryVariables>;
export const assignedDataPermissionConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assignedDataPermissionConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserDataPermissionConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"divisionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"divisionCategoryPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"division"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceTypePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<assignedDataPermissionConfigurationQuery, assignedDataPermissionConfigurationQueryVariables>;
export const accountUserMembershipRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountUserMembershipRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserMembershipRequestFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userMembershipRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<accountUserMembershipRequestsQuery, accountUserMembershipRequestsQueryVariables>;
export const ActiveViewingAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveViewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeViewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ActiveViewingAccountQuery, ActiveViewingAccountQueryVariables>;
export const AccountPermissionsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountPermissionsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountPermissionsDupe1Query, AccountPermissionsDupe1QueryVariables>;
export const createDataPermissionConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createDataPermissionConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDataPermissionConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDataPermissionConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataPermissionConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<createDataPermissionConfigurationMutation, createDataPermissionConfigurationMutationVariables>;
export const updateDataPermissionConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDataPermissionConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDataPermissionConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDataPermissionConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataPermissionConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<updateDataPermissionConfigurationMutation, updateDataPermissionConfigurationMutationVariables>;
export const categoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"categoriesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentName"}},{"kind":"Field","name":{"kind":"Name","value":"department"}}]}}]}}]}}]}}]} as unknown as DocumentNode<categoriesQueryQuery, categoriesQueryQueryVariables>;
export const CollectionsQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe1Query, CollectionsQueryDupe1QueryVariables>;
export const dataPermissionConfigurationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"dataPermissionConfigurationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataPermissionConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"id"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"configuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"divisionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"divisionCategoryPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"division"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceTypePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<dataPermissionConfigurationQueryQuery, dataPermissionConfigurationQueryQueryVariables>;
export const PriceTypesQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesQueryDupe1Query, PriceTypesQueryDupe1QueryVariables>;
export const createRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRegionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"custom"}}]}}]}}]} as unknown as DocumentNode<createRegionMutation, createRegionMutationVariables>;
export const deleteRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteRegionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteRegionMutation, deleteRegionMutationVariables>;
export const updateRegionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateRegion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRegionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRegion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<updateRegionMutation, updateRegionMutationVariables>;
export const checkMergingOrderCriteriaDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkMergingOrderCriteriaDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedOrdersIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkMergingOrderCriteria"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedOrdersIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<checkMergingOrderCriteriaDupe1Query, checkMergingOrderCriteriaDupe1QueryVariables>;
export const OrderSettingsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderSettingsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"multipleDivisionsAllowed"}}]}}]}}]} as unknown as DocumentNode<OrderSettingsDupe1Query, OrderSettingsDupe1QueryVariables>;
export const OrderExportTaskStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderExportTaskStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListOrderExportTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOrderExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<OrderExportTaskStatusQuery, OrderExportTaskStatusQueryVariables>;
export const BulkSetOrdersToReexportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkSetOrdersToReexport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkSetOrdersToReexportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkSetOrdersToReexport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<BulkSetOrdersToReexportMutation, BulkSetOrdersToReexportMutationVariables>;
export const salesRepQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"salesRepQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInactives"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeInactives"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInactives"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<salesRepQueryQuery, salesRepQueryQueryVariables>;
export const UpdatePaymentSettingsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentSettingsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"retailersCanSeeInvoices"}},{"kind":"Field","name":{"kind":"Name","value":"sendBrandMailPaymentProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"sendRetailerMailPaymentProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"brandNotificationEmail"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentSettingsMutationMutation, UpdatePaymentSettingsMutationMutationVariables>;
export const UpdatePaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAvailablePaymentMethodsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAvailablePaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isSepaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isAchEnabled"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentMethodsMutation, UpdatePaymentMethodsMutationVariables>;
export const connectPaymentProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"connectPaymentProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectPaymentProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectPaymentProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProvider"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]} as unknown as DocumentNode<connectPaymentProviderMutation, connectPaymentProviderMutationVariables>;
export const updateAccountProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectPaymentProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProvider"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]} as unknown as DocumentNode<updateAccountProviderMutation, updateAccountProviderMutationVariables>;
export const paymentProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paymentProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"connectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}}]}}]}}]} as unknown as DocumentNode<paymentProvidersQuery, paymentProvidersQueryVariables>;
export const updateAccountUserGeoRestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountUserGeoRestrictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUserGeoRestrictionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUserGeoRestrictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAccountUserGeoRestrictionsMutation, updateAccountUserGeoRestrictionsMutationVariables>;
export const updateAccountUsersPermissionAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountUsersPermissionAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUsersPermissionAccessInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUsersPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<updateAccountUsersPermissionAccessMutation, updateAccountUsersPermissionAccessMutationVariables>;
export const updateAccountUserPossibleExceptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAccountUserPossibleExceptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUserPossibleExceptionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUserPossibleExceptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<updateAccountUserPossibleExceptionsMutation, updateAccountUserPossibleExceptionsMutationVariables>;
export const AccountUserGeoRestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountUserGeoRestrictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserGeoRestrictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"regionAssignedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"exceptionAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"possibleExceptionAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AccountUserGeoRestrictionsQuery, AccountUserGeoRestrictionsQueryVariables>;
export const RegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Regions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegionsQuery, RegionsQueryVariables>;
export const accountUserPermissionAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountUserPermissionAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<accountUserPermissionAccessQuery, accountUserPermissionAccessQueryVariables>;
export const ProductTraitValuesQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTraitValuesQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTraitValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductTraitValuesQueryDupe1Query, ProductTraitValuesQueryDupe1QueryVariables>;
export const StyleTagsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleTagsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueTagValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleTagsDupe1Query, StyleTagsDupe1QueryVariables>;
export const BadgesDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BadgesDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BadgesDupe1Query, BadgesDupe1QueryVariables>;
export const retailerBrandsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"retailerBrandsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<retailerBrandsQueryQuery, retailerBrandsQueryQueryVariables>;
export const orderSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"minUnits"}},{"kind":"Field","name":{"kind":"Name","value":"minAmount"}},{"kind":"Field","name":{"kind":"Name","value":"minDetail"}}]}}]}}]} as unknown as DocumentNode<orderSettingsQuery, orderSettingsQueryVariables>;
export const noteVariantsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"noteVariantsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddVariantsInProgressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addVariantsInProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderIds"}}]}}]}}]} as unknown as DocumentNode<noteVariantsDupe1Mutation, noteVariantsDupe1MutationVariables>;
export const CreateOrphanRetailerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrphanRetailer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectionProcessed"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrphanRetailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerEmail"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"connectionProcessed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectionProcessed"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"retailerCode"}},{"kind":"Field","name":{"kind":"Name","value":"connectionProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"update"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<CreateOrphanRetailerMutation, CreateOrphanRetailerMutationVariables>;
export const CombinedCollectionsAndProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CombinedCollectionsAndProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionProductsFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionsBrandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionProductsBrandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionProductGroupByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionProductOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productVideosAreEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionsBrandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionProductsFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionProductsBrandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"casepacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productVideosAreEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"priceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"minRetailValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetailValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CombinedCollectionsAndProductsQuery, CombinedCollectionsAndProductsQueryVariables>;
export const collectionProductsGroupTotalQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsGroupTotalQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsGroupTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductsGroupTotalQueryQuery, collectionProductsGroupTotalQueryQueryVariables>;
export const collectionProductsTotalQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsTotalQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}]}]}}]} as unknown as DocumentNode<collectionProductsTotalQueryDupe1Query, collectionProductsTotalQueryDupe1QueryVariables>;
export const WarehousesQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehousesQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableOn"}},{"kind":"Field","name":{"kind":"Name","value":"isImmediate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WarehousesQueryDupe1Query, WarehousesQueryDupe1QueryVariables>;
export const aggregateSkuInventoryItemsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"aggregateSkuInventoryItemsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregateSkuInventoryItemsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateSkuInventoryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"warehouseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouseIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeImmediate"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"skuId"}}]}}]}}]}}]} as unknown as DocumentNode<aggregateSkuInventoryItemsDupe1Query, aggregateSkuInventoryItemsDupe1QueryVariables>;
export const variantsInCartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"variantsInCart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orphanRetailerIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantsInCart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orphanRetailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orphanRetailerIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"door"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<variantsInCartQuery, variantsInCartQueryVariables>;
export const CollectionProductsByShareTokenQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsByShareTokenQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsByShareToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"minRetailValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetailValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsByShareTokenQueryQuery, CollectionProductsByShareTokenQueryQueryVariables>;
export const createConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<createConfigurationMutation, createConfigurationMutationVariables>;
export const updateConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<updateConfigurationMutation, updateConfigurationMutationVariables>;
export const deleteConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteConfigurationMutation, deleteConfigurationMutationVariables>;
export const deliveryReportFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deliveryReportFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryReportFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}]}}]} as unknown as DocumentNode<deliveryReportFeatureQuery, deliveryReportFeatureQueryVariables>;
export const brandProfileNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"brandProfileName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<brandProfileNameQuery, brandProfileNameQueryVariables>;
export const configurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"projectName"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"sharedUserIds"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<configurationsQuery, configurationsQueryVariables>;
export const LookQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lookId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"look"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lookId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"COLOR","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textContents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"layoutKey"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}}]}}]}}]}}]} as unknown as DocumentNode<LookQueryQuery, LookQueryQueryVariables>;
export const PriceRangeGroupsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceRangeGroupsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRangeGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"PRICE_TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceRangeGroupsDupe1Query, PriceRangeGroupsDupe1QueryVariables>;
export const UpdateCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShowroomCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShowroomCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToAllConnected"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const PriceRangeGroupsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceRangeGroupsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRangeGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"PRICE_TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceRangeGroupsDupe2Query, PriceRangeGroupsDupe2QueryVariables>;
export const CollectionsQueryDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowroomCollectionsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowroomCollectionOrderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fetchAllInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAllInfo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAllInfo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleToAllConnected"}},{"kind":"Field","name":{"kind":"Name","value":"url3dShowroom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastModified"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionShares"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareDate"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe3Query, CollectionsQueryDupe3QueryVariables>;
export const ShowroomCollectionListFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShowroomCollectionListFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShowroomCollectionStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionListFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ShowroomCollectionListFiltersQuery, ShowroomCollectionListFiltersQueryVariables>;
export const Url3dShowroomQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Url3dShowroomQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Url3dShowroomFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url3dShowroom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}}]}}]} as unknown as DocumentNode<Url3dShowroomQueryQuery, Url3dShowroomQueryQueryVariables>;
export const UpsertUrl3dShowroomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertUrl3dShowroom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertUrl3dShowroomInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertUrl3dShowroom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertUrl3dShowroomMutation, UpsertUrl3dShowroomMutationVariables>;
export const DeleteUrl3dShowroomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUrl3dShowroom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUrl3dShowroomInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUrl3dShowroom"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ids"}}]}}]}}]} as unknown as DocumentNode<DeleteUrl3dShowroomMutation, DeleteUrl3dShowroomMutationVariables>;
export const AddStyleboardCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddStyleboardComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddStyleboardCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addStyleboardComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountProfileName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<AddStyleboardCommentMutation, AddStyleboardCommentMutationVariables>;
export const StyleboardCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleboardComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountProfileName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taggedAccountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardCommentsQuery, StyleboardCommentsQueryVariables>;
export const VisibleUsersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisibleUsersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboardVisibleToAccountUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"styleboardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisibleUsersQueryQuery, VisibleUsersQueryQueryVariables>;
export const UpdateStyleboardsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStyleboardsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateStyleboardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStyleboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateStyleboardsDupe1Mutation, UpdateStyleboardsDupe1MutationVariables>;
export const UpsertStyleboardDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertStyleboardDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertStyleboardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertStyleboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastModified"}}]}}]}}]} as unknown as DocumentNode<UpsertStyleboardDupe1Mutation, UpsertStyleboardDupe1MutationVariables>;
export const PriceRangeGroupsDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceRangeGroupsDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceRangeGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"PRICE_TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceRangeGroupsDupe3Query, PriceRangeGroupsDupe3QueryVariables>;
export const UpdateStyleboardsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStyleboardsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateStyleboardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStyleboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateStyleboardsDupe2Mutation, UpdateStyleboardsDupe2MutationVariables>;
export const StyleboardBrandWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleboardBrandWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardBrandWarehousesQuery, StyleboardBrandWarehousesQueryVariables>;
export const StyleboardsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleboardsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StyleboardsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StyleboardOrderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fetchAllInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAllInfo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAllInfo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"lastModified"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"styleboardShares"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardsQueryQuery, StyleboardsQueryQueryVariables>;
export const StyleboardListFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleboardListFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StyleboardStatus"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboardListFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ownerUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardListFiltersQuery, StyleboardListFiltersQueryVariables>;
export const StyleboardCommentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleboardCommentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastLogin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboardComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdStartDateTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastLogin"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardCommentsQueryQuery, StyleboardCommentsQueryQueryVariables>;
export const IdConfigsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IdConfigsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idpConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"ssoLoginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"acsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"sigCert"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IdConfigsQueryQuery, IdConfigsQueryQueryVariables>;
export const CreateIdentityProviderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIdentityProviderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIdentityProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIdentityProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"idpConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"ssoLoginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"acsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"sigCert"}}]}}]}}]}}]} as unknown as DocumentNode<CreateIdentityProviderMutationMutation, CreateIdentityProviderMutationMutationVariables>;
export const UpdateIdentityProviderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIdentityProviderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIdentityProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIdentityProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"idpConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"domain"}},{"kind":"Field","name":{"kind":"Name","value":"ssoLoginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"acsUrl"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"sigCert"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateIdentityProviderMutationMutation, UpdateIdentityProviderMutationMutationVariables>;
export const DeleteIdentityProviderMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteIdentityProviderMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteIdentityProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIdentityProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteIdentityProviderMutationMutation, DeleteIdentityProviderMutationMutationVariables>;
export const externalProviderAuthsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"externalProviderAuths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalProviderAuths"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}}]}}]} as unknown as DocumentNode<externalProviderAuthsQuery, externalProviderAuthsQueryVariables>;
export const createExternalProviderAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createExternalProviderAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateExternalProviderAuthInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExternalProviderAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}}]}}]} as unknown as DocumentNode<createExternalProviderAuthMutation, createExternalProviderAuthMutationVariables>;
export const bulkDeleteExternalProviderAuthsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkDeleteExternalProviderAuths"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteExternalProviderAuthsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteExternalProviderAuths"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalProviderAuthsIds"}}]}}]}}]} as unknown as DocumentNode<bulkDeleteExternalProviderAuthsMutation, bulkDeleteExternalProviderAuthsMutationVariables>;
export const userQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<userQueryQuery, userQueryQueryVariables>;
export const BulkUpdateAssortmentDetailsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateAssortmentDetailsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAssortmentDetailsInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateAssortmentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentIds"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateAssortmentDetailsMutationMutation, BulkUpdateAssortmentDetailsMutationMutationVariables>;
export const CreateAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailCurrencyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wholesaleCurrencyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wholesaleCurrencyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wholesaleCurrencyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailCurrencyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailCurrencyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAssortmentMutation, CreateAssortmentMutationVariables>;
export const CreateRetailWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRetailWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRetailWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailWorkspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRetailWorkspaceMutation, CreateRetailWorkspaceMutationVariables>;
export const CopyAssortmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CopyAssortments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"copyAssortments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CopyAssortmentsMutation, CopyAssortmentsMutationVariables>;
export const AccountSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountSeasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountSeasonsQuery, AccountSeasonsQueryVariables>;
export const BrandNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssortmentFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentsQuery"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BrandNotesQuery, BrandNotesQueryVariables>;
export const upsertAccountConnectionStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertAccountConnectionStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAccountConnectionStatusesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAccountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<upsertAccountConnectionStatusesMutation, upsertAccountConnectionStatusesMutationVariables>;
export const getAccountCustomerCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccountCustomerCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountCustomerCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"otherAccountIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"otherAccountId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<getAccountCustomerCodesQuery, getAccountCustomerCodesQueryVariables>;
export const retailersThatFavoritedBrandDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"retailersThatFavoritedBrandDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailersThatFavoritedBrand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"IntValue","value":"365"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tradeShowEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeFavorited"}}]}}]}}]} as unknown as DocumentNode<retailersThatFavoritedBrandDupe2Query, retailersThatFavoritedBrandDupe2QueryVariables>;
export const retailerProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"retailerProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"topBrands"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}}]}}]}}]}}]}}]} as unknown as DocumentNode<retailerProfilesQuery, retailerProfilesQueryVariables>;
export const ACCOUNT_CONNECTION_STATUSESDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ACCOUNT_CONNECTION_STATUSESDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ACCOUNT_CONNECTION_STATUSESDupe2Query, ACCOUNT_CONNECTION_STATUSESDupe2QueryVariables>;
export const UploadBulkStyleImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadBulkStyleImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadBulkStyleImageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadBulkStyleImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}}]}}]} as unknown as DocumentNode<UploadBulkStyleImageMutationMutation, UploadBulkStyleImageMutationMutationVariables>;
export const ImagesUploaderProcessMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImagesUploaderProcessMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filePath"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileNameParts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploaderFileNameParts"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"separator"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlyProductLevel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replace"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customSorting"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imagesUploaderProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filePath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filePath"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileNameParts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileNameParts"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"separator"},"value":{"kind":"Variable","name":{"kind":"Name","value":"separator"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlyProductLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlyProductLevel"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"replace"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replace"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"customSorting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customSorting"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}}]}}]} as unknown as DocumentNode<ImagesUploaderProcessMutationMutation, ImagesUploaderProcessMutationMutationVariables>;
export const LinesheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Linesheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinesheetsQuery, LinesheetsQueryVariables>;
export const ListConnectionBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListConnectionBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionBuyersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionBuyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ListConnectionBuyersQuery, ListConnectionBuyersQueryVariables>;
export const CreateConnectionBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateConnectionBuyerInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionBuyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connection_buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<CreateConnectionBuyersMutation, CreateConnectionBuyersMutationVariables>;
export const UpdateConnectionBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConnectionBuyerInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionBuyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connection_buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionBuyersMutation, UpdateConnectionBuyersMutationVariables>;
export const DeleteConnectionBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteConnectionBuyerInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionBuyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connection_buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteConnectionBuyersMutation, DeleteConnectionBuyersMutationVariables>;
export const ListConnectionDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListConnectionDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionDiscountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"divisionId"}}]}}]}}]} as unknown as DocumentNode<ListConnectionDiscountsQuery, ListConnectionDiscountsQueryVariables>;
export const BrandsDivisionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsDivisions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"divisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandsDivisionsQuery, BrandsDivisionsQueryVariables>;
export const CreateConnectionDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateConnectionDiscountInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectionDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"divisionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<CreateConnectionDiscountsMutation, CreateConnectionDiscountsMutationVariables>;
export const UpdateConnectionDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConnectionDiscountInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectionDiscounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"divisionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionDiscountsMutation, UpdateConnectionDiscountsMutationVariables>;
export const DeleteConnectionDiscountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionDiscounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteConnectionDiscountInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ids"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteConnectionDiscountsMutation, DeleteConnectionDiscountsMutationVariables>;
export const ConnectionShippingAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectionShippingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConnectionShippingAddressesQuery, ConnectionShippingAddressesQueryVariables>;
export const ListConnectionDoorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListConnectionDoors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionDoorsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddressId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}}]}}]}}]} as unknown as DocumentNode<ListConnectionDoorsQuery, ListConnectionDoorsQueryVariables>;
export const CreateConnectionDoorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionDoors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionDoorInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddressId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}}]}}]}}]} as unknown as DocumentNode<CreateConnectionDoorsMutation, CreateConnectionDoorsMutationVariables>;
export const UpdateConnectionDoorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionDoors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionDoorInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddressId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionDoorsMutation, UpdateConnectionDoorsMutationVariables>;
export const DeleteConnectionDoorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionDoors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionDoorInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteConnectionDoorsMutation, DeleteConnectionDoorsMutationVariables>;
export const BrandsPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandsPaymentMethodsQuery, BrandsPaymentMethodsQueryVariables>;
export const ConnectionPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectionPaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionPaymentMethodsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionPaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<ConnectionPaymentMethodsQuery, ConnectionPaymentMethodsQueryVariables>;
export const CreateConnectionPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionPaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionPaymentMethodInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionPaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<CreateConnectionPaymentMethodsMutation, CreateConnectionPaymentMethodsMutationVariables>;
export const UpdateConnectionPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionPaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionPaymentMethodInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionPaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionPaymentMethodsMutation, UpdateConnectionPaymentMethodsMutationVariables>;
export const DeleteConnectionPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionPaymentMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionPaymentMethodInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionPaymentMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteConnectionPaymentMethodsMutation, DeleteConnectionPaymentMethodsMutationVariables>;
export const BrandPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandPriceTypesQuery, BrandPriceTypesQueryVariables>;
export const BrandTermsAndConditionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandTermsAndConditions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandTermsAndConditionsQuery, BrandTermsAndConditionsQueryVariables>;
export const ListConnectionPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListConnectionPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionPriceTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionPriceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ListConnectionPriceTypesQuery, ListConnectionPriceTypesQueryVariables>;
export const CreateConnectionPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateConnectionPriceTypeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionPriceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectionPriceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<CreateConnectionPriceTypesMutation, CreateConnectionPriceTypesMutationVariables>;
export const UpdateConnectionPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConnectionPriceTypeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionPriceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectionPriceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionPriceTypesMutation, UpdateConnectionPriceTypesMutationVariables>;
export const DeleteConnectionPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteConnectionPriceTypeInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionPriceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ids"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"details"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteConnectionPriceTypesMutation, DeleteConnectionPriceTypesMutationVariables>;
export const BrandsShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsShippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandsShippingMethodsQuery, BrandsShippingMethodsQueryVariables>;
export const ConnectionShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectionShippingMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionShippingMethodsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionShippingMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<ConnectionShippingMethodsQuery, ConnectionShippingMethodsQueryVariables>;
export const CreateConnectionShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionShippingMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionShippingMethodInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionShippingMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<CreateConnectionShippingMethodsMutation, CreateConnectionShippingMethodsMutationVariables>;
export const UpdateConnectionShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionShippingMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionShippingMethodInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionShippingMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionShippingMethodsMutation, UpdateConnectionShippingMethodsMutationVariables>;
export const DeleteConnectionShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionShippingMethods"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionShippingMethodInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionShippingMethods"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteConnectionShippingMethodsMutation, DeleteConnectionShippingMethodsMutationVariables>;
export const BrandsWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsWarehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandsWarehousesQuery, BrandsWarehousesQueryVariables>;
export const ConnectionWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectionWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionWarehousesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionWarehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouseId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<ConnectionWarehousesQuery, ConnectionWarehousesQueryVariables>;
export const CreateConnectionWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConnectionWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionWarehouseInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConnectionWarehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouseId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<CreateConnectionWarehousesMutation, CreateConnectionWarehousesMutationVariables>;
export const UpdateConnectionWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnectionWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionWarehouseInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConnectionWarehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouseId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionWarehousesMutation, UpdateConnectionWarehousesMutationVariables>;
export const DeleteConnectionWarehousesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConnectionWarehouses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionWarehouseInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConnectionWarehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteConnectionWarehousesMutation, DeleteConnectionWarehousesMutationVariables>;
export const ConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Connection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectedAccountIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"connectionId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"publicRetailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConnectionQuery, ConnectionQueryVariables>;
export const UpdateConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAccountCustomerCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAccountCustomerCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<UpdateConnectionMutation, UpdateConnectionMutationVariables>;
export const ConnectAccountsThroughJiraMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConnectAccountsThroughJiraMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectAccountsThroughJira"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<ConnectAccountsThroughJiraMutationMutation, ConnectAccountsThroughJiraMutationMutationVariables>;
export const SubscribeUserToFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubscribeUserToFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubscribeUserToFeatureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscribeUserToFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SubscribeUserToFeatureMutation, SubscribeUserToFeatureMutationVariables>;
export const UnSubscribeUserToFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnSubscribeUserToFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnSubscribeUserToFeatureInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unSubscribeUserToFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UnSubscribeUserToFeatureMutation, UnSubscribeUserToFeatureMutationVariables>;
export const FindNewBrandsSendConnectionRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FindNewBrandsSendConnectionRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAccountConnectionStatusesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAccountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<FindNewBrandsSendConnectionRequestMutation, FindNewBrandsSendConnectionRequestMutationVariables>;
export const FindNewBrandsSendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FindNewBrandsSendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threadId"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<FindNewBrandsSendMessageMutation, FindNewBrandsSendMessageMutationVariables>;
export const FindNewBrandsAddFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FindNewBrandsAddFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFavoriteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFavoriteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandAccountId"}}]}}]}}]} as unknown as DocumentNode<FindNewBrandsAddFavoriteMutation, FindNewBrandsAddFavoriteMutationVariables>;
export const FindNewBrandsDeleteFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FindNewBrandsDeleteFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFavoriteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFavoriteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<FindNewBrandsDeleteFavoriteMutation, FindNewBrandsDeleteFavoriteMutationVariables>;
export const FindNewBrandsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindNewBrandsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchBrandsFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"customProfileImageUrls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lookbooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connected"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<FindNewBrandsPageQuery, FindNewBrandsPageQueryVariables>;
export const FindNewBrandsGetBrandProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindNewBrandsGetBrandProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"retailMin"}},{"kind":"Field","name":{"kind":"Name","value":"retailMax"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customProfileImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"connected"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindNewBrandsGetBrandProfileQuery, FindNewBrandsGetBrandProfileQueryVariables>;
export const SearchBrandsCurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchBrandsCurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchBrandsCurrenciesQuery, SearchBrandsCurrenciesQueryVariables>;
export const RetailerCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerCategoriesQuery, RetailerCategoriesQueryVariables>;
export const retailerFavoriteBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"retailerFavoriteBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoritedBrandsByRetailAccountUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<retailerFavoriteBrandQuery, retailerFavoriteBrandQueryVariables>;
export const InvitationMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvitationMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inviteMessage"}}]}}]}}]} as unknown as DocumentNode<InvitationMessageQuery, InvitationMessageQueryVariables>;
export const SearchBrandsCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchBrandsCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchBrandCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchBrandsCategoriesQuery, SearchBrandsCategoriesQueryVariables>;
export const ListTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountExportIntegrationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"integrationTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PRODUCT_EXPORT"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"columnConfig"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<ListTemplatesQuery, ListTemplatesQueryVariables>;
export const PriceTypesDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesDupe1Query, PriceTypesDupe1QueryVariables>;
export const BrandsDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandsDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tagGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandsDupe3Query, BrandsDupe3QueryVariables>;
export const CreateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createExportIntegrationConfigInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateExportIntegrationConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExportIntegrationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createExportIntegrationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const UpdateTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateExportIntegrationConfigInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateExportIntegrationConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExportIntegrationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateExportIntegrationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<UpdateTemplateMutation, UpdateTemplateMutationVariables>;
export const DeleteTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteExportIntegrationConfigInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteExportIntegrationConfigsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExportIntegrationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteExportIntegrationConfigInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const ListMonitoringJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListMonitoringJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListMonitoringJobsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMonitoringJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputData"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errorDetails"}},{"kind":"Field","name":{"kind":"Name","value":"outputData"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<ListMonitoringJobsQuery, ListMonitoringJobsQueryVariables>;
export const FindNewRetailersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindNewRetailers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LGFindRetailersFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LGFindRetailersOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"brandsCarried"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"autoConnect"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"submissionRecipients"}},{"kind":"Field","name":{"kind":"Name","value":"allRecipientsContacted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindNewRetailersQuery, FindNewRetailersQueryVariables>;
export const FindNewRetailersAsyncDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindNewRetailersAsyncData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LGFindRetailersFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LGFindRetailersOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"submission"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasBeenAwarded"}},{"kind":"Field","name":{"kind":"Name","value":"submissionRecipients"}},{"kind":"Field","name":{"kind":"Name","value":"allRecipientsContacted"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindNewRetailersAsyncDataQuery, FindNewRetailersAsyncDataQueryVariables>;
export const LGFindRetailersCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LGFindRetailersCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProductLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<LGFindRetailersCategoriesQuery, LGFindRetailersCategoriesQueryVariables>;
export const FindBrandsCarriedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindBrandsCarried"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findBrandsCarried"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FindBrandsCarriedQuery, FindBrandsCarriedQueryVariables>;
export const SubmissionAuthorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionAuthors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissionAuthors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserActive"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionAuthorsQuery, SubmissionAuthorsQueryVariables>;
export const ProspectsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FindProspectsOrderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FindProspectsFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionsOrderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmissionsOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findProspects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"autoConnect"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"brandsCarried"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"submissionsOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionsOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalActivitiesCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserTitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccountUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activityType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"submissionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"connectionRequestInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccountId"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProspectsPageQuery, ProspectsPageQueryVariables>;
export const UpdateRetailerProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRetailerProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRetailerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRetailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateRetailerProfileMutation, UpdateRetailerProfileMutationVariables>;
export const BulkUpsertRetailerUploadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpsertRetailerUploads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpsertRetailerUploadsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpsertRetailerUploads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerUploadIds"}}]}}]}}]} as unknown as DocumentNode<BulkUpsertRetailerUploadsMutation, BulkUpsertRetailerUploadsMutationVariables>;
export const BulkDeleteRetailerUploadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteRetailerUploads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteRetailerUploadsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteRetailerUploads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerUploadIds"}}]}}]}}]} as unknown as DocumentNode<BulkDeleteRetailerUploadsMutation, BulkDeleteRetailerUploadsMutationVariables>;
export const BulkUpsertRetailerLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpsertRetailerLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpsertRetailerLocationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpsertRetailerLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpsertRetailerLocationsMutation, BulkUpsertRetailerLocationsMutationVariables>;
export const BulkDeleteRetailerLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteRetailerLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteRetailerLocationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteRetailerLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerLocationIds"}}]}}]}}]} as unknown as DocumentNode<BulkDeleteRetailerLocationMutation, BulkDeleteRetailerLocationMutationVariables>;
export const RetailerLocationCountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerLocationCountries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"StringValue","value":"COUNTRY","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerLocationCountriesQuery, RetailerLocationCountriesQueryVariables>;
export const RetailerProfileStatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerProfileStates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"states"},"name":{"kind":"Name","value":"geographies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"STATE","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geographyParentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerProfileStatesQuery, RetailerProfileStatesQueryVariables>;
export const ClienteleDescriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClienteleDescriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listClienteleDescriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClienteleDescriptionsQuery, ClienteleDescriptionsQueryVariables>;
export const ClienteleInterestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClienteleInterests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listClienteleInterests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ClienteleInterestsQuery, ClienteleInterestsQueryVariables>;
export const ProductLinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProductLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductLinesQuery, ProductLinesQueryVariables>;
export const AllBrandsAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllBrandsAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllBrandsAccountsQuery, AllBrandsAccountsQueryVariables>;
export const RetailerProfileTitleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerProfileTitleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RetailerProfileTitleQueryQuery, RetailerProfileTitleQueryQueryVariables>;
export const RetailerProfilePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerProfilePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isBrandAccount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileSnoozeCounter"}},{"kind":"Field","name":{"kind":"Name","value":"autoConnect"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"profileCompleteness"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"taxId"}},{"kind":"Field","name":{"kind":"Name","value":"taxIdCountry"}},{"kind":"Field","name":{"kind":"Name","value":"yearsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"brandsOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"categoriesOrdered"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clienteleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"male"}},{"kind":"Field","name":{"kind":"Name","value":"female"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandsCarried"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"clienteleInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"age"}},{"kind":"Field","name":{"kind":"Name","value":"male"}},{"kind":"Field","name":{"kind":"Name","value":"female"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"interests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandsCarried"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}}]}},{"kind":"Field","name":{"kind":"Name","value":"people"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"submissions"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isBrandAccount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountSubmission"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isBrandAccount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"awards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"awardBadgeUrl"}}]}}]}}]}}]} as unknown as DocumentNode<RetailerProfilePageQueryQuery, RetailerProfilePageQueryQueryVariables>;
export const VisitRetailerProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VisitRetailerProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisitRetailerProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visitRetailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<VisitRetailerProfileMutation, VisitRetailerProfileMutationVariables>;
export const AcceptRequestConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptRequestConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptRequestConnectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptRequestConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<AcceptRequestConnectionMutation, AcceptRequestConnectionMutationVariables>;
export const ValidateTaxIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateTaxId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taxId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateTaxId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"taxId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taxId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ValidateTaxIdQuery, ValidateTaxIdQueryVariables>;
export const SendSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"sendSubmissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendSubmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SendSubmissionMutation, SendSubmissionMutationVariables>;
export const AddLinesheetModalQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddLinesheetModalQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"skipLimitByProfileSettings"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasProducts"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}}]}}]}}]}}]} as unknown as DocumentNode<AddLinesheetModalQueryQuery, AddLinesheetModalQueryQueryVariables>;
export const get8ProductsForSubmissionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"get8ProductsForSubmissionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skipLimitByProfileSettings"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"productPagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"8"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"swatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<get8ProductsForSubmissionQueryQuery, get8ProductsForSubmissionQueryQueryVariables>;
export const SubmissionContactPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionContactPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isBuyer"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}}]}},{"kind":"Field","name":{"kind":"Name","value":"people"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"submissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"connectionRequestStatus"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]} as unknown as DocumentNode<SubmissionContactPageQueryQuery, SubmissionContactPageQueryQueryVariables>;
export const GenerateAiMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateAiMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientAccountUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientAccountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSubmissionMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"recipientAccountUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientAccountUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipientAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientAccountId"}}}]}]}}]} as unknown as DocumentNode<GenerateAiMessageQuery, GenerateAiMessageQueryVariables>;
export const GeneralCategoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GeneralCategoriesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProductLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GeneralCategoriesQueryQuery, GeneralCategoriesQueryQueryVariables>;
export const UpdateSubmissionSenderProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSubmissionSenderProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSubmissionSenderProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubmissionSenderProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}}]}}]}}]} as unknown as DocumentNode<UpdateSubmissionSenderProfileMutation, UpdateSubmissionSenderProfileMutationVariables>;
export const SubmissionHeaderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionHeaderQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissionTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"headerImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionHeaderQueryQuery, SubmissionHeaderQueryQueryVariables>;
export const CreateSubmissionTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSubmissionTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createSubmissionTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"createSubmissionTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubmissionTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createSubmissionTemplateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSubmissionTemplateMutation, CreateSubmissionTemplateMutationVariables>;
export const UpdateSubmissionTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSubmissionTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateSubmissionTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateSubmissionTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSubmissionTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateSubmissionTemplateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"headerImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateSubmissionTemplateMutation, UpdateSubmissionTemplateMutationVariables>;
export const SendSubmissionConnectionRequestPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SendSubmissionConnectionRequestPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"priceTypeAndTermsConditions"},"name":{"kind":"Name","value":"lgGetRequestConnectionData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currencyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SendSubmissionConnectionRequestPriceTypesQuery, SendSubmissionConnectionRequestPriceTypesQueryVariables>;
export const RetailerListViewSubmissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerListViewSubmissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmissionsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"personalizedMessage"}},{"kind":"Field","name":{"kind":"Name","value":"headerImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserPictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerListViewSubmissionsQuery, RetailerListViewSubmissionsQueryVariables>;
export const SubmissionsListFiltersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionsListFiltersCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pendingSubmissions"},"name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectionRequestStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NEW"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"acceptedSubmissions"},"name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectionRequestStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ACCEPTED"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"declinedSubmissions"},"name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectionRequestStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DECLINED"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"oldSubmissions"},"name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectionRequestStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NON_EXISTENT"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SubmissionsListFiltersCountQuery, SubmissionsListFiltersCountQueryVariables>;
export const SubmissionPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"submissionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"submissionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"connectionRequestInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"recipientAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserTitle"}},{"kind":"Field","name":{"kind":"Name","value":"accountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserPictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"brandsCarried"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUrl"}},{"kind":"Field","name":{"kind":"Name","value":"facebookUrl"}},{"kind":"Field","name":{"kind":"Name","value":"instagramUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"personalizedMessage"}},{"kind":"Field","name":{"kind":"Name","value":"submissionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activityType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"8"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"swatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserName"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserTitle"}},{"kind":"Field","name":{"kind":"Name","value":"accountProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserPictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"twitterUrl"}},{"kind":"Field","name":{"kind":"Name","value":"facebookUrl"}},{"kind":"Field","name":{"kind":"Name","value":"instagramUrl"}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionPageQueryQuery, SubmissionPageQueryQueryVariables>;
export const NewSubmissionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewSubmissionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmissionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"submissionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"headerImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewSubmissionsQueryQuery, NewSubmissionsQueryQueryVariables>;
export const ReplySubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplySubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReplySubmissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replySubmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageId"}}]}}]}}]} as unknown as DocumentNode<ReplySubmissionMutation, ReplySubmissionMutationVariables>;
export const ViewSubmissionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ViewSubmission"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewSubmissionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewSubmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ViewSubmissionMutation, ViewSubmissionMutationVariables>;
export const getPaginatedProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPaginatedProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"skipLimitByProfileSettings"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"swatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<getPaginatedProductsQuery, getPaginatedProductsQueryVariables>;
export const SubmissionAccountConnectionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionAccountConnectionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherAccountIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionAccountConnectionStatusQuery, SubmissionAccountConnectionStatusQueryVariables>;
export const SubmissionAcceptRequestConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmissionAcceptRequestConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptRequestConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SubmissionAcceptRequestConnectionMutation, SubmissionAcceptRequestConnectionMutationVariables>;
export const SubmissionUndoDeclinedConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmissionUndoDeclinedConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"undoDeclinedConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SubmissionUndoDeclinedConnectionMutation, SubmissionUndoDeclinedConnectionMutationVariables>;
export const SubmissionSendConnectionRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmissionSendConnectionRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAccountConnectionStatusesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAccountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionSendConnectionRequestMutation, SubmissionSendConnectionRequestMutationVariables>;
export const SubmissionDeclineConnectionRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmissionDeclineConnectionRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAccountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherAccountConnectionActions"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"otherAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"action"},"value":{"kind":"EnumValue","value":"DECLINE"}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionDeclineConnectionRequestMutation, SubmissionDeclineConnectionRequestMutationVariables>;
export const ConnectionModalDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConnectionModalData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lgGetRequestConnectionData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteMessage"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currencyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherUserBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currencyName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConnectionModalDataQuery, ConnectionModalDataQueryVariables>;
export const RequestConnectionToRetailerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestConnectionToRetailer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestConnectionToRetailerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestConnectionToRetailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"connectionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<RequestConnectionToRetailerMutation, RequestConnectionToRetailerMutationVariables>;
export const SendMessageToConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessageToConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessageToConnection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"recipientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"uploadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messageId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SendMessageToConnectionMutation, SendMessageToConnectionMutationVariables>;
export const noteVariantsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"noteVariantsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddVariantsInProgressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addVariantsInProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderIds"}}]}}]}}]} as unknown as DocumentNode<noteVariantsDupe2Mutation, noteVariantsDupe2MutationVariables>;
export const SkusInAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SkusInAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"style"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SkusInAssortmentQuery, SkusInAssortmentQueryVariables>;
export const ProductVariantsAndSkusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariantsAndSkus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductVariantsAndSkusQuery, ProductVariantsAndSkusQueryVariables>;
export const BadgesDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BadgesDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BadgesDupe2Query, BadgesDupe2QueryVariables>;
export const CollectionProductsBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsBasicInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsBasicInfoQuery, CollectionProductsBasicInfoQueryVariables>;
export const CollectionProductsEditModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsEditMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"groupedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsEditModeQuery, CollectionProductsEditModeQueryVariables>;
export const collectionProductsGroupTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsGroupTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionProductGroupByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsGroupTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<collectionProductsGroupTotalQuery, collectionProductsGroupTotalQueryVariables>;
export const CollectionProductsViewModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsViewMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionProductGroupByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionProductOrderByInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productVideosAreEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"groupedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productVideosAreEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"priceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"minRetailValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsViewModeQuery, CollectionProductsViewModeQueryVariables>;
export const aggregateSkuInventoryItemsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"aggregateSkuInventoryItemsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregateSkuInventoryItemsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateSkuInventoryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"warehouseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouseIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeImmediate"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"skuId"}}]}}]}}]}}]} as unknown as DocumentNode<aggregateSkuInventoryItemsDupe2Query, aggregateSkuInventoryItemsDupe2QueryVariables>;
export const CollectionProductsByShareTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsByShareToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsByShareToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"minRetailValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetailValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsByShareTokenQuery, CollectionProductsByShareTokenQueryVariables>;
export const UpdateLinesheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLinesheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareWithRetailersInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareCollectionsWithRetailersInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldShareWithRetailers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unshareWithRetailersInput"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnshareCollectionsWithRetailersInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUnshareWithRetailers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePublicStatusInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionsPublicInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdatePublicStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"syncToIpad"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffDate"}},{"kind":"Field","name":{"kind":"Name","value":"minimumShippingWindow"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shareCollectionsWithRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareWithRetailersInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldShareWithRetailers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"unshareCollectionsWithRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unshareWithRetailersInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUnshareWithRetailers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollectionsPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePublicStatusInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdatePublicStatus"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLinesheetMutation, UpdateLinesheetMutationVariables>;
export const BulkDuplicateCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDuplicateCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDuplicateCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDuplicateCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BulkDuplicateCollectionsMutation, BulkDuplicateCollectionsMutationVariables>;
export const UpdateCollectionBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCollectionBanners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCollectionBannersInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldCreate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCollectionBannersInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCollectionBannersInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCollectionBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldCreate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleteCollectionBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textBannerIds"}},{"kind":"Field","name":{"kind":"Name","value":"imageBannerIds"}},{"kind":"Field","name":{"kind":"Name","value":"videoBannerIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updateCollectionBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCollectionBannersMutation, UpdateCollectionBannersMutationVariables>;
export const UpsertLinesheetTextStylesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertLinesheetTextStyles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textStyles"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionTextStyleInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertCollectionTextStyles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"textStyles"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textStyles"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textStyles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"typeface"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertLinesheetTextStylesMutation, UpsertLinesheetTextStylesMutationVariables>;
export const UpdateLinesheetGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLinesheetGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkCreateCollectionGroupsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldCreate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteCollectionGroupsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionGroupsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkCreateCollectionGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldCreate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdCollectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteCollectionGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionGroupIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollectionGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"header"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLinesheetGroupsMutation, UpdateLinesheetGroupsMutationVariables>;
export const UpdateLinesheetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLinesheetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateProductsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateLinesheetProductsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkAddProductsToCollectionInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdateLinesheetProducts"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deleteInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkRemoveProductsAndSkusFromCollectionsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkAddProductsToCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateLinesheetProductsInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdateLinesheetProducts"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"bulkRemoveProductsAndSkusFromCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deleteInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldDelete"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLinesheetProductsMutation, UpdateLinesheetProductsMutationVariables>;
export const SingleCollectionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleCollectionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linesheetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"linesheetId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"includeArchived"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"syncToIpad"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"minimumShippingWindow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textStyles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"typeface"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SingleCollectionQueryQuery, SingleCollectionQueryQueryVariables>;
export const CollectionParamsByShareTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionParamsByShareToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionParamsByShareToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasAccess"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"banners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"textStyles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"typeface"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionParamsByShareTokenQuery, CollectionParamsByShareTokenQueryVariables>;
export const SeasonsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SeasonsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SeasonsQueryQuery, SeasonsQueryQueryVariables>;
export const BrandSeasonsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandSeasonsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subtype"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandSeasonsQueryQuery, BrandSeasonsQueryQueryVariables>;
export const CollectionBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionBanners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"textBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoBanners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionBannersQuery, CollectionBannersQueryVariables>;
export const PriceTypesDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceTypesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesDupe2Query, PriceTypesDupe2QueryVariables>;
export const WarehousesQueryDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehousesQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableOn"}},{"kind":"Field","name":{"kind":"Name","value":"isImmediate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WarehousesQueryDupe2Query, WarehousesQueryDupe2QueryVariables>;
export const CollectionProductsTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}]}]}}]} as unknown as DocumentNode<CollectionProductsTotalQuery, CollectionProductsTotalQueryVariables>;
export const usesNewEditAndCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"usesNewEditAndCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usesNewEditAndCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}]}}]} as unknown as DocumentNode<usesNewEditAndCreateQuery, usesNewEditAndCreateQueryVariables>;
export const ProductTraitValuesQueryDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTraitValuesQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductTraitValuesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTraitValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductTraitValuesQueryDupe2Query, ProductTraitValuesQueryDupe2QueryVariables>;
export const StyleTagsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleTagsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uniqueTagValuesFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueTagValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleTagsDupe2Query, StyleTagsDupe2QueryVariables>;
export const CollectionsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsDupe1Query, CollectionsDupe1QueryVariables>;
export const BulkDeleteCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkDeleteCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkDeleteCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionIds"}}]}}]}}]} as unknown as DocumentNode<BulkDeleteCollectionMutation, BulkDeleteCollectionMutationVariables>;
export const BulkUpdateCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"syncToIpad"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateCollectionMutation, BulkUpdateCollectionMutationVariables>;
export const BulkUpdateCollectionsPublicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateCollectionsPublic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionsPublicInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollectionsPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"syncToIpad"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateCollectionsPublicMutation, BulkUpdateCollectionsPublicMutationVariables>;
export const BulkUpdateUserFavoriteCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateUserFavoriteCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateUserFavoriteCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateUserFavoriteCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateUserFavoriteCollectionsMutation, BulkUpdateUserFavoriteCollectionsMutationVariables>;
export const SendCollectionsToConnectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendCollectionsToConnections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendCollectionsToConnectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendCollectionsToConnections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SendCollectionsToConnectionsMutation, SendCollectionsToConnectionsMutationVariables>;
export const BulkUpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionsPositionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollectionsPosition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateOrderMutation, BulkUpdateOrderMutationVariables>;
export const CollectionQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"archived"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedWith"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limitByProfileSettingsMax"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"Variable","name":{"kind":"Name","value":"archived"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sharedWith"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedWith"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"POSITION"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"archived"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlThumbnail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"syncToIpad"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionQueryDupe1Query, CollectionQueryDupe1QueryVariables>;
export const UserFavoriteCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFavoriteCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteCollections"}}]}}]}}]} as unknown as DocumentNode<UserFavoriteCollectionsQuery, UserFavoriteCollectionsQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const ExportBulkProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportBulkProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"triggerBulkProductExportInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerBulkProductExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerBulkProductExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"triggerBulkProductExportInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ExportBulkProductMutation, ExportBulkProductMutationVariables>;
export const ListTemplatesDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListTemplatesDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountExportIntegrationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"integrationTypes"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PRODUCT_EXPORT"}]}},{"kind":"Argument","name":{"kind":"Name","value":"isActive"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"}}]}}]}}]} as unknown as DocumentNode<ListTemplatesDupe2Query, ListTemplatesDupe2QueryVariables>;
export const UniqueTagValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UniqueTagValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uniqueTagValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UniqueTagValuesQuery, UniqueTagValuesQueryVariables>;
export const AccountPermissionsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountPermissionsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountPermissionsDupe2Query, AccountPermissionsDupe2QueryVariables>;
export const CollectionsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsDupe2Query, CollectionsDupe2QueryVariables>;
export const BrandDoorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandDoors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandDoorsQuery, BrandDoorsQueryVariables>;
export const BulkRemoveUnmatchedUploadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkRemoveUnmatchedUploads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unmatchedImageIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkRemoveUnmatchedUploads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unmatchedImageIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unmatchedImageIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}}]}}]} as unknown as DocumentNode<BulkRemoveUnmatchedUploadsMutation, BulkRemoveUnmatchedUploadsMutationVariables>;
export const SaveUnmatchedUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveUnmatchedUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveUnmatchedUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadId"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchedUploadId"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SaveUnmatchedUploadMutation, SaveUnmatchedUploadMutationVariables>;
export const SaveProductImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveProductImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasProductImagesChanges"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productImages"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImages"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleColorsImage"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StyleColorsImage"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveProductImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hasProductImagesChanges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasProductImagesChanges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"productImages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productImages"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"styleColorsImage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleColorsImage"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}}]}}]} as unknown as DocumentNode<SaveProductImagesMutation, SaveProductImagesMutationVariables>;
export const GetManageImagesStyleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetManageImagesStyleData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getManageImagesStyleData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"styleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleId"}},{"kind":"Field","name":{"kind":"Name","value":"styleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"styleName"}},{"kind":"Field","name":{"kind":"Name","value":"fabrication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"silhouette"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"styleColors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"swatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hex"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetManageImagesStyleDataQuery, GetManageImagesStyleDataQueryVariables>;
export const ListUnmatchedUploadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListUnmatchedUploads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchFileName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listUnmatchedUploads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchFileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchFileName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mediaType"},"value":{"kind":"EnumValue","value":"IMAGE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"uploads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"unmatchedUploadId"}}]}}]}}]}}]} as unknown as DocumentNode<ListUnmatchedUploadsQuery, ListUnmatchedUploadsQueryVariables>;
export const NavigationProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavigationProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOrderByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavigationProductsQuery, NavigationProductsQueryVariables>;
export const UpsertCollectionsVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCollectionsVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionVisibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertCollectionsVisibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"customerIds"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertCollectionsVisibilityMutation, UpsertCollectionsVisibilityMutationVariables>;
export const VisibilityForLinesheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisibilityForLinesheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linesheetIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linesheetIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisibilityForLinesheetsQuery, VisibilityForLinesheetsQueryVariables>;
export const BrandConnectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandConnections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandConnectionsQuery, BrandConnectionsQueryVariables>;
export const PriceTypesDupe4Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesDupe4"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesDupe4Query, PriceTypesDupe4QueryVariables>;
export const PriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesQuery, PriceTypesQueryVariables>;
export const createLinesheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLinesheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkCreateCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkCreateCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<createLinesheetsMutation, createLinesheetsMutationVariables>;
export const createAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailCurrencyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailCurrencyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailCurrencyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<createAssortmentMutation, createAssortmentMutationVariables>;
export const PriceTypesDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesDupe3Query, PriceTypesDupe3QueryVariables>;
export const InProgressOrdersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InProgressOrdersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limitByProfileSettingsMax"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inProgressOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"salesReps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"retailerAccountName"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InProgressOrdersCountQuery, InProgressOrdersCountQueryVariables>;
export const CollectionRetailersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionRetailers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limitByProfileSettingsMax"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionRetailersQuery, CollectionRetailersQueryVariables>;
export const BulkUpdateAccountsPrivacyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateAccountsPrivacy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateAccountsPrivacyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateAccountsPrivacy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacy"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateAccountsPrivacyMutation, BulkUpdateAccountsPrivacyMutationVariables>;
export const LiteRetailerAccountsInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiteRetailerAccountsInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreationSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allConnections"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiteRetailerAccountsInfoQuery, LiteRetailerAccountsInfoQueryVariables>;
export const RecentlyCreatedAccountsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecentlyCreatedAccountsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recentlyCreatedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacy"}}]}}]}}]}}]} as unknown as DocumentNode<RecentlyCreatedAccountsQueryQuery, RecentlyCreatedAccountsQueryQueryVariables>;
export const UpdateRetailerPrimaryAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRetailerPrimaryAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRetailerPrimaryAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UpdateRetailerPrimaryAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerId"}}]}}]}}]} as unknown as DocumentNode<UpdateRetailerPrimaryAccountMutation, UpdateRetailerPrimaryAccountMutationVariables>;
export const AcknowledgeRecentlyCreatedAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcknowledgeRecentlyCreatedAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcknowledgeRecentlyCreatedAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acknowledgeRecentlyCreatedAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AcknowledgeRecentlyCreatedAccountsMutation, AcknowledgeRecentlyCreatedAccountsMutationVariables>;
export const CheckMergeCriteriaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckMergeCriteria"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkMergingAccountCriteria"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ids"}}]}}]}}]} as unknown as DocumentNode<CheckMergeCriteriaQuery, CheckMergeCriteriaQueryVariables>;
export const MergeAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergeAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergeAccountsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergeAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<MergeAccountsMutation, MergeAccountsMutationVariables>;
export const SetSelectedAccountMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSelectedAccountMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetSelectedAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSelectedAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SetSelectedAccountMutationMutation, SetSelectedAccountMutationMutationVariables>;
export const LiteRetailerConnectedAccountsDropdownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiteRetailerConnectedAccountsDropdown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"privacy"}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allConnections"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiteRetailerConnectedAccountsDropdownQuery, LiteRetailerConnectedAccountsDropdownQueryVariables>;
export const ordersInProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ordersInProgress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"IN_PROGRESS"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalProducts"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"totalVariant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orphanRetailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerEmail"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ordersInProgressQuery, ordersInProgressQueryVariables>;
export const NewInvitationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewInvitationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newInvitationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<NewInvitationCountQuery, NewInvitationCountQueryVariables>;
export const setDisplayLanguageForUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setDisplayLanguageForUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetDisplayLanguageForUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setDisplayLanguageForUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayLanguage"}}]}}]}}]} as unknown as DocumentNode<setDisplayLanguageForUserMutation, setDisplayLanguageForUserMutationVariables>;
export const UnreadMessagesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnreadMessagesCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unreadMessageCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>;
export const GetBrandStyleIdentifierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrandStyleIdentifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBrandStyleIdentifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleIdentifiers"}}]}}]}}]} as unknown as DocumentNode<GetBrandStyleIdentifierQuery, GetBrandStyleIdentifierQueryVariables>;
export const NewSubmissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewSubmissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmissionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<NewSubmissionsQuery, NewSubmissionsQueryVariables>;
export const AssignPriceTypesModalPriceTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssignPriceTypesModalPriceTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssignPriceTypesModalPriceTypesQuery, AssignPriceTypesModalPriceTypesQueryVariables>;
export const RetailerInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectedAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectedAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectedAccountIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicRetailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerInfoQuery, RetailerInfoQueryVariables>;
export const CreateExternalPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExternalPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateExternalPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExternalPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<CreateExternalPaymentMutation, CreateExternalPaymentMutationVariables>;
export const SendPaymentLinkEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPaymentLinkEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SendPaymentLinkEmailMutation, SendPaymentLinkEmailMutationVariables>;
export const ExternalPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPaymentByLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"brandContactName"}},{"kind":"Field","name":{"kind":"Name","value":"brandContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerEmails"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingCountry"}},{"kind":"Field","name":{"kind":"Name","value":"billingState"}},{"kind":"Field","name":{"kind":"Name","value":"billingCity"}},{"kind":"Field","name":{"kind":"Name","value":"billingPostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"}}]}}]}}]} as unknown as DocumentNode<ExternalPaymentQuery, ExternalPaymentQueryVariables>;
export const ExternalPaymentRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalPaymentRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalPaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPaymentRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"externalPaymentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalPaymentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"}},{"kind":"Field","name":{"kind":"Name","value":"localCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BankAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExternalPaymentRecordsQuery, ExternalPaymentRecordsQueryVariables>;
export const DeleteExternalPaymentRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExternalPaymentRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteExternalPaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExternalPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteExternalPaymentRecordMutation, DeleteExternalPaymentRecordMutationVariables>;
export const ExternalPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExternalPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalPayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerEmails"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"sentDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}}]}}]}}]} as unknown as DocumentNode<ExternalPaymentsQuery, ExternalPaymentsQueryVariables>;
export const BrandBudgetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandBudgets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandBudgets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"priceTypeIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"door"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalWholesale"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnitsPriorYear"}},{"kind":"Field","name":{"kind":"Name","value":"totalWholesalePriorYear"}},{"kind":"Field","name":{"kind":"Name","value":"division"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandBudgetsQuery, BrandBudgetsQueryVariables>;
export const totalInOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"totalInOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalInOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"priceTypeIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"totalWholesale"}},{"kind":"Field","name":{"kind":"Name","value":"door"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"division"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"retailerId"}},{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}}]} as unknown as DocumentNode<totalInOrdersQuery, totalInOrdersQueryVariables>;
export const JoorPayOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JoorPayOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"salesRepresentative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"webOrderLookupId"}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstAddress"}},{"kind":"Field","name":{"kind":"Name","value":"secondAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"factor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"firstRequest"}},{"kind":"Field","name":{"kind":"Name","value":"lastNotifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"remainingBalance"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<JoorPayOrdersQuery, JoorPayOrdersQueryVariables>;
export const mergeOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mergeOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergeOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergeOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<mergeOrderMutation, mergeOrderMutationVariables>;
export const OrdersToMergeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersToMerge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingStart"}},{"kind":"Field","name":{"kind":"Name","value":"shippingComplete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotal"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skuLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sku"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"casepackLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"casepack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailPrice"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrdersToMergeQuery, OrdersToMergeQueryVariables>;
export const checkMergingOrderCriteriaDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkMergingOrderCriteriaDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedOrdersIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetOrderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkMergingOrderCriteria"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedOrdersIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"targetOrderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<checkMergingOrderCriteriaDupe2Query, checkMergingOrderCriteriaDupe2QueryVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"priceTypeIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailPrice"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const orderContactsDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderContactsDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<orderContactsDupe1Query, orderContactsDupe1QueryVariables>;
export const anonymousOrderQueryRedirectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"anonymousOrderQueryRedirect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderByInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<anonymousOrderQueryRedirectQuery, anonymousOrderQueryRedirectQueryVariables>;
export const anonymousOrderQueryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"anonymousOrderQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderByInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryStart"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryComplete"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"shippingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"taxAmount"}},{"kind":"Field","name":{"kind":"Name","value":"discountAmount"}},{"kind":"Field","name":{"kind":"Name","value":"shippingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"salesRepresentative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountedPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalRetailPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingPhone"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCompany"}},{"kind":"Field","name":{"kind":"Name","value":"shippingFirstAddress"}},{"kind":"Field","name":{"kind":"Name","value":"shippingSecondAddress"}},{"kind":"Field","name":{"kind":"Name","value":"shippingState"}},{"kind":"Field","name":{"kind":"Name","value":"shippingZip"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCity"}},{"kind":"Field","name":{"kind":"Name","value":"shippingState"}},{"kind":"Field","name":{"kind":"Name","value":"shippingCountry"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"webOrderLookupId"}},{"kind":"Field","name":{"kind":"Name","value":"seasonYear"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxIdNumber"}},{"kind":"Field","name":{"kind":"Name","value":"billingCountry"}},{"kind":"Field","name":{"kind":"Name","value":"billingCompany"}},{"kind":"Field","name":{"kind":"Name","value":"billingFirstAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingSecondAddress"}},{"kind":"Field","name":{"kind":"Name","value":"billingState"}},{"kind":"Field","name":{"kind":"Name","value":"billingZip"}},{"kind":"Field","name":{"kind":"Name","value":"billingCity"}},{"kind":"Field","name":{"kind":"Name","value":"billingPhone"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"door"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFinancials"}}]}}]}}]}}]}},...OrderFinancialsFragmentDoc.definitions]} as unknown as DocumentNode<anonymousOrderQueryQuery, anonymousOrderQueryQueryVariables>;
export const OrderPaymentRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderPaymentRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"}},{"kind":"Field","name":{"kind":"Name","value":"localCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BankAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderPaymentRecordsQuery, OrderPaymentRecordsQueryVariables>;
export const LocalCurrenciesFFQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocalCurrenciesFFQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useJoorPayLocalPayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}}}]}]}}]}}]} as unknown as DocumentNode<LocalCurrenciesFFQueryQuery, LocalCurrenciesFFQueryQueryVariables>;
export const TriggerOrdersPDFExportTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerOrdersPDFExportTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerOrdersPdfExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskIds"}}]}}]}}]} as unknown as DocumentNode<TriggerOrdersPDFExportTasksMutation, TriggerOrdersPDFExportTasksMutationVariables>;
export const ListOrderExportTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListOrderExportTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOrderExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<ListOrderExportTasksQuery, ListOrderExportTasksQueryVariables>;
export const CreateManualTransactionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateManualTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateManualPaymentRecordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManualPaymentRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManualTransaction"}}]}}]}},...ManualTransactionFragmentDoc.definitions]} as unknown as DocumentNode<CreateManualTransactionMutation, CreateManualTransactionMutationVariables>;
export const UpdateManualTransactionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateManualTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateManualPaymentRecordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateManualPaymentRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManualTransaction"}}]}}]}},...ManualTransactionFragmentDoc.definitions]} as unknown as DocumentNode<UpdateManualTransactionMutation, UpdateManualTransactionMutationVariables>;
export const DeleteManualTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteManualTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteManualPaymentRecordInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteManualPaymentRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<DeleteManualTransactionMutation, DeleteManualTransactionMutationVariables>;
export const ManualTransactionsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ManualTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manualPaymentRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ManualTransaction"}}]}}]}},...ManualTransactionFragmentDoc.definitions]} as unknown as DocumentNode<ManualTransactionsQuery, ManualTransactionsQueryVariables>;
export const CreateReachPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReachPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePaymentWithPaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReachPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateReachPaymentMutation, CreateReachPaymentMutationVariables>;
export const UpdateReachPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReachPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<UpdateReachPaymentMutation, UpdateReachPaymentMutationVariables>;
export const AnonymousCreateReachPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AnonymousCreateReachPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePaymentWithPaymentMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anonymousCreateReachPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<AnonymousCreateReachPaymentMutation, AnonymousCreateReachPaymentMutationVariables>;
export const AnonymousUpdateReachPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AnonymousUpdateReachPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anonymousUpdatePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<AnonymousUpdateReachPaymentMutation, AnonymousUpdateReachPaymentMutationVariables>;
export const PaymentProvidersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentProvidersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountPaymentProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"destinationAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentProvider"}},{"kind":"Field","name":{"kind":"Name","value":"connectionDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentProvidersQueryQuery, PaymentProvidersQueryQueryVariables>;
export const OrderPartialPaymentRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderPartialPaymentRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partialPaymentRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderPartialPaymentRequestsQuery, OrderPartialPaymentRequestsQueryVariables>;
export const PublicOrderPartialPaymentRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicOrderPartialPaymentRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderByInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partialPaymentRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicOrderPartialPaymentRequestsQuery, PublicOrderPartialPaymentRequestsQueryVariables>;
export const OrderRemainingBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderRemainingBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"remainingBalance"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderRemainingBalanceQuery, OrderRemainingBalanceQueryVariables>;
export const PublicOrderRemainingBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicOrderRemainingBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getOrderByInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"remainingBalance"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicOrderRemainingBalanceQuery, PublicOrderRemainingBalanceQueryVariables>;
export const TriggerOrdersPdfExportTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TriggerOrdersPdfExportTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerOrdersPdfExportTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerOrdersPdfExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskIds"}}]}}]}}]} as unknown as DocumentNode<TriggerOrdersPdfExportTasksMutation, TriggerOrdersPdfExportTasksMutationVariables>;
export const listOrderExportTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listOrderExportTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListOrderExportTasksInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOrderExportTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]}}]} as unknown as DocumentNode<listOrderExportTasksQuery, listOrderExportTasksQueryVariables>;
export const UpdateOrderInfoDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderInfoDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderInfoDupe3Mutation, UpdateOrderInfoDupe3MutationVariables>;
export const UpdateHeaderPricetypesAndDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHeaderPricetypesAndDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrdersConnection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateHeaderPricetypesAndDatesMutation, UpdateHeaderPricetypesAndDatesMutationVariables>;
export const UpdateOrderDeliveryInfoDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderDeliveryInfoDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderDeliveryInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderDeliveryInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderDeliveryInfoDupe1Mutation, UpdateOrderDeliveryInfoDupe1MutationVariables>;
export const OrderBillingShippingDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderBillingShipping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sourceBillingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"firstAddress"}},{"kind":"Field","name":{"kind":"Name","value":"secondAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderTax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}},...OrderShippingDetailsFragmentDoc.definitions,...OrderTaxFragmentDoc.definitions]} as unknown as DocumentNode<OrderBillingShippingQuery, OrderBillingShippingQueryVariables>;
export const CountriesForAddressModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountriesForAddressModal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geographies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"COUNTRY","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"taxLabel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CountriesForAddressModalQuery, CountriesForAddressModalQueryVariables>;
export const BrandShippingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandShippingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectedAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectedAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectedAccountIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandShippingInfoQuery, BrandShippingInfoQueryVariables>;
export const RetailerLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicRetailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimaryLocation"}}]}}]}}]}}]} as unknown as DocumentNode<RetailerLocationsQuery, RetailerLocationsQueryVariables>;
export const UpdateOrderBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderBillingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderBilling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderBillingMutation, UpdateOrderBillingMutationVariables>;
export const UpdateOrderShippingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderShipping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderShippingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderShipping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderShippingMutation, UpdateOrderShippingMutationVariables>;
export const UpdateShippingDetailDoorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShippingDetailDoor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderDeliveryInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderDeliveryInfo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doorId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<UpdateShippingDetailDoorMutation, UpdateShippingDetailDoorMutationVariables>;
export const UpdateFinancialSummaryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFinancialSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateOrderFinancials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrdersConnection"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateOrderFinancials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFinancials"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},...OrderFinancialsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateFinancialSummaryMutation, UpdateFinancialSummaryMutationVariables>;
export const UpdateOrderInternalCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderInternalComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"internalComments"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrderInternalCommentMutation, UpdateOrderInternalCommentMutationVariables>;
export const OrderDetailsEditInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderDetailsEditInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isBrand"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldFetchConnection"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"CREATION_DATE"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASCENDING"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isBrand"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderTypes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isBrand"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isBrand"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listConnectionWarehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldFetchConnection"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouseId"}}]}}]}}]} as unknown as DocumentNode<OrderDetailsEditInfoQuery, OrderDetailsEditInfoQueryVariables>;
export const UpdateOrderDetailsEventAndTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderDetailsEventAndType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderInfoInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderDetailsEventAndTypeMutation, UpdateOrderDetailsEventAndTypeMutationVariables>;
export const UpdateOrderDetailsWarehouseAndSeasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderDetailsWarehouseAndSeason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderDeliveryInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderDeliveryInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrderDetailsWarehouseAndSeasonMutation, UpdateOrderDetailsWarehouseAndSeasonMutationVariables>;
export const SendJoorPayImInterestedEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendJoorPayImInterestedEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendJoorPayImInterestedEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendJoorPayImInterestedEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SendJoorPayImInterestedEmailMutation, SendJoorPayImInterestedEmailMutationVariables>;
export const PaymentOrderInfoDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentOrderInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"webOrderLookupId"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstAddress"}},{"kind":"Field","name":{"kind":"Name","value":"secondAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusModified"}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueTotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minPrice"}},{"kind":"Field","name":{"kind":"Name","value":"maxPrice"}}]}}]}}]}}]}}]}}]}},...OrderShippingDetailsFragmentDoc.definitions]} as unknown as DocumentNode<PaymentOrderInfoQuery, PaymentOrderInfoQueryVariables>;
export const SendInvoicesPaymentRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendInvoicesPaymentRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendInvoicesForOrdersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendInvoicesForOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"sentTo"}},{"kind":"Field","name":{"kind":"Name","value":"sentOn"}}]}}]}}]} as unknown as DocumentNode<SendInvoicesPaymentRequestMutation, SendInvoicesPaymentRequestMutationVariables>;
export const CreateInvoicePaymentRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInvoicePaymentRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInvoicesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceId"}}]}}]}}]} as unknown as DocumentNode<CreateInvoicePaymentRequestMutation, CreateInvoicePaymentRequestMutationVariables>;
export const UpdateOrderInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreesWithTerms"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"dateModified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderComments"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrderInfoMutation, UpdateOrderInfoMutationVariables>;
export const BulkUpdateOrderStatusMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateOrderStatusMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateOrderStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateOrderStatusMutationMutation, BulkUpdateOrderStatusMutationMutationVariables>;
export const OrderGeneralInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderGeneralInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderGeneralInfoQuery, OrderGeneralInfoQueryVariables>;
export const OrderReviewGigaQueryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderReviewGigaQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traitCodes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VariantFilterValuesInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"internalComments"}},{"kind":"Field","name":{"kind":"Name","value":"isOrphan"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"orderComments"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusModified"}},{"kind":"Field","name":{"kind":"Name","value":"webOrderLookupId"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleTotal"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrandOrderSettings"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orphanRetailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCollections"}}]}},{"kind":"Field","name":{"kind":"Name","value":"divisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderFinancials"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastModifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"byAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"decimals"}},{"kind":"Field","name":{"kind":"Name","value":"decimal_separator"}},{"kind":"Field","name":{"kind":"Name","value":"thousands_separator"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesComissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"salesRepresentative"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderShippingDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderTax"}}]}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreesWithTerms"}},{"kind":"Field","name":{"kind":"Name","value":"terms"}},{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"dateModified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductsInfo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkMinimums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderAmount"}},{"kind":"Field","name":{"kind":"Name","value":"orderQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"productMinimums"}},{"kind":"Field","name":{"kind":"Name","value":"colorMinimums"}}]}}]}}]}}]}},...BrandOrderSettingsFragmentDoc.definitions,...OrderCollectionsFragmentDoc.definitions,...OrderFinancialsFragmentDoc.definitions,...OrderShippingDetailsFragmentDoc.definitions,...OrderTaxFragmentDoc.definitions,...ProductsInfoFragmentDoc.definitions]} as unknown as DocumentNode<OrderReviewGigaQueryQuery, OrderReviewGigaQueryQueryVariables>;
export const OrderRequirementChecksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderRequirementChecks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderRequirementChecks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"checksMinimums"}},{"kind":"Field","name":{"kind":"Name","value":"sizeRunChanged"}}]}}]}}]} as unknown as DocumentNode<OrderRequirementChecksQuery, OrderRequirementChecksQueryVariables>;
export const AccountHasPaymentProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountHasPaymentProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountPaymentProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"destinationAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProvider"}},{"kind":"Field","name":{"kind":"Name","value":"retailersCanSeeInvoices"}}]}}]}}]} as unknown as DocumentNode<AccountHasPaymentProvidersQuery, AccountHasPaymentProvidersQueryVariables>;
export const OrderRequestStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderRequestStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestStatus"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderRequestStatusQuery, OrderRequestStatusQueryVariables>;
export const UseJoorPayFlagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UseJoorPayFlag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useJoorPay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountId"}}}]}]}}]}}]} as unknown as DocumentNode<UseJoorPayFlagQuery, UseJoorPayFlagQueryVariables>;
export const ListConnectionPriceTypesORDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListConnectionPriceTypesOR"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListConnectionPriceTypeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listConnectionPriceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListConnectionPriceTypesORQuery, ListConnectionPriceTypesORQueryVariables>;
export const OrderHasRemainingBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderHasRemainingBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remainingBalance"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderHasRemainingBalanceQuery, OrderHasRemainingBalanceQueryVariables>;
export const GetShopifySubscriptionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShopifySubscriptionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopifyAppName"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopifyIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionActive"}},{"kind":"Field","name":{"kind":"Name","value":"storeCurrencyCode"}}]}}]}}]} as unknown as DocumentNode<GetShopifySubscriptionStatusQuery, GetShopifySubscriptionStatusQueryVariables>;
export const UpdateOrderContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateOrderInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderContactsMutation, UpdateOrderContactsMutationVariables>;
export const BrandContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrandsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"connectedAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"EnumValue","value":"SALES_REPRESENTATIVE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectedAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"connectedAccountIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandContactsQuery, BrandContactsQueryVariables>;
export const UploadAttachmentToS3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadAttachmentToS3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadAttachmentToS3Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAttachmentToS3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<UploadAttachmentToS3Mutation, UploadAttachmentToS3MutationVariables>;
export const TradeShowRetailersV1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TradeShowRetailersV1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowEventRetailerFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowPageInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tradeShowRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"mainPictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"mainStorePictureUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<TradeShowRetailersV1Query, TradeShowRetailersV1QueryVariables>;
export const TradeShowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TradeShows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowEventFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tradeShows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TradeShowsQuery, TradeShowsQueryVariables>;
export const TradeShowBrandsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TradeShowBrandsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowEventBrandFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowPageInfo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tradeShowBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"mainPictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImageUrls"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<TradeShowBrandsV2Query, TradeShowBrandsV2QueryVariables>;
export const TradeShowBrandsCategoriesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TradeShowBrandsCategoriesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowEventBrandFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tradeShowBrandsCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TradeShowBrandsCategoriesV2Query, TradeShowBrandsCategoriesV2QueryVariables>;
export const TradeShowRetailersCategoriesV1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TradeShowRetailersCategoriesV1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowEventRetailerFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tradeShowRetailersCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TradeShowRetailersCategoriesV1Query, TradeShowRetailersCategoriesV1QueryVariables>;
export const createFavoriteAccountDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFavoriteAccountDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFavoriteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFavoriteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"tradeShowEventId"}}]}}]}}]} as unknown as DocumentNode<createFavoriteAccountDupe1Mutation, createFavoriteAccountDupe1MutationVariables>;
export const deleteFavoriteAccountDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFavoriteAccountDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFavoriteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFavoriteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteFavoriteAccountDupe1Mutation, deleteFavoriteAccountDupe1MutationVariables>;
export const FavoritedBrandsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FavoritedBrandsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoritedBrandsByRetailAccountUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"}},{"kind":"Field","name":{"kind":"Name","value":"tradeShowEventSlug"}}]}}]}}]} as unknown as DocumentNode<FavoritedBrandsQueryQuery, FavoritedBrandsQueryQueryVariables>;
export const PublicRetailerPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicRetailerPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"profileImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"upload"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicRetailerPageQuery, PublicRetailerPageQueryVariables>;
export const viewingAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"viewingAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unreadMessageCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newInvitationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfileCompletion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listLatestFavoriteBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listRecentBrandAssortments"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pro"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"orderTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"linesheetName"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}}]}}]}}]} as unknown as DocumentNode<viewingAccountQuery, viewingAccountQueryVariables>;
export const listCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listRecentSharedCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectionType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"brandImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sharedOn"}}]}}]}}]} as unknown as DocumentNode<listCollectionsQuery, listCollectionsQueryVariables>;
export const listRecentBrandOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listRecentBrandOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listRecentBrandOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}},{"kind":"Field","name":{"kind":"Name","value":"orderTime"}},{"kind":"Field","name":{"kind":"Name","value":"linesheetName"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"brandImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}}]}}]}}]} as unknown as DocumentNode<listRecentBrandOrdersQuery, listRecentBrandOrdersQueryVariables>;
export const listLatestBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listLatestBrands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLatestBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"}}]}}]}}]} as unknown as DocumentNode<listLatestBrandsQuery, listLatestBrandsQueryVariables>;
export const FindInterestedBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindInterestedBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findInterestedBrands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]} as unknown as DocumentNode<FindInterestedBrandsQuery, FindInterestedBrandsQueryVariables>;
export const SubmissionsBrandsInterestedInYouQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubmissionsBrandsInterestedInYouQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmissionsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"senderAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"accountProfilePictureUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmissionsBrandsInterestedInYouQueryQuery, SubmissionsBrandsInterestedInYouQueryQueryVariables>;
export const NewBrandsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewBrands"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListLatestBrandsFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLatestBrands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"}}]}}]}}]} as unknown as DocumentNode<NewBrandsQuery, NewBrandsQueryVariables>;
export const NewBrandsCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewBrandsCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TradeShowEventBrandFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tradeShowBrandsCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewBrandsCategoriesQuery, NewBrandsCategoriesQueryVariables>;
export const RetailerCenterAccountConnectionStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerCenterAccountConnectionStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountConnectionStatusFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountConnectionStatusOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"brandProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<RetailerCenterAccountConnectionStatusesQuery, RetailerCenterAccountConnectionStatusesQueryVariables>;
export const DataActivityCenterQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DataActivityCenterQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListMonitoringJobsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMonitoringJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"inputFileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"inputData"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"outputData"}},{"kind":"Field","name":{"kind":"Name","value":"errorDetails"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<DataActivityCenterQueryQuery, DataActivityCenterQueryQueryVariables>;
export const ShippingReportFeatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShippingReportFeature"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingReportFeature"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}]}}]} as unknown as DocumentNode<ShippingReportFeatureQuery, ShippingReportFeatureQueryVariables>;
export const CompleteShopifyInstallationForEmbeddedAppsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteShopifyInstallationForEmbeddedApps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteShopifyInstallationForEmbeddedAppsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeShopifyInstallationForEmbeddedApps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CompleteShopifyInstallationForEmbeddedAppsMutation, CompleteShopifyInstallationForEmbeddedAppsMutationVariables>;
export const UpdateShopifyBrandSyncSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShopifyBrandSyncSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopifySyncSettingsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateShopifyBrandSyncSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShopifyBrandSyncSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopifySyncSettingsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"retailPriceMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePriceMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"lastFullSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"canPerformFullSync"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateShopifyBrandSyncSettingsMutation, UpdateShopifyBrandSyncSettingsMutationVariables>;
export const GetBrandShopifyIntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrandShopifyIntegration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopifyAppName"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopifyIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shopUrl"}},{"kind":"Field","name":{"kind":"Name","value":"shopName"}},{"kind":"Field","name":{"kind":"Name","value":"linkedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncDate"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionActive"}},{"kind":"Field","name":{"kind":"Name","value":"isInstalled"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandShopifyIntegration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"canPerformFullSync"}},{"kind":"Field","name":{"kind":"Name","value":"lastFullSyncAt"}},{"kind":"Field","name":{"kind":"Name","value":"retailPriceMultiplier"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePriceMultiplier"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBrandShopifyIntegrationQuery, GetBrandShopifyIntegrationQueryVariables>;
export const CompleteShopifyInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteShopifyInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteShopifyInstallationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeShopifyInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"shopifyIntegrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopUrl"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteShopifyInstallationMutation, CompleteShopifyInstallationMutationVariables>;
export const UpdateShopifyRetailerSyncSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShopifyRetailerSyncSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopifyRetailerProductSyncSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRetailerShopifyProductSyncSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountStoreSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"syncSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoSyncProducts"}},{"kind":"Field","name":{"kind":"Name","value":"syncStyleName"}},{"kind":"Field","name":{"kind":"Name","value":"syncStyleDescription"}},{"kind":"Field","name":{"kind":"Name","value":"syncMedia"}},{"kind":"Field","name":{"kind":"Name","value":"syncCategory"}},{"kind":"Field","name":{"kind":"Name","value":"syncLinesheet"}},{"kind":"Field","name":{"kind":"Name","value":"syncSilhouette"}},{"kind":"Field","name":{"kind":"Name","value":"syncBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"syncBrandNameStyleName"}},{"kind":"Field","name":{"kind":"Name","value":"syncRetailPrice"}},{"kind":"Field","name":{"kind":"Name","value":"syncSkuPrices"}},{"kind":"Field","name":{"kind":"Name","value":"syncSkuCode"}},{"kind":"Field","name":{"kind":"Name","value":"syncUpcCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeAccountStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"syncSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoSyncProducts"}},{"kind":"Field","name":{"kind":"Name","value":"syncStyleName"}},{"kind":"Field","name":{"kind":"Name","value":"syncStyleDescription"}},{"kind":"Field","name":{"kind":"Name","value":"syncMedia"}},{"kind":"Field","name":{"kind":"Name","value":"syncCategory"}},{"kind":"Field","name":{"kind":"Name","value":"syncLinesheet"}},{"kind":"Field","name":{"kind":"Name","value":"syncSilhouette"}},{"kind":"Field","name":{"kind":"Name","value":"syncBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"syncBrandNameStyleName"}},{"kind":"Field","name":{"kind":"Name","value":"syncRetailPrice"}},{"kind":"Field","name":{"kind":"Name","value":"syncSkuPrices"}},{"kind":"Field","name":{"kind":"Name","value":"syncSkuCode"}},{"kind":"Field","name":{"kind":"Name","value":"syncUpcCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShopifyRetailerSyncSettingsMutation, UpdateShopifyRetailerSyncSettingsMutationVariables>;
export const GetRetailerShopifyProductSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRetailerShopifyProductSync"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopifyAppName"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopifyIntegrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shopUrl"}},{"kind":"Field","name":{"kind":"Name","value":"shopName"}},{"kind":"Field","name":{"kind":"Name","value":"linkedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncDate"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionActive"}},{"kind":"Field","name":{"kind":"Name","value":"isInstalled"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RetailerShopifyProductSync"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountStoreSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"syncSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoSyncProducts"}},{"kind":"Field","name":{"kind":"Name","value":"syncStyleName"}},{"kind":"Field","name":{"kind":"Name","value":"syncStyleDescription"}},{"kind":"Field","name":{"kind":"Name","value":"syncMedia"}},{"kind":"Field","name":{"kind":"Name","value":"syncCategory"}},{"kind":"Field","name":{"kind":"Name","value":"syncLinesheet"}},{"kind":"Field","name":{"kind":"Name","value":"syncSilhouette"}},{"kind":"Field","name":{"kind":"Name","value":"syncBrandName"}},{"kind":"Field","name":{"kind":"Name","value":"syncBrandNameStyleName"}},{"kind":"Field","name":{"kind":"Name","value":"syncRetailPrice"}},{"kind":"Field","name":{"kind":"Name","value":"syncSkuPrices"}},{"kind":"Field","name":{"kind":"Name","value":"syncSkuCode"}},{"kind":"Field","name":{"kind":"Name","value":"syncUpcCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activeAccountStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"styleSyncErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sku"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"size"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRetailerShopifyProductSyncQuery, GetRetailerShopifyProductSyncQueryVariables>;
export const EligibleAccountsToLinkToShopifyStoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EligibleAccountsToLinkToShopifyStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleAccountsToLinkToShopifyStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreationSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allConnections"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EligibleAccountsToLinkToShopifyStoreQuery, EligibleAccountsToLinkToShopifyStoreQueryVariables>;
export const SyncShopifyOrderStylesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncShopifyOrderStyles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"syncShopifyOrderStylesInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SyncShopifyOrderStylesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncShopifyOrderStyles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"syncShopifyOrderStylesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobIds"}}]}}]}}]} as unknown as DocumentNode<SyncShopifyOrderStylesMutation, SyncShopifyOrderStylesMutationVariables>;
export const StartShopifyInstallationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartShopifyInstallation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartShopifyInstallationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startShopifyInstallation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}}]}}]}}]}}]} as unknown as DocumentNode<StartShopifyInstallationMutation, StartShopifyInstallationMutationVariables>;
export const UpdateAccountsLinkToStoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccountsLinkToStore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"updateAccountsLinkedToStoreInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountsLinkedToStore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shopUrl"}},{"kind":"Field","name":{"kind":"Name","value":"shopName"}},{"kind":"Field","name":{"kind":"Name","value":"linkedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAccountsLinkToStoreMutation, UpdateAccountsLinkToStoreMutationVariables>;
export const CancelShopifySubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelShopifySubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppSubscriptionCancelInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appSubscriptionCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CancelShopifySubscriptionMutation, CancelShopifySubscriptionMutationVariables>;
export const favoritedBrandsByRetailAccountUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"favoritedBrandsByRetailAccountUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoritedBrandsByRetailAccountUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<favoritedBrandsByRetailAccountUserQuery, favoritedBrandsByRetailAccountUserQueryVariables>;
export const deleteFavoriteAccountDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteFavoriteAccountDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteFavoriteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFavoriteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<deleteFavoriteAccountDupe2Mutation, deleteFavoriteAccountDupe2MutationVariables>;
export const createFavoriteAccountDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createFavoriteAccountDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddFavoriteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFavoriteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandAccountId"}}]}}]}}]} as unknown as DocumentNode<createFavoriteAccountDupe2Mutation, createFavoriteAccountDupe2MutationVariables>;
export const BrandProductLinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandProductLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProductLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<BrandProductLinesQuery, BrandProductLinesQueryVariables>;
export const UpsertBrandProfileMutationDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertBrandProfileMutationDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertBrandProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertBrandProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"retailMin"}},{"kind":"Field","name":{"kind":"Name","value":"retailMax"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"customUrlHandle"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialMediaType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoId"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ipadPhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"ipadPhotoUrl"}}]}}]}}]} as unknown as DocumentNode<UpsertBrandProfileMutationDupe1Mutation, UpsertBrandProfileMutationDupe1MutationVariables>;
export const bulkUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateStorefrontsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateStorefronts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isHome"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"statusSince"}}]}}]}}]} as unknown as DocumentNode<bulkUpdateMutation, bulkUpdateMutationVariables>;
export const BulkDeleteStorefrontDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkDeleteStorefront"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteStorefronts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<BulkDeleteStorefrontMutation, BulkDeleteStorefrontMutationVariables>;
export const storefrontsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storefronts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefronts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"storefrontFragment"}}]}}]}},...storefrontFragmentFragmentDoc.definitions]} as unknown as DocumentNode<storefrontsQuery, storefrontsQueryVariables>;
export const PublicStorefrontDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicStorefront"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefronts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"storefrontFragment"}}]}}]}}]}},...storefrontFragmentFragmentDoc.definitions]} as unknown as DocumentNode<PublicStorefrontQuery, PublicStorefrontQueryVariables>;
export const AccountConnectionStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountConnectionStatuses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountConnectionStatuses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"otherAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherAccountIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<AccountConnectionStatusesQuery, AccountConnectionStatusesQueryVariables>;
export const PublicBrandProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicBrandProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiteBrand"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicBrandProfileQuery, PublicBrandProfileQueryVariables>;
export const storefrontNavigationAsBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storefrontNavigationAsBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefronts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isHome"}}]}}]}}]} as unknown as DocumentNode<storefrontNavigationAsBrandQuery, storefrontNavigationAsBrandQueryVariables>;
export const publicStorefrontNavigationAsBrandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"publicStorefrontNavigationAsBrand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storefronts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"isHome"}}]}}]}}]}}]} as unknown as DocumentNode<publicStorefrontNavigationAsBrandQuery, publicStorefrontNavigationAsBrandQueryVariables>;
export const UpsertStorefrontDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertStorefront"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertStorefrontInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertStorefront"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"isHome"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueName"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"statusSince"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"template"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"elements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"elementType"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontTextElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontProductElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontVideoElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoId"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontImageElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageId"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageExternalLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontCollectionElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"elementType"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontAboutElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontShowroomCollectionElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionId"}},{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionTitle"}},{"kind":"Field","name":{"kind":"Name","value":"coverId"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontLookbookElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lookbookId"}},{"kind":"Field","name":{"kind":"Name","value":"lookbookTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lookbookUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverId"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontOrb360Element"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalVideoId"}},{"kind":"Field","name":{"kind":"Name","value":"externalVideoLink"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontShowroomBrandElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomBrandId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StorefrontInstagramElement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"instagramAuthId"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertStorefrontMutation, UpsertStorefrontMutationVariables>;
export const UpsertTextStylesMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTextStylesMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertStorefrontTextStylesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertStorefrontTextStyles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"typeface"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}}]}}]}}]} as unknown as DocumentNode<UpsertTextStylesMutationMutation, UpsertTextStylesMutationMutationVariables>;
export const UpsertBrandProfileMutationDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertBrandProfileMutationDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertBrandProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertBrandProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"retailMin"}},{"kind":"Field","name":{"kind":"Name","value":"retailMax"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"customUrlHandle"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialMediaType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoId"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]} as unknown as DocumentNode<UpsertBrandProfileMutationDupe2Mutation, UpsertBrandProfileMutationDupe2MutationVariables>;
export const collectionProductsQueryDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductsQueryDupe2Query, collectionProductsQueryDupe2QueryVariables>;
export const collectionProductsQueryDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsQueryDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductsQueryDupe3Query, collectionProductsQueryDupe3QueryVariables>;
export const PublicCollectionsQueryDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicCollectionsQueryDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicCollectionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"swatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicCollectionsQueryDupe1Query, PublicCollectionsQueryDupe1QueryVariables>;
export const CollectionsQueryDupe4Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe4"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limitByProfileSettingsMax"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"POSITION"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe4Query, CollectionsQueryDupe4QueryVariables>;
export const brandProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"brandProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiteBrand"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"retailMin"}},{"kind":"Field","name":{"kind":"Name","value":"retailMax"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"customUrlHandle"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoId"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ipadPhotoId"}},{"kind":"Field","name":{"kind":"Name","value":"ipadPhotoUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<brandProfilesQuery, brandProfilesQueryVariables>;
export const PublicBrandProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicBrandProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isLiteBrand"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"yearEstablished"}},{"kind":"Field","name":{"kind":"Name","value":"productLines"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMin"}},{"kind":"Field","name":{"kind":"Name","value":"wholesaleMax"}},{"kind":"Field","name":{"kind":"Name","value":"retailMin"}},{"kind":"Field","name":{"kind":"Name","value":"retailMax"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"customUrlHandle"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"socialMediaType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mediaType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoId"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicBrandProfilesQuery, PublicBrandProfilesQueryVariables>;
export const ShowroomCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShowroomCollections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToAllConnected"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShowroomCollectionsQuery, ShowroomCollectionsQueryVariables>;
export const PriceTypesQueryDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesQueryDupe2Query, PriceTypesQueryDupe2QueryVariables>;
export const instagramAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"instagramAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InstagramAccountFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instagramAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"brandId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<instagramAccountsQuery, instagramAccountsQueryVariables>;
export const instagramImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"instagramImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instagramAccountImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"instagramAccountIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}}]}}]}}]} as unknown as DocumentNode<instagramImagesQuery, instagramImagesQueryVariables>;
export const BrandCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parentName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"department"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandCategoriesQuery, BrandCategoriesQueryVariables>;
export const BrandSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandAccountIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"subtype"},"value":{"kind":"EnumValue","value":"ALL"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrandSeasonsQuery, BrandSeasonsQueryVariables>;
export const ValidateStyleImportFileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateStyleImportFileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filePath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateStyleImportFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filePath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filePath"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validationResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newStylesCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedStylesCount"}},{"kind":"Field","name":{"kind":"Name","value":"invalidStylesCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasCategoryColumns"}},{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowNumber"}},{"kind":"Field","name":{"kind":"Name","value":"styleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"errorCode"}},{"kind":"Field","name":{"kind":"Name","value":"errorDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<ValidateStyleImportFileMutationMutation, ValidateStyleImportFileMutationMutationVariables>;
export const UploadStyleImportFileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadStyleImportFileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadStyleImportFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filePath"}}]}}]}}]} as unknown as DocumentNode<UploadStyleImportFileMutationMutation, UploadStyleImportFileMutationMutationVariables>;
export const BulkStyleImportMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkStyleImportMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filePath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoryOption"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryOptions"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isNewCollection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkStyleImport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filePath"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filePath"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoryOption"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoryOption"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isNewCollection"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isNewCollection"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<BulkStyleImportMutationMutation, BulkStyleImportMutationMutationVariables>;
export const BulkCreateLinesheetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkCreateLinesheets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkCreateCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkCreateCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BulkCreateLinesheetsMutation, BulkCreateLinesheetsMutationVariables>;
export const GenerateBSUTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateBSUTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateBSUTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateBSUTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bsuTemplateFileUrl"}}]}}]}}]} as unknown as DocumentNode<GenerateBSUTemplateMutation, GenerateBSUTemplateMutationVariables>;
export const StylesDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StylesData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOrderByInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"modified"}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mainImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StylesDataQuery, StylesDataQueryVariables>;
export const CreateCustomerPortalLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerPortalLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerPortalLink"}}]}}]} as unknown as DocumentNode<CreateCustomerPortalLinkMutation, CreateCustomerPortalLinkMutationVariables>;
export const CreateStripeProductLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStripeProductLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripeProductLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"priceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"returnUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"returnUrl"}}}]}]}}]} as unknown as DocumentNode<CreateStripeProductLinkMutation, CreateStripeProductLinkMutationVariables>;
export const PremiumFeaturesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PremiumFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"premiumFeatures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"internalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"marketingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupLevel"}},{"kind":"Field","name":{"kind":"Name","value":"openTrialDaysRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"trialDays"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}},{"kind":"Field","name":{"kind":"Name","value":"accountAccessCount"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isTrial"}}]}}]}}]}}]} as unknown as DocumentNode<PremiumFeaturesQuery, PremiumFeaturesQueryVariables>;
export const AssignStyleColorSwatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignStyleColorSwatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hexCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"revert"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignStyleColorSwatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"colorName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"styleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"hexCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hexCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"imageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"revert"},"value":{"kind":"Variable","name":{"kind":"Name","value":"revert"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}}]}}]} as unknown as DocumentNode<AssignStyleColorSwatchMutation, AssignStyleColorSwatchMutationVariables>;
export const LinesheetsForSeasonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LinesheetsForSeason"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"season"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinesheetsForSeasonQuery, LinesheetsForSeasonQueryVariables>;
export const ListAccountColorSwatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListAccountColorSwatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startRow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endRow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAccountColorSwatchesOrderBy"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListAccountColorSwatchesFilterBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAccountColorSwatches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startRow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endRow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterBy"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorSwatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorSwatchId"}},{"kind":"Field","name":{"kind":"Name","value":"stylesMissingSwatch"}},{"kind":"Field","name":{"kind":"Name","value":"colorName"}},{"kind":"Field","name":{"kind":"Name","value":"colorCode"}},{"kind":"Field","name":{"kind":"Name","value":"stylesCount"}},{"kind":"Field","name":{"kind":"Name","value":"swatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListAccountColorSwatchesQuery, ListAccountColorSwatchesQueryVariables>;
export const ListStylesColorSwatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListStylesColorSwatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startRow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endRow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ListStylesColorSwatchOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listStylesColorSwatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startRow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endRow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stylesColorSwatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleId"}},{"kind":"Field","name":{"kind":"Name","value":"styleName"}},{"kind":"Field","name":{"kind":"Name","value":"styleNumber"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"styleColorImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"styleColorSwatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListStylesColorSwatchQuery, ListStylesColorSwatchQueryVariables>;
export const SwatchListImageSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SwatchListImageSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startRow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endRow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swatchListImageSelector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"styleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"startRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startRow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endRow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endRow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"level"}}]}}]}}]}}]} as unknown as DocumentNode<SwatchListImageSelectorQuery, SwatchListImageSelectorQueryVariables>;
export const SwatchListImageSelectorTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SwatchListImageSelectorTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swatchListImageSelector"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"styleIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fileName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"totalCount"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SwatchListImageSelectorTotalQuery, SwatchListImageSelectorTotalQueryVariables>;
export const BrandAllImagesTotalCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandAllImagesTotalCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchFilename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mediaType"},"value":{"kind":"EnumValue","value":"IMAGE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BrandAllImagesTotalCountQuery, BrandAllImagesTotalCountQueryVariables>;
export const BrandAllImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrandAllImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchFilename"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mediaType"},"value":{"kind":"EnumValue","value":"IMAGE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"urlThumbnail"}}]}}]}}]}}]} as unknown as DocumentNode<BrandAllImagesQuery, BrandAllImagesQueryVariables>;
export const BulkCopyAccountUserGeoRestrictionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkCopyAccountUserGeoRestrictions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUserGeoRestrictionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUserGeoRestrictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BulkCopyAccountUserGeoRestrictionsMutation, BulkCopyAccountUserGeoRestrictionsMutationVariables>;
export const BulkCopyAccountUsersPermissionAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkCopyAccountUsersPermissionAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUsersPermissionAccessInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUsersPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BulkCopyAccountUsersPermissionAccessMutation, BulkCopyAccountUsersPermissionAccessMutationVariables>;
export const BulkCopyPermissionsAccountUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BulkCopyPermissionsAccountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeViewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"userType"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BulkCopyPermissionsAccountUsersQuery, BulkCopyPermissionsAccountUsersQueryVariables>;
export const AccountUserPermissionAccessBulkCopyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountUserPermissionAccessBulkCopy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserPermissionAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountUserPermissionAccessBulkCopyQuery, AccountUserPermissionAccessBulkCopyQueryVariables>;
export const AccountUserGeoRestrictionsBulkCopyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountUserGeoRestrictionsBulkCopy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserGeoRestrictions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"regionAssignedOverride"}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"exceptionAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"possibleExceptionAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AccountUserGeoRestrictionsBulkCopyQuery, AccountUserGeoRestrictionsBulkCopyQueryVariables>;
export const UpdateAccountUserMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccountUserMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountsUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountsUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsUsersIds"}}]}}]}}]} as unknown as DocumentNode<UpdateAccountUserMutationMutation, UpdateAccountUserMutationMutationVariables>;
export const CreateAccountUserMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAccountUserMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAccountUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccountUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUserId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<CreateAccountUserMutationMutation, CreateAccountUserMutationMutationVariables>;
export const UpdateAccountUserStatusMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccountUserStatusMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAccountUserStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountUserStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountsUsersIds"}}]}}]}}]} as unknown as DocumentNode<UpdateAccountUserStatusMutationMutation, UpdateAccountUserStatusMutationMutationVariables>;
export const InviteEmailTriggerMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteEmailTriggerMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteEmailTriggerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteEmailTrigger"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InviteEmailTriggerMutationMutation, InviteEmailTriggerMutationMutationVariables>;
export const UserManagementAccountUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserManagementAccountUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"viewingUserSeesInternal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeViewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"viewingUserSeesInternal"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderCC"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"userType"}},{"kind":"Field","name":{"kind":"Name","value":"lastDateAdded"}},{"kind":"Field","name":{"kind":"Name","value":"lastDateRemoved"}},{"kind":"Field","name":{"kind":"Name","value":"numberConnections"}},{"kind":"Field","name":{"kind":"Name","value":"dataPermissionConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserManagementAccountUsersQuery, UserManagementAccountUsersQueryVariables>;
export const GetOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractedSeats"}},{"kind":"Field","name":{"kind":"Name","value":"activeSeats"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountName"}},{"kind":"Field","name":{"kind":"Name","value":"activeSeats"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const CheckUserInOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckUserInOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkUserInOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isInOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<CheckUserInOrganizationQuery, CheckUserInOrganizationQueryVariables>;
export const VABudgetsViewsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VABudgetsViews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"budgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"budgetView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BudgetViewFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardFieldsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"missingBrand"}},{"kind":"Field","name":{"kind":"Name","value":"missingCategory"}},{"kind":"Field","name":{"kind":"Name","value":"missingColor"}},{"kind":"Field","name":{"kind":"Name","value":"missingCost"}},{"kind":"Field","name":{"kind":"Name","value":"missingDeliveryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"missingDoor"}},{"kind":"Field","name":{"kind":"Name","value":"missingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"missingWholesaleCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"missingRetailCurrency"}}]}}]}}]}}]}}]}}]}},...BudgetViewFieldsFragmentDoc.definitions]} as unknown as DocumentNode<VABudgetsViewsQuery, VABudgetsViewsQueryVariables>;
export const AddOrdersToVisualAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddOrdersToVisualAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrdersToVisualAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addedOrderIds"}},{"kind":"Field","name":{"kind":"Name","value":"existingOrderIds"}}]}}]}}]} as unknown as DocumentNode<AddOrdersToVisualAssortmentMutation, AddOrdersToVisualAssortmentMutationVariables>;
export const SyncVisualAssortmentOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncVisualAssortmentOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncVisualAssortmentOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncedOrderIds"}}]}}]}}]} as unknown as DocumentNode<SyncVisualAssortmentOrdersMutation, SyncVisualAssortmentOrdersMutationVariables>;
export const DeleteVisualAssortmentCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVisualAssortmentCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVisualAssortmentCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedCardIds"}},{"kind":"Field","name":{"kind":"Name","value":"versionDelta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oldVersion"}},{"kind":"Field","name":{"kind":"Name","value":"newVersion"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteVisualAssortmentCardsMutation, DeleteVisualAssortmentCardsMutationVariables>;
export const UpdateVAAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVAAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccountsForVisualAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateVAAccountsMutation, UpdateVAAccountsMutationVariables>;
export const SetVADefaultGroupingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetVADefaultGrouping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groups"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentGroupingByInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setVisualAssortmentDefaultGrouping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groups"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groups"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"versionDelta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"oldVersion"}},{"kind":"Field","name":{"kind":"Name","value":"newVersion"}}]}}]}}]}}]} as unknown as DocumentNode<SetVADefaultGroupingMutation, SetVADefaultGroupingMutationVariables>;
export const EditVisualAssortmentCardsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditVisualAssortmentCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardsToEdit"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCardsToEdit"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"editVisualAssortmentCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"cardsToEdit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardsToEdit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyEdited"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentCardFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"versionDelta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newVersion"}},{"kind":"Field","name":{"kind":"Name","value":"oldVersion"}}]}}]}}]}},...VisualAssortmentCardFieldsFragmentDoc.definitions]} as unknown as DocumentNode<EditVisualAssortmentCardsMutation, EditVisualAssortmentCardsMutationVariables>;
export const CreateCustomProductsFromSheetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomProductsFromSheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sheet"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomProductsFromSheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sheet"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sheet"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<CreateCustomProductsFromSheetMutation, CreateCustomProductsFromSheetMutationVariables>;
export const DownloadCustomProductsSheetTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadCustomProductsSheetTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadCustomProductsSheetTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customProductsSheetUrl"}}]}}]}}]} as unknown as DocumentNode<DownloadCustomProductsSheetTemplateMutation, DownloadCustomProductsSheetTemplateMutationVariables>;
export const AsyncAddOrdersToVisualAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AsyncAddOrdersToVisualAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncAddOrdersToVisualAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<AsyncAddOrdersToVisualAssortmentMutation, AsyncAddOrdersToVisualAssortmentMutationVariables>;
export const UploadImageToVisualAssortmentCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadImageToVisualAssortmentCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadImageToVisualAssortmentCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardUuid"}}},{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"image"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"versionDelta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newVersion"}},{"kind":"Field","name":{"kind":"Name","value":"oldVersion"}}]}}]}}]}}]} as unknown as DocumentNode<UploadImageToVisualAssortmentCardMutation, UploadImageToVisualAssortmentCardMutationVariables>;
export const CreateVAAttributeValuesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVAAttributeValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeValues"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentAttributeValueInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVisualAssortmentAttributeValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributeValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeValues"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentAttributeKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"}}]}}]}}]}},...VisualAssortmentAttributeKeyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CreateVAAttributeValuesMutation, CreateVAAttributeValuesMutationVariables>;
export const UpdateVAAttributeValuesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVAAttributeValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributeValues"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentAttributeValueUpdateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVisualAssortmentAttributeValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attributeValues"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributeValues"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentAttributeKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"}}]}}]}}]}},...VisualAssortmentAttributeKeyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateVAAttributeValuesMutation, UpdateVAAttributeValuesMutationVariables>;
export const DeleteVAAttributeValuesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVAAttributeValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVisualAssortmentAttributeValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentAttributeKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"}}]}}]}}]}},...VisualAssortmentAttributeKeyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<DeleteVAAttributeValuesMutation, DeleteVAAttributeValuesMutationVariables>;
export const CreateVAAttributeKeyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVAAttributeKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateVisualAssortmentAttributeKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVisualAssortmentAttributeKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"}}]}}]}}]}},...VisualAssortmentAttributeKeyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CreateVAAttributeKeyMutation, CreateVAAttributeKeyMutationVariables>;
export const UpdateVAAttributeKeyDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVAAttributeKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVisualAssortmentAttributeKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVisualAssortmentAttributeKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attributeKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"}}]}}]}}]}},...VisualAssortmentAttributeKeyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateVAAttributeKeyMutation, UpdateVAAttributeKeyMutationVariables>;
export const DeleteVAAttributeKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVAAttributeKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVisualAssortmentAttributeKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteVAAttributeKeyMutation, DeleteVAAttributeKeyMutationVariables>;
export const UpsertVisualAssortmentAccessUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertVisualAssortmentAccessUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentAccessUserInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertVisualAssortmentAccessUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpsertVisualAssortmentAccessUsersMutation, UpsertVisualAssortmentAccessUsersMutationVariables>;
export const RemoveVisualAssortmentAccessUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveVisualAssortmentAccessUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeVisualAssortmentAccessUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveVisualAssortmentAccessUsersMutation, RemoveVisualAssortmentAccessUsersMutationVariables>;
export const AsyncExportVisualAssortmentPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AsyncExportVisualAssortmentPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncExportVisualAssortmentPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<AsyncExportVisualAssortmentPdfMutation, AsyncExportVisualAssortmentPdfMutationVariables>;
export const ExportVisualAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportVisualAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportVisualAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ExportVisualAssortmentMutation, ExportVisualAssortmentMutationVariables>;
export const CreateVABudgetDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVABudget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateVisualAssortmentBudgetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVisualAssortmentBudget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentBudgetFields"}}]}}]}},...VisualAssortmentBudgetFieldsFragmentDoc.definitions]} as unknown as DocumentNode<CreateVABudgetMutation, CreateVABudgetMutationVariables>;
export const UpdateVABudgetDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVABudget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVisualAssortmentBudgetInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVisualAssortmentBudget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentBudgetFields"}}]}}]}},...VisualAssortmentBudgetFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateVABudgetMutation, UpdateVABudgetMutationVariables>;
export const ExportVABudgetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportVABudget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"budgetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormat"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportVisualAssortmentBudget"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"budgetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"budgetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ExportVABudgetMutation, ExportVABudgetMutationVariables>;
export const UpsertVABudgetRowsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertVABudgetRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertVisualAssortmentBudgetRowsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertVisualAssortmentBudgetRows"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BudgetViewFields"}}]}}]}},...BudgetViewFieldsFragmentDoc.definitions]} as unknown as DocumentNode<UpsertVABudgetRowsMutation, UpsertVABudgetRowsMutationVariables>;
export const VisualAssortmentVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortmentVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentVersionQuery, VisualAssortmentVersionQueryVariables>;
export const VisualAssortmentGroupsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortmentGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentGroupFields"}}]}}]}}]}}]}}]}},...VisualAssortmentGroupFieldsFragmentDoc.definitions]} as unknown as DocumentNode<VisualAssortmentGroupsQuery, VisualAssortmentGroupsQueryVariables>;
export const VisualAssortmentDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCardsFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardPagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCardsPaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCardsSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"groupedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"option"}},{"kind":"Field","name":{"kind":"Name","value":"attributeKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ordersInSync"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"addedByAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardPagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentCardFields"}}]}}]}}]}}]}}]}},...VisualAssortmentCardFieldsFragmentDoc.definitions]} as unknown as DocumentNode<VisualAssortmentQuery, VisualAssortmentQueryVariables>;
export const VACardOrdersDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VACardOrdersDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentCardOrdersDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"styleColorId"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"productCost"}},{"kind":"Field","name":{"kind":"Name","value":"productRetailCost"}},{"kind":"Field","name":{"kind":"Name","value":"color"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productSizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}}]}}]}}]} as unknown as DocumentNode<VACardOrdersDetailsQuery, VACardOrdersDetailsQueryVariables>;
export const EligibleOrdersForVADocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EligibleOrdersForVA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EligibleOrdersFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleOrdersForVisualAssortments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"collectionName"}},{"kind":"Field","name":{"kind":"Name","value":"totalProducts"}},{"kind":"Field","name":{"kind":"Name","value":"totalUnits"}},{"kind":"Field","name":{"kind":"Name","value":"inAssortment"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}}]}}]}}]} as unknown as DocumentNode<EligibleOrdersForVAQuery, EligibleOrdersForVAQueryVariables>;
export const EligibleAccountsForVisualAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EligibleAccountsForVisualAssortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleAccountsForVisualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isPublic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"privacy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreationSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestedByAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"allConnections"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}}]}}]}}]} as unknown as DocumentNode<EligibleAccountsForVisualAssortmentQuery, EligibleAccountsForVisualAssortmentQueryVariables>;
export const EligibleUsersForVisualAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EligibleUsersForVisualAssortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligibleAccountsForVisualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isSelected"}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eligibleUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EligibleUsersForVisualAssortmentQuery, EligibleUsersForVisualAssortmentQueryVariables>;
export const VisualAssortmentAccessUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortmentAccessUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentAccessUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNbr"}},{"kind":"Field","name":{"kind":"Name","value":"isActiveForAnyAccount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentAccessUsersQuery, VisualAssortmentAccessUsersQueryVariables>;
export const HasVisualAssortmentAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasVisualAssortmentAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasVisualAssortmentAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasUserAccess"}},{"kind":"Field","name":{"kind":"Name","value":"isAccessInitialized"}}]}}]}}]} as unknown as DocumentNode<HasVisualAssortmentAccessQuery, HasVisualAssortmentAccessQueryVariables>;
export const VisualAssortmentOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortmentOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hexCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"visualAssortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visualAssortmentId"}}}]}]}}]}}]} as unknown as DocumentNode<VisualAssortmentOptionsQuery, VisualAssortmentOptionsQueryVariables>;
export const VisualAssortmentCancelledCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortmentCancelledCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardFilters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCardsFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardSearch"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VisualAssortmentCardsSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardFilters"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VisualAssortmentCancelledCardsQuery, VisualAssortmentCancelledCardsQueryVariables>;
export const ListMonitoringVAJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListMonitoringVAJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMonitoringJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorDetails"}},{"kind":"Field","name":{"kind":"Name","value":"outputData"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<ListMonitoringVAJobsQuery, ListMonitoringVAJobsQueryVariables>;
export const ListVAAttributeKeysDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListVAAttributeKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentAttributeKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentAttributeKeyFields"}}]}}]}},...VisualAssortmentAttributeKeyFieldsFragmentDoc.definitions]} as unknown as DocumentNode<ListVAAttributeKeysQuery, ListVAAttributeKeysQueryVariables>;
export const VisualAssortmentLimitsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisualAssortmentLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activePackages"}},{"kind":"Field","name":{"kind":"Name","value":"hasCustomAccountLimits"}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationDays"}},{"kind":"Field","name":{"kind":"Name","value":"priceId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packageLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentLimitFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customAccountLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentLimitFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveLimits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentLimitFields"}}]}}]}}]}},...VisualAssortmentLimitFieldsFragmentDoc.definitions]} as unknown as DocumentNode<VisualAssortmentLimitsQuery, VisualAssortmentLimitsQueryVariables>;
export const VABudgetsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VABudgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"budgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisualAssortmentBudgetFields"}}]}}]}}]}}]}}]}},...VisualAssortmentBudgetFieldsFragmentDoc.definitions]} as unknown as DocumentNode<VABudgetsQuery, VABudgetsQueryVariables>;
export const VACardFieldsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VACardFieldsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visualAssortments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"visualAssortmentCardFieldsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"missingImage"}},{"kind":"Field","name":{"kind":"Name","value":"missingBrand"}},{"kind":"Field","name":{"kind":"Name","value":"missingCategory"}},{"kind":"Field","name":{"kind":"Name","value":"missingColor"}},{"kind":"Field","name":{"kind":"Name","value":"missingCost"}},{"kind":"Field","name":{"kind":"Name","value":"missingDeliveryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"missingDoor"}},{"kind":"Field","name":{"kind":"Name","value":"missingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"missingSeason"}},{"kind":"Field","name":{"kind":"Name","value":"missingWholesaleCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"missingRetailCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledInOrder"}},{"kind":"Field","name":{"kind":"Name","value":"unitMismatch"}},{"kind":"Field","name":{"kind":"Name","value":"missingCustomAttributes"}},{"kind":"Field","name":{"kind":"Name","value":"notReceived"}}]}}]}}]}}]} as unknown as DocumentNode<VACardFieldsCountQuery, VACardFieldsCountQueryVariables>;
export const VACurrenciesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VACurrencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VACurrenciesQuery, VACurrenciesQueryVariables>;
export const getZendeskSSOTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZendeskSSOToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zendeskUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SSOToken"}}]}}]}}]} as unknown as DocumentNode<getZendeskSSOTokenQuery, getZendeskSSOTokenQueryVariables>;
export const UsesNewEditAndCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsesNewEditAndCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usesNewEditAndCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}]}}]} as unknown as DocumentNode<UsesNewEditAndCreateQuery, UsesNewEditAndCreateQueryVariables>;
export const UserInfoQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInfoQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingAccountUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tiedWithBuyerHierarchy"}},{"kind":"Field","name":{"kind":"Name","value":"accountUserType"}},{"kind":"Field","name":{"kind":"Name","value":"viewingAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandViewerAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"canTransact"}},{"kind":"Field","name":{"kind":"Name","value":"canViewDataPortal"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}},{"kind":"Field","name":{"kind":"Name","value":"subType"}},{"kind":"Field","name":{"kind":"Name","value":"enableChat"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreationSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalSource"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RetailerViewerAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"enableChat"}},{"kind":"Field","name":{"kind":"Name","value":"assortmentPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"integrations"}},{"kind":"Field","name":{"kind":"Name","value":"canShop"}},{"kind":"Field","name":{"kind":"Name","value":"canFindBrands"}},{"kind":"Field","name":{"kind":"Name","value":"accountCreationSource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalSource"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminViewerAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewingUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"dateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"assortmentPlanning"}},{"kind":"Field","name":{"kind":"Name","value":"profileImage"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"loggedInAsAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"lastLogin"}},{"kind":"Field","name":{"kind":"Name","value":"userType"}},{"kind":"Field","name":{"kind":"Name","value":"internalUser"}},{"kind":"Field","name":{"kind":"Name","value":"emailLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"displayLanguage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountUserPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BrandViewerAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RetailerViewerAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AdminViewerAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserInfoQueryQuery, UserInfoQueryQueryVariables>;
export const UpsertAccountCustomerCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAccountCustomerCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertAccountCustomerCodesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAccountCustomerCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<UpsertAccountCustomerCodesMutation, UpsertAccountCustomerCodesMutationVariables>;
export const createMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"threadId"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<createMessageMutation, createMessageMutationVariables>;
export const BulkUpdateOrderSalesRepByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateOrderSalesRepByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateOrderSalesRepByFiltersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateOrderSalesRepByFilters"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrdersCount"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateOrderSalesRepByFiltersMutation, BulkUpdateOrderSalesRepByFiltersMutationVariables>;
export const orderStatusChangeJobQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderStatusChangeJobQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listMonitoringJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"jobIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"outputData"}},{"kind":"Field","name":{"kind":"Name","value":"errorDetails"}}]}}]}}]}}]} as unknown as DocumentNode<orderStatusChangeJobQueryQuery, orderStatusChangeJobQueryQueryVariables>;
export const bulkUpdateOrderStatusAsyncMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkUpdateOrderStatusAsyncMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateOrderStatusAsyncInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateOrderStatusAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobId"}}]}}]}}]} as unknown as DocumentNode<bulkUpdateOrderStatusAsyncMutationMutation, bulkUpdateOrderStatusAsyncMutationMutationVariables>;
export const orderStatusChangeEligibilityQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderStatusChangeEligibilityQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderStatusChangeEligibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<orderStatusChangeEligibilityQueryQuery, orderStatusChangeEligibilityQueryQueryVariables>;
export const CreateRawOrdersExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRawOrdersExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRawOrdersExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskId"}}]}}]}}]} as unknown as DocumentNode<CreateRawOrdersExportMutation, CreateRawOrdersExportMutationVariables>;
export const BulkMarkOrdersAsExportedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkMarkOrdersAsExported"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkMarkOrdersAsExportedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkMarkOrdersAsExported"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<BulkMarkOrdersAsExportedMutation, BulkMarkOrdersAsExportedMutationVariables>;
export const accountExportIntegrationConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountExportIntegrationConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"integrationTypes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountExportIntegrationConfigs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"integrationTypes"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"integrationTypes"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"columnConfig"}}]}}]}}]} as unknown as DocumentNode<accountExportIntegrationConfigsQuery, accountExportIntegrationConfigsQueryVariables>;
export const ImportValidatedOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportValidatedOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportValidatedOrdersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importValidatedOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importJobIdentifier"}}]}}]}}]} as unknown as DocumentNode<ImportValidatedOrdersMutation, ImportValidatedOrdersMutationVariables>;
export const RetailerBrandDoorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerBrandDoors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerBrandDoorsQuery, RetailerBrandDoorsQueryVariables>;
export const LinesheetsQueryCADocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LinesheetsQueryCA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"excludeCollectionsFromOrders"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"visibleForRetailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LinesheetsQueryCAQuery, LinesheetsQueryCAQueryVariables>;
export const PriceTypesQueryCADocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PriceTypesQueryCA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PriceTypesQueryCAQuery, PriceTypesQueryCAQueryVariables>;
export const ShippingBillingQueryCADocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShippingBillingQueryCA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connectedAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connectedAccountIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"publicRetailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"companyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShippingBillingQueryCAQuery, ShippingBillingQueryCAQueryVariables>;
export const GenerateSummaryFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateSummaryFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSummaryFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSummaryFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GenerateSummaryFileMutation, GenerateSummaryFileMutationVariables>;
export const UploadFileToS3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadFileToS3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadFileToS3Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFileToS3"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UploadFileToS3Mutation, UploadFileToS3MutationVariables>;
export const ValidateOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidateOrdersSettings"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderSettings"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderInputSettings"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settings"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderSettings"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatedOrdersIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doorId"}},{"kind":"Field","name":{"kind":"Name","value":"orderIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"poNumber"}},{"kind":"Field","name":{"kind":"Name","value":"skuLineItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colorId"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sizeId"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"multiplier"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<ValidateOrdersMutation, ValidateOrdersMutationVariables>;
export const BulkUnscheduleForExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUnscheduleForExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUnscheduleForExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUnscheduleForExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<BulkUnscheduleForExportMutation, BulkUnscheduleForExportMutationVariables>;
export const SendInvoicesForOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendInvoicesForOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendInvoicesForOrdersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendInvoicesForOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"sentTo"}},{"kind":"Field","name":{"kind":"Name","value":"sentOn"}}]}}]}}]} as unknown as DocumentNode<SendInvoicesForOrdersMutation, SendInvoicesForOrdersMutationVariables>;
export const CreatePaymentInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePaymentInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateInvoicesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceId"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentInvoiceMutation, CreatePaymentInvoiceMutationVariables>;
export const NewCustomerDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewCustomerData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NewCustomerDataQuery, NewCustomerDataQueryVariables>;
export const OrphanRetailersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrphanRetailers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrphanRetailersRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orphanRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerName"}},{"kind":"Field","name":{"kind":"Name","value":"retailerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"retailerCode"}},{"kind":"Field","name":{"kind":"Name","value":"connectionProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"update"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]} as unknown as DocumentNode<OrphanRetailersQuery, OrphanRetailersQueryVariables>;
export const UserConnectedAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserConnectedAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brands"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountStatuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"PENDING"},{"kind":"EnumValue","value":"ACTIVE"},{"kind":"EnumValue","value":"INVISIBLE"},{"kind":"EnumValue","value":"PRE_ACTIVE"},{"kind":"EnumValue","value":"INTERNAL"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"allConnections"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"profileName"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserConnectedAccountsQuery, UserConnectedAccountsQueryVariables>;
export const doorIdsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"doorIdsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brandDoors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<doorIdsQueryQuery, doorIdsQueryQueryVariables>;
export const CollectionsQueryDupe5Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe5"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionOrderByField"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe5Query, CollectionsQueryDupe5QueryVariables>;
export const BulkUpdateOrderPricingByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateOrderPricingByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateOrderPricingByIdsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateOrderPricingByIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrdersCount"}},{"kind":"Field","name":{"kind":"Name","value":"notUpdatedOrdersCount"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateOrderPricingByIdsMutation, BulkUpdateOrderPricingByIdsMutationVariables>;
export const UpsertOrderQuantitiesDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertOrderQuantitiesDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertOrderQuantitiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOrderQuantities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedOrderIds"}}]}}]}}]} as unknown as DocumentNode<UpsertOrderQuantitiesDupe1Mutation, UpsertOrderQuantitiesDupe1MutationVariables>;
export const CollectionsQueryDupe6Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe6"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isVisibleToRetailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe6Query, CollectionsQueryDupe6QueryVariables>;
export const CollectionsOprhanOrderQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsOprhanOrderQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsOprhanOrderQueryQuery, CollectionsOprhanOrderQueryQueryVariables>;
export const collectionProductsQueryDupe4Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsQueryDupe4"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"priceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxWholesaleValue"}},{"kind":"Field","name":{"kind":"Name","value":"minRetailValue"}},{"kind":"Field","name":{"kind":"Name","value":"maxRetailValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductsQueryDupe4Query, collectionProductsQueryDupe4QueryVariables>;
export const collectionProductsTotalQueryDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsTotalQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProductsTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}]}]}}]} as unknown as DocumentNode<collectionProductsTotalQueryDupe2Query, collectionProductsTotalQueryDupe2QueryVariables>;
export const OrderVariantTotalsQueryDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderVariantTotalsQueryDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderVariantTotalsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderVariantTotals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrderVariantTotalsQueryDupe3Query, OrderVariantTotalsQueryDupe3QueryVariables>;
export const OrdersCommonInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersCommonInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailerProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrdersCommonInfoQuery, OrdersCommonInfoQueryVariables>;
export const ReassignConnectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReassignConnections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceAccountUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetAccountUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reassignConnections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceAccountUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceAccountUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"targetAccountUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetAccountUserId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ReassignConnectionsMutation, ReassignConnectionsMutationVariables>;
export const getRetailerSeasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getRetailerSeasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<getRetailerSeasonsQuery, getRetailerSeasonsQueryVariables>;
export const getAssortmentsForCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAssortmentsForCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCustom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortmentsForCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeCustom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCustom"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<getAssortmentsForCollectionQuery, getAssortmentsForCollectionQueryVariables>;
export const createAssortmentWithColorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAssortmentWithColors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailCurrencyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"wholesaleCurrencyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAssortmentWithColors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailCurrencyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailCurrencyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"seasonId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seasonId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"wholesaleCurrencyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"wholesaleCurrencyId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<createAssortmentWithColorsMutation, createAssortmentWithColorsMutationVariables>;
export const addColorsToAssortmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addColorsToAssortment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addColorsToAssortment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assortmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assortmentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"colorIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"priceTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priceTypeId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assortment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<addColorsToAssortmentMutation, addColorsToAssortmentMutationVariables>;
export const addUnitsInProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addUnitsInProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddUnitsInProgressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUnitsInProgress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdOrderIds"}}]}}]}}]} as unknown as DocumentNode<addUnitsInProgressMutation, addUnitsInProgressMutationVariables>;
export const WarehousesQueryDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WarehousesQueryDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"availabilityGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableOn"}},{"kind":"Field","name":{"kind":"Name","value":"isImmediate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WarehousesQueryDupe3Query, WarehousesQueryDupe3QueryVariables>;
export const CollectionProductQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productVideosAreEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tagValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderMinimum"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videos"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productVideosAreEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"format"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"orderMinimum"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailPrice"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"casepacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variantValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"wholesalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedRetailPrice"}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductQueryQuery, CollectionProductQueryQueryVariables>;
export const CollectionsQueryDupe7Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe7"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"madeToOrder"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe7Query, CollectionsQueryDupe7QueryVariables>;
export const aggregateSkuInventoryItemsDupe3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"aggregateSkuInventoryItemsDupe3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"warehouseIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeImmediate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AggregateSkuInventoryItemsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateSkuInventoryItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"warehouseIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"warehouseIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"includeImmediate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeImmediate"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"skuId"}}]}}]}}]}}]} as unknown as DocumentNode<aggregateSkuInventoryItemsDupe3Query, aggregateSkuInventoryItemsDupe3QueryVariables>;
export const DiscountsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DiscountsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDiscounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"retailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"factor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DiscountsQueryQuery, DiscountsQueryQueryVariables>;
export const skuDeliveriesDupe1Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"skuDeliveriesDupe1"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SkuDeliveryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skuDeliveries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<skuDeliveriesDupe1Query, skuDeliveriesDupe1QueryVariables>;
export const skuDeliveriesDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"skuDeliveriesDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SkuDeliveryFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skuDeliveries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sku"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<skuDeliveriesDupe2Query, skuDeliveriesDupe2QueryVariables>;
export const collectionProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"casepacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"skus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductsQuery, collectionProductsQueryVariables>;
export const CollectionsQueryDupe9Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe9"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"NAME"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe9Query, CollectionsQueryDupe9QueryVariables>;
export const CollectionProductsQueryDupe5Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsQueryDupe5"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tagValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"COLOR","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsQueryDupe5Query, CollectionProductsQueryDupe5QueryVariables>;
export const AddProductsToOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddProductsToOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddProductsToOrdersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addProductsToOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdWebOrderIds"}}]}}]}}]} as unknown as DocumentNode<AddProductsToOrdersMutation, AddProductsToOrdersMutationVariables>;
export const UpsertStyleboardDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertStyleboardDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertStyleboardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertStyleboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertStyleboardDupe2Mutation, UpsertStyleboardDupe2MutationVariables>;
export const StyleboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Styleboards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"look"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"textContents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"layoutKey"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardsQuery, StyleboardsQueryVariables>;
export const DeleteCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteShowroomCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteShowroomCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCollectionsMutation, DeleteCollectionsMutationVariables>;
export const DeleteStyleboardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStyleboards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteStyleboardsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteStyleboards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteStyleboardsMutation, DeleteStyleboardsMutationVariables>;
export const SaveCollectionDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertShowroomCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertShowroomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToAllConnected"}},{"kind":"Field","name":{"kind":"Name","value":"url3dShowroom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"looks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LookFragment"}}]}}]}}]}}]}}]}},...LookFragmentFragmentDoc.definitions]} as unknown as DocumentNode<SaveCollectionMutation, SaveCollectionMutationVariables>;
export const sharedShowroomCollectionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sharedShowroomCollectionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionShares"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"shareDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<sharedShowroomCollectionQueryQuery, sharedShowroomCollectionQueryQueryVariables>;
export const ShareCollectionsWithRetailersDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareCollectionsWithRetailersDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareCollectionsWithRetailersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareCollectionsWithRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShareCollectionsWithRetailersDupe2Mutation, ShareCollectionsWithRetailersDupe2MutationVariables>;
export const BulkUpdateCollectionsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateCollectionsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateCollectionsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateCollections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUpdateCollectionsDupe2Mutation, BulkUpdateCollectionsDupe2MutationVariables>;
export const getShowroomCollectionTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getShowroomCollectionToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetShowroomCollectionTokenizedLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"token"},"name":{"kind":"Name","value":"getShowroomCollectionTokenizedLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenizedLink"}}]}}]}}]} as unknown as DocumentNode<getShowroomCollectionTokenMutation, getShowroomCollectionTokenMutationVariables>;
export const ShareStyleboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareStyleboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareStyleboardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareStyleboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboardId"}}]}}]}}]} as unknown as DocumentNode<ShareStyleboardMutation, ShareStyleboardMutationVariables>;
export const CollectionsQueryDupe8Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionsQueryDupe8"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collectionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"visibleForRetailerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionsQueryDupe8Query, CollectionsQueryDupe8QueryVariables>;
export const ShareCollectionsWithRetailerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareCollectionsWithRetailer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareCollectionsWithRetailersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareCollectionsWithRetailers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShareCollectionsWithRetailerMutation, ShareCollectionsWithRetailerMutationVariables>;
export const ShareShowroomCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareShowroomCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareShowroomCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareShowroomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionId"}}]}}]}}]} as unknown as DocumentNode<ShareShowroomCollectionMutation, ShareShowroomCollectionMutationVariables>;
export const UnshareShowroomCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnshareShowroomCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnshareShowroomCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unshareShowroomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollectionId"}}]}}]}}]} as unknown as DocumentNode<UnshareShowroomCollectionMutation, UnshareShowroomCollectionMutationVariables>;
export const TeamMembersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamMembersQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamMembersQueryQuery, TeamMembersQueryQueryVariables>;
export const RetailerTeamMembersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetailerTeamMembersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retailerUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"retailerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retailerIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetailerTeamMembersQueryQuery, RetailerTeamMembersQueryQueryVariables>;
export const Orb360ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orb360Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orb360Products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchText"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchText"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Orb360ProductQuery, Orb360ProductQueryVariables>;
export const collectionProductExtraInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductExtraInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductExtraInfoQuery, collectionProductExtraInfoQueryVariables>;
export const CollectionProductsDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionProductsDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionProductsDupe2Query, CollectionProductsDupe2QueryVariables>;
export const PublicCollectionsQueryDupe2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicCollectionsQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicCollectionsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brandId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandId"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"swatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicCollectionsQueryDupe2Query, PublicCollectionsQueryDupe2QueryVariables>;
export const collectionProductsQueryDupe6Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"collectionProductsQueryDupe6"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductsCollectionFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"displayDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hexColor"}},{"kind":"Field","name":{"kind":"Name","value":"swatchImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchandiseImages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<collectionProductsQueryDupe6Query, collectionProductsQueryDupe6QueryVariables>;
export const CollectionParamsByShareTokenQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionParamsByShareTokenQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionParamsByShareToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retailCurrency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CollectionParamsByShareTokenQueryQuery, CollectionParamsByShareTokenQueryQueryVariables>;
export const CollectionQueryDupe2Document = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CollectionQueryDupe2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"showroomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"warehouses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"visibleToAllConnected"}},{"kind":"Field","name":{"kind":"Name","value":"url3dShowroom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"looks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LookFragment"}}]}}]}}]}}]}}]}},...LookFragmentFragmentDoc.definitions]} as unknown as DocumentNode<CollectionQueryDupe2Query, CollectionQueryDupe2QueryVariables>;
export const PublicShowroomCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PublicShowroomCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"public"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publicShowroomCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"showroomCollectionShareToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url3dShowroom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPublic"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"looks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionProductId"}},{"kind":"Field","name":{"kind":"Name","value":"productNumber"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"productImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"visible"}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"colorVariantTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textContents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"layoutKey"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"media"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"streamingUrl"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PublicShowroomCollectionQuery, PublicShowroomCollectionQueryVariables>;
export const LastModifiedQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastModifiedQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboardLastModified"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastModified"}}]}}]}}]} as unknown as DocumentNode<LastModifiedQueryQuery, LastModifiedQueryQueryVariables>;
export const StyleboardQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StyleboardQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"styleboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"styleboardId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountProfileName"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastModified"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"look"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"collectionProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tagValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"tag"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"externalMedia"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalMediaEnabled"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"traitValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trait"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completeShipDate"}},{"kind":"Field","name":{"kind":"Name","value":"startShipDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"StringValue","value":"COLOR","block":false}}]},{"kind":"Field","name":{"kind":"Name","value":"priceTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"textContents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"layoutKey"}},{"kind":"Field","name":{"kind":"Name","value":"presentation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"styleboardShares"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalRecipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StyleboardQueryQuery, StyleboardQueryQueryVariables>;
export const accountPaymentProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accountPaymentProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"destinationAccountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountPaymentProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"destinationAccountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"destinationAccountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"paymentProvider"}},{"kind":"Field","name":{"kind":"Name","value":"isSepaEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isAchEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"retailersCanSeeInvoices"}},{"kind":"Field","name":{"kind":"Name","value":"sendBrandMailPaymentProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"sendRetailerMailPaymentProcessed"}},{"kind":"Field","name":{"kind":"Name","value":"brandNotificationEmail"}}]}}]}}]} as unknown as DocumentNode<accountPaymentProvidersQuery, accountPaymentProvidersQueryVariables>;
export const PaymentRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"}},{"kind":"Field","name":{"kind":"Name","value":"localCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"billingName"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BankAccount"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreditCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentRecordQuery, PaymentRecordQueryVariables>;
export const invoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"invoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"sentOn"}},{"kind":"Field","name":{"kind":"Name","value":"sentTo"}}]}}]}}]} as unknown as DocumentNode<invoicesQuery, invoicesQueryVariables>;
export const PaymentInfoOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentInfoOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"remainingBalance"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentInfoOrdersQuery, PaymentInfoOrdersQueryVariables>;
export const getZendeskUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getZendeskUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zendeskUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"messagingToken"}}]}}]}}]} as unknown as DocumentNode<getZendeskUserQuery, getZendeskUserQueryVariables>;